angular.module(
    'jfApp',
    [
        'ngSentry',
        'ui.router',
        'ngMaterial',
        'ngStorage',
        'ngAnimate',
        'ngCookies',
        'ngResource',
        'ngMessages',
        'ngActionCable',
        'http-auth-interceptor',
        'utf8-base64',
        'angularSpinner',
        'pascalprecht.translate',
        'ngSanitize',
        'templates',
        'angular-inview',
        'duScroll',
        'jf.urls.config',
        'jf.shared.config',
        'jf.directives-jf-spinner-factory',
        'jf.directives-jf-spinner',
        'jf.dialog',
        'jf.controller',
        'jf.json-api',
        'jf.internet-connection',
        'jf.user',
        'jf.token',
        'jf.network',
        'jf.login',
        'jf.location',
        'jf.helpers',
        'jf.app-update',
        'jf.mobile-events',
        'jf.api-application',
        'jf.api-account',
        'jf.api-books',
        'jf.api-shop',
        'jf.api-logistic',
        'jf.api-notification',
        'jf.api-context',
        'jf.history'
    ]
)
.run(['$rootScope', '$mdMedia', '$state', '$window', '$transitions', 'JF_SHARED_CONFIG', 'JF_CONFIG', 'jfUser', 'jfToken', 'jfHelper', 'jfMobileEvents', 'jfInternetConnection', 'jfHistory', 'jfConfigUrls', 'ActionCableConfig', 'SpinnerFactory', 'CustomerAppHelpersFactory', function(
    $rootScope,
    $mdMedia,
    $state,
    $window,
    $transitions,
    JF_SHARED_CONFIG,
    JF_CONFIG,
    jfUser,
    jfToken,
    jfHelper,
    jfMobileEvents,
    jfInternetConnection,
    jfHistory,
    jfConfigUrls,
    ActionCableConfig,
    SpinnerFactory,
    CustomerAppHelpersFactory
) {
    'use strict';

    /**
     * Init app history
     */
    jfHistory.init();

    /**
     * Internet Connection checker
     */
    jfInternetConnection.init();

    /**
     * Init loader
     */
    SpinnerFactory.init();

    /**
     * Init error logger
     */
    LE.init({
        token: JF_SHARED_CONFIG.logEntriesToken,
        catchall: false,
        page_info: 'per-page'
    });

    /**
     * Set Sentry user context
     */
    if (angular.isDefined($window.Sentry) && jfUser.isLoggedIn()) {
        $window.Sentry.setUser({ id: jfUser.get().id });
    }

    /**
     * Global variables
     */
    $rootScope.$mdMedia = $mdMedia;
    $rootScope.$state = $state;
    $rootScope.currencySymbols = JF_CONFIG.currencySymbols;
    $rootScope.imagesCDN = jfConfigUrls.get('jfImagesCDN', 'customerApp');
    $rootScope.jfShared.jfNetwork.fatalErrorAlertPopup = null;
    $rootScope.blogUrl = jfConfigUrls.get('jfBlogUrl', 'customerApp');
    $rootScope.mobileTrackingPermissionGranted = false;

    /**
     * Device Ready listener
     */
    document.addEventListener('deviceready', function() {
        jfMobileEvents.deviceready();

        if (
            angular.isDefined($window.device) &&
            angular.isDefined($window.cordova) &&
            angular.isDefined($window.cordova.plugins) &&
            angular.isDefined($window.cordova.plugins.idfa)
        ) {
            if ($window.device.platform.toLowerCase() !== 'ios') {
                $window.dataLayer.push({ event: 'mobileTrackingPermission', mobileTrackingPermissionGranted: true });
                $rootScope.mobileTrackingPermissionGranted = true;

                if (angular.isDefined($window.cordova.plugins.firebase)) {
                    $window.cordova.plugins.firebase.analytics.setEnabled(true);
                }
            } else {
                $window
                    .cordova
                    .plugins
                    .idfa
                    .getInfo()
                    .then(function(info) {
                        if (info.trackingPermission === $window.cordova.plugins.idfa.TRACKING_PERMISSION_NOT_DETERMINED) {
                            return $window.cordova.plugins.idfa.requestPermission().then(function(result) {
                                if (result === $window.cordova.plugins.idfa.TRACKING_PERMISSION_AUTHORIZED) {
                                    $window.dataLayer.push({ event: 'mobileTrackingPermission', mobileTrackingPermissionGranted: true });
                                    $rootScope.mobileTrackingPermissionGranted = true;

                                    if (angular.isDefined($window.cordova.plugins.firebase)) {
                                        $window.cordova.plugins.firebase.analytics.setEnabled(true);
                                    }
                                }
                            });
                        } else if (info.trackingPermission === $window.cordova.plugins.idfa.TRACKING_PERMISSION_AUTHORIZED) {
                            $window.dataLayer.push({ event: 'mobileTrackingPermission', mobileTrackingPermissionGranted: true });
                            $rootScope.mobileTrackingPermissionGranted = true;

                            if (angular.isDefined($window.cordova.plugins.firebase)) {
                                $window.cordova.plugins.firebase.analytics.setEnabled(true);
                            }
                        }
                    });
            }
        }

        if (angular.isDefined($window.device) && $window.device.platform.toLowerCase() === 'android') {
            $window.cordova.plugins.InAppUpdate.getUpdateAvailability(
              function (response) {
                if (response === 'UPDATE_AVAILABLE') {
                    setTimeout(function() {
                        $rootScope.$emit('show-android-app-update-popup');
                    }, 1000);

                  $window.cordova.plugins.InAppUpdate.updateImmediate(
                    function () {},
                    function (err) {
                        $rootScope.$emit('app-error', {err: err, silent: true});
                    }
                  );
                }
              },
              function (err) {
                $rootScope.$emit('app-error', {err: err, silent: true});
              }
            );
          }
    }, false);

    /**
     * Device Resume listener
     */
    document.addEventListener('resume', function() {
        jfMobileEvents.resume();
        if (angular.isDefined($window.device) && $window.device.platform.toLowerCase() === 'android' && !$rootScope.androidAppUpdatePopupVisible) {
            $window.cordova.plugins.InAppUpdate.getUpdateAvailability(
              function (response) {
                if (response === 'UPDATE_AVAILABLE') {
                    setTimeout(function() {
                        $rootScope.$emit('show-android-app-update-popup');
                    }, 1000);

                  $window.cordova.plugins.InAppUpdate.updateImmediate(
                    function () {},
                    function (err) {
                        $rootScope.$emit('app-error', {err: err, silent: true});
                    }
                  );
                }
              },
              function (err) {
                $rootScope.$emit('app-error', {err: err, silent: true});
              }
            );
          }
    });

    /**
     * Back button handler
     */
    document.addEventListener(
        'backbutton',
        function() {
            jfMobileEvents.backbutton(function() {
                if ($state.current.name === 'checkout') {
                    $state.go('products', { '#': 'c0', stepBack: true });
                } else {
                    jfHelper.goBackInHistory();
                }
            });
        },
        false
    );

    /**
     * Socket IO config
     */
    ActionCableConfig.autoStart = false;
    ActionCableConfig.wsUri = jfConfigUrls.get('actionCableHost');
    ActionCableConfig.protocols = ['actioncable-v1-json', 'actioncable-unsupported'];
    ActionCableConfig.debug = JF_CONFIG.actionCable.debug;

    /**
     * Set global flag when shop is started as a mobile app
     */
    $rootScope.mobileAppMode = jfHelper.mobileAppMode;

    /**
     * Global helpers
     */
    $rootScope.countObjKeys = jfHelper.countObjKeys;

    /**
     * Auth init
     */
    jfUser.init();

    /**
     * Set global title
     */
    $transitions.onSuccess({}, jfHelper.stateChangeSuccessHandler);

    /**
     * Global state change start listener
     */
    $transitions.onStart({}, jfHelper.stateChangeStartHandler);

    CustomerAppHelpersFactory.prepareOrderInitValue();

    jfToken
        .init()
        .then(
            function() {},
            function(err) {
                if (err.status === 403) {
                    $state.go('logout');
                } else if (err.status !== 345) {
                    $rootScope.$emit('app-error', {err: err, silent: true});
                }
            }
        );

    /**
     * General app errors listener
     */
    $rootScope.$on('app-error', jfHelper.appErrorHandler);

    /**
     * General app log listener
     */
    $rootScope.$on('app-log', jfHelper.appLogHandler);

    /**
     * App cache invalidation - modify timestamps to clear caches
     */
    CustomerAppHelpersFactory.handleCacheInvalidation(
        '1657875283394', // Modify this timestamp to invalidate footer cache
        '1774533079211', // Modify this timestamp to invalidate user profile cache
        '1761221645890', // Modify this timestamp to invalidate company details cache
        '1663146196827' // Modify this timestamp to invalidate payment methods cache
    );
}]);

angular.module('jfApp')
    .provider(
        'responseStatus',
        function() {
            'use strict';

            this.setStatus = function(response) {
                if (!response.resource) {
                    response.resource = {};
                }

                response.resource.$status = response.status;

                return response.resource;
            };

            this.$get = function() {};
        }
    );
angular.module('jfApp')
    .provider(
        'urlRules',
        function() {
            'use strict';

            this.setTrailingSlash = function($injector, $location) {
                var path = $location.url();

                // check to see if the path already has a slash where it should be
                if (!(path[path.length - 1] === '/' || path.indexOf('/?') > -1 || path.indexOf('/#') > -1)) {
                    if (path.indexOf('?') > -1) {
                        return path.replace('?', '/?');
                    } else {
                        return path + '/';
                    }
                }
            };

            this.prepareTemplateUrl = function(stateParams) {
                var mainPath = 'app/components/' + stateParams.stateName;

                return mainPath + '/' + stateParams.stateName + '.' +
                    stateParams.section +
                    (stateParams.subnav ? '-' + stateParams.subnav : '') +
                    '.html';
            };

            this.$get = function() {};
        }
    );
/**
 * Jonny Fresh app configuration
 */
angular.module('jfApp')
    /**
     * App config
     */
    .constant(
        'JF_CONFIG',
        {
            environment: window.jfEbs ? window.jfEbs.JF_ENV : 'development',
            requestTimeout: 60000, // 60 seconds
            paymentMethodsCacheTime: 43200000, // 12 hours
            userProfileCacheTime: 86400000, // 24 hours
            companyDetailsCacheTime: 43200000, // 12 hours
            defaultLocale: 'de_DE',
            defaultLocation: 'de',
            shopCountries: ['DE', 'AT'],
            localeCookieName: 'jf-preferred-language',
            locales: {
                'de_DE': {
                    locale: 'de_DE',
                    shortName: 'de',
                    visible: true,
                    i18n: 'LOCALE_GERMAN_GERMAN',
                    flagUrl: 'assets/img/de.png'
                },
                'de_AT': {
                    locale: 'de_AT',
                    shortName: 'at',
                    visible: true,
                    i18n: 'LOCALE_GERMAN_AUSTRIA',
                    flagUrl: 'assets/img/at.png'
                },
                'en_DE': {
                    locale: 'en_DE',
                    shortName: 'en',
                    visible: true,
                    i18n: 'LOCALE_ENGLISH_GERMAN',
                    flagUrl: 'assets/img/en.png'
                },
                'en_AT': {
                    locale: 'en_AT',
                    shortName: 'en',
                    visible: false,
                    i18n: 'LOCALE_ENGLISH_GERMAN',
                    flagUrl: 'assets/img/en.png'
                }
            },
            productImgPlaceholder: 'business/hemd-gelegt/hemd-gelegt',
            currencySymbols: {
                EUR: '€'
            },
            paymentMethods: {
                cash: '1710a98c-971b-4783-bb89-95ac963467a0',
                payPalAfterPayment: '2568a434-7d00-4a58-8d6b-ef8816e2ef81',
                creditCard: '36fad83f-49a3-4a20-b11c-3456cd0be212',
                invoice: 'cd94346c-2eb0-4513-8962-548dfd56fe03',
                monthlyInvoice: 'ef40730e-0ddc-4054-8956-fb58af090d54',
                monthlyInvoiceDirectDebit: 'ecdc2c96-d088-4390-b477-c76590e53b54',
                amazonPay: 'c8609f34-0615-42b8-a5b5-8fac84a7588c',
                sepa: '4fc9147e-66d2-45a7-a3a5-83f298fec2f3',
                app: '55f62acb-0ea7-4f68-b6a5-13b8a5e2b20d'
            },
            paymentProviders: {
                cash: 'JonnyFresh GmbH',
                creditCards: 'Adyen',
                payPal: 'PayPal',
                amazon: 'Amazon',
                sepa: 'Adyen',
                app: 'Apple Pay'
            },
            minOrderValue: 15.00,
            supportPhoneNumbers: {
                DE: '+49 30 536 034 570',
                DE_dial: '+4930536034570',
                AT: '+43 800 700 020',
                AT_dial: '+43800700020'
            },
            orderKinds: {
                b2b: 'b2b',
                b2c: 'b2c',
                corporate: 'corp'
            },
            actionCable: {
                debug: window.jfEbs ? window.jfEbs.JF_ACTION_CABLE_DEBUG : false,
                channels: {
                    jobs: 'ApplicationCable::Jobs'
                }
            },
            supportEmail: 'service@jonnyfresh.com',
            pageHeadTitleSuffix: ' | Jonny Fresh',
            cookies_domain: window.jfEbs ? window.jfEbs.JF_COOKIES_DOMAIN : '',
            adyenPublicKey: window.jfEbs ? window.jfEbs.JF_ADYEN_PUBLIC_KEY : '',
            adyenHmacKey: window.jfEbs ? window.jfEbs.JF_ADYEN_HMAC_KEY : '',
            adyenOriginKey: {
                desktop: window.jfEbs ? window.jfEbs.JF_ADYEN_ORIGIN_KEY_DESKTOP : '',
                android: window.jfEbs ? window.jfEbs.JF_ADYEN_ORIGIN_KEY_ANDROID : '',
                ios: window.jfEbs ? window.jfEbs.JF_ADYEN_ORIGIN_KEY_IOS : ''
            },
            adyenMerchantAccount: {
                DE: window.jfEbs ? window.jfEbs.JF_ADYEN_MERCHANT_ACCOUNT_DE : '',
                AT: window.jfEbs ? window.jfEbs.JF_ADYEN_MERCHANT_ACCOUNT_AT : ''
            },
            adyenSkinCode: window.jfEbs ? window.jfEbs.JF_ADYEN_SKIN_CODE : '',
            surveyProvider: window.jfEbs ? window.jfEbs.JF_SURVEY_PROVIDER: '',
            zenloop: {
                desktop: {
                    url: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_DESKTOP_URL : '',
                    hashIdDE: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_DESKTOP_HASH_ID_DE : '',
                    hashIdEN: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_DESKTOP_HASH_ID_EN : '',
                },
                mobile: {
                    url: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_MOBILE_URL : '',
                    imageUrl: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_MOBILE_IMAGE_URL : '',
                    hashIdDE: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_MOBILE_HASH_ID_DE : '',
                    hashIdEN: window.jfEbs ? window.jfEbs.JF_ZENLOOP_SURVEY_MOBILE_HASH_ID_EN : '',
                }
            },
            tripTypes: {
                pickup: 'PickupTrip',
                delivery: 'DeliveryTrip',
            },
            addressTypes: {
                invoice: 'invoice_addresses',
                service: 'service_addresses'
            },
            orderEvents: {
                conclude: 'conclude_at_shop'
            },
            orderStates: {
                commenced: 'commenced'
            },
            api_keys: {
                web: window.jfEbs ? window.jfEbs.JF_API_KEY_WEB : '',
                android: window.jfEbs ? window.jfEbs.JF_API_KEY_ANDROID : '',
                ios: window.jfEbs ? window.jfEbs.JF_API_KEY_IOS : ''
            },
            accountTypes: {
                company: 'company',
                personal: 'personal'
            },
            gMapApiKey: window.jfEbs ? window.jfEbs.JF_GMAP_API_KEY : '',
            appVersionCheckInterval: window.jfEbs ? window.jfEbs.JF_API_APP_VERSION_CHECK_INTERVAL : 2000,
            defaultOrderSort: '-created_at',
            codePushEnabled: window.jfEbs ? window.jfEbs.JF_MOBILE_CODE_PUSH_ENABLED : '',
            globalBottomAlertEnabled: false
        }
    )
    /**
     * Angular Resource interceptor
     */
    .config(['$resourceProvider', 'responseStatusProvider', 'JF_CONFIG', function($resourceProvider, responseStatusProvider, JF_CONFIG) {
        'use strict';

        $resourceProvider.defaults.actions = {
            update: {
                method: 'PUT',
                timeout: JF_CONFIG.requestTimeout,
                interceptor: {
                    response: responseStatusProvider.setStatus
                }
            },
            get: {
                method: 'GET',
                timeout: JF_CONFIG.requestTimeout,
                interceptor: {
                    response: responseStatusProvider.setStatus
                }
            },
            save : {
                method: 'POST',
                timeout: JF_CONFIG.requestTimeout,
                interceptor: {
                    response: responseStatusProvider.setStatus
                }
            },
            query : {
                method: 'GET',
                timeout: JF_CONFIG.requestTimeout,
                interceptor: {
                    response: responseStatusProvider.setStatus
                },
                isArray: true
            },
            remove : {
                method: 'DELETE',
                timeout: JF_CONFIG.requestTimeout,
                interceptor: {
                    response: responseStatusProvider.setStatus
                }
            },
            delete : {
                method: 'DELETE',
                timeout: JF_CONFIG.requestTimeout,
                interceptor: {
                    response: responseStatusProvider.setStatus
                }
            }
        };
    }])
    /**
     * XHR jfNetwork loading
     */
    .config(['$httpProvider', function($httpProvider) {
        'use strict';

        $httpProvider.interceptors.push('jfNetwork');
    }])
    /**
     * App urls
     */
    .config(['$locationProvider', function($locationProvider) {
        'use strict';

        if (!(document.URL.indexOf( 'https://cwa.' ) > -1 || (document.URL.indexOf( 'http://' ) === -1 && document.URL.indexOf( 'https://' ) === -1))) {
            $locationProvider.html5Mode(true);
        }
    }])
    /**
     * Routing config
     */
    .config(['$urlServiceProvider', '$urlRouterProvider', 'urlRulesProvider', function($urlServiceProvider, $urlRouterProvider, urlRulesProvider) {
        'use strict';

        $urlServiceProvider.config.strictMode(false);

        $urlRouterProvider.rule(urlRulesProvider.setTrailingSlash);
    }])
    /**
     * Translations config
     */
    .config(['$translateProvider', function($translateProvider) {
        'use strict';

        $translateProvider.usePostCompiling(true);
        $translateProvider.useStaticFilesLoader({
            prefix: 'app/i18n/',
            suffix: '.json' + '?v=' + window.jfAppVersion
        });
        $translateProvider.useMessageFormatInterpolation();
        $translateProvider.preferredLanguage('de_DE');
        // $translateProvider.fallbackLanguage('de');
        $translateProvider.useSanitizeValueStrategy('escapeParameters');
    }])
    .config(['$compileProvider', function($compileProvider) {
        'use strict';

        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file|blob|ionic):|data:image/);
    }])
    /**
     * Disable click hijack
     */
    .config(['$mdGestureProvider', function($mdGestureProvider) {
        'use strict';

        $mdGestureProvider.skipClickHijack();
    }])
    /**
     * JF theme settings
     */
    .config(['$mdIconProvider', '$mdThemingProvider', function($mdIconProvider, $mdThemingProvider) {
        // Angular-Material Color Theming
        'use strict';

        $mdIconProvider
            .icon('logo', './assets/svg/logo.svg', 48)
            .icon('logo_white', './assets/svg/logo-white.svg', 48)
            .icon('burger_menu', './assets/svg/burger-menu.svg', 48)
            .icon('products', './assets/svg/products.svg', 48)
            .icon('account', './assets/svg/account.svg', 48)
            .icon('help', './assets/svg/help.svg', 48)
            .icon('how', './assets/svg/how.svg', 48)
            .icon('arrow_right', './assets/svg/arrow-right.svg', 48)
            .icon('arrow_left', './assets/svg/arrow-left.svg', 48)
            .icon('arrow_right_blue', './assets/svg/arrow-right-blue.svg', 48)
            .icon('arrow_right_dark', './assets/svg/arrow-right-dark.svg', 48)
            .icon('add', './assets/svg/add.svg', 48)
            .icon('remove', './assets/svg/remove.svg', 48)
            .icon('edit', './assets/svg/edit.svg', 48)
            .icon('delete', './assets/svg/delete.svg', 48)
            .icon('credit_card_black', './assets/svg/credit_card_black.svg', 48)
            .icon('mc', './assets/svg/mastercard.svg', 48)
            .icon('visa', './assets/svg/visa.svg', 48)
            .icon('amex', './assets/svg/amex.svg', 48)
            .icon('broken_link', './assets/svg/broken-link.svg', 48)
            // Catalog categories - start
            .icon('business', './assets/svg/business.svg', 48)
            .icon('wash_and_fold', './assets/svg/wash-and-fold.svg', 48)
            .icon('outer', './assets/svg/outer.svg', 48)
            .icon('jackets', './assets/svg/jackets.svg', 48)
            .icon('flatwork', './assets/svg/flatwork.svg', 48)
            .icon('towels', './assets/svg/towels.svg', 48)
            .icon('underwear', './assets/svg/underwear.svg', 48)
            .icon('pillow', './assets/svg/pillow.svg', 48)
            .icon('festive', './assets/svg/festive.svg', 48)
            .icon('medical', './assets/svg/medical.svg', 48)
            .icon('work-clothes', './assets/svg/work-clothes.svg', 48)
            // Catalog categories - end
            .icon('new', './assets/svg/new.svg', 48)
            .icon('discount', './assets/svg/discount.svg', 48)
            .icon('time', './assets/svg/time.svg', 48)
            .icon('time-white', './assets/svg/time-white.svg', 48)
            .icon('increment', './assets/svg/increment.svg', 48)
            .icon('decrement', './assets/svg/decrement.svg', 48)
            .icon('fill', './assets/svg/fill.svg', 48)
            .icon('swipe', './assets/svg/swipe.svg', 48)
            .icon('pickup', './assets/svg/pickup.svg', 48)
            .icon('delivery', './assets/svg/delivery.svg', 48)
            .icon('drycleaning', './assets/svg/drycleaning.svg', 48)
            .icon('address', './assets/svg/address.svg', 48)
            .icon('payment', './assets/svg/payment.svg', 48)
            .icon('info', './assets/svg/info.svg', 48)
            .icon('calendar', './assets/svg/calendar.svg', 48)
            .icon('coupon', './assets/svg/coupon.svg', 48)
            .icon('check', './assets/svg/check.svg', 48)
            .icon('check_circle', './assets/svg/check_circle.svg', 48)
            .icon('category-placeholder', './assets/svg/jackets.svg', 48)
            // Trust bar icons
            .icon('support', './assets/svg/support-white.svg', 48)
            .icon('service', './assets/svg/service-white.svg', 48)
            .icon('location', './assets/svg/location-white.svg', 48)
            // Trust bar blue icons
            .icon('support_blue', './assets/svg/support-blue.svg', 48)
            .icon('service_blue', './assets/svg/service-blue.svg', 48)
            .icon('cart_blue', './assets/svg/cart-blue.svg', 48)
            .icon('location_blue', './assets/svg/location-blue.svg', 48)
            .icon('location_pink', './assets/svg/location-pink.svg', 48)
            .icon('location_white', './assets/svg/location-white.svg', 48)
            .icon('jf_logo_blue', './assets/svg/jf-logo-blue.svg', 48)
            .icon('person_blue', './assets/svg/jf-person-blue.svg', 48)
            .icon('person_pink', './assets/svg/jf-person-pink.svg', 48)
            .icon('person_white', './assets/svg/jf-person-white.svg', 48);



        $mdThemingProvider.definePalette('jfPrimaryPalette', {
            '50': '#D0E8F8',
            '100': '#9CCEEC',
            '200': '#68B4E0',
            '300': '#349AD4',
            '400': '#0080c8',
            '500': '#0073B4',
            '600': '#0066A0',
            '700': '#00598C',
            '800': '#004C78',
            '900': '#003F64',
            'A100': '#9CDFEA',
            'A200': '#68CDDE',
            'A400': '#34BBD2',
            'A700': '#00a9c6',
            'contrastDefaultColor': 'light'
        });

        $mdThemingProvider.definePalette('jfAccentPalette', {
            '50': '#F9DDE7',
            '100': '#F3B9D3',
            '200': '#ED95BF',
            '300': '#E771AB',
            '400': '#E14D97',
            '500': '#CA4588',
            '600': '#B33D79',
            '700': '#9C356A',
            '800': '#852D5B',
            '900': '#6E254C',
            'A100': '#ED95BF',
            'A200': '#E771AB',
            'A400': '#E14D97',
            'A700': '#CA4588',
            'contrastDefaultColor': 'light'
        });

        $mdThemingProvider.definePalette('jfWarnPalette', {
            '50': '#F9DFD9',
            '100': '#F3C1B5',
            '200': '#EDA391',
            '300': '#E7856D',
            '400': '#e16749',
            '500': '#CA5D42',
            '600': '#B3533B',
            '700': '#9C4934',
            '800': '#853F2D',
            '900': '#6E3526',
            'A100': '#FFAB9C',
            'A200': '#FF8368',
            'A400': '#FF5B34',
            'A700': '#FF3300',
            'contrastDefaultColor': 'light'
        });

        $mdThemingProvider
            .theme('default')
            .primaryPalette('jfPrimaryPalette', {
                'default': '400'
            })
            .accentPalette('jfAccentPalette', {
                'default': '400'
            })
            .warnPalette('jfWarnPalette', {
                'default': '400'
            });
    }])
    /**
     * Internet connection config
     */
    .config(['jfInternetConnectionProvider', function(jfInternetConnectionProvider) {
        'use strict';

        jfInternetConnectionProvider.setTranslations({
            offlinePopupTitle: 'OFFLINE_POPUP_TITLE',
            offlinePopupMsg: 'OFFLINE_POPUP_MSG',
            offlinePopupButton: 'OFFLINE_POPUP_BUTTON'
        });
    }])
    /**
     * User module
     */
    .config(['jfUserProvider', function(jfUserProvider) {
        'use strict';

        jfUserProvider.setUserDetailsToUpdate({
            data: {
                customerNo: 'customer_no',
                corporateCode: 'corporate_code',
                companyId: 'company_id',
                corporateEnabled: 'corporate_enabled',
                parcelServiceEnabled: 'parcel_service.enabled',
                allowPaymentMethodEdits: 'allow_payment_method_edits'
            },
            included: {
                firstName: 'first_name',
                lastName: 'last_name',
                phoneNo: 'phone_no',
                ppid: 'pickup_address_id',
                pdid: 'delivery_address_id',
                pbid: 'billing_address_id',
                defaultPaymentMethod: 'payment_method_id',
                locale: 'preferred_locale',
                country: 'country_of_residence',
                newsletter: 'newsletter',
                trip_notification: 'trip_notification_email',
                pb2bid: 'preferred_b2b_address_id',
                pb2bPaymentMethod: 'preferred_b2b_payment_method_id',
                companyPostalCode: 'company_postal_code',
                salutation: 'salutation',
                agb_version: 'agb_version',
                preferredBillingAgreementId: 'frontend_data.preferred_billing_agreement_id'
            },
            relationships: ['profile', 'company'],
            encode: ['corporateCode', 'firstName', 'lastName', 'phoneNo']
        });
    }])
    /**
     * Token module
     */
    .config(['jfTokenProvider', function(jfTokenProvider) {
        'use strict';

        jfTokenProvider.setTranslations({
            fatalErrorPopupTitle: 'FATAL_ERROR_POPUP_TITLE',
            fatalErrorPopupMsg: 'FATAL_ERROR_POPUP_MSG',
            fatalErrorPopupButton: 'FATAL_ERROR_POPUP_BUTTON'
        });
    }])
    /**
     * Network module
     */
    .config(['jfNetworkProvider', function(jfNetworkProvider) {
        'use strict';

        jfNetworkProvider.setTranslations({
            timeout1PopupTitle: 'TIMEOUT_1_POPUP_TITLE',
            timeout1PopupMsg: 'TIMEOUT_1_POPUP_MSG',
            timeout1PopupButton: 'TIMEOUT_1_POPUP_BUTTON',
            timeout2PopupTitle: 'TIMEOUT_2_POPUP_TITLE',
            timeout2PopupMsg: 'TIMEOUT_2_POPUP_MSG',
            timeout2PopupButton: 'TIMEOUT_2_POPUP_BUTTON'
        });
    }])
    /**
     * Login module
     */
    .config(['jfLoginProvider', function(jfLoginProvider) {
        'use strict';

        jfLoginProvider.setAllowedUserRole('customer');
        jfLoginProvider.setUserDetails({
            data: {
                customerNo: 'customer_no',
                corporateCode: 'corporate_code',
                corporateEnabled: 'corporate_enabled',
                parcelServiceEnabled: 'parcel_service.enabled',
                allowPaymentMethodEdits: 'allow_payment_method_edits'
            },
            included: {
                firstName: 'first_name',
                lastName: 'last_name',
                phoneNo: 'phone_no',
                ppid: 'pickup_address_id',
                pdid: 'delivery_address_id',
                pbid: 'billing_address_id',
                newsletter: 'newsletter',
                trip_notification: 'trip_notification_email',
                defaultPaymentMethod: 'payment_method_id',
                pb2bid: 'preferred_b2b_address_id',
                pb2bPaymentMethod: 'preferred_b2b_payment_method_id',
                companyPostalCode: 'company_postal_code',
                salutation: 'salutation',
                agb_version: 'agb_version',
                preferredBillingAgreementId: 'frontend_data.preferred_billing_agreement_id'
            },
            relationships: ['company'],
            encode: ['corporateCode', 'firstName', 'lastName', 'phoneNo']
        });
    }])
    /**
     * Helpers module
     */
    .config(['jfHelperProvider', 'JF_CONFIG', function(jfHelperProvider, JF_CONFIG) {
        'use strict';

        jfHelperProvider.setPageHeadTitleSuffix(JF_CONFIG.pageHeadTitleSuffix);
        jfHelperProvider.setTranslations({
            fatalErrorPopupTitle: 'FATAL_ERROR_POPUP_TITLE',
            fatalErrorPopupMsg: 'FATAL_ERROR_POPUP_MSG',
            fatalErrorPopupButton: 'FATAL_ERROR_POPUP_BUTTON'
        });
    }])
    /**
     * App Update module
     */
     .config(['jfAppUpdateProvider', function(jfAppUpdateProvider) {
        'use strict';

        jfAppUpdateProvider.setTranslations({
            forceUpdatePopupTitle: 'UPDATE_POPUP_TITLE',
            forceUpdatePopupMsg: 'UPDATE_POPUP_MSG',
            forceUpdatePopupButton: 'UPDATE_POPUP_BUTTON'
        });

        var googlePlayLink = 'market://details?id=de.jonnyfresh.jonnyfresh',
            appleStoreLink = 'itms-apps://itunes.apple.com/app/id1024534584';

        if (angular.isDefined(window.jfEbs) && window.jfEbs.JF_ENV === 'Staging') {
            googlePlayLink = 'market://details?id=de.jonnyfresh.staging';
        }

        jfAppUpdateProvider.setGooglePlayLink(googlePlayLink);
        jfAppUpdateProvider.setAppleStoreLink(appleStoreLink);
    }])
    /**
     * Mobile Events module
     */
    .config(['jfMobileEventsProvider', function(jfMobileEventsProvider) {
        'use strict';

        jfMobileEventsProvider.setAppDefaultScreens(['products']);
        jfMobileEventsProvider.setTranslations({
            appExitDialogTitle: 'APP_EXIT_DIALOG_TITLE',
            appExitDialogContent: 'APP_EXIT_DIALOG_CONTENT',
            appExitDialogOk: 'APP_EXIT_DIALOG_OK',
            appExitDialogCancel: 'APP_EXIT_DIALOG_CANCEL'
        });
    }]);

/**
 * App Google Analytics constants
 */
angular.module('jfApp')
    .constant(
        'JF_GA',
        {
            customEventName: 'jf:ga:customEvent',
            ga4CustomEventName: 'jf:ga4:customEvent',
            events: {
                loginPage: {
                    loginButton: {
                        category: 'Login Page',
                        action: 'Login Button'
                    },
                    forgotPasswordLink: {
                        category: 'Login Page',
                        action: 'Forgot Password Button'
                    },
                    registerLink: {
                        category: 'Login Page',
                        action: 'Register Button'
                    }
                },
                onBoardingPage: {
                    saveButton: {
                        category: 'Onboarding Page',
                        action: 'Save Button'
                    }
                },
                forgotPasswordPage: {
                    sendButton: {
                        category: 'Forgot Password Page',
                        action: 'Send Button'
                    },
                    backButton: {
                        category: 'Forgot Password Page',
                        action: 'Back Button'
                    }
                },
                registerPage: {
                    registerButton: {
                        category: 'Register Page',
                        action: 'Register Button'
                    },
                    loginButton: {
                        category: 'Register Page',
                        action: 'Login Button'
                    }
                },
                shopHeaderBar: {
                    shopLogo: {
                        category: 'Header',
                        action: 'Logo Click'
                    },
                    orderButton: {
                        category: 'Header',
                        action: 'New Order'
                    },
                    corporate: {
                        category: 'Header',
                        action: 'Corporate section'
                    },
                    corporateMan: {
                        category: 'Header',
                        action: 'Corporate - MAN'
                    },
                    corporateStroer: {
                        category: 'Header',
                        action: 'Corporate - Stroer'
                    },
                    accountButton: {
                        category: 'Header',
                        action: 'My Account'
                    },
                    faqButton: {
                        category: 'Header',
                        action: 'FAQ'
                    },
                    askUs: {
                        category: 'Header',
                        action: 'Ask us'
                    },
                    loginButton: {
                        category: 'Header',
                        action: 'Login'
                    },
                    logoutButton: {
                        category: 'Header',
                        action: 'Logout'
                    },
                    cartButton: {
                        category: 'Header',
                        action: 'Basket'
                    }
                },
                catalogCategoriesBar: {
                    category0: {
                        category: 'Category',
                        action: 'Business'
                    },
                    category1: {
                        category: 'Category',
                        action: 'Oberkleidung'
                    },
                    category2: {
                        category: 'Category',
                        action: 'Jacken & Mantel'
                    },
                    category3: {
                        category: 'Category',
                        action: 'Flachwäsche'
                    },
                    category4: {
                        category: 'Category',
                        action: 'Handtücher'
                    },
                    category5: {
                        category: 'Category',
                        action: 'Unterwäsche'
                    },
                    category6: {
                        category: 'Category',
                        action: 'Bett and Decken'
                    },
                    category7: {
                        category: 'Category',
                        action: 'Festtagsbekleidung'
                    },
                    category8: {
                        category: 'Category',
                        action: 'Praxiskleidung'
                    }
                },
                catalogPage: {
                    catalogTypeSelectChange: {
                        category: 'Catalog',
                        action: 'Profile Switch'
                    },
                    showCouponSectionLink: {
                        category: 'Catalog',
                        action: 'Catalog Coupon Option Click'
                    },
                    addToCartFromCatalog: {
                        category: 'Catalog',
                        action: 'Product: Add to basket'
                    },
                    removeFromCartFromCatalog: {
                        category: 'Catalog',
                        action: 'Product: Remove from Basket'
                    },
                    addToCartFromCart: {
                        category: 'Catalog',
                        action: 'On Cart: Add to basket'
                    },
                    removeFromCartFromCart: {
                        category: 'Catalog',
                        action: 'On Cart: Remove from Basket'
                    },
                    goToCheckoutButton: {
                        category: 'Catalog',
                        action: 'Proceed to Checkout button'
                    },
                    goToCheckoutButtonNoItems: {
                        category: 'Catalog',
                        action: 'Proceed to Checkout button - no items'
                    }
                },
                checkoutPage: {
                    editPickupTimeIcon: {
                        category: 'Checkout',
                        action: 'Pickup Appointment Edit'
                    },
                    editDeliveryTimeIcon: {
                        category: 'Checkout',
                        action: 'Delivery Options Edit Button'
                    },
                    paymentMethodSelectOptionBarzahlung: {
                        category: 'Checkout',
                        action: 'Payment Selector: Cash Payment'
                    },
                    paymentMethodSelectOptionPayPal: {
                        category: 'Checkout',
                        action: 'Payment Options: Paypal Payment'
                    },
                    paymentMethodSelectOptionKreditkarte: {
                        category: 'Checkout',
                        action: 'Payment Selector: Credit Card Payment'
                    },
                    paymentMethodSelectOptionMonatsrechnung: {
                        category: 'Checkout',
                        action: 'Payment Selector: Monatsrechnung Payment'
                    },
                    pickupNoteTextarea: {
                        category: 'Checkout',
                        action: 'Pickup Notes'
                    },
                    deliveryNoteTextarea: {
                        category: 'Checkout',
                        action: 'Delivery Note'
                    },
                    specialInstructionsNoteTextarea: {
                        category: 'Checkout',
                        action: 'Special Notes'
                    },
                    showCouponSectionLink: {
                        category: 'Checkout',
                        action: 'Coupon Option'
                    },
                    addCouponButton: {
                        category: 'Checkout',
                        action: 'Einlösen Button'
                    },
                    removeCouponButton: {
                        category: 'Checkout',
                        action: 'Coupon Code Removal'
                    },
                    backButton: {
                        category: 'Checkout',
                        action: 'One Page Checkout Back Button'
                    },
                    newsletterCheckbox: {
                        category: 'Checkout',
                        action: 'Newsletter Input'
                    },
                    confirmOrderButton: {
                        category: 'Checkout',
                        action: 'Confirm Order Button'
                    }
                },
                checkoutConfirmationPage: {
                    backButton: {
                        category: 'Confirmation page',
                        action: 'Back button'
                    },
                    orderNowButton: {
                        category: 'Confirmation Page',
                        action: 'Purchase Button'
                    }
                },
                myAccountPage: {
                    detailsNavItem: {
                        category: 'My Account',
                        action: 'My Details'
                    },
                    preferencesNavItem: {
                        category: 'My Account',
                        action: 'Kundenwünsche'
                    },
                    passwordNavItem: {
                        category: 'My Account',
                        action: 'Password'
                    },
                    'my-addressesNavItem': {
                        category: 'My Account',
                        action: 'Addresses'
                    },
                    'my-ordersNavItem': {
                        category: 'My Account',
                        action: 'Order History'
                    }
                },
                footer: {
                    impressum: {
                        category: 'Footer',
                        action: 'Footer Menu Item: Impressum'
                    },
                    privacy: {
                        category: 'Footer',
                        action: 'Footer Menu Item: Datenschutz'
                    },
                    terms: {
                        category: 'Footer',
                        action: 'Footer Menu Item: AGB'
                    },
                    appStore: {
                        category: 'Footer',
                        action: 'Footer Menu Item: App Store'
                    },
                    googlePlay: {
                        category: 'Footer',
                        action: 'Footer Menu Item: Google Play'
                    },
                    googlePlus: {
                        category: 'Footer',
                        action: 'Footer Menu Item: Google+'
                    },
                    twitter: {
                        category: 'Footer',
                        action: 'Footer Menu Item: Twitter'
                    }
                }
            }
        }
    );
angular.module('templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('app/layout/main.html','<div ui-view="sidenav" ng-hide="$mdMedia(\'gt-xs\')"></div>\n\n<div layout="column" layout-fill role="main">\n    <div ui-view="nav-toolbar" ng-if="[\'products\', \'checkout.success\', \'account.section\', \'wp-content\', \'help\', \'account\', \'404\', \'invoices\', \'maintenance\'].indexOf($state.current.name) > -1 && source !== \'app\'" class="jf-nav-toolbar-container jf-top-bar"></div>\n    <div ui-view="products-toolbar" ng-if="[\'products\'].indexOf($state.current.name) > -1"></div>\n    <div ui-view="products-location-toolbar" ng-if="$mdMedia(\'xs\') && [\'products\'].indexOf($state.current.name) > -1"></div>\n    <div ui-view="account-toolbar" ng-if="$mdMedia(\'gt-xs\') && [\'account\', \'account.section\'].indexOf($state.current.name) > -1"></div>\n\n    <md-content flex md-scroll-y in-view-container layout-fill class="jf-main-scrollable-section" jf-scroll-top-on-state-change style="scroll-behavior: smooth;">\n        <div ui-view="trust-bar" ng-if="[\'products\',\'checkout.success\', \'account\', \'account.section\'].indexOf($state.current.name) === -1" class="jf-trust-bar-container"></div>\n        <ui-view class="jf-main-content-container">\n            <div ui-view="content" class="jf-main-content jf-animated-transition"></div>\n        </ui-view>\n        <jf-footer ng-if="!mobileAppMode && [\'instructions\',\n                                             \'checkout\',\n                                             \'checkout.summary\',\n                                             \'checkout.notes\',\n                                             \'checkout.addresses\',\n                                             \'checkout.pickup-delivery\',\n                                             \'login\',\n                                             \'register\',\n                                             \'location-picker\',\n                                             \'forgot_password\',\n                                             \'password_reset\',\n                                             \'on-boarding\'\n                                             ].indexOf($state.current.name) === -1\n                                            && source !== \'app\'"\n        ></jf-footer>\n    </md-content>\n    <div ui-view="footer-toolbar"></div>\n</div>\n<jf-spinner ng-if="jfShared.spinner.isLoading(\'global\')" spinner-position="40"></jf-spinner>\n<jf-corporate-popup></jf-corporate-popup>\n<jf-mobile-app-download></jf-mobile-app-download>\n\n<div class="jf-cwa-bottom-alert" ng-if="showGlobalBottomAlert()">\n    <p><img src="/assets/img/bottom-alert-image-shirt.png" alt="" width="30" height="30" /> {{\'BOTTOM_WARNING_TEXT\' | translate}}</p>\n</div>');
$templateCache.put('app/blocks/cart/laundry-basket-bar.html','<div ng-controller="LaundryBasketController" ng-if="($mdMedia(\'xs\') || $mdMedia(\'sm\'))">\n    <md-toolbar ng-hide="couponForm" class="md-accent jf-laundry-basket-bar">\n        <div class="md-toolbar-tools jf-laundry-basket-bar-text" ng-click="proceedToCheckoutMobile()">\n            <h2 class="jf-laundry-basket-bar-text-description">\n                <p ng-if="order.details.attributes.items_number !== 0" class="jf-laundry-basket-bar-text-description-item" translate>CONTINUE_TO_CHECKOOUT</p>\n                <p ng-if="order.details.attributes.items_number === 0" class="jf-laundry-basket-bar-text-description-item" translate>CONFIRM_ORDER_WITHOUT_ITEMS</p>\n            </h2>\n            <span flex></span>\n            <md-button class="md-icon-button" aria-label="{{\'YOUR_ORDER\' | translate}}">\n                <md-icon md-svg-icon="arrow_right"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n</div>\n\n');
$templateCache.put('app/blocks/cart/laundry-basket-icon.html','<md-button aria-label="{{\'LAUNDRY_BASKET\' | translate}}" ng-click="redirectToCheckoutDesktop()"\n           ng-if="$mdMedia(\'gt-xs\')" class="md-icon-button jf-laundry-basket-button"\n           id="header-nav-item-basket"\n>\n    <div class="jf-laundry-basket-icon"></div>\n    <span class="jf-laundry-basket-items-count" ng-if="order.additionalInfo.totalItems > 0">{{order.additionalInfo.totalItems}}</span>\n</md-button>\n\n<md-button aria-label="{{\'LAUNDRY_BASKET\' | translate}}" ng-click="redirectToCheckoutMobile()" class="md-icon-button jf-laundry-basket-button"\n           ng-if="$mdMedia(\'xs\')" id="header-nav-item-mobile-basket"\n>\n    <div class="jf-laundry-basket-icon"></div>\n    <span class="jf-laundry-basket-items-count" ng-if="order.additionalInfo.totalItems > 0">{{order.additionalInfo.totalItems}}</span>\n</md-button>');
$templateCache.put('app/blocks/nav/header-account-switcher.directive.html','<div>\n    <div class="jf-popup-container jf-popup-account-switcher" ng-class="{ \'jf-popup-trust-bar\': trustBar }" trust-bar-click-outside="accountSwitcher" ng-if="accountSwitcher">\n        <div class="jf-popup-title">\n            {{\'ACCOUNT_TYPE\' | translate}}\n            <i class="material-icons" ng-click="closePopup()">cancel</i>\n        </div>\n        <div class="jf-popup-body">\n            <span ng-class="!account.switcher ? \'jf-active-account-type\' : \'jf-not-active-account-type\'">{{\'ACCOUNT_TYPE_PRIVATE\' | translate}}</span>\n            <md-switch ng-disabled="!corporateEnabled" ng-change="changeAccountType()" ng-model="account.switcher" aria-label="{{\'ACCOUNT_TYPE\' | translate}}" id="header-nav-item-account-switcher-selector">\n            </md-switch>\n            <span ng-class="account.switcher ? \'jf-active-account-type\' : \'jf-not-active-account-type\'">{{\'ACCOUNT_TYPE_COMPANY\' | translate}}</span>\n        </div>\n    </div>\n    <div class="jf-popup-backdrop"></div>\n</div>');
$templateCache.put('app/blocks/nav/header-catalog-location-selector.directive.html','<div>\n    <div ng-if="expandedOutside !== true" class="jf-popup-container jf-popup-catalog-switcher" ng-class="{ \'jf-popup-trust-bar\': trustBar }" trust-bar-click-outside="catalogSelector">\n        <div class="jf-popup-title">\n            {{\'CHANGE_POSTALCODE\' | translate}}\n            <i class="material-icons" ng-click="closePopup()">cancel</i>\n        </div>\n        <div class="jf-popup-body">\n            <form name="headerLocationSelectorForm" class="jf-form" novalidate>\n                <div class="jf-popup-row">\n                    <span>{{\'CURRENT_POSTAL_CODE\'| translate}}</span>\n                    <span class="jf-current-city">{{currentCatalogPostalCode}} {{currentDeliveryLocation}}</span>\n                </div>\n                <div class="jf-popup-row" layout="column">\n                    <span>{{\'DESIRED_POSTAL_CODE\'| translate}}</span>\n                    <md-input-container flex class="jf-input-container md-block jf-postal-code-container" md-no-float id="header-nav-item-catalog-changer-input">\n                        <jf-postal-code ng-cloak model="formModel" form="headerLocationSelectorForm" selectedtext="selectedPostalCode"\n                                    validate-in-service="true" repeater-css-class="repeaterCssClass"\n                                    custom-clear-button="true" short-suggestions="true" show-standard-label="true"\n                                    disable-same-city-check="true"\n                        >\n                        </jf-postal-code>\n                    </md-input-container>\n                </div>\n            </form>\n            <md-button ng-click="submitLocationForm(headerLocationSelectorForm)" ng-disabled="!formModel.postal_code || formModel.postal_code === currentCatalogPostalCode" class="jf-button jf-mark-button md-raised md-accent"\n                        aria-label="{{\'CHANGE_CATALOG_POSTAL_CODE\' | translate}}" id="header-nav-item-catalog-changer-button"\n            >\n                {{\'CHANGE_CATALOG_POSTAL_CODE\' | translate}}\n            </md-button>\n        </div>\n    </div>\n    <div ng-if="expandedOutside !== true" class="jf-popup-backdrop"></div>\n    <div ng-if="expandedOutside === true" class="jf-mobile-catalog-switcher-popup">\n        <form name="headerLocationSelectorForm" class="jf-form" novalidate>\n            <div class="jf-mobile-catalog-changer-current-city">\n                <span>{{\'CURRENT_POSTAL_CODE\'| translate}}</span>\n                <span class="jf-current-city">{{currentCatalogPostalCode}} {{currentDeliveryLocation}}</span>\n            </div>\n            <div class="jf-mobile-catalog-changer-new-city" layout="column">\n                <span>{{\'DESIRED_POSTAL_CODE\'| translate}}</span>\n                <md-input-container flex class="jf-input-container md-block jf-postal-code-container" md-no-float id="header-nav-item-catalog-changer-mobile-input">\n                    <jf-postal-code ng-cloak model="formModel" form="headerLocationSelectorForm" selectedtext="selectedPostalCode"\n                                    validate-in-service="true" repeater-css-class="repeaterCssClass"\n                                    custom-clear-button="false" short-suggestions="false" show-standard-label="true"\n                                    disable-same-city-check="true"\n                    >\n                    </jf-postal-code>\n                </md-input-container>\n            </div>\n        </form>\n        <md-button ng-click="submitLocationForm(headerLocationSelectorForm)" ng-disabled="!formModel.postal_code" class="jf-button jf-mark-button md-raised md-accent"\n                   aria-label="{{\'CHANGE_CATALOG_POSTAL_CODE\' | translate}}" id="header-nav-item-catalog-changer-mobile-button"\n        >\n            {{\'CHANGE_CATALOG_POSTAL_CODE\' | translate}}\n        </md-button>\n    </div>\n</div>');
$templateCache.put('app/blocks/nav/nav-toolbar.desktop.html','<md-toolbar flex class="jf-nav-toolbar" ng-class="{\'jf-header-staging\' : isStaging()}">\n    <div class="jf-container">\n        <div class="md-toolbar-tools">\n            <div class="md-toolbar-item">\n                <a href="{{blogUrl}}{{\'PRIVATE_CUSTOMERS_URL\' | translate}}" class="jf-logo-link" ng-click="sendGAEvent(\'shopHeaderBar\', \'shopLogo\')">\n                    <img src="assets/img/jf-logo-white@2x.png" alt="" width="119" height="34" class="jf-logo-link">\n                </a>\n            </div>\n            <span class="flex"></span>\n            <div class="md-toolbar-item" layout="row" layout-align="space-between center">\n                <md-button class="jf-nav-toolbar-order-button" aria-label="{{\'PRODUCTS\' | translate}}" md-no-ink\n                           ui-sref="products({\'#\': \'c0\'})" ng-click="sendGAEvent(\'shopHeaderBar\', \'orderButton\')" ng-class="{\'jf-active-nav-item\': state.current.name === \'products\'}"\n                           id="header-nav-item-catalog"\n                >\n                    {{\'PRODUCTS\' | translate}}\n                </md-button>\n                <md-button class="jf-nav-toolbar-order-jf-support" aria-label="{{\'JF_SUPPORT\' | translate}}"\n                           ng-href="{{blogUrl + \'/kundenservice/\'}}" md-no-ink ng-click="sendGAEvent(\'shopHeaderBar\', \'askUs\')"\n                           id="header-nav-item-support"\n                >\n                    {{\'JF_SUPPORT\' | translate}}\n                </md-button>\n                <md-button class="jf-nav-toolbar-order-faq" aria-label="{{\'FAQ\' | translate}}"\n                           ng-href="{{blogUrl + \'/faq/\'}}" md-no-ink ng-click="sendGAEvent(\'shopHeaderBar\', \'faqButton\')"\n                           id="header-nav-item-faq"\n                >\n                    {{\'FAQ\' | translate}}\n                </md-button>\n                <div class="jf-second-lvl-nav jf-current-user-link">\n                    <div class="jf-second-lvl-nav-link">\n                        <md-button class="jf-nav-toolbar-order-corporate" aria-label="{{\'ACCOUNT\' | translate}}"\n                                   md-no-ink\n                                   ng-class="{\'jf-active-nav-item\': state.current.name === \'account\' || state.current.name === \'account.section\'}"\n                                   ng-click="redirectToAccount()" id="header-nav-item-my-account"\n                        >\n                            <span class="jf-nav-toolbar-order-corporate-salutation">{{ \'HELLO\' | translate }}, {{ name }}</span>\n                            <span class="jf-nav-toolbar-order-corporate-description">{{\'ACCOUNT\' | translate}}</span>\n                        </md-button>\n                    </div>\n                    <div class="jf-second-lvl-nav-content">\n                        <md-button class="jf-nav-toolbar-order-account" aria-label="{{\'SETTINGS\' | translate}}"\n                                   ui-sref="account.section({section: \'my-orders\', subnav: null})" md-no-ink\n                                   ng-click="sendGAEvent(\'shopHeaderBar\', \'accountButton\')"\n                                   id="header-nav-item-settings"\n                        >\n                            <i class="material-icons">keyboard_arrow_right</i> {{\'SETTINGS\' | translate}}\n                        </md-button>\n                        <md-button class="jf-nav-toolbar-order-logout" ng-if="jfShared.jfUser.id"\n                                   aria-label="{{\'SIGN_OUT\' | translate}}" ui-sref="logout" md-no-ink\n                                   ng-click="sendGAEvent(\'shopHeaderBar\', \'logoutButton\')"\n                                   id="header-nav-item-logout"\n                        >\n                            <i class="material-icons">keyboard_arrow_right</i> {{\'SIGN_OUT\' | translate}}\n                        </md-button>\n                        <md-button class="jf-nav-toolbar-order-login" ng-if="!jfShared.jfUser.id"\n                                   aria-label="{{\'SIGN_IN\' | translate}}" ui-sref="login" md-no-ink\n                                   ng-click="sendGAEvent(\'shopHeaderBar\', \'loginButton\')"\n                                   id="header-nav-item-login"\n                        >\n                            <i class="material-icons">keyboard_arrow_right</i> {{\'SIGN_IN\' | translate}}\n                        </md-button>\n                    </div>\n                </div>\n                <div class="jf-second-lvl-nav jf-language-switcher-link">\n                    <jf-language-switcher origin="nav"></jf-language-switcher>\n                </div>\n                <div class="jf-second-lvl-nav">\n                    <jf-button-profile-changer origin="nav" color="white" show-caption="true"></jf-button-profile-changer>\n                </div>\n                <div class="jf-second-lvl-nav">\n                    <jf-button-catalog-changer origin="nav" color="white" show-caption="false"></jf-button-catalog-changer>\n                </div>\n            </div>\n\n            <ng-include src="\'app/blocks/cart/laundry-basket-icon.html\'"></ng-include>\n        </div>\n    </div>\n</md-toolbar>\n');
$templateCache.put('app/blocks/nav/nav-toolbar.html','<md-toolbar flex class="jf-nav-toolbar" ng-class="{\'jf-nav-open-menu\' : isOpen(), \'jf-header-staging\' : isStaging()}"\n            ng-if="$mdMedia(\'xs\') && [\'checkout.success\', \'account.section\'].indexOf(state.current.name) > -1"\n>\n    <div class="jf-container">\n        <div class="md-toolbar-tools">\n            <div aria-label="{{\'TOGGLE_NAVIGATION\' | translate}}"\n                 class="jf-burger-menu-toggle" layout="column" layout-align="space-between start"\n                 ng-click="activateMenu()"\n                 ng-class="{\'jf-open-burger-icon\' : isOpen()}"\n            >\n                <div class="jf-burger-menu-line"></div>\n                <div class="jf-burger-menu-line"></div>\n                <div class="jf-burger-menu-line"></div>\n            </div>\n            <md-button class="md-icon-button jf-view-back-button" aria-label="{{\'BACK\' | translate}}"\n                       ng-click="goBackActionFromNav()"\n                       ng-hide="($state.params.section === \'confirm\' && countObjKeys(order.items) === 0) || isOpen()"\n            >\n                <md-icon md-svg-icon="arrow_left"></md-icon>\n            </md-button>\n            <span class="jf-nav-toolbar-title" translate="{{jfShared.pageTitle}}"></span>\n            <ng-include src="\'app/blocks/cart/laundry-basket-icon.html\'" class="jf-mobile-nav-toolbar-cart-container"></ng-include>\n        </div>\n    </div>\n</md-toolbar>\n\n<ng-include src="\'app/blocks/nav/nav-toolbar.mobile.html\'" ng-if="$mdMedia(\'xs\') && [\'checkout.success\', \'account.section\'].indexOf(state.current.name) === -1"></ng-include>\n<ng-include src="\'app/blocks/nav/nav-toolbar.desktop.html\'" ng-if="$mdMedia(\'gt-xs\')"></ng-include>');
$templateCache.put('app/blocks/nav/nav-toolbar.mobile.html','<md-toolbar flex class="jf-nav-toolbar" ng-class="{\'jf-nav-open-menu\' : isOpen(), \'jf-header-staging\' : isStaging()}"  ng-hide="mobileAppMode === true &&\n                                                ($state.current.name === \'home\' ||\n                                                $state.current.name === \'register\' ||\n                                                $state.current.name === \'login\' ||\n                                                $state.current.name === \'forgot_password\' ||\n                                                $state.current.name === \'password_reset\')">\n    <div class="jf-container">\n        <div class="md-toolbar-tools">\n            <div aria-label="{{\'TOGGLE_NAVIGATION\' | translate}}"\n                 class="jf-burger-menu-toggle" layout="column" layout-align="space-between start"\n                 ng-click="activateMenu()"\n                 ng-class="{\'jf-open-burger-icon\' : isOpen()}"\n            >\n                <div class="jf-burger-menu-line"></div>\n                <div class="jf-burger-menu-line"></div>\n                <div class="jf-burger-menu-line"></div>\n            </div>\n            <span class="jf-nav-toolbar-title" translate="{{jfShared.pageTitle}}" ng-if="mobileAppMode === true"></span>\n            <md-button aria-label="Jonny Fresh" ng-href="{{blogUrl}}{{\'PRIVATE_CUSTOMERS_URL\' | translate}}" class="jf-logo-link-mobile"\n                       ng-if="mobileAppMode === false && $state.current.name !== \'checkout\'"\n            >\n                <img src="assets/img/jf-logo-white@2x.png" alt="" width="119" height="34" class="jf-logo-link-mobile">\n            </md-button>\n            <jf-button-profile-changer origin="nav" color="white" show-caption="true"></jf-button-profile-changer>\n            <jf-button-catalog-changer origin="nav" color="white" show-caption="false"></jf-button-catalog-changer>\n            <ng-include src="\'app/blocks/cart/laundry-basket-icon.html\'" class="jf-mobile-nav-toolbar-cart-container"></ng-include>\n        </div>\n    </div>\n</md-toolbar>\n');
$templateCache.put('app/blocks/nav/sidenav.html','<md-sidenav class="md-sidenav-left jf-sidenav" ng-class="{\'jf-app-download-notification-visible\' : !mobileAppMode && appDownloadNotificationVisible}" md-component-id="left"\n            ng-hide="mobileAppMode === true &&\n                    ($state.current.name === \'register\' ||\n                    $state.current.name === \'login\' ||\n                    $state.current.name === \'forgot_password\' ||\n                    $state.current.name === \'password_reset\')">\n    <md-list ng-cloak class="jf-sidenav-list">\n        <md-list-item ng-click="close()" ui-sref="products">\n            <p class="md-list-item-text" translate>PRODUCTS</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="close()" ui-sref="account">\n            <p class="md-list-item-text" translate>ACCOUNT</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="close()" ui-sref="help" ng-if="mobileAppMode === true">\n            <p class="md-list-item-text" translate>HELP</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="close()" ng-href="{{blogUrl + \'/kundenservice/\'}}" ng-if="mobileAppMode === false">\n            <p class="md-list-item-text" translate>JF_SUPPORT</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="openExternalUrl(blogUrl + \'/faq\', \'FAQ\')">\n            <p class="md-list-item-text" translate>FAQ</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="close()" ui-sref="instructions" ng-if="mobileAppMode === true">\n            <p class="md-list-item-text" translate>HOW_IT_WORKS</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="showAboutUs = !showAboutUs" ng-class="{\'jf-open-sublist\' : showAboutUs}" ng-show="mobileAppMode === false" md-no-ink class="jf-has-sublist">\n            <p class="md-list-item-text" translate>INFORMATIONS</p>\n        </md-list-item>\n        <div class="jf-sidenav-sublist" ng-show="mobileAppMode === false && showAboutUs">\n            <md-list-item ng-click="close()" ng-href="{{blogUrl + \'/ueber-uns/\'}}" ng-if="mobileAppMode === false">\n                <p class="md-list-item-text" translate>ABOUT_US</p>\n            </md-list-item>\n            <md-list-item ng-click="close()" ng-href="{{blogUrl + \'/jobs/\'}}" ng-if="mobileAppMode === false">\n                <p class="md-list-item-text" translate>JOBS</p>\n            </md-list-item>\n            <md-list-item ng-click="close()" ng-href="{{blogUrl + \'/blog/\'}}" ng-if="mobileAppMode === false">\n                <p class="md-list-item-text" translate>BLOG</p>\n            </md-list-item>\n        </div>\n        <!-- ================= -->\n        <md-list-item ng-click="showLegals = !showLegals" ng-class="{\'jf-open-sublist\' : showLegals}" md-no-ink class="jf-has-sublist">\n            <p class="md-list-item-text" translate>LEGAL</p>\n        </md-list-item>\n        <div class="jf-sidenav-sublist" ng-show="showLegals">\n            <md-list-item ng-click="openExternalUrl(blogUrl + \'/agb\', \'LEGAL\')">\n                <p class="md-list-item-text" translate>TERMS_AND_CONDITIONS</p>\n            </md-list-item>\n            <md-list-item ng-click="openExternalUrl(blogUrl + \'/datenschutz\', \'PRIVACY\')">\n                <p class="md-list-item-text" translate>PRIVACY</p>\n            </md-list-item>\n            <md-list-item ng-click="openExternalUrl(blogUrl + \'/impressum\', \'IMPRINT\')">\n                <p class="md-list-item-text" translate>IMPRINT</p>\n            </md-list-item>\n        </div>\n        <!-- ================= -->\n        <jf-language-switcher origin="sidenav" show-language-nav="showLanguageNav" mobile-app-mode="mobileAppMode"></jf-language-switcher>\n        <!-- ================= -->\n        <!-- ================= -->\n        <md-list-item ng-click="close()" ui-sref="login" ng-if="!jfShared.jfUser.id" class="jf-sidenav-login-logout-link">\n            <p class="md-list-item-text" translate>SIGN_IN</p>\n        </md-list-item>\n        <!-- ================= -->\n        <md-list-item ng-click="close()" ui-sref="logout" ng-if="jfShared.jfUser.id" class="jf-sidenav-login-logout-link">\n            <p class="md-list-item-text" translate>SIGN_OUT</p>\n        </md-list-item>\n        <!-- ================= -->\n    </md-list>\n</md-sidenav>\n');
$templateCache.put('app/blocks/nav/trust-bar.html','<div ng-if="[\'login\', \'register\', \'forgot_password\', \'password_reset\', \'on-boarding\', \'location-picker\'].indexOf($state.current.name) > -1" class="jf-white-trust-bar">\n    <div class="jf-trust-bar jf-top-bar" ng-class="{\'jf-download-app-notification-visible\' : appDownloadNotificationVisible}" layout="row" layout-align="space-around start">\n        <div flex>\n            <div class="jf-trust-bar-icon">\n                <md-button class="md-icon" md-no-ink aria-label="{{\'SUPPORT\' | translate}}">\n                    <md-icon class="jf-arrow-icon" md-svg-icon="support">menu</md-icon>\n                    <div flex class="jf-trust-bar-text">\n                        <div>{{\'SUPPORT\' | translate}}</div>\n                        <div>{{\'SUPPORT_DAYS\' | translate}}</div>\n                    </div>\n                </md-button>\n            </div>\n        </div>\n        <div flex>\n            <div class="jf-trust-bar-icon">\n                <md-button class="md-icon" md-no-ink aria-label="{{\'SERVICE24\' | translate}}">\n                    <md-icon class="jf-arrow-icon" md-svg-icon="service">menu</md-icon>\n                    <div flex class="jf-trust-bar-text">\n                        <div>{{\'PROCESSING_TIME_SERVICE_TRUST_BAR\' | translate}} <br> {{\'PROCESSING_TIME_TRUST_BAR\' | translate}}</div>\n                    </div>\n                </md-button>\n            </div>\n        </div>\n        <div flex>\n            <div class="jf-trust-bar-icon">\n                <md-button class="md-icon" md-no-ink aria-label="{{\'LOCATION\' | translate}}">\n                    <md-icon md-svg-icon="location">menu</md-icon>\n                    <div flex class="jf-trust-bar-text">{{\'LOCATION_TRUST_BAR\' | translate}} <br> {{\'APPOINTMENT_TRUST_BAR\' | translate}}</div>\n                </md-button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="jf-reverse-trust-bar" ng-if="[\'checkout\', \'checkout.summary\', \'checkout.notes\', \'checkout.addresses\', \'checkout.pickup-delivery\'].indexOf($state.current.name) > -1">\n    <div class="jf-trust-bar jf-top-bar" ng-class="{\'jf-download-app-notification-visible\' : appDownloadNotificationVisible}">\n        <div class="jf-container" layout="row" layout-align="space-between center">\n            <div ng-hide="$mdMedia(\'sm\') || $mdMedia(\'xs\')" class="jf-logo-trust-bar-block">\n                <md-icon class="jf-logo-blue jf-icon-nav" md-svg-icon="jf_logo_blue">menu</md-icon>\n            </div>\n            <a ui-sref="products({ stepBack: true })" class="jf-mobile-checkout-back-button" ng-if="($mdMedia(\'sm\') || $mdMedia(\'xs\')) && $state.current.name === \'checkout\'">\n                <i class="material-icons">arrow_back_ios</i>\n            </a>\n            <div flex flex-gt-sm="73" class="jf-trust-bar-icons-block" ng-class="{\'jf-checkout-back-button-active\': ($mdMedia(\'sm\') || $mdMedia(\'xs\')) && $state.current.name === \'checkout\'}" layout="row" layout-align="end start">\n                <div flex-xs flex-sm>\n                    <md-button class="md-icon" md-no-ink aria-label="{{\'SUPPORT\' | translate}}">\n                        <div layout-xs="column" layout="row" layout-align="center center">\n                            <md-icon class="jf-arrow-icon" md-svg-icon="support_blue">menu</md-icon>\n                            <div flex class="jf-trust-bar-text">\n                                <div>{{\'SUPPORT\' | translate}}</div>\n                                <div>{{\'SUPPORT_DAYS\' | translate}}</div>\n                            </div>\n                        </div>\n                    </md-button>\n                </div>\n                <div flex-xs flex-sm>\n                    <md-button class="md-icon" md-no-ink aria-label="{{\'SERVICE24\' | translate}}">\n                        <div layout-xs="column" layout="row" layout-align="center center">\n                            <md-icon class="jf-arrow-icon" md-svg-icon="service_blue" class="jf-icon-nav">menu</md-icon>\n                            <div flex class="jf-trust-bar-text">\n                                <div>{{\'PROCESSING_TIME_SERVICE_TRUST_BAR\' | translate}} <br> {{\'PROCESSING_TIME_TRUST_BAR\' | translate}}</div>\n                            </div>\n                        </div>\n                    </md-button>\n                </div>\n                <div flex-xs flex-sm>\n                    <md-button class="md-icon" md-no-ink aria-label="{{\'LOCATION_TRUST_BAR\' | translate}}">\n                        <div layout-xs="column" layout="row" layout-align="center center">\n                            <md-icon md-svg-icon="location_blue" class="jf-icon-nav">menu</md-icon>\n                            <div flex class="jf-trust-bar-text">\n                                <div>{{\'LOCATION_TRUST_BAR\' | translate}} <br> {{\'APPOINTMENT_TRUST_BAR\' | translate}}</div>\n                            </div>\n                        </div>\n                    </md-button>\n                </div>\n                <div flex-xs flex-sm class="jf-tooltip-parent" ng-if="corporateEnabled">\n                    <jf-button-profile-changer origin="trustbar" color="blue" show-caption="true" trust-bar="true"></jf-button-profile-changer>\n                </div>\n                <div flex-xs flex-sm class="jf-tooltip-parent">\n                    <jf-button-catalog-changer origin="trustbar" color="blue" show-caption="true" trust-bar="true"></jf-button-catalog-changer>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/404/404.html','<div class="jf-container jf-container--small">\n    <h2 class="md-display-2">{{\'PAGE_NOT_FOUND_CONTENT_TITLE\' | translate}}</h2>\n    <p>{{\'PAGE_NOT_FOUND_CONTENT_TEXT\' | translate}}</p>\n    <div class="jf-spacer-15"></div>\n</div>');
$templateCache.put('app/components/home/home.html','<jf-instructions></jf-instructions>\n<div ui-view="footer-toolbar"></div>');
$templateCache.put('app/components/checkout/checkout-profile.dialog.html','<md-dialog class="jf-dialog">\n    <md-toolbar>\n        <div class="md-toolbar-tools">\n            <h2 translate>MISSING_PROFILE_FIELDS_POPUP_TITLE</h2>\n        </div>\n    </md-toolbar>\n    <form name="missingProfileDataForm" novalidate>\n        <md-dialog-content>\n            <div class="md-dialog-content" style="padding-bottom: 10px;">\n                {{ \'MISSING_PROFILE_FIELDS_POPUP_TEXT\' | translate }}<br><br>\n                <md-input-container class="jf-input-container md-block" flex md-no-float ng-if="!currentUser.firstName">\n                    <md-input-label>* {{ \'FIRST_NAME\' | translate }}</md-input-label>\n                    <input name="first_name" ng-model="userProfileData.profile_attributes.first_name" placeholder="{{ \'FIRST_NAME_PLACEHOLDER\' | translate }}" required>\n                    <div ng-messages="missingProfileDataForm.first_name.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                    </div>\n                </md-input-container>\n                <md-input-container class="jf-input-container md-block" flex md-no-float ng-if="!currentUser.lastName">\n                    <md-input-label>* {{ \'LAST_NAME\' | translate }}</md-input-label>\n                    <input name="last_name" ng-model="userProfileData.profile_attributes.last_name" placeholder="{{ \'LAST_NAME_PLACEHOLDER\' | translate }}" required>\n                    <div ng-messages="missingProfileDataForm.last_name.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                    </div>\n                </md-input-container>\n                <md-input-container class="jf-input-container md-block" flex md-no-float ng-if="!currentUser.phoneNo">\n                    <md-input-label>* {{ \'TELEPHONE_NUMBER\' | translate }}</md-input-label>\n                    <input type="tel" name="phone_no" ng-model="userProfileData.profile_attributes.phone_no" placeholder="{{ \'TELEPHONE_NUMBER_PLACEHOLDER\' | translate }}" ng-pattern="/^\\+?\\d+$/" ng-maxlength="16" ng-minlength="8" required>\n                    <div ng-messages="missingProfileDataForm.phone_no.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                        <div ng-message="maxlength" translate>TELEPHONE_NUMBER_MAX_LENGTH_ERROR</div>\n                        <div ng-message="minlength" translate>TELEPHONE_NUMBER_MIN_LENGTH_ERROR</div>\n                        <div ng-message="pattern" translate>TELEPHONE_NUMBER_INVALID_INPUT</div>\n                    </div>\n                </md-input-container>\n                <md-input-container class="jf-input-container md-block" flex md-no-float ng-if="!currentUser.salutation">\n                    <md-input-label>* {{ \'SALUTATION\' | translate }}</md-input-label>\n                    <md-select name="salutation" ng-model="userProfileData.profile_attributes.salutation" ng-attr-placeholder="{{ \'PLEASE_SELECT\' | translate }}" class="md-no-underline" required aria-label="{{ \'PLEASE_SELECT\' | translate }}" >\n                        <md-option value="ms" translate>MRS</md-option>\n                        <md-option value="mr" translate>MR</md-option>\n                    </md-select>\n                    <div class="md-errors-spacer"></div>\n                        <div ng-messages="missingProfileDataForm.salutation.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                    </div>\n                </md-input-container>\n                <div layout="row" layout-xs="column" class="jf-dialog-actions-no-scroll">\n                    <md-button class="md-raised" ng-click="cancelAction()">{{ \'MISSING_PROFILE_FIELDS_POPUP_CANCEL\' | translate}}</md-button>\n                    <md-button type="submit" class="md-raised md-primary" ng-click="saveAction()">{{ \'MISSING_PROFILE_FIELDS_POPUP_SAVE\' | translate }}</md-button>\n                </div>\n            </div>\n        </md-dialog-content>\n    </form>\n</md-dialog>');
$templateCache.put('app/components/checkout/checkout.desktop.html','<div ng-if="$mdMedia(\'gt-xs\')" class="jf-checkout">\n    <div class="jf-container jf-checkout-container jf-one-page-checkout">\n        <div layout="row" layout-align="space-between stretch">\n            <div class="jf-threeds-container" layout="column" layout-align="space-between stretch" ng-show="!showMainCheckout">\n                <a ui-sref="checkout({ stepBack: true })" ui-sref-opts="{ reload: true }" class="jf-checkout-back" ng-if="!showMainCheckout">\n                    <span><i class="material-icons">forward</i></span>\n                    {{\'CHECKOUT_BACK_BUTTON_THREEDS\' | translate}}\n                </a>\n                <div id="threedsContainer">\n                    <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-payment-methods\')" spinner-position="30"></jf-spinner>\n                </div>\n                <div id="jf-adyen-cc-component-3ds"></div>\n                <div id="adyenIosProcessingIframeWrapper" style="height: 250px;min-height:500px;">\n                    <iframe ng-if="jfShared.adyen.iframe.adyenIosProcessingIframe" src="{{jfShared.adyen.iframe.adyenIosProcessingIframeUrl}}" width="100%" height="100%" scrolling="no" style="overflow: hidden;" frameborder="0"></iframe>\n                </div>\n            </div>\n            <div flex="50" flex-gt-sm="65" flex-order-sm="1" layout="column" class="jf-checkout-main-column" ng-show="showMainCheckout">\n                <a ui-sref="products({\'#\': \'c0\'})" class="jf-checkout-header-back" ng-if="$mdMedia(\'gt-sm\')"><span><i class="material-icons">forward</i></span> {{\'CHECKOUT_BACK_BUTTON\' | translate}}</a>\n                <div class="jf-headline jf-text-align-center">{{\'CHECKOUT_USER_DATA\' | translate}}</div>\n                <div class="jf-container jf-clear-padding" ng-if="editAddressForm || newAddressForm">\n                    <account-address ng-if="editAddressForm" cancel-callback="addNewAddressCancelOnePageCheckoutCallback"\n                                     submit-callback="editAddressSubmitOnePageCheckoutCallback" manageable-preferred="false"\n                    ></account-address>\n                    <account-address ng-if="newAddressForm" cancel-callback="editAddressCancelOnePageCheckoutCallback"\n                                     submit-callback="newAddressSubmitOnePageCheckoutCallback"\n                    ></account-address>\n                    <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-addresses-add-edit\')" spinner-position="30"></jf-spinner>\n                </div>\n                <div class="jf-container jf-clear-padding" ng-if="showPickup || showDelivery">\n                    <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-time-slots-picker\')" spinner-position="30"></jf-spinner>\n                    <div class="jf-checkout-box jf-checkout-box-no-margin-bottom" ng-if="showPickup">\n                        <div class="jf-checkout-box-title">\n                            {{\'PICKUP\' | translate}} <i class="material-icons" ng-click="closePickupTimeSlotSelector()">cancel</i>\n                        </div>\n                        <div class="jf-checkout-box-content">\n                            <pickup-timetable order="orderCopy" origin="checkout"></pickup-timetable>\n                        </div>\n                    </div>\n                    <div class="jf-checkout-box jf-checkout-box-no-margin-bottom" ng-if="showDelivery">\n                        <div class="jf-checkout-box-title">\n                            {{\'DELIVERY\' | translate}} <i class="material-icons" ng-click="closeDeliveryTimeSlotSelector()">cancel</i>\n                        </div>\n                        <div class="jf-checkout-box-content">\n                            <delivery-timetable order="orderCopy" origin="checkout"></delivery-timetable>\n                        </div>\n                    </div>\n                </div>\n                <div layout-gt-sm="row" layout-align="space-between start" class="jf-checkout-boxes">\n                    <div layout="column" layout-align="space-between stretch" flex class="jf-checkout-boxes-column"\n                         ng-controller="CheckoutAddressController" ng-show="!newAddressForm && !editAddressForm && !showPickup && !showDelivery"\n                    >\n                        <choose-address show-all-addresses="{{desktopShowAllAddresses}}"\n                                        ng-if="countObjKeys(jfShared.checkout.userAddresses) > 0 || (!newAddressForm && !editAddressForm && countObjKeys(jfShared.checkout.userAddresses) === 0)"\n                        ></choose-address>\n                    </div>\n                    <div layout="column" layout-align="space-between stretch" flex class="jf-checkout-boxes-column"\n                         ng-show="!newAddressForm && !editAddressForm && !showPickup && !showDelivery"\n                    >\n                        <div class="jf-checkout-box">\n                            <div class="jf-checkout-box-title">\n                                {{\'CHECKOUT_APPOINTMENTS\' | translate}}\n                            </div>\n                            <div class="jf-checkout-box-content">\n                                <p class="jf-error" ng-if="allAddressesSpecified()" ng-repeat="timeSlotError in order.additionalInfo.errors.timeSlots.pickup">\n                                    {{timeSlotError}}\n                                </p>\n                                <p class="jf-error" ng-if="allAddressesSpecified()" ng-repeat="timeSlotError in order.additionalInfo.errors.timeSlots.delivery">\n                                    {{timeSlotError}}\n                                </p>\n                                <div ng-show="allAddressesSpecified()">\n                                    <closest-appointments order="orderCopy" origin="checkout"></closest-appointments>\n                                </div>\n                                <div ng-if="isBillingAddressMissing()" class="jf-error" translate="PLEASE_FINALIZE_INVOICE_ADDRESS_CREATION"></div>\n                                <div ng-if="!isBillingAddressMissing() && !allAddressesSpecified()" class="jf-error" translate="PLEASE_FINALIZE_ADDRESS_CREATION"></div>\n                            </div>\n                        </div>\n                        <div class="jf-checkout-box">\n                            <div class="jf-checkout-box-title">\n                                {{\'PAYMENT_METHODS\' | translate}}\n                            </div>\n                            <div class="jf-checkout-box-content">\n                                <p class="jf-error" ng-if="allAddressesSpecified()" ng-repeat="paymentError in order.additionalInfo.errors.payment">\n                                    {{paymentError}}\n                                </p>\n                                <div ng-show="allAddressesSpecified()">\n                                    <payment-methods></payment-methods>\n                                </div>\n\n                                <div ng-if="isBillingAddressMissing()" class="jf-error" translate="PLEASE_FINALIZE_INVOICE_ADDRESS_CREATION_FOR_PAYMENT"></div>\n                                <div ng-if="!isBillingAddressMissing() && !allAddressesSpecified()" class="jf-error" translate="PLEASE_FINALIZE_ADDRESS_CREATION_FOR_PAYMENT"></div>\n                                <p class="jf-error" ng-show="paymentError" translate>SELECT_PICKUP_DELIVERY_TIMES</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div layout-sm="column" layout-gt-sm="row" layout-align-sm="start stretch"\n                     layout-align-gt-sm="space-between start" class="jf-checkout-boxes jf-checkout-component"\n                     ng-if="!editAddressForm && !newAddressForm && !showPickup && !showDelivery"\n                >\n                    <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-notes\')" spinner-position="40"></jf-spinner>\n                    <div class="jf-checkout-box" flex flex-sm="100" ng-if="showNotes">\n                        <div class="jf-checkout-box-title">\n                            {{\'PICKUP_NOTES\' | translate}}\n                        </div>\n                        <div class="jf-checkout-box-content">\n                            <pickup-notes></pickup-notes>\n                        </div>\n                    </div>\n                    <div class="jf-checkout-box" flex ng-if="showNotes">\n                        <div class="jf-checkout-box-title">\n                            {{\'DELIVERY_NOTES\' | translate}}\n                        </div>\n                        <div class="jf-checkout-box-content">\n                            <delivery-notes></delivery-notes>\n                        </div>\n                    </div>\n                    <div class="jf-checkout-box" ng-class="{ \'full-special-instructions\': !showNotes }" flex>\n                        <div class="jf-checkout-box-title">\n                            {{\'SPECIAL_INSTRUCTIONS_SHORT\' | translate}}\n                        </div>\n                        <div class="jf-checkout-box-content">\n                            <special-instructions></special-instructions>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div flex-sm="50" flex-gt-sm="35" flex-order-sm="2" class="jf-laundry-basket-desktop-container"\n                 ng-if="$mdMedia(\'gt-xs\') && !(countObjKeys(order.items) === 0 && $state.params.section === \'confirm\')">\n                <laundry-basket-desktop cart-model="order" class="jf-one-page-checkout-laundry-basket"></laundry-basket-desktop>\n                <jf-spinner ng-if="jfShared.spinner.isLoading(\'cart\')" spinner-position="20"></jf-spinner>\n            </div>\n        </div>\n    </div>\n    <div class="jf-checkout-footer">\n        <div class="jf-container">\n            <a ui-sref="products({\'#\': \'c0\'})" class="jf-checkout-footer-back"><span><i class="material-icons">forward</i></span> {{\'CHECKOUT_BACK_BUTTON\' | translate}}</a>\n            <ul>\n                <li><a ng-href="{{blogUrl + \'/faq\'}}" target="_blank">{{\'PAGE_TITLE_FAQ\' | translate}}</a></li>\n                <li><a ng-href="{{blogUrl + \'/impressum\'}}" target="_blank">{{\'IMPRINT\' | translate}}</a></li>\n                <li><a ng-href="{{blogUrl + \'/agb\'}}" target="_blank">{{\'TERMS_AND_CONDITIONS\' | translate}}</a></li>\n                <li><a ng-href="{{blogUrl + \'/datenschutz\'}}" target="_blank">{{\'PAGE_TITLE_PRIVACY\' | translate}}</a></li>\n            </ul>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/checkout.html','<div ui-view="mobile" ng-if="$mdMedia(\'xs\')" class="jf-checkout jf-animated-transition"></div>\n<div ui-view="desktop" ng-if="$mdMedia(\'gt-xs\')" class="jf-checkout"></div>');
$templateCache.put('app/components/checkout/checkout.mobile.html','<div class="jf-threeds-container" layout="column" layout-align="space-between stretch" ng-show="!showMainCheckout">\n    <a ui-sref="checkout({ stepBack: true })" ui-sref-opts="{ reload: true }" class="jf-checkout-back" ng-if="!showMainCheckout">\n        <span><i class="material-icons">forward</i></span>\n        {{\'CHECKOUT_BACK_BUTTON_THREEDS\' | translate}}\n    </a>\n    <div id="threedsContainer">\n        <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-payment-methods\')" spinner-position="30"></jf-spinner>\n    </div>\n    <div id="jf-adyen-cc-component-3ds"></div>\n    <div id="adyenIosProcessingIframeWrapper" style="height: 250px;min-height:500px;">\n        <iframe ng-if="jfShared.adyen.iframe.adyenIosProcessingIframe" src="{{jfShared.adyen.iframe.adyenIosProcessingIframeUrl}}" width="100%" height="100%" scrolling="no" style="overflow: hidden;" frameborder="0"></iframe>\n        <iframe ng-if="jfShared.adyen.iframe.adyenIosIdentifyIframe" src="{{jfShared.adyen.iframe.adyenIosIdentifyIframeUrl}}" width="100%" height="100%" scrolling="no" style="overflow: hidden;" frameborder="0"></iframe>\n    </div>\n    <a ui-sref="checkout({ stepBack: true })" ui-sref-opts="{ reload: true }" class="jf-checkout-back" ng-if="!showMainCheckout">\n        <span><i class="material-icons">forward</i></span>\n        {{\'CHECKOUT_BACK_BUTTON_THREEDS\' | translate}}\n    </a>\n</div>\n<div class="jf-container jf-checkout-mobile-container" ng-show="showMainCheckout">\n    <p class="jf-error" ng-repeat="checkoutGeneralError in order.additionalInfo.checkoutGeneralErrors"\n       layout="row" layout-align="start start"\n    >\n        <i class="material-icons">warning</i> <span>{{checkoutGeneralError.message}}</span>\n    </p>\n    <p class="jf-error" ng-if="order.additionalInfo.errorsCount > 0">{{\'CHECK_YOUR_ENTRY_ERROR\' | translate}}</p>\n    <p class="jf-error" ng-repeat="generalError in order.additionalInfo.errors.general">\n        {{generalError}}\n    </p>\n    <div class="jf-checkout-box">\n        <div class="jf-checkout-box-title">{{\'YOUR_ORDER\' | translate}}</div>\n        <div class="jf-checkout-box-content">\n            <jf-spinner ng-if="jfShared.spinner.isLoading(\'cart\')" spinner-position="10"></jf-spinner>\n            <laundry-basket-summary cart-model="order" items-short-summary="false" items-full-summary="true" min-order-value="minOrderValue"></laundry-basket-summary>\n        </div>\n    </div>\n    <choose-address mobile-checkout-preview="true"></choose-address>\n\n    <closest-appointments ng-show="allAddressesSpecified()" order="orderCopy" origin="checkout"></closest-appointments>\n    <div ng-if="!allAddressesSpecified()" class="jf-position-relative">\n        <div class="jf-checkout-box">\n            <div class="jf-checkout-box-content">\n                <div class="jf-checkout-time-slots-content jf-checkout-time-slots-content-full-width">\n                    <strong translate>{{ \'PICKUP\' | translate }}:</strong>\n                    <div ng-show="isBillingAddressMissing()" class="jf-error" translate="PLEASE_FINALIZE_INVOICE_ADDRESS_CREATION"></div>\n                    <div ng-show="!isBillingAddressMissing() && !allAddressesSpecified()" class="jf-error" translate="PLEASE_FINALIZE_ADDRESS_CREATION"></div>\n                </div>\n            </div>\n        </div>\n        <div class="jf-checkout-box">\n            <div class="jf-checkout-box-content">\n                <div class="jf-checkout-time-slots-content jf-checkout-time-slots-content-full-width">\n                    <strong translate>{{ \'DELIVERY\' | translate }}:</strong>\n                    <div ng-show="isBillingAddressMissing()" class="jf-error" translate="PLEASE_FINALIZE_INVOICE_ADDRESS_CREATION"></div>\n                    <div ng-show="!isBillingAddressMissing() && !allAddressesSpecified()" class="jf-error" translate="PLEASE_FINALIZE_ADDRESS_CREATION"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="jf-checkout-box">\n        <div class="jf-checkout-box-content">\n            <div class="jf-checkout-payments-content">\n                <p class="jf-error" ng-if="allAddressesSpecified()" ng-repeat="paymentError in order.additionalInfo.errors.payment">\n                    {{paymentError}}\n                </p>\n                <div ng-show="allAddressesSpecified()" ng-class="{\'jf-mobile-checkout-section-disabled\': !order.details.attributes.delivery_address.resource_id || order.details.attributes.delivery_address.resource_id === null}">\n                    <p class="jf-mobile-checkout-payment-summary" ng-click="toggleMobilePaymentMethods()">\n                        <strong ng-if="order.additionalInfo.selectedPaymentMethodId">{{\'PAYMENT\' | translate}}:</strong>\n                        <strong ng-if="!order.additionalInfo.selectedPaymentMethodId">{{\'DEFAULT_SELECT_PAYMENT_METHOD\' | translate}}</strong>\n                        <span ng-show="countObjKeys(jfShared.checkout.userAddresses) === 0">{{\'NO_ADDRESS_ADDED\' | translate}}</span>\n                        <span ng-show="countObjKeys(jfShared.checkout.userAddresses) > 0">{{visiblePaymentMethods[order.additionalInfo.selectedPaymentMethodId] ? visiblePaymentMethods[order.additionalInfo.selectedPaymentMethodId].name : \'\'}} <a class="jf-checkout-mobile-show-payment-methods" ng-if="order.additionalInfo.selectedPaymentMethodId && !selectedPaymentMethodWithoutBillingAgreement(order.additionalInfo.selectedPaymentMethodId)" ng-class="{\'jf-checkout-mobile-payment-methods-visible\': showPaymentMethodsOnMobile}"><i class="material-icons">play_arrow</i></a></span>\n                    </p>\n                    <span class="jf-checkout-box-separator jf-mobile-checkout-payment" ng-if="showPaymentMethodsMobileBox(order.additionalInfo.selectedPaymentMethodId)"></span>\n                    <payment-methods ng-show="showPaymentMethodsMobileBox(order.additionalInfo.selectedPaymentMethodId)"></payment-methods>\n                </div>\n                <div ng-show="!allAddressesSpecified()">\n                    <p class="jf-mobile-checkout-payment-summary">\n                        <strong>{{\'PAYMENT\' | translate}}:</strong>\n                        <div ng-show="isBillingAddressMissing()" class="jf-error" translate="PLEASE_FINALIZE_INVOICE_ADDRESS_CREATION_FOR_PAYMENT"></div>\n                        <div ng-show="!isBillingAddressMissing() && !allAddressesSpecified()" class="jf-error" translate="PLEASE_FINALIZE_ADDRESS_CREATION_FOR_PAYMENT"></div>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="jf-checkout-box" ng-class="{\'jf-basket-coupon-code-content\' : !couponForm && !couponVerified}">\n        <div class="jf-checkout-box-content">\n            <jf-spinner ng-if="couponForm && jfShared.spinner.isLoading(\'cart\')"></jf-spinner>\n            <coupon-code></coupon-code>\n        </div>\n    </div>\n    <div class="jf-checkout-box">\n        <div class="jf-checkout-box-content">\n            <a ui-sref="checkout.notes" class="jf-checkout-edit-icon jf-checkout-edit-icon-large" ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}">\n                <i class="material-icons">edit</i>\n                <span>{{\'EDIT_BUTTON\' | translate}}</span>\n            </a>\n            <p ng-if="showNotes"><strong>{{\'PICKUP_NOTES\' | translate}}: </strong>{{order.additionalInfo.pickupNote || \'---\'}}</p>\n            <p ng-if="showNotes"><strong>{{\'DELIVERY_NOTES\' | translate}}: </strong>{{order.additionalInfo.deliveryNote || \'---\'}}</p>\n            <p><strong>{{\'SPECIAL_INSTRUCTIONS_SHORT\' | translate}}: </strong>{{order.additionalInfo.specialInstructions || \'---\'}}</p>\n        </div>\n    </div>\n    <form name="checkoutOrder" class="jf-checkout-legal-and-newsletter">\n        <jf-newsletter ng-if="!newsletterFlagSet" form-model="order.additionalInfo.newsletter"></jf-newsletter>\n        <div class="jf-checkbox-container" ng-if="invoicingFee">\n            <md-checkbox class="jf-checkbox md-primary jf-invoicing-fee-checkbox" ng-model="order.additionalInfo.invoicingFee" ng-true-value="true"\n                         ng-false-value="false" aria-label="{{\'INVOICING_FEE\' | translate}}" flex ng-change="saveInvoicingFeeSelection()"\n                         required ng-class="{\'jf-validation-error\': order.additionalInfo.errors.invoicingFee.length > 0}"\n            >\n                <md-label>\n                    <strong translate="INVOICING_FEE_AGREEMENT" translate-values="{ invoicing_fee: invoicingFee }"></strong>\n                </md-label>\n            </md-checkbox>\n            <p class="jf-error" ng-repeat="invoicingFeeError in order.additionalInfo.errors.invoicingFee">\n                {{invoicingFeeError}}\n            </p>\n        </div>\n        <div class="jf-checkbox-container" ng-if="!userAcceptedCurrentAgb()">\n            <md-checkbox class="jf-checkbox md-primary jf-newsletter-checkbox" ng-model="order.additionalInfo.agb" ng-true-value="true"\n                         ng-false-value="false" aria-label="{{\'TERMS_AND_CONDITIONS\' | translate}}" flex ng-change="saveAgbSelection()"\n                         required ng-class="{\'jf-validation-error\': order.additionalInfo.errors.termsAndConditions.length > 0}"\n            >\n                <md-label>\n                    <strong translate="TERMS_AND_CONDITIONS_AGREEMENT" translate-values="{ terms_and_conditions_link: legalDocuments.gtc.document_file.url || \'https://www.jonnyfresh.com/agb\', privacy_policy_link: legalDocuments.pp.document_file.url || \'https://www.jonnyfresh.com/datenschutz\' }"></strong>\n                </md-label>\n            </md-checkbox>\n            <p class="jf-error" ng-repeat="termsAndConditionsError in order.additionalInfo.errors.termsAndConditions">\n                {{termsAndConditionsError}}\n            </p>\n        </div>\n    </form>\n    <p class="jf-error" ng-repeat="checkoutGeneralError in order.additionalInfo.checkoutGeneralErrors"\n       layout="row" layout-align="start start"\n    >\n        <i class="material-icons">warning</i> <span>{{checkoutGeneralError.message}}</span>\n    </p>\n    <p class="jf-error" ng-repeat="generalError in order.additionalInfo.errors.general">\n        {{generalError}}\n    </p>\n    <p class="jf-error" ng-if="order.additionalInfo.errorsCount > 0">{{\'CHECK_YOUR_ENTRY_ERROR\' | translate}}</p>\n    <md-button class="jf-button md-raised md-accent" aria-label="{{ \'ORDER\' | translate }}" ng-click="mobileOrderCommit()"\n               ng-disabled="jfShared.checkout.orderProcessing === true || !isLoadingCompleted()"\n    >\n        {{ \'ORDER\' | translate }}\n    </md-button>\n</div>\n<div class="jf-checkout-footer" ng-if="showMainCheckout">\n    <div class="jf-container">\n        <a ui-sref="products({ stepBack: true })" class="jf-checkout-footer-back"><span><i class="material-icons">forward</i></span> {{\'CHECKOUT_BACK_BUTTON\' | translate}}</a>\n    </div>\n</div>\n');
$templateCache.put('app/components/account/account-toolbar.html','<md-tabs md-dynamic-height md-swipe-content md-autoselect md-center-tabs class="jf-tabs jf-account-tabs" md-no-pagination id="jf-account-tabs">\n    <md-tab ng-repeat="(sectionName, sectionDetails) in accountSections" md-active="$state.params.section == sectionName"\n            ui-sref="account.section({section: sectionName, subnav: null})" md-on-select="sendGAEvent(\'myAccountPage\', sectionName + \'NavItem\')"\n    >\n        <md-tab-label>\n            <label class="jf-tab-label jf-plain-label" translate>{{ sectionDetails.title }}</label>\n        </md-tab-label>\n    </md-tab>\n</md-tabs>\n');
$templateCache.put('app/components/account/account.corporate.html','<div class="jf-spacer-45" hide-xs></div>\n<div hide-gt-xs>\n    <div class="jf-headline jf-padding" layout translate>CORPORATE_DETAILS</div>\n    <md-divider></md-divider>\n    <div class="jf-spacer-15"></div>\n</div>\n<div class="jf-container jf-container--small">\n    <jf-company-account></jf-company-account>\n</div>\n');
$templateCache.put('app/components/account/account.desktop.html','<md-tab-body>\n    <ng-include src="accountSections[$state.params.section].subnav[$state.params.subnav]" ng-if="$state.params.subnav"></ng-include>\n    <ng-include src="accountSections[$state.params.section].template" ng-if="!$state.params.subnav"></ng-include>\n</md-tab-body>');
$templateCache.put('app/components/account/account.details-delete-account.html','<div class="jf-spacer-45" hide-xs></div>\n<div class="jf-container jf-container--small jf-delete-account-msg" ng-controller="AccountDetailsDeleteAccountCtrl">\n\t<div layout layout-align="center center">\n\t    <h1 class="jf-headline" translate>{{\'DELETE_ACCOUNT\' | translate}}</h1>\n\t</div>\n\t<div layout="column" layout-align="center center">\n\t    <p align="center" translate="DELETE_ACCOUNT_MESSAGE"></p>\n\t\t\t<div class="jf-spacer-15"></div>\n\t</div>\n\t<div layout layout-align="center center" class="md-dense">\n\t\t<md-button class="jf-button jf-button-account-delete md-raised md-primary" ng-click="deleteAccount()" aria-label="{{\'YES\' | translate}}">\n\t\t\t{{\'YES\' | translate}}\n\t\t</md-button>\n\t\t<md-button class="jf-button jf-button-account-delete md-raised" ng-click="cancel()" aria-label="{{\'DISCARD\' | translate}}">\n\t\t\t{{\'DISCARD\' | translate}}\n\t\t</md-button>\n\t</div>\n\t<div class="jf-spacer-15"></div>\n\t<jf-spinner ng-if="jfShared.spinner.isLoading(\'delete-account\')"></jf-spinner>\n</div>\n');
$templateCache.put('app/components/account/account.details.html','<div hide-gt-xs>\n    <div class="jf-headline jf-padding" translate>ACCOUNT_DETAILS</div>\n    <md-divider></md-divider>\n    <div class="jf-spacer-15"></div>\n</div>\n<div class="jf-spacer-45" hide-xs></div>\n<div class="jf-container jf-container--small jf-account-details-container" ng-controller="AccountDetailsCtrl">\n\n    <div ng-if="$mdMedia(\'xs\')" class="jf-mobile-account-type-block">\n        <md-input-container class="jf-input-container md-block" flex md-no-float>\n            <md-select name="account-type-name" ng-model="activeTab" class="md-no-underline jf-account-type-select">\n                <md-option ng-value="0" translate>{{\'LOGIN_AND_SECURITY_USER_DATA\' | translate}}</md-option>\n                <md-option ng-value="1" translate>{{\'LOGIN_AND_SECURITY_PASSWORD_CHANGE\' | translate}}</md-option>\n            </md-select>\n        </md-input-container>\n        <jf-personal-account ng-if="activeTab === 0"></jf-personal-account>\n        <jf-my-account-change-password ng-if="activeTab === 1"></jf-my-account-change-password>\n    </div>\n\n    <md-tabs ng-if="$mdMedia(\'gt-xs\')" md-dynamic-height md-center-tabs md-selected="activeTab" class="jf-account-type-tabs jf-no-animate">\n        <md-tab>\n            <md-tab-label>{{\'LOGIN_AND_SECURITY_USER_DATA\' | translate}}</md-tab-label>\n            <md-tab-body>\n                <jf-personal-account></jf-personal-account>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>{{\'LOGIN_AND_SECURITY_PASSWORD_CHANGE\' | translate}}</md-tab-label>\n            <md-tab-body>\n                <jf-my-account-change-password></jf-my-account-change-password>\n            </md-tab-body>\n        </md-tab>\n    </md-tabs>\n</div>\n\n');
$templateCache.put('app/components/account/account.forgot-password.html','<div class="jf-gradient-bg">\n    <div class="jf-container jf-container--small">\n        <div layout="column" layout-align="space-around stretch">\n            <div layout="row" layout-align="center center">\n                <ng-include flex flex-gt-xs="60" src="\'app/components/account/forms/account.forgot-password.html\'"></ng-include>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'forgot-password-page\')"></jf-spinner>\n</div>');
$templateCache.put('app/components/account/account.html','<div ui-view="mobile" ng-if="$mdMedia(\'xs\')" class="jf-mobile-container jf-animated-transition"></div>\n<div ui-view="desktop" ng-if="$mdMedia(\'gt-xs\')"></div>');
$templateCache.put('app/components/account/account.login.html','<div class="jf-gradient-bg">\n    <div class="jf-container jf-container--medium">\n        <div class="jf-login-container" layout="column" layout-align="space-around stretch">\n            <div class="jf-page-logo">\n                <img src="assets/img/jf-logo-white-slogan.png" width="220" alt="Jonny Fresh">\n            </div>\n            <p class="jf-success jf-success-strong" ng-if="password_changed" translate>PASSWORD_CHANGED</p>\n\n            <div ng-if="$mdMedia(\'gt-sm\')" layout-xs="column" layout-gt-sm="row" layout-align-xs="center center" layout-align-gt-sm="center start" class="jf-login-form">\n                <ng-include flex flex="45" src="\'app/components/account/forms/account.login.html\'"></ng-include>\n            </div>\n            <div ng-if="$mdMedia(\'xs\') || $mdMedia(\'sm\')">\n                <ng-include flex flex-xs="100" src="\'app/components/account/forms/account.login.html\'"></ng-include>\n            </div>\n\n            <div layout="row" layout-align="start center" ng-if="mobileAppMode">\n                <div flex class="location-picker-link">\n                    <a ui-sref="location-picker" ng-click="sendGAEvent(\'loginPage\', \'locationPickerLink\')" aria-label="{{\'GOTO_WEBSITE\' | translate}}">{{\'GOTO_WEBSITE\' | translate}}</a>\n                </div>\n            </div>\n            <div layout="row" layout-align="start center" ng-if="!mobileAppMode">\n                <div flex class="goto-website-link">\n                    <a href="{{blogUrl}}{{\'PRIVATE_CUSTOMERS_URL\' | translate}}" ng-click="sendGAEvent(\'loginPage\', \'gotoWebsiteLink\')" aria-label="{{\'GOTO_WEBSITE\' | translate}}">{{\'GOTO_WEBSITE\' | translate}}</a>\n                </div>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'login-page\')"></jf-spinner>\n</div>');
$templateCache.put('app/components/account/account.logout.html','<div class="jf-gradient-bg jf-page-logout">\n    <div class="jf-page-logo">\n        <img src="assets/img/jf-logo-white-slogan.png" width="220" alt="Jonny Fresh">\n    </div>\n    <div class="jf-page-subheadline"></div>\n    <p class="jf-page-subheadline-text">{{\'LOGOUT_PAGE_HEADER_SUB_TEXT\' | translate}}</p>\n    <div class="jf-container jf-container--small">\n        <div layout="column" layout-align="space-around stretch">\n            <div layout="column" layout-align="center center">\n                <p class="jf-logout-loading">\n                    <span us-spinner="{radius:8, width:3, length: 10, color: \'#FFFFFF\'}"></span> \n                </p>\n                <p class="jf-logout-loading-text">{{ \'REDIRECTING_TO_LOGIN\' | translate }}</p>\n            </div>\n            <div layout="column" layout-align="center center" ng-if="showLoginButton">\n                <div class="jf-logout-error">\n                    <p translate>REDIRECTION_MESSAGE</p>\n                    <div class="jf-login-button-container" flex flex-gt-xs="50">\n                        <md-button ng-click="gotoLogin()" class="jf-button md-raised md-accent jf-login-button" aria-label="{{\'PAGE_TITLE_LOGIN\' | translate}}">{{\'PAGE_TITLE_LOGIN\' | translate}}</md-button>\n                    </div>\n                </div>          \n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/account/account.mobile.html','<md-list flex class="jf-menu-list">\n    <md-list-item class="md-2-line" ng-repeat="(sectionName, sectionDetails) in accountSections"\n        ng-click="navigateToAccountSection(sectionName, $event)" ng-show="sectionName != \'delete-account\'"\n        id="my-account-nav-mobile-{{sectionName}}"\n    >\n      <div class="md-list-item-text" layout="column">\n        <h3 translate="{{ sectionDetails.title }}">{{ sectionDetails.title }}</h3>\n        <p translate="{{ sectionDetails.summary }}">{{ sectionDetails.summary }}</p>\n      </div>\n      <md-icon md-svg-icon="arrow_right_blue"></md-icon>\n      <md-divider></md-divider>\n    </md-list-item>\n</md-list>\n');
$templateCache.put('app/components/account/account.my-addresses-edit-address.html','<div class="jf-container jf-container--small">\n    <account-address></account-address>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-my-addresses-add-edit\')" spinner-position="30"></jf-spinner>\n</div>');
$templateCache.put('app/components/account/account.my-addresses-new-address.html','<div class="jf-container jf-container--small" ng-controller="AccountMyAddressesCtrl">\n    <account-address submit-callback="addressAdded"></account-address>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-my-addresses-add-edit\')" spinner-position="30"></jf-spinner>\n</div>');
$templateCache.put('app/components/account/account.my-addresses.html','<div class="jf-container jf-container--small" ng-controller="AccountMyAddressesCtrl">\n    <div>\n        <div class="jf-headline" layout><span hide-gt-xs translate>MY_ADDRESSES</span>\n            <span flex></span>\n            <md-button class="md-icon-button" aria-label="{{\'ADD_NEW_ADDRESS\' | translate}}" ui-sref="account.section({section: \'my-addresses\', subnav: \'new-address\'})">\n                <md-icon md-svg-icon="add">add</md-icon>\n            </md-button>\n        </div>\n        <p ng-if="countObjKeys(addresses) === 0" translate>NO_ADDRESS_ADDED</p>\n        <div class="jf-list jf-my-addresses" ng-if="countObjKeys(addresses) > 0">\n            <div class="jf-list-item jf-my-address" layout layout-align="center stretch" ng-repeat="address in addresses">\n                <div class="jf-padding">\n                    <p>{{address.attributes.company_name}}</p>\n                    <p>{{address.attributes.first_name}} {{address.attributes.last_name}}</p>\n                    <p ng-if="address.attributes.phone_no">{{address.attributes.phone_no}}</p>\n                    <p>{{address.attributes.street}} {{address.attributes.house_no_main}} {{address.attributes.house_no_add}} {{address.attributes.other}}</p>\n                    <p>{{address.attributes.postal_code}} {{address.attributes.city}} {{address.attributes.province}}</p>\n                </div>\n                <span flex></span>\n                <div layout="column" layout-align="space-between end">\n                    <md-button class="md-icon-button" ui-sref="account.section({section: \'my-addresses\', subnav: \'edit-address\', addressToEdit: address})" aria-label="{{\'EDIT_ADDRESS\' | translate}}">\n                        <md-icon md-svg-icon="edit">edit</md-icon>\n                    </md-button>\n                    <md-button class="md-icon-button jf-delete-address" ng-click="delete(address.id)" aria-label="{{\'DELETE_ADDRESS\' | translate}}">\n                        <md-icon md-svg-icon="delete">{{\'DELETE_ADDRESS\' | translate}}</md-icon>\n                    </md-button>\n                </div>\n            </div>\n        </div>\n        <form class="jf-form" name="addressPreferencesForm" novalidate ng-submit="submitAddressPreferences(addressPreferencesForm)">\n            <div layout-gt-sm="row">\n                <md-input-container class="jf-input-container md-block" flex md-no-float>\n                    <md-input-label translate>PICKUP_NOTES</md-input-label>\n                    <textarea name="pickup_notes" rows="4" ng-model="addressPreferences.pickup_notes" ng-attr-placeholder="{{\'PICKUP_NOTES_PLACEHOLDER\' | translate}}"></textarea>\n                </md-input-container>\n                <div flex="5" hide-xs hide-sm></div>\n                <md-input-container class="jf-input-container md-block" flex md-no-float>\n                    <md-input-label translate>DELIVERY_NOTES</md-input-label>\n                    <textarea name="delivery_notes" rows="4" ng-model="addressPreferences.delivery_notes" ng-attr-placeholder="{{\'DELIVERY_NOTES_PLACEHOLDER\' | translate}}"></textarea>\n                </md-input-container>\n                <div flex="5" hide-xs hide-sm></div>\n                <md-input-container class="jf-input-container md-block" flex md-no-float>\n                    <md-input-label translate>SPECIAL_INSTRUCTIONS_SHORT</md-input-label>\n                    <textarea name="special_instructions" rows="4" ng-model="addressPreferences.special_instructions" ng-attr-placeholder="{{\'SPECIAL_INSTRUCTIONS_PLACEHOLDER\' | translate}}"></textarea>\n                </md-input-container>\n            </div>\n            <div layout-gt-sm="row">\n                <div class="jf-flex-container" layout-xs="column">\n                    <md-checkbox class="jf-checkbox md-primary" ng-model="addressPreferences.newsletter" ng-true-value="true" ng-false-value="false" aria-label="{{\'NEWSLETTER_ABO_TRANSLATE\' | translate}}" flex>\n                        <md-label>\n                            <strong translate>NEWSLETTER_ABO_TRANSLATE</strong>\n                        </md-label>\n                    </md-checkbox>\n                    <md-checkbox class="jf-checkbox md-primary" ng-model="addressPreferences.trip_notification" ng-true-value="true" ng-false-value="false" aria-label="{{\'PICKUP_DELIVERY_NOTIFICATION\' | translate}}" flex>\n                        <md-label>\n                            <strong translate>PICKUP_DELIVERY_NOTIFICATION</strong>\n                        </md-label>\n                    </md-checkbox>\n                </div>\n            </div>\n            <div layout>\n                <span flex></span>\n                <div flex flex-xs="100" flex-gt-xs="20">\n                    <md-button class="jf-button md-raised md-accent" type="submit" aria-label="{{\'SAVE\' | translate}}">{{\'SAVE\' | translate}}</md-button>\n                </div>\n            </div>\n        </form>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-my-addresses\')" spinner-position="30"></jf-spinner>\n</div>\n');
$templateCache.put('app/components/account/account.my-orders.html','<div hide-gt-xs>\n    <div class="jf-headline jf-padding" translate>MY_ORDERS</div>\n</div>\n<div id="my-orders-top" class="jf-container" ng-controller="AccountMyOrdersCtrl">\n    <div ng-if="$mdMedia(\'xs\')" class="jf-mobile-account-type-block">\n        <md-input-container class="jf-input-container md-block" flex md-no-float>\n            <md-select name="account-type-name" ng-model="activeTab" class="md-no-underline jf-account-type-select" ng-init="activeTab = 0">\n                <md-option ng-value="0" translate>{{\'MY_ORDERS_ACTIVE\' | translate}}</md-option>\n                    <md-option ng-value="1" translate>{{\'MY_ORDERS_COMPLETED\' | translate}}</md-option>\n                    <md-option ng-value="2" translate>{{\'MY_ORDERS_CANCELED\' | translate}}</md-option>\n            </md-select>\n        </md-input-container>\n        <jf-my-orders status="active" ng-if="activeTab === 0"></jf-my-orders>\n        <jf-my-orders status="completed" ng-if="activeTab === 1"></jf-my-orders>\n        <jf-my-orders status="canceled" ng-if="activeTab === 2"></jf-my-orders>\n    </div>\n    <md-tabs ng-if="$mdMedia(\'gt-xs\')" md-dynamic-height md-center-tabs md-selected="activeTab" class="jf-account-type-tabs jf-no-animate" ng-init="activeTab = 0">\n        <md-tab>\n            <md-tab-label>{{\'MY_ORDERS_ACTIVE\' | translate}}</md-tab-label>\n            <md-tab-body>\n                <jf-my-orders status="active" ng-if="activeTab === 0"></jf-my-orders>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>{{\'MY_ORDERS_COMPLETED\' | translate}}</md-tab-label>\n            <md-tab-body>\n                <jf-my-orders status="completed" ng-if="activeTab === 1"></jf-my-orders>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>{{\'MY_ORDERS_CANCELED\' | translate}}</md-tab-label>\n            <md-tab-body>\n                <jf-my-orders status="canceled" ng-if="activeTab === 2"></jf-my-orders>\n            </md-tab-body>\n        </md-tab>\n    </md-tabs>\n</div>');
$templateCache.put('app/components/account/account.on-boarding.html','<div class="jf-gradient-bg">\n    <div class="jf-container jf-container--small">\n        <div layout="column" layout-align="space-around stretch" class="jf-on-boarding-container">\n            <div layout="row" layout-align="center center">\n                <ng-include flex flex-gt-xs="55" src="\'app/components/account/forms/account.on-boarding.html\'"></ng-include>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'onboarding-page\')"></jf-spinner>\n</div>');
$templateCache.put('app/components/account/account.password-reset.html','<div class="jf-gradient-bg">\n    <div class="jf-container jf-container--small">\n        <div layout="column" layout-align="space-around stretch">\n            <div layout="row" layout-align="center center">\n                <ng-include flex flex-gt-xs="60" src="\'app/components/account/forms/account.password-reset.html\'"></ng-include>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'password-reset-page\')"></jf-spinner>\n</div>');
$templateCache.put('app/components/account/account.payment-methods-new.html','<div ng-controller="PaymentMethodsManagerNewController">\n  <!-- <div class="jf-spacer-45" hide-xs></div> -->\n    <div class="jf-container jf-container--small jf-payment-methods-manager-add-new-container">\n      <div layout layout-align="center none" class="jf-payment-methods-manager-add-new-wrapper">\n\n        <div class="jf-threeds-container" layout="column" layout-align="space-between stretch" ng-show="showAdyenFrame">\n            <a ui-sref="account.section({ section: \'payment-methods\' })" ui-sref-opts="{ reload: true }" class="jf-checkout-back" ng-if="showAdyenFrame">\n                <span><i class="material-icons">forward</i></span>\n                {{\'CHECKOUT_BACK_BUTTON_THREEDS\' | translate}}\n            </a>\n            <div id="threedsContainer">\n                <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-payment-methods\')" spinner-position="30"></jf-spinner>\n            </div>\n\n            <div id="jf-adyen-cc-component-3ds" ng-if="!jfShared.adyen.iframe.adyenIosProcessingIframe && !jfShared.adyen.iframe.adyenIosIdentifyIframe"></div>\n\n            <div id="adyenIosProcessingIframeWrapper" style="height: 250px;min-height:500px;" ng-if="jfShared.adyen.iframe.adyenIosProcessingIframe">\n                <iframe src="{{jfShared.adyen.iframe.adyenIosProcessingIframeUrl}}" width="100%" height="100%" scrolling="no" style="overflow: hidden;" frameborder="0"></iframe>\n            </div>\n            <div id="adyenIosProcessingIframeWrapper" style="height: 250px;min-height:500px;" ng-if="jfShared.adyen.iframe.adyenIosIdentifyIframe">\n              <iframe id="adyenIosIdentifyIframe" src="{{jfShared.adyen.iframe.adyenIosIdentifyIframeUrl}}" width="100%" height="0" scrolling="no" style="overflow: hidden;height: 100%;" frameborder="0"></iframe>\n            </div>\n        </div>\n\n        <account-credit-card-form hide-header="false" form="creditCardForm"\n              save-callback="creditCardSaveCallback" country="locale" ng-if="paymentMethod.type === \'cc\'"\n              cancel-callback="creditCardCancelCallback"\n        ></account-credit-card-form>\n\n        <jf-sepa-payment country="locale" ng-if="paymentMethod.type === \'sepa\'" show-cancel-button="true"\n                        cancel-callback="sepaCancelCallback" save-callback="sepaSaveCallback"\n        ></jf-sepa-payment>\n\n        <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-credit-cards\')" spinner-position="40"></jf-spinner>\n      </div>\n    </div>\n</div>');
$templateCache.put('app/components/account/account.payment-methods.html','<div class="jf-spacer-45" hide-xs></div>\n<div hide-gt-xs>\n    <div class="jf-headline jf-padding" layout translate>PREFERENCES</div>\n    <md-divider></md-divider>\n    <div class="jf-spacer-15"></div>\n</div>\n<div class="jf-container jf-container--small">\n    <ng-include flex flex-gt-xs="50" src="\'app/components/account/forms/account.payment-methods.html\'"></ng-include>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-preferences\')" spinner-position="30"></jf-spinner>\n</div>\n');
$templateCache.put('app/components/account/account.register.html','<div class="jf-gradient-bg">\n    <div class="jf-container jf-container--small" ng-controller="AccountRegisterCtrl">\n        <div layout="column" layout-align="space-around stretch" class="jf-register-container">\n            <div layout="row" layout-align="center center">\n                <ng-include flex flex-gt-xs="60" src="\'app/components/account/forms/account.register.html\'"></ng-include>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'register-page\')"></jf-spinner>\n</div>');
$templateCache.put('app/components/help/help.html','<div class="jf-gradient-bg">\n    <div class="jf-help-actions">\n        <md-button class="jf-button md-raised md-accent" ng-click="callSupport()" aria-label="{{\'CALL_SUPPORT\' | translate}}">\n            {{\'CALL_SUPPORT\' | translate}}\n        </md-button>\n        <md-button class="jf-button md-raised md-accent" ng-click="mailSupport()" aria-label="{{\'EMAIL_SUPPORT\' | translate}}">\n            {{\'EMAIL_SUPPORT\' | translate}}\n        </md-button>\n    </div>\n</div>');
$templateCache.put('app/components/invoices/invoices.html','<div class="jf-container jf-container--small jf-invoices">\n    <div class="jf-invoices-logo" ng-if="source === \'app\'">\n        <img src="assets/img/jf-logo-white-slogan.png" width="120" alt="Jonny Fresh">\n    </div>\n    <h2>{{\'INVOICE_FROM_EMAIL_GENERATION\' | translate}}</h2>\n    <span us-spinner="{radius:7, width:2, length: 7, color: \'#0184C5\'}"></span>\n</div>');
$templateCache.put('app/components/instructions/instructions.html','<jf-instructions force-display="true"></jf-instructions>');
$templateCache.put('app/components/instructions/jf-instructions.html','<div class="jf-instructions">\n    <div class="slider" id="intro-slider" jf-intro-slider>\n        <div class="slider-panel" ng-style="{ \'background\': getImgUrl(\'1\') }">\n            <div layout layout-align="center center" layout-fill>\n                <span flex="10"></span>\n                <div flex>\n                    <div class="slider-headline"></div>\n                    <p ></p>\n                </div>\n                <span flex="10"></span>\n            </div>\n        </div>\n        <div class="slider-panel" ng-style="{ \'background\': getImgUrl(\'2\') }">\n            <div layout layout-align="center center" layout-fill>\n                <span flex="10"></span>\n                <div flex>\n                    <p translate></p>\n                </div>\n                <span flex="10"></span>\n            </div>\n        </div>\n        <div class="slider-panel" ng-style="{ \'background\': getImgUrl(\'3\') }">\n            <div layout layout-align="center center" layout-fill>\n                <span flex="10"></span>\n                <div flex>\n                    <p translate></p>\n                </div>\n                <span flex="10"></span>\n            </div>\n        </div>\n    </div>\n    <div class="slider-pagination-container" layout="row" layout-align="center center">\n        <div class="slider-pagination" flex>\n        </div>\n        <div class="slider-cta-container" flex>\n            <md-button ng-click="cancelDialog()" class="jf-button md-no-ink md-no-focus"\n               aria-label="{{\'INTRO_SLIDER_SKIP\' | translate}}"\n            >\n                {{\'INTRO_SLIDER_SKIP\' | translate}}\n            </md-button>\n            <md-button ng-click="cancelDialog()" class="jf-button jf-slider-last-button md-no-ink md-no-focus"\n               aria-label="{{\'INTRO_SLIDER_ORDER_NOW\' | translate}}"\n            >\n                {{\'INTRO_SLIDER_ORDER_NOW\' | translate}}\n            </md-button>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/location-picker/location-picker.html','<div layout="column" layout-fill class="jf-location-picker-mobile-container jf-gradient-bg" ngCloak>\n    <div layout-fill class="jf-location-picker-mobile jf-container" layout="column" layout-align="center center">\n        <div>\n            <ng-include src="\'app/components/location-picker/forms/location-picker-form.html\'"></ng-include>\n        </div>\n        <div flex layout-fill>\n            &nbsp;\n        </div>\n        <div class="jf-location-picker-login-button">\n            <div flex="100" flex-gt-xs="50" layout="column" layout-align="center" class="jf-button-login-container">\n                <md-button class="jf-button jf-button-login md-raised" ng-if="!jfShared.jfUser.id"\n                    aria-label="{{\'SIGN_IN\' | translate}}" ui-sref="login"\n                    ng-class="{ \'jf-button-login-spacer-mobile\': mobileAppMode }"\n                >\n                    {{\'SIGN_IN\' | translate}}\n                </md-button>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'location-picker-page\')" spinner-position="50"></jf-spinner>\n</div>');
$templateCache.put('app/components/maintenance/maintenance.html','<div class="jf-container jf-container--small jf-maintenance">\n    <p class="maintenance-logo"><i class="material-icons">build</i></p>\n    <div translate="MAINTENANCE_PAGE_TEXT"></div>\n</div>');
$templateCache.put('app/components/products/products-location-toolbar.html','');
$templateCache.put('app/components/products/products-toolbar.html','<div class="jf-scroll-tabs-container">\n    <div class="jf-tabs-hint jf-tabs-hint-left jf-tabs-hint-hidden" ng-click="scrollToLeft()" ng-show="!$mdMedia(\'gt-sm\')">\n        <i class="material-icons">keyboard_arrow_left</i>\n    </div>\n    <div class="jf-tabs-hint jf-tabs-hint-right" ng-click="scrollToRight()" ng-show="!$mdMedia(\'gt-sm\')">\n        <i class="material-icons">keyboard_arrow_right</i>\n    </div>\n    <md-tabs md-dynamic-height md-center-tabs md-selected="selectedTabIndex" class="jf-tabs jf-categories" md-no-pagination\n             ng-show="countObjKeys(categoriesArr) > 0 && $state.current.name !== \'products.address-picker\'" jf-product-tabs-scroll>\n        <md-tab ng-repeat="category in categoriesArr | orderBy: \'position\' track by category.id"\n                md-on-select="selectTab(category.id, $index)" jf-md-tab-class ng-class="{\'jf-product-page-category-{{$index}}\': true}"\n        >\n            <md-tab-label>\n                <md-icon md-svg-icon="{{ category.image }}" class="jf-tab-icon" aria-label="{{ category.name }}"></md-icon>\n                <md-icon md-svg-icon="new" aria-label="{{\'NEW_CATEGORY\' | translate}}" ng-if="category.isNew" class="jf-tab-badge"></md-icon>\n                <md-icon md-svg-icon="discount" aria-label="{{\'DISCOUNT_IN_CATEGORY\' | translate}}" ng-if="category.hasDiscount" class="jf-category-badge"></md-icon>\n                <label class="jf-tab-label">{{ category.name }}</label>\n            </md-tab-label>\n        </md-tab>\n    </md-tabs>\n</div>');
$templateCache.put('app/components/products/products.desktop.html','<div class="jf-container" ng-show="categoriesArr.length > 0">\n    <div layout="row" layout-align="space-between stretch">\n        <div flex="100" flex-gt-sm="65" layout="column" class="jf-products-main-column">\n            <md-tab-body ng-repeat="category in categoriesArr | orderBy: \'position\'" ng-if="isSelected(category.id, $first)">\n                <div ng-repeat="product in category.products | orderBy: \'position\'" class="jf-product" layout flex>\n                    <div class="jf-product-image">\n                        <img in-view="$inview && lazyLoadImage(product.product_image_name + \'.png\', $inviewInfo)" jf-add-preloaded-image="{{product.product_image_name}}.png">\n                        <span class="jf-product-package-promo" ng-if="product.price_quantity > 1" translate translate-values="{NEXT: product.label_name, productName: product.label_name, singlePrice: currencySymbols[product.price_currency] + \'&nbsp;\' + (product.price_value | round: 2), quantity: product.price_quantity}">PACKAGE</span>\n                        <span class="jf-product-package-promo jf-product-package-promo-simple" ng-if="product.elements > 1" translate>PACKAGE_SIMPLE</span>\n\n                    </div>\n                    <div flex layout="row" layout-align="space-between stretch">\n                        <div flex="70" class="jf-product-details">\n                            <div layout="row" layout-align="start center">\n                                <div class="jf-product-clothing-type">{{ product.product_name }}</div>\n                                <div class="jf-product-additional-info" ng-if="hasAdditionalInfo(product.product_id)">\n                                    <i class="material-icons" ng-click="showAdditionalInfo(product.product_id)">info</i>\n                                </div>\n                            </div>\n                            <div class="jf-product-washing-service">{{ product.product_clarification }}</div>\n                            <div class="jf-product-delivery-time">\n                                <md-icon md-svg-src="time"></md-icon> <span translate="DAYS" translate-values="{ days: product.processing_time }"></span>\n                            </div>\n                        </div>\n                        <div flex="20" layout="row" layout-align="end center">\n                            <div class="jf-product-washing-price">{{currencySymbols[product.price_currency]}}\n                                <jf-catalog-product-price product="product"></jf-catalog-product-price>\n                            </div>\n                        </div>\n                        <div flex="15" layout="column" layout-align="center center" ng-class="{\'jf-disable-element\': jfShared.spinner.isLoading(\'cart\')}">\n                            <md-button class="md-icon-button jf-amount-button {{product.product_name}}"\n                                       aria-label="{{\'ADD\' | translate}}" ng-if="currentDeliveryLocation !== null"\n                                       ng-click="addToOrder(product.product_id, product.price_quantity, category.id, category.name)"\n                            >\n                                <md-icon md-svg-src="increment"></md-icon>\n                            </md-button>\n                            <md-button class="md-icon-button jf-amount-button {{product.product_name}}"\n                                       aria-label="{{\'REMOVE\' | translate}}" ng-if="currentDeliveryLocation !== null"\n                                       ng-click="removeFromOrder(product.product_id, product.price_quantity)"\n                            >\n                                <md-icon md-svg-src="decrement"></md-icon>\n                            </md-button>\n                        </div>\n                    </div>\n                </div>\n            </md-tab-body>\n            <jf-spinner ng-if="jfShared.spinner.isLoading(\'catalog\')" spinner-position="10"></jf-spinner>\n        </div>\n        <div flex="35" ng-if="$mdMedia(\'gt-sm\')" class="jf-laundry-basket-desktop-container">\n            <laundry-basket-desktop cart-model="order" class="jf-products-laundry-basket"></laundry-basket-desktop>\n            <jf-spinner ng-if="jfShared.spinner.isLoading(\'cart\')" spinner-position="10"></jf-spinner>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/products/products.footer-toolbar.html','<ng-include src="\'app/blocks/cart/laundry-basket-bar.html\'"></ng-include>');
$templateCache.put('app/components/products/products.html','<div class="jf-products-container" ui-view="mobile" ng-if="$mdMedia(\'xs\')" class="jf-animated-transition"></div>\n<div class="jf-products-container" ui-view="desktop" ng-if="$mdMedia(\'gt-xs\')"></div>');
$templateCache.put('app/components/products/products.mobile.html','<md-tab-body ng-repeat="category in categoriesArr | orderBy: \'position\'" ng-if="isSelected(category.id, $first)">\n    <div ng-repeat="product in category.products | orderBy: \'position\'" class="jf-product" layout flex>\n        <jf-spinner ng-if="mobileProductsThatAreLoading.indexOf(product.product_id) > -1" spinner-position="40"></jf-spinner>\n        <div class="jf-product-image">\n            <img in-view="$inview && lazyLoadImage(product.product_image_name + \'-background@2x.png\', $inviewInfo)" ng-style="{\'min-height\': minProductImgHeight + \'px\'}"  jf-add-preloaded-image="{{product.product_image_name}}-background@2x.png">\n            <div class="jf-product-overlay">\n                <div layout="column" layout-align="space-between stretch" layout-fill>\n                    <div flex="30">\n                        <span class="jf-product-package-promo" ng-if="product.price_quantity > 1" translate translate-values="{NEXT: product.label_name, productName: product.label_name, singlePrice: currencySymbols[product.price_currency] + \'&nbsp;\' + (product.price_value | round: 2), quantity: product.price_quantity}">PACKAGE</span>\n                        <span class="jf-product-package-promo" ng-if="product.elements > 1" translate>PACKAGE_SIMPLE</span>\n                        <span flex></span>\n                        <div class="jf-product-laundry-basket-quantity-input" ng-if="displayQuantityLabel(product)">\n                            <jf-order-item-quantity-changer order-item="order.items[product.item_order_position]" display-edit-icon="true" custom-css-class-name="\'jf-mobile-laundry-basket-quantity-change jf-mobile-laundry-basket-quantity-change-catalog\'"\n                                catalog-item-position="product.position" catalog-item-category="category.id" categories-arr="categoriesArr" mobile-products-that-are-loading="mobileProductsThatAreLoading"\n                            ></jf-order-item-quantity-changer>\n                        </div>\n                        <div class="jf-product-laundry-basket-delete-item" ng-if="displayQuantityLabel(product)">\n                            <md-button class="md-icon-button" aria-label="{{\'REMOVE\' | translate}}" ng-click="removeFromOrderOnMobile(product.product_id, order.items[product.item_order_position].attributes.quantity, category.id, product.position)">\n                                <md-icon md-svg-src="delete"></md-icon>\n                            </md-button>\n                        </div>\n                        <div class="jf-product-laundry-basket-buttons">\n                            <md-button md-no-ink class="md-icon-button jf-amount-button {{product.product_name}}"\n                                aria-label="{{\'ADD\' | translate}}" ng-if="currentDeliveryLocation !== null"\n                                ng-click="addToOrderOnMobile(product.product_id, product.price_quantity, category.id, category.name)"\n                            >\n                                <span class="text-icon-button">+</span>\n                            </md-button>\n                            <md-button md-no-ink class="md-icon-button jf-amount-button {{product.product_name}}"\n                                       aria-label="{{\'REMOVE\' | translate}}" ng-if="currentDeliveryLocation !== null"\n                                       ng-click="removeFromOrderOnMobile(product.product_id, product.price_quantity)"\n                            >\n                                <span class="text-icon-button">-</span>\n                            </md-button>\n                        </div>\n                    </div>\n                    <div flex="70" layout="row" layout-align="space-between end"\n                         class="jf-product-details jf-product-details--light">\n                        <div flex>\n                            <div layout="row" layout-align="start center">\n                                <div class="jf-product-clothing-type">{{ product.product_name }}</div>\n                                <div class="jf-product-additional-info" ng-if="hasAdditionalInfo(product.product_id)">\n                                    <i class="material-icons" ng-click="showAdditionalInfo(product.product_id)">info</i>\n                                </div>\n                            </div>\n                            <div class="jf-product-washing-service">{{ product.product_clarification }}</div>\n                            <div class="jf-product-delivery-time-mobile">\n                                <md-icon md-svg-src="time-white"></md-icon> <span translate="DAYS" translate-values="{ days: product.processing_time }"></span>\n                            </div>\n                        </div>\n                        <div flex="25" layout layout-align="end center">\n                            <div class="jf-product-washing-price">{{currencySymbols[product.price_currency]}}\n                                <jf-catalog-product-price product="product"></jf-catalog-product-price>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <jf-spinner ng-if="jfShared.spinner.isLoading([\'catalog\', \'cart\'])" spinner-position="10"></jf-spinner>\n</md-tab-body>\n');
$templateCache.put('app/components/wp-content/wp-content.html','<div class="jf-iframe-container">\n    <iframe scrolling="yes" ng-src="{{url | trustAsResourceUrl}}" wp-iframe-onload></iframe>\n</div>');
$templateCache.put('app/components/reminders/reminders.html','<div class="jf-container jf-container--small jf-invoices">\n  <h2>{{\'REMINDER_FROM_EMAIL_GENERATION\' | translate}}</h2>\n  <span us-spinner="{radius:7, width:2, length: 7, color: \'#0184C5\'}"></span>\n</div>');
$templateCache.put('app/shared/directives/jf-app-download-notification.html','<div class="jf-app-download-notification" ng-show="appDownloadNotificationVisible && !mobileAppMode && $mdMedia(\'xs\')">\n    <div class="jf-download-notification-wrap">\n        <div class="jf-banner-content">\n            <i class="jf-app-download-notification-close material-icons" ng-click="closeStickyNotificationOnMobile()">clear</i>\n            <img src="assets/img/icons/jf-logo-app-download-banner@2x.png" alt="JonnyFresh">\n            <div class="jf-smart-banner-wrap">\n                <p class="jf-smart-banner-headline">{{\'APP_DOWNLOAD_NOTIFICATION_HEADLINE\' | translate}}</p>\n                <p>{{\'APP_DOWNLOAD_NOTIFICATION_SUBHEADLINE\' | translate}}</p>\n                <div class="jf-app-rating">\n                    <i class="material-icons">star_rate</i>\n                    <i class="material-icons">star_rate</i>\n                    <i class="material-icons">star_rate</i>\n                    <i class="material-icons">star_rate</i>\n                    <i class="material-icons">star_rate</i>\n                </div>\n                <p>&gt; {{\'APP_DOWNLOAD_NOTIFICATION_REVIEWS_TEXT\' | translate}}</p>\n                <p>{{\'APP_DOWNLOAD_NOTIFICATION\' | translate}}</p>\n            </div>\n        </div>\n        <p class="jf-show-in-app" ng-click="goToMobileApp()">{{\'APP_DOWNLOAD_NOTIFICATION_TEXT\' | translate}}</p>\n    </div>\n</div>');
$templateCache.put('app/shared/directives/jf-button-catalog-changer.directive.html','<div class="jf-header-catalog-location jf-tooltip-parent">\n    <md-button ng-class="{\'jf-active-switcher\': catalogSelector}"\n        ng-click="showSelector()"\n        aria-label="{{\'CHANGE_CATALOG_LOCATION\' | translate}}"\n        class="md-icon jf-trust-bar-switcher-button" id="header-nav-item-catalog-changer"\n    >\n        <div layout-xs="column" layout="row" layout-align="center center">\n            <div class="jf-catalog-location-icon">\n                <md-icon ng-cloak ng-if="!catalogSelector" md-svg-icon="{{\'location_\' + color }}">menu</md-icon>\n                <md-icon ng-cloak ng-if="catalogSelector" md-svg-icon="location_pink">menu</md-icon>\n            </div>\n            <div flex class="jf-trust-bar-text-pink" ng-if="showCaption">\n                <div>{{\'CHANGE_CATALOG_LOCATION_START_TRUST_BAR\' | translate}} <br> {{\'CHANGE_CATALOG_LOCATION_END_TRUST_BAR\' | translate}}</div>\n            </div>\n        </div>\n    </md-button>\n    <header-catalog-location-selector ng-if="catalogSelector" trust-bar="{{ trustBar }}"></header-catalog-location-selector>\n</div>');
$templateCache.put('app/shared/directives/jf-button-profile-changer.directive.html','<div class="jf-button-profile-changer" ng-if="corporateEnabled">\n    <md-button ng-class="{\'jf-active-switcher\': accountSwitcher}"\n        ng-click="showSelector()"\n        aria-label="{{\'LAUNDRY_BASKET\' | translate}}"\n        class="md-icon jf-trust-bar-switcher-button" id="header-nav-item-account-switcher"\n    >\n        <div class="jf-button-profile-changer-internal" layout-xs="column" layout="row" layout-align="center center">\n            <div class="jf-profile-changer-icon">\n                <md-icon ng-cloak ng-if="!accountSwitcher" md-svg-icon="{{\'person_\' + color }}">menu</md-icon>\n                <md-icon ng-cloak ng-if="accountSwitcher" md-svg-icon="person_pink">menu</md-icon>\n            </div>\n            <div ng-cloak flex class="jf-trust-bar-text-pink" ng-if="showCaption && origin === \'trustbar\'">\n                <div>{{\'PROFIL\' | translate}}</div>\n                <div ng-cloak ng-if="isCorporate">({{ \'ACCOUNT_TYPE_COMPANY\' | translate }})</div>\n                <div ng-cloak ng-if="!isCorporate">({{ \'ACCOUNT_TYPE_PRIVATE\' | translate }})</div>\n            </div>\n            <div ng-cloak flex class="jf-trust-bar-text-pink" ng-if="showCaption && origin === \'nav\'">\n                <div ng-cloak ng-if="isCorporate">{{ \'ACCOUNT_TYPE_COMPANY\' | translate }}</div>\n                <div ng-cloak ng-if="!isCorporate">{{ \'ACCOUNT_TYPE_PRIVATE\' | translate }}</div>\n            </div>\n        </div>\n    </md-button>\n    <header-account-switcher ng-show="accountSwitcher" trust-bar="{{ trustBar }}"></header-account-switcher>\n</div>');
$templateCache.put('app/shared/directives/jf-corporate-popup.tpl.html','<div ng-if="corporatePopupVisible">\n    <div class="jf-corporate-popup-container">\n        <div class="jf-corporate-popup-content" ng-class="{\'active\': activateBackdrop}">\n            <div class="jf-corporate-popup-header">\n                <i class="material-icons jf-corporate-popup-close" ng-click="hidePopup()">highlight_off</i>\n                <i class="material-icons jf-corporate-popup-location-icon">place</i>\n                <h3 translate="{{popupTitle}}"></h3>\n            </div>\n            <div class="jf-corporate-popup-body">\n                <p translate="{{popupContent}}"></p>\n                <div class="jf-corporate-popup-account-actions" ng-if="popupShowButtons">\n                    <a ui-sref="login" ng-click="hidePopup(true)">{{\'SIGN_IN\' | translate}}</a>\n                    <a ui-sref="register" ng-click="hidePopup(true)">{{\'REGISTER_BUTTON\' | translate}}</a>\n                </div>\n                <div class="jf-corporate-popup-account-actions" ng-if="popupShowAccountInstructions">\n                    <a ui-sref="account.section({section: \'corporate\', subnav: null})" ng-click="hidePopup(true)">{{\'CORPORATE_POPUP_ACCOUNT_INSTRUCTIONS_BUTTON\' | translate}}</a>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="jf-corporate-popup-backdrop" ng-class="{\'active\': activateBackdrop}"></div>\n</div>');
$templateCache.put('app/shared/directives/jf-footer.tpl.html','<section class="jf-footer fusion-footer fusion-body" ng-class="{\'jf-cookies-visible\' : alertVisible}"></section>');
$templateCache.put('app/shared/directives/jf-language-switcher-nav.html','<div class="jf-second-lvl-nav-link">\n    <md-button class="jf-nav-toolbar-language-switcher" aria-label="{{activeLocale.i18n | translate}}"\n                md-no-ink id="header-nav-item-current-language"\n    >\n        {{currentLanguageText | translate}}\n    </md-button>\n</div>\n<div class="jf-second-lvl-nav-content">\n    <md-button class="jf-nav-toolbar-language-switcher-item" aria-label="{{ item.i18n | translate }}"\n                md-no-ink\n                ng-click="changeLocale(item.id)"\n                ng-repeat="item in locales track by item.id"\n                ng-if="item.visible && item.id !== activeLocale.locale && !(activeLocale.locale === \'en_AT\' && item.id === \'en_DE\')"\n                id="header-nav-item-language-switcher-{{item.locale}}"\n    >\n        <img class="jf-language-switcher-flag-icon" ng-src="{{ item.flagUrl }}" alt="{{ item.locale }}" width="18" ng-if="item.flagUrl !== locales[$index-1].flagUrl" />\n        <div class="jf-language-switcher-img-space" ng-if="item.flagUrl === locales[$index-1].flagUrl"></div>\n        <span class="jf-language-switcher-description">{{ item.i18n | translate }}</span>\n    </md-button>\n</div>');
$templateCache.put('app/shared/directives/jf-language-switcher-sidenav.html','<md-list-item ng-click="showLanguageNav = !showLanguageNav" ng-class="{\'jf-open-sublist\' : showLanguageNav}" md-no-ink class="jf-has-sublist">\n    <p class="md-list-item-text" translate>{{currentLanguageText}}</p>\n</md-list-item>\n<div class="jf-sidenav-sublist" ng-show="showLanguageNav">\n    <md-list-item ng-click="changeLocale(item.id)" ng-if="showLanguageNav && item.visible && item.id !== activeLocale.locale && !(activeLocale.locale === \'en_AT\' && item.id === \'en_DE\')"\n        class="jf-language-switcher"\n        ng-repeat="item in ::locales track by item.id">\n        <img class="jf-language-switcher-flag-icon" ng-src="{{ item.flagUrl }}" alt="{{ item.locale }}" width="18" ng-if="item.flagUrl !== locales[$index-1].flagUrl" />\n        <div class="jf-language-switcher-img-space" ng-if="item.flagUrl === locales[$index-1].flagUrl"></div>\n        <p class="md-list-item-text">{{ item.i18n | translate }}</p>\n    </md-list-item>\n</div>');
$templateCache.put('app/shared/directives/jf-mobile-app-download.tpl.html','<md-dialog class="jf-dialog jf-dialog-mobile-app-download">\n  <md-dialog-content>\n    <div class="md-dialog-content">\n        <div class="jf-app-download-modal">\n          <img src="assets/img/app-download-img.png" width="220" alt="Jonny Fresh">\n          <p>{{ \'MOBILE_APP_DOWNLOAD_TEXT1\' | translate }}</p>\n          <p><strong>{{ \'MOBILE_APP_DOWNLOAD_TEXT2\' | translate }}</strong></p>\n          <md-button class="jf-button md-raised md-primary" ng-click="downloadAndroid()" aria-label="Zum Play Store">\n            {{ \'MOBILE_APP_DOWNLOAD_ANDROID\' | translate }}\n          </md-button>\n            <md-button class="jf-button md-raised md-primary" ng-click="downloadIOS()" aria-label="Zum iOS Store">\n              {{ \'MOBILE_APP_DOWNLOAD_IOS\' | translate }}\n          </md-button>\n            <md-button class="jf-button md-raised md-primary jf-button-outlined" ng-click="skip()" aria-label="Sp\xE4ter vielleicht">\n              {{ \'MOBILE_APP_DOWNLOAD_SKIP\' | translate }}\n          </md-button>\n        </div>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n');
$templateCache.put('app/shared/directives/jf-my-orders.directive.html','<div class="jf-container jf-my-orders">\n    <div class="jf-order-message" ng-if="showCancelConfirmationMessage" translate="ORDER_CANCEL_MESSAGE_CONFIRMATION" translate-values="{ \'order_no\': order_no }"></div>\n    <div class="jf-order-message" ng-if="showAppointmentConfirmationMessage" translate>ORDER_APPOINTMENT_MESSAGE_CONFIRMATION</div>\n    <div flex-xs="100" flex-gt-sm="70" class="jf-checkout-box jf-checkout-box-timetable" ng-if="(showPickup && order.details.attributes.scheduled_pickup_start_time) || showDelivery || showConfirmation">\n        <div class="jf-checkout-box-title">\n            {{\'CHECKOUT_APPOINTMENTS\' | translate}}\n        </div>\n        <div class="jf-checkout-box-content">\n            <closest-appointments order="order" origin="my-orders"></closest-appointments>\n        </div>\n    </div>\n    <div class="jf-container-button-confirmation" flex-xs="100" flex-gt-sm="70" layout="row" layout-align="end center" ng-if="showConfirmation">\n        <div flex-xs="40" flex-gt-sm="25">\n            <md-button class="jf-button" ng-click="closeDeliveryTimeSlotSelector(false)" aria-label="{{\'DISCARD\' | translate}}">{{\'DISCARD\' | translate}}</md-button>\n        </div>\n        <span flex></span>\n        <div flex-xs="75" flex-gt-sm="30">\n            <md-button class="jf-button md-raised md-accent md-button md-ink-ripple" ng-click="confirmTimeSlotChanges()" aria-label="{{\'CONFIRM_SELECTION\' | translate}}">{{\'CONFIRM_SELECTION\' | translate}}</md-button>\n        </div>\n    </div>\n    <div flex-xs="100" flex-gt-sm="70" class="jf-checkout-box jf-checkout-box-timetable" ng-if="showPickup">\n        <div class="jf-checkout-box-title">\n            {{\'PICKUP\' | translate}}\n        </div>\n        <div class="jf-checkout-box-content">\n            <pickup-timetable order="order" origin="my-orders"></pickup-timetable>\n            <div layout>\n                <span flex></span>\n                <div flex-xs="40" flex-gt-sm="25">\n                    <md-button class="jf-button" ng-click="closePickupTimeSlotSelector()" aria-label="{{\'DISCARD\' | translate}}">{{\'DISCARD\' | translate}}</md-button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div flex-xs="100" flex-gt-sm="70" class="jf-checkout-box jf-checkout-box-timetable" ng-if="showDelivery">\n        <div class="jf-checkout-box-title">\n            {{\'DELIVERY\' | translate}}\n        </div>\n        <div class="jf-checkout-box-content">\n            <delivery-timetable order="order" origin="my-orders"></delivery-timetable>\n            <div layout>\n                <div flex-xs="40" flex-gt-sm="25" ng-if="allowEditPickup(order)">\n                    <md-button class="jf-button" ng-click="openPickupTimeSlotSelector()" aria-label="{{\'BACK\' | translate}}">{{\'BACK\' | translate}}</md-button>\n                </div>\n                <span flex></span>\n                <div flex-xs="40" flex-gt-sm="25">\n                    <md-button class="jf-button" ng-click="closeDeliveryTimeSlotSelector(false)" aria-label="{{\'DISCARD\' | translate}}">{{\'DISCARD\' | translate}}</md-button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <p class="jf-orders jf-text-align-center" ng-if="countObjKeys(orders) === 0" translate>NO_ORDERS</p>\n    <div class="jf-orders" ng-if="showOrders && countObjKeys(orders) > 0">\n        <div class="jf-list-item jf-order" layout="column" layout-align="center stretch" ng-repeat="order in orders" ng-init="orderActiveTab = 0">\n            <jf-order-summary order="order" status="status" info-title="ORDER_SUMMARY_TITLE" items-title="ORDER_ITEMS_TITLE" editable="isEditable(order)"></jf-order-summary>\n            <div class="jf-spacer-30"></div>\n            <span class="jf-checkout-box-separator ng-scope" ng-if="!$last"></span>\n        </div>\n    </div>\n    <div in-view="loadMoreOrders($index, $inview)" in-view-options="{offset: [50, 0, 0, 0]}" ng-if="!showPickup && !showDelivery && !showConfirmation"></div>\n</div>\n\n<jf-spinner ng-if="jfShared.spinner.isLoading(\'account-my-orders-\' + status)" spinner-position="10"></jf-spinner>');
$templateCache.put('app/shared/directives/jf-order-summary-info.directive.html','<div class="jf-checkout-box" ng-class="{ \'jf-checkout-box-margin-right\': $mdMedia(\'gt-xs\') }">\n    <div class="jf-checkout-box-title" translate="{{ boxTitle }}" translate-values="{ orderDate: formattedOrderDate }"></div>\n    <div class="jf-checkout-box-content">\n        <div layout="row" class="jf-checkout-box-content-row">\n            <span class="jf-checkout-box-content-description" flex layout-fill><strong translate>ORDER_NUMBER</strong></span>\n            <span ng-class="{ \'jf-checkout-items-right\': $mdMedia(\'xs\') }" flex layout-fill>{{orderNumberFormatted}}</span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-xs="column" layout-sm="column">\n                <span flex layout-fill>\n                    <p class="jf-checkout-box-content-description">\n                        <strong translate>PICKUP</strong>\n                        <a\n                            translate-attr="{ title: \'EDIT_PICKUP_DATE_BUTTON\' }"\n                            ng-click="openPickup()"\n                            class="jf-checkout-edit-icon order-edit-icon jf-checkout-edit-icon-large"\n                            ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                            ng-if="isTripEditable(\'pickup\') || isPickupMissed()"\n                        >\n                            <i class="material-icons">edit</i>\n                            <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                        </a>\n                        <a\n                            class="jf-checkout-check-icon order-edit-icon ng-scope"\n                            ng-if="(isTripDone(\'pickup\', \'concluded\') && !isPickupMissed()) || pickupTripDoneButNotUloaded"\n                        >\n                            <i class="material-icons">check</i>\n                        </a>\n                    </p>\n                    <div layout="column" layout-xs="row" layout-sm="row" ng-class="{ \'jf-order-done\': isTripDone(\'pickup\', \'concluded\') || isMissed() || pickupTripDoneButNotUloaded, \'jf-trip-not-scheduled\': pickupNotScheduled}">\n                        <p class="jf-checkout-box-content-calendar">\n                            <i class="jf-grey-icon jf-grey-icon-calendar"></i>\n                            <span>{{pickupDate | date: \'EEE\' | translate}} - {{pickupDate | date: \'dd.MM.yyyy\'}}</span>\n                        </p>\n                        <p class="jf-checkout-box-content-time">\n                            <i class="jf-grey-icon jf-grey-icon-clock-2"></i>\n                            <span>{{pickupStartTime}} - {{pickupEndTime}}</span>\n                        </p>\n                    </div>\n                </span>\n                <span flex layout-fill ng-class="{ \'jf-order-done\': isTripDone(\'pickup\', \'concluded\') || isMissed() || pickupTripDoneButNotUloaded }" class="jf-order-summary-address-box">\n                    <span ng-if="order.details.attributes.pickup_address.company_name">{{order.details.attributes.pickup_address.company_name}}<br></span>\n                    <span ng-if="order.details.attributes.pickup_address.addressable_type !== \'Company\'">{{order.details.attributes.pickup_address.first_name}} {{order.details.attributes.pickup_address.last_name}}<br></span>\n                    <span ng-if="order.details.attributes.pickup_address.addressable_type === \'Company\'">{{currentUser.firstName}} {{currentUser.lastName}}<br></span>\n                    <span ng-if="order.details.attributes.pickup_address.addressable_type !== \'Company\'">{{order.details.attributes.pickup_address.phone_no}}<br></span>\n                    <span ng-if="order.details.attributes.pickup_address.addressable_type === \'Company\'">{{currentUser.phoneNo}}<br></span>\n                    <span>{{order.details.attributes.pickup_address.street}} {{order.details.attributes.pickup_address.house_no_main}}</span><span ng-if="order.details.attributes.pickup_address.house_no_add"> {{order.details.attributes.pickup_address.house_no_add}}</span>,\n                    <span>{{order.details.attributes.pickup_address.postal_code}} {{order.details.attributes.pickup_address.city}}</span><br>\n                    <span>{{order.details.attributes.pickup_address.province}}, {{order.details.attributes.pickup_address.country}}</span><br>\n                </span>\n            </div>\n            <div ng-if="order.trips.pickup_trips && order.trips.pickup_trips.attributes.state === \'in_transit\' && (order.trips.pickup_trips.attributes.schedule_info.estimation_time || order.trips.pickup_trips.attributes.checkpoints.estimated_concluded_at) && order.trips.pickup_trips.attributes.b_level !== \'corp\'">\n                <p class="jf-checkout-box-content-estimated-time">\n                    <span class="material-icons jf-scheduled-time-icon">pending_actions</span>\n                    <span>{{\'ESTIMATED_TRIP_TIME\' | translate}}: <span ng-bind-html="prepareEstimationTime(order.trips.pickup_trips.attributes)"></span></span>\n                </p>\n                <p class="jf-checkout-box-content-estimated-time-late" ng-if="isDriverDelayed(order.trips.pickup_trips.attributes)">\n                    <span class="material-icons jf-scheduled-time-info-icon">warning</span>\n                    <span>{{\'ESTIMATED_TRIP_TIME_DELAY_INFO\' | translate}}</span>\n                </p>\n            </div>\n            <p class="jf-checkout-box-content-estimated-time-info" ng-if="order.trips.pickup_trips && [\'commenced\', \'in_scheduling\', \'scheduled\'].indexOf(order.trips.pickup_trips.attributes.state) > -1 && order.trips.pickup_trips.attributes.b_level !== \'corp\'">\n                <span class="material-icons jf-scheduled-time-info-icon">info</span>\n                <span class="jf-content-highlighted-pink">{{\'ESTIMATED_PICKUP_TIME_INFO\' | translate}}</span>\n            </p>\n            <div layout="column">\n                <span flex layout-fill ng-if="!isTripEditable(\'pickup\')">\n                    <p\n                        class="jf-content-highlighted-pink jf-checkout-pickup-delivery"\n                        ng-if="showDriverInTransit(\'pickup\') && !isPickupMissed() && !pickupTripDoneButNotUloaded"\n                        translate="ORDER_IN_TRANSIT"\n                    >\n                    </p>\n                    <p\n                        class="jf-content-highlighted-pink jf-checkout-pickup-delivery"\n                        ng-if="isPickupMissed()"\n                        translate="ORDER_TRIP_MISSED_PICKUP"\n                    >\n                    </p>\n                </span>\n                <span flex layout-fill>\n                    <p class="jf-content-highlighted-pink jf-checkout-pickup-delivery" ng-if="showPickupNotes && !isMissed()" translate="CORPORATE_PICKUP_NOTE" translate-values="{ pickup_start_time: pickupStartTime}"></p>\n                    <a ng-click="addCalendarEvent(pickupType)" class="jf-add-trip-to-calendar" ng-if="origin === \'checkout\'">\n                        <i class="material-icons">event_note</i> {{\'ADD_TO_CALENDAR\' | translate}}\n                    </a>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-xs="column" layout-sm="column">\n                <span flex layout-fill>\n                    <p class="jf-checkout-box-content-description">\n                        <strong translate>DELIVERY</strong>\n                        <a\n                            translate-attr="{ title: \'EDIT_DELIVERY_DATE_BUTTON\' }"\n                            ng-click="openDelivery()"\n                            class="jf-checkout-edit-icon order-edit-icon jf-checkout-edit-icon-large"\n                            ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                            ng-if="isTripEditable(\'delivery\') || isDeliveryMissed()"\n                        >\n                            <i class="material-icons">edit</i>\n                            <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                        </a>\n                        <a\n                            class="jf-checkout-check-icon order-edit-icon"\n                            ng-if="isTripDone(\'delivery\', \'concluded\') && !isMissed()"\n                        >\n                            <i class="material-icons">check</i>\n                        </a>\n                    </p>\n                    <div layout="column" layout-xs="row" layout-sm="row" ng-class="{ \'jf-order-done\': isTripDone(\'delivery\', \'concluded\') || isMissed(), \'jf-trip-not-scheduled\': pickupNotScheduled }">\n                        <p class="jf-checkout-box-content-calendar">\n                            <i class="jf-grey-icon jf-grey-icon-calendar"></i>\n                            <span>{{deliveryDate | date: \'EEE\'| translate}} - {{deliveryDate | date: \'dd.MM.yyyy\'}}</span>\n                        </p>\n                        <p class="jf-checkout-box-content-time">\n                            <i class="jf-grey-icon jf-grey-icon-clock-2"></i>\n                            <span>{{deliveryStartTime}} - {{deliveryEndTime}}</span>\n                        </p>\n                    </div>\n                </span>\n                <span flex layout-fill ng-class="{ \'jf-order-done\': isTripDone(\'delivery\', \'concluded\') || isMissed() }" class="jf-order-summary-address-box">\n                    <span ng-if="order.details.attributes.delivery_address.company_name">{{order.details.attributes.delivery_address.company_name}}<br></span>\n                    <span ng-if="order.details.attributes.delivery_address.addressable_type !== \'Company\'">{{order.details.attributes.delivery_address.first_name}} {{order.details.attributes.delivery_address.last_name}}<br></span>\n                    <span ng-if="order.details.attributes.delivery_address.addressable_type === \'Company\'">{{currentUser.firstName}} {{currentUser.lastName}}<br></span>\n                    <span ng-if="order.details.attributes.delivery_address.addressable_type !== \'Company\'">{{order.details.attributes.delivery_address.phone_no}}<br></span>\n                    <span ng-if="order.details.attributes.delivery_address.addressable_type === \'Company\'">{{currentUser.phoneNo}}<br></span>\n                    <span>{{order.details.attributes.delivery_address.street}} {{order.details.attributes.delivery_address.house_no_main}}</span>\n                    <span ng-if="order.details.attributes.delivery_address.house_no_add">  {{order.details.attributes.delivery_address.house_no_add}}</span>,\n                    <span>{{order.details.attributes.delivery_address.postal_code}} {{order.details.attributes.delivery_address.city}}</span><br>\n                    <span>{{order.details.attributes.delivery_address.province}}, {{order.details.attributes.delivery_address.country}}</span>\n                </span>\n            </div>\n            <div ng-if="order.trips.delivery_trips && order.trips.delivery_trips.attributes.state === \'in_transit\' && (order.trips.delivery_trips.attributes.schedule_info.estimation_time || order.trips.delivery_trips.attributes.checkpoints.estimated_concluded_at) && order.trips.delivery_trips.attributes.b_level !== \'corp\'">\n                <p class="jf-checkout-box-content-estimated-time">\n                    <span class="material-icons jf-scheduled-time-icon">pending_actions</span>\n                    <span>{{\'ESTIMATED_TRIP_TIME\' | translate}}: <span ng-bind-html="prepareEstimationTime(order.trips.delivery_trips.attributes)"></span></span>\n                </p>\n                <p class="jf-checkout-box-content-estimated-time-late" ng-if="isDriverDelayed(order.trips.delivery_trips.attributes)">\n                    <span class="material-icons jf-scheduled-time-info-icon">warning</span>\n                    <span>{{\'ESTIMATED_TRIP_TIME_DELAY_INFO\' | translate}}</span>\n                </p>\n            </div>\n            <p class="jf-checkout-box-content-estimated-time-info" ng-if="order.trips.delivery_trips && [\'commenced\', \'in_scheduling\', \'scheduled\'].indexOf(order.trips.delivery_trips.attributes.state) > -1 && order.trips.delivery_trips.attributes.b_level !== \'corp\'">\n                <span class="material-icons jf-scheduled-time-info-icon">info</span>\n                <span class="jf-content-highlighted-pink">{{\'ESTIMATED_DELIVERY_TIME_INFO\' | translate}}</span>\n            </p>\n            <div layout="column">\n                <span flex layout-fill ng-if="!isTripEditable(\'delivery\')">\n                    <p\n                        class="jf-content-highlighted-pink jf-checkout-pickup-delivery"\n                        ng-if="showDriverInTransit(\'delivery\') && !isDeliveryMissed()"\n                        translate="ORDER_IN_TRANSIT"\n                    >\n                    </p>\n                    <p\n                        class="jf-content-highlighted-pink jf-checkout-pickup-delivery"\n                        ng-if="isDeliveryMissed()"\n                        translate="ORDER_TRIP_MISSED_DELIVERY"\n                    >\n                    </p>\n                </span>\n                <span flex layout-fill>\n                    <p class="jf-content-highlighted-pink jf-checkout-pickup-delivery" ng-if="showDeliveryNotes && !isMissed()" translate="CORPORATE_DELIVERY_NOTE" translate-values="{ delivery_end_time: deliveryEndTime }"></p>\n                    <a ng-click="addCalendarEvent(deliveryType)" class="jf-add-trip-to-calendar" ng-if="origin === \'checkout\'">\n                        <i class="material-icons">event_note</i> {{\'ADD_TO_CALENDAR\' | translate}}\n                    </a>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-align="start center">\n                <span class="jf-checkout-box-content-description" flex layout-fill><strong translate>PAYMENT_METHOD</strong></span>\n                <span class="jf-checkout-box-content-payment-info" ng-class="{ \'jf-checkout-items-right\': $mdMedia(\'xs\') || $mdMedia(\'sm\') }" flex layout-fill>\n                    <i class="jf-grey-icon jf-grey-icon-cash" ng-if="order.details.attributes.payment_method_id === paymentMethods.cash && !companyInformation"></i>\n                    <i class="jf-grey-icon jf-grey-icon-cc" ng-if="order.details.attributes.payment_method_id === paymentMethods.creditCard"></i>\n                    <i class="jf-grey-icon jf-grey-icon-paypal" ng-if="order.details.attributes.payment_method_id === paymentMethods.payPalAfterPayment"></i>\n                    <i class="jf-grey-icon jf-grey-icon-sepa" ng-if="order.details.attributes.payment_method_id === paymentMethods.sepa"></i>\n                    <i class="jf-grey-icon jf-grey-icon-amazon-pay" ng-if="order.details.attributes.payment_method_id === paymentMethods.amazonPay"></i>\n                    <i class="jf-grey-icon jf-grey-icon-apple-pay" ng-if="order.details.attributes.payment_method_id === paymentMethods.app"></i>\n                    <span ng-if="!companyInformation">{{paymentMethodName}}</span>\n                    <span ng-if="creditCardDetails"><br>************{{creditCardDetails.attributes.payment_info.card.number}}, {{creditCardDetails.attributes.payment_info.card.holderName}}</span>\n                    <span ng-if="companyInformation">{{\'PAYMENT_DONE_BY_COMPANY\' | translate}} <strong>{{companyInformation.name}}</strong></span>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-xs="column" layout-sm="column">\n                <p class="jf-checkout-box-content-description" flex layout-fill><strong translate>PREFERRED_BILLING_ADDRESS</strong></p>\n                <span flex layout-fill>\n                    {{order.details.attributes.billing_address.first_name}} {{order.details.attributes.billing_address.last_name}}<br>\n                    {{order.details.attributes.billing_address.street}} {{order.details.attributes.billing_address.house_no_main}}\n                    <span ng-if="order.details.attributes.billing_address.house_no_add"> {{order.details.attributes.billing_address.house_no_add}}</span>,\n                    {{order.details.attributes.billing_address.postal_code}} {{order.details.attributes.billing_address.city}}<br>\n                    {{order.details.attributes.billing_address.province}}, {{order.details.attributes.billing_address.country}}</p>\n                </span>\n            </div>\n            <div layout="row" ng-if="showInvoiceMessage">\n                <p class="jf-content-highlighted-pink jf-checkout-pickup-delivery" translate="INVOICE_NOT_READY"></p>\n            </div>\n            <div layout="row" ng-if="isConcluded() && !showInvoiceMessage">\n                <span flex hide-xs hide-sm>&nbsp;</span>\n                <span flex-xs="100" flex-sm="100" flex-gt-sm="50">\n                    <a ng-click="downloadInvoice()" class="jf-add-trip-to-calendar">\n                        <i class="material-icons">description</i> {{\'DOWNLOAD_INVOICE\' | translate}}\n                    </a>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator" ng-if="showCancelButton()"></span>\n        <div layout="row" class="jf-checkout-box-content-row button-cancel" ng-if="showCancelButton()">\n            <md-button class="jf-button jf-button-cancel md-raised md-accent md-primary" ng-click="showOrderCancelConfirmation()" aria-label="{{\'ORDER_STORNO_TITLE\' | translate}}">\n                {{\'ORDER_STORNO_TITLE\' | translate}}\n            </md-button>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/shared/directives/jf-order-summary-items.directive.html','<div class="jf-checkout-box">\n    <div class="jf-checkout-box-title">\n        {{boxTitle | translate}}\n    </div>\n    <div class="jf-checkout-box-content" ng-if="!isCanceled()">\n        <div layout="row" class="jf-checkout-box-content-row">\n            <span flex-gt-xs="40" flex-xs="40" class="jf-checkout-box-content-description" layout-fill>\n                {{\'CHECKOUT_ARTICLE_NAME\' | translate}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-box-content-description jf-checkout-items-centered" layout-fill>\n                {{\'CHECKOUT_ITEM_QUANTITY\' | translate}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-box-content-description" ng-class="{ \'jf-checkout-items-right\': $mdMedia(\'gt-xs\'), \'jf-checkout-items-centered\': $mdMedia(\'xs\') }" layout-fill>\n                {{\'CHECKOUT_ITEM_PRICE\' | translate}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-box-content-description jf-checkout-items-right" layout-fill>\n                {{\'CHECKOUT_TOTAL_PRICE\' | translate}}\n            </span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div layout="row" class="jf-checkout-items" ng-repeat="orderItem in order.items | orderBy: \'attributes.created_at\'">\n            <span flex-gt-xs="40" flex-xs="40" layout-fill>\n                {{orderItem.attributes.name}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-items-centered" layout-fill>\n                {{ orderItem.attributes.quantity }}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-items-right" layout-fill>\n                {{orderItem.attributes.price | round: 2}} {{currencySymbols[orderItem.attributes.currency]}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-items-right" layout-fill>\n                {{orderItem.attributes.total_amount | round: 2}} {{currencySymbols[orderItem.attributes.currency]}}\n            </span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div layout="row" class="jf-checkout-items">\n            <span flex-gt-xs="50" hide-xs hide-sm layout-fill>\n                &nbsp;\n            </span>\n            <span flex layout-fill>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(order.details.attributes.sub_total_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'SUM_ITEMS\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{Math.abs(order.details.attributes.sub_total_amount) | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary jf-checkout-items-highlighted-pink" ng-if="Math.abs(order.details.attributes.mov_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">\n                        {{\'MINIMUM_ORDER_VALUE_AMOUNT\' | translate}}:<br/>\n                        <span class="jf-fee-description" translate="MINIMUM_ORDER_VALUE_AMOUNT_DETAIL" translate-values="{ min_order_value: order.details.attributes.mov, currency: currencySymbols[order.details.attributes.currency] }"></span>\n                    </span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{order.details.attributes.mov_amount | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(order.details.attributes.customer_discount_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'USER_DISCOUNT\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">-{{Math.abs(order.details.attributes.customer_discount_amount) | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(order.details.attributes.corporate_discount_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'COMPANY_DISCOUNT\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{order.details.attributes.corporate_discount * 100 | round: 0}}%</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(order.details.attributes.coupon_discount_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'PROMOTIONAL_CODE\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">-{{Math.abs(order.details.attributes.coupon_discount_amount) | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                 <div layout="row" class="jf-checkout-box-content-summary" ng-if="order.details.attributes.delivery_fee_amount > 0">\n                    <span flex fill flex-gt-sm="60" flex-xs="80" flex-sm="80">\n                        {{ \'DELIVERY_FEE\' | translate }}:\n                        <span class="jf-fee-description" ng-if="order.details.attributes.applied_delivery_fee.threshold > 0">({{ \'DELIVERY_FEE_TRESHOLD\' | translate }} {{order.details.attributes.applied_delivery_fee.threshold / 100}}{{currencySymbols[order.details.attributes.currency]}})</span>\n                    </span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{order.details.attributes.delivery_fee_amount || 0 | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary jf-checkout-items-highlighted">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'TOTAL_PRICE\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{order.details.attributes.payable_amount | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="order.details.attributes.pricing_base && order.details.attributes.pricing_base === \'netto\'">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80" translate="INCLUDED_VAT_AMOUT" translate-values="{vatAmout: (order.details.attributes.vat * 100)}">:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{order.details.attributes.vat_amount | round: 2}} {{currencySymbols[order.details.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="!order.details.attributes.pricing_base || order.details.attributes.pricing_base !== \'netto\'">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'ALL_PRICES_CONTAIN_VAT\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">({{order.details.attributes.vat * 100}}%)</span>\n                </div>\n            </span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div layout="row" class="jf-checkout-box-content-row" ng-if="!isClosed()">\n            <span flex layout-fill translate>CHECKOUT_ITEMS_FOOTER</span>\n        </div>\n    </div>\n    <div class="jf-checkout-box-content jf-text-align-center" ng-if="isCanceled()">\n        <span flex class="jf-checkout-box-content-description" layout-fill>\n            {{\'NOTHING_PICKED_UP\' | translate}}\n        </span>\n    </div>\n</div>');
$templateCache.put('app/shared/directives/jf-order-summary.directive.html','<div layout="row" layout-xs="column" layout-fill>\n    <div flex-sm="100" flex-gt-sm="50">\n        <jf-order-summary-info order="order" status="status" box-title="{{ infoTitle }}" editable="editable"></jf-order-summary-info>\n    </div>\n    <div flex-sm="100" flex-gt-sm="50">\n        <jf-order-summary-items order="order" box-title="{{ itemsTitle }}" editable="editable"></jf-order-summary-items>\n    </div>\n</div>');
$templateCache.put('app/shared/directives/jf-postal-code.tpl.html','<div class="jf-autocomplete-container">\n    <md-autocomplete ng-if="showStandardLabel" md-autoselect="true"\n                     md-input-name="autocompleteField" md-selected-item-change="$parent.selectedPostalCode(item)"\n                     md-selected-item="$parent.selectedtext" md-search-text="$parent.postalCode" md-items="item in getPostalCodes($parent.postalCode)"\n                     md-item-text="$parent.selectedPostalCodeValue(item.attributes)" placeholder="{{postalPlaceholder}}"\n                     required md-require-match md-clear-button="!$parent.customClearButton && $parent.selectedtext"\n                     md-min-length="2" md-input-minlength="2" ng-disabled="disableSearch"\n                     md-search-text-change="$parent.hideLanguageSwitcher()"\n                     ng-click="$parent.hideLanguageSwitcher()"\n                     ng-blur="$parent.showLanguage = true;$parent.postalCodeInputBlur()" ng-focus="$parent.postalCodeInputFocused()"\n    >\n        <md-item-template>\n            <span md-highlight-text="$parent.postalCode" ng-if="item.attributes.country_code !== \'DE\'">{{item.attributes.suggestion}}</span>\n            <span md-highlight-text="$parent.postalCode" ng-if="item.attributes.country_code === \'DE\'">{{item.attributes.code}} {{item.attributes.city_name}}</span>\n        </md-item-template>\n        <md-not-found>{{\'NOT_FOUND\' | translate}}</md-not-found>\n    </md-autocomplete>\n\n    <md-autocomplete ng-if="!showStandardLabel" md-autoselect="true"\n                     md-input-name="autocompleteField" md-selected-item-change="$parent.selectedPostalCode(item)"\n                     md-selected-item="$parent.selectedtext" md-search-text="$parent.postalCode" md-items="item in getPostalCodes($parent.postalCode)"\n                     md-item-text="$parent.selectedPostalCodeValue(item.attributes)"\n                     required md-require-match md-clear-button="!$parent.customClearButton && $parent.selectedtext"\n                     md-min-length="2" md-input-minlength="2" ng-disabled="disableSearch"\n                     md-search-text-change="$parent.hideLanguageSwitcher()"\n                     ng-click="$parent.hideLanguageSwitcher()"\n                     ng-blur="$parent.showLanguage = true;$parent.postalCodeInputBlur()" md-floating-label="{{postalPlaceholder}}" ng-focus="$parent.postalCodeInputFocused()"\n    >\n        <md-item-template>\n            <span md-highlight-text="$parent.postalCode" ng-if="item.attributes.country_code !== \'DE\'">{{item.attributes.suggestion}}</span>\n            <span md-highlight-text="$parent.postalCode" ng-if="item.attributes.country_code === \'DE\'">{{item.attributes.code}} {{item.attributes.city_name}}</span>\n        </md-item-template>\n        <md-not-found>{{\'NOT_FOUND\' | translate}}</md-not-found>\n    </md-autocomplete>\n\n    <div class="md-errors-spacer"></div>\n    <a class="jf-postal-code-clear-button" ng-if="customClearButton && selectedtext" ng-click="clearPostalCodeInput()"><i class="material-icons">close</i></a>\n</div>\n<div ng-messages="form.autocompleteField.$error" class="jf-postal-code-error-messages jf-yellow-error-message" ng-if="form.autocompleteField.$touched || form.$submitted">\n    <div class="jf-no-animate" ng-message="required" translate>REQUIRED</div>\n    <div class="jf-no-animate" ng-message="minlength" translate>POSTAL_CODE_TOO_SHORT</div>\n    <div class="jf-no-animate" ng-message="md-require-match" translate>SELECT_AN_EXISTING_STATE</div>\n    <div class="jf-no-animate" ng-message="noInService" translate>SERVICE_NOT_WORK_IN_THIS_LOCATION</div>\n    <div class="jf-no-animate" ng-message="corpRequired" translate>CORP_ACCOUNT_REQUIRED</div>\n    <div class="jf-no-animate" ng-message="b2bRequired" translate translate-values="{wordpressHost: blogUrl}">B2B_ACCOUNT_REQUIRED</div>\n    <div class="jf-no-animate" ng-message="sameCity" translate>DIFFERENT_CITY_REQUIRED</div>\n</div>\n');
$templateCache.put('app/shared/directives/jf-survey-loader.tpl.html','<md-dialog class="jf-dialog jf-dialog-survey">\n  <md-toolbar ng-if="!thankYou">\n    <div class="md-toolbar-tools">\n        <h2>{{ \'SURVEY_DIALOG_TITLE\' | translate}}</h2>\n        <i class="material-icons jf-dialog-close" ng-click="closeDialog()">clear</i>\n    </div>\n  </md-toolbar>\n  <md-dialog-content>\n    <div class="md-dialog-content">\n        <section class="jf-survey" ng-if="!thankYou">\n            <form name="mobileSurveyForm" novalidate ng-submit="sendSurveyComment()">\n              <h1 class="jf-survey-question" ng-if="!showFeedbackTextarea">{{ \'SURVEY_QUESTION\' | translate }}</h1>\n              <h1 class="jf-survey-question" ng-if="showFeedbackTextarea">{{ \'SURVEY_QUESTION_FEEDBACK_TITLE\' | translate }}</h1>\n              <section class="jf-survey-values" layout="row" ng-show="!showFeedbackTextarea">\n                <span flex ng-repeat="n in [].constructor(5) track by $index" ng-click="setAnswer($index+1)" class="material-icons jf-survey-star-selected" ng-if="survey.answer_score && ($index+1) <= survey.answer_score">star</span>\n                <span flex ng-repeat="n in [].constructor(5) track by $index" ng-click="setAnswer($index+1)" class="material-icons" ng-if="!survey.answer_score || ($index+1) > survey.answer_score">star_border</span>\n              </section>\n              <section class="jf-survey-labels" layout="row" ng-show="!showFeedbackTextarea">\n                <p flex="30" class="jf-survey-labels-min-score">{{ \'SURVEY_MIN_SCORE\' | translate }}</p>\n                <span layout-fill>&nbsp;</span>\n                <p flex="30" class="jf-survey-labels-max-score">{{ \'SURVEY_MAX_SCORE\' | translate }}</p>\n              </section>\n              <section class="jf-survey-comment" ng-if="showFeedbackTextarea">\n                  <md-input-container class="jf-input-container md-block" flex md-no-float>\n                      <md-input-label translate>SURVEY_COMMENT</md-input-label>\n                      <textarea name="response" rows="4" ng-model="survey.response" ng-attr-placeholder="{{ \'SURVEY_PLACEHOLDER\' | translate }}"></textarea>\n                  </md-input-container>\n              </section>\n              <img ng-src="{{ imageUrl }}" height="1" width="1">\n              <div class="jf-spacer-15" ng-if="showFeedbackTextarea"></div>\n              <md-button type="submit" class="md-raised md-primary jf-survey-submit" ng-if="showFeedbackTextarea">{{ \'SURVEY_BUTTON_SUBMIT\' | translate }}</md-button>\n            </form>\n        </section>\n        <section class="jf-survey-thanks" layout-fill ng-if="(thankYou && !mobileAppMode) || (thankYou && mobileAppMode && survey.answer_score !== 5)">\n          <div layout="column" layout-align="center center" layout-fill>\n            <div class="item">\n              <h1 class="jf-survey-thanks-message">{{ \'SURVEY_THANK_YOU\' | translate }}</h1>\n              <div class="jf-spacer-15"></div>\n              <md-button class="jf-survey-thanks-button jf-button md-raised md-primary" aria-label="{{\'FATAL_ERROR_POPUP_BUTTON\' | translate}}" ng-click="closeDialog()">\n                  {{\'FATAL_ERROR_POPUP_BUTTON\' | translate}}\n              </md-button>\n            </div>\n          </div>\n        </section>\n        <section class="jf-survey-thanks" layout-fill ng-if="thankYou && mobileAppMode && survey.answer_score === 5">\n          <div layout="column" layout-align="center center" layout-fill>\n            <div class="item">\n              <img src="assets/img/icons/jf-logo-app-download-banner@2x.png" alt="" width="64" height="64" class="jf-logo-app">\n              <h2 class="jf-survey-thanks-title">{{ \'SURVEY_THANK_YOU_APP\' | translate }}</h2>\n              <p class="jf-survey-thanks-message" translate translate-values="{ storeName: storeName }">SURVEY_THANK_YOU_MSG</p>\n              <a ng-click="openStore()">\n                <div class="jf-survey-thanks-rating">\n                  <div layout="row" layout-align="center center" layout-fill>\n                    <div class="jf-survey-thanks-star">\n                        <i class="material-icons">star_border</i>\n                    </div>\n                    <div class="jf-survey-thanks-star">\n                        <i class="material-icons">star_border</i>\n                    </div>\n                    <div class="jf-survey-thanks-star">\n                        <i class="material-icons">star_border</i>\n                    </div>\n                    <div class="jf-survey-thanks-star">\n                        <i class="material-icons">star_border</i>\n                    </div>\n                    <div class="jf-survey-thanks-star">\n                        <i class="material-icons">star_border</i>\n                    </div>\n                  </div>\n                </div>\n              </a>\n              <div class="jf-spacer-15"></div>\n              <md-button class="jf-survey-thanks-button jf-button md-raised md-primary" aria-label="{{\'FATAL_ERROR_POPUP_BUTTON\' | translate}}" ng-click="closeDialog()">\n                  {{\'SURVEY_BUTTON_APP_CLOSE\' | translate}}\n              </md-button>\n            </div>\n          </div>\n        </section>\n    </div>\n  </md-dialog-content>\n</md-dialog>\n');
$templateCache.put('app/blocks/cart/directives/coupon.html','<div>\n    <p class="jf-coupon-code-remove" ng-if="couponVerified">\n        <strong>{{\'PROMOTIONAL_CODE\' | translate}}:</strong> {{couponBlock.couponCode}}\n        <a ng-click="removeCouponCode()" title="{{\'REMOVE_COUPON\' | translate}}"><i class="material-icons">clear</i></a>\n    </p>\n\n    <div class="jf-promotional-code" ng-if="!couponForm && !couponVerified">\n        <md-button class="jf-button md-raised md-accent md-primary jf-submit-voucher jf-coupon-code-show-form" ng-click="showCouponBlock()" aria-label="{{\'ENCASH_PROMOTIONAL_CODE\' | translate}}">\n            {{\'ENCASH_PROMOTIONAL_CODE\' | translate}}\n        </md-button>\n    </div>\n    <form name="checkoutCouponForm" class="jf-coupon-form" novalidate ng-if="!couponVerified && couponForm">\n        <div>\n            <i class="material-icons close-coupon-block" ng-click="closeCouponBlock()">close</i>\n        </div>\n\n        <div flex>\n            <div layout-xs="column" layout-align-xs="stretch" layout-align-gt-sm="column" layout-align-gt-sm="stretch" layout-sm="row" layout-align-sm="space-between start">\n                <div flex flex-sm="45">\n                    <md-input-container flex class="jf-input-container md-block" md-no-float>\n                        <md-input-label>{{\'PROMOTIONAL_CODE\' | translate}}</md-input-label>\n\n                        <input name="coupon" ng-model="couponBlock.couponCode" ng-change="clearErrors()"\n                               placeholder="{{\'PROMOTIONAL_CODE_PLACEHOLDER\' | translate}}" ng-disabled="couponVerified" required jf-input-text-to-uppercase\n                        />\n                        <div ng-messages="checkoutCouponForm.coupon.$error">\n                            <div ng-message="required" translate>MISSING_COUPON_CODE</div>\n                            <div ng-message="wrongCode" translate>WRONG_COUPON_CODE</div>\n                            <div ng-repeat="formError in formErrors">\n                                <div class="jf-coupon-error">{{ formError}}</div>\n                            </div>\n                        </div>\n                        <p ng-show="couponVerified" class="jf-success" translate>COUPON_SUCCESSFULLY_VERIFIED</p>\n                    </md-input-container>\n                    <span flex="5"></span>\n\n                    <div flex ng-show="couponVerified">\n                        <md-button class="jf-button md-primary" ng-click="removeCouponCode(checkoutCouponForm)" aria-label="{{\'REMOVE_COUPON\' | translate}}">\n                            {{\'REMOVE_COUPON\' | translate}}\n                        </md-button>\n                    </div>\n                    <div flex ng-show="!couponVerified">\n                        <md-button class="jf-button md-raised md-accent md-primary jf-submit-voucher" ng-click="submitCouponCode(checkoutCouponForm)" aria-label="{{\'GET_DISCOUNT\' | translate}}">\n                            {{\'GET_DISCOUNT\' | translate}}\n                        </md-button>\n                    </div>\n                </div>\n                <div flex flex-sm="45"></div>\n            </div>\n        </div>\n    </form>\n</div>\n');
$templateCache.put('app/blocks/cart/directives/laundry-basket-desktop.html','<div class="jf-laundry-basket" jf-laundry-basket-position-handler>\n    <h4 class="jf-laundry-basket-title" ng-if="$state.params.section === \'confirm\'" translate>ORDER_SUMMARY</h4>\n    <h4 class="jf-laundry-basket-title" ng-if="!($state.params.section === \'confirm\')" ng-class="{\'jf-basket-title-compact\': !userLoggedIn}" translate>LAUNDRY_BASKET</h4>\n\n    <div class="jf-laundry-basket-container">\n        <div class="jf-laundry-basket-items jf-basket-box" ng-if="cartModel.items.length > 0">\n            <div class="jf-basket-box-content">\n                <div ng-repeat="item in cartModel.items | orderBy: \'attributes.created_at\'" class="jf-laundry-basket-item">\n                    <div layout="row" layout-align="space-between start">\n                        <div flex="30" class="jf-basket-item-img"><img ng-src="{{item.attributes.product_image}}" alt="" /></div>\n                        <div flex layout="column" layout-align="start none">\n                            <span class="jf-laundry-basket-item-name">{{ item.attributes.product_name || item.attributes.name }}</span>\n                            <div class="jf-laundry-basket-item-processing">\n                                <i class="material-icons">hourglass_empty</i> <span translate="DAYS" translate-values="{ days: item.attributes.processing_time }"></span>\n                            </div>\n                            <span class="jf-laundry-basket-item-price">\n                                <jf-order-item-quantity-changer order-item="item" custom-css-class-name="\'jf-mobile-laundry-basket-quantity-change\'"></jf-order-item-quantity-changer> x {{currencySymbols[cartModel.details.attributes.currency]}} {{item.attributes.price | round: 2}}\n                            </span>\n                        </div>\n\n                        <div flex="20" layout="column" ng-hide="$state.current.name === \'checkout.success\'">\n                            <div layout="row" class="jf-laundry-basket-actions">\n                                <md-button class="md-icon-button jf-amount-button jf-laundry-basket-add-to-cart" aria-label="{{\'ADD\' | translate}}" ng-click="addToOrder(item.attributes.product_id, 1)">\n                                    <md-icon md-svg-src="increment" class="jf-laundry-basket-add-to-cart"></md-icon>\n                                </md-button>\n                                <md-button class="md-icon-button jf-amount-button jf-laundry-basket-remove-from-cart" aria-label="{{\'REMOVE\' | translate}}" ng-click="removeFromOrder(item.attributes.product_id, 1)">\n                                    <md-icon md-svg-src="decrement" class="jf-laundry-basket-remove-from-cart"></md-icon>\n                                </md-button>\n                            </div>\n                            <div class="jf-laundry-basket-delete-from-cart">\n                                <md-button class="md-icon-button jf-amount-button" aria-label="{{\'REMOVE\' | translate}}" ng-click="removeFromOrder(item.attributes.product_id, item.attributes.quantity)">\n                                    <md-icon md-svg-src="delete"></md-icon>\n                                </md-button>\n                            </div>\n                        </div>\n                    </div>\n                    <span ng-if="!$last" class="jf-checkout-box-separator"></span>\n                </div>\n            </div>\n        </div>\n        <div class="jf-basket-box jf-basket-coupon-code" ng-class="{\'jf-basket-coupon-code-content\' : couponForm || couponVerified}" ng-hide="!userLoggedIn || $state.current.name === \'checkout.success\'">\n            <coupon-code></coupon-code>\n        </div>\n        <laundry-basket-summary cart-model="cartModel" min-order-value="minOrderValue"></laundry-basket-summary>\n        <p class="jf-error jf-no-margin-top" ng-show="orderError" translate>MIN_ORDER_VALUE_ERROR</p>\n        <md-button class="jf-button md-raised md-accent" ng-click="goToCheckout()" ng-show="$state.current.name == \'products\'"\n            aria-label="{{\'CONFIRM_ORDER\' | translate}}" ng-class="{\'jf-laundry-basket-continue-without-items\' : cartModel.items.length === 0}"\n        >\n            <span ng-if="cartModel.items.length === 0" translate>CONFIRM_ORDER_WITHOUT_ITEMS</span>\n            <span ng-if="cartModel.items.length === 0"> *</span>\n            <span ng-if="cartModel.items.length > 0" translate>CONFIRM_ORDER</span>\n        </md-button>\n\n        <div ng-if="$state.current.name === \'checkout\'">\n            <form name="checkoutOrder" class="jf-form jf-checkout-legal-and-newsletter" ng-submit="goToConfirmationPageDesktop()">\n                <jf-newsletter ng-if="!newsletterFlagSet" form-model="cartModel.additionalInfo.newsletter" ng-hide="$mdMedia(\'xs\')"></jf-newsletter>\n                <div class="jf-checkbox-container" ng-if="invoicingFee">\n                    <md-checkbox class="jf-checkbox md-primary jf-invoicing-fee-checkbox" ng-model="cartModel.additionalInfo.invoicingFee" ng-true-value="true"\n                                 ng-false-value="false" aria-label="{{\'INVOICING_FEE\' | translate}}" flex ng-change="saveInvoicingFeeSelection()"\n                                 required ng-class="{\'jf-validation-error\': cartModel.additionalInfo.errors.invoicingFee.length > 0}"\n                    >\n                        <md-label>\n                            <strong translate="INVOICING_FEE_AGREEMENT" translate-values="{ invoicing_fee: invoicingFee }"></strong>\n                        </md-label>\n                    </md-checkbox>\n                    <p class="jf-error" ng-repeat="invoicingFeeError in cartModel.additionalInfo.errors.invoicingFee">\n                        {{invoicingFeeError}}\n                    </p>\n                </div>\n                <div class="jf-checkbox-container" ng-if="!userAcceptedCurrentAgb()">\n                    <md-checkbox class="jf-checkbox md-primary jf-newsletter-checkbox" ng-model="cartModel.additionalInfo.agb" ng-true-value="true"\n                                 ng-false-value="false" aria-label="{{\'TERMS_AND_CONDITIONS\' | translate}}" flex ng-change="saveAgbSelection()"\n                                 required ng-class="{\'jf-validation-error\': cartModel.additionalInfo.errors.termsAndConditions.length > 0}"\n                    >\n                        <md-label>\n                            <strong translate="TERMS_AND_CONDITIONS_AGREEMENT" translate-values="{ terms_and_conditions_link: legalDocuments.gtc.document_file.url || \'https://www.jonnyfresh.com/agb\', privacy_policy_link: legalDocuments.pp.document_file.url || \'https://www.jonnyfresh.com/datenschutz\' }"></strong>\n                        </md-label>\n                    </md-checkbox>\n                    <p class="jf-error" ng-repeat="termsAndConditionsError in cartModel.additionalInfo.errors.termsAndConditions">\n                        {{termsAndConditionsError}}\n                    </p>\n                </div>\n                <p class="jf-error jf-checkout-general-error" ng-repeat="checkoutComponentError in cartModel.additionalInfo.errorMessages"\n                   layout="row" layout-align="start start"\n                >\n                    <i class="material-icons">warning</i> <span>{{checkoutComponentError}}</span>\n                </p>\n                <p class="jf-error jf-checkout-general-error" ng-repeat="checkoutGeneralError in cartModel.additionalInfo.checkoutGeneralErrors"\n                   layout="row" layout-align="start start"\n                >\n                    <i class="material-icons">warning</i> <span>{{checkoutGeneralError.message}}</span>\n                </p>\n                <md-button class="jf-button jf-checkout-order md-raised md-accent jf-confirm-order-button" type="submit"\n                           aria-label="{{\'CONFIRM\' | translate}}" ng-disabled="jfShared.checkout.orderProcessing === true || !isLoadingCompleted()"\n                >\n                    {{\'ORDER\' | translate}} <span ng-if="cartModel.items.length === 0">*</span>\n                </md-button>\n            </form>\n        </div>\n        <p ng-if="cartModel.items.length === 0" class="jf-laundry-basket-no-items-hint" translate>LANDRY_BASKET_CONTINUE_WITHOUT_ITEMS</p>\n    </div>\n</div>\n');
$templateCache.put('app/blocks/cart/directives/laundry-basket-summary.html','<div class="jf-laundry-basket-summary jf-basket-box">\n    <div class="jf-basket-box-content" ng-if="itemsFullSummary && $mdMedia(\'xs\')">\n        <div class="jf-laundry-basket-summary-items" ng-class="{ \'jf-laundry-basket-summary-items-show-more\': showMoreItems }">\n            <div class="jf-laundry-basket-summary-item" ng-repeat="orderItem in cartModel.items | orderBy: \'attributes.created_at\'">\n                <div class="jf-laundry-basket-summary-item-name">\n                    <strong>{{$index+1}}. {{orderItem.attributes.name}}</strong>\n                </div>\n                <div layout="row" layout-align="start center">\n                    <span class="jf-laundry-basker-summary-item-price">\n                        <jf-order-item-quantity-changer order-item="orderItem"display-edit-icon="true" custom-css-class-name="\'jf-mobile-laundry-basket-quantity-change jf-mobile-laundry-basket-quantity-change-checkout-summary\'"></jf-order-item-quantity-changer>\n                        &nbsp;x {{currencySymbols[cartModel.details.attributes.currency]}}&nbsp;{{orderItem.attributes.price | round: 2}}\n                    </span>\n                    <div class="jf-button-summary-buttons" flex>\n                        <md-button md-no-ink class="jf-button jf-button-summary-small md-raised md-primary"\n                            aria-label="{{\'ADD\' | translate}}" ng-if="currentDeliveryLocation !== null"\n                            ng-click="addToOrder(orderItem.attributes.product_id, 1)"\n                        >\n                            <span class="text-icon-button">+</span>\n                        </md-button>\n                        <md-button md-no-ink class="jf-button jf-button-summary-small md-raised md-primary"\n                            aria-label="{{\'REMOVE\' | translate}}" ng-if="currentDeliveryLocation !== null"\n                            ng-click="removeFromOrder(orderItem.attributes.product_id, 1)"\n                        >\n                            <span class="text-icon-button">-</span>\n                        </md-button>\n                        <md-button md-no-ink class="jf-button jf-button-summary-small jf-laundry-basket-summary-item-delete"\n                        aria-label="{{\'REMOVE\' | translate}}" ng-click="removeFromOrder(orderItem.attributes.product_id, orderItem.attributes.quantity)"\n                        >\n                            <md-icon md-svg-src="delete"></md-icon>\n                        </md-button>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="jf-spacer-15" ng-if="cartModel.items.length > 5"></div>\n\n        <md-button class="jf-button md-raised jf-laundry-basket-summary-item-show-more" ng-click="showMore()" aria-label="{{\'CHECKOUT_SHOW_MORE\' | translate}}" ng-if="cartModel.items.length > 5 && !showMoreItems">\n            {{\'CHECKOUT_SHOW_MORE\' | translate}}\n        </md-button>\n        <md-button class="jf-button md-raised jf-laundry-basket-summary-item-show-more" ng-click="showMore()" aria-label="{{\'CHECKOUT_SHOW_MORE\' | translate}}" ng-if="cartModel.items.length > 5 && showMoreItems">\n            {{\'CHECKOUT_SHOW_LESS\' | translate}}\n        </md-button>\n\n        <div class="jf-spacer-15"></div>\n    </div>\n    <div class="jf-basket-box-content">\n        <div layout="row" layout-align="space-between start">\n            <span translate>{{\'SUM_ITEMS\' | translate }}</span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{cartModel.details.attributes.sub_total_amount | round: 2}}</span>\n        </div>\n        <div layout="row" layout-align="space-between start" class="jf-laundry-basket-summary-mov-amount" ng-if="cartModel.details.attributes.mov_amount > 0 && !($state.current.name == \'products\' && cartModel.items.length === 0)">\n            <span flex flex-gt-sm="80" flex-xs="80" flex-sm="80">\n                <span ng-bind-html="\'MINIMUM_ORDER_VALUE_AMOUNT\' | translate"></span>\n                <span class="jf-fee-description" translate="MINIMUM_ORDER_VALUE_AMOUNT_DETAIL" translate-values="{ min_order_value: cartModel.details.attributes.mov, currency: currencySymbols[cartModel.details.attributes.currency] }"></span>\n            </span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{cartModel.details.attributes.mov_amount | round: 2}}</span>\n        </div>\n\n        <div layout="row" layout-align="space-between start" ng-show="cartModel.details.attributes.total_amount < minOrderValue">\n            <span translate>MIN_ORDER_VALUE</span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{minOrderValue | round: 2}}</span>\n        </div>\n\n        <div layout="row" layout-align="space-between start" ng-if="Math.abs(cartModel.details.attributes.customer_discount_amount) > 0 && !($state.current.name == \'products\' && cartModel.items.length === 0)">\n            <span translate>USER_DISCOUNT</span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} -{{Math.abs(cartModel.details.attributes.customer_discount_amount) | round: 2}}</span>\n        </div>\n\n        <div layout="row" layout-align="space-between start" ng-if="Math.abs(cartModel.details.attributes.corporate_discount_amount) > 0">\n            <span translate>COMPANY_DISCOUNT</span>\n            <span>{{cartModel.details.attributes.corporate_discount * 100 | round: 0}}%</span>\n        </div>\n\n        <div layout="row" layout-align="space-between start" ng-if="Math.abs(cartModel.details.attributes.coupon_discount_amount) > 0">\n            <span translate>PROMOTIONAL_CODE</span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} -{{Math.abs(cartModel.details.attributes.coupon_discount_amount) | round: 2}}</span>\n        </div>\n\n        <div layout="row" layout-align="space-between start" ng-if="!($state.current.name == \'products\' && cartModel.items.length === 0) && cartModel.details.attributes.delivery_fee_amount > 0">\n            <span>{{ \'DELIVERY_FEE\' | translate }}<span class="jf-fee-description" ng-if="cartModel.details.attributes.applied_delivery_fee.threshold > 0">({{ \'DELIVERY_FEE_TRESHOLD\' | translate }} {{(cartModel.details.attributes.applied_delivery_fee.threshold / 100)}}{{currencySymbols[cartModel.details.attributes.currency]}})</span></span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{cartModel.details.attributes.delivery_fee_amount || 0 | round: 2}}</span>\n        </div>\n\n        <div class="jf-laundry-basket-summary-total" layout="row" layout-align="space-between start">\n            <span translate ng-if="!cartModel.details.attributes.pricing_base || cartModel.details.attributes.pricing_base !== \'netto\'">TOTAL_PRICE</span>\n            <span translate ng-if="cartModel.details.attributes.pricing_base && cartModel.details.attributes.pricing_base === \'netto\'">TOTAL_PRICE_BRUTTO</span>\n            <span class="jf-laundry-basket-summary-price" ng-if="!($state.current.name == \'products\' && cartModel.items.length === 0)">{{currencySymbols[cartModel.details.attributes.currency]}} {{ cartModel.details.attributes.payable_amount | round: 2 }}</span>\n            <span class="jf-laundry-basket-summary-price" ng-if="$state.current.name == \'products\' && cartModel.items.length === 0">{{currencySymbols[cartModel.details.attributes.currency]}} {{ 0 | round: 2 }}</span>\n        </div>\n\n        <div class="jf-laundry-basket-summary-total-vat" ng-if="(cartModel.items.length > 0 || $state.current.name != \'products\') && cartModel.details.attributes.pricing_base && cartModel.details.attributes.pricing_base === \'netto\'" layout="row" layout-align="space-between start">\n            <span translate="INCLUDED_VAT_AMOUT" translate-values="{vatAmout: (cartModel.details.attributes.vat * 100)}"></span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{cartModel.details.attributes.vat_amount  | round: 2}}</span>\n        </div>\n        <div class="jf-laundry-basket-summary-total-vat" ng-if="!cartModel.details.attributes.pricing_base || cartModel.details.attributes.pricing_base !== \'netto\'" layout="row" layout-align="space-between start">\n            <span translate="ALL_PRICES_CONTAIN_VAT"></span>\n            <span>({{cartModel.details.attributes.vat * 100}}%)</span>\n        </div>\n        <br ng-if="cartModel.items.length === 0 && cartModel.details.attributes.pricing_base && cartModel.details.attributes.pricing_base === \'netto\'">\n\n        <div layout="row" layout-align="space-between start" class="jf-laundry-basket-desktop-line">\n            <span class="jf-laundry-basket-summary-processing-time" translate="TOTAL_PROCESSING_TIME_START"></span>\n            <span class="jf-laundry-basket-summary-processing-time">{{cartModel.details.attributes.processing_time}} {{\'TOTAL_PROCESSING_TIME_END\' | translate}}</span>\n        </div>\n        <br ng-if="!($state.current.name == \'products\' && cartModel.items.length === 0)">\n\n        <div layout="row" layout-align="space-between start" class="jf-laundry-basket-desktop-line" ng-if="cartModel.details.attributes.mov_amount > 0 && $state.current.name == \'products\' && cartModel.items.length === 0">\n            <span flex flex-gt-sm="80" flex-xs="80" flex-sm="80">\n                <span ng-bind-html="\'MINIMUM_ORDER_VALUE_AMOUNT_ALTERNATIVE\' | translate"></span>\n            </span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{cartModel.details.attributes.mov_amount | round: 2}}</span>\n        </div>\n\n        <div layout="row" layout-align="space-between start" class="jf-laundry-basket-desktop-line" ng-if="$state.current.name == \'products\' && cartModel.items.length === 0 && cartModel.details.attributes.delivery_fee_amount > 0">\n            <span>{{ \'DELIVERY_FEE\' | translate }}<span class="jf-fee-description" ng-if="cartModel.details.attributes.applied_delivery_fee.threshold > 0">({{ \'DELIVERY_FEE_TRESHOLD\' | translate }} {{(cartModel.details.attributes.applied_delivery_fee.threshold / 100)}}{{currencySymbols[cartModel.details.attributes.currency]}})</span></span>\n            <span>{{currencySymbols[cartModel.details.attributes.currency]}} {{cartModel.details.attributes.delivery_fee_amount || 0 | round: 2}}</span>\n        </div>\n        <br ng-if="$state.current.name == \'products\' && cartModel.items.length === 0">\n    </div>\n</div>\n');
$templateCache.put('app/components/checkout/partials/checkout-success-data.tpl.html','<div class="jf-checkout-box jf-checkout-box-no-margin-bottom">\n    <div class="jf-checkout-box-title">\n        {{\'CHECKOUT_USER_DATA\' | translate}}\n    </div>\n    <div class="jf-checkout-box-content">\n        <div layout="row" class="jf-checkout-box-content-row">\n            <span class="jf-checkout-box-content-description" flex layout-fill><strong translate>ORDER_NUMBER</strong></span>\n            <span ng-class="{ \'jf-checkout-items-right\': $mdMedia(\'xs\') }" flex layout-fill>{{orderNumberFormatted}}</span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-xs="column" layout-sm="column">\n                <span flex layout-fill>\n                    <p class="jf-checkout-box-content-description"><strong translate>PICKUP</strong></p>\n                    <div layout="column" layout-xs="row" layout-sm="row">\n                        <p class="jf-checkout-box-content-calendar">\n                            <i class="jf-grey-icon jf-grey-icon-calendar"></i>\n                            {{commitedOrderSummary.data.attributes.pickup_date | date: \'EEE\' | translate}} - {{commitedOrderSummary.data.attributes.pickup_date | date: \'dd.MM.yyyy\'}}\n                        </p>\n                        <p class="jf-checkout-box-content-time">\n                            <i class="jf-grey-icon jf-grey-icon-clock-2"></i>\n                            {{commitedOrderSummary.data.attributes.pickup_start_time}} - {{commitedOrderSummary.data.attributes.pickup_end_time}}\n                        </p>\n                    </div>\n                </span>\n                <span flex layout-fill>\n                    <span ng-if="commitedOrderSummary.data.attributes.pickup_address.company_name">{{commitedOrderSummary.data.attributes.pickup_address.company_name}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.pickup_address.addressable_type !== \'Company\'">{{commitedOrderSummary.data.attributes.pickup_address.first_name}} {{commitedOrderSummary.data.attributes.pickup_address.last_name}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.pickup_address.addressable_type === \'Company\'">{{currentUser.firstName}} {{currentUser.lastName}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.pickup_address.addressable_type !== \'Company\'">{{commitedOrderSummary.data.attributes.pickup_address.phone_no}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.pickup_address.addressable_type === \'Company\'">{{currentUser.phoneNo}}<br></span>\n                    {{commitedOrderSummary.data.attributes.pickup_address.street}} {{commitedOrderSummary.data.attributes.pickup_address.house_no_main}}<span ng-if="commitedOrderSummary.data.attributes.pickup_address.house_no_add"> {{commitedOrderSummary.data.attributes.pickup_address.house_no_add}}</span>, {{commitedOrderSummary.data.attributes.pickup_address.postal_code}} {{commitedOrderSummary.data.attributes.pickup_address.city}}<br>\n                    {{commitedOrderSummary.data.attributes.pickup_address.province}}, {{commitedOrderSummary.data.attributes.pickup_address.country}}<br>\n                </span>\n            </div>\n            <div layout="column">\n                <span flex layout-fill>\n                    <p class="jf-content-highlighted-pink jf-checkout-pickup-delivery" ng-if="showNotes" translate="CORPORATE_PICKUP_NOTE" translate-values="{ pickup_start_time: commitedOrderSummary.data.attributes.pickup_start_time }"></p>\n                    <a ng-click="addCalendarEvent(pickupType)" class="jf-add-trip-to-calendar"><i class="material-icons">event_note</i> {{\'ADD_TO_CALENDAR\' | translate}}</a>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-xs="column" layout-sm="column">\n                <span flex layout-fill>\n                    <p class="jf-checkout-box-content-description"><strong translate>DELIVERY</strong></p>\n                    <div layout="column" layout-xs="row" layout-sm="row">\n                        <p class="jf-checkout-box-content-calendar">\n                            <i class="jf-grey-icon jf-grey-icon-calendar"></i>\n                            {{commitedOrderSummary.data.attributes.delivery_date | date: \'EEE\'| translate}} - {{commitedOrderSummary.data.attributes.delivery_date | date: \'dd.MM.yyyy\'}}\n                        </p>\n                        <p class="jf-checkout-box-content-time">\n                            <i class="jf-grey-icon jf-grey-icon-clock-2"></i>\n                            {{commitedOrderSummary.data.attributes.delivery_start_time}} - {{commitedOrderSummary.data.attributes.delivery_end_time}}\n                        </p>\n                    </div>\n                </span>\n                <span flex layout-fill>\n                    <span ng-if="commitedOrderSummary.data.attributes.delivery_address.company_name">{{commitedOrderSummary.data.attributes.delivery_address.company_name}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.delivery_address.addressable_type !== \'Company\'">{{commitedOrderSummary.data.attributes.delivery_address.first_name}} {{commitedOrderSummary.data.attributes.delivery_address.last_name}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.delivery_address.addressable_type === \'Company\'">{{currentUser.firstName}} {{currentUser.lastName}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.delivery_address.addressable_type !== \'Company\'">{{commitedOrderSummary.data.attributes.delivery_address.phone_no}}<br></span>\n                    <span ng-if="commitedOrderSummary.data.attributes.delivery_address.addressable_type === \'Company\'">{{currentUser.phoneNo}}<br></span>\n                    {{commitedOrderSummary.data.attributes.delivery_address.street}} {{commitedOrderSummary.data.attributes.delivery_address.house_no_main}}<span ng-if="commitedOrderSummary.data.attributes.delivery_address.house_no_add">  {{commitedOrderSummary.data.attributes.delivery_address.house_no_add}}</span>, {{commitedOrderSummary.data.attributes.delivery_address.postal_code}} {{commitedOrderSummary.data.attributes.delivery_address.city}}<br>\n                    {{commitedOrderSummary.data.attributes.delivery_address.province}}, {{commitedOrderSummary.data.attributes.delivery_address.country}}<br>\n                </span>\n            </div>\n            <div layout="column">\n                <span flex layout-fill>\n                    <p class="jf-content-highlighted-pink jf-checkout-pickup-delivery" ng-if="showNotes" translate="CORPORATE_DELIVERY_NOTE" translate-values="{ delivery_end_time: commitedOrderSummary.data.attributes.delivery_end_time }"></p>\n                    <a ng-click="addCalendarEvent(deliveryType)" class="jf-add-trip-to-calendar"><i class="material-icons">event_note</i> {{\'ADD_TO_CALENDAR\' | translate}}</a>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-align="start center">\n                <span class="jf-checkout-box-content-description" flex layout-fill><strong translate>PAYMENT_METHOD</strong></span>\n                <span class="jf-checkout-box-content-payment-info" ng-class="{ \'jf-checkout-items-right\': $mdMedia(\'xs\') || $mdMedia(\'sm\') }" flex layout-fill>\n                    <i class="jf-grey-icon jf-grey-icon-cash" ng-if="commitedOrderSummary.data.attributes.payment_method_id === paymentMethods.cash && !companyInformation"></i>\n                    <i class="jf-grey-icon jf-grey-icon-cc" ng-if="commitedOrderSummary.data.attributes.payment_method_id === paymentMethods.creditCard"></i>\n                    <i class="jf-grey-icon jf-grey-icon-paypal" ng-if="commitedOrderSummary.data.attributes.payment_method_id === paymentMethods.payPalAfterPayment"></i>\n                    <i class="jf-grey-icon jf-grey-icon-sepa" ng-if="commitedOrderSummary.data.attributes.payment_method_id === paymentMethods.sepa"></i>\n                    <i class="jf-grey-icon jf-grey-icon-apple-pay" ng-if="commitedOrderSummary.data.attributes.payment_method_id === paymentMethods.app"></i>\n                    <span ng-if="!companyInformation">{{paymentMethodName}}</span>\n                    <span ng-if="creditCardDetails"><br>************{{creditCardDetails.attributes.payment_info.card.number}}, {{creditCardDetails.attributes.payment_info.card.holderName}}</span>\n                    <span ng-if="companyInformation">{{\'PAYMENT_DONE_BY_COMPANY\' | translate}} <strong>{{companyInformation.name}}</strong></span>\n                </span>\n            </div>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div class="jf-checkout-box-content-row">\n            <div layout="row" layout-xs="column" layout-sm="column">\n                <p class="jf-checkout-box-content-description" flex layout-fill><strong translate>PREFERRED_BILLING_ADDRESS</strong></p>\n                <span flex layout-fill>\n                    {{commitedOrderSummary.data.attributes.billing_address.first_name}} {{commitedOrderSummary.data.attributes.billing_address.last_name}}<br>\n                    {{commitedOrderSummary.data.attributes.billing_address.street}} {{commitedOrderSummary.data.attributes.billing_address.house_no_main}}<span ng-if="commitedOrderSummary.data.attributes.billing_address.house_no_add"> {{commitedOrderSummary.data.attributes.billing_address.house_no_add}}</span>, {{commitedOrderSummary.data.attributes.billing_address.postal_code}} {{commitedOrderSummary.data.attributes.billing_address.city}}<br>\n                    {{commitedOrderSummary.data.attributes.billing_address.province}}, {{commitedOrderSummary.data.attributes.billing_address.country}}</p>\n                </span>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/partials/checkout-success-items.tpl.html','<div class="jf-checkout-box">\n    <div class="jf-checkout-box-title">\n        {{\'CHECKOUT_ITEMS_TITLE\' | translate}}\n    </div>\n    <div class="jf-checkout-box-content">\n        <div layout="row" class="jf-checkout-box-content-row">\n            <span flex-gt-xs="40" flex-xs="40" class="jf-checkout-box-content-description" layout-fill>\n                {{\'CHECKOUT_ARTICLE_NAME\' | translate}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-box-content-description jf-checkout-items-centered" layout-fill>\n                {{\'CHECKOUT_ITEM_QUANTITY\' | translate}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-box-content-description" ng-class="{ \'jf-checkout-items-right\': $mdMedia(\'gt-xs\'), \'jf-checkout-items-centered\': $mdMedia(\'xs\') }" layout-fill>\n                {{\'CHECKOUT_ITEM_PRICE\' | translate}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-box-content-description jf-checkout-items-right" layout-fill>\n                {{\'CHECKOUT_TOTAL_PRICE\' | translate}}\n            </span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div layout="row" class="jf-checkout-items" ng-repeat="orderItem in orderItems | orderBy: \'attributes.created_at\'">\n            <span flex-gt-xs="40" flex-xs="40" layout-fill>\n                {{orderItem.attributes.name}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-items-centered" layout-fill>\n                {{ orderItem.attributes.quantity }}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-items-right" layout-fill>\n                {{orderItem.attributes.price | round: 2}} {{currencySymbols[orderItem.attributes.currency]}}\n            </span>\n            <span flex-gt-xs="20" flex-xs="20" class="jf-checkout-items-right" layout-fill>\n                {{orderItem.attributes.total_amount | round: 2}} {{currencySymbols[orderItem.attributes.currency]}}\n            </span>\n        </div>\n        <span class="jf-checkout-box-separator" ng-if="orderItems.length > 0"></span>\n        <div layout="row" class="jf-checkout-items">\n            <span flex-gt-xs="50" hide-xs hide-sm layout-fill>\n                &nbsp;\n            </span>\n            <span flex layout-fill>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(commitedOrderSummary.data.attributes.sub_total_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'SUM_ITEMS\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{Math.abs(commitedOrderSummary.data.attributes.sub_total_amount) | round: 2}} {{currencySymbols[commitedOrderSummary.data.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary jf-checkout-items-highlighted-pink" ng-if="Math.abs(commitedOrderSummary.data.attributes.mov_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">\n                        {{\'MINIMUM_ORDER_VALUE_AMOUNT\' | translate}}:<br/>\n                        <span class="jf-fee-description" translate="MINIMUM_ORDER_VALUE_AMOUNT_DETAIL" translate-values="{ min_order_value: commitedOrderSummary.data.attributes.mov, currency: currencySymbols[commitedOrderSummary.data.attributes.currency] }"></span>\n                    </span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{commitedOrderSummary.data.attributes.mov_amount | round: 2}} {{currencySymbols[commitedOrderSummary.data.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(commitedOrderSummary.data.attributes.customer_discount_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'USER_DISCOUNT\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">-{{Math.abs(commitedOrderSummary.data.attributes.customer_discount_amount) | round: 2}} {{currencySymbols[commitedOrderSummary.data.attributes.currency]}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(commitedOrderSummary.data.attributes.corporate_discount_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'COMPANY_DISCOUNT\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{commitedOrderSummary.data.attributes.corporate_discount * 100 | round: 0}}%</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="Math.abs(commitedOrderSummary.data.attributes.coupon_discount_amount) > 0">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'PROMOTIONAL_CODE\' | translate }}</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">-{{Math.abs(commitedOrderSummary.data.attributes.coupon_discount_amount) | round: 2}} {{currencySymbols[commitedOrderSummary.data.attributes.currency]}}</span>\n                </div>\n\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="commitedOrderSummary.data.attributes.delivery_fee_amount > 0">\n                    <span flex fill flex-gt-sm="60" flex-xs="80" flex-sm="80">\n                        {{ \'DELIVERY_FEE\' | translate }}:\n                        <span class="jf-fee-description" ng-if="commitedOrderSummary.data.attributes.applied_delivery_fee.threshold > 0">({{ \'DELIVERY_FEE_TRESHOLD\' | translate }} {{commitedOrderSummary.data.attributes.applied_delivery_fee.threshold / 100}}{{currencySymbols[commitedOrderSummary.data.attributes.currency]}})</span>\n                    </span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{commitedOrderSummary.data.attributes.delivery_fee_amount || 0 | round: 2}} {{currencySymbols[commitedOrderSummary.data.attributes.currency]}}</span>\n                </div>\n\n                <div layout="row" class="jf-checkout-box-content-summary jf-checkout-items-highlighted">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'TOTAL_PRICE\' | translate }}</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{commitedOrderSummary.data.attributes.payable_amount | round: 2}} {{currencySymbols[commitedOrderSummary.data.attributes.currency]}}</span>\n                </div>\n\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="commitedOrderSummary.data.attributes.pricing_base && commitedOrderSummary.data.attributes.pricing_base === \'netto\'">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80" translate="INCLUDED_VAT_AMOUT" translate-values="{vatAmout: (commitedOrderSummary.data.attributes.vat * 100)}">:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">{{currencySymbols[commitedOrderSummary.data.attributes.currency]}} {{commitedOrderSummary.data.attributes.vat_amount | round: 2}}</span>\n                </div>\n                <div layout="row" class="jf-checkout-box-content-summary" ng-if="!commitedOrderSummary.data.attributes.pricing_base || commitedOrderSummary.data.attributes.pricing_base !== \'netto\'">\n                    <span flex flex-gt-sm="60" flex-xs="80" flex-sm="80">{{ \'ALL_PRICES_CONTAIN_VAT\' | translate }}:</span>\n                    <span flex flex-gt-sm="40" flex-xs="20" flex-sm="20">({{commitedOrderSummary.data.attributes.vat * 100}}%)</span>\n                </div>\n            </span>\n        </div>\n        <span class="jf-checkout-box-separator"></span>\n        <div layout="row" class="jf-checkout-box-content-row">\n            <span ng-if="!invoicingFee" flex layout-fill translate>CHECKOUT_ITEMS_FOOTER</span>\n            <span ng-if="invoicingFee" flex layout-fill translate translate-values="{invoicing_fee: invoicingFee}">CHECKOUT_ITEMS_B2B_FOOTER</span>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/partials/checkout-success-notes.tpl.html','<div flex class="jf-checkout-box" layout-fill>\n    <div class="jf-checkout-box-title-pink" ng-if="orderCorp">\n        {{\'OFFICE_SERVICE_NOTES_TITLE_B2B\' | translate}}\n    </div>\n    <div class="jf-checkout-box-title-pink" ng-if="!orderCorp">\n        {{\'OFFICE_SERVICE_NOTES_TITLE_B2C\' | translate}}\n    </div>\n    <div class="jf-checkout-box-content jf-checkout-success-notes">\n        <div layout="row" ng-if="orderCorp">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Weitere Informationen" class="jf-checkout-image-sprite jf-checkout-success-notes-image jf-checkout-image-exclamation"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span ng-if="!mobileAppMode" flex layout-fill translate="CHECKOUT_NOTES_ONE_B2B" translate-values="{ blogUrl: blogUrl, landingPageUrl: landingPageUrl }"></span>\n            <span ng-if="mobileAppMode" flex layout-fill translate="CHECKOUT_NOTES_ONE_B2B_MOBILE_APP"></span>\n        </div>\n        <div layout="row" ng-if="!orderCorp">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Weitere Informationen" class="jf-checkout-image-sprite jf-checkout-success-notes-image jf-checkout-image-bag"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span flex layout-fill translate>CHECKOUT_NOTES_ONE_B2C</span>\n        </div>\n        <div class="jf-spacer-30"></div>\n        <div layout="row">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Mehr Textilien" class="jf-checkout-image-sprite jf-checkout-success-notes-image jf-checkout-image-shirt-plus"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span flex layout-fill translate>CHECKOUT_NOTES_TWO</span>\n        </div>\n        <div class="jf-spacer-30"></div>\n        <div layout="row">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Weitere Informationen" class="jf-checkout-success-notes-image jf-checkout-image-order-editing"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span flex layout-fill translate>CHECKOUT_NOTES_ORDER_EDITING</span>\n        </div>\n        <div class="jf-spacer-30" ng-if="!orderCorp"></div>\n        <div layout="row" ng-if="!orderCorp">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Weitere Informationen" class="jf-checkout-success-notes-image jf-checkout-image-arrival-time"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span flex layout-fill translate>CHECKOUT_NOTES_ARRIVAL_TIME</span>\n        </div>\n        <div class="jf-spacer-30"></div>\n        <div layout="row">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Weitere Informationen" class="jf-checkout-image-sprite jf-checkout-success-notes-image jf-checkout-image-shirt"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span flex layout-fill translate>CHECKOUT_NOTES_THREE</span>\n        </div>\n        <div class="jf-spacer-30" ng-if="!orderCorp"></div>\n        <div layout="row" ng-if="!orderCorp">\n            <span flex="30" class="jf-text-align-center">\n                <div alt="Weitere Informationen" class="jf-checkout-image-sprite jf-checkout-success-notes-image jf-checkout-image-hanger"></div>\n            </span>\n            <span flex="5" layout-fill ng-show="$mdMedia(\'xs\') || $mdMedia(\'sm\')">&nbsp;</span>\n            <span flex layout-fill translate>CHECKOUT_NOTES_FOUR_B2C</span>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/directives/choose-address.html','<div>\n    <ng-form name="checkoutChooseAddressForm" class="jf-form jf-checkout-component">\n        <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-choose-address\')" spinner-position="45"></jf-spinner>\n\n        <div class="jf-checkout-box" ng-if="!jfShared.checkout.addressesLoading && (countObjKeys(jfShared.checkout.userAddresses) === 0 ||\n                  countObjKeys(jfShared.checkout.userAddresses) === countObjKeys(jfShared.checkout.companyAddresses))">\n            <div class="jf-checkout-box-title">{{\'CHOOSE_ADDRESS\' | translate}}</div>\n            <div class="jf-checkout-box-content">\n                <p class="jf-error" ng-repeat="addressError in order.additionalInfo.errors.addresses">\n                    {{addressError}}\n                </p>\n                <p class="jf-error" translate="NO_ADDRESSES_ERROR" ng-if="!order.additionalInfo.errors.addresses || order.additionalInfo.errors.addresses.length === 0"></p>\n                <p class="jf-empty-addresses" translate="PLEASE_ADD_NEW_ADDRESS"></p>\n            </div>\n        </div>\n\n        <div class="jf-checkout-box" ng-repeat="userAddress in sortedUserAddresses | filter:visibilityManagement">\n            <div class="jf-checkout-box-title" ng-if="$first">\n                {{\'CHOOSE_ADDRESS\' | translate}} <i class="material-icons" ng-click="openNewAddressForm()">add_circle</i>\n            </div>\n            <div class="jf-checkout-box-content">\n                <p ng-if="$parent.$first" class="jf-error" ng-repeat="addressError in order.additionalInfo.errors.addresses">\n                    {{addressError}}\n                </p>\n                <div class="jf-checkout-address-content">\n                    <p>\n                        <span ng-if="userAddress.attributes.company_name" class="jf-address-owner-company">{{userAddress.attributes.company_name}}<br></span>\n                        <span class="jf-address-owner-name">{{userAddress.attributes.first_name}} {{userAddress.attributes.last_name}}</span><br>\n                        <span ng-if="userAddress.attributes.phone_no">{{userAddress.attributes.phone_no}}<br></span>\n                        {{userAddress.attributes.street}} {{userAddress.attributes.house_no_main}} {{userAddress.attributes.house_no_add}} {{userAddress.attributes.other}}<br>\n                        {{userAddress.attributes.postal_code}} {{userAddress.attributes.city}} {{userAddress.attributes.province}}\n                    </p>\n                    <a title="{{\'EDIT_ADDRESS\' | translate}}" ng-click="openEditAddressForm(userAddress)"\n                       class="jf-checkout-edit-icon jf-checkout-edit-icon-large" ng-if="showEditButton(userAddress)"\n                       ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                    >\n                        <i class="material-icons">edit</i>\n                        <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                    </a>\n                    <span class="jf-checkout-box-separator"></span>\n                    <div layout layout-align="center start" class="jf-location-picker">\n                        <div flex layout layout-align="start center">\n                            <md-checkbox class="jf-checkbox md-primary" ng-model="selectedAddresses.pickupAddressId"\n                                         aria-label="{{\'PICKUP\' | translate}}" ng-true-value="\'{{userAddress.id}}\'"\n                                         ng-change="changePickupAddressAction(userAddress.id)"\n                                         ng-disabled="disablePickupAddress(catalogCity, userAddress)"\n                            >\n                                <span>{{\'PICKUP\' | translate}}</span>\n                            </md-checkbox>\n                        </div>\n                        <div flex layout layout-align="center center">\n                            <md-checkbox class="jf-checkbox md-primary" ng-model="selectedAddresses.deliveryAddressId"\n                                         aria-label="{{\'DELIVERY\' | translate}}" ng-true-value="\'{{userAddress.id}}\'"\n                                         ng-change="changeDeliveryAddressAction(userAddress.id)"\n                                         ng-disabled="disableDeliveryAddress(catalogCity, userAddress)"\n                            >\n                                <span>{{\'DELIVERY\' | translate}}</span>\n                            </md-checkbox>\n                        </div>\n                        <div flex layout layout-align="end center">\n                            <md-checkbox class="jf-checkbox md-primary" ng-model="selectedAddresses.billingAddressId"\n                                         aria-label="{{\'BILLING\' | translate}}" ng-true-value="\'{{userAddress.id}}\'"\n                                         ng-change="changeBillingAddressAction(userAddress.id)"\n                                         ng-disabled="disableBillingAddress(userAddress)"\n                            >\n                                {{\'BILLING\' | translate}}\n                            </md-checkbox>\n                        </div>\n                    </div>\n                </div>\n                <a class="jf-checkout-box-more-addresses" ng-show="!mobileCheckoutPreview && $last && !showAllAddresses && countObjKeys(sortedUserAddresses) > ($index + 1)" ng-click="toggleShowAllAddresses()">\n                    <span><i class="material-icons">forward</i></span> {{\'SHOW_ALL_ADDRESSES\' | translate}}\n                </a>\n                <a class="jf-checkout-box-more-addresses jf-checkout-box-more-addresses-hide" ng-show="!mobileCheckoutPreview && $last && showAllAddresses && countObjKeys(sortedUserAddresses) > countSelectedAddresses()" ng-click="toggleShowAllAddresses()">\n                    <span><i class="material-icons">forward</i></span> {{\'HIDE_ALL_ADDRESSES\' | translate}}\n                </a>\n            </div>\n        </div>\n    </ng-form>\n    <md-button class="jf-button md-primary jf-show-all-addresses" ng-click="toggleShowAllAddresses()" ng-if="$mdMedia(\'xs\') && (sortedUserAddresses.length > countSelectedAddresses()) && !showAllAddresses" aria-label="{{\'SHOW_ALL_ADDRESSES_MOBILE\' | translate}}">\n        {{\'SHOW_ALL_ADDRESSES_MOBILE\' | translate}} <i class="material-icons">play_arrow</i>\n    </md-button>\n    <md-button class="jf-button md-primary jf-show-all-addresses jf-hide-all-addresses" ng-click="toggleShowAllAddresses()" ng-if="$mdMedia(\'xs\') && (sortedUserAddresses.length > countSelectedAddresses()) && showAllAddresses" aria-label="{{\'HIDE_ALL_ADDRESSES_MOBILE\' | translate}}">\n        {{\'HIDE_ALL_ADDRESSES_MOBILE\' | translate}} <i class="material-icons">play_arrow</i>\n    </md-button>\n</div>');
$templateCache.put('app/components/checkout/directives/closest-appointments.directive.html','<div>\n    <div ng-if="$mdMedia(\'xs\')" class="jf-position-relative">\n        <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-closest-appointments\')" spinner-position="30"></jf-spinner>\n        <div ng-if="noAppointmentsForAddress" class="jf-appointment-block">\n            <p flex ng-class="{\'jf-error\': noAppointmentsForAddress}">{{\'NO_AVAILABLE_APPOINTMENTS_FOR_ADDRESS\' | translate}}</p>\n        </div>\n        <div class="jf-checkout-box">\n            <div class="jf-checkout-box-content">\n                <p class="jf-error jf-error-mobile-box" ng-repeat="timeSlotError in order.additionalInfo.errors.timeSlots.pickup">\n                    {{timeSlotError}}\n                </p>\n                <div class="jf-checkout-time-slots-content" ng-class="{\'jf-mobile-checkout-section-disabled\': !checkoutAppointmentsLoaded || !order.details.attributes.pickup_address.resource_id || order.details.attributes.pickup_address.resource_id === null}">\n                    <strong translate>{{ \'PICKUP\' | translate }}:</strong>\n                    <span ng-if="pickupDate" ng-class="{ \'jf-order-done\': isTripDone(\'pickup\', \'concluded\') }">\n                        {{pickupDate | date: \'dd.MM.yyyy\'}}&nbsp;&bullet;&nbsp;{{pickupStartTime}}&nbsp;-&nbsp;{{pickupEndTime}}\n                    </span><br/>\n                    <span class="jf-checkout-notes" ng-if="showPickupNotes" translate="CORPORATE_PICKUP_NOTE" translate-values="{ pickup_start_time: pickupStartTime }"></span>\n                    <span ng-if="!pickupStartTime || pickupStartTime === null">\n                        {{\'ADD_PICKUP_TIME\' | translate}}\n                    </span>\n                    <a ui-sref="checkout.pickup-delivery({showPickup: true, showDelivery: false})"\n                       class="jf-checkout-edit-icon jf-checkout-edit-icon-large" ng-if="origin === \'checkout\'"\n                       ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                    >\n                        <i class="material-icons">edit</i>\n                        <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                    </a>\n                    <a class="jf-checkout-check-icon order-edit-icon-closest" ng-if="isTripDone(\'pickup\', \'concluded\')">\n                        <i class="material-icons">check</i>\n                    </a>\n                </div>\n            </div>\n        </div>\n        <div class="jf-checkout-box">\n            <div class="jf-checkout-box-content">\n                <p class="jf-error jf-error-mobile-box" ng-repeat="timeSlotError in order.additionalInfo.errors.timeSlots.delivery">\n                    {{timeSlotError}}\n                </p>\n                <div class="jf-checkout-time-slots-content" ng-class="{\'jf-mobile-checkout-section-disabled\': !pickupStartTime || !checkoutAppointmentsLoaded || !order.details.attributes.pickup_start_ts || (!order.details.attributes.delivery_address.resource_id || order.details.attributes.delivery_address.resource_id === null)}">\n                    <strong translate>{{ \'DELIVERY\' | translate }}:</strong>\n                    <span ng-if="deliveryDate" ng-class="{ \'jf-order-done\': isTripDone(\'delivery\', \'concluded\') }">\n                        {{deliveryDate | date: \'dd.MM.yyyy\'}}&nbsp;&bullet;&nbsp;{{deliveryStartTime}}&nbsp;-&nbsp;{{deliveryEndTime}}\n                    </span><br/>\n                    <span class="jf-checkout-notes" ng-if="showDeliveryNotes && deliveryStartTime" translate="CORPORATE_DELIVERY_NOTE" translate-values="{ delivery_end_time: deliveryEndTime }"></span>\n                    <span ng-if="!deliveryStartTime || deliveryStartTime === null">\n                        {{\'ADD_DELIVERY_TIME\' | translate}}\n                    </span>\n                    <a ui-sref="checkout.pickup-delivery({showPickup: false, showDelivery: true})"\n                       class="jf-checkout-edit-icon jf-checkout-edit-icon-large" ng-if="origin === \'checkout\'"\n                       ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                    >\n                        <i class="material-icons">edit</i>\n                        <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                    </a>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="jf-closest-appointments-block" ng-if="$mdMedia(\'gt-xs\')">\n        <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-closest-appointments\')" spinner-position="30"></jf-spinner>\n        <div layout="column">\n            <div class="jf-appointment-block" ng-class="{\'jf-disabled\': !checkoutAppointmentsLoaded}">\n                <div layout="row">\n                    <div flex class="jf-subheadline">{{\'PICKUP\' | translate}}</div>\n                    <div flex class="jf-text-align-center" ng-if="origin === \'checkout\'">\n                        <a title="{{\'EDIT_BUTTON\' | translate}}" ng-click="checkoutAppointmentsLoaded && showPickupTimetable()"\n                           class="jf-checkout-edit-icon jf-checkout-edit-icon-large"\n                           ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                        >\n                            <i class="material-icons">edit</i>\n                            <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                        </a>\n                    </div>\n                    <a class="jf-checkout-check-icon order-edit-icon-closest" ng-if="isTripDone(\'pickup\', \'concluded\')">\n                        <i class="material-icons">check</i>\n                    </a>\n                </div>\n                <div layout="row">\n                    <div\n                        ng-if="pickupStartTime && pickupStartTime !== null && checkoutAppointmentsLoaded"\n                        class="jf-appointment"\n                        ng-class="{ \'jf-order-done\': isTripDone(\'pickup\', \'concluded\') }"\n                    >\n                        <p><i class="jf-grey-icon jf-grey-icon-calendar"></i>{{pickupDate | date: \'dd.MM.yyyy\'}}</p>\n                        <p><i class="jf-grey-icon jf-grey-icon-clock-2"></i>{{pickupStartTime}} - {{pickupEndTime}}</p>\n                        <p class="jf-checkout-notes" ng-if="showPickupNotes" translate="CORPORATE_PICKUP_NOTE" translate-values="{ pickup_start_time: pickupStartTime }"></p>\n                    </div>\n                    <div ng-if="!pickupStartTime || pickupStartTime === null" ng-class="{\'jf-error\': timeslotsErrors.length > 0}" class="jf-no-time-slot-selected">\n                        {{\'ADD_PICKUP_TIME\' | translate}}\n                    </div>\n                </div>\n            </div>\n            <span class="jf-checkout-box-separator"></span>\n            <div class="jf-appointment-block" ng-class="{\'jf-disabled\': !pickupStartTime || !checkoutAppointmentsLoaded}">\n                <div layout="row">\n                    <div flex class="jf-subheadline">{{\'DELIVERY\' | translate}}</div>\n                    <div flex class="jf-text-align-center jf-edit-delivery-button" ng-if="origin === \'checkout\'">\n                        <a title="{{\'EDIT_BUTTON\' | translate}}" ng-click="pickupStartTime && showDeliveryTimetable()"\n                           class="jf-checkout-edit-icon jf-checkout-edit-icon-large"\n                           ng-class="{\'jf-checkout-edit-icon-en\': isEnglishLocale}"\n                        >\n                            <i class="material-icons">edit</i>\n                            <span>{{\'EDIT_BUTTON\' | translate}}</span>\n                        </a>\n                    </div>\n                    <a class="jf-checkout-check-icon order-edit-icon-closest" ng-if="isTripDone(\'delivery\', \'concluded\')">\n                        <i class="material-icons">check</i>\n                    </a>\n                </div>\n                <div layout="row">\n                    <div\n                        ng-if="deliveryStartTime && deliveryStartTime !== null && checkoutAppointmentsLoaded"\n                        class="jf-appointment"\n                        ng-class="{ \'jf-order-done\': isTripDone(\'delivery\', \'concluded\') }"\n                    >\n                        <p><i class="jf-grey-icon jf-grey-icon-calendar"></i>{{deliveryDate | date: \'dd.MM.yyyy\'}}</p>\n                        <p><i class="jf-grey-icon jf-grey-icon-clock-2"></i>{{deliveryStartTime}} - {{deliveryEndTime}}</p>\n                        <p class="jf-checkout-notes" ng-if="showDeliveryNotes && deliveryStartTime" translate="CORPORATE_DELIVERY_NOTE" translate-values="{ delivery_end_time: deliveryEndTime }"></p>\n                    </div>\n                    <div ng-if="!deliveryStartTime || deliveryStartTime === null" ng-class="{\'jf-error\': timeslotsErrors.length > 0}" class="jf-no-time-slot-selected">\n                        {{\'ADD_DELIVERY_TIME\' | translate}}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-if="noAppointmentsForAddress" class="jf-appointment-block">\n            <p flex ng-class="{\'jf-error\': noAppointmentsForAddress}">{{\'NO_AVAILABLE_APPOINTMENTS_FOR_ADDRESS\' | translate}}</p>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/directives/delivery-notes.html','<div>\n    <md-input-container class="jf-input-container md-block" md-no-float>\n        <textarea md-no-autogrow class="jf-delivery-note" name="deliveryNote" rows="4" ng-model="order.additionalInfo.deliveryNote"\n                  ng-focus="sendGAEvent(\'checkoutPage\', \'deliveryNoteTextarea\')" ng-change="saveDeliveryNote()"\n                  ng-attr-placeholder="{{\'DELIVERY_NOTES_PLACEHOLDER\' | translate}}"\n        ></textarea>\n    </md-input-container>\n</div>');
$templateCache.put('app/components/checkout/directives/delivery-timetable.html','<ng-form name="CheckoutDeliveryForm" class="jf-form jf-no-margin-bottom">\n    <div class="jf-error" ng-if="deliveryTimeSlots && countObjKeys(deliveryTimeSlots) === 0">\n        <p ng-if="origin === \'my-orders\'">{{\'NO_AVAILABLE_APPOINTMENTS_FOR_ADDRESS_ORDER_EDIT\' | translate}}</p>\n        <p ng-if="origin === \'checkout\'" class="jf-no-margin-bottom jf-margin-top-5">{{\'NO_AVAILABLE_APPOINTMENTS_FOR_ADDRESS_NO_PLZ_AVAILABLE\' | translate}}</p>\n    </div>\n    <div class="jf-scroll-tabs-container" ng-if="countObjKeys(deliveryTimeSlots) > 0">\n        <div class="jf-tabs-hint jf-tabs-hint-left jf-tabs-hint-hidden" ng-click="scrollToLeft()">\n            <i class="material-icons">keyboard_arrow_left</i>\n        </div>\n        <div class="jf-tabs-hint jf-tabs-hint-right jf-tabs-hint-hidden" ng-click="scrollToRight()">\n            <i class="material-icons">keyboard_arrow_right</i>\n        </div>\n        <md-tabs md-dynamic-height md-center-tabs md-no-pagination jf-product-tabs-scroll class="jf-tabs jf-trip-tabs"\n                 md-selected="selectedDeliveryDay"\n                 ng-class="{ \'jf-editing\': origin !== \'checkout\' }"\n        >\n            <md-tab ng-repeat="(weekday, weekdayDetails) in deliveryTimeSlots">\n                <md-tab-label>\n                    <div class="jf-trip-weekday-name">{{ weekday | date: \'EEE\' | translate }}</div>\n                    <div class="jf-trip-weekday-number">{{ weekday | date: \'dd\' }}</div>\n                </md-tab-label>\n                <md-tab-body>\n                    <div layout layout-xs="column" class="jf-trip-weekday-container">\n                        <div ng-if="limit !== 0 || $mdMedia(\'gt-sm\')" ng-repeat="limit in [Math.floor(weekdayDetails.length/2) + (weekdayDetails.length % 2), -Math.floor(weekdayDetails.length/2) ] track by $index"\n                             class="jf-trip-weekday-timeslots" flex>\n                            <div ng-repeat="timeslot in weekdayDetails | limitTo : limit"\n                                 class="jf-trip-weekday-timeslot" ng-class="{\'active\' : selectedDeliveryTimeSlot(timeslot)}"\n                                 ng-click="selectDeliveryTime(timeslot)" layout="row" layout-align="start center"\n                            >\n                                <md-icon md-svg-icon="check" ng-if="!timeslot.isClosed"></md-icon>\n                                <div>{{timeslot.attributes.start_time}} - {{timeslot.attributes.end_time}} <span class="jf-time-slot-length">({{getHoursDifference(timeslot.attributes.start_ts, timeslot.attributes.end_ts)}}h)</span></div>\n                                <div class="jf-time-slot-icons">\n                                    <span class="material-icons jf-scheduled-time-slot" ng-if="timeslot.attributes.scheduled === true">beenhere</span>\n                                    <span class="material-icons jf-eco-time-slot" ng-if="timeslot.attributes.eco === true">eco</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <p class="jf-time-slots-icon-description" layout="row" ng-if="daysWithEcoTimeSlots.indexOf(weekday) > -1">\n                        <i class="material-icons jf-eco-time-slot">eco</i>\n                        <span translate>TIME_SLOT_ECO_HINT_TEXT</span>\n                    </p>\n                    <p class="jf-time-slots-icon-description" layout="row" ng-if="daysWithScheduledTimeSlots.indexOf(weekday) > -1">\n                        <i class="material-icons jf-scheduled-time-slot">beenhere</i>\n                        <span translate>TIME_SLOT_SCHEDULED_HINT_TEXT</span>\n                    </p>\n                </md-tab-body>\n            </md-tab>\n        </md-tabs>\n    </div>\n</ng-form>\n');
$templateCache.put('app/components/checkout/directives/jf-apple-pay.directive.html','<div>\n  <div id="jf-apple-pay-container"></div>\n</div>');
$templateCache.put('app/components/checkout/directives/jf-newsletter.html','<div>\n    <md-checkbox class="jf-checkbox md-primary jf-newsletter-checkbox" ng-model="formModel" ng-true-value="true"\n                 ng-false-value="false" ng-change="saveNewsletterCheckbox()"\n                 aria-label="{{\'NEWSLETTER_TRANSLATE\' | translate}}" flex\n    >\n        <md-label>\n            <strong translate>NEWSLETTER_TRANSLATE</strong>\n        </md-label>\n    </md-checkbox>\n</div>\n');
$templateCache.put('app/components/checkout/directives/jf-pay-pal-authorize-form.html','<a ng-click="submitPayPalAuthorizeForm()" class="jf-pp-auth-link">{{\'AUTHORIZE_PAY_PAL_PAYMENT\' | translate}}</a>\n<p class="jf-pp-error jf-error" ng-if="showAuthorizationError">{{\'AUTHORIZE_PAY_PAL_PAYMENT_ERROR\' | translate}}</p>');
$templateCache.put('app/components/checkout/directives/jf-sepa-payment.directive.html','<div class="jf-input-wrapper" ng-class="{\'jf-input-wrapper-light\': !accountView}">\n    <div class="jf-form-subheadline" ng-if="accountView">{{\'ADD_SEPA_CONNECTION\'| translate}}</div>\n    <div id="jf-sepa-container"></div>\n</div>\n\n<div layout-gt-sm="row">\n    <p ng-repeat="error in genericErrors" class="jf-error jf-no-margin-bottom">{{error.detail}}</p>\n</div>\n<md-button class="jf-button jf-button-slim md-raised md-accent" ng-click="saveSepa()"\n            aria-label="{{\'SAVE\' | translate}}" ng-disabled="disableSepaSubmitButton()"\n            ng-if="!showCancelButton" id="my-account-save-sepa"\n>\n    {{\'SAVE\' | translate}}\n</md-button>\n\n<div layout layout-align="center start" ng-if="showCancelButton">\n    <div hide-xs flex="30">\n        <md-button class="jf-button" ng-click="cancelCallback()"\n            aria-label="{{\'CANCEL\' | translate}}" id="my-account-save-sepa-cancel"\n        >\n            {{\'CANCEL\' | translate}}\n        </md-button>\n    </div>\n    <span flex></span>\n    <div flex-xs="100" flex-gt-xs="30">\n        <md-button type="submit" class="jf-button md-raised md-accent" ng-click="saveSepa()" ng-disabled="disableSepaSubmitButton()" aria-label="{{\'SAVE\' | translate}}" id="my-account-save-sepa">\n            {{\'SAVE\' | translate}}\n        </md-button>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/directives/payment-methods.html','<div>\n    <div ng-show="displayPaymentMethods() === false" class="jf-disabled">{{\'NO_ADDRESS_ADDED\' | translate}}</div>\n    <div class="jf-payment-methods-wrapper" ng-show="displayPaymentMethods() === true">\n        <div class="jf-form jf-checkout-component">\n            <jf-spinner ng-if="jfShared.spinner.isLoading(\'checkout-payment-methods\')" spinner-position="20"></jf-spinner>\n            <div layout-gt-sm="column">\n                <p ng-if="parcelServiceEnabled" class="jf-payment-methods-manager-parcel-info">{{\'PARCEL_SERVICE_ENABLED_PAYMENT_INFO\' | translate}}</p>\n                <p ng-if="!allowPaymentMethodEdits && !parcelServiceEnabled" class="jf-payment-methods-manager-parcel-info">{{\'PAYMENT_METHODS_EDIT_NOT_ALLOWED\' | translate}}</p>\n                <div ng-if="companyPays" class="jf-company-payment-method">{{\'PAYMENT_DONE_BY_COMPANY\' | translate}} <strong>{{companyName}}</strong></div>\n                <p class="jf-payment-covered-by-coupon" ng-if="showCouponCoversTheOrderInfo()">{{\'PAYMENT_COVERED_BY_COUPON_INFO\' | translate}}</p>\n                <div ng-show="allowPaymentMethodEdits">\n                    <md-radio-group ng-model="selectedPaymentMethod" ng-change="changePaymentMethod()" class="jf-payment-methods">\n                        <div ng-repeat="paymentMethod in visiblePaymentMethods" layout="column" layout-align="space-between start" class="jf-payment-method jf-payment-method-{{paymentMethod.abbreviation}}"\n                            ng-class="{\'jf-payment-method-app-available\': (paymentMethod.id === paymentMethods.app && showApplePay) || (paymentMethod.id === paymentMethods.app && jfShared.checkout.userBillingAgreements.app.length > 0)}"\n                        >\n                            <md-radio-button ng-value="paymentMethod.id" class="jf-radio-button md-primary"\n                                ng-if="displayPaymentMethod(paymentMethod)"\n                            >\n                                <md-label class="jf-payment-method-label" row layout="column">\n                                    <strong>\n                                        <i class="jf-grey-icon jf-grey-icon-cash" ng-if="paymentMethod.id === paymentMethods.cash"></i>\n                                        <i class="jf-grey-icon jf-grey-icon-cc" ng-if="paymentMethod.id === paymentMethods.creditCard"></i>\n                                        <i class="jf-grey-icon jf-grey-icon-paypal" ng-if="paymentMethod.id === paymentMethods.payPalAfterPayment"></i>\n                                        <i class="jf-grey-icon jf-grey-icon-sepa" ng-if="paymentMethod.id === paymentMethods.sepa"></i>\n                                        <i class="jf-grey-icon jf-grey-icon-apple-pay" ng-if="paymentMethod.id === paymentMethods.app"></i>\n                                        {{paymentMethod.name}}\n                                    </strong>\n                                </md-label>\n                            </md-radio-button>\n\n                            <p ng-if="paymentMethod.name === monthlyInvoiceName &&\n                                selectedPaymentMethod === paymentMethod.id" class="jf-adyen-auth-info jf-checkout-info-icon-large"\n                            ng-click="showMonthlyInvoiceInfoPopup()"\n                            >\n                                <i class="material-icons">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <p ng-if="paymentMethod.name !== monthlyInvoiceName &&\n                                paymentMethod.id === paymentMethods.cash &&\n                                selectedPaymentMethod === paymentMethod.id" class="jf-adyen-auth-info jf-checkout-info-icon-large"\n                            ng-click="showCashInfoPopup()"\n                            >\n                                <i class="material-icons">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <p ng-if="paymentMethod.id === paymentMethods.payPalAfterPayment &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                jfShared.checkout.userBillingAgreements.payPal.length === 0" class="jf-adyen-auth-info jf-checkout-info-icon-large"\n                            ng-click="showPayPalAuthorizationInfoPopup()"\n                            >\n                                <i class="material-icons">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n                            <p ng-if="paymentMethod.id === paymentMethods.payPalAfterPayment &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                jfShared.checkout.userBillingAgreements.payPal.length > 0" class="jf-adyen-auth-info jf-checkout-info-icon-large jf-checkout-info-icon-large-authorized"\n                            ng-click="showPayPalAuthorizedInfoPopup()"\n                            >\n                                <i class="material-icons jf-adyen-authorized">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <jf-pay-pal-authorize-form ng-if="paymentMethod.id === paymentMethods.payPalAfterPayment &&\n                                                            jfShared.checkout.userBillingAgreements.payPal.length === 0 &&\n                                                            selectedPaymentMethod === paymentMethod.id && allowPaymentMethodEdits"\n                                                    country="creditCardFormCountry"\n                            >\n                            </jf-pay-pal-authorize-form>\n\n                            <p ng-if="paymentMethod.id === paymentMethods.creditCard &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                showCreditCardsForm === false &&\n                                jfShared.checkout.userBillingAgreements.cc.length > 0 &&\n                                allowPaymentMethodEdits" class="jf-show-add-new-cc-form"\n                            >\n                                <i class="material-icons jf-adyen-authorized" ng-click="toggleCreditCardForm()">add_circle</i>\n                            </p>\n\n                            <p ng-if="paymentMethod.id === paymentMethods.creditCard &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                showCreditCardsForm === true &&\n                                jfShared.checkout.userBillingAgreements.cc.length === 0" class="jf-adyen-auth-info jf-checkout-info-icon-large"\n                                ng-click="showCCAuthorizationInfoPopup()"\n                            >\n                                <i class="material-icons">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <p ng-if="paymentMethod.id === paymentMethods.creditCard &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                jfShared.checkout.userBillingAgreements.cc.length > 0" class="jf-adyen-auth-info jf-checkout-info-icon-large jf-checkout-info-icon-large-authorized"\n                            ng-click="showCCAuthorizedInfoPopup()"\n                            >\n                                <i class="material-icons jf-adyen-authorized">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <div ng-if="showCreditCardsForm && paymentMethod.id === paymentMethods.creditCard" class="jf-checkout-new-credit-card-form-container">\n                                <form name="creditCardForm" class="jf-form jf-checkout-new-credit-card-form" novalidate>\n                                    <account-credit-card-form hide-cancel-button="true" hide-header="true" form="creditCardForm"\n                                                            save-callback="creditCardSaveCallback" country="creditCardFormCountry"\n                                    ></account-credit-card-form>\n                                    <p class="jf-close-cc-form" ng-show="jfShared.checkout.userBillingAgreements.cc.length > 0">\n                                        <a ng-click="toggleCreditCardForm()">{{\'CHECKOUT_NEW_CC_FORM_CLOSE\' | translate}}</a>\n                                    </p>\n                                </form>\n                            </div>\n\n                            <div ng-if="showCreditCardsSelector && paymentMethod.id === paymentMethods.creditCard" class="jf-select-credit-card">\n                                <ng-form name="creditCardSelectorForm" class="jf-form" novalidate>\n                                    <span class="jf-checkout-box-separator"></span>\n                                    <md-radio-group ng-model="$parent.$parent.selectedCreditCard" ng-change="changeSelectedCreditCard()" class="jf-credit-cards-selector">\n                                        <div ng-repeat="creditCard in jfShared.checkout.userBillingAgreements.cc" layout="row" layout-align="space-between start">\n                                            <md-radio-button ng-value="creditCard.id + \'|\' + creditCard.attributes.variant" class="jf-radio-button md-primary">\n                                                <md-label row layout="column">\n                                                    <strong>\n                                                        <i class="jf-grey-icon jf-grey-icon-visa" ng-if="creditCard.attributes.variant === \'visa\'"></i>\n                                                        <i class="jf-grey-icon jf-grey-icon-mc" ng-if="creditCard.attributes.variant === \'mc\'"></i>\n                                                        <i class="jf-grey-icon jf-grey-icon-cc" ng-if="[\'visa\', \'mc\'].indexOf(creditCard.attributes.variant) === -1"></i>\n                                                        ************{{creditCard.attributes.payment_info.card.number}}, {{creditCard.attributes.payment_info.card.holderName}}\n                                                    </strong>\n                                                </md-label>\n                                            </md-radio-button>\n                                        </div>\n                                    </md-radio-group>\n                                    <span class="jf-checkout-box-separator"></span>\n                                </ng-form>\n                            </div>\n\n                            <p ng-if="paymentMethod.id === paymentMethods.sepa &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                jfShared.checkout.userBillingAgreements.sepa.length === 0" class="jf-adyen-auth-info jf-checkout-info-icon-large"\n                            ng-click="showSepaAuthorizationInfoPopup()"\n                            >\n                                <i class="material-icons">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <p ng-if="paymentMethod.id === paymentMethods.sepa &&\n                                selectedPaymentMethod === paymentMethod.id &&\n                                jfShared.checkout.userBillingAgreements.sepa.length > 0" class="jf-adyen-auth-info jf-checkout-info-icon-large jf-checkout-info-icon-large-authorized"\n                            ng-click="showSepaAuthorizedInfoPopup()"\n                            >\n                                <i class="material-icons jf-adyen-authorized">error_outline</i>\n                                <span>{{\'INFO_BUTTON\' | translate}}</span>\n                            </p>\n\n                            <div ng-if="selectedPaymentMethod === paymentMethod.id && paymentMethod.id === paymentMethods.sepa && allowPaymentMethodEdits" class="jf-checkout-sepa-container">\n                                <jf-sepa-payment country="sepaFormCountry" ng-if="jfShared.checkout.userBillingAgreements.sepa === null || jfShared.checkout.userBillingAgreements.sepa.length === 0"></jf-sepa-payment>\n                            </div>\n\n                            <div ng-if="!mobileAppMode &&\n                                        paymentMethod.id === paymentMethods.app &&\n                                        (jfShared.checkout.userBillingAgreements.app === null || jfShared.checkout.userBillingAgreements.app.length === 0) && \n                                        allowPaymentMethodEdits"\n                                class="jf-checkout-apple-pay-container">\n                                <jf-apple-pay ng-show="selectedPaymentMethod === paymentMethod.id && paymentMethod.id === paymentMethods.app"></jf-apple-pay>\n                            </div>\n                        </div>\n                    </md-radio-group>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/checkout/directives/pickup-notes.html','<div>\n    <md-input-container class="jf-input-container md-block" md-no-float>\n        <textarea md-no-autogrow class="jf-pickup-note" name="pickupNote" rows="4" ng-model="order.additionalInfo.pickupNote"\n                  ng-focus="sendGAEvent(\'checkoutPage\', \'pickupNoteTextarea\')" ng-change="savePickupNote()"\n                  ng-attr-placeholder="{{\'PICKUP_NOTES_PLACEHOLDER\' | translate}}"\n        ></textarea>\n    </md-input-container>\n</div>');
$templateCache.put('app/components/checkout/directives/pickup-timetable.html','<ng-form name="CheckoutPickupForm" class="jf-form jf-no-margin-bottom">\n    <div class="jf-error" ng-if="pickupTimeSlots && countObjKeys(pickupTimeSlots) === 0">\n        <p ng-if="origin === \'my-orders\'">{{\'NO_AVAILABLE_APPOINTMENTS_FOR_ADDRESS_ORDER_EDIT\' | translate}}</p>\n        <p ng-if="origin === \'checkout\'" class="jf-no-margin-bottom jf-margin-top-5">{{\'NO_AVAILABLE_APPOINTMENTS_FOR_ADDRESS_NO_PLZ_AVAILABLE\' | translate}}</p>\n    </div>\n    <div class="jf-scroll-tabs-container" ng-if="countObjKeys(pickupTimeSlots) > 0">\n        <div class="jf-tabs-hint jf-tabs-hint-left jf-tabs-hint-hidden" ng-click="scrollToLeft()">\n            <i class="material-icons">keyboard_arrow_left</i>\n        </div>\n        <div class="jf-tabs-hint jf-tabs-hint-right jf-tabs-hint-hidden" ng-click="scrollToRight()">\n            <i class="material-icons">keyboard_arrow_right</i>\n        </div>\n        <md-tabs md-dynamic-height md-center-tabs md-no-pagination jf-product-tabs-scroll class="jf-tabs jf-trip-tabs"\n                 md-selected="selectedPickupDay"\n                 ng-class="{ \'jf-editing\': origin !== \'checkout\' }"\n        >\n            <md-tab ng-repeat="(weekday, weekdayDetails) in pickupTimeSlots">\n                <md-tab-label>\n                    <div class="jf-trip-weekday-name">{{ weekday | date: \'EEE\' | translate}}</div>\n                    <div class="jf-trip-weekday-number">{{ weekday | date: \'dd\' }}</div>\n                </md-tab-label>\n                <md-tab-body>\n                    <div layout layout-xs="column" class="jf-trip-weekday-container">\n                        <div ng-if="limit !== 0 || $mdMedia(\'gt-sm\')" ng-repeat="limit in [Math.floor(weekdayDetails.length/2) + (weekdayDetails.length % 2), -Math.floor(weekdayDetails.length/2) ] track by $index"\n                             class="jf-trip-weekday-timeslots" flex>\n                            <div ng-repeat="timeslot in weekdayDetails | limitTo : limit"\n                                 class="jf-trip-weekday-timeslot" ng-class="{\'active\' : selectedPickupTimeSlot(timeslot)}"\n                                 ng-click="selectPickupTime(timeslot)" layout="row" layout-align="start center"\n                            >\n                                <md-icon md-svg-icon="check" ng-if="!timeslot.isClosed"></md-icon>\n                                <div>{{timeslot.attributes.start_time}} - {{timeslot.attributes.end_time}} <span class="jf-time-slot-length">({{getHoursDifference(timeslot.attributes.start_ts, timeslot.attributes.end_ts)}}h)</span></div>\n                                <div class="jf-time-slot-icons">\n                                    <span class="material-icons jf-scheduled-time-slot" ng-if="timeslot.attributes.scheduled === true">beenhere</span>\n                                    <span class="material-icons jf-eco-time-slot" ng-if="timeslot.attributes.eco === true">eco</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <p class="jf-time-slots-icon-description" layout="row" ng-if="daysWithEcoTimeSlots.indexOf(weekday) > -1">\n                        <i class="material-icons jf-eco-time-slot">eco</i>\n                        <span translate>TIME_SLOT_ECO_HINT_TEXT</span>\n                    </p>\n                    <p class="jf-time-slots-icon-description" layout="row" ng-if="daysWithScheduledTimeSlots.indexOf(weekday) > -1">\n                        <i class="material-icons jf-scheduled-time-slot">beenhere</i>\n                        <span translate>TIME_SLOT_SCHEDULED_HINT_TEXT</span>\n                    </p>\n                </md-tab-body>\n            </md-tab>\n        </md-tabs>\n    </div>\n    <p class="jf-delivery-time-info" ng-show="showDeliveryTimeClearedInfo && $mdMedia(\'gt-xs\')"><md-icon md-svg-icon="info" aria-label="{{\'DELIVER_TIME_CLEARED_INFO\' | translate}}"></md-icon> {{\'DELIVER_TIME_CLEARED_INFO\' | translate}}</p>\n</ng-form>\n');
$templateCache.put('app/components/checkout/directives/special-instructions.html','<md-input-container class="jf-input-container md-block" md-no-float>\n    <textarea md-no-autogrow class="jf-special-note" name="specialInstructions" rows="4"\n              ng-model="order.additionalInfo.specialInstructions" ng-change="saveSpecialInstructionsNote()"\n              ng-focus="sendGAEvent(\'checkoutPage\', \'specialInstructionsNoteTextarea\')"\n              ng-attr-placeholder="{{\'SPECIAL_INSTRUCTIONS_PLACEHOLDER\' | translate}}"\n    ></textarea>\n</md-input-container>\n');
$templateCache.put('app/components/checkout/steps/checkout.addresses-edit-address.html','<div class="jf-container jf-container--small" ng-controller="CheckoutAddressController">\n    <account-address cancel-callback="addNewAddressCancelCallback" submit-callback="addNewAddressSubmitCallback" manageable-preferred="false"></account-address>\n</div>');
$templateCache.put('app/components/checkout/steps/checkout.addresses-new-address.html','<div class="jf-container jf-container--small" ng-controller="CheckoutAddressController">\n    <account-address cancel-callback="addNewAddressCancelCallback" submit-callback="addNewAddressSubmitCallback" manageable-preferred="false"></account-address>\n</div>');
$templateCache.put('app/components/checkout/steps/checkout.addresses.html','<div ng-class="{\'jf-container\' : $mdMedia(\'xs\')}" ng-controller="CheckoutAddressController">\n    <div class="jf-form">\n        <div ng-class="{\'jf-checkout-mobile-container\': !mobileCheckoutPreview && $mdMedia(\'xs\')}">\n            <md-button class="jf-button md-raised md-accent" aria-label="{{ \'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate }}"\n                       ui-sref="checkout({stepBack: true})" ng-if="!mobileCheckoutPreview && currentState.name !== \'checkout\'"\n            >\n                <span class="jf-button-back-icon"><i class="material-icons">forward</i></span> {{\'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate}}\n            </md-button>\n            <account-address ng-if="editAddressForm" cancel-callback="addNewAddressCancelOnePageCheckoutCallback" submit-callback="editAddressSubmitOnePageCheckoutCallback" manageable-preferred="false"></account-address>\n            <account-address ng-if="newAddressForm" cancel-callback="addNewAddressCancelOnePageCheckoutCallback" new-address-form="newAddressForm" submit-callback="newAddressSubmitOnePageCheckoutCallback"></account-address>\n            <md-button class="jf-button md-raised md-accent" aria-label="{{ \'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate }}"\n                       ui-sref="checkout({stepBack: true})" ng-if="!mobileCheckoutPreview && currentState.name !== \'checkout\'"\n            >\n                <span class="jf-button-back-icon"><i class="material-icons">forward</i></span> {{\'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate}}\n            </md-button>\n            <jf-spinner ng-if="(editAddressForm || newAddressForm) && jfShared.spinner.isLoading([\'checkout-addresses-add-edit\', \'account-my-addresses\'])" spinner-position="10"></jf-spinner>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/checkout/steps/checkout.notes.html','<div class="jf-container jf-checkout-mobile-container">\n    <md-button class="jf-button md-raised md-accent" aria-label="{{ \'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate }}"\n               ui-sref="checkout({stepBack: true})"\n    >\n        <span class="jf-button-back-icon"><i class="material-icons">forward</i></span> {{\'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate}}\n    </md-button>\n    <div ng-if="showNotes" class="jf-checkout-box" flex flex-sm="100">\n        <div class="jf-checkout-box-title">\n            {{\'PICKUP_NOTES\' | translate}}\n        </div>\n        <div class="jf-checkout-box-content">\n            <pickup-notes></pickup-notes>\n        </div>\n    </div>\n    <div ng-if="showNotes" class="jf-checkout-box" flex>\n        <div class="jf-checkout-box-title">\n            {{\'DELIVERY_NOTES\' | translate}}\n        </div>\n        <div class="jf-checkout-box-content">\n            <delivery-notes></delivery-notes>\n        </div>\n    </div>\n    <div class="jf-checkout-box" flex>\n        <div class="jf-checkout-box-title">\n            {{\'SPECIAL_INSTRUCTIONS_SHORT\' | translate}}\n        </div>\n        <div class="jf-checkout-box-content">\n            <special-instructions></special-instructions>\n        </div>\n    </div>\n    <md-button class="jf-button md-raised md-accent" aria-label="{{ \'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate }}"\n               ui-sref="checkout({stepBack: true})"\n               ng-if="showNotes"\n    >\n        <span class="jf-button-back-icon"><i class="material-icons">forward</i></span> {{\'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate}}\n    </md-button>\n</div>');
$templateCache.put('app/components/checkout/steps/checkout.pickup-delivery.html','<div ng-class="{\'jf-container\' : $mdMedia(\'xs\'), \'jf-checkout-mobile-container\': $mdMedia(\'xs\')}" ng-controller="CheckoutPickupDeliveryController">\n    <md-button class="jf-button md-raised md-accent" aria-label="{{ \'CONFIRM_ORDER\' | translate }}"\n               ui-sref="checkout({stepBack: true})"\n    >\n        <span class="jf-button-back-icon"><i class="material-icons">forward</i></span> {{\'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate}}\n    </md-button>\n    <form name="CheckoutPickupDeliveryForm" class="jf-form">\n        <pickup-timetable order="order" origin="checkout" ng-if="$mdMedia(\'xs\') && $state.params.showPickup"></pickup-timetable>\n        <delivery-timetable order="order" origin="checkout" ng-if="$mdMedia(\'xs\') && $state.params.showDelivery"></delivery-timetable>\n        <p class="jf-error" ng-show="timesError" translate>SELECT_PICKUP_DELIVERY_TIMES</p>\n        <special-instructions ng-show="$mdMedia(\'gt-xs\')"></special-instructions>\n        <div layout>\n            <div hide-xs flex="20">\n                <md-button class="jf-button jf-go-to-checkout-step-1" ng-click="backToAddressStep()" aria-label="{{\'BACK\' | translate}}">\n                    {{\'BACK\' | translate}}\n                </md-button>\n            </div>\n            <span flex></span>\n        </div>\n    </form>\n    <md-button class="jf-button md-raised md-accent" aria-label="{{ \'CONFIRM_ORDER\' | translate }}"\n               ui-sref="checkout({stepBack: true})"\n    >\n        <span class="jf-button-back-icon"><i class="material-icons">forward</i></span> {{\'BACK_TO_MOBILE_CHECKOUT_MAIN_VIEW\' | translate}}\n    </md-button>\n\n    <jf-spinner ng-if="jfShared.spinner.isLoading([\'checkout-time-slots-picker\', \'checkout-time-slots-picker\'])"></jf-spinner>\n</div>\n');
$templateCache.put('app/components/checkout/steps/checkout.success.html','<div class="jf-container jf-checkout-container jf-one-page-checkout">\n        <div class="jf-spacer-15" hide-xs></div>\n        <div layout-sm="column" layout-gt-sm="row" layout-align="space-between stretch">\n            <div flex="100" flex-order-sm="2" layout="column">\n                <div class="jf-form">\n                    <div id="success">\n                        <div layout="column" layout-align="center center">\n                            <div class="jf-spacer-15" ng-show="$mdMedia(\'gt-sm\')"></div>\n                            <div class="jf-headline" translate>THANK_YOU_FOR_ORDER</div>\n                            <span class="jf-subtitle" translate>EMAIL_ORDER_CONFIRMATION</span>\n                            <div class="jf-spacer-45" ng-hide="$mdMedia(\'xs\')"></div>\n                            <div class="jf-spacer-30" ng-hide="$mdMedia(\'gt-xs\')"></div>\n                            <div layout="row" layout-xs="column" layout-fill>\n                                <ng-include flex src="\'app/components/checkout/partials/checkout-success-data.tpl.html\'"></ng-include>\n                                <div class="jf-spacer-30" ng-show="$mdMedia(\'xs\')"></div>\n                                <span flex="5"></span>\n                                <ng-include flex src="\'app/components/checkout/partials/checkout-success-notes.tpl.html\'"></ng-include>\n                            </div>\n                            <div class="jf-spacer-30">&nbsp;</div>\n                            <div layout="row" layout-xs="column" layout-fill>\n                                <ng-include flex src="\'app/components/checkout/partials/checkout-success-items.tpl.html\'"></ng-include>\n                            </div>\n                            <jf-survey-loader ng-if="commitedOrderSummary"></jf-survey-loader>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>');
$templateCache.put('app/components/account/forms/account.forgot-password.html','<form name="accountForgotPasswordForm" class="jf-form jf-form--light" novalidate\n      ng-submit="submitForgottenPassword(accountForgotPasswordForm)" ng-controller="ForgottenPasswordFormCtrl">\n    <div class="jf-page-logo">\n        <img src="assets/img/jf-logo-white-slogan.png" width="220" alt="Jonny Fresh">\n    </div>\n    <div class="jf-page-subheadline" translate>FORGOT_PASSWORD_SUBHEADLINE</div>\n    <p><strong translate>FORGOT_PASSWORD_HINT</strong></p>\n\n    <div class="jf-input-wrapper">\n        <md-input-container ng-if="!emailSent" class="jf-input-container md-block" flex>\n            <input type="email" name="email_address" ng-model="user.email_address" required\n                   ng-pattern="/^.+@.+\\..+$/"\n                   ng-keydown="accountForgotPasswordForm.email_address.$error.notExists ? accountForgotPasswordForm.email_address.$setValidity(\'notExists\', true) : null">\n            <label>{{\'EMAIL_ADDRESS\' | translate}}</label>\n            <div ng-messages="accountForgotPasswordForm.email_address.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="email" translate>EMAIL_ADDRESS_INVALID</div>\n                <div ng-message="pattern" translate>EMAIL_ADDRESS_INVALID</div>\n                <div ng-message="notExists" translate>USER_DOES_NOT_EXIST</div>\n            </div>\n        </md-input-container>\n        <p class="jf-success jf-success-strong" ng-if="emailSent" translate>FORGOT_PASSWORD_SUCCESS</p>\n    </div>\n    <div layout="row" layout-align="start center">\n        <div flex class="jf-mandatory-field">\n            <div translate>MANDATORY_FIELD</div>\n        </div>\n    </div>\n\n    <md-button type="submit" ng-show="!emailSent" class="jf-button jf-mark-button md-raised md-accent jf-forgot-password-page-send-button" aria-label="{{\'SEND_BUTTON\' | translate}}">{{\'SEND_BUTTON\' | translate}}</md-button>\n\n    <div class="jf-form-button-container">\n        <md-button ui-sref="register({redirect: $state.params.redirect})" class="jf-button jf-mark-button md-raised jf-blue-button" aria-label="{{\'REGISTER_BUTTON\' | translate}}">{{\'REGISTER_BUTTON\' | translate}}</md-button>\n        <div class="jf-button-container">\n            <md-button ui-sref="login({stepBack: true})" class="jf-button jf-mark-button md-raised jf-blue-button" ng-click="sendGAEvent(\'forgotPasswordPage\', \'backButton\')" aria-label="{{\'LOGIN_BUTTON\' | translate}}">{{\'LOGIN_BUTTON\' | translate}}</md-button>\n        </div>\n    </div>\n\n    <div layout="row" layout-align="start center" ng-if="mobileAppMode">\n        <div flex class="location-picker-link">\n            <a ui-sref="location-picker" ng-click="sendGAEvent(\'forgotPasswordPage\', \'locationPickerLink\')" aria-label="{{\'GOTO_WEBSITE\' | translate}}">{{\'GOTO_WEBSITE\' | translate}}</a>\n        </div>\n    </div>\n    <div layout="row" layout-align="start center" ng-if="!mobileAppMode">\n        <div flex class="goto-website-link">\n            <a href="{{blogUrl}}{{\'PRIVATE_CUSTOMERS_URL\' | translate}}" ng-click="sendGAEvent(\'forgotPasswordPage\', \'gotoWebsiteLink\')" aria-label="{{\'GOTO_WEBSITE\' | translate}}">{{\'GOTO_WEBSITE\' | translate}}</a>\n        </div>\n    </div>\n</form>\n');
$templateCache.put('app/components/account/forms/account.login.html','<form name="accountLoginForm" class="jf-form jf-form--light jf-password-login-form" novalidate ng-controller="LoginFormCtrl">\n    <p class="jf-success jf-success-strong" ng-if="password_changed" translate>PASSWORD_CHANGED</p>\n    <p class="jf-success jf-success-strong" ng-if="account_deleted" translate>ACCOUNT_DELETED</p>\n    <div class="jf-page-subheadline" translate ng-if="$mdMedia(\'gt-xs\')">JONNY_FRESH_LOGIN</div>\n\n    <div class="jf-input-wrapper jf-form-without-subheadline">\n        <md-input-container class="jf-input-container md-block" flex>\n            <input type="email" name="email_address" ng-model="user.email_address" required\n                   ng-pattern="/^.+@.+\\..+$/" aria-label="{{\'EMAIL_ADDRESS\' | translate}}"\n                   ng-keydown="accountLoginForm.email_address.$error.notExists ? accountLoginForm.email_address.$setValidity(\'notExists\', true) : null">\n            <label>{{\'EMAIL_ADDRESS\' | translate}}</label>\n            <div ng-messages="accountLoginForm.email_address.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="email" translate>EMAIL_ADDRESS_INVALID</div>\n                <div ng-message="pattern" translate>EMAIL_ADDRESS_INVALID</div>\n                <div ng-message="notExists" translate>USER_DOES_NOT_EXIST</div>\n            </div>\n        </md-input-container>\n        <md-input-container class="jf-input-container md-block" flex="100">\n            <input type="password" name="password" ng-model="user.password" required\n                   ng-minlength="6" aria-label="{{\'PASSWORD_PLACEHOLDER\' | translate}}"\n                   ng-keydown="accountLoginForm.password.$error.badPassword ? accountLoginForm.password.$setValidity(\'badPassword\', true) : null">\n            <label>{{\'PASSWORD_PLACEHOLDER\' | translate}}</label>\n            <div ng-messages="accountLoginForm.password.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="badPassword" translate>PASSWORD_NOT_CORRECT</div>\n                <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n            </div>\n        </md-input-container>\n    </div>\n\n    <div layout="row" layout-align="start center">\n        <div flex class="jf-mandatory-field">\n            <div translate>MANDATORY_FIELD</div>\n        </div>\n        <div flex class="forgot-password-link">\n            <a ui-sref="forgot_password" ng-click="sendGAEvent(\'loginPage\', \'forgotPasswordLink\')" translate>FORGOT_PASSWORD</a>\n        </div>\n    </div>\n\n    <md-button type="submit" ng-click="submitLogin(accountLoginForm)" class="jf-button jf-mark-button md-raised md-accent jf-login-button" aria-label="{{\'PAGE_TITLE_LOGIN\' | translate}}">{{\'PAGE_TITLE_LOGIN\' | translate}}</md-button>\n\n    <div class="jf-button-container">\n        <md-button ng-click="navigateToRegistrationPage()" class="jf-button jf-mark-button md-raised jf-blue-button" ng-click="sendGAEvent(\'loginPage\', \'registerLink\')" aria-label="{{\'REGISTER_BUTTON\' | translate}}">{{\'REGISTER_BUTTON\' | translate}}</md-button>\n    </div>\n</form>\n');
$templateCache.put('app/components/account/forms/account.on-boarding.html','<div class="jf-on-boarding-block jf-form--light">\n    <div class="jf-page-logo">\n        <img src="assets/img/jf-logo-white-slogan.png" width="220" alt="Jonny Fresh">\n    </div>\n    <div class="jf-page-subheadline" translate="WELCOME_COMPANY_HEADLINE" translate-values="{ companyName: companyName }"></div>\n\n    <div class="jf-marketing-block-for-company"></div>\n    <jf-company-addresses ga-event-section="onBoardingPage"></jf-company-preferences>\n</div>');
$templateCache.put('app/components/account/forms/account.password-reset.html','<form name="accountPasswordResetForm" class="jf-form jf-form--light" novalidate\n      ng-submit="submitPasswordReset(accountPasswordResetForm)" ng-controller="PasswordResetFormCtrl">\n    <div class="jf-page-logo">\n        <img src="assets/img/jf-logo-white-slogan.png" width="220" alt="Jonny Fresh">\n    </div>\n    <div class="jf-page-subheadline" translate>FORGOT_PASSWORD_SUBHEADLINE</div>\n    <p><strong translate>PASSWORD_RESET_HINT</strong></p>\n\n    <div class="jf-input-wrapper">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'NEW_PASSWORD\' | translate}}</label>\n            <input type="password" name="password" ng-model="user.password" required ng-minlength="6">\n            <div ng-messages="accountPasswordResetForm.password.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n            </div>\n        </md-input-container>\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'CONFIRM_NEW_PASSWORD\' | translate}}</label>\n            <input type="password" name="password_confirmation" ng-model="user.password_confirmation" jf-compare-to="user.password" required ng-minlength="6">\n            <div ng-messages="accountPasswordResetForm.password_confirmation.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n                <div ng-message="compareTo" translate>PASSWORDS_DONT_MATCH</div>\n            </div>\n        </md-input-container>\n    </div>\n    <div layout="row" layout-align="start center">\n        <div flex class="jf-mandatory-field">\n            <div translate>MANDATORY_FIELD</div>\n        </div>\n    </div>\n\n    <md-button type="submit" class="jf-button md-raised md-accent" aria-label="{{\'SAVE\' | translate}}">{{\'SAVE\' | translate}}</md-button>\n\n    <div class="jf-form-button-container">\n        <md-button ui-sref="register({redirect: $state.params.redirect})" class="jf-button jf-mark-button  md-raised jf-blue-button" aria-label="{{\'REGISTER_BUTTON\' | translate}}">{{\'REGISTER_BUTTON\' | translate}}</md-button>\n        <div class="jf-button-container">\n            <md-button ui-sref="login({stepBack: true})" class="jf-button jf-mark-button md-raised jf-gray-button" ng-click="sendGAEvent(\'forgotPasswordPage\', \'backButton\')" aria-label="{{\'LOGIN_BUTTON\' | translate}}">{{\'LOGIN_BUTTON\' | translate}}</md-button>\n        </div>\n    </div>\n</form>\n');
$templateCache.put('app/components/account/forms/account.payment-methods.html','<div layout layout-align="center none">\n    <div class="jf-input-wrapper" flex flex-gt-xs="100">\n        <div class="jf-form-subheadline" translate>PAYMENT_METHODS_MANAGER_TITLE</div>\n        <jf-payment-methods-manager></jf-payment-methods-manager>\n        <jf-spinner ng-if="jfShared.spinner.isLoading(\'jf-payment-methods-manager\')" spinner-position="30"></jf-spinner>\n    </div>\n</div>');
$templateCache.put('app/components/account/forms/account.register.html','<form name="registerForm" class="jf-form jf-form--light" novalidate>\n    <account-register-form form="registerForm" form-model="registerFormData" show-register-form="showRegisterForm"\n                           ga-event-section="registerPage"\n    ></account-register-form>\n    <p class="jf-error" ng-repeat="registerError in registerFormErrors">{{registerError.detail}}</p>\n    <div ng-show="showRegisterForm">\n        <md-button type="submit" class="jf-button md-raised jf-mark-button md-accent jf-register-page-register-button"\n            ng-click="submitRegistration(registerForm)" aria-label="{{\'CREATE_JONNY_FRESH_ACCOUNT\' | translate}}"\n        >\n            {{\'CREATE_JONNY_FRESH_ACCOUNT\' | translate}}\n        </md-button>\n\n        <div class="jf-button-container">\n            <md-button ng-click="navigateToLoginPage()" class="jf-button md-raised jf-blue-button jf-mark-button"\n                       aria-label="{{\'LOGIN_BUTTON\' | translate}}" ng-click="sendGAEvent(\'registerPage\', \'loginButton\')"\n            >\n                {{\'LOGIN_BUTTON\' | translate}}\n            </md-button>\n        </div>\n\n        <div layout="row" layout-align="start center" ng-if="mobileAppMode">\n            <div flex class="location-picker-link">\n                <a ui-sref="location-picker" ng-click="sendGAEvent(\'registerPage\', \'locationPickerLink\')" aria-label="{{\'GOTO_WEBSITE\' | translate}}">{{\'GOTO_WEBSITE\' | translate}}</a>\n            </div>\n        </div>\n        <div layout="row" layout-align="start center" ng-if="!mobileAppMode">\n            <div flex class="goto-website-link">\n                <a href="{{blogUrl}}{{\'PRIVATE_CUSTOMERS_URL\' | translate}}" ng-click="sendGAEvent(\'registerPage\', \'gotoWebsiteLink\')" aria-label="{{\'GOTO_WEBSITE\' | translate}}">{{\'GOTO_WEBSITE\' | translate}}</a>\n            </div>\n        </div>\n    </div>\n</form>');
$templateCache.put('app/components/location-picker/footer/location-picker-footer.html','<md-button aria-label="{{ activeLocale.i18n | translate }}" class="jf-language-picker-button" ng-click="openLanguageSwitcher()" ng-if="showSwitcher">\n    <i class="material-icons">keyboard_arrow_up</i>\n    <img class="jf-language-picker-menu-flag" ng-src="{{activeLocale.flagUrl}}" width="18"> {{ activeLocale.i18n | translate }}\n</md-button>');
$templateCache.put('app/components/location-picker/forms/location-picker-form.html','<form name="locationPickerForm" class="jf-form" novalidate ng-controller="LocationPickerFormController">\n    <div flex="100" flex-gt-xs="50" class="location-picker-form-wrapper">\n        <div>\n            <p class="jf-location-picker-headline">{{\'POSTAL_CODE_HEADLINE\'| translate}}</p>\n            <p class="jf-location-picker-subheadline">{{\'POSTAL_CODE_SUBHEADLINE\'| translate}}</p>\n        </div>\n        <span class="arrow"></span>\n        <md-input-container class="jf-input-container md-block" flex md-no-float>\n            <jf-postal-code model="formModel" form="locationPickerForm" selectedtext="selectedPostalCode"\n                            validate-in-service="true" custom-placeholder="POSTAL_CODE_PLACEHOLDER_EXTENDED"\n                            disable-same-city-check="true" show-standard-label="true"\n            >\n            </jf-postal-code>\n            <div class="jf-location-picker-not-in-service-error" ng-if="emptyCatalog">{{\'SERVICE_NOT_WORK_IN_THIS_LOCATION\' | translate}}</div>\n            <div class="md-errors-spacer"></div>\n        </md-input-container>\n        <md-button ng-click="submitLocationPickerForm(locationPickerForm)" class="jf-button jf-button-location-picker md-raised md-accent"\n                aria-label="Show prices"\n        >\n            {{\'SHOW_PRICES\' | translate}}\n        </md-button>\n    </div>\n</form>');
$templateCache.put('app/components/account/directives/account-address-form.html','<div>\n    <br>\n    <div layout-gt-sm="row">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'SALUTATION\' | translate}}</label>\n            <md-select name="title" ng-model="formModel.title" aria-label="{{\'SALUTATION\' | translate}}"\n                       ng-attr-placeholder="{{\'SALUTATION\' | translate}}" required class="md-no-underline"\n            >\n                <md-option value="ms" translate>MRS</md-option>\n                <md-option value="mr" translate>MR</md-option>\n            </md-select>\n            <div class="md-errors-spacer"></div>\n            <div ng-messages="form.title.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n            </div>\n        </md-input-container>\n        <div flex="5" hide-xs hide-sm></div>\n        <div flex class="jf-input-container"></div>\n    </div>\n\n    <div layout-gt-sm="row">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'FIRST_NAME\' | translate}}</label>\n            <input name="first_name" ng-model="formModel.first_name" required>\n            <div ng-messages="form.first_name.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n            </div>\n        </md-input-container>\n\n        <div flex="5" hide-xs hide-sm></div>\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'LAST_NAME\' | translate}}</label>\n            <input name="last_name" ng-model="formModel.last_name" required>\n            <div ng-messages="form.last_name.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n            </div>\n        </md-input-container>\n    </div>\n\n    <div layout-gt-sm="row">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'COMPANY_NAME\' | translate}}</label>\n            <input name="company_name" ng-model="formModel.company_name" >\n        </md-input-container>\n\n        <div flex="5" hide-xs hide-sm></div>\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'DEPARTMENT_NAME_PLACEHOLDER\' | translate}}</label>\n            <input name="department_name" ng-model="formModel.department_name">\n        </md-input-container>\n\n    </div>\n\n    <div layout-gt-sm="row">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'USER_ADDRESS\' | translate}}</label>\n            <input name="address" ng-model="formModel.address" required>\n            <div ng-messages="form.address.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n            </div>\n        </md-input-container>\n        <div flex="5" hide-xs hide-sm></div>\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'NUMBER\' | translate}}</label>\n            <input name="number" ng-model="formModel.number" required>\n            <div ng-messages="form.number.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n            </div>\n        </md-input-container>\n    </div>\n    <div layout-gt-sm="row">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'ADDITIONAL_NUMBER\' | translate}}</label>\n            <input name="additional_number" ng-model="formModel.additional_number">\n        </md-input-container>\n\n        <div flex="5" hide-xs hide-sm></div>\n        <md-input-container class="jf-input-container md-block" flex>\n            <label ng-if="onlyInvoiceAddressChecked">{{\'POSTAL_CODE_PLACEHOLDER\' | translate}}</label>\n            <jf-postal-code ng-if="!onlyInvoiceAddressChecked" model="formModel" form="form" selectedtext="selectedPostalCode"\n            ></jf-postal-code>\n            <input ng-if="onlyInvoiceAddressChecked" name="postal_code"\n                   ng-pattern="/^\\+?\\d+$/"\n                   ng-model="formModel.postal_code"\n                   required\n            >\n            <div ng-messages="form.postal_code.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="pattern" translate>POSTAL_CODE_DIALOG_TITLE</div>\n            </div>\n        </md-input-container>\n    </div>\n\n    <div class="jf-additional-address-fields">\n        <div layout-gt-sm="row" ng-if="onlyInvoiceAddressChecked">\n            <md-input-container class="jf-input-container md-block" flex md-no-float>\n                <md-select name="country_name" ng-model="formModel.country"\n                           ng-attr-placeholder="{{\'COUNTRY\' | translate}} *"  class="md-no-underline" aria-label="{{\'COUNTRY\' | translate}}"\n                           md-no-asterisk="true"\n                           ng-change="assignSelectedCountryCode(formModel.country)"\n                           required>\n                    <md-option ng-repeat="country in countriesArr" value="{{country.name}}">{{country.name}}</md-option>\n                </md-select>\n                <div class="md-errors-spacer"></div>\n                <div ng-messages="form.country_name.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                </div>\n            </md-input-container>\n\n            <div flex="5" hide-xs hide-sm></div>\n\n            <md-input-container class="jf-input-container md-block" flex>\n                <label>{{\'CITY\' | translate}}</label>\n                <input name="city" ng-model="formModel.city" required>\n                <div ng-messages="form.city.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                </div>\n            </md-input-container>\n        </div>\n\n        <div layout-gt-sm="row" ng-if="onlyInvoiceAddressChecked">\n            <md-input-container class="jf-input-container md-block" flex>\n                <label>{{\'PROVINCE\' | translate}}</label>\n                <input name="province" ng-model="formModel.province">\n            </md-input-container>\n            <div flex="5" hide-xs hide-sm></div>\n            <md-input-container class="jf-input-container md-block" flex>\n                <label>{{\'FLOOR_DEPARTMENT\' | translate}}</label>\n                <input name="floor_department" ng-model="formModel.floor_department">\n            </md-input-container>\n        </div>\n\n        <div layout-gt-sm="row" ng-hide="onlyInvoiceAddressChecked">\n            <md-input-container class="jf-input-container md-block" flex>\n                <label>{{\'FLOOR_DEPARTMENT\' | translate}}</label>\n                <input name="floor_department" ng-model="formModel.floor_department">\n            </md-input-container>\n            <div flex="5" hide-xs hide-sm></div>\n            <md-input-container class="jf-input-container md-block" flex>\n                <label>{{\'TELEPHONE_NUMBER\' | translate}}</label>\n                <input type="tel" name="phone_number" ng-model="formModel.phone_number" required\n                       ng-pattern="/^\\+?\\d+$/" ng-maxlength="16"\n                       ng-minlength="8">\n                <div ng-messages="form.phone_number.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                    <div ng-message="maxlength" translate>TELEPHONE_NUMBER_MAX_LENGTH_ERROR</div>\n                    <div ng-message="minlength" translate>TELEPHONE_NUMBER_MIN_LENGTH_ERROR</div>\n                    <div ng-message="pattern" translate>TELEPHONE_NUMBER_INVALID_INPUT</div>\n                </div>\n            </md-input-container>\n        </div>\n    </div>\n\n    <div layout-gt-sm="row" ng-if="onlyInvoiceAddressChecked">\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'TELEPHONE_NUMBER\' | translate}}</label>\n            <input type="tel" name="phone_number" ng-model="formModel.phone_number" required\n                   ng-pattern="/^\\+?\\d+$/" ng-maxlength="16"\n                   ng-minlength="8">\n            <div ng-messages="form.phone_number.$error">\n                <div ng-message="required" translate>REQUIRED</div>\n                <div ng-message="maxlength" translate>TELEPHONE_NUMBER_MAX_LENGTH_ERROR</div>\n                <div ng-message="minlength" translate>TELEPHONE_NUMBER_MIN_LENGTH_ERROR</div>\n                <div ng-message="pattern" translate>TELEPHONE_NUMBER_INVALID_INPUT</div>\n            </div>\n        </md-input-container>\n        <div flex="5" hide-xs hide-sm></div>\n        <md-input-container class="jf-input-container md-block" flex>\n            <label>{{\'COUNTRY_CODE\' | translate}}</label>\n            <input disabled name="country_code"\n                   ng-model="formModel.country_code"\n                   ng-hide="true">\n        </md-input-container>\n    </div>\n    <span translate class="jf-form-required-fields-legend">MANDATORY_FIELD</span>\n    <span translate class="jf-form-required-fields-error" ng-if="!form.$valid && form.$submitted">MISING_REQUIRED_INFO</span>\n</div>\n');
$templateCache.put('app/components/account/directives/account-address.tpl.html','<div ng-if="!isCheckoutView">\n    <div class="jf-spacer-45" hide-xs></div>\n    <div hide-gt-xs>\n        <div class="jf-headline" layout ng-show="!addressToEdit">{{\'ADD_NEW_ADDRESS\' | translate}}</div>\n        <div class="jf-headline" layout ng-show="addressToEdit">{{\'EDIT_ADDRESS\' | translate}}</div>\n        <md-divider></md-divider>\n        <div class="jf-spacer-15"></div>\n    </div>\n</div>\n<form name="accountAddressForm" class="jf-form jf-input-wrapper" ng-class="{\'jf-checkout-view\': isCheckoutView}" novalidate ng-submit="submitAddressForm(accountAddressForm)">\n    <div class="jf-form-subheadline" ng-show="!addressToEdit">\n        {{\'ADD_NEW_ADDRESS\' | translate}}\n        <i class="material-icons" ng-click="addNewAddressCancelOnePageCheckoutCallback()" ng-if="isCheckoutView">cancel</i>\n    </div>\n    <div class="jf-form-subheadline" ng-show="addressToEdit">\n        {{\'EDIT_ADDRESS\' | translate}}\n        <i class="material-icons" ng-click="editAddressCancelOnePageCheckoutCallback()" ng-if="isCheckoutView">cancel</i>\n    </div>\n\n    <div layout-gt-sm="row" ng-show="manageablePreferred !== false && hidePreferredAddresses === false">\n        <md-input-container class="jf-input-container md-block jf-preferred-addresses-selector" flex md-no-float>\n            <md-input-label translate>PREFERRED_ADDRESS</md-input-label>\n            <div class="jf-flex-container">\n                <md-checkbox  class="jf-checkbox md-primary" ng-model="user.preferred_pickup" aria-label="{{\'PREFERRED_PICKUP_ADDRESS\' | translate}}" ng-disabled="addressToEdit.id === userDatils.preferredPickupAddress || forcePickupAddress">\n                    <span translate>PREFERRED_PICKUP_ADDRESS</span>\n                </md-checkbox>\n                <md-checkbox class="jf-checkbox md-primary" ng-model="user.preferred_delivery" aria-label="{{\'PREFERRED_DELIVERY_ADDRESS\' | translate}}" ng-disabled="addressToEdit.id === userDatils.preferredDeliveryAddress || forceDeliveryAddress">\n                    <span translate>PREFERRED_DELIVERY_ADDRESS</span>\n                </md-checkbox>\n                <md-checkbox class="jf-checkbox md-primary" ng-model="user.preferred_billing" aria-label="{{\'PREFERRED_BILLING_ADDRESS\' | translate}}" ng-disabled="addressToEdit.id === userDatils.preferredBillingAddress || forceBillingAddress">\n                    <span translate>PREFERRED_BILLING_ADDRESS</span>\n                </md-checkbox>\n                <div class="md-errors-spacer"></div>\n            </div>\n        </div>\n    </div>\n\n    <account-address-form only-invoice-address-checked="onlyInvoiceAddressChecked" form="accountAddressForm" form-model="user" selected-postal-code="selectedValue"></account-address-form>\n\n    <div class="jf-spacer-15" hide-xs></div>\n    <div layout="row" layout-align="center start" class="jf-input-container">\n        <div hide-xs flex="25" ng-if="!isCheckoutView">\n            <md-button class="jf-button" ng-click="cancel()" aria-label="{{\'CANCEL\' | translate}}">\n                {{\'CANCEL\' | translate}}\n            </md-button>\n        </div>\n        <span hide-xs flex="10"></span>\n        <div flex-xs="100" flex-gt-xs="25">\n            <md-button type="submit" class="jf-button md-raised md-accent" aria-label="{{\'SAVE\' | translate}}">\n                {{\'SAVE\' | translate}}\n            </md-button>\n        </div>\n    </div>\n    <div class="jf-spacer-15" hide-xs></div>\n</form>\n');
$templateCache.put('app/components/account/directives/account-credit-card-form.html','<div class="jf-input-wrapper" ng-class="{\'jf-input-wrapper-light\': !accountView}" ng-show="showMainCheckout">\n    <div class="jf-form-subheadline" ng-if="accountView">{{\'ADD_CREDIT_CARD\'| translate}}</div>\n    <div id="jf-adyen-cc-component"></div>\n\n    <div id="adyenIosInitIframeWrapper" style="height: 210px;" ng-if="jfShared.adyen.iframe.adyenIosInitIframe">\n        <iframe ng-if="jfShared.adyen.iframe.adyenIosInitIframeUrl" src="{{jfShared.adyen.iframe.adyenIosInitIframeUrl}}" width="100%" height="100%" scrolling="no" style="overflow: hidden;" frameborder="0"></iframe>\n    </div>\n    <!-- <iframe ng-if="jfShared.adyen.iframe.adyenIosIdentifyIframe" id="adyenIosIdentifyIframe" src="{{jfShared.adyen.iframe.adyenIosIdentifyIframeUrl}}" width="100%" height="0" scrolling="no" style="overflow: hidden;visibility: hidden;" frameborder="0"></iframe> -->\n\n    <span translate class="jf-form-required-fields-legend">MANDATORY_FIELD</span>\n</div>\n\n<div layout layout-align="center start" ng-if="!hideHeader" ng-show="showMainCheckout">\n    <div hide-xs flex="20" ng-hide="hideCancelButton">\n        <md-button class="jf-button" ng-click="cancelAction()"\n            aria-label="{{\'CANCEL\' | translate}}" id="my-account-save-cc-cancel"\n        >\n            {{\'CANCEL\' | translate}}\n        </md-button>\n    </div>\n    <span flex ng-hide="hideCancelButton"></span>\n    <div flex-xs="100" flex-gt-xs="30">\n        <md-button type="submit" class="jf-button md-raised md-accent" ng-click="saveCreditCard()" aria-label="{{\'SAVE\' | translate}}" id="my-account-save-cc">\n            {{\'SAVE\' | translate}}\n        </md-button>\n    </div>\n</div>\n<div layout layout-align="center start" ng-if="hideHeader" ng-show="showMainCheckout">\n    <div flex-xs="100" flex-gt-xs="70">\n        <md-button type="submit" class="jf-button jf-button-slim md-raised md-accent" ng-click="saveCreditCard()" aria-label="{{\'SAVE\' | translate}}" ng-disabled="disableCCSubmitButton()" id="my-account-save-cc">\n            {{\'SAVE\' | translate}}\n        </md-button>\n    </div>\n</div>\n<div layout-gt-sm="row">\n    <p ng-repeat="error in genericErrors" class="jf-error jf-no-margin-bottom">{{error.detail}}</p>\n</div>');
$templateCache.put('app/components/account/directives/account-register-form.html','<div>\n    <div class="jf-page-logo">\n        <img src="assets/img/jf-logo-white-slogan.png" width="220" alt="Jonny Fresh">\n    </div>\n    <div class="jf-page-subheadline" translate>REGISTER_FOR_FREE</div>\n\n    <div ng-if="!showRegisterForm">\n        <md-button class="jf-button md-raised jf-mark-button md-accent jf-register-page-register-button" ng-click="registerFormToggle(showRegisterForm)"\n                   aria-label="{{\'LOGIN_WITH_EMAIL_HEADLINE\' | translate}}"\n        >\n            {{\'LOGIN_WITH_EMAIL_HEADLINE\' | translate}}\n        </md-button>\n        <div class="jf-form-button-container">\n            <md-button ui-sref="login({stepBack: true})"  class="jf-button md-raised jf-blue-button jf-mark-button"\n                       aria-label="{{\'LOGIN_BUTTON\' | translate}}">\n                {{\'LOGIN_BUTTON\' | translate}}\n            </md-button>\n        </div>\n    </div>\n\n    <div class="jf-register-form-inputs" ng-if="showRegisterForm">\n        <div class="jf-input-wrapper">\n            <div class="jf-form-subheadline jf-form-headline-register" translate>LOGIN_WITH_EMAIL_BOX_HEADLINE</div>\n            <md-input-container class="jf-input-container md-block" flex>\n                <input type="email" name="email_address" ng-model="formModel.email_address" required\n                       ng-pattern="/^.+@.+\\..+$/" ng-change="form.email_address.$setValidity(\'loginAlreadyTaken\', true)"\n                        aria-label="{{\'EMAIL_ADDRESS\' | translate}}" />\n                <label>{{\'EMAIL_ADDRESS\' | translate}}</label>\n                <div ng-messages="form.email_address.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                    <div ng-message="email" translate>EMAIL_ADDRESS_INVALID</div>\n                    <div ng-message="pattern" translate>EMAIL_ADDRESS_INVALID</div>\n                    <div ng-message="loginAlreadyTaken" translate>EMAIL_ALREADY_IN_USE</div>\n                </div>\n            </md-input-container>\n            <md-input-container class="jf-input-container md-block" flex>\n                <input type="password" name="new_password" ng-model="formModel.new_password" required ng-minlength="6"\n                        aria-label="{{\'PASSWORD_PLACEHOLDER\' | translate}}" />\n                <label>{{\'PASSWORD_PLACEHOLDER\' | translate}}</label>\n                <div ng-messages="form.new_password.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                    <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n                </div>\n            </md-input-container>\n            <md-input-container class="jf-input-container md-block" flex>\n                <input type="password" name="confirm_new_password" ng-model="formModel.confirm_new_password" required\n                       jf-compare-to="formModel.new_password" ng-minlength="6" aria-label="{{\'CONFIRM_NEW_PASSWORD_PLACEHOLDER\' | translate}}"/>\n                <label>{{\'CONFIRM_NEW_PASSWORD_PLACEHOLDER\' | translate}}</label>\n                <div ng-messages="form.confirm_new_password.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                    <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n                    <div ng-message="compareTo" translate>PASSWORDS_DONT_MATCH</div>\n                </div>\n            </md-input-container>\n        </div>\n\n        <div layout="row" class="jf-data-protection-block">\n            <div class="jf-checkbox-container md-block" flex="80" flex-gt-xs="75" ng-class="{ \'has-term-condition-error\': form.terms_conditions.$error.required && form.$submitted }">\n                <md-checkbox class="jf-checkbox" name="terms_conditions" ng-model="formModel.terms_conditions" aria-label="{{\'TERMS_AND_CONDITIONS\' | translate}}" required>\n                    <strong translate="TERMS_AND_CONDITIONS_AGREEMENT" translate-values="{ terms_and_conditions_link: legalDocuments.gtc.document_file.url || \'https://www.jonnyfresh.com/agb\', privacy_policy_link: legalDocuments.pp.document_file.url || \'https://www.jonnyfresh.com/datenschutz\' }"></strong>\n                </md-checkbox>\n                <div ng-messages="form.terms_conditions.$error" ng-if="form.$submitted" class="jf-checkbox-errors">\n                    <div ng-message="required" translate>TERMS_AND_CONDITIONS_ACCEPT_REQUIRED </div>\n                </div>\n            </div>\n            <div flex class="jf-divider-block" translate>MANDATORY_FIELD</div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/account/directives/jf-company-account.directive.html','<p class="jf-account-customer-number" ng-if="$state.current.name === \'account.section\'" ng-show="customerNumber">{{\'CUSTOMER_ID\' | translate}}: <strong>{{customerNumber}}</strong></p>\n\n<form ng-if="corporateAccount === false" name="linkUserToCompany" class="jf-form jf-link-user-to-company" novalidate ng-submit="submitLink(linkUserToCompany)">\n    <div flex class="jf-input-wrapper">\n        <div class="jf-account-headline">{{\'CORPORATE_SUB_NAV\' | translate}}</div>\n        <md-input-container class="jf-input-container">\n            <div class="jf-register-corporate-code-hint">{{\'REGISTER_CORPORATE_CODE_HINT\' | translate}}</div>\n        </md-input-container>\n        <div layout="column" layout-align="start stretch" class="jf-link-user-form">\n            <md-input-container class="jf-input-container md-block" flex>\n                <label>{{\'CORPORATE_CODE_LABEL\' | translate}}</label>\n                <input type="text" name="corporate_code" ng-model="linkUser.corporate_code" required\n                       ng-change="linkUserToCompany.corporate_code.$setValidity(\'corporateCodeInvalid\', true)">\n                <div ng-messages="linkUserToCompany.corporate_code.$error">\n                    <div ng-message="required" translate>REQUIRED</div>\n                    <div ng-message="corporateCodeInvalid" translate>CORPORATE_CODE_INVALID</div>\n                </div>\n            </md-input-container>\n            <span translate class="jf-form-required-fields-legend">MANDATORY_FIELD</span>\n            <md-input-container class="jf-input-container md-block" md-no-float flex>\n                <md-button class="jf-button md-raised md-accent jf-save-corporate-code" type="submit" aria-label="{{\'SAVE\' | translate}}">{{\'SAVE\' | translate}}</md-button>\n            </md-input-container>\n        </div>\n    </div>\n</form>\n\n<div ng-if="corporateAccount === true" class="jf-company-profile" layout-gt-sm="row">\n    <div flex class="jf-input-wrapper">\n        <div class="jf-account-headline">{{\'CORPORATE_PREFERENCES_TITLE\' | translate}}</div>\n        <jf-company-preferences></jf-company-preferences>\n    </div>\n    <div flex="5" hide-xs hide-sm></div>\n    <div class="jf-unlink-corporate-code jf-input-wrapper" flex>\n        <div class="jf-account-headline jf-account-headline-unlink">{{\'CANCEL_CORPORATE_CODE_TITLE\' | translate}}</div>\n        <div class="jf-input-container jf-unlink-inner-content" layout="column" layout-align="space-between center">\n            <span>{{\'CANCEL_CORPORATE_BENEFITS_HEADLINE\' | translate}}</span>\n            <div class="jf-spacer-15"></div>\n            <md-button class="jf-button md-raised jf-cancel-corporate-code" ng-click="unlinkUser(companyName)"\n                       aria-label="{{\'CANCEL_CORPORATE_CODE_BUTTON\' | translate}}"\n            >\n                {{\'CANCEL_CORPORATE_CODE_BUTTON\' | translate}}\n            </md-button>\n            <div class="jf-spacer-15" hide-gt-sm></div>\n        </div>\n    </div>\n</div>\n\n<jf-spinner ng-if="jfShared.spinner.isLoading(\'account-corporate\')" spinner-position="30"></jf-spinner>');
$templateCache.put('app/components/account/directives/jf-company-addresses.directive.html','<div class="jf-company-addresses">\n    <h3 translate>PLEASE_CHOOSE_SERVICE_STATION</h3>\n    <md-list flex>\n        <md-list-item class="md-3-line" ng-repeat="(locationId, location) in companyLocations" ng-class="{ \'selected\': selectedIndex === $index }" ng-click="chooseAddress(location)">\n            <div class="md-list-item-text" layout="column">\n                <h3>{{location.attributes.street}} {{location.attributes.house_no_main}} {{location.attributes.house_no_add}}</h3>\n                <h4>{{location.attributes.postal_code}} - {{location.attributes.city}}</h4>\n                <p>{{location.attributes.province}}, {{location.attributes.country}}</p>\n            </div>\n        </md-list-item>\n    </md-list>\n</div>');
$templateCache.put('app/components/account/directives/jf-company-preferences-addresses.dialog.html','<md-dialog class="jf-dialog jf-dialog-company-address">\n  <md-toolbar>\n      <div class="md-toolbar-tools">\n          <h2 translate>SERVICE_LOCATION</h2>\n      </div>\n  </md-toolbar>\n    <md-dialog-content>\n        <div class="md-dialog-content">\n          <md-list flex>\n              <md-list-item class="md-3-line" ng-repeat="(locationId, location) in locations" ng-class="{ \'selected\': selectedIndex === $index }" ng-click="chooseLocation(location, $index)">\n                <div class="md-list-item-text" layout="column">\n                  <h3>{{location.attributes.street}} {{location.attributes.house_no_main}}</h3>\n                  <h4>{{location.attributes.postal_code}} - {{location.attributes.city}}</h4>\n                  <p>{{location.attributes.province}}, {{location.attributes.country}}</p>\n                </div>\n              </md-list-item>\n          </md-list>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions layout="row" layout-align="space-around center">\n        <md-button class="jf-button md-raised jf-button-cancel-dialog" ng-click="cancelAction()" ng-if="showCancelButton">{{ \'CANCEL\' | translate }}</md-button>\n        <md-button class="jf-button md-raised md-primary" ng-disabled="buttonSaveDisabled" ng-click="saveAction()">{{ \'SAVE\' | translate }}</md-button>\n    </md-dialog-actions>\n</md-dialog>\n');
$templateCache.put('app/components/account/directives/jf-company-preferences.directive.html','<div class="jf-input-container jf-company-address" layout="column" layout-align="space-between start">\n    <span>\n        {{companyLocations[companyLocation].attributes.street}} {{companyLocations[companyLocation].attributes.house_no_main}}{{companyLocations[companyLocation].attributes.house_no_add ? \' \'+companyLocations[companyLocation].attributes.house_no_add : \'\' }}, {{companyLocations[companyLocation].attributes.postal_code}}<br/>\n        {{companyLocations[companyLocation].attributes.city}}, {{companyLocations[companyLocation].attributes.province}}, {{companyLocations[companyLocation].attributes.country}}<br/>\n    </span>\n    <div class="jf-spacer-15" ng-if="locationsQuantity > 1"></div>\n    <md-button class="jf-button jf-mark-button md-raised md-accent jf-company-preferences-form-save-button" aria-label="{{\'CHANGE\' | translate}}" ng-click="chooseAddress()" ng-if="locationsQuantity > 1">{{\'CHANGE\' | translate}}</md-button>\n    <div class="jf-spacer-15" hide-gt-sm ng-if="locationsQuantity > 1"></div>\n</div>');
$templateCache.put('app/components/account/directives/jf-my-account-change-password.directive.html','<div>\n    <form class="jf-form" name="accountPasswordForm" novalidate ng-submit="submitAccountPassword(accountPasswordForm)">\n        <div layout-gt-sm="row" layout-align="center center">\n            <div class="jf-input-wrapper" flex-gt-sm="60">\n                <div class="jf-form-subheadline">{{\'PASSWORD\' | translate}}</div>\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'CURRENT_PASSWORD_PLACEHOLDER\' | translate}}</label>\n                    <input type="password" name="current_password" ng-model="user.current_password" required ng-minlength="6" ng-change="accountPasswordForm.current_password.$setValidity(\'wrongCurrentPassword\', true)">\n                    <div ng-messages="accountPasswordForm.current_password.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                        <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n                        <div ng-message="wrongCurrentPassword" translate>WRONG_CURRENT_PASSWORD</div>\n                    </div>\n                </md-input-container>\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'NEW_PASSWORD_PLACEHOLDER\' | translate}}</label>\n                    <input type="password" name="new_password" ng-model="user.new_password" required ng-minlength="6">\n                    <div ng-messages="accountPasswordForm.new_password.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                        <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n                    </div>\n                </md-input-container>\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'CONFIRM_NEW_PASSWORD_PLACEHOLDER\' | translate}}</label>\n                    <input type="password" name="confirm_new_password" ng-model="user.confirm_new_password" required ng-minlength="6" jf-compare-to="user.new_password">\n                    <div ng-messages="accountPasswordForm.confirm_new_password.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                        <div ng-message="minlength" translate>PASSWORD_TOO_SHORT</div>\n                        <div ng-message="compareTo" translate>PASSWORDS_DONT_MATCH</div>\n                    </div>\n                </md-input-container>\n                <span translate class="jf-form-required-fields-legend">MANDATORY_FIELD</span>\n            </div>\n        </div>\n        <div layout>\n            <span flex hide-xs></span>\n            <div flex-xs="45" flex-gt-xs="25">\n                <md-button class="jf-button md-raised md-accent" type="submit" aria-label="{{\'SAVE\' | translate}}">\n                    {{\'SAVE\' | translate}}\n                </md-button>\n            </div>\n            <span flex="20" hide-xs></span>\n        </div>\n    </form>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-details-password-change\')" spinner-position="30"></jf-spinner>\n</div>\n');
$templateCache.put('app/components/account/directives/jf-payment-methods-manager.directive.html','<div class="jf-payment-methods-manager" layout="column" layout-align="center none">\n  <div ng-if="parcelServiceEnabled">\n    <p class="jf-payment-methods-manager-parcel-info">{{\'PARCEL_SERVICE_ENABLED_PAYMENT_INFO\' | translate}}</p>\n  </div>\n  <p ng-if="!allowPaymentMethodEdits && !parcelServiceEnabled" class="jf-payment-methods-manager-parcel-info">{{\'PAYMENT_METHODS_EDIT_NOT_ALLOWED\' | translate}}</p>\n  <div class="jf-payment-method-section" ng-repeat="paymentMethodSection in paymentMethodSections" ng-if="paymentMethodSection.type !== \'app\' && allowPaymentMethodEdits">\n    <h3 ng-bind-html="paymentMethodSection.title"></h3>\n    <img src="assets/img/payment-method-cc-icons.png" alt="" height="15" class="jf-payment-method-section-icons" ng-if="paymentMethodSection.type === \'cc\'" />\n    <img src="assets/img/payment-method-pp-icon.png" alt="" height="15" class="jf-payment-method-section-icons" ng-if="paymentMethodSection.type === \'pp\'" />\n    <img src="assets/img/payment-method-sepa-icon.png" alt="" height="15" class="jf-payment-method-section-icons" ng-if="paymentMethodSection.type === \'sepa\'" />\n    <img src="assets/img/payment-method-app-icon.png" alt="" height="15" class="jf-payment-method-section-icons" ng-if="paymentMethodSection.type === \'app\'" />\n    <div class="jf-list" ng-if="paymentMethodSection.activeBillingAgreements.length > 0">\n        <div class="jf-list-item" ng-repeat="activeBillingAgreement in paymentMethodSection.activeBillingAgreements">\n            <div layout layout-align-xs="space-between start" layout-align="space-between stretch">\n                <div>\n                    <div flex layout="column" class="jf-padding" ng-if="[\'paypal\', \'sepadirectdebit\'].indexOf(activeBillingAgreement.variant) === -1 && activeBillingAgreement.variant.indexOf(\'_applepay\') === -1">\n                        <div class="jf-payment-method-type">\n                            <i class="material-icons jf-payment-methods-default" ng-if="$mdMedia(\'xs\') && isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement)">check_circle</i>\n                            {{activeBillingAgreement.payment_info.card.holderName}} <md-icon md-svg-icon="{{[\'mc\', \'visa\', \'amex\'].indexOf(activeBillingAgreement.variant) > -1 ? activeBillingAgreement.variant : \'credit_card_black\'}}"></md-icon>\n                        </div>\n                        <div class="jf-payment-method-id">\n                            ************{{activeBillingAgreement.payment_info.card.number}}\n                        </div>\n                    </div>\n                    <div flex layout="column" class="jf-padding" ng-if="[\'paypal\'].indexOf(activeBillingAgreement.variant) > -1">\n                        <div class="jf-payment-method-type">\n                            <i class="material-icons jf-payment-methods-default" ng-if="$mdMedia(\'xs\') && isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement)">check_circle</i>\n                            {{activeBillingAgreement.payment_info.token_details.tokenData.EmailId}}\n                        </div>\n                        <div class="jf-payment-method-id">\n                            ID: {{activeBillingAgreement.payment_info.token_details.tokenData.BillingAgreementId}}\n                        </div>\n                    </div>\n                    <div flex layout="column" class="jf-padding" ng-if="[\'sepadirectdebit\'].indexOf(activeBillingAgreement.variant) > -1">\n                        <div class="jf-payment-method-type">\n                            <i class="material-icons jf-payment-methods-default" ng-if="$mdMedia(\'xs\') && isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement)">check_circle</i>\n                            {{activeBillingAgreement.payment_info.bank.ownerName}}\n                        </div>\n                        <div class="jf-payment-method-id">\n                            IBAN: {{activeBillingAgreement.payment_info.bank.iban}}\n                        </div>\n                    </div>\n                    <div flex layout="column" class="jf-padding" ng-if="activeBillingAgreement.variant.indexOf(\'_applepay\') > -1">\n                        <div class="jf-payment-method-type">\n                            <i class="material-icons jf-payment-methods-default" ng-if="$mdMedia(\'xs\') && isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement)">check_circle</i>\n                            {{activeBillingAgreement.payment_info.card.holderName}} <md-icon md-svg-icon="{{[\'mc\', \'visa\', \'amex\'].indexOf(activeBillingAgreement.variant.replace(\'_applepay\', \'\')) > -1 ? activeBillingAgreement.variant.replace(\'_applepay\', \'\') : \'credit_card_black\'}}"></md-icon>\n                        </div>\n                        <div class="jf-payment-method-id">\n                            ************{{activeBillingAgreement.payment_info.card.number}}\n                        </div>\n                    </div>\n                </div>\n                <div layout="row" layout-align="end center" class="jf-payment-methods-manager-actions">\n                    <md-button aria-label="{{\'SET_AS_PREFERRED_PAYMENT_METHOD\' | translate}}" ng-click="saveAsPreferredPaymentMethod(paymentMethodSection.paymentMethodId, activeBillingAgreement.recurring_detail_reference)"\n                        class="jf-button jf-button-slim md-raised md-secondary jf-payment-method-set-as-preferred"\n                        ng-if="$mdMedia(\'gt-xs\') && !isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement) && allowPaymentMethodEdits" id="my-account-save-payment-method-as-default"\n                    >\n                        {{\'SET_AS_PREFERRED_PAYMENT_METHOD\' | translate}}\n                    </md-button>\n                    <i class="material-icons jf-payment-methods-default" ng-if="$mdMedia(\'gt-xs\') && isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement)">check_circle</i>\n                    <md-icon md-svg-icon="delete" class="jf-payment-method-delete"\n                        ng-click="paymentMethodSection.deleteAction(activeBillingAgreement, paymentMethodSection)"\n                        id="my-account-delete-payment-method"\n                        ng-if="allowPaymentMethodEdits"\n                    ></md-icon>\n                </div>\n            </div>\n            <md-button aria-label="{{\'SET_AS_PREFERRED_PAYMENT_METHOD\' | translate}}" ng-click="saveAsPreferredPaymentMethod(paymentMethodSection.paymentMethodId, activeBillingAgreement.recurring_detail_reference)"\n                    class="jf-button jf-button-slim md-raised md-secondary jf-payment-method-set-as-preferred"\n                    ng-if="$mdMedia(\'xs\') && !isDefaultPaymentMethod(paymentMethodSection, activeBillingAgreement) && allowPaymentMethodEdits" id="my-account-save-payment-method-as-default"\n                >\n                    {{\'SET_AS_PREFERRED_PAYMENT_METHOD\' | translate}}\n                </md-button>\n        </div>\n    </div>\n    <p ng-if="paymentMethodSection.type === \'pp\' && showAuthorizationError" class="jf-pp-error jf-error">{{\'AUTHORIZE_PAY_PAL_PAYMENT_ERROR\' | translate}}</p>\n    <div class="jf-payment-method-section-add-new" ng-if="showAddNewPaymentMethodLink(paymentMethodSection) && allowPaymentMethodEdits">\n        <a ng-if="paymentMethodSection.type !== \'pp\'" ng-click="triggerPaymentMethodAdd(paymentMethodSection)" id="my-account-add-new-{{paymentMethodSection.type}}-{{$index}}"><i class="material-icons">add</i> {{paymentMethodSection.addNewTitle}}</a>\n        <a ng-if="paymentMethodSection.type === \'pp\'" ng-click="triggerPayPal(paymentMethodSection)" id="my-account-add-new-{{paymentMethodSection.type}}-{{$index}}"><i class="material-icons">add</i> {{paymentMethodSection.addNewTitle}}</a>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/components/account/directives/jf-personal-account.directive.html','<div class="personal-account">\n    <p class="jf-account-customer-number" ng-show="customerNumber">{{\'CUSTOMER_ID\' | translate}}: <strong>{{customerNumber}}</strong></p>\n    <form class="jf-form" ng-show="!deleteAccountInfo" name="accountDetailsForm" novalidate ng-submit="submitAccountDetails(accountDetailsForm)">\n        <div class="jf-input-wrapper">\n            <div class="jf-form-subheadline">{{\'PRIVATE_ACCOUNT_TITLE\'| translate}}</div>\n            <br>\n            <div layout-gt-sm="row">\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'SALUTATION\' | translate}}</label>\n                    <md-select name="title" ng-model="user.title"\n                               class="md-no-underline" required aria-label="{{\'SALUTATION\' | translate}}"\n                    >\n                        <md-option value="ms" translate>MRS</md-option>\n                        <md-option value="mr" translate>MR</md-option>\n                    </md-select>\n                    <div class="md-errors-spacer"></div>\n                    <div ng-messages="accountDetailsForm.title.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                    </div>\n                </md-input-container>\n                <div flex="5" hide-xs hide-sm></div>\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'FIRST_NAME_PLACEHOLDER\' | translate}}</label>\n                    <input name="first_name" ng-model="user.first_name">\n                </md-input-container>\n            </div>\n            <div layout-gt-sm="row">\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'LAST_NAME_PLACEHOLDER\' | translate}}</label>\n                    <input name="last_name" ng-model="user.last_name">\n                </md-input-container>\n                <div flex="5" hide-xs hide-sm></div>\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'TELEPHONE_NUMBER_PLACEHOLDER\' | translate}}</label>\n                    <input type="tel" name="phone_number" ng-model="user.phone_number"\n                           ng-pattern="/^\\+?\\d+$/" ng-maxlength="16"\n                           ng-minlength="8">\n                    <div ng-messages="accountDetailsForm.phone_number.$error">\n                        <div ng-message="maxlength" translate>TELEPHONE_NUMBER_MAX_LENGTH_ERROR</div>\n                        <div ng-message="minlength" translate>TELEPHONE_NUMBER_MIN_LENGTH_ERROR</div>\n                        <div ng-message="pattern" translate>TELEPHONE_NUMBER_INVALID_INPUT</div>\n                    </div>\n                </md-input-container>\n            </div>\n\n            <div layout-gt-sm="row">\n                <md-input-container class="jf-input-container md-block" flex>\n                    <label>{{\'EMAIL_ADDRESS_PLACEHOLDER\' | translate}}</label>\n                    <input type="email" name="email_address" ng-model="user.email_address" required\n                           ng-pattern="/^.+@.+\\..+$/" disabled>\n                    <div ng-messages="accountDetailsForm.email_address.$error">\n                        <div ng-message="required" translate>REQUIRED</div>\n                        <div ng-message="email" translate>EMAIL_ADDRESS_INVALID</div>\n                        <div ng-message="pattern" translate>EMAIL_ADDRESS_INVALID</div>\n                    </div>\n                </md-input-container>\n            </div>\n            <span translate class="jf-form-required-fields-legend">MANDATORY_FIELD</span>\n            <span translate class="jf-form-required-fields-error" ng-if="!accountDetailsForm.$valid && accountDetailsForm.$submitted">MISING_REQUIRED_INFO</span>\n        </div>\n        <div layout layout-xs="column">\n            <div hide-xs flex="30">\n                <md-button class="jf-button jf-delete-account" ui-sref="account.section({section: \'details\', subnav: \'delete-account\'})"\n                           aria-label="{{\'DELETE_ACCOUNT\' | translate}}"\n                >\n                    {{\'DELETE_ACCOUNT\' | translate}}\n                </md-button>\n            </div>\n            <div hide-xs flex></div>\n            <div flex-xs flex-gt-xs="20" flex-order-xs="1">\n                <md-button class="jf-button md-raised md-accent" type="submit" aria-label="{{\'SAVE\' | translate}}">{{\'SAVE\' | translate}}</md-button>\n            </div>\n            <div hide-gt-xs flex-xs flex-order-xs="3">\n                <md-button class="jf-button jf-delete-account"  ui-sref="account.section({section: \'details\', subnav: \'delete-account\'})"\n                           aria-label="{{\'DELETE_ACCOUNT\' | translate}}"\n                >\n                    {{\'DELETE_ACCOUNT\' | translate}}\n                </md-button>\n            </div>\n        </div>\n    </form>\n    <jf-spinner ng-if="jfShared.spinner.isLoading(\'account-details-customer-data\')"></jf-spinner>\n</div>');
$templateCache.put('app/components/location-picker/menu/location-picker-language-menu.html','<md-bottom-sheet class="jf-language-picker-menu md-list">\n    <md-list ng-cloak>\n        <md-list-item class="jf-language-picker-menu-item" ng-repeat="item in locales track by item.id" ng-if="item.visible">\n            <md-button class="md-list-item-content jf-language-picker-menu-button" ng-click="changeLocale(item.id, false)" md-autofocus="item.i18n === activeLocale.i18n">\n                <img class="jf-language-picker-menu-flag" ng-src="{{item.flagUrl}}" width="18" ng-if="item.flagUrl !== locales[$index-1].flagUrl"\n                />\n                <div class="jf-language-picker-img-space" ng-if="item.flagUrl === locales[$index-1].flagUrl"></div>\n                <span class="jf-language-picker-menu-description md-inline-list-icon-label">{{ item.i18n | translate }}</span>\n            </md-button>\n        </md-list-item>\n    </md-list>\n</md-bottom-sheet>');}]);
angular.module('jfApp')
    .config([
        '$stateProvider',
        '$urlServiceProvider',
        'urlRulesProvider',
        function (
            $stateProvider,
            $urlServiceProvider,
            urlRulesProvider
        ) {
            'use strict';

            $stateProvider.state(
                'master', {
                    url: '',
                    abstract: true,
                    views: {
                        '': {
                            templateUrl: 'app/layout/main.html'
                        },

                        'sidenav@master': {
                            templateUrl: 'app/blocks/nav/sidenav.html',
                            controller: 'SidenavController'
                        },

                        'nav-toolbar@master': {
                            templateUrl: 'app/blocks/nav/nav-toolbar.html',
                            controller: 'NavController'
                        },

                        'trust-bar@master': {
                            templateUrl: 'app/blocks/nav/trust-bar.html',
                            controller: 'TrustBarController'
                        },

                        'products-toolbar@master': {},

                        'products-location-toolbar@master': {},

                        'checkout-toolbar@master': {},

                        'account-toolbar@master': {},

                        'footer-toolbar@master': {}
                    },
                    resolve: {
                        translateReady: ['$translate', function($translate) {
                            return $translate.onReady();
                        }]
                    }
                }
            );

            $stateProvider.state(
                'home',
                {
                    url: '/',
                    title: '',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/home/home.html'
                        },
                        'footer-toolbar@master': {
                            templateUrl: 'app/components/location-picker/footer/location-picker-footer.html',
                            controller: 'LocationPickerFooterController'
                        }
                    },
                    params: {
                        stepBack: false
                    },
                    notRestricted: true
                }
            );

            $stateProvider.state(
                'login',
                {
                    url: '/login/?redirect',
                    title: 'PAGE_TITLE_LOGIN',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/account/account.login.html'
                        }
                    },
                    params: {
                        password_changed: null,
                        account_deleted: null,
                        stepBack: false,
                        checkoutRedirect: false,
                        redirect: null
                    },
                    notRestricted: true
                }
            );

            $stateProvider.state(
                'logout',
                {
                    url: '/logout/',
                    title: 'PAGE_TITLE_LOGOUT',
                    notRestricted: true,
                    views: {
                        '': {
                            controller: 'LogoutController',
                            templateUrl: 'app/components/account/account.logout.html'
                        }
                    },
                    params: {
                        account_deleted: null,
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'forgot_password',
                {
                    url: '/forgot-password/',
                    title: 'PAGE_TITLE_FORGOT_PASSWORD',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/account/account.forgot-password.html'
                        }
                    },
                    params: {
                        stepBack: false
                    },
                    notRestricted: true
                }
            );

            $stateProvider.state(
                'password_reset',
                {
                    url: '/password-reset/?t',
                    title: 'PAGE_TITLE_PASSWORD_RESET',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/account/account.password-reset.html'
                        }
                    },
                    params: {
                        stepBack: false
                    },
                    notRestricted: true
                }
            );

            $stateProvider.state(
                'register',
                {
                    url: '/register/?redirect&corporateCode',
                    title: 'PAGE_TITLE_REGISTER',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/account/account.register.html'
                        }
                    },
                    params: {
                        stepBack: false,
                        checkoutRedirect: false
                    },
                    notRestricted: true
                }
            );

            $stateProvider.state(
                'on-boarding',
                {
                    url: '/onboarding/',
                    title: 'PAGE_TITLE_ON_BOARDING',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/account/account.on-boarding.html',
                            controller: 'AccountController'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'account',
                {
                    url: '/account/',
                    title: 'PAGE_TITLE_ACCOUNT',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/account/account.html',
                            controller: 'AccountController'
                        },

                        'mobile@account': {
                            templateUrl: 'app/components/account/account.mobile.html'
                        },

                        'desktop@account': {
                            templateUrl: 'app/components/account/account.desktop.html'
                        },

                        'account-toolbar@master': {
                            templateUrl: 'app/components/account/account-toolbar.html'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'account.section',
                {
                    url: ':section/:subnav',
                    title: 'PAGE_TITLE_ACCOUNT',
                    views: {
                        'mobile@account': {
                            templateUrl: urlRulesProvider.prepareTemplateUrl
                        }
                    },
                    params: {
                        stateName: 'account',
                        stepBack: false,
                        section: null,
                        subnav: null,
                        addressToEdit: {
                            value: null,
                            dynamic: true
                        },
                        paymentMethod: null
                    }
                }
            );

            $stateProvider.state(
                'products',
                {
                    url: '/online-bestellen/',
                    title: 'PAGE_TITLE_PRODUCT_PRODUCTS',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/products/products.html',
                            controller: 'ProductsController'
                        },

                        'mobile@products': {
                            templateUrl: 'app/components/products/products.mobile.html'
                        },

                        'desktop@products': {
                            templateUrl: 'app/components/products/products.desktop.html'
                        },

                        'products-toolbar@master': {
                            templateUrl: 'app/components/products/products-toolbar.html',
                            controller: 'ProductsToolbarController'
                        },

                        'products-location-toolbar@master': {
                            templateUrl: 'app/components/products/products-location-toolbar.html'
                        },

                        'footer-toolbar@master': {
                            templateUrl: 'app/components/products/products.footer-toolbar.html'
                        }
                    },
                    params: {
                        orderError: false,
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'location-picker',
                {
                    url: '/location-picker/',
                    title: 'PAGE_TITLE_LOCATION_PICKER',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/location-picker/location-picker.html'
                        },
                        'footer-toolbar@master': {
                            templateUrl: 'app/components/location-picker/footer/location-picker-footer.html',
                            controller: 'LocationPickerFooterController'
                        }
                    },
                    params: {
                        stepBack: false,
                        emptyCatalog: false,
                        postalCode: null
                    }
                }
            );

            $stateProvider.state(
                'checkout',
                {
                    url: '/checkout/',
                    title: 'PAGE_TITLE_CHECKOUT',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/checkout/checkout.html',
                            controller: 'CheckoutController'
                        },

                        'mobile@checkout': {
                            templateUrl: 'app/components/checkout/checkout.mobile.html'
                        },

                        'desktop@checkout': {
                            templateUrl: 'app/components/checkout/checkout.desktop.html'
                        }
                    },
                    params: {
                        stepBack: false,
                        addressToEdit: {
                            value: null,
                            dynamic: true
                        }
                    }
                }
            );

            $stateProvider.state(
                'checkout.success',
                {
                    url: 'success/:orderId/',
                    title: 'PAGE_TITLE_CHECKOUT',
                    views: {
                        'desktop': {
                            templateUrl: 'app/components/checkout/steps/checkout.success.html',
                            controller: 'CheckoutSuccessController'
                        },
                        'mobile': {
                            templateUrl: 'app/components/checkout/steps/checkout.success.html',
                            controller: 'CheckoutSuccessController'
                        }
                    },
                    params: {
                        stateName: 'checkout',
                        data: null,
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'checkout.notes',
                {
                    url: 'notes/',
                    title: 'PAGE_TITLE_CHECKOUT',
                    views: {
                        'mobile': {
                            templateUrl: 'app/components/checkout/steps/checkout.notes.html'
                        }
                    },
                    params: {
                        stateName: 'checkout',
                        data: null,
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'checkout.pickup-delivery',
                {
                    url: 'pickup-delivery/',
                    title: 'PAGE_TITLE_CHECKOUT',
                    views: {
                        'mobile': {
                            templateUrl: 'app/components/checkout/steps/checkout.pickup-delivery.html'
                        }
                    },
                    params: {
                        stateName: 'checkout',
                        data: null,
                        stepBack: false,
                        showPickup: false,
                        showDelivery: false
                    }
                }
            );

            $stateProvider.state(
                'checkout.addresses',
                {
                    url: 'addresses/',
                    title: 'PAGE_TITLE_CHECKOUT',
                    views: {
                        'mobile': {
                            templateUrl: 'app/components/checkout/steps/checkout.addresses.html'
                        }
                    },
                    params: {
                        stateName: 'checkout',
                        data: null,
                        stepBack: false,
                        showAddresses: false,
                        subnav: null
                    }
                }
            );

            $stateProvider.state(
                'help',
                {
                    url: '/help/',
                    title: 'PAGE_TITLE_HELP',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/help/help.html',
                            controller: 'HelpController'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'instructions',
                {
                    url: '/instructions',
                    title: 'PAGE_TITLE_INSTRUCTIONS',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/instructions/instructions.html'
                        },
                        'footer-toolbar@master': {
                            templateUrl: 'app/components/location-picker/footer/location-picker-footer.html',
                            controller: 'LocationPickerFooterController'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                '404',
                {
                    url: '/404/',
                    title: 'PAGE_TITLE_404',
                    parent: 'master',
                    views: {
                        'content': {
                            templateUrl: 'app/components/404/404.html'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'wp-content',
                {
                    url: '/wp-content/?title&url',
                    title: '',
                    parent: 'master',
                    views: {
                        'content': {
                            controller: 'WpContentController',
                            templateUrl: 'app/components/wp-content/wp-content.html'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'invoices',
                {
                    url: '/invoices/:id',
                    title: 'INVOICES',
                    parent: 'master',
                    views: {
                        'content': {
                            controller: 'InvoicesController',
                            templateUrl: 'app/components/invoices/invoices.html'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'reminders',
                {
                    url: '/reminders/:id',
                    title: 'PAGE_TITLE_REMINDERS',
                    parent: 'master',
                    views: {
                        'content': {
                            controller: 'RemindersController',
                            templateUrl: 'app/components/reminders/reminders.html'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            $stateProvider.state(
                'maintenance',
                {
                    url: '/maintenance/',
                    title: 'MAINTENANCE_PAGE',
                    parent: 'master',
                    views: {
                        'content': {
                            controller: 'MaintenanceController',
                            templateUrl: 'app/components/maintenance/maintenance.html'
                        }
                    },
                    params: {
                        stepBack: false
                    }
                }
            );

            /**
             * Custom redirects
             */
            $urlServiceProvider.rules.when('/anmelden', '/login');

            /**
             * Default redirect
             */
            $urlServiceProvider.rules.when('/', '/online-bestellen');

            /**
             * 404 page
             */
            $urlServiceProvider.rules.otherwise(function() {
                return { state: '404' };
            });
        }
    ]);
/**
 * Model compare values directive
 */
angular.module('jfApp')
    .directive(
        'jfCompareTo',
        function() {
            'use strict';

            return {
                require: 'ngModel',
                scope: {
                    otherModelValue: '=jfCompareTo'
                },
                link: function(scope, element, attributes, ngModel) {
                    ngModel.$validators.compareTo = function(modelValue) {
                        return modelValue === scope.otherModelValue;
                    };

                    scope.$watch('otherModelValue', function() {
                        ngModel.$validate();
                    });
                }
            };
        }
    );
/**
 * Postal code auto complete directive
 */
angular.module('jfApp')
    .directive(
        'jfPostalCode',
        ['$timeout', function($timeout) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/shared/directives/jf-postal-code.tpl.html',
                scope: {
                    model: '=model',
                    form: '=form',
                    selectedtext: '=selectedtext',
                    validateInService: '=?validateInService',
                    disableSearch: '=?disableSearch',
                    repeaterCssClass: '=repeaterCssClass',
                    customPlaceholder: '@?customPlaceholder',
                    customClearButton: '=?customClearButton',
                    shortSuggestions: '=?',
                    disableSameCityCheck: '=?',
                    showStandardLabel: '=?'
                },
                controller: ['$scope', '$rootScope', '$q', '$state', '$window', '$translate', 'ContextLocationsFactory', 'SpinnerFactory', 'jfUser', 'jfHelper', 'jfLocation', 'JF_SHARED_CONFIG', function(
                    $scope,
                    $rootScope,
                    $q,
                    $state,
                    $window,
                    $translate,
                    ContextLocationsFactory,
                    SpinnerFactory,
                    jfUser,
                    jfHelper,
                    jfLocation,
                    JF_SHARED_CONFIG
                ) {
                    $scope.showLanguage = false;
                    $scope.postalPlaceholder = $scope.customPlaceholder ? $scope.customPlaceholder : 'POSTAL_CODE_PLACEHOLDER';
                    $scope.state = $state;
                    $scope.blogUrl = $rootScope.blogUrl;
                    $scope.showStandardLabel = $scope.showStandardLabel || false;
                    $scope.postalCodeResultsCache = {};
                    $scope.currentInputValue = null;

                    $translate($scope.postalPlaceholder)
                        .then(function (translation) {
                            $scope.postalPlaceholder = translation;
                        }, function (translationId) {
                            $scope.postalPlaceholder = translationId;
                        });

                    $scope.$on('validatePostalCodeServiceability', function () {
                        $scope.validateInService = true;
                    });

                    $scope.hideLanguageSwitcher = function() {
                        if (angular.isDefined($scope.form.autocompleteField.$modelValue)) {
                            $rootScope.$broadcast('languageSwitcherHide');
                        }
                    };

                    $scope.showLanguageSwitcher = function() {
                        $rootScope.$broadcast('languageSwitcherShow');
                    };

                    $scope.clearPostalCodeInput = function() {
                        $scope.selectedtext = '';
                    };

                    $scope.postalCodeInputFocused = function() {
                        $rootScope.$broadcast('postalCodeInputFocused');
                    };

                    $scope.postalCodeInputBlur = function() {
                        var inputCurrentValue = $scope.form.autocompleteField.$viewValue;

                        if (
                            angular.isDefined($scope.model) &&
                            (
                                angular.isUndefined($scope.model.postal_code_id) ||
                                $scope.model.postal_code_id === null
                            ) &&
                            inputCurrentValue !== '' &&
                            angular.isDefined($scope.postalCodeResultsCache[inputCurrentValue]) &&
                            $scope.postalCodeResultsCache[inputCurrentValue].length > 0
                        ) {
                            $scope.selectedPostalCode($scope.postalCodeResultsCache[inputCurrentValue][0]);
                            $scope.selectedtext = $scope.selectedPostalCodeValue($scope.postalCodeResultsCache[inputCurrentValue][0].attributes);
                        }

                        $rootScope.$broadcast('postalCodeInputBlur');
                    };

                    $scope.getPostalCodes = function(query) {
                        var deferred = $q.defer();

                        ContextLocationsFactory
                            .get({
                                'filter[code][prefix]': query.toUpperCase()
                            })
                            .$promise
                            .then(function(results) {
                                $scope.postalCodeResultsCache[query.toUpperCase()] = results.data;

                                deferred.resolve(results.data);
                            }, function(err) {
                                deferred.reject(err);

                                $rootScope.$emit('app-error', {err: err, silent: true});
                            });

                        return deferred.promise;
                    };

                    $scope.selectedPostalCode = function(item) {
                        $scope.form.autocompleteField.$setValidity('noInService', true);
                        $scope.form.autocompleteField.$setValidity('corpRequired', true);
                        $scope.form.autocompleteField.$setValidity('b2bRequired', true);
                        $scope.form.autocompleteField.$setValidity('sameCity', true);

                        if (jfHelper.mobileAppMode && angular.isDefined($window.Keyboard) && angular.isDefined($window.Keyboard.hide)) {
                            $window.Keyboard.hide();
                        }

                        if (angular.isUndefined($scope.disableSearch) || $scope.disableSearch === false) {
                            if (angular.isDefined(item) && angular.isDefined(item.attributes)) {
                                if (angular.isDefined($scope.validateInService) && $scope.validateInService === true) {

                                    var companyId = jfUser.get().companyId || null;

                                    SpinnerFactory.set('location-picker-page');

                                    jfLocation
                                        .postalCodeInService(item.id, companyId)
                                        .then(function(validationResult) {
                                            SpinnerFactory.unset('location-picker-page');

                                            if (validationResult.valid === true) {
                                                if (
                                                    (
                                                        angular.isUndefined($scope.disableSameCityCheck) ||
                                                        $scope.disableSameCityCheck === false
                                                    ) &&
                                                    $rootScope.currentDeliveryLocation === item.attributes.city_name
                                                ) {
                                                    $scope.form.autocompleteField.$setValidity('sameCity', false);
                                                } else {
                                                    $scope.assignSelectedPostalCode(item);
                                                }
                                            } else {
                                                if (validationResult.reason === 3) {
                                                    $scope.form.autocompleteField.$setValidity('corpRequired', false);
                                                } else if (validationResult.reason === 2) {
                                                    $scope.form.autocompleteField.$setValidity('b2bRequired', false);
                                                } else {
                                                    if (angular.isDefined($scope.form.autocompleteField)) {
                                                        $scope.form.autocompleteField.$setValidity('noInService', false);
                                                    }
                                                }
                                            }
                                        }, function(err) {
                                            SpinnerFactory.unset('location-picker-page');

                                            $rootScope.$emit('app-error', {err: err, silent: true});
                                            $scope.form.autocompleteField.$setValidity('noInService', false);
                                        });
                                } else {
                                    $scope.assignSelectedPostalCode(item);
                                }
                            } else {
                                $scope.model.postal_code_id = null;
                                $scope.model.postal_code = null;
                                $scope.model.city = null;
                                $scope.model.province = null;
                                $scope.model.country_code = null;
                                $scope.model.country = null;
                                $scope.model.default_locale = null;
                                $scope.model.addressable_type = null;
                            }
                        }
                    };

                    $scope.assignSelectedPostalCode = function(item) {
                        $scope.model.postal_code_id = item.id;
                        $scope.model.postal_code = item.attributes.code;
                        $scope.model.city = item.attributes.city_name;
                        $scope.model.province = item.attributes.province;
                        $scope.model.country = JF_SHARED_CONFIG.countries.find(function(country) { return country.code === item.attributes.country_code; }).name;
                        $scope.model.country_code = item.attributes.country_code;
                        $scope.model.default_locale = item.attributes.default_locale;
                        $scope.model.addressable_type = item.attributes.addressable_type || null;
                        $scope.model.type = item.type || null;

                        $scope.showLanguage = true;
                    };

                    $scope.selectedPostalCodeValue = function(postalCodeDetails) {
                        if (angular.isDefined(postalCodeDetails)) {
                            if (angular.isDefined($scope.shortSuggestions) && $scope.shortSuggestions === true) {
                                return postalCodeDetails.code + ' ' + postalCodeDetails.city_name + ' (' + postalCodeDetails.country_code + ')';
                            } else {
                                if (postalCodeDetails.country_code === 'DE') {
                                    return postalCodeDetails.code + ' ' + postalCodeDetails.city_name;
                                } else {
                                    return postalCodeDetails.suggestion;
                                }

                            }
                        } else {
                            return $scope.selectedtext;
                        }
                    };
                }],
                link: function($scope) {
                    if (angular.isDefined($scope.repeaterCssClass) && $scope.repeaterCssClass !== '') {
                        angular.element(document.querySelectorAll('md-virtual-repeat-container')).addClass($scope.repeaterCssClass);
                    }

                    var listenForSelectedPostalCode = $scope.$watch('showLanguage', function(newValue, oldValue) {
                        if (oldValue !== newValue && newValue === true) {
                            $scope.showLanguageSwitcher();
                            $scope.showLanguage = false;
                        }
                    });

                    var postalCodeChangeListener = $scope.$watch('postalCode', function(newVal, oldVal) {
                        if (angular.isDefined(newVal) && newVal !== '' && newVal !== null && newVal !== oldVal) {
                            var scrollMask = angular.element(document.querySelectorAll('.md-scroll-mask'));

                            if (!scrollMask.hasClass('jf-hide')) {
                                $timeout(function() {
                                    angular.element(document.querySelectorAll('.md-scroll-mask')).addClass('jf-hide');
                                }, 800);
                            }
                        }
                    });

                    $scope.$on('$destroy', function() {
                        listenForSelectedPostalCode();
                        postalCodeChangeListener();
                    });
                }
            };
        }]
    );
/**
 * Intro slider directive
 */
angular.module('jfApp')
    .directive(
        'jfIntroSlider',
        function() {
            'use strict';

            return {
                link: function($scope, element) {
                    // 1. Basic object for our stuff
                    var slider = {};

                    // 2. Settings
                    slider.sliderPanelSelector = '.slider-panel';
                    slider.sliderPaginationSelector = '.slider-pagination';
                    slider.sensitivity = 25; // horizontal % needed to trigger swipe

                    // 2. Placeholder to remember which slide we’re on
                    slider.activeSlide = 0;

                    // 3. Slide counter
                    slider.slideCount = 0;

                    // 4. Initialization + event listener
                    slider.init = function(selector) {
                        // 4a. Find the container
                        slider.sliderEl = document.querySelector(selector);

                        // 4b. Count stuff
                        slider.slideCount = slider.sliderEl.querySelectorAll(slider.sliderPanelSelector).length;

                        // 4c. Populate pagination
                        var n = 0;
                        for (n; n < slider.slideCount; n++) {
                            var activeStatus = n === slider.activeSlide ? ' class="is-active"' : '';
                            slider.sliderEl.parentElement.querySelector(
                                slider.sliderPaginationSelector
                            ).innerHTML += '<div ' + activeStatus + '></div>';
                        }

                        // 4d. Set up HammerJS
                        var sliderManager = new Hammer.Manager(slider.sliderEl);
                        sliderManager.add(new Hammer.Pan({
                            threshold: 0,
                            pointers: 0
                        }));
                        sliderManager.on('pan', function(e) {
                            // 4e. Calculate pixel movements into 1:1 screen percents so gestures track with motion
                            var percentage = 100 / slider.slideCount * e.deltaX / window.innerWidth;

                            // 4f. Multiply percent by # of slide we’re on
                            var percentageCalculated = percentage - 100 / slider.slideCount * slider.activeSlide;

                            // 4g. Apply transformation
                            slider.sliderEl.style.transform = 'translateX( ' + percentageCalculated + '% )';

                            // 4h. Snap to slide when done
                            if (e.isFinal) {
                                if (e.velocityX > 1) {
                                    slider.goTo(slider.activeSlide - 1);
                                } else if(e.velocityX < -1) {
                                    slider.goTo(slider.activeSlide + 1);
                                } else {
                                    if (percentage <= -(slider.sensitivity / slider.slideCount)) {
                                        slider.goTo(slider.activeSlide + 1);
                                    } else if (percentage >= (slider.sensitivity / slider.slideCount)) {
                                        slider.goTo(slider.activeSlide - 1);
                                    } else {
                                        slider.goTo(slider.activeSlide);
                                    }
                                }
                            }
                        });
                    };

                    // 5. Update current slide
                    slider.goTo = function(number) {
                        // 5a. Stop it from doing weird things like moving to slides that don’t exist
                        if (number < 0) {
                            slider.activeSlide = 0;
                        } else if (number > slider.slideCount - 1) {
                            slider.activeSlide = slider.slideCount - 1;
                        } else {
                            slider.activeSlide = number;
                        }

                        // 5b. Apply transformation & smoothly animate via .is-animating CSS
                        slider.sliderEl.classList.add('is-animating');
                        var percentage = -(100 / slider.slideCount) * slider.activeSlide;
                        slider.sliderEl.style.transform = 'translateX( ' + percentage + '% )';

                        // 5c. Update the counters
                        var pagination = slider.sliderEl.parentElement.querySelectorAll(
                            slider.sliderPaginationSelector + ' > *'
                        );
                        var n = 0;
                        for (n; n < pagination.length; n++) {
                            var className = n === slider.activeSlide ? 'is-active' : '';
                            pagination[n].className = className;
                        }

                        //5d. Check if button text should be changed
                        if (slider.activeSlide === 3) {
                            slider.sliderEl.classList.add('is-last');
                        } else {
                            slider.sliderEl.classList.remove('is-last');
                        }
                    };

                    // Initialize
                    slider.init('#'+ element[0].id);
                }
            };
        }
    );
/**
 * Cart Item swipe directive
 */
angular.module('jfApp')
    .directive(
        'jfSwipeItem',
        function() {
            'use strict';

            return {
                restrict: 'A',
                controller: ['$scope', '$rootScope', 'OrderFactory', function($scope, $rootScope, OrderFactory) {
                    $scope.itemsToAdd = 0;
                    $scope.itemsToRemove = 0;

                    $scope.addToOrder = function(productId, quantity, categoryRef, categoryName) {
                        $rootScope.sendGAEvent('catalogPage', 'addToCartFromCatalog');

                        OrderFactory
                            .addToOrder(productId, quantity, categoryRef, categoryName)
                            .then(function() {

                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.removeFromOrder = function(productId, quantity) {
                        $rootScope.sendGAEvent('catalogPage', 'removeFromCartFromCatalog');

                        OrderFactory.removeFromOrder(productId, quantity);
                    };
                }],
                link: function($scope, $element, attrs) {
                    var clientScreenWidth = $element[0].clientWidth,
                        positionX = 0,
                        $counterAddElement = angular.element(
                            $element[0].getElementsByClassName('jf-swipe-item-action-count add')
                        ),
                        $counterRemoveElement = angular.element(
                            $element[0].getElementsByClassName('jf-swipe-item-action-count remove')
                        ),
                        isScrolling = false,
                        hammer = new Hammer(
                            $element[0],
                            {
                                inputClass: Hammer.TouchInput,
                                touchAction : 'pan-y',
                                recognizers: [[Hammer.Pan, {}]]
                            }
                        );

                    // Perform any setup for the drag actions.
                    hammer.on('panstart', function(e) {
                        isScrolling = (e.additionalEvent === 'panup' || e.additionalEvent === 'pandown');

                        // We don't want an animation delay when dragging.
                        $element.removeClass('animate');
                    });

                    // Follow the drag position when the user is interacting.
                    hammer.on('pan', function(e) {
                        if (!isScrolling && $scope.$root !== null) {
                            positionX = e.deltaX;

                            var disableRemoveAction = false;

                            if (positionX > 0) {
                                $scope.itemsToAdd = (positionX/100).toFixed();
                                $counterAddElement.text('+' + (positionX/100).toFixed());
                            }

                            if (positionX < 0) {
                                if (angular.isDefined(attrs.jfSwipeItemOrderPosition) &&
                                    angular.isUndefined($scope.$root.order.items[attrs.jfSwipeItemOrderPosition])
                                ) {
                                    disableRemoveAction = true;
                                } else {
                                    var itemsToRemoveSlideValue = (positionX/100).toFixed();

                                    if (angular.isUndefined(attrs.jfSwipeItemId)) { // Example slide item
                                        $scope.itemsToRemove = itemsToRemoveSlideValue;
                                        $counterRemoveElement.text(itemsToRemoveSlideValue);
                                    } else { // Normal slide item
                                        var itemsInCart = ($scope.$root.order.items[attrs.jfSwipeItemOrderPosition].attributes.quantity * -1);

                                        if (itemsToRemoveSlideValue >= itemsInCart) {
                                            $scope.itemsToRemove = itemsToRemoveSlideValue;
                                            $counterRemoveElement.text(itemsToRemoveSlideValue);
                                        } else {
                                            $scope.itemsToRemove = itemsInCart;
                                            $counterRemoveElement.text(itemsInCart);
                                        }
                                    }
                                }
                            }

                            // Set the current position.
                            if (Math.abs(positionX) > clientScreenWidth) {
                                $element.addClass('animate');
                                $element.css('-webkit-transform', 'translate3d(0px, 0px, 0px)');
                            } else {
                                $element.toggleClass('jf-disabled-remove', disableRemoveAction);
                                $element.css('-webkit-transform', 'translate3d(' + positionX + 'px,0px,0px)');
                                $element.css('transform', 'translate3d(' + positionX + 'px,0px,0px)');
                            }
                        }
                    });

                    // The drag is finishing so we'll animate to a snap point.
                    hammer.on('panend', function() {
                        isScrolling = false;

                        $element.addClass('animate');
                        $element.css('-webkit-transform', 'translate3d(0px, 0px, 0px)');

                        if (angular.isDefined(attrs.jfSwipeItemId)) {
                            if ($scope.itemsToAdd > 0) {
                                $scope.addToOrder(attrs.jfSwipeItemId, ($scope.itemsToAdd * attrs.jfSwipeItemPriceQuantity), attrs.jfSwipeItemCategoryRef, attrs.jfSwipeItemCategoryName);
                            } else if ($scope.itemsToRemove < 0) {
                                $scope.removeFromOrder(attrs.jfSwipeItemId, (($scope.itemsToRemove * -1) * attrs.jfSwipeItemPriceQuantity));
                            }
                        }

                        $scope.itemsToAdd = 0;
                        $scope.itemsToRemove = 0;
                    });
                }
            };
        }
    );

/**
 * Footer directive
 */
angular.module('jfApp')
    .directive(
        'jfFooter',
        ['$http', '$q', '$rootScope', 'JF_CONFIG', '$localStorage', 'LanguageFactory', 'jfConfigUrls', function(
            $http,
            $q,
            $rootScope,
            JF_CONFIG,
            $localStorage,
            LanguageFactory,
            jfConfigUrls
        ) {
            'use strict';

            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/shared/directives/jf-footer.tpl.html',
                controller: ['$scope', function($scope) {
                    $scope.getFooterFromBlog = function() {
                        var deferred = $q.defer(),
                            activeLocale = JF_CONFIG.locales[LanguageFactory.getActiveLocale()].shortName;

                        $http
                            .get(jfConfigUrls.get('jfBlogUrl', 'customerApp') + '/wp-admin/admin-ajax.php?action=getAjaxFooter&lang=' + activeLocale)
                            .then(function (response) {
                                var footerContent =
                                    '<link rel="stylesheet" href="' + jfConfigUrls.get('jfBlogUrl', 'customerApp') + '/wp-content/themes/jonnyfresh/assets/css/remote-footer.css?ver=' + new Date().getTime() + '" type="text/css" media="all">' +
                                    response.data;

                                $scope.cacheFooter($localStorage.shopLocale, footerContent);

                                deferred.resolve(footerContent);
                            }, function (err) {
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.cacheFooter = function(locale, footerContent) {
                        var currentTime = Math.floor(Date.now());

                        $localStorage.footerCache = {
                            expiration: currentTime + (86400000 * 30), // 30 days
                            locale: locale,
                            content: footerContent
                        };
                    };
                }],
                link: function($scope, $element) {
                    $scope.initTracking = function() {
                        angular.element(document.querySelectorAll('.jf-footer-nav a')).on('click', function() {
                            $rootScope.sendCustomGAEvent('Footer', angular.element(this).text());
                        });
                        angular.element(document.querySelectorAll('.jf-copyrights .jf-copyrights-impressum-link')).on('click', function() {
                            $rootScope.sendGAEvent('footer', 'impressum');
                        });
                        angular.element(document.querySelectorAll('.jf-copyrights .jf-copyrights-privacy-policy-link')).on('click', function() {
                            $rootScope.sendGAEvent('footer', 'privacy');
                        });
                        angular.element(document.querySelectorAll('.jf-copyrights .jf-copyrights-agb-link')).on('click', function() {
                            $rootScope.sendGAEvent('footer', 'terms');
                        });
                        angular.element(document.querySelectorAll('.jf-footer.fsn-row .jf-app-store-link')).on('click', function() {
                            $rootScope.sendGAEvent('footer', 'appStore');
                        });
                        angular.element(document.querySelectorAll('.jf-footer.fsn-row .jf-google-play-link')).on('click', function() {
                            $rootScope.sendGAEvent('footer', 'googlePlay');
                        });
                    };

                    $scope.initFooterNavToogle = function() {
                        var footerHeaders = document.querySelectorAll('.jf-footer-nav .jf-footer-nav-header');

                        for (var i = 0; i < footerHeaders.length; i++) {
                            footerHeaders[i].addEventListener('click', function(e) {
                                if (window.innerWidth <= 991) {
                                    e.preventDefault();
                                }
                                var target = e.target;

                                if (angular.isUndefined(e.target.dataset.bsTarget)) {
                                    target = e.target.parentNode;
                                }

                                target.classList.toggle('collapsed');
                                document.getElementById(target.dataset.bsTarget.replace('#', '')).classList.toggle('show');
                            });
                        }
                    };

                    $scope.initFooter = function(footerContent) {
                        $element.append(footerContent);
                        $scope.initTracking();
                        $scope.initFooterNavToogle();
                    };

                    if (angular.isDefined($localStorage.footerCache) &&
                        $localStorage.footerCache.locale === $localStorage.shopLocale &&
                        $localStorage.footerCache.expiration > Math.floor(Date.now())
                    ) {
                        $scope.initFooter($localStorage.footerCache.content);
                    } else {
                        $scope
                            .getFooterFromBlog()
                            .then(function(footerContent) {
                                $scope.initFooter(footerContent);
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err, silent: true});
                            });
                    }

                }
            };
        }]
    );

/**
 *  jf App Download Notification directive
 */
angular.module('jfApp')
    .directive(
        'jfAppDownloadNotification',
        ['$cookies', '$rootScope', 'JF_CONFIG', function(
            $cookies,
            $rootScope,
            JF_CONFIG
        ) {
            'use strict';

            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/shared/directives/jf-app-download-notification.html',
                controller: ['$scope', function($scope) {
                    $scope.googlePlayLink = 'http://play.google.com/store/apps/details?id=de.jonnyfresh.jonnyfresh';
                    $scope.appleStoreLink = 'https://itunes.apple.com/us/app/jonnyfresh/id1024534584?mt=8';
                    var ua = navigator.userAgent;
                    $scope.goToMobileApp = function() {
                        if (ua.match(/iPhone/i )) {
                            window.location = $scope.appleStoreLink;
                        } else {
                            window.location = $scope.googlePlayLink;
                        }
                    };
                }],
                link: function($scope) {
                    $rootScope.appDownloadNotificationVisible = angular.isUndefined($cookies.getObject('jf-app-download-notification-dismiss'));

                    $scope.closeStickyNotificationOnMobile = function() {
                        $rootScope.appDownloadNotificationVisible = false;

                        var d = new Date();
                        d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days

                        $cookies.put(
                            'jf-app-download-notification-dismiss',
                            1,
                            {
                                domain: JF_CONFIG.cookies_domain,
                                path: '/',
                                expires: d.toUTCString(),
                                samesite: 'lax',
                                secure: true
                            }
                        );
                    };
                }
            };
        }]
    );

/**
 * Scroll top on state change directive
 */
angular.module('jfApp')
    .directive(
        'jfScrollTopOnStateChange',
        ['$transitions', function(
            $transitions
        ) {
            'use strict';

            return {
                restrict: 'A',
                link: function(_scope, element) {
                    $transitions.onSuccess({}, function() {
                        setTimeout(function() {
                            angular.element(element)[0].scrollTo(0, 0);
                        }, 100);
                    });
                }
            };
        }]
    );
/**
 * Input number validation directive
 */
angular.module('jfApp')
    .directive(
        'jfInputOnlyNumbers',
        function() {
            'use strict';

            return {
                require: 'ngModel',
                restrict: 'A',
                link: function(scope, element, attrs, modelCtrl) {
                    modelCtrl.$parsers.push(function(inputValue) {
                        var cleanInputValue = inputValue.replace(/[^0-9]/gi, '');

                        modelCtrl.$setViewValue(cleanInputValue);
                        modelCtrl.$render();

                        return cleanInputValue;
                    });
                }
            };
        }
    );
/**
 *  jf App Download Notification directive
 */
angular.module('jfApp')
    .directive(
        'jfMdTabClass',
        function(

        ) {
            'use strict';

            return {
                restrict: 'A',
                require: ['^mdTabs'],
                controller: function() {

                },
                link: function($scope, element, attrs, controllers) {
                    var classWatcher = $scope.$watch(
                        function() {
                            return element.attr('class');
                        },
                        function(newVal) {
                            var mdTabs = controllers[0],
                                mdTabsElement = element.parent().parent().parent(),
                                mdTab,
                                mdIcon,
                                mdLabel,
                                tabIdx,
                                mdTabItem,
                                classNamesToAdd;

                            if (!mdTab) {
                                mdTab = mdTabs.tabs.filter(function(tab){
                                    return angular.equals(tab.element, element);
                                }).shift();
                            }

                            tabIdx = mdTab.getIndex();
                            mdTabItem = mdTabsElement.find('md-tab-item')[tabIdx];
                            mdIcon = angular.element(mdTabItem).find('md-icon');
                            mdLabel = angular.element(mdTabItem).find('label');

                            classNamesToAdd = newVal.split(' ').filter(function(className) {
                                return className.indexOf('md-') !== 0 && className.indexOf('ng-') !== 0;
                            });

                            angular.element(mdTabItem).addClass(classNamesToAdd.join(' '));
                            angular.element(mdIcon).addClass(classNamesToAdd.join(' '));
                            angular.element(mdLabel).addClass(classNamesToAdd.join(' '));

                            classWatcher();
                        }
                    );
                }
            };
        }
    );

/**
 *  jf Corporate popup directive
 */
angular.module('jfApp')
    .directive(
        'jfCorporatePopup',
        ['$rootScope', '$filter', '$timeout', function(
            $rootScope,
            $filter,
            $timeout
        ) {
            'use strict';

            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/shared/directives/jf-corporate-popup.tpl.html',
                controller: ['$scope', function($scope) {
                    $rootScope.corporatePopupVisible = false;
                    $scope.shopCorpPopupListener = null;
                    $scope.hideCorpPopupListener = null;
                    $scope.activateBackdrop = false;

                    $scope.popupTitle = $filter('translate')('CORPORATE_POPUP_LOGIN_REGISTER_TITLE');
                    $scope.popupContent = $filter('translate')('CORPORATE_POPUP_LOGIN_REGISTER_CONTENT');
                    $scope.popupShowButtons = true;
                    $scope.popupShowAccountInstructions = false;

                    $scope.hidePopup = function(hideInstantly) {
                        $rootScope.$emit('jf:hideCorporatePopup', { hideInstantly: hideInstantly });
                    };

                    $scope.shopCorpPopupListener = $rootScope.$on('jf:showCorporatePopup', function(e, data) {
                        if (
                            angular.isDefined(data) &&
                            angular.isDefined(data.accountInstructions) &&
                            data.accountInstructions === true
                        ) {
                            $scope.popupTitle = $filter('translate')('CORPORATE_POPUP_ACCOUNT_INSTRUCTIONS_TITLE');
                            $scope.popupContent = $filter('translate')('CORPORATE_POPUP_ACCOUNT_INSTRUCTIONS_CONTENT');
                            $scope.popupShowButtons = false;
                            $scope.popupShowAccountInstructions = true;
                        } else {
                            $scope.popupShowButtons = true;
                            $scope.popupShowAccountInstructions = false;
                        }

                        $rootScope.corporatePopupVisible = true;
                        $timeout(function() {
                            $scope.activateBackdrop = true;
                        }, 1);
                    });

                    $scope.hideCorpPopupListener = $rootScope.$on('jf:hideCorporatePopup', function(e, data) {
                        $scope.activateBackdrop = false;

                        var timeout = 300;

                        if (
                            angular.isDefined(data) &&
                            angular.isDefined(data.hideInstantly) &&
                            data.hideInstantly === true
                        ) {
                            timeout = 0;
                        }

                        $timeout(function() {
                            $rootScope.corporatePopupVisible = false;
                        }, timeout);
                    });

                    $scope.$on('$destroy', function() {
                        $scope.shopCorpPopupListener();
                        $scope.hideCorpPopupListener();
                    });
                }]
            };
        }]
    );

/**
 * Survey Script Loader
 */
angular.module('jfApp')
    .directive(
        'jfSurveyLoader',
        ['$rootScope', 'SurveyFactory', 'AccountUserProfileFactory', 'jfUser', '$timeout', '$mdDialog', '$http', '$httpParamSerializerJQLike', '$window', 'jfController', 'SpinnerFactory', function(
            $rootScope,
            SurveyFactory,
            AccountUserProfileFactory,
            jfUser,
            $timeout,
            $mdDialog,
            $http,
            $httpParamSerializerJQLike,
            $window,
            jfController,
            SpinnerFactory
        ) {
            'use strict';

            return {
                restrict: 'E',
                replace: true,
                controller: ['$scope', function(
                    $scope
                ) {
                    $scope.submitSurvey = function() {
                        $scope.survey.identity = SurveyFactory.identity;
                        $scope.survey.identity_type = 'email';
                        $scope.survey.first_name = SurveyFactory.firstName;
                        $scope.survey.last_name = SurveyFactory.lastName;
                        $scope.survey.properties = SurveyFactory.properties;

                        var data = $httpParamSerializerJQLike($scope.survey);
                        var config = {
                            S3Request: true,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        };

                        SpinnerFactory.set('global');

                        $http
                            .post($scope.url.toString(), data, config)
                            .then(function() {
                                SpinnerFactory.unset('global');

                                if ($scope.survey.answer_score < 5) {
                                    $scope.showFeedbackTextarea = true;
                                } else {
                                    $scope.thankYou = true;
                                }
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err, silent: true});
                            });
                    };

                    $scope.sendSurveyComment = function() {
                        if (angular.isUndefined($scope.survey.response)) {
                            $scope.thankYou = true;
                        } else {
                            var config = {
                                    S3Request: true,
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    },
                                    withCredentials: true
                                };

                            SpinnerFactory.set('global');

                            var data = $httpParamSerializerJQLike($scope.survey);

                            $http
                                .post($scope.url.toString(), data, config)
                                .then(function() {
                                    SpinnerFactory.unset('global');

                                    $scope.thankYou = true;
                                }, function(err) {
                                    SpinnerFactory.unset('global');
                                    $rootScope.$emit('app-error', {err: err, silent: true});
                                });
                        }
                    };

                    $scope.setAnswer = function(value) {
                        $scope.survey.answer_score = value;

                        $timeout(function() {
                            $scope.submitSurvey();
                        }, 500);
                    };

                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    };

                    $scope.showModal = function() {
                        $mdDialog
                            .show({
                                templateUrl: 'app/shared/directives/jf-survey-loader.tpl.html',
                                parent: angular.element(document.body),
                                clickOutsideToClose: false,
                                escapeToClose: false,
                                scope: $scope,
                                preserveScope: true
                            });

                    };

                    $scope.openStore = function() {
                        $window.open($scope.store, '_system');
                        $scope.closeDialog();
                    };

                    $scope.initSurvey = function() {
                        $scope.loadSurvey = undefined;
                        $scope.url = SurveyFactory.getUrl();
                        $scope.imageUrl = SurveyFactory.getImageUrl();
                        $scope.thankYou = false;
                        $scope.storeName = SurveyFactory.isMobile.Android() ? 'Play Store' : 'App Store';
                        $scope.googlePlayLink = 'market://details?id=de.jonnyfresh.jonnyfresh';
                        $scope.appleStoreLink = 'itms-apps://itunes.apple.com/app/jonnyfresh/id1024534584?mt=8';
                        $scope.store = SurveyFactory.isMobile.Android() ? $scope.googlePlayLink : $scope.appleStoreLink;
                        $scope.mobileAppMode = $rootScope.mobileAppMode;
                        $scope.survey = {
                            identity: undefined,
                            identity_type: 'email',
                            first_name: undefined,
                            last_name: undefined,
                            answer_score: undefined,
                            response: undefined
                        };
                        $scope.showFeedbackTextarea = false;

                        if (jfUser.isLoggedIn()) {
                            AccountUserProfileFactory
                                .get({
                                    'filter[user_id]': jfUser.get().id
                                })
                                .$promise
                                .then(function(result) {
                                    $scope.loadSurvey = SurveyFactory.showSurvey(result.data[0].attributes.frontend_data);
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $scope.loadSurvey = false;
                        }
                    };

                    jfController.init(['initSurvey'], $scope);
                }],
                link: function($scope) {
                    var listenForLoadSurvey = $scope.$watch('loadSurvey', function(newValue, oldValue) {
                        if (newValue !== oldValue && newValue === true) {
                            if (SurveyFactory.getDeviceType() === 'Computer') {
                                var script = angular.element(document.createElement('script'))[0];

                                script.type = 'text/javascript';
                                script.id = 'zl-website-overlay-loader';
                                script.async = true;
                                script.src = $scope.url;

                                script.onload = script.onreadystatechange = function() {
                                    $rootScope.$emit('jfCheckout:surveyScriptLoaded');
                                };
                                script.onerror = function(err) {
                                    $rootScope.$emit('app-error', {err: err, silent: true});
                                };

                                angular.element(document).find('body').append(script);
                            } else {
                                $scope.showModal();
                                $rootScope.$emit('jfCheckout:surveyScriptLoaded');
                            }
                        }
                    });

                    $scope.$on('$destroy', function() {
                        listenForLoadSurvey();
                    });
                }
            };
        }]
    );
/**
 * Mobile app download popup
 */
angular.module('jfApp')
    .directive(
        'jfMobileAppDownload',
        ['jfAppUpdate', '$mdDialog', '$localStorage', '$window', '$mdMedia', 'jfController', function(
            jfAppUpdate,
            $mdDialog,
            $localStorage,
            $window,
            $mdMedia,
            jfController
        ) {
            'use strict';

            return {
                restrict: 'E',
                replace: true,
                controller: ['$scope', function(
                    $scope
                ) {
                    $scope.downloadAndroid = function() {
                        $window.location = jfAppUpdate.googlePlayLink;
                    };

                    $scope.downloadIOS = function() {
                        $window.open(jfAppUpdate.appleStoreLink, '_system');
                    };

                    $scope.skip = function() {
                        $mdDialog.hide();
                    };

                    $scope.initMobileAppDownload = function() {
                        if (!$localStorage.mobileAppDownloadModalCounter) {
                            $localStorage.mobileAppDownloadModalCounter = 0;
                        }
                        if ($mdMedia('xs') || $mdMedia('sm')) {
                            if (
                                !$localStorage.mobileAppDownloadModalCounter || 
                                $localStorage.mobileAppDownloadModalCounter < 2
                            ) {
                                $mdDialog
                                    .show({
                                        templateUrl: 'app/shared/directives/jf-mobile-app-download.tpl.html',
                                        parent: angular.element(document.body),
                                        clickOutsideToClose: false,
                                        escapeToClose: false,
                                        scope: $scope,
                                        preserveScope: true
                                    });
                                $localStorage.mobileAppDownloadModalCounter = $localStorage.mobileAppDownloadModalCounter + 1;
                            }
                        }
                    };

                    jfController.init(['initMobileAppDownload'], $scope);
                }],
            };
        }]
    );
/**
 * My Orders account directive
 */
angular.module('jfApp')
    .directive(
        'jfMyOrders',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/shared/directives/jf-my-orders.directive.html',
                scope: {
                    status: '@'
                },
                controller: ['$scope', '$rootScope', '$q', '$interval', '$filter', '$anchorScroll', '$mdMedia', 'BooksOrdersFactory', 'AccountFactory', 'JF_CONFIG', 'OrderFactory', 'SpinnerFactory', 'LogisticTripsFactory', 'jfUser', 'jfDialog', 'jfController', function (
                    $scope,
                    $rootScope,
                    $q,
                    $interval,
                    $filter,
                    $anchorScroll,
                    $mdMedia,
                    BooksOrdersFactory,
                    AccountFactory,
                    JF_CONFIG,
                    OrderFactory,
                    SpinnerFactory,
                    LogisticTripsFactory,
                    jfUser,
                    jfDialog,
                    jfController
                ) {
                    $scope.fetchOrders = function(page, sort) {
                        var deferred = $q.defer();

                        var params = {
                            'filter[customer_id]' : jfUser.get().id,
                            sort: sort,
                            'page[size]': $scope.ordersPerPage,
                            'page[number]': page,
                            include: 'order_items',
                            'stats[total]': 'count',
                            'filter[type][not_eq][]': ['ReturnOrder', 'V20Order']
                        };

                        if (page === 1) {
                            $scope.orders = [];
                            params['page[size]'] = 3;
                        } else {
                            if (page === 2) {
                                // workaround to avoid load duplicated orders
                                $scope.ordersPage = $scope.ordersPage + 2;
                                params['page[number]'] = $scope.ordersPage;
                            }
                        }

                        if ($scope.status === 'active') {
                            params['filter[state][not_eq][]'] = ['completing', 'concluded', 'canceled'] ;
                        } else if ($scope.status === 'completed') {
                            params['filter[state][]'] = ['completing', 'concluded'];
                        } else if ($scope.status === 'canceled') {
                            var today = new Date(),
                            last30Days = new Date(today.setDate(today.getDate() - 30)),
                            month = last30Days.getMonth() + 1,
                            day = last30Days.getDate(),
                            year = last30Days.getFullYear();

                            params['filter[state]'] ='canceled';
                            params['filter[created_at][gte]'] = year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
                        }

                        BooksOrdersFactory
                            .get(params)
                            .$promise
                            .then(function(orders) {
                                if (orders.data.length > 0) {
                                    $scope.totalOrders = orders.meta.stats.total.count;

                                    var ordersList = [];

                                    angular.forEach(orders.data, function(order) {
                                        ordersList.push(order.attributes.logistic_order_id);

                                        var orderObj = {
                                            id: order.id,
                                            details: order,
                                            items: [],
                                            trips: {}
                                        };

                                        angular.forEach(orders.included, function(orderItem) {
                                            angular.forEach(order.relationships.order_items.data, function(orderRelItem) {
                                                if (orderItem.id === orderRelItem.id) {
                                                    orderObj.items.push(orderItem);
                                                }
                                            });
                                        });

                                        $scope.orders.push(orderObj);
                                    });

                                    $scope.noMoreOrders = false;

                                    $scope
                                        .fetchOrderTrips(ordersList)
                                        .then(function() {
                                            deferred.resolve();
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    $scope.noMoreOrders = true;
                                    deferred.resolve();
                                }
                            }, function(err) {
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.refreshOrders = function() {
                        if (!$scope.ordersRefreshInProgress && $scope.ordersToRefresh.length > 0) {
                            $scope.ordersRefreshInProgress = true;

                            $scope
                                .fetchOrderTrips($scope.ordersToRefresh, true)
                                .then(function() {
                                    $scope.ordersRefreshInProgress = false;
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err, silent: true});
                                    $scope.ordersRefreshInProgress = false;
                                });
                        }
                    };

                    $scope.fetchOrderTrips = function(ordersList, refreshAction) {
                        var deferred = $q.defer();

                        LogisticTripsFactory
                            .get({
                                'filter[order_id][]': ordersList,
                                'page[number]': 1,
                                'page[size]': 999
                            })
                            .$promise
                            .then(function(trips) {
                                angular.forEach($scope.orders, function(order) {
                                    angular.forEach(trips.data, function(trip) {
                                        if (order.details.attributes.logistic_order_id === trip.attributes.order_id) {
                                            if (angular.isUndefined(refreshAction) || refreshAction === false) {
                                                if (
                                                    (
                                                        angular.isDefined(trip.attributes.schedule_info.estimation_time) &&
                                                        trip.attributes.schedule_info.estimation_time !== null
                                                    ) ||
                                                    (
                                                        angular.isDefined(trip.attributes.checkpoints.estimated_concluded_at) &&
                                                        trip.attributes.checkpoints.estimated_concluded_at !== null
                                                    )
                                                ) {
                                                    $rootScope.sendCustomGAEvent('trip estimated time - available', jfUser.get().id, trip.id, new Date().getTime());
                                                } else {
                                                    $rootScope.sendCustomGAEvent('trip estimated time - not available', jfUser.get().id, trip.id, new Date().getTime());
                                                }
                                            }

                                            order.trips[trip.type] = trip;

                                            // We need to refresh orders, that can get new Estimated Arrival Time from BE
                                            if (
                                                ['commenced', 'in_scheduling', 'scheduled', 'in_transit'].indexOf(trip.attributes.state) > -1
                                            ) {
                                                if ($scope.ordersToRefresh.indexOf(trip.attributes.order_id) === -1) {
                                                    $scope.ordersToRefresh.push(trip.attributes.order_id);
                                                }
                                            } else {
                                                if ($scope.ordersToRefresh.indexOf(trip.attributes.order_id) > -1) {
                                                    $scope.ordersToRefresh.splice($scope.ordersToRefresh.indexOf(trip.attributes.order_id), 1);
                                                }
                                            }
                                        }
                                    });
                                });

                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.editAddress = function(addressType, orderId) {
                        if ($scope.changeAddress !== orderId) {
                            $scope.changeAddress = orderId;
                            $scope.getAllUserAddresses();
                        } else {
                            $scope.changeAddress = null;
                        }
                    };

                    $scope.changePickupAddress = function() {
                        // TODO: to be implemented
                    };

                    $scope.changeDeliveryAddress = function() {
                        // TODO: to be implemented
                    };

                    $scope.changeBillingAddress = function() {
                        // TODO: to be implemented
                    };

                    $scope.changeOrderAddress = function(addressType, orderId) {
                        switch(addressType) {
                            case 'pickup':
                                $scope.changePickupAddress(orderId);
                                break;
                            case 'delivery':
                                $scope.changeDeliveryAddress(orderId);
                                break;
                            case 'billing':
                                $scope.changeBillingAddress(orderId);
                                break;
                        }
                    };

                    $scope.getAllUserAddresses = function() {
                        if (angular.isDefined(jfUser.get().id)) {
                            SpinnerFactory.set('account-my-orders-' + $scope.status);
                            AccountFactory
                                .fetchUserPrivateAddresses()
                                .then(function(addresses) {
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                    $scope.addresses = addresses;
                                }, function(err) {
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    $scope.getOrder = function(page, order) {
                        if (!$scope.noMoreOrders || page === 1) {
                            SpinnerFactory.set('account-my-orders-' + $scope.status);

                            $scope.loadInProgress = true;

                            $scope
                                .fetchOrders(page, order)
                                .then(function() {
                                    $scope.loadInProgress = false;
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                }, function(err) {
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    $scope.loadMoreOrders = function($index, $inview) {
                        if (
                            $scope.showOrders !== false &&
                            $scope.loadInProgress === false &&
                            !$scope.noMoreOrders && $inview === true
                        ) {
                            $scope.ordersPage = $scope.ordersPage + 1;
                            $scope.getOrder($scope.ordersPage, $scope.ordersSort);
                        }
                    };

                    $scope.isEditable = function(order) {
                        if (['completing', 'concluded', 'canceled'].indexOf(order.details.attributes.state) > -1) {
                            return false;
                        }
                        return true;
                    };

                    $scope.gotoTop = function() {
                        $anchorScroll('my-orders-top');
                    };

                    $scope.isPickupMissed = function() {
                        return (
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers.reset_pickup) &&
                            $scope.order.details.attributes.editable_content_by_customers.reset_pickup === true
                        );
                    };

                    $scope.isDeliveryMissed = function() {
                        return (
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers.reset_delivery) &&
                            $scope.order.details.attributes.editable_content_by_customers.reset_delivery === true
                        );
                    };

                    $scope.confirmTimeSlotChanges = function() {
                        var dataToUpdate = {
                            company_id: $scope.order.details.attributes.company_id
                        };

                        if (
                            $scope.isPickupMissed() ||
                            (
                                angular.isDefined($scope.oldPickupStart) &&
                                $scope.oldPickupStart !== $scope.order.details.attributes.scheduled_pickup_start_ts
                            )
                        ) {
                            dataToUpdate.pickup_start_ts = $scope.order.details.attributes.scheduled_pickup_start_ts;
                            dataToUpdate.pickup_end_ts = $scope.order.details.attributes.scheduled_pickup_end_ts;
                        }

                        if (
                            $scope.isPickupMissed() ||
                            $scope.isDeliveryMissed() ||
                            (
                                angular.isDefined($scope.oldDeliveryStart) &&
                                $scope.oldDeliveryStart !== $scope.order.details.attributes.scheduled_delivery_start_ts
                            )
                        ) {
                            dataToUpdate.delivery_start_ts = $scope.order.details.attributes.scheduled_delivery_start_ts;
                            dataToUpdate.delivery_end_ts = $scope.order.details.attributes.scheduled_delivery_end_ts;
                        }

                        if (Object.keys(dataToUpdate).length === 0) {
                            jfDialog
                                .showAlert(
                                    $filter('translate')('ORDER_UPDATE_ERROR_TITLE'),
                                    $filter('translate')('ORDER_UPDATE_ERROR_CONTENT'),
                                    $filter('translate')('ORDER_UPDATE_ERROR_OK')
                                );
                            return false;
                        }

                        SpinnerFactory.set([
                            'account-my-orders-active',
                            'account-my-orders-completed',
                            'account-my-orders-canceled'
                        ]);

                        OrderFactory
                            .updateOrder(
                                $scope.order.details.id,
                                dataToUpdate
                            )
                            .then(function() {
                                SpinnerFactory.unset([
                                    'account-my-orders-active',
                                    'account-my-orders-completed',
                                    'account-my-orders-canceled'
                                ]);
                                $scope.showConfirmationMessage();
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-my-orders-active',
                                    'account-my-orders-completed',
                                    'account-my-orders-canceled'
                                ]);

                                if (err.status === 422) {
                                    var invalidTimeSlots = false;

                                    angular.forEach(err.data.errors, function(err) {
                                        if (
                                            invalidTimeSlots === false &&
                                            (
                                                err.source.pointer === '/data/attributes/pickup_trip' ||
                                                err.source.pointer === '/data/attributes/delivery_trip'
                                            )
                                        ) {
                                            invalidTimeSlots = true;
                                        }
                                    });

                                    if (invalidTimeSlots) {
                                        jfDialog
                                            .showAlert(
                                                $filter('translate')('INVALID_TIME_SLOTS_ERROR_TITLE'),
                                                $filter('translate')('INVALID_TIME_SLOTS_ERROR_CONTENT'),
                                                $filter('translate')('INVALID_TIME_SLOTS_ERROR_OK'),
                                                function() {
                                                    $scope.showCancelConfirmationMessage = false;
                                                    $scope.showOrders = true;
                                                    $scope.showPickup = false;
                                                    $scope.showDelivery = false;
                                                    $scope.showConfirmation = false;
                                                    $scope.getOrder(1, $scope.ordersSort);
                                                },
                                                false
                                            );
                                    } else {
                                        $rootScope.$emit('app-error', {err: err});
                                    }
                                } else {
                                    $rootScope.$emit('app-error', {err: err});
                                }
                            });
                    };

                    $scope.openPickupTimeSlotSelector = function() {
                        $scope.showAppointmentConfirmationMessage = false;
                        $scope.showCancelConfirmationMessage = false;
                        $scope.showOrders = false;
                        $scope.showPickup = true;
                        $scope.showDelivery = false;
                    };

                    $scope.openDeliveryTimeSlotSelector = function() {
                        $scope.showAppointmentConfirmationMessage = false;
                        $scope.showCancelConfirmationMessage = false;
                        $scope.showOrders = false;
                        $scope.showPickup = false;
                        $scope.showDelivery = true;
                    };

                    $scope.closePickupTimeSlotSelector = function() {
                        $scope.gotoTop();
                        $scope.showPickup = false;
                        $scope.showConfirmation = false;
                        $scope.showOrders = true;
                    };

                    $scope.closeDeliveryTimeSlotSelector = function(confirm) {
                        $scope.gotoTop();
                        $scope.showDelivery = false;
                        $scope.showConfirmation = confirm;
                        $scope.showOrders = false;

                        if (!confirm) {
                            $scope.showOrders = true;
                            $scope.getOrder(1, $scope.ordersSort);
                        }
                    };

                    $scope.showConfirmationMessage = function() {
                        $scope.showAppointmentConfirmationMessage = true;
                        $scope.showCancelConfirmationMessage = false;
                        $scope.showOrders = true;
                        $scope.showPickup = false;
                        $scope.showDelivery = false;
                        $scope.showConfirmation = false;
                        $scope.getOrder(1, $scope.ordersSort);
                    };

                    $scope.allowEditPickup = function(order) {
                        return angular.isDefined(order) &&
                            angular.isDefined(order.details) &&
                            angular.isDefined(order.details.attributes) &&
                            angular.isDefined(order.details.attributes.editable_content_by_customers) &&
                            order.details.attributes.editable_content_by_customers.pickup_appointment;
                    };


                    $scope.initAccountMyOrdersView = function() {
                        $scope.orders = [];
                        $scope.showOrders = true;
                        $scope.ordersPage = 1;
                        $scope.ordersPerPage = 1;
                        $scope.defaultOrderSort = JF_CONFIG.defaultOrderSort;
                        $scope.ordersSort = JF_CONFIG.defaultOrderSort;
                        $scope.totalOrders = 0;
                        $scope.noMoreOrders = false;
                        $scope.loadInProgress = false;
                        $scope.showPickup = false;
                        $scope.showDelivery = false;
                        $scope.showConfirmation = false;
                        $scope.documents = null;
                        $scope.changeAddress = false;
                        $scope.editOrder = {};
                        $scope.showCancelConfirmationMessage = false;
                        $scope.showAppointmentConfirmationMessage = false;
                        $scope.ordersToRefresh = [];
                        $scope.ordersRefreshInProgress = false;

                        $scope.$mdMedia = $mdMedia;
                        $scope.countObjKeys = $rootScope.countObjKeys;
                        $scope.jfShared = $rootScope.jfShared;

                        $scope.getOrder($scope.ordersPage, $scope.ordersSort);

                        var cancelMessageListener = $rootScope.$on('jfOrder:cancel-message', function(event, order) {
                            $scope.showCancelConfirmationMessage = true;
                            $scope.showAppointmentConfirmationMessage = false;
                            $scope.order_no = order.details.attributes.order_no;
                            $scope.getOrder(1, $scope.ordersSort);
                        });

                        var appointMessageListener = $rootScope.$on('jfOrder:show-confirmation', function() {
                            $scope.closeDeliveryTimeSlotSelector(true);
                        });

                        var openPickupListener = $rootScope.$on('jfOrder:open-pickup', function(event, order) {
                            $scope.order = angular.copy(order);
                            $scope.oldPickupStart = order.details.attributes.scheduled_pickup_start_ts;
                            $scope.openPickupTimeSlotSelector();
                        });

                        var openDeliveryListener = $rootScope.$on('jfOrder:open-delivery', function(event, order) {
                            $scope.order = angular.copy(order);
                            $scope.oldDeliveryStart = order.details.attributes.scheduled_delivery_start_ts;
                            $scope.openDeliveryTimeSlotSelector();
                        });

                        var ordersRefresher = $interval(function() {
                            $scope.refreshOrders();
                        }, 5000);

                        $scope.$on('$destroy', function() {
                            cancelMessageListener();
                            appointMessageListener();
                            openPickupListener();
                            openDeliveryListener();
                            $interval.cancel(ordersRefresher);
                        });
                    };

                    jfController.init(['initAccountMyOrdersView'], $scope);
                }]
            };
        }
    );

/**
 *  jf App Summary info directive
 */
angular.module('jfApp')
    .directive(
        'jfOrderSummaryInfo',
        function(
        ) {
            'use strict';

            return {
                restrict: 'E',
                scope: {
                    order: '=',
                    boxTitle: '@',
                    editable: '=',
                    status: '='
                },
                replace: true,
                templateUrl: 'app/shared/directives/jf-order-summary-info.directive.html',
                controller: ['$scope', '$rootScope', '$localStorage', '$anchorScroll', '$translate', '$mdMedia', '$window', '$filter', 'BooksPaymentMethodsFactory', 'BooksOrdersFactory', 'CheckoutFactory', 'OrderFactory', 'BooksOrderSlipsFactory', 'NotificationInvoiceDocumentsFactory', 'NotificationInvoiceDetailsDocumentsFactory', 'ActionCableConfig', 'ActionCableChannel', 'ActionCableSocketWrangler', 'SpinnerFactory', 'base64', 'jfController', 'jfDialog', 'jfUser', 'jfHelper', 'jfJsonApi', 'LanguageFactory', 'JF_SHARED_CONFIG', 'JF_CONFIG', function(
                    $scope,
                    $rootScope,
                    $localStorage,
                    $anchorScroll,
                    $translate,
                    $mdMedia,
                    $window,
                    $filter,
                    BooksPaymentMethodsFactory,
                    BooksOrdersFactory,
                    CheckoutFactory,
                    OrderFactory,
                    BooksOrderSlipsFactory,
                    NotificationInvoiceDocumentsFactory,
                    NotificationInvoiceDetailsDocumentsFactory,
                    ActionCableConfig,
                    ActionCableChannel,
                    ActionCableSocketWrangler,
                    SpinnerFactory,
                    base64,
                    jfController,
                    jfDialog,
                    jfUser,
                    jfHelper,
                    jfJsonApi,
                    LanguageFactory,
                    JF_SHARED_CONFIG,
                    JF_CONFIG
                ) {
                    $scope.prepareCurrentUser = function() {
                        if (angular.isDefined($rootScope.jfShared.jfUser.firstName) && $rootScope.jfShared.jfUser.firstName !== null) {
                            try {
                                $scope.currentUser.firstName = base64.decode($rootScope.jfShared.jfUser.firstName);
                            } catch(err) {
                                $scope.currentUser.firstName = $rootScope.jfShared.jfUser.firstName;
                            }

                        }

                        if (angular.isDefined($rootScope.jfShared.jfUser.lastName) && $rootScope.jfShared.jfUser.lastName !== null) {
                            try {
                                $scope.currentUser.lastName = base64.decode($rootScope.jfShared.jfUser.lastName);
                            } catch(err) {
                                $scope.currentUser.lastName = $rootScope.jfShared.jfUser.lastName;
                            }
                        }

                        if (angular.isDefined($rootScope.jfShared.jfUser.phoneNo) && $rootScope.jfShared.jfUser.phoneNo !== null) {
                            try {
                                $scope.currentUser.phoneNo = base64.decode($rootScope.jfShared.jfUser.phoneNo);
                            } catch(err) {
                                $scope.currentUser.phoneNo = $rootScope.jfShared.jfUser.phoneNo;
                            }
                        }
                    };

                    $scope.prepareOrderNumber = function() {
                        var orderNumber = $scope.order.details.attributes.order_no;
                        return orderNumber.substring(0, orderNumber.length -5) + ' - ' + orderNumber.substring(orderNumber.length-5, orderNumber.length);
                    };

                    $scope.addCalendarEvent = function(tripType) {
                        CheckoutFactory
                            .fetchOrderTrip($scope.order.details.attributes.logistic_order_id, tripType, true)
                            .then(function(trip) {
                                if ($rootScope.mobileAppMode) {
                                    var eventTitle = '',
                                        eventLocation = '',
                                        eventNote = '',
                                        eventStart = '',
                                        eventEnd = '';

                                    var jcalData = $window.ICAL.parse(trip.attributes.ical_content);
                                    var vcalendar = new $window.ICAL.Component(jcalData);
                                    var vevent = vcalendar.getFirstSubcomponent('vevent');

                                    eventTitle = vevent.getFirstPropertyValue('summary');
                                    eventLocation = vevent.getFirstPropertyValue('location');
                                    eventNote = vevent.getFirstPropertyValue('description');

                                    var startDate = vevent.getFirstPropertyValue('dtstart');
                                    var endDate = vevent.getFirstPropertyValue('dtend');

                                    // Creating new date from date properties than toString because in IOS had an issue:
                                    // it was adding timezone in time
                                    eventStart = new Date(startDate.year, startDate.month-1, startDate.day, startDate.hour, startDate.minute, startDate.second);
                                    eventEnd = new Date(endDate.year, endDate.month-1, endDate.day, endDate.hour, endDate.minute, endDate.second);

                                    if (angular.isDefined($window.plugins) && angular.isDefined($window.plugins.calendar)) {
                                        $window.plugins.calendar.createEventInteractively(eventTitle, eventLocation, eventNote, eventStart, eventEnd);
                                    }

                                } else {
                                    jfHelper.createAndDownloadFile('calendar_event.ics', 'text/calendar', trip.attributes.ical_content);
                                }
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.fetchPaymentMethod = function() {
                        SpinnerFactory.set('account-my-orders-' + $scope.status);

                        BooksPaymentMethodsFactory
                            .get({
                                id: $scope.order.details.attributes.payment_method_id
                            })
                            .$promise
                            .then(function(paymentMethod) {
                                $scope.paymentMethodName = paymentMethod.data.attributes.localized_name[LanguageFactory.getLocale()];
                                SpinnerFactory.unset('account-my-orders-' + $scope.status);
                            }, function(err) {
                                SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.fetchSlips = function() {
                        SpinnerFactory.set('account-my-orders-' + $scope.status);

                        BooksOrderSlipsFactory
                            .get(
                                {
                                    orderId: $scope.order.details.id,
                                }
                            )
                            .$promise
                            .then(function(orderSlips) {
                                SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                if (jfHelper.countObjKeys(orderSlips.data) > 0) {
                                    $scope.order.slips = {};

                                    angular.forEach(orderSlips.data, function(orderSlipDetails, orderSlipType) {
                                        $scope.order.slips[orderSlipType] = orderSlipDetails;
                                    });

                                    if (angular.isUndefined($scope.order.slips.invoices) || Object.keys($scope.order.slips.invoices).length === 0) {
                                        $scope.showInvoiceMessage = true;
                                    }
                                } else {
                                    $scope.showInvoiceMessage = true;
                                }
                            }, function(err) {
                                SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.prepareCompanyInformation = function() {
                        if (
                            angular.isDefined($localStorage.companyDetails) &&
                            $localStorage.companyDetails !== null &&
                            $localStorage.companyDetails.pays_for_user === true &&
                            $localStorage.catalogType === JF_CONFIG.accountTypes.company
                        ) {
                            $scope.companyInformation = $localStorage.companyDetails;
                        }
                    };

                    $scope.showOrderCancelConfirmation = function() {
                        jfDialog
                            .showConfirm(
                                $filter('translate')('ORDER_CANCEL_CONFIRM_TITLE'),
                                $filter('translate')('ORDER_CANCEL_CONFIRM_CONTENT'),
                                $filter('translate')('ORDER_CANCEL_CONFIRM_OK'),
                                $filter('translate')('ORDER_CANCEL_CONFIRM_CANCEL'),
                                function() {
                                    $scope.cancelOrder();
                                }
                            );
                    };

                    $scope.cancelOrder = function() {
                        SpinnerFactory.set('account-my-orders-' + $scope.status);

                        BooksOrdersFactory
                            .delete(
                                { id: $scope.order.details.id }
                            )
                            .$promise
                            .then(function() {
                                SpinnerFactory.unset('account-my-orders-' + $scope.status);

                                $scope.gotoTop();
                                $rootScope.$emit('jfOrder:cancel-message', $scope.order);
                            }, function(err) {
                                SpinnerFactory.unset('account-my-orders-' + $scope.status);

                                if (err.status === 422) {
                                    jfDialog
                                    .showAlert(
                                        $filter('translate')('ORDER_CANCEL_ERROR_TITLE'),
                                        err.data.errors[0].meta.message,
                                        $filter('translate')('ORDER_CANCEL_ERROR_OK')
                                    );
                                    $rootScope.$emit('app-error', {err: err, silent: true});
                                }
                            });
                    };

                    $scope.openPickup = function() {
                        $scope.gotoTop();
                        $rootScope.$emit('jfOrder:open-pickup', $scope.order);
                    };

                    $scope.openDelivery = function() {
                        $scope.gotoTop();
                        $rootScope.$emit('jfOrder:open-delivery', $scope.order);
                    };

                    $scope.gotoTop = function() {
                        $anchorScroll('my-orders-top');
                    };

                    $scope.isClosed = function() {
                        return ['completing', 'completed', 'concluded', 'canceled'].indexOf($scope.order.details.attributes.state) > -1;
                    };

                    $scope.isConcluded = function() {
                        return ['completing', 'completed', 'concluded'].indexOf($scope.order.details.attributes.state) > -1;
                    };

                    $scope.isPickupMissed = function() {
                        return $scope.editable &&
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers.reset_pickup) &&
                            $scope.order.details.attributes.editable_content_by_customers.reset_pickup === true;
                    };

                    $scope.isDeliveryMissed = function() {
                        return $scope.editable &&
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers.reset_delivery) &&
                            $scope.order.details.attributes.editable_content_by_customers.reset_delivery === true;
                    };

                    $scope.isMissed = function() {
                        return (
                            (
                                angular.isDefined($scope.order.details) &&
                                angular.isDefined($scope.order.details.attributes) &&
                                angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                                angular.isDefined($scope.order.details.attributes.editable_content_by_customers.reset_pickup) &&
                                $scope.order.details.attributes.editable_content_by_customers.reset_pickup === true
                            ) ||
                            (
                                angular.isDefined($scope.order.details) &&
                                angular.isDefined($scope.order.details.attributes) &&
                                angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                                angular.isDefined($scope.order.details.attributes.editable_content_by_customers.reset_delivery) &&
                                $scope.order.details.attributes.editable_content_by_customers.reset_delivery === true
                            )
                        );
                    };

                    $scope.isTripDone = function(tripType, status) {
                        return (
                            $scope.editable &&
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            !$scope.order.details.attributes.editable_content_by_customers[tripType + '_appointment'] &&
                            $scope.order.details.attributes['state_for_' + tripType] === status &&
                            !$scope.isClosed()
                        );
                    };

                    $scope.showDriverInTransit = function(type) {
                        var today = $filter('date')(new Date(), 'yyyy-MM-dd');
                        return $scope.order.details.attributes['state_for_' + type] !== 'concluded' &&
                            $scope.order.details.attributes.state !== 'canceled' &&
                            $scope.order.details.attributes['state_for_' + type] !== 'impedimented' &&
                            $scope.order.details.attributes['scheduled_' + type + '_date'] === today;
                    };

                    $scope.isTripEditable = function(type) {
                        return $scope.editable &&
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            $scope.order.details.attributes.editable_content_by_customers[type + '_appointment'] &&
                            !$scope.isClosed();
                    };

                    $scope.showCancelButton = function() {
                        return ($scope.editable &&
                            angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            $scope.order.details.attributes.editable_content_by_customers.cancel_order) ||
                            (
                                $scope.editable &&
                                ($scope.isPickupMissed() &&
                                !$scope.isDeliveryMissed())
                            );
                    };

                    $scope.getDocument = function() {
                        NotificationInvoiceDocumentsFactory
                            .save(
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.invoices,
                                    {
                                        websocket_params: {
                                            identifier: jfUser.get().id
                                        },
                                        invoice_id: $scope.order.slips.invoices.invoice_id,
                                        invoice_date: $scope.order.slips.invoices.invoice_date,
                                        invoice_no: $scope.order.slips.invoices.invoice_no
                                    }
                                )
                            )
                            .$promise
                            .then(function(documentResponse) {
                                if (documentResponse.data.attributes.url !== null) {
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status, null);

                                    $scope.closeActionCable();

                                    $window.open(documentResponse.data.attributes.url, '_system');
                                }
                            }, function(err) {
                                SpinnerFactory.unset('account-my-orders-' + $scope.status, null);
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.triggerActionCable = function() {
                        $scope.consumerHandler = new ActionCableChannel(JF_CONFIG.actionCable.channels.jobs);

                        $scope.consumerHandler.onConfirmSubscription(function() {
                            $scope.getDocument();
                        });

                        var inboundCallback = function (incomingMessage) {
                            SpinnerFactory.unset('account-my-orders-' + $scope.status, null);

                            if (
                                angular.isDefined(incomingMessage.message.args) &&
                                (
                                    (
                                        angular.isDefined(incomingMessage.message.args.invoice_id) &&
                                        incomingMessage.message.args.invoice_id === $scope.order.slips.invoices.invoice_id
                                    )
                                ) &&
                                angular.isDefined(incomingMessage.message.websocket) &&
                                angular.isDefined(incomingMessage.message.websocket.identifier) &&
                                incomingMessage.message.websocket.identifier === jfUser.get().id
                            ) {
                                $scope.closeActionCable();

                                $window.open(incomingMessage.message.websocket.redirect_url, '_system');
                            }
                        };

                        $scope.consumerHandler.subscribe(inboundCallback);

                        ActionCableSocketWrangler.start();
                    };

                    $scope.downloadInvoice = function() {
                        SpinnerFactory.set('account-my-orders-' + $scope.status, $translate.instant('DOCUMENT_GENERATION'));

                        if (
                            angular.isDefined($scope.order.slips.invoices.company_invoicing_breakdown) &&
                            $scope.order.slips.invoices.company_invoicing_breakdown === true
                        ) {
                            NotificationInvoiceDetailsDocumentsFactory
                                .save(
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.invoiceDetails,
                                        {
                                            invoice_id: $scope.order.slips.invoices.invoice_id,
                                            invoice_date: $scope.order.slips.invoices.invoice_date,
                                            invoice_no: $scope.order.slips.invoices.invoice_no,
                                            websocket_params: {
                                                identifier: jfUser.get().id
                                            }
                                        }
                                    )
                                )
                                .$promise
                                .then(function(documentResponse) {
                                    if (documentResponse.data.attributes.url !== null) {
                                        window.location = documentResponse.data.attributes.url;
                                    }

                                    $scope.triggerActionCable();
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $scope.triggerActionCable();
                        }
                    };

                    $scope.closeActionCable = function() {
                        if (angular.isDefined($scope.consumerHandler)) {
                            $scope.consumerHandler.unsubscribe();
                            ActionCableSocketWrangler.stop();
                            $scope.consumerHandler = undefined;
                        }
                    };

                    $scope.prepareEstimationTime = function(tripDetails) {
                        var estimationTime = tripDetails.checkpoints.estimated_concluded_at || tripDetails.schedule_info.estimation_time;

                        var originalEstimationTimeArr = estimationTime.split(':'),
                            currentDate = new Date();

                        var originalEstimation = new Date();
                        originalEstimation.setHours(originalEstimationTimeArr[0]);
                        originalEstimation.setMinutes(originalEstimationTimeArr[1]);
                        originalEstimation.setSeconds(0);

                        var estimatedArrivalStart = new Date();
                        estimatedArrivalStart.setHours(originalEstimationTimeArr[0]);
                        estimatedArrivalStart.setMinutes(originalEstimationTimeArr[1]);
                        estimatedArrivalStart.setMinutes(estimatedArrivalStart.getMinutes() - 15);
                        estimatedArrivalStart.setSeconds(0);

                        var estimatedArrivalEnd = new Date();
                        estimatedArrivalEnd.setHours(originalEstimationTimeArr[0]);
                        estimatedArrivalEnd.setMinutes(originalEstimationTimeArr[1]);
                        estimatedArrivalEnd.setMinutes(estimatedArrivalEnd.getMinutes() + 15);
                        estimatedArrivalEnd.setSeconds(0);

                        var scheduledStart = new Date(),
                            scheduledStartTimeArr = tripDetails.start_time.split(':');
                        scheduledStart.setHours(scheduledStartTimeArr[0]);
                        scheduledStart.setMinutes(scheduledStartTimeArr[1]);
                        scheduledStart.setSeconds(0);

                        var startTimeToDisplay = scheduledStart > estimatedArrivalStart ? scheduledStart : estimatedArrivalStart;

                        var finalEstimatedStartTime = startTimeToDisplay.getHours() + ':' + (startTimeToDisplay.getMinutes() < 10 ? '0' : '') + startTimeToDisplay.getMinutes();

                        if (startTimeToDisplay < currentDate) {
                            if (currentDate > originalEstimation) {
                                finalEstimatedStartTime = originalEstimation.getHours() + ':' + (originalEstimation.getMinutes() < 10 ? '0' : '') + originalEstimation.getMinutes();
                            } else {
                                var newFinalDate = currentDate;
                                newFinalDate.setMinutes(currentDate.getMinutes() + 1);

                                finalEstimatedStartTime = newFinalDate.getHours() + ':' + (newFinalDate.getMinutes() < 10 ? '0' : '') + newFinalDate.getMinutes();
                            }
                        }

                        return finalEstimatedStartTime + '&nbsp;-&nbsp;'+estimatedArrivalEnd.getHours() + ':' + (estimatedArrivalEnd.getMinutes() < 10 ? '0' : '') + estimatedArrivalEnd.getMinutes();
                    };

                    $scope.isDriverDelayed = function(tripDetails) {
                        var estimationTime = tripDetails.checkpoints.estimated_concluded_at || tripDetails.schedule_info.estimation_time,
                            originalEstimationTimeArr = estimationTime.split(':'),
                            currentDate = new Date(),
                            estimatedArrivalEnd = new Date();

                        estimatedArrivalEnd.setHours(originalEstimationTimeArr[0]);
                        estimatedArrivalEnd.setMinutes(originalEstimationTimeArr[1]);
                        estimatedArrivalEnd.setMinutes(estimatedArrivalEnd.getMinutes() + 15);
                        estimatedArrivalEnd.setSeconds(0);

                        return currentDate > estimatedArrivalEnd;
                    };

                    $scope.initOrderSummary = function() {
                        if (ActionCableConfig.wsUri.indexOf('current_user_id') === -1) {
                            ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_user_id=' + jfUser.get().id;
                        }

                        $scope.formattedOrderDate = $filter('date')($scope.order.details.attributes.order_date, 'dd.MM.yyyy');
                        $scope.currentUser = {};
                        $scope.$mdMedia = $mdMedia;
                        $scope.currencySymbols = $rootScope.currencySymbols;
                        $scope.Math = $window.Math;
                        $scope.showInvoiceMessage = false;
                        $scope.pickupTripDoneButNotUloaded = false;
                        $scope.pickupNotScheduled = false;
                        $scope.deliveryNotScheduled = false;
                        $scope.isEnglishLocale = $localStorage.shopLocale && $localStorage.shopLocale.indexOf('en') > -1;
                        $scope.paymentMethods = JF_CONFIG.paymentMethods;

                        $scope.showPickupNotes = OrderFactory.showPickupNotes($scope.order.details);
                        $scope.showDeliveryNotes = OrderFactory.showDeliveryNotes($scope.order.details);
                        $scope.orderNumberFormatted = $scope.prepareOrderNumber();

                        if ($scope.order.details.attributes.state === JF_CONFIG.orderStates.commenced) {
                            $scope.pickupDate = $scope.order.details.attributes.pickup_date;
                            $scope.pickupStartTime = $scope.order.details.attributes.pickup_start_time;
                            $scope.pickupEndTime = $scope.order.details.attributes.pickup_end_time;
                            $scope.deliveryDate = $scope.order.details.attributes.delivery_date;
                            $scope.deliveryStartTime = $scope.order.details.attributes.delivery_start_time;
                            $scope.deliveryEndTime = $scope.order.details.attributes.delivery_end_time;
                        } else {
                            if ($scope.order.details.attributes.scheduled_pickup_date === null) {
                                $scope.pickupNotScheduled = true;
                                $scope.pickupDate = $scope.order.details.attributes.pickup_date;
                                $scope.pickupStartTime = $scope.order.details.attributes.pickup_start_time;
                                $scope.pickupEndTime = $scope.order.details.attributes.pickup_end_time;
                            } else {
                                $scope.pickupDate = $scope.order.details.attributes.scheduled_pickup_date;
                                $scope.pickupStartTime = $scope.order.details.attributes.scheduled_pickup_start_time;
                                $scope.pickupEndTime = $scope.order.details.attributes.scheduled_pickup_end_time;
                            }

                            if ($scope.order.details.attributes.scheduled_delivery_date === null) {
                                $scope.deliveryNotScheduled = true;
                                $scope.deliveryDate = $scope.order.details.attributes.delivery_date;
                                $scope.deliveryStartTime = $scope.order.details.attributes.delivery_start_time;
                                $scope.deliveryEndTime = $scope.order.details.attributes.delivery_end_time;
                            } else {
                                $scope.deliveryDate = $scope.order.details.attributes.scheduled_delivery_date;
                                $scope.deliveryStartTime = $scope.order.details.attributes.scheduled_delivery_start_time;
                                $scope.deliveryEndTime = $scope.order.details.attributes.scheduled_delivery_end_time;
                            }
                        }

                        $scope.prepareCurrentUser();
                        $scope.fetchPaymentMethod();
                        $scope.prepareCompanyInformation();

                        if ($scope.isConcluded()) {
                            $scope.fetchSlips();
                        }

                        if ($scope.showDriverInTransit('pickup') && !$scope.isTripDone('pickup', 'concluded')) {
                            SpinnerFactory.set('account-my-orders-' + $scope.status);
                            CheckoutFactory
                                .fetchOrderTrip($scope.order.details.attributes.logistic_order_id, JF_CONFIG.tripTypes.pickup, false)
                                .then(function(trip) {
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                    if (trip.attributes.state === 'in_transit') {
                                        $scope.pickupTripDoneButNotUloaded = true;
                                    }
                                }, function(err) {
                                    SpinnerFactory.unset('account-my-orders-' + $scope.status);
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    jfController.init(['initOrderSummary'], $scope);
                }]
            };
        }
    );

/**
 *  jf App Summary items directive
 */
angular.module('jfApp')
    .directive(
        'jfOrderSummaryItems',
        ['LanguageFactory', function(
            LanguageFactory
        ) {
            'use strict';

            return {
                restrict: 'E',
                scope: {
                    order: '=',
                    boxTitle: '@',
                    editable: '='
                },
                replace: true,
                templateUrl: 'app/shared/directives/jf-order-summary-items.directive.html',
                controller: ['$scope', '$rootScope', '$mdMedia', '$localStorage', '$window', 'jfController', function(
                    $scope,
                    $rootScope,
                    $mdMedia,
                    $localStorage,
                    $window,
                    jfController
                ) {
                    $scope.isClosed = function() {
                        return ['completing', 'completed', 'concluded', 'canceled'].indexOf($scope.order.details.attributes.state) > -1;
                    };

                    $scope.isCanceled = function() {
                        return $scope.order.details.attributes.state === 'canceled';
                    };

                    $scope.initOrderSummary = function() {
                        $scope.$mdMedia = $mdMedia;
                        $scope.currencySymbols = $rootScope.currencySymbols;
                        $scope.Math = $window.Math;
                        $scope.shopLocale = LanguageFactory.getLocale();
                    };

                    jfController.init(['initOrderSummary'], $scope);
                }]
            };
        }]
    );

/**
 *  jf App Download Notification directive
 */
angular.module('jfApp')
    .directive(
        'jfOrderSummary',
        function(
        ) {
            'use strict';

            return {
                restrict: 'E',
                scope: {
                    order: '=',
                    infoTitle: '@',
                    itemsTitle: '@',
                    editable: '=',
                    status: '='
                },
                replace: true,
                templateUrl: 'app/shared/directives/jf-order-summary.directive.html',
                controller: function() {

                }
            };
        }
    );

/**
 * Input text to uppercase
 */
angular
    .module('jfApp')
    .directive(
        'jfInputTextToUppercase',
        function() {
            'use strict';

            return {
                require: 'ngModel',
                restrict: 'A',
                link: function(scope, element, attrs, ctrl) {
                    // Code to allow only alpha numeric text
                    //
                    // element.on('keypress', function(e) {
                    //     var char = e.char || String.fromCharCode(e.charCode);
                    //     if (!/^[A-Z0-9]$/i.test(char)) {
                    //         e.preventDefault();
                    //         return false;
                    //     }
                    // });

                    ctrl.$formatters.push(function(value) {
                        if (ctrl.$isEmpty(value)) {
                            return value;
                        }
                        return value.toUpperCase();
                    });
                    ctrl.$parsers.push(function(value) {
                        if (ctrl.$isEmpty(value)) {
                            return value;
                        }
                        var formatedValue = value.toUpperCase();

                        if (ctrl.$viewValue !== formatedValue) {
                            ctrl.$setViewValue(formatedValue);
                            ctrl.$render();
                        }
                        return formatedValue;
                    });
                }
            };
        }
    );
(function() {
    'use strict';

    JfShrinkToolbar.$inject = ['$window', '$timeout'];
    angular
        .module('jfApp')
        .directive('jfShrinkToolbar', JfShrinkToolbar);

    /* @ngInject */
    function JfShrinkToolbar($window, $timeout) {

        var directive = {
            restrict: 'A',
            scope: {},
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element) {
            /* header DOM element with md-page-header attribute */
            var header = document.querySelector('[jf-shrink-toolbar-header]');
            /* Store header dimensions to initialize header styling */
            var baseDimensions = header.getBoundingClientRect();
            /* DOM element with md-header-title attribute (title in toolbar) */
            var title = angular.element(document.querySelector('[jf-shrink-toolbar-title]'));
            /* DOM element with md-header-picture attribute (picture in header) */
            var picture = angular.element(document.querySelector('[jf-shrink-toolbar-image]'));
            /* DOM element with main-fab class (a DOM element which contains the main float action button element) */
            /* The height of a toolbar by default in Angular Material */
            var legacyToolbarH = 56;
            /* The mid-height of a float action button by default in Angular Material */
            /* The zoom scale of the toolbar title when it's placed at the bottom of the header picture */
            var titleZoom = 1.5;
            /* The primary color palette used by Angular Material */
            var primaryColor = [1,132,197];

            function styleInit() {
                title.css('position', 'relative');
                title.css('transform-origin', '24px');
                title.css('visibility', 'hidden');
            }

            function handleStyle(dim) {
                if ((dim.bottom-baseDimensions.top) > legacyToolbarH) {
                    title.css('top', ((dim.bottom-baseDimensions.top)-legacyToolbarH)+'px');
                    element.css('height', (dim.bottom-baseDimensions.top)+'px');
                    title.css('transform','scale('+((titleZoom-1)*ratio(dim)+1)+','+((titleZoom-1)*ratio(dim)+1)+')');
                    title.css('visibility', 'hidden');
                } else {
                    title.css('top', '0px');
                    element.css('height', legacyToolbarH+'px');
                    title.css('visibility', 'block');
                    title.css('transform','scale(1,1)');
                    title.css('visibility', 'visible');
                }
                element.css('background-color','rgba('+primaryColor[0]+','+primaryColor[1]+','+primaryColor[2]+','+(1-ratio(dim))+')');
                picture.css('background-position','50% '+(ratio(dim)*50)+'%');
                /* Uncomment the line below if you want shadow inside picture (low performance) */
                // element.css('box-shadow', '0 -'+(dim.height*3/4)+'px '+(dim.height/2)+'px -'+(dim.height/2)+'px rgba(0,0,0,'+ratio(dim)+') inset');
            }

            function ratio(dim) {
                var r = (dim.bottom - baseDimensions.top) / dim.height;
                if (r < 0) {
                    return 0;
                }
                if (r > 1) {
                    return 1;
                }
                return Number(r.toString().match(/^\d+(?:\.\d{0,2})?/));
            }

            $timeout(function() {
                styleInit();
                handleStyle(header.getBoundingClientRect());
            }, 100);

            /* Scroll event listener */
            document.querySelector('[jf-scrollable]').addEventListener('scroll', function () {
                var dimensions = header.getBoundingClientRect();
                handleStyle(dimensions);
                scope.$apply();
            });

            /* Resize event listener */
            angular.element($window).bind('resize', function () {
                baseDimensions = header.getBoundingClientRect();
                var dimensions = header.getBoundingClientRect();
                handleStyle(dimensions);
                scope.$apply();
            });

        }
    }
})();
/**
 * Laundry Basket Desktop directive
 */
angular.module('jfApp')
    .directive(
        'laundryBasketDesktop',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/blocks/cart/directives/laundry-basket-desktop.html',
                scope: {
                    cartModel: '=?',
                    orderId: '=?',
                    orderDetails: '=?'
                },
                controller: ['$scope', '$rootScope', '$state', '$localStorage', '$filter', 'BooksOrdersOrderItemsFactory', 'OrderFactory', 'CheckoutFactory', 'SpinnerFactory', 'CustomerAppHelpersFactory', 'jfController', 'jfUser', function(
                    $scope,
                    $rootScope,
                    $state,
                    $localStorage,
                    $filter,
                    BooksOrdersOrderItemsFactory,
                    OrderFactory,
                    CheckoutFactory,
                    SpinnerFactory,
                    CustomerAppHelpersFactory,
                    jfController,
                    jfUser
                ) {
                    $scope.goToCheckout = function() {
                        $rootScope.sendGAEvent('catalogPage', 'goToCheckoutButton');

                        if ($rootScope.order.details.attributes.items_number === 0) {
                            $rootScope.sendGAEvent('catalogPage', 'goToCheckoutButtonNoItems');
                        }

                        $scope.orderError = false;

                        if (parseFloat($rootScope.order.details.attributes.total_amount) < parseFloat($scope.minOrderValue)) {
                            $scope.orderError = true;
                        } else {
                            $state.go('checkout');
                        }
                    };

                    $scope.goToConfirmationPageDesktop = function() {
                        $rootScope.sendGAEvent('checkoutPage', 'confirmOrderButton');

                        $rootScope.$emit('jfCheckout:orderCommit');
                    };

                    $scope.saveAgbSelection = CheckoutFactory.saveAgbSelection;
                    $scope.saveInvoicingFeeSelection = CheckoutFactory.saveInvoicingFeeSelection;

                    $scope.addToOrder = function(productId, quantity) {
                        $rootScope.sendGAEvent('catalogPage', 'addToCartFromCart');

                        SpinnerFactory.set('cart');

                        OrderFactory
                            .addToOrder(productId, quantity)
                            .then(function() {
                                SpinnerFactory.unset('cart');
                            }, function(err) {
                                SpinnerFactory.unset('cart');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.removeFromOrder = function(productId, quantity) {
                        $rootScope.sendGAEvent('catalogPage', 'removeFromCartFromCart');

                        SpinnerFactory.set('cart');

                        OrderFactory
                            .removeFromOrder(productId, quantity)
                            .then(function() {
                                SpinnerFactory.unset('cart');
                            }, function(err) {
                                SpinnerFactory.unset('cart');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.validateAgbCheckbox = function() {
                        if (CheckoutFactory.userAcceptedCurrentAgb() || (!CheckoutFactory.userAcceptedCurrentAgb() && $localStorage.order.additionalInfo.agb === true)) {
                            if ($rootScope.checkoutProcessing.steps.indexOf(4) === -1) {
                                $rootScope.checkoutProcessing.steps.push(4);
                            }
                        } else {
                            if ($rootScope.checkoutProcessing.steps.indexOf(4) > -1) {
                                $rootScope.checkoutProcessing.steps.splice($rootScope.checkoutProcessing.steps.indexOf(4), 1);
                            }
                        }
                    };

                    $scope.downloadAgb = function(e) {
                        e.stopPropagation();

                        if ($rootScope.mobileAppMode) {
                            e.preventDefault();
                            CustomerAppHelpersFactory.downloadFile($scope.legalDocuments.gtc.document_file.url, 'agb');
                        }
                    };

                    $scope.downloadPrivacyPolicy = function(e) {
                        e.stopPropagation();

                        if ($rootScope.mobileAppMode) {
                            e.preventDefault();
                            CustomerAppHelpersFactory.downloadFile($scope.legalDocuments.pp.document_file.url, 'datenschutz');
                        }
                    };

                    $scope.isLoadingCompleted = function() {
                        return SpinnerFactory.isLoadingCompleted();
                    };

                    $scope.initLaundryBasketDesktopView = function() {
                        CustomerAppHelpersFactory.fetchLegalDocuments().then(function(legalDocuments) {
                            $scope.legalDocuments = legalDocuments;
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });

                        $scope.minOrderValue = CheckoutFactory.getMinimumOrderValue();
                        $scope.orderError = $state.params.orderError;
                        $scope.Math = window.Math;
                        $scope.currencySymbols = $rootScope.currencySymbols;
                        $scope.$state = $state;
                        $scope.newsletterFlagSet = jfUser.get().newsletter;
                        $scope.userLoggedIn = $rootScope.jfShared.jfUser.id;
                        $scope.userAcceptedCurrentAgb = CheckoutFactory.userAcceptedCurrentAgb;
                        $scope.jfShared = $rootScope.jfShared;

                        if (angular.isDefined($localStorage.companyDetails) && $localStorage.companyDetails !== null && $localStorage.companyDetails.invoicing_fee) {
                            $scope.invoicingFee = $filter('round')($localStorage.companyDetails.invoicing_fee, 2);
                        }

                        if (angular.isUndefined($scope.cartModel)) {
                            $scope.cartModel = {};
                        }

                        if (angular.isDefined($scope.orderDetails)) {
                            $scope.cartModel.details = $scope.orderDetails;
                        }

                        if (angular.isDefined($scope.orderId)) {
                            SpinnerFactory.set('cart');

                            BooksOrdersOrderItemsFactory
                                .get({
                                    'filter[order_id]': $scope.orderId,
                                    'page[size]': 999,
                                    'page[number]': 1
                                })
                                .$promise
                                .then(function(orderItems) {
                                    SpinnerFactory.unset('cart');
                                    $scope.cartModel.items = OrderFactory.prepareOrderItems(orderItems.data);
                                }, function(err) {
                                    SpinnerFactory.unset('cart');
                                    $rootScope.$emit('app-error', {err: err});
                                });

                        }

                        var amountWatcher = $rootScope.$watch('order.details.attributes.total_amount', function(newVal, oldVal) {
                            if (newVal !== oldVal && newVal >= $scope.minOrderValue) {
                                $scope.orderError = false;
                            }
                        });

                        $scope.processOrderListener = $rootScope.$on('jfCheckout:processOrder', $scope.validateAgbCheckbox);

                        $scope.$on('$destroy', function() {
                            amountWatcher();

                            if (angular.isDefined($scope.processOrderListener)) {
                                $scope.processOrderListener();
                            }
                        });
                    };

                    jfController.init(['initLaundryBasketDesktopView'], $scope);
                }]
            };
        }
    );
/**
 * Laundry Basket Summary directive
 */
angular.module('jfApp')
    .directive(
        'laundryBasketSummary',
        ['$timeout', function(
            $timeout
        ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/blocks/cart/directives/laundry-basket-summary.html',
                scope: {
                    cartModel: '=',
                    itemsShortSummary: '=',
                    itemsFullSummary: '=',
                    minOrderValue: '='
                },
                controller: ['$scope', '$rootScope', '$mdMedia', '$window', '$state', 'OrderFactory', 'SpinnerFactory', 'CheckoutFactory', 'BooksOrdersOrderItemsFactory', 'jfController', function(
                    $scope,
                    $rootScope,
                    $mdMedia,
                    $window,
                    $state,
                    OrderFactory,
                    SpinnerFactory,
                    CheckoutFactory,
                    BooksOrdersOrderItemsFactory,
                    jfController
                ) {
                    $scope.checkHeight = function() {
                        if ($scope.showMoreItems) {
                            if ($scope.cartModel.items.length > 5) {
                                angular.element(document.querySelector('.jf-laundry-basket-summary-items')).css('max-height', 'inherit');
                            } else {
                                angular.element(document.querySelector('.jf-laundry-basket-summary-items')).css('max-height', $scope.maxLength + 'px');
                            }
                        } else {
                            if ($scope.cartModel.items.length > 5) {
                                angular.element(document.querySelector('.jf-laundry-basket-summary-items')).css('max-height', $scope.maxLength + 'px');
                            } else {
                                angular.element(document.querySelector('.jf-laundry-basket-summary-items')).css('max-height', 'inherit');
                            }
                        }
                    };

                    $scope.showMore = function() {
                        $scope.showMoreItems = !$scope.showMoreItems;
                        $scope.checkHeight();
                    };

                    $scope.addToOrder = function(productId, quantity) {
                        $rootScope.sendGAEvent('catalogPage', 'addToCartFromCart');

                        SpinnerFactory.set('cart');

                        OrderFactory
                            .addToOrder(productId, quantity)
                            .then(function() {
                                SpinnerFactory.unset('cart');
                                $scope.checkHeight();
                            }, function(err) {
                                SpinnerFactory.unset('cart');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.removeFromOrder = function(productId, quantity) {
                        $rootScope.sendGAEvent('catalogPage', 'removeFromCartFromCart');

                        SpinnerFactory.set('cart');

                        OrderFactory
                            .removeFromOrder(productId, quantity)
                            .then(function() {
                                SpinnerFactory.unset('cart');
                                $scope.checkHeight();
                            }, function(err) {
                                SpinnerFactory.unset('cart');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.initLaundryBasketSummaryView = function() {
                        $scope.$mdMedia = $mdMedia;
                        $scope.$state = $state;
                        $scope.currencySymbols = $rootScope.currencySymbols;
                        $scope.Math = $window.Math;
                        $scope.showMoreItems = false;

                        if (angular.isUndefined($scope.cartModel.items)) {
                            SpinnerFactory.set('cart');

                            BooksOrdersOrderItemsFactory
                                .get({
                                    'filter[order_id]': $scope.cartModel.details.id,
                                    'page[size]': 999,
                                    'page[number]': 1
                                })
                                .$promise
                                .then(function(orderItems) {
                                    SpinnerFactory.unset('cart');
                                    $scope.cartModel.items = OrderFactory.prepareOrderItems(orderItems.data);
                                }, function(err) {
                                    SpinnerFactory.unset('cart');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }

                        var orderChangeWatcher = $rootScope.$watch('order', function(newVal, oldVal) {
                            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                                $scope.minOrderValue = CheckoutFactory.getMinimumOrderValue();
                            }
                        }, true);

                        $scope.$on('$destroy', function() {
                            orderChangeWatcher();
                        });
                    };

                    jfController.init(['initLaundryBasketSummaryView'], $scope);
                }],
                link: function($scope) {
                    $timeout(function() {
                        if ($scope.cartModel.items.length > 5) {
                            var items = angular.element(document.querySelector('.jf-laundry-basket-summary-items'))[0];
                            if (angular.isDefined(items)) {
                                $scope.maxLength = 0;
                                for (var i=1; i <= 5; i++) {
                                    $scope.maxLength += items.children[i].offsetHeight;
                                }
                                // fallback in case of not able to get maxlength from items
                                if ($scope.maxLength === 0) {
                                    $scope.maxLength = 150;
                                }
                                angular.element(document.querySelector('.jf-laundry-basket-summary-items')).css('max-height', ($scope.maxLength+4) + 'px');
                            }
                        }
                    });
                }
            };
        }]
    );
/**
 * Laundry Basket Position Handler directive
 */
angular.module('jfApp')
    .directive(
        'jfLaundryBasketPositionHandler',
        ['$state', '$mdMedia', '$timeout', function(
            $state,
            $mdMedia,
            $timeout
        ) {
            'use strict';

            return {
                restrict: 'A',
                link: function($scope, element) {
                    if (angular.isUndefined($scope.orderDetails) && $mdMedia('gt-sm')) {
                        $timeout(function() {
                            var scrollContainer = angular.element(document.querySelectorAll('.jf-main-scrollable-section')),
                                mainContent = angular.element(document.querySelectorAll('.jf-main-content')),
                                mainToolbar = angular.element(document.querySelectorAll('.jf-top-bar')),
                                mainToolbarHeight = parseInt(window.getComputedStyle(mainToolbar[0]).height),
                                basketMarginBottom = parseInt(window.getComputedStyle(element[0]).marginBottom),
                                basketTopThreshold = $state.current.name === 'checkout' ? 50 : 0,
                                basketTitlePaddingTop = $state.current.name === 'checkout' ? 52 : 0,
                                basketBottomThreshold = $state.current.name === 'checkout' ? 0 : 30,
                                basketHeightListener = null,
                                getBasketHeight = function() {
                                    return element[0].clientHeight + basketMarginBottom + basketTitlePaddingTop;
                                },
                                stickinessAvailable = function() {
                                    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                                        productsToolbar = null,
                                        productsToolbarHeight = 0;

                                    if (productsToolbar === null || angular.isUndefined(productsToolbar[0])) {
                                        productsToolbar = angular.element(document.querySelectorAll('.jf-scroll-tabs-container'));
                                    }

                                    if (angular.isDefined(productsToolbar[0])) {
                                        productsToolbarHeight = productsToolbar[0].offsetHeight;
                                    }

                                    return mainContent[0].clientHeight > getBasketHeight() && (viewportHeight - mainToolbarHeight - productsToolbarHeight) > getBasketHeight();
                                },
                                disableStickiness = function() {
                                    element.css('transform', 'translateY(0px)');
                                    element.addClass('jf-stickiness-disabled');
                                },
                                enableStickiness = function() {
                                    element.removeClass('jf-stickiness-disabled');
                                },
                                validateStickiness = function() {
                                    if (!stickinessAvailable()) {
                                        disableStickiness();
                                    } else {
                                        enableStickiness();
                                    }
                                },
                                scrollHandler = function() {
                                    if (basketHeightListener !== null) {
                                        basketHeightListener();
                                    }

                                    if (!stickinessAvailable()) {
                                        disableStickiness();
                                    } else {
                                        if ((scrollContainer.scrollTop() + getBasketHeight() + basketBottomThreshold) <= mainContent[0].clientHeight) {
                                            if (scrollContainer.scrollTop() > basketTopThreshold) {
                                                element.css(
                                                    'transform',
                                                    'translateY(' + (scrollContainer.scrollTop() - basketTitlePaddingTop) + 'px)'
                                                );
                                            } else {
                                                element.css('transform', 'translateY(0px)');
                                            }
                                        } else {
                                            element.css(
                                                'transform',
                                                'translateY(' + (mainContent[0].clientHeight - getBasketHeight() - basketBottomThreshold) + 'px)'
                                            );
                                        }
                                    }
                                };

                            scrollContainer.on('scroll', scrollHandler);

                            $scope.$on('$routeChangeSuccess', function () {
                                validateStickiness();
                            });

                            basketHeightListener = $scope.$watch(function() {
                                validateStickiness();
                            });
                        }, 1);
                    }
                }
            };
        }]
    );
/**
 * Account Address directive
 */
angular.module('jfApp')
    .directive(
        'accountAddress',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/account-address.tpl.html',
                scope: {
                    cancelCallback: '=',
                    submitCallback: '=',
                    manageablePreferred: '=',
                    newAddressForm:  '='
                },
                controller: ['$scope', '$rootScope', '$state', '$window', '$filter', '$mdToast', '$mdDialog', '$mdMedia', '$localStorage', '$q', 'base64', 'jfJsonApi', 'jfLocation', 'AccountAddressesFactory', 'AccountUserProfileFactory', 'ContextGeocodingLocationsFactory', 'ContextPostalAddressesFactory', 'ContextPostalCodesFactory', 'SpinnerFactory', 'jfController', 'jfHelper', 'jfDialog', 'AccountFactory', 'OrderFactory', 'jfUser', 'JF_SHARED_CONFIG', 'JF_CONFIG', function(
                    $scope,
                    $rootScope,
                    $state,
                    $window,
                    $filter,
                    $mdToast,
                    $mdDialog,
                    $mdMedia,
                    $localStorage,
                    $q,
                    base64,
                    jfJsonApi,
                    jfLocation,
                    AccountAddressesFactory,
                    AccountUserProfileFactory,
                    ContextGeocodingLocationsFactory,
                    ContextPostalAddressesFactory,
                    ContextPostalCodesFactory,
                    SpinnerFactory,
                    jfController,
                    jfHelper,
                    jfDialog,
                    AccountFactory,
                    OrderFactory,
                    jfUser,
                    JF_SHARED_CONFIG,
                    JF_CONFIG
                ) {
                    $scope.submitAddressForm = function(form) {
                        if (form.$valid) {
                            if (!$scope.onlyInvoiceAddressChecked) {
                                SpinnerFactory.set([
                                    'account-my-addresses-add-edit',
                                    'checkout-addresses-add-edit'
                                ]);
                                ContextGeocodingLocationsFactory
                                    .get({
                                        'filter[street]': $scope.user.address,
                                        'filter[house_no]': $scope.user.number,
                                        'filter[postal_code]': $scope.user.postal_code,
                                        'filter[city]': $scope.user.city,
                                        'filter[country]': $scope.user.country
                                    })
                                    .$promise
                                    .then(function(locatedAddresses) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);

                                        if (locatedAddresses.data.length > 0) {
                                            $scope.showLocationMapPopup(locatedAddresses);
                                        } else {
                                            $scope.showLocationMapPopup();
                                        }
                                    }, function(err) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);

                                        if (err.status === 404) {
                                            $scope.showLocationMapPopup();
                                        } else {
                                            $rootScope.$emit('app-error', {err: err});
                                        }
                                    });
                            } else {
                                $scope.saveAddress({
                                    street: $scope.user.address,
                                    house_no_main: $scope.user.number,
                                    postal_code: $scope.user.postal_code,
                                    city: $scope.user.city,
                                    country: $scope.user.country,
                                    country_code: $scope.user.country_code
                                });
                            }

                        }
                    };

                    $scope.loadMultipleLocations = function(locatedAddresses) {
                        $scope.selectedLocation = locatedAddresses.data[0].attributes;
                        $scope.selectedLocationText = $scope.formatAddress(locatedAddresses.data[0].attributes);

                        $scope.otherLocations = {};
                        angular.forEach(locatedAddresses.data, function(otherLocation) {
                            $scope.otherLocations[
                                base64.encode(
                                    String(otherLocation.attributes.latitude) + String(otherLocation.attributes.longitude)
                                )
                                ] = otherLocation.attributes;
                        });
                    };

                    $scope.showLocationMapPopup = function(locatedAddresses) {
                        $scope.map = null;
                        $scope.marker = null;
                        $scope.selectedLocation = null;
                        $scope.loadingLocation = false;
                        $scope.selectedOtherLocation = null;
                        $scope.otherLocations = {};
                        $scope.countObjKeys = $rootScope.countObjKeys;
                        $scope.disableMapSubmitButton = false;

                        if (angular.isDefined(locatedAddresses)) {
                            $scope.loadMultipleLocations(locatedAddresses);
                        }

                        $mdDialog
                            .show({
                                template: '' +
                                '<md-dialog class="jf-dialog jf-dialog-geolocation-map">' +
                                    '<md-toolbar>' +
                                        '<div class="md-toolbar-tools">' +
                                            '<h2>{{\'LOCATION_MAP_POPUP_TITLE\' | translate}}</h2>' +
                                            '<i class="material-icons jf-dialog-close" ng-click="closeDialog()">clear</i>' +
                                        '</div>' +
                                    '</md-toolbar>' +
                                    '<md-dialog-content>' +
                                        '<div class="md-dialog-content" style="padding-bottom: 10px;">' +
                                            '<div class="jf-map-geolocation">' +
                                                '<p ng-if="!selectedLocation">{{\'LOCATION_MAP_POPUP_LOCATION_NOT_FOUND\' | translate}}</p>' +
                                                '<p ng-if="selectedLocation && !selectedLocation.street">{{\'LOCATION_MAP_POPUP_STREET_MISSING\' | translate}}</p>' +
                                                '<div class="jf-map-geolocation-input">' +
                                                    '<input type="text" id="jf-address-autocomplete" ng-model="selectedLocationText" placeholder="{{\'LOCATION_MAP_POPUP_LOCATION_INPUT_PLACEHOLDER\' | translate}}" />' +
                                                    '<span ng-show="loadingLocation" us-spinner="{radius:7, width:2, length: 4, color: \'#0184C5\'}"></span>' +
                                                '</div>' +
                                                '<md-input-container class="jf-input-container md-block" ng-class="{\'jf-map-street-error-visibe\': selectedLocation && !selectedLocation.street}" flex md-no-float ng-if="otherLocations && countObjKeys(otherLocations) > 1">' +
                                                    '<md-select name="other_locations" ng-change="switchLocation()" ' +
                                                        'ng-model="$parent.selectedOtherLocation" ng-attr-placeholder="{{\'LOCATION_MAP_POPUP_SUGGESTIONS\' | translate}}" ' +
                                                        'class="md-no-underline" aria-label="{{\'LOCATION_MAP_POPUP_SUGGESTIONS\' | translate}}"' +
                                                    '>' +
                                                        '<md-option md-option-empty ng-value="null">{{\'LOCATION_MAP_POPUP_SUGGESTIONS\' | translate}}</md-option>' +
                                                        '<md-option ng-repeat="(otherLocationId, otherLocation) in $parent.otherLocations track by otherLocationId" ' +
                                                            'ng-class="{\'jf-selected-address\': otherLocationId === $parent.generateLocationId($parent.selectedLocation)}" ' +
                                                            'ng-value="otherLocation"' +
                                                        '>' +
                                                            '{{$parent.formatAddress(otherLocation)}}' +
                                                        '</md-option>' +
                                                    '</md-select>' +
                                                '</md-input-container>' +
                                                '<div id="jf-map"></div>' +
                                                '<md-button class="jf-button md-raised md-accent" ng-click="saveLocationAsAddress()" ng-disabled="disableMapSubmitButton">' +
                                                    '{{\'LOCATION_MAP_POPUP_SUBMIT_BUTTON\' | translate}}' +
                                                '</md-button>' +
                                            '</form>' +
                                        '</div>' +
                                    '</md-dialog-content>' +
                                '</md-dialog>',
                                parent: angular.element(document.body),
                                clickOutsideToClose: true,
                                scope: $scope,
                                preserveScope: true,
                                onComplete: $scope.loadGoogleMapsScript
                            });
                    };

                    $scope.loadGoogleMapsScript = function() {
                        var js,
                            fjs = document.getElementsByTagName('script')[0];

                        if (!document.getElementById('gmap-api')) {
                            js = document.createElement('script');
                            js.id = 'gmap-api';
                            js.setAttribute('async', '');
                            js.src = 'https://maps.googleapis.com/maps/api/js?callback=initMap&key=' + JF_CONFIG.gMapApiKey + '&libraries=places&language=de';
                            fjs.parentNode.insertBefore(js, fjs);
                        } else {
                            $window.initMap();
                        }
                    };

                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    };

                    $scope.geoLocateUser = function() {
                        var deferred = $q.defer();

                        navigator
                            .geolocation
                            .getCurrentPosition(
                                function(position) {
                                    deferred.resolve({
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude
                                    });
                                }, function() {
                                    deferred.reject();
                                }
                            );

                        return deferred.promise;
                    };

                    $scope.geoCodeLocation = function(address) {
                        var deferred = $q.defer();

                        $scope
                            .geocoder
                            .geocode(
                                { address: address },
                                function(results, status) {
                                    if (status === 'OK') {
                                        deferred.resolve(results[0].geometry.location);
                                    } else {
                                        deferred.reject();
                                    }
                                }
                            );

                        return deferred.promise;
                    };

                    $scope.assignMapClickEvent = function() {
                        $window
                            .google
                            .maps
                            .event
                            .addListener(
                                $scope.map,
                                'click',
                                function(e) {
                                    $scope.loadingLocation = true;

                                    $scope.placeMarker(e.latLng);

                                    $scope.decodeMarkerLocation(e.latLng);
                                }
                            );
                    };

                    $scope.assignMarkerDragEvent = function() {
                        $window
                            .google
                            .maps
                            .event
                            .addListener(
                                $scope.marker,
                                'dragstart',
                                function () {
                                    $scope.marker.setAnimation(3);
                                }
                            );

                        $window
                            .google
                            .maps
                            .event
                            .addListener(
                                $scope.marker,
                                'dragend',
                                function () {
                                    $scope.marker.setAnimation(4);

                                    $scope.loadingLocation = true;

                                    $scope.decodeMarkerLocation({
                                        lat: this.getPosition().lat(),
                                        lng: this.getPosition().lng()
                                    });
                                }
                            );
                    };

                    $scope.decodeMarkerLocation = function(geoLocation) {
                        $scope
                            .geocoder
                            .geocode(
                                {
                                    location: geoLocation
                                },
                                function(results, status) {
                                    if (status === 'OK') {
                                        if (results[0]) {
                                            var preparedAddressToGeolocation = $scope.prepareToGeolocate(results[0]);

                                            ContextGeocodingLocationsFactory
                                                .get({
                                                    'filter[street]': preparedAddressToGeolocation.street,
                                                    'filter[house_no]': preparedAddressToGeolocation.number,
                                                    'filter[postal_code]': preparedAddressToGeolocation.postal_code,
                                                    'filter[city]': preparedAddressToGeolocation.city,
                                                    'filter[country]': preparedAddressToGeolocation.country
                                                })
                                                .$promise
                                                .then(function(locatedNewAddress) {
                                                    if (locatedNewAddress.data.length === 1) {
                                                        $scope.selectedLocation = locatedNewAddress.data[0].attributes;
                                                        $scope.selectedLocationText = $scope.formatAddress(locatedNewAddress.data[0].attributes);

                                                        $scope.otherLocations = null;

                                                        $scope.loadingLocation = false;
                                                    } else {
                                                        $scope.loadMultipleLocations(locatedNewAddress);

                                                        $scope.loadingLocation = false;
                                                    }
                                                }, function(err) {
                                                    $scope.loadingLocation = false;

                                                    if (err.status === 404 || err.status === 400) {
                                                        $scope.selectedLocation = null;
                                                    } else {
                                                        $rootScope.$emit('app-error', {err: err});
                                                    }
                                                });
                                        } else {
                                            $scope.selectedLocation = null;
                                            $scope.loadingLocation = false;
                                        }
                                    } else {
                                        $scope.selectedLocation = null;
                                        $scope.loadingLocation = false;
                                    }
                                }
                            );
                    };

                    $scope.initAutocomplete = function() {
                        $scope.mapAutocomplete = new $window.google.maps.places.Autocomplete(
                            document.getElementById('jf-address-autocomplete'),
                            { types: ['address'] }
                        );

                        $scope.mapAutocomplete.addListener('place_changed', function() {
                            var place = $scope.mapAutocomplete.getPlace();

                            if (!place.geometry) {
                                $scope.selectedLocation = null;

                                if ($scope.marker !== null) {
                                    $scope.marker.setMap(null);
                                }
                            } else {
                                $scope.selectedLocation = $scope.prepareToGeolocate(place);
                                $scope.selectedLocation.latitude = place.geometry.location.lat();
                                $scope.selectedLocation.longitude = place.geometry.location.lng();

                                $scope.map.setCenter(place.geometry.location);
                                $scope.placeMarker(place.geometry.location);

                                $scope.otherLocations = null;
                            }
                        });
                    };

                    $scope.renderMap = function(mapCenter, marker) {
                        $scope.map = new $window.google.maps.Map(
                            document.getElementById('jf-map'),
                            {
                                center: mapCenter,
                                zoom: 15,
                                disableDefaultUI: true,
                                zoomControl: true
                            }
                        );

                        if (angular.isDefined(marker) && marker === true) {
                            $scope.placeMarker(mapCenter);
                        } else {
                            $scope.assignMapClickEvent();
                        }

                        $scope.initAutocomplete();
                    };

                    $scope.placeMarker = function(position) {
                        if ($scope.marker !== null) {
                            $scope.marker.setMap(null);
                        }

                        $scope.marker = new $window.google.maps.Marker({
                            position: position,
                            map: $scope.map,
                            draggable: true
                        });

                        $scope.assignMarkerDragEvent();
                    };

                    $window.initMap = function() {
                        $scope.geocoder = new $window.google.maps.Geocoder();

                        var fallbackLocation = { lat: 52.5191362, lng: 13.3966418 };

                        if ($scope.selectedLocation !== null) {
                            $scope.renderMap(
                                {
                                    lat: $scope.selectedLocation.latitude,
                                    lng: $scope.selectedLocation.longitude
                                },
                                true
                            );
                        } else {
                            if (navigator.geolocation) {
                                $scope
                                    .geoLocateUser()
                                    .then(function(mapCenter) {
                                        $scope.renderMap(mapCenter);
                                    }, function() {
                                        $scope
                                            .geoCodeLocation($scope.user.postal_code + ' ' + $scope.user.city + ' ' + $scope.user.country)
                                            .then(function(mapCenter) {
                                                $scope.renderMap(mapCenter);
                                            }, function() {
                                                $scope.renderMap(fallbackLocation);
                                            });
                                    });
                            } else {
                                $scope
                                    .geoCodeLocation($scope.user.postal_code + ' ' + $scope.user.city + ' ' + $scope.user.country)
                                    .then(function(mapCenter) {
                                        $scope.renderMap(mapCenter);
                                    }, function() {
                                        $scope.renderMap(fallbackLocation);
                                    });
                            }
                        }
                    };

                    $scope.cancel = function() {
                        if (angular.isDefined($scope.cancelCallback)) {
                            $scope.cancelCallback();
                        } else {
                            if (angular.isDefined($scope.newAddressForm)) {
                                $state.reload();
                            } else {
                                $state.go('account.section', {section: 'my-addresses', subnav: null});
                            }
                        }
                    };

                    $scope.prepareToGeolocate = function(googleResult) {
                        var result = {};

                        angular.forEach(googleResult.address_components, function(addressComponent) {
                            if (addressComponent.types.indexOf('route') > -1) {
                                result.street = addressComponent.long_name;
                            } else if (addressComponent.types.indexOf('street_number') > -1) {
                                result.house_no = addressComponent.long_name;
                            } else if (addressComponent.types.indexOf('postal_code') > -1) {
                                result.postal_code = addressComponent.long_name;
                            } else if (addressComponent.types.indexOf('locality') > -1) {
                                result.city = addressComponent.long_name;
                            } else if (addressComponent.types.indexOf('administrative_area_level_1') > -1) {
                                result.province = addressComponent.long_name;
                            } else if (addressComponent.types.indexOf('country') > -1) {
                                result.country = addressComponent.long_name;
                                result.country_code = addressComponent.short_name;
                            }
                        });

                        if (angular.isUndefined(result.number)) {
                            result.number = $scope.user.number;
                        }

                        return result;
                    };

                    $scope.generateLocationId = function(location) {
                        if (angular.isUndefined(location) || location === null) {
                            return false;
                        } else {
                            return base64.encode(String(location.latitude) + String(location.longitude));
                        }
                    };

                    $scope.switchLocation = function() {
                        $scope.selectedLocation = $scope.selectedOtherLocation;
                        $scope.selectedLocationText = $scope.formatAddress($scope.selectedOtherLocation);

                        $scope.marker.setPosition({lat: $scope.selectedLocation.latitude, lng: $scope.selectedLocation.longitude});
                        $scope.map.setCenter({lat: $scope.selectedLocation.latitude, lng: $scope.selectedLocation.longitude});

                        $scope.selectedOtherLocation = null;
                    };

                    $scope.formatAddress = function(address) {
                        if (angular.isDefined(address)) {
                            var formattedAddress =  '';

                            if (address.street !== null && address.street !== '') {
                                formattedAddress = address.street + ' ';
                            }

                            if (address.house_no !== null && address.house_no !== '') {
                                formattedAddress = formattedAddress + address.house_no;
                            }

                            if (formattedAddress !== '') {
                                formattedAddress = formattedAddress + ', ';
                            }

                            if (address.postal_code !== null && address.postal_code !== '') {
                                formattedAddress = formattedAddress + address.postal_code + ' ';
                            }

                            formattedAddress = formattedAddress + address.city;
                            formattedAddress = formattedAddress + ', ' + address.country;

                            return formattedAddress;
                        } else {
                            return '';
                        }
                    };

                    $scope.showOutOfServiceAlert = function() {
                        $scope.user.preferred_pickup = false;
                        $scope.user.preferred_delivery = false;
                        jfDialog
                            .showAlert(
                                $filter('translate')('POSTAL_CODE_EMPTY_LABEL'),
                                $filter('translate')('POSTAL_CODE_EMPTY_CONTENT'),
                                $filter('translate')('POSTAL_CODE_EMPTY_BUTTON')
                            );
                    };

                    $scope.saveLocationAsAddress = function() {
                        if (
                            $scope.selectedLocation !== null &&
                            $scope.selectedLocation.street !== null &&
                            $scope.loadingLocation !== true
                        ) {
                            $scope.disableMapSubmitButton = true;

                            if (angular.isUndefined($scope.selectedLocation.postal_code)) {
                                jfDialog
                                    .showAlert(
                                        $filter('translate')('ZIP_CODE_UNDEFINED_LABEL'),
                                        $filter('translate')('ZIP_CODE_UNDEFINED_CONTENT'),
                                        $filter('translate')('ZIP_CODE_UNDEFINED_BUTTON')
                                    );

                                $scope.disableMapSubmitButton = false;

                                return false;
                            }
                            if ($scope.user.postal_code !== $scope.selectedLocation.postal_code) {
                                SpinnerFactory.set([
                                    'account-my-addresses-add-edit',
                                    'checkout-addresses-add-edit'
                                ]);
                                ContextPostalCodesFactory
                                    .get({
                                        'filter[code]': $scope.selectedLocation.postal_code
                                    })
                                    .$promise
                                    .then(function(postalCode) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);

                                        if (angular.isUndefined(postalCode) || angular.isUndefined(postalCode.data) || postalCode.data.length === 0) {
                                            $scope.showOutOfServiceAlert();

                                            $scope.disableMapSubmitButton = false;
                                            $rootScope.$emit('app-log', {msg: 'User tried to change zip code at gmaps search and it is unserviceable.'});
                                        } else {
                                            var promises = [],
                                                postalCodeId = postalCode.data[0] ? postalCode.data[0].id : $scope.selectedLocation.postal_code;
                                            if (postalCodeId) {
                                                promises.push(
                                                    ContextPostalAddressesFactory
                                                        .save(
                                                            jfJsonApi.prepare(
                                                                JF_SHARED_CONFIG.modelTypes.postal_address,
                                                                {
                                                                    street: $scope.selectedLocation.street || $scope.user.address,
                                                                    house_no: $scope.selectedLocation.house_no || $scope.user.number,
                                                                    latitude: $scope.selectedLocation.latitude,
                                                                    longitude: $scope.selectedLocation.longitude
                                                                },
                                                                undefined,
                                                                undefined,
                                                                {
                                                                    postal_code: {
                                                                        data: {
                                                                            id: postalCodeId,
                                                                            type: 'postal_codes'
                                                                        }
                                                                    }
                                                                }
                                                            )
                                                        )
                                                        .$promise
                                                );
                                            }

                                            SpinnerFactory.set([
                                                'account-my-addresses-add-edit',
                                                'checkout-addresses-add-edit'
                                            ]);

                                            $q.all(promises).then(function(postalAddress) {
                                                SpinnerFactory.unset([
                                                    'account-my-addresses-add-edit',
                                                    'checkout-addresses-add-edit'
                                                ]);

                                                $mdDialog
                                                    .hide()
                                                    .then(function() {
                                                        $scope.saveAddress({
                                                            street: $scope.selectedLocation.street || $scope.user.address,
                                                            house_no_main: $scope.selectedLocation.house_no || $scope.user.number,
                                                            latitude: $scope.selectedLocation.latitude,
                                                            longitude: $scope.selectedLocation.longitude,
                                                            city: $scope.selectedLocation.city,
                                                            province: $scope.selectedLocation.province,
                                                            country: $scope.selectedLocation.country,
                                                            country_code: $scope.selectedLocation.country_code,
                                                            postal_code: $scope.selectedLocation.postal_code,
                                                            postal_code_id: postalCodeId,
                                                            postal_address_id: postalAddress.length > 0 ? postalAddress[0].data.id : undefined
                                                        });
                                                    });
                                            }, function(err) {
                                                SpinnerFactory.unset([
                                                    'account-my-addresses-add-edit',
                                                    'checkout-addresses-add-edit'
                                                ]);

                                                // not serviceable address
                                                if (err.status === 422 || err.status === 404) {
                                                    $scope.showOutOfServiceAlert();

                                                    $scope.disableMapSubmitButton = false;
                                                    $rootScope.$emit('app-log', {msg: 'User tried to change zip code at gmaps search and it is unserviceable.'});
                                                } else {
                                                    $rootScope.$emit('app-error', {err: err});
                                                }
                                            });
                                        }
                                    }, function(err) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                SpinnerFactory.set([
                                    'account-my-addresses-add-edit',
                                    'checkout-addresses-add-edit'
                                ]);

                                ContextPostalAddressesFactory
                                    .save(
                                        jfJsonApi.prepare(
                                            JF_SHARED_CONFIG.modelTypes.postal_address,
                                            {
                                                street: $scope.selectedLocation.street || $scope.user.address,
                                                house_no: $scope.selectedLocation.house_no || $scope.user.number,
                                                latitude: $scope.selectedLocation.latitude,
                                                longitude: $scope.selectedLocation.longitude
                                            },
                                            undefined,
                                            undefined,
                                            {
                                                postal_code: {
                                                    data: {
                                                        id: $scope.user.postal_code_id,
                                                        type: 'postal_codes'
                                                    }
                                                }
                                            }
                                        )
                                    )
                                    .$promise
                                    .then(function(postalAddress) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);

                                        $mdDialog
                                            .hide()
                                            .then(function() {
                                                $scope.saveAddress({
                                                    street: $scope.selectedLocation.street || $scope.user.address,
                                                    house_no_main: $scope.selectedLocation.house_no || $scope.user.number,
                                                    latitude: $scope.selectedLocation.latitude,
                                                    longitude: $scope.selectedLocation.longitude,
                                                    postal_code: $scope.selectedLocation.postal_code,
                                                    postal_code_id: $scope.user.postal_code_id,
                                                    postal_address_id: postalAddress.data.id
                                                });
                                            });
                                    }, function(err) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);

                                        // not serviceable address
                                        if (err.status === 422) {
                                            $scope.showOutOfServiceAlert();

                                            $scope.disableMapSubmitButton = false;
                                            $rootScope.$emit('app-log', {msg: 'User tried to change zip code at gmaps search and it is unserviceable.'});
                                        } else {
                                            $rootScope.$emit('app-error', {err: err});
                                        }
                                    });
                            }
                        }
                    };

                    $scope.saveAddress = function(customValues) {
                        var serviceType,
                            valuesToSave = {
                                salutation: $scope.user.title,
                                first_name: $scope.user.first_name,
                                last_name: $scope.user.last_name,
                                company_name: $scope.user.company_name,
                                house_no_add: $scope.user.additional_number,
                                other: $scope.user.floor_department,
                                city: $scope.user.city,
                                province: $scope.user.province,
                                country_code: $scope.user.country_code,
                                country: $scope.user.country,
                                phone_no: $scope.user.phone_number,
                                department: $scope.user.department_name,
                                addressable_id: jfUser.get().id,
                                addressable_type: 'Customer'
                            };

                        angular.extend(valuesToSave, customValues);

                        if (customValues.postal_code_id) {
                            serviceType = JF_SHARED_CONFIG.modelTypes.service_address;
                        } else {
                            serviceType = JF_SHARED_CONFIG.modelTypes.invoice_address;
                            // for invoice address, we do not need to send latitude and longitude
                            valuesToSave.latitude = undefined;
                            valuesToSave.longitude = undefined;
                        }

                        var dataToSend = jfJsonApi.prepare(
                                serviceType,
                                valuesToSave,
                                { id: $scope.reqParams.addressId }
                            ),
                            promise;

                        if ($scope.reqParams.addressId) {
                            if (customValues.postal_code_id) {
                                dataToSend.data.attributes.address_kind = JF_SHARED_CONFIG.modelTypes.service_address;
                            } else {
                                dataToSend.data.attributes.address_kind = JF_SHARED_CONFIG.modelTypes.invoice_address;
                            }

                            promise = AccountAddressesFactory
                            .update(
                                $scope.reqParams,
                                dataToSend
                            );
                        } else {
                            promise = AccountAddressesFactory
                            .save(
                                $scope.reqParams,
                                dataToSend
                            );
                        }

                        SpinnerFactory.set([
                            'account-my-addresses-add-edit',
                            'checkout-addresses-add-edit'
                        ]);

                        promise
                            .$promise
                            .then(function(updatedAddress) {
                                $scope
                                    .updateOrderAddresses(updatedAddress)
                                    .then(function() {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);

                                        $scope.savePreferredAddressesToProfile(updatedAddress.data);
                                    }, function(err) {
                                        SpinnerFactory.unset([
                                            'account-my-addresses-add-edit',
                                            'checkout-addresses-add-edit'
                                        ]);
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-my-addresses-add-edit',
                                    'checkout-addresses-add-edit'
                                ]);
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.updateOrderAddresses = function(updatedAddress) {
                        var deferred = $q.defer(),
                            orderCompanyId = $localStorage.order.details.attributes.company_id || null;

                            if (angular.isUndefined(updatedAddress.data.attributes.postal_code_id) || updatedAddress.data.attributes.postal_code_id === null) {
                                deferred.resolve();
                            } else {
                                jfLocation
                                    .postalCodeInService(updatedAddress.data.attributes.postal_code_id, orderCompanyId)
                                    .then(function(validationResult) {
                                        if (validationResult.valid === true) {
                                            updatedAddress.data.postal_code_in_service = validationResult.valid;

                                            if (
                                                angular.isDefined(validationResult.postalCodeDetails) &&
                                                angular.isDefined(validationResult.postalCodeDetails.plant_id) &&
                                                validationResult.postalCodeDetails.plant_id !== null
                                            ) {
                                                updatedAddress.data.plant_id = validationResult.postalCodeDetails.plant_id;
                                            }

                                            $scope
                                                .proceedWithOrderAddressesUpdate(updatedAddress)
                                                .then(function() {
                                                    deferred.resolve();
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        } else {
                                            if (
                                                (
                                                    angular.isDefined($localStorage.order.details.attributes.pickup_address) &&
                                                    angular.isDefined($localStorage.order.details.attributes.pickup_address.resource_id) &&
                                                    $localStorage.order.details.attributes.pickup_address.resource_id === updatedAddress.data.id
                                                ) ||
                                                (
                                                    angular.isDefined($localStorage.order.details.attributes.delivery_address) &&
                                                    angular.isDefined($localStorage.order.details.attributes.delivery_address.resource_id) &&
                                                    $localStorage.order.details.attributes.delivery_address.resource_id === updatedAddress.data.id
                                                )
                                            ) {
                                                if (angular.isDefined($localStorage.catalogLocation)) {
                                                    var addressToSave = angular.copy($localStorage.catalogLocation);
                                                    addressToSave.resource_id = updatedAddress.id;
                                                    addressToSave.addressable_type = $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company';

                                                    OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                                    OrderFactory
                                                        .updateOrder(
                                                            $localStorage.order.details.id,
                                                            {
                                                                pickup_address: addressToSave,
                                                                delivery_address: addressToSave,
                                                                billing_address: { _destroy: true }
                                                            }
                                                        )
                                                        .then(function() {
                                                            deferred.resolve();
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                } else {
                                                    deferred.resolve();
                                                }
                                            } else {
                                                deferred.resolve();
                                            }
                                        }
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }

                        return deferred.promise;
                    };

                    $scope.proceedWithOrderAddressesUpdate = function(updatedAddress) {
                        var dataToUpdate = {},
                            deferred = $q.defer();

                        if (
                            $localStorage.order.details.attributes.pickup_address &&
                            $localStorage.order.details.attributes.pickup_address.resource_id === updatedAddress.data.id
                        ) {
                            dataToUpdate.pickup_address = updatedAddress.data.attributes;
                            dataToUpdate.pickup_address.resource_id = updatedAddress.data.id;

                            OrderFactory.prefillEmptyOrderAddressDetails(dataToUpdate.pickup_address);

                            if (
                                $localStorage.order.details.attributes.pickup_address &&
                                $localStorage.order.details.attributes.pickup_address.postal_code !== dataToUpdate.pickup_address.postal_code
                            ) {
                                dataToUpdate.pickup_start_ts = null;
                                dataToUpdate.pickup_end_ts = null;
                                dataToUpdate.delivery_start_ts = null;
                                dataToUpdate.delivery_end_ts = null;
                            }
                        }

                        if (
                            $localStorage.order.details.attributes.delivery_address &&
                            $localStorage.order.details.attributes.delivery_address.resource_id === updatedAddress.data.id
                        ) {
                            dataToUpdate.delivery_address = updatedAddress.data.attributes;
                            dataToUpdate.delivery_address.resource_id = updatedAddress.data.id;

                            OrderFactory.prefillEmptyOrderAddressDetails(dataToUpdate.delivery_address);

                            if (
                                $localStorage.order.details.attributes.delivery_address &&
                                $localStorage.order.details.attributes.delivery_address.postal_code !== dataToUpdate.delivery_address.postal_code
                            ) {
                                dataToUpdate.delivery_start_ts = null;
                                dataToUpdate.delivery_end_ts = null;
                            }
                        }

                        if (
                            $localStorage.order.details.attributes.billing_address &&
                            $localStorage.order.details.attributes.billing_address.resource_id === updatedAddress.data.id
                        ) {
                            dataToUpdate.billing_address = updatedAddress.data.attributes;
                            dataToUpdate.billing_address.resource_id = updatedAddress.data.id;

                            OrderFactory.prefillEmptyOrderAddressDetails(dataToUpdate.billing_address);
                        }

                        if (jfHelper.countObjKeys(dataToUpdate) > 0) {
                            OrderFactory
                                .updateOrder(
                                    $localStorage.order.details.id,
                                    dataToUpdate
                                )
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            deferred.resolve();
                        }

                        return deferred.promise;
                    };

                    $scope.checkPreferredInvoiceAddress = function() {
                        if (
                            $scope.user.preferred_billing &&
                            (
                                !$scope.user.preferred_pickup &&
                                !$scope.user.preferred_delivery
                            )
                        ) {
                            $scope.onlyInvoiceAddressChecked = true;
                        } else {
                            $scope.onlyInvoiceAddressChecked = false;
                        }
                    };

                    $scope.savePreferredAddressesToProfile = function(address) {
                        var dataToSave = $scope.preparePreferredAddresses(address);

                        if ($rootScope.countObjKeys(dataToSave.addresses) > 0) {
                            SpinnerFactory.set([
                                'account-my-addresses-add-edit',
                                'checkout-addresses-add-edit'
                            ]);

                            AccountUserProfileFactory
                                .update(
                                    { id: jfUser.get().profileId },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.profile,
                                        dataToSave.addresses,
                                        { id: jfUser.get().profileId }
                                    )
                                )
                                .$promise
                                .then(function() {
                                    SpinnerFactory.unset([
                                        'account-my-addresses-add-edit',
                                        'checkout-addresses-add-edit'
                                    ]);

                                    jfUser.update(dataToSave.userUpdate);

                                    $scope.successSubmitCallback(address, dataToSave.addresses);
                                }, function(err) {
                                    SpinnerFactory.unset([
                                        'account-my-addresses-add-edit',
                                        'checkout-addresses-add-edit'
                                    ]);

                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $scope.successSubmitCallback(address);
                        }
                    };

                    $scope.successSubmitCallback = function(address, savedPreferredAddresses) {
                        $scope.user = {};

                        if (angular.isDefined($scope.accountAddressForm)) {
                            $scope.accountAddressForm.$setPristine();
                            $scope.accountAddressForm.$setUntouched();
                        }

                        $mdToast.show($mdToast.simple().textContent($filter('translate')('ADDRESS_SAVED')));

                        if (angular.isDefined($scope.submitCallback)) {
                            $scope.submitCallback(address, savedPreferredAddresses);
                        } else {
                            if (angular.isDefined($scope.newAddressForm)) {
                                $state.reload();
                            } else {
                                $state.go('account.section', {section: 'my-addresses', subnav: null}, {reload: true});
                            }
                        }
                    };

                    $scope.preparePreferredAddresses = function(address) {
                        var addressId = address.id,
                            preferredAddresses = {},
                            userUpdate = {};

                        if ($scope.hidePreferredAddresses === false && !$scope.user.preferred_pickup && addressId === jfUser.get().ppid) {
                            preferredAddresses.pickup_address_id = null;
                            userUpdate.ppid = null;
                        } else if ($scope.user.preferred_pickup) {
                            if (address.type !== JF_CONFIG.addressTypes.invoice) {
                                preferredAddresses.pickup_address_id = addressId;
                                userUpdate.ppid = addressId;
                            }
                        }

                        if ($scope.hidePreferredAddresses === false && !$scope.user.preferred_delivery && addressId === jfUser.get().pdid) {
                            preferredAddresses.delivery_address_id = null;
                            userUpdate.pdid = null;
                        } else if ($scope.user.preferred_delivery) {
                            if (address.type !== JF_CONFIG.addressTypes.invoice) {
                                preferredAddresses.delivery_address_id = addressId;
                                userUpdate.pdid = addressId;
                            }
                        }

                        if ($scope.hidePreferredAddresses === false && !$scope.user.preferred_billing && addressId === jfUser.get().pbid) {
                            preferredAddresses.billing_address_id = null;
                            userUpdate.pbid = null;
                        } else if ($scope.user.preferred_billing) {
                            preferredAddresses.billing_address_id = addressId;
                            userUpdate.pbid = addressId;
                        }

                        return {
                            addresses: preferredAddresses,
                            userUpdate: userUpdate
                        };
                    };

                    $scope.prepareAddNewView = function() {
                        SpinnerFactory.set([
                            'account-my-addresses-add-edit',
                            'checkout-addresses-add-edit'
                        ]);

                        AccountUserProfileFactory
                            .get({
                                'filter[user_id]': jfUser.get().id
                            })
                            .$promise
                            .then(function(result) {
                                SpinnerFactory.unset([
                                    'account-my-addresses-add-edit',
                                    'checkout-addresses-add-edit'
                                ]);

                                if (angular.isDefined(result.data[0].attributes.first_name) &&
                                    result.data[0].attributes.first_name !== null
                                ) {
                                    $scope.user.first_name = result.data[0].attributes.first_name;
                                }
                                if (angular.isDefined(result.data[0].attributes.last_name) &&
                                    result.data[0].attributes.last_name !== null
                                ) {
                                    $scope.user.last_name = result.data[0].attributes.last_name;
                                }
                                if (angular.isDefined(result.data[0].attributes.phone_no) &&
                                    result.data[0].attributes.phone_no !== null
                                ) {
                                    $scope.user.phone_number = result.data[0].attributes.phone_no;
                                }
                                if (angular.isDefined(result.data[0].attributes.salutation) &&
                                    result.data[0].attributes.salutation !== null
                                ) {
                                    $scope.user.title = result.data[0].attributes.salutation;
                                }
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-my-addresses-add-edit',
                                    'checkout-addresses-add-edit'
                                ]);
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.prepareEditView = function() {
                        $scope.reqParams.addressId = $scope.addressToEdit.id;

                        $scope.user = {
                            title: $scope.addressToEdit.attributes.salutation,
                            first_name: $scope.addressToEdit.attributes.first_name,
                            last_name: $scope.addressToEdit.attributes.last_name,
                            company_name: $scope.addressToEdit.attributes.company_name,
                            address: $scope.addressToEdit.attributes.street,
                            number: $scope.addressToEdit.attributes.house_no_main,
                            additional_number: $scope.addressToEdit.attributes.house_no_add,
                            floor_department: $scope.addressToEdit.attributes.other,
                            postal_code_id: $scope.addressToEdit.attributes.postal_code_id,
                            postal_code: $scope.addressToEdit.attributes.postal_code,
                            city: $scope.addressToEdit.attributes.city,
                            province: $scope.addressToEdit.attributes.province,
                            country_code: $scope.addressToEdit.attributes.country_code,
                            country: $scope.addressToEdit.attributes.country,
                            phone_number: $scope.addressToEdit.attributes.phone_no,
                            department_name: $scope.addressToEdit.attributes.department
                        };

                        if (angular.isDefined($scope.addressToEdit.attributes.postal_code_id) && $scope.addressToEdit.attributes.postal_code_id !== null) {
                            $scope.setSelectedPostalCodeText(
                                $scope.user.postal_code,
                                $scope.user.city,
                                $scope.user.province,
                                $scope.user.country
                            );
                        }

                        $scope.user.preferred_pickup = jfUser.get().ppid === $scope.addressToEdit.id;
                        $scope.user.preferred_delivery = jfUser.get().pdid === $scope.addressToEdit.id;
                        $scope.user.preferred_billing = jfUser.get().pbid === $scope.addressToEdit.id;
                        $scope.checkPreferredInvoiceAddress();
                    };

                    $scope.setSelectedPostalCodeText = function(postalCode, city, province, country) {
                        $scope.selectedValue = postalCode + ' ' +
                            city + ', ' +
                            province + ', ' +
                            country;
                    };

                    $scope.preselectCheckboxes = function() {
                        // Preselect checkboxes when there is no preferred addresses and when preferred management is available
                        if (!AccountFactory.isCompanyAccount()) {
                            if (!jfUser.get().ppid) {
                                $scope.user.preferred_pickup = true;
                                $scope.forcePickupAddress = true;
                            }
                            if (!jfUser.get().pdid) {
                                $scope.user.preferred_delivery = true;
                                $scope.forceDeliveryAddress = true;
                            }
                            if (!jfUser.get().pbid) {
                                $scope.user.preferred_billing = true;
                                $scope.forceBillingAddress = true;
                            }
                        }
                    };

                    $scope.setPostalCodeInServiceValidation = function() {
                        SpinnerFactory.set('account-my-addresses');

                        AccountFactory
                            .fetchUserPrivateAddresses()
                            .then(function (addresses) {
                                SpinnerFactory.unset('account-my-addresses');

                                if ($rootScope.countObjKeys(addresses) === 0) {
                                    if (!AccountFactory.isCompanyAccount()) {
                                        $scope.hidePreferredAddresses = true;
                                    }
                                }
                            }, function (err) {
                                SpinnerFactory.unset('account-my-addresses');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.checkAddressData = function() {
                        if (angular.isDefined($scope.addressToEdit) && $scope.addressToEdit !== null) {
                            $scope.prepareEditView();
                        } else {
                            $scope.prepareAddNewView();
                        }
                    };

                    $scope.editAddressCancelOnePageCheckoutCallback = function() {
                        $rootScope.$emit('jfCheckout:checkoutEditAddressClose');
                    };

                    $scope.addNewAddressCancelOnePageCheckoutCallback = function() {
                        if ($mdMedia('xs')) {
                            $state.go('checkout');
                        } else {
                            $rootScope.$emit('jfCheckout:checkoutNewAddressClose');
                        }
                    };

                    $scope.initAccountAddressDirectiveView = function() {
                        $scope.user = {};
                        $scope.userDatils = {
                            preferredPickupAddress: jfUser.get().ppid,
                            preferredDeliveryAddress: jfUser.get().pdid,
                            preferredBillingAddress: jfUser.get().pbid
                        };
                        $scope.selectedValue = null;
                        $scope.hidePreferredAddresses = false;
                        $scope.onlyInvoiceAddressChecked = false;
                        $scope.isCheckoutView = false;

                        if (['checkout', 'checkout.addresses'].indexOf($state.current.name) > -1) {
                            $scope.isCheckoutView = true;
                        }

                        if (angular.isDefined($state.params.subnav) && $state.params.subnav === 'edit-address') {
                            $scope.addressToEdit = angular.copy($state.params.addressToEdit);
                        }

                        $scope.reqParams = {};

                        $scope.$on('addressErrors', function(event, data) {
                            $scope.addressesErrors = data;
                        });

                        var preferredAddressesWatcher =  $scope.$watchGroup(
                            ['user.preferred_billing', 'user.preferred_pickup', 'user.preferred_delivery'],
                            function(newValues, oldValues) {
                                if (newValues !== oldValues) {
                                    $scope.checkPreferredInvoiceAddress();
                                }
                        });

                        $scope.$on('$destroy', function() {
                            preferredAddressesWatcher();
                        });

                        $scope.checkAddressData();

                        $scope.preselectCheckboxes();
                        $scope.setPostalCodeInServiceValidation();
                    };

                    jfController.init(['initAccountAddressDirectiveView'], $scope);
                }]
            };
        }
    );
/**
 * Account Address Form directive
 */
angular.module('jfApp')
    .directive(
        'accountAddressForm',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/account-address-form.html',
                scope: {
                    form: '=',
                    formModel: '=',
                    selectedPostalCode: '=',
                    onlyInvoiceAddressChecked: '='
                },
                controller: ['$rootScope', '$scope', '$filter', 'jfController', 'JF_SHARED_CONFIG', function(
                    $rootScope,
                    $scope,
                    $filter,
                    jfController,
                    JF_SHARED_CONFIG
                ) {
                    $scope.countObjKeys = $rootScope.countObjKeys;

                    $scope.assignSelectedCountryCode = function(country_name) {
                        var country = JF_SHARED_CONFIG.countries.find(function(country) { return country.name === country_name; });
                        $scope.formModel.country_code = country.country_code;
                    };

                    $scope.initAccountAddressFormView = function() {
                        $scope.countriesArr = JF_SHARED_CONFIG.countries;
                    };

                    jfController.init(['initAccountAddressFormView'], $scope);
                }]
            };
        }
    );
/**
 * Account Register Form directive
 */
angular.module('jfApp')
    .directive(
        'accountRegisterForm',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/account-register-form.html',
                scope: {
                    form: '=',
                    formModel: '=',
                    hideHeader: '=',
                    showRegisterForm: '='
                },
                controller: ['$scope', '$rootScope', '$mdMedia', 'CustomerAppHelpersFactory', 'jfHelper', 'jfController', function(
                    $scope,
                    $rootScope,
                    $mdMedia,
                    CustomerAppHelpersFactory,
                    jfHelper,
                    jfController
                ) {
                    $scope.downloadAgb = function(e) {
                        e.stopPropagation();

                        if ($rootScope.mobileAppMode) {
                            e.preventDefault();
                            CustomerAppHelpersFactory.downloadFile($scope.legalDocuments.gtc.document_file.url, 'agb');
                        }
                    };

                    $scope.downloadPrivacyPolicy = function(e) {
                        e.stopPropagation();

                        if ($rootScope.mobileAppMode) {
                            e.preventDefault();
                            CustomerAppHelpersFactory.downloadFile($scope.legalDocuments.pp.document_file.url, 'datenschutz');
                        }
                    };

                    $scope.registerFormToggle = function () {
                        $scope.showRegisterForm = !$scope.showRegisterForm;
                    };

                    $scope.initRegisterFormView = function() {
                        CustomerAppHelpersFactory.fetchLegalDocuments().then(function(legalDocuments) {
                            $scope.legalDocuments = legalDocuments;
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });

                        $scope.$mdMedia = $mdMedia;
                        $scope.mobileAppMode = jfHelper.mobileAppMode;
                        $scope.blogUrl = $rootScope.blogUrl;
                    };

                    jfController.init(['initRegisterFormView'], $scope);
                }],
                link: function($scope, element, attributes) {
                    $scope.gaEventSection = attributes.gaEventSection || null;
                }
            };
        }
    );
/**
 * Account Credit Card Form directive
 */
angular.module('jfApp')
    .directive(
        'accountCreditCardForm',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/account-credit-card-form.html',
                scope: {
                    hideCancelButton: '=?',
                    hideHeader: '=?',
                    saveCallback: '=?',
                    cancelCallback: '=?',
                    form: '=',
                    country: '='
                },
                controller: ['$scope', '$rootScope', '$state', '$sce', '$q', '$filter', '$window', '$timeout', '$mdMedia', '$localStorage', 'JF_CONFIG', 'jfConfigUrls', 'jfHelper', 'jfUser', 'LanguageFactory', 'SpinnerFactory', 'PaymentMethodsManagerFactory', 'AdyenFactory', 'AccountUsersBillingAgreementsThreeDs', 'jfController', function(
                    $scope,
                    $rootScope,
                    $state,
                    $sce,
                    $q,
                    $filter,
                    $window,
                    $timeout,
                    $mdMedia,
                    $localStorage,
                    JF_CONFIG,
                    jfConfigUrls,
                    jfHelper,
                    jfUser,
                    LanguageFactory,
                    SpinnerFactory,
                    PaymentMethodsManagerFactory,
                    AdyenFactory,
                    AccountUsersBillingAgreementsThreeDs,
                    jfController
                ) {
                    $scope.cancelAction = function() {
                        if (angular.isDefined($scope.cancelCallback)) {
                            $scope.cancelCallback();
                        }
                    };

                    $scope.getBrowserInfo = function() {
                        var browserInfo = $window.ThreedDS2Utils.getBrowserInfo();

                        return {
                            color_depth: browserInfo.colorDepth,
                            java_enabled: true,
                            language: browserInfo.language,
                            screen_height: browserInfo.screenHeight,
                            screen_width: browserInfo.screenWidth,
                            time_zone_offset: browserInfo.timeZoneOffset,
                            user_agent: browserInfo.userAgent
                        };
                    };

                    $scope.disableCCSubmitButton = function() {
                        return AdyenFactory.ccFormSubmitDisabled;
                    };

                    $scope.initializeAdyenPayment = function() {
                        var deferred = $q.defer();

                        PaymentMethodsManagerFactory
                            .getBillingAddress()
                            .then(function(billingAddress) {
                                if (angular.isDefined(billingAddress)) {
                                    if (angular.isDefined($rootScope.jfShared.adyen.ccFormValues)) {
                                        SpinnerFactory.set([
                                            'account-credit-cards',
                                            'checkout-payment-methods'
                                        ]);

                                        AdyenFactory
                                            .sendAdyenBillingAggreement(
                                                {
                                                    customer_id: jfUser.get().id,
                                                    country_code: $scope.country,
                                                    payment_info: {
                                                        number: $rootScope.jfShared.adyen.ccEndDigits,
                                                        paymentMethod: $rootScope.jfShared.adyen.ccFormValues.paymentMethod,
                                                        browserInfo: $rootScope.jfShared.adyen.ccFormValues.browserInfo,
                                                        billingAddress: billingAddress,
                                                        returnUrl: jfConfigUrls.get('accountService') + '/accounts/threeds/redirect_shoppers/',
                                                        origin: $scope.appOrigin
                                                    },
                                                    event: 'init'
                                                },
                                                $scope.country
                                            )
                                            .then(function(result) {
                                                SpinnerFactory.unset([
                                                    'account-credit-cards',
                                                    'checkout-payment-methods'
                                                ]);
                                                deferred.resolve(result.data);
                                            }, function(err) {
                                                SpinnerFactory.unset([
                                                    'account-credit-cards',
                                                    'checkout-payment-methods'
                                                ]);

                                                deferred.reject(err);
                                            });
                                    } else {
                                        deferred.reject();
                                    }
                                } else {
                                    deferred.reject({
                                        customErrorMsg: $filter('translate')('CC_ADYEN_ERROR_BILLING_ADDRESS')
                                    });
                                }
                            }, function(err) {
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.processIdentifyShopperResult = function(identifyShopperResult) {
                        var deferred = $q.defer();

                        SpinnerFactory.set([
                            'account-credit-cards',
                            'checkout-payment-methods'
                        ]);

                        AdyenFactory
                            .sendAdyenBillingAggreement(
                                {
                                    event: 'identify_shopper',
                                    customer_id: jfUser.get().id,
                                    country_code: $scope.country,
                                    payment_info: {
                                        number: $rootScope.jfShared.adyen.ccEndDigits,
                                        details: identifyShopperResult.details,
                                        paymentData: identifyShopperResult.paymentData
                                    }
                                },
                                $scope.country
                            )
                            .then(function(adyenResponse) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods'
                                ]);

                                $scope
                                    .processAdyenEvent(adyenResponse.data)
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods'
                                ]);

                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.processChallengeShopperResult = function(challengeShopperResult) {
                        var deferred = $q.defer();

                        SpinnerFactory.set([
                            'account-credit-cards',
                            'checkout-payment-methods'
                        ]);

                        AdyenFactory
                            .sendAdyenBillingAggreement(
                                {
                                    event: 'challenge_shopper',
                                    customer_id: jfUser.get().id,
                                    country_code: $scope.country,
                                    payment_info: {
                                        number: $rootScope.jfShared.adyen.ccEndDigits,
                                        details: challengeShopperResult.details,
                                        paymentData: challengeShopperResult.paymentData
                                    }
                                },
                                $scope.country
                            )
                            .then(function(adyenResponse) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods'
                                ]);

                                $scope
                                    .processAdyenEvent(adyenResponse.data)
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods'
                                ]);

                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.processAdyenEvent = function(adyenResponse) {
                        var deferred = $q.defer();

                        if (adyenResponse.attributes.state === 'IdentifyShopper') {
                            if ($scope.isIOS) {
                                var identifyGetParams = 'lang=' + LanguageFactory.getActiveLocale() + '&origin=' + JF_CONFIG.adyenOriginKey.ios + '&env=' + (JF_CONFIG.environment === 'Production' ? 'live' : 'test') + '&action=identify_shopper#'+JSON.stringify(adyenResponse.attributes.payment_info);

                                $rootScope.jfShared.adyen.iframe.adyenIosIdentifyIframe = true;
                                $rootScope.jfShared.adyen.iframe.adyenIosIdentifyIframeUrl = $sce.trustAsResourceUrl(jfConfigUrls.get('jfShopUrl', 'customerApp') + 'adyen-ios-iframe-3ds.html?' + identifyGetParams);
                                $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', false);

                                var _identifyShopperListener = function(e) {
                                    var adyenResponse = typeof e.data !== 'object' ? JSON.parse(e.data) : e.data;

                                    if (adyenResponse.type === '3dsResult') {
                                        if (adyenResponse.action === 'identify_shopper') {
                                            $window.removeEventListener('message', _identifyShopperListener, true);

                                            $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                                            $scope
                                                .processIdentifyShopperResult(adyenResponse.data)
                                                .then(function () {
                                                    deferred.resolve();
                                                }, function(err) {
                                                    $scope.clearAdyenIosProcessingFrames();
                                                    $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);
                                                    deferred.reject(err);
                                                });
                                        }
                                    }

                                    if (adyenResponse.action === 'resizeProcessingIframe') {
                                        document.getElementById('adyenIosProcessingIframeWrapper').style.height = adyenResponse.height + 'px';
                                    }
                                };

                                $window.addEventListener('message', _identifyShopperListener, true);
                            } else {
                                SpinnerFactory.set([
                                    'account-credit-cards',
                                    'checkout-payment-methods'
                                ]);

                                $scope
                                    .createFromActionComponent(adyenResponse.attributes.payment_info)
                                    .then(function(identifyShopperResult) {
                                        $scope
                                            .processIdentifyShopperResult(identifyShopperResult)
                                            .then(function () {
                                                deferred.resolve();
                                            }, function(err) {
                                                $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);
                                                deferred.reject(err);
                                            });
                                    }, function(err) {
                                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);
                                        deferred.reject(err);
                                    });
                            }
                        } else if (adyenResponse.attributes.state === 'ChallengeShopper') {
                            $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', false);

                            if ($scope.isIOS) {
                                var challengeGetParams = 'lang=' + LanguageFactory.getActiveLocale() + '&origin=' + JF_CONFIG.adyenOriginKey.ios + '&env=' + (JF_CONFIG.environment === 'Production' ? 'live' : 'test') + '&action=challenge_shopper#'+JSON.stringify(adyenResponse.attributes.payment_info);

                                $rootScope.jfShared.adyen.iframe.adyenIosProcessingIframe = true;
                                $rootScope.jfShared.adyen.iframe.adyenIosProcessingIframeUrl = $sce.trustAsResourceUrl(jfConfigUrls.get('jfShopUrl', 'customerApp') + 'adyen-ios-iframe-3ds.html?' + challengeGetParams);

                                var _challengeShopperListener = function(e) {
                                    var adyenResponse = typeof e.data !== 'object' ? JSON.parse(e.data) : e.data;

                                    if (adyenResponse.type === '3dsResult') {
                                        if (adyenResponse.action === 'challenge_shopper') {
                                            $window.removeEventListener('message', _challengeShopperListener, true);

                                            $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                                            $scope
                                                .processChallengeShopperResult(adyenResponse.data)
                                                .then(function() {
                                                    $scope.clearAdyenAllIosFrames();

                                                    deferred.resolve();
                                                }, function(err) {
                                                    $scope.clearAdyenIosProcessingFrames();
                                                    $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                                                    deferred.reject(err);
                                                });
                                        }
                                    }

                                    if (adyenResponse.action === 'resizeProcessingIframe') {
                                        document.getElementById('adyenIosProcessingIframeWrapper').style.height = adyenResponse.height + 'px';
                                    }
                                };

                                $window.addEventListener('message', _challengeShopperListener, true);
                            } else {
                                $scope
                                    .createFromActionComponent(adyenResponse.attributes.payment_info)
                                    .then(function(challengeShopperResult) {
                                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                                        $scope
                                            .processChallengeShopperResult(challengeShopperResult)
                                            .then(function() {
                                                deferred.resolve();
                                            }, function(err) {
                                                $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);
                                                deferred.reject(err);
                                            });
                                    }, function(err) {
                                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);
                                        deferred.reject(err);
                                    });
                            }
                        } else if (adyenResponse.attributes.state === 'RedirectShopper') {
                            $scope
                                .createAdyenRedirectShopper(adyenResponse)
                                .then(function() {
                                    if ($scope.isIOS) {
                                        $scope.clearAdyenAllIosFrames();
                                    }

                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else if (adyenResponse.attributes.state === 'active') {
                            $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                            if ($scope.isIOS) {
                                $scope.clearAdyenAllIosFrames();
                            }

                            deferred.resolve();
                        } else {
                            $rootScope.$emit('app-error', {err: adyenResponse, silent: true});
                            $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                            deferred.reject();
                        }

                        return deferred.promise;
                    };

                    $scope.listenToAdyenRedirect = function() {
                        var deferred = $q.defer(),
                            _messageListener = function(e) {
                                if (
                                    e.origin === jfConfigUrls.get('accountService') ||
                                    e.origin === jfConfigUrls.get('adyenDomainUrl', 'customerApp') ||
                                    e.origin === 'file://' ||
                                    e.origin === 'ionic://localhost'
                                ) {
                                    $window.removeEventListener('message', _messageListener, true);

                                    var eventData = e.data;

                                    if (eventData.hasOwnProperty('action') && eventData.hasOwnProperty('md')) {
                                        deferred.resolve(eventData);
                                    }
                                }
                            };

                        $window.addEventListener('message', _messageListener, true);

                        return deferred.promise;
                    };

                    $scope.createAdyenRedirectShopper = function(adyenResponse) {
                        var deferred = $q.defer(),
                            paRequest = adyenResponse.attributes.payment_info.data.PaReq,
                            mD = adyenResponse.attributes.payment_info.data.MD,
                            termUrl = jfConfigUrls.get('adyenCheckoutReturnUrl', 'customerApp'),
                            issuerUrl = adyenResponse.attributes.payment_info.url,
                            IFRAME_NAME = 'threeDSMethodIframe',
                            threedsContainer = document.getElementById('threedsContainer'),
                            countryCode = $localStorage.order.details.attributes.delivery_address ? $localStorage.order.details.attributes.delivery_address.country_code : 'DE';

                        threedsContainer.style.display = 'block';

                        $scope
                            .listenToAdyenRedirect(adyenResponse, IFRAME_NAME)
                            .then(function(eventData) {
                                $scope
                                    .processAdyenRedirectShopper(eventData.md, adyenResponse, IFRAME_NAME)
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        $scope.hideIframe(IFRAME_NAME);
                                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                deferred.reject(err);
                            });

                        SpinnerFactory.set([
                            'account-credit-cards',
                            'checkout-payment-methods'
                        ]);

                        $window.ThreedDS2Utils.createIframe(threedsContainer, IFRAME_NAME, '390', '550', function() {
                            SpinnerFactory.unset([
                                'account-credit-cards',
                                'checkout-payment-methods'
                            ]);
                        });

                        var form = $window.ThreedDS2Utils.createForm('3dform', issuerUrl, IFRAME_NAME, 'PaReq', paRequest);

                        var input1 = document.createElement( 'input' );
                        input1.name = 'MD';
                        input1.value = mD;
                        form.appendChild( input1 );

                        var input2 = document.createElement( 'input' );
                        input2.name = 'TermUrl';
                        input2.value = termUrl;
                        form.appendChild( input2 );

                        var input3 = document.createElement( 'input' );
                        input3.name = 'SkinCode';
                        input3.value = JF_CONFIG.adyenSkinCode;
                        form.appendChild( input3 );

                        var input4 = document.createElement( 'input' );
                        input4.name = 'MerchantAccount';
                        input4.value = JF_CONFIG.adyenMerchantAccount[countryCode];
                        form.appendChild( input4 );

                        threedsContainer.appendChild(form);

                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', false);

                        $timeout( function () {
                            threedsContainer.removeChild( form );
                        }, 1000 );

                        form.submit();

                        return deferred.promise;
                    };

                    $scope.processAdyenRedirectShopper = function(md, adyenResponse, IFRAME_NAME) {
                        var deferred = $q.defer();

                        SpinnerFactory.set([
                            'account-credit-cards',
                            'checkout-payment-methods'
                        ]);

                        AccountUsersBillingAgreementsThreeDs
                            .get({
                                md: md
                            })
                            .$promise
                            .then(function(result) {
                                AdyenFactory
                                    .sendAdyenBillingAggreement(
                                        {
                                            event: 'redirect_shopper',
                                            customer_id: jfUser.get().id,
                                            country_code: $scope.country,
                                            payment_info: {
                                                number: $rootScope.jfShared.adyen.ccEndDigits,
                                                details: {
                                                    MD: result.md,
                                                    PaRes: result.pa_response
                                                },
                                                paymentData: adyenResponse.attributes.payment_info.paymentData
                                            }
                                        },
                                        $scope.country
                                    )
                                    .then(function(adyenResponse) {
                                        SpinnerFactory.unset([
                                            'account-credit-cards',
                                            'checkout-payment-methods'
                                        ]);

                                        $scope.hideIframe(IFRAME_NAME);
                                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', true);

                                        $scope
                                            .processAdyenEvent(adyenResponse.data)
                                            .then(function() {
                                                deferred.resolve();
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    }, function(err) {
                                        SpinnerFactory.unset([
                                            'account-credit-cards',
                                            'checkout-payment-methods'
                                        ]);

                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods'
                                ]);

                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.hideIframe = function(iframeName) {
                        var threedsContainer = document.getElementById('threedsContainer'),
                            iframeElement = document.querySelector('iframe[name="'+ iframeName + '"]');

                        threedsContainer.style.display = 'none';

                        if (iframeElement) {
                            threedsContainer.removeChild(iframeElement);
                        }
                    };

                    $scope.saveCreditCard = function() {
                        $scope.genericErrors = [];

                        $scope
                            .initializeAdyenPayment()
                            .then(function(adyenResponse) {
                                $scope
                                    .processAdyenEvent(adyenResponse)
                                    .then(function() {
                                        $scope.cleanAdyenIosData();

                                        $scope
                                            .saveCallback()
                                            .then(function() {

                                            }, function(err) {
                                                $rootScope.$emit('app-error', {err: err, silent: true});

                                                $scope.genericErrors.push({ detail: $filter('translate')('CC_ADYEN_ERROR') });
                                            });
                                    }, function(err) {
                                        if (angular.isDefined(err)) {
                                            $scope.handleCreditCardSaveErrors(err);
                                        }
                                    });
                            }, function(err) {
                                if (angular.isDefined(err)) {
                                    $scope.handleCreditCardSaveErrors(err);
                                }
                            });
                    };

                    $scope.handleCreditCardSaveErrors = function(err) {
                        if (
                            err.status === 422 &&
                            angular.isDefined(err.data) &&
                            angular.isDefined(err.data.errors)
                        ) {
                            var showExpireMonthError = false;
                            var showNotValidCardError = false;

                            angular.forEach(err.data.errors, function(errorObj) {
                                if (
                                    !showExpireMonthError &&
                                    angular.isDefined(errorObj.meta) &&
                                    errorObj.meta.code === 'expires_soon'
                                ) {
                                    showExpireMonthError = true;
                                } else if (
                                    !showNotValidCardError &&
                                    angular.isDefined(errorObj.meta) &&
                                    errorObj.meta.code === 'not_eligible_for_billing_agreements'
                                ) {
                                    showNotValidCardError = true;
                                }
                            });

                            if (showExpireMonthError) {
                                $scope.genericErrors.push({ detail: $filter('translate')('CC_ADYEN_EXPIRE_SOON_ERROR') });
                            } else if (showNotValidCardError) {
                                $scope.genericErrors.push({ detail: $filter('translate')('CC_ADYEN_NOT_VALID_CARD_ERROR') });
                            } else {
                                $rootScope.$emit('app-error', {err: err, silent: true});
                                $scope.genericErrors.push({ detail: $filter('translate')('CC_ADYEN_ERROR') });
                            }
                        } else {
                            $rootScope.$emit('app-error', {err: err, silent: true});

                            if (angular.isDefined(err.customErrorMsg) && err.customErrorMsg !== '') {
                                $scope.genericErrors.push({ detail: err.customErrorMsg });
                            } else {
                                $scope.genericErrors.push({ detail: $filter('translate')('CC_ADYEN_ERROR') });
                            }
                        }
                    };

                    $scope.goBack = function() {
                        $state.go('account.section', {section: 'preferences', subnav: null});
                    };

                    $scope.initIosCCIframe = function() {
                        var getParams = 'lang=' + $scope.country + '&origin=' + JF_CONFIG.adyenOriginKey.ios + '&env=' + (JF_CONFIG.environment === 'Production' ? 'live' : 'test');

                        $rootScope.jfShared.adyen.iframe.adyenIosInitIframe = true;
                        $rootScope.jfShared.adyen.iframe.adyenIosInitIframeUrl = $sce.trustAsResourceUrl(jfConfigUrls.get('jfShopUrl', 'customerApp') + 'adyen-ios-iframe.html?' + getParams + '&t=' + new Date().getTime());

                        if (angular.isUndefined($rootScope.jfShared.adyen.iOSInitCCIframeListener)) {
                            $rootScope.jfShared.adyen.iOSInitCCIframeListener = function(e) {
                                var adyenResponse = typeof e.data !== 'object' ? JSON.parse(e.data) : e.data;

                                if (adyenResponse.type === 'adyenInit') {
                                    AdyenFactory.ccFormSubmitDisabled = !adyenResponse.valid;

                                    if (adyenResponse.valid) {
                                        $rootScope.jfShared.adyen.ccEndDigits = adyenResponse.ccEndDigits;
                                        $rootScope.jfShared.adyen.ccFormValues = adyenResponse.data;
                                    }
                                }

                                if (adyenResponse.action === 'resizeInitIframe') {
                                    document.getElementById('adyenIosInitIframeWrapper').style.height = adyenResponse.height + 'px';
                                }
                            };

                            $window.addEventListener('message', $rootScope.jfShared.adyen.iOSInitCCIframeListener, true);
                        }
                    };

                    $scope.clearAdyenAllIosFrames = function() {
                        $rootScope.jfShared.adyen.iframe.adyenIosInitIframe = false;
                        delete $rootScope.jfShared.adyen.iframe.adyenIosInitIframeUrl;
                        $rootScope.jfShared.adyen.iframe.adyenIosIdentifyIframe = false;
                        delete $rootScope.jfShared.adyen.iframe.adyenIosIdentifyIframeUrl;
                        $rootScope.jfShared.adyen.iframe.adyenIosProcessingIframe = false;
                        delete $rootScope.jfShared.adyen.iframe.adyenIosProcessingIframeUrl;
                    };

                    $scope.clearAdyenIosProcessingFrames = function() {
                        $rootScope.jfShared.adyen.iframe.adyenIosIdentifyIframe = false;
                        delete $rootScope.jfShared.adyen.iframe.adyenIosIdentifyIframeUrl;
                        $rootScope.jfShared.adyen.iframe.adyenIosProcessingIframe = false;
                        delete $rootScope.jfShared.adyen.iframe.adyenIosProcessingIframeUrl;
                    };

                    $scope.cleanAdyenIosData = function() {
                        $rootScope.jfShared.adyen = { iframe: {} };
                    };

                    $scope.createFromActionComponent = function(card) {
                        var deferred = $q.defer();

                        function handleOnAdditionalDetails(state) {
                            deferred.resolve(state.data);
                        }

                        var configuration = {
                            locale: LanguageFactory.getActiveLocale(),
                            environment: JF_CONFIG.environment === 'Production' ? 'live' : 'test',
                            clientKey: AdyenFactory.adyenOriginKey,
                            onAdditionalDetails: handleOnAdditionalDetails
                        };

                        $window.AdyenCheckout(configuration).then(function(checkoutHandler) {
                            var widgetHolder = checkoutHandler.createFromAction(card).mount('#jf-adyen-cc-component-3ds');

                            $scope.$on('$destroy', function() {
                                widgetHolder.unmount();
                            });
                        }, function(err) {
                            console.log(err);
                        });

                        $rootScope.$emit('jfCheckout:checkoutshowMainCheckout', false);

                        SpinnerFactory.unset([
                            'account-credit-cards',
                            'checkout-payment-methods'
                        ]);

                        return deferred.promise;
                    };

                    $scope.initCreditCardFormDirective = function() {
                        $scope.genericErrors = [];
                        $scope.accountView = $state.current.name !== 'checkout';
                        $scope.showMainCheckout = true;
                        $scope.$mdMedia = $mdMedia;
                        $scope.adyenIosInitIframe = false;
                        $scope.appOrigin = $window.location.origin;
                        $scope.isIOS = jfHelper.mobileAppMode && angular.isDefined($window.device) && $window.device.platform.toLowerCase() === 'ios';
                        $scope.jfShared = $rootScope.jfShared;

                        $rootScope.jfShared.adyen = $rootScope.jfShared.adyen || {};

                        /**
                         * Adyen iOS workaround
                         *
                         * Initial problem:
                         * In order to use Adyen widgets, we need to generate Origin Key on Adyen website. Unfortunately they validate the protocol
                         * of the app, so they expect "https://..". Because of WkWebview on iOS, we run our app under ionic://cwa.jonnyfresh.com.
                         * We were not able to generate origin key for iOS app.
                         *
                         * Solution:
                         * As a workaround, we created new .html files on the server https://shop.jonnyfresh.com/adyen-ios-iframe.html and https://shop.jonnyfresh.com/adyen-ios-iframe-3ds.html.
                         * We load there Adyen widgets (with generated Origin Key for https://shop...) and pass data there from our app.
                         * New pages are loaded to our app with <iframe> elements and they use postMessage to send Adyen results back to the app.
                         * App is communicating with iframes through the iframe url by # value.
                         * It was not possible to use GET params (too long values) or postMessage (CORS issue, different protocols).
                         * Hash value was the only way to make it work.
                         */
                        if ($scope.isIOS) {
                            $rootScope.jfShared.adyen.iframe = {};

                            $scope.appOrigin = jfConfigUrls.get('jfShopUrl', 'customerApp');

                            $scope.initIosCCIframe();
                        } else {
                            if (!AdyenFactory.isScriptLoaded() && !AdyenFactory.scriptInjected) {
                                AdyenFactory.loadScript();
                                AdyenFactory.loadCss();
                            }

                            $scope.adyenLibWatcher = $scope.$watch(
                                function() {
                                    return $window.AdyenCheckout;
                                }, function(newValue) {
                                    if (angular.isDefined(newValue)) {
                                        AdyenFactory.initCCForm('#jf-adyen-cc-component');
                                    }
                                }
                            );
                        }

                        $scope.showMainCheckoutListener = $rootScope.$on(
                            'jfCheckout:checkoutshowMainCheckout', function(e, data) {
                                $scope.showMainCheckout = data;
                            }
                        );

                        $scope.$on('$destroy', function() {
                            $scope.showMainCheckoutListener();
                            if (angular.isDefined($scope.adyenLibWatcher)) {
                                $scope.adyenLibWatcher();
                            }
                            if (angular.isDefined($rootScope.jfShared.adyen.iOSInitCCIframeListener)) {
                                $window.removeEventListener('message', $rootScope.jfShared.adyen.iOSInitCCIframeListener, true);
                            }
                            $scope.cleanAdyenIosData();
                        });
                    };

                    jfController.init(['initCreditCardFormDirective'], $scope);
                }]
            };
        }
    );
/**
 * Company preferences directive
 */
angular.module('jfApp')
    .directive(
        'jfCompanyPreferences',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/jf-company-preferences.directive.html',
                controller: ['$scope', '$rootScope', 'AccountFactory', 'SpinnerFactory', 'jfUser', 'JF_CONFIG', 'jfController', function(
                    $scope,
                    $rootScope,
                    AccountFactory,
                    SpinnerFactory,
                    jfUser,
                    JF_CONFIG,
                    jfController
                ) {
                    $scope.paymentMethods = {};
                    $scope.companyLocations = {};

                    $scope.companyAddressesSuccessCallback = function(companyAddresses) {
                        if ($rootScope.countObjKeys(companyAddresses) > 0) {
                            $scope.companyLocations = companyAddresses;
                            $scope.firstAddress = $scope.companyLocations[Object.keys($scope.companyLocations)[0]];
                            $scope.locationsQuantity = $rootScope.countObjKeys(companyAddresses);

                            if (
                                angular.isDefined(jfUser.get().pb2bid) &&
                                jfUser.get().pb2bid !== null &&
                                angular.isDefined($scope.companyLocations[jfUser.get().pb2bid]) &&
                                $scope.companyLocations[jfUser.get().pb2bid].type === JF_CONFIG.addressTypes.service
                            ) {
                                $scope.companyLocation = jfUser.get().pb2bid;
                            } else {
                                $scope.companyLocation = $scope.firstAddress.id;
                            }


                            if ($rootScope.countObjKeys(companyAddresses) === 1) {
                                if (angular.isUndefined(jfUser.get().companyPostalCode)) {
                                    jfUser.update({
                                        companyPostalCode: $scope.companyLocations[Object.keys($scope.companyLocations)[0]].attributes.postal_code
                                    });
                                }

                                AccountFactory
                                    .saveUserPreferences($scope.companyLocations, $scope.companyLocations[Object.keys($scope.companyLocations)[0]].id, true)
                                    .then(function() {
                                        SpinnerFactory.unset('account-corporate');
                                    }, function(err) {
                                        SpinnerFactory.unset('account-corporate');
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                SpinnerFactory.unset('account-corporate');
                            }
                        } else {
                            SpinnerFactory.unset('account-corporate');
                        }
                    };

                    $scope.chooseAddress = function() {
                        AccountFactory.chooseAddress($scope.companyId, $scope.companyLocations, $scope.companyLocations[$scope.companyLocation], $scope.gaEventSection, true, $scope.initCompanyPreferencesView);
                    };

                    $scope.initCompanyPreferencesView = function() {
                        SpinnerFactory.set('account-corporate');

                        AccountFactory
                            .fetchCompanyId()
                            .then(function(companyId) {
                                $scope.companyId = companyId;
                                if (angular.isDefined(companyId) && companyId !== null) {
                                    AccountFactory
                                        .fetchUserCompanyAddresses(companyId, 'ServiceAddress')
                                        .then(function(companyAddresses) {
                                            $scope.companyAddressesSuccessCallback(companyAddresses);
                                        }, function(err) {
                                            SpinnerFactory.unset('account-corporate');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                } else {
                                    SpinnerFactory.unset('account-corporate');
                                    console.log('companyId was not defined');
                                }
                            }, function(err) {
                                SpinnerFactory.unset('account-corporate');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    jfController.init(['initCompanyPreferencesView'], $scope);
                }],
                link: function($scope, element, attributes) {
                    $scope.gaEventSection = attributes.gaEventSection || null;
                }
            };
        }
    );
/**
 * Company preferences directive
 */
angular.module('jfApp')
    .directive(
        'jfCompanyAddresses',
        function() {
            'use strict';

            return {
                restrict: 'E',
            templateUrl: 'app/components/account/directives/jf-company-addresses.directive.html',
                controller: ['$q', '$scope', '$rootScope', '$state', 'AccountFactory', 'OrderFactory', 'SpinnerFactory', 'jfUser', 'JF_CONFIG', 'jfController', function(
                    $q,
                    $scope,
                    $rootScope,
                    $state,
                    AccountFactory,
                    OrderFactory,
                    SpinnerFactory,
                    jfUser,
                    JF_CONFIG,
                    jfController
                ) {
                    $scope.paymentMethods = {};
                    $scope.companyLocations = {};

                    $scope.companyAddressesSuccessCallback = function(companyAddresses) {
                        SpinnerFactory.unset('onboarding-page');

                        if ($rootScope.countObjKeys(companyAddresses) > 0) {
                            $scope.firstAddress = $scope.companyLocations[Object.keys($scope.companyLocations)[0]];
                            $scope.locationsQuantity = $rootScope.countObjKeys(companyAddresses);

                            if (
                                angular.isDefined(jfUser.get().pb2bid) &&
                                jfUser.get().pb2bid !== null &&
                                angular.isDefined($scope.companyLocations[jfUser.get().pb2bid]) &&
                                $scope.companyLocations[jfUser.get().pb2bid].type === JF_CONFIG.addressTypes.service
                            ) {
                                $scope.companyLocation = jfUser.get().pb2bid;
                            } else {
                                $scope.companyLocation = $scope.firstAddress.id;
                            }
                        }
                    };

                    $scope.saveCompanyAccountPreferences = function(location) {
                        var deferred = $q.defer();
                        AccountFactory
                            .submitCompanyAccountPreferences($scope.companyLocations, location, $scope.gaEventSection)
                            .then(function() {
                                var addressToSave = {};
                                addressToSave = location.attributes;
                                addressToSave.id = location.id;
                                addressToSave.type = JF_CONFIG.addressTypes.service;

                                OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                OrderFactory
                                    .createNewOrder({
                                        company_id: $scope.companyId,
                                        pickup_address: addressToSave,
                                        delivery_address: addressToSave
                                    })
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                deferred.reject(err);
                            });
                        return deferred.promise;
                    };

                    $scope.chooseAddress = function(location) {
                        SpinnerFactory.set('onboarding-page');
                        $scope
                            .saveCompanyAccountPreferences(location)
                            .then(function() {
                                $state.go('products', {'#': 'c0'});
                            }, function(err) {
                                SpinnerFactory.unset('onboarding-page');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.initCompanyAddressesView = function() {
                        SpinnerFactory.set('onboarding-page');

                        AccountFactory
                            .fetchCompanyId()
                            .then(function(companyId) {
                                $scope.companyId = companyId;
                                if (angular.isDefined(companyId) && companyId !== null) {
                                    AccountFactory
                                        .fetchUserCompanyAddresses(companyId, 'ServiceAddress')
                                        .then(function(companyAddresses) {
                                            $scope.companyLocations = companyAddresses;
                                            if ($rootScope.countObjKeys(companyAddresses) > 1) {
                                                $scope.companyAddressesSuccessCallback(companyAddresses);
                                            } else {
                                                $scope
                                                    .saveCompanyAccountPreferences(companyAddresses[Object.keys(companyAddresses)[0]])
                                                    .then(function() {
                                                        $state.go('products', {'#': 'c0'});
                                                    }, function(err) {
                                                        SpinnerFactory.unset('onboarding-page');
                                                        $rootScope.$emit('app-error', {err: err});
                                                    });
                                            }
                                        }, function(err) {
                                            SpinnerFactory.unset('onboarding-page');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                } else {
                                    SpinnerFactory.unset('onboarding-page');
                                    console.log('companyId was not defined');
                                }
                            }, function(err) {
                                SpinnerFactory.unset('onboarding-page');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    jfController.init(['initCompanyAddressesView'], $scope);
                }],
                link: function($scope, element, attributes) {
                    $scope.gaEventSection = attributes.gaEventSection || null;
                }
            };
        }
    );
/**
 * Company account directive
 */
angular.module('jfApp')
    .directive(
        'jfCompanyAccount',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/jf-company-account.directive.html',
                controller: ['$scope', '$rootScope', '$filter', '$localStorage', '$state', 'AccountCustomerUnlinkOperationsFactory', 'AccountCustomerLinkOperationsFactory', 'AccountFactory', 'OrderFactory', 'ProductsFactory', 'SpinnerFactory', 'jfController', 'jfUser', 'jfJsonApi', 'base64', 'jfDialog', 'JF_CONFIG', 'JF_SHARED_CONFIG', function(
                    $scope,
                    $rootScope,
                    $filter,
                    $localStorage,
                    $state,
                    AccountCustomerUnlinkOperationsFactory,
                    AccountCustomerLinkOperationsFactory,
                    AccountFactory,
                    OrderFactory,
                    ProductsFactory,
                    SpinnerFactory,
                    jfController,
                    jfUser,
                    jfJsonApi,
                    base64,
                    jfDialog,
                    JF_CONFIG,
                    JF_SHARED_CONFIG
                ) {
                    $scope.unlinkUser = function() {
                        SpinnerFactory.set('account-corporate');

                        AccountCustomerUnlinkOperationsFactory
                            .save(
                                { id: jfUser.get().id },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.user,
                                    {
                                        corporate_code: base64.decode(jfUser.get().corporateCode),
                                        customer_id: jfUser.get().id
                                    },
                                    { id: jfUser.get().id }
                                )
                            )
                            .$promise
                            .then(function() {
                                $scope.unLinkCatalogSwitch();

                                if (
                                    angular.isDefined($localStorage.order) &&
                                    angular.isDefined($localStorage.order.details) &&
                                    angular.isDefined($localStorage.order.details.id)
                                ) {
                                    if (angular.isDefined($localStorage.lastPrivateCatalogLocation)) {
                                        var addressToSave = angular.copy($localStorage.lastPrivateCatalogLocation);
                                        addressToSave.addressable_type = 'Customer';

                                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                        OrderFactory
                                            .updateOrder(
                                                $localStorage.order.details.id,
                                                {
                                                    pickup_address: addressToSave,
                                                    delivery_address: addressToSave,
                                                    billing_address: { _destroy: true },
                                                    payment_method_id_destroy: true,
                                                    pickup_start_ts: null,
                                                    pickup_end_ts: null,
                                                    delivery_start_ts: null,
                                                    delivery_end_ts: null,
                                                    company_id: null
                                                }
                                            )
                                            .then(function() {
                                                $scope.unLinkCallback();
                                            }, function(err) {
                                                SpinnerFactory.unset('account-corporate');
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    } else {
                                        OrderFactory
                                            .updateOrder(
                                                $localStorage.order.details.id,
                                                {
                                                    billing_address: { _destroy: true },
                                                    payment_method_id_destroy: true,
                                                    pickup_start_ts: null,
                                                    pickup_end_ts: null,
                                                    delivery_start_ts: null,
                                                    delivery_end_ts: null,
                                                    company_id: null
                                                }
                                            )
                                            .then(function() {
                                                $scope.unLinkCallback();
                                            }, function(err) {
                                                SpinnerFactory.unset('account-corporate');
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    }
                                } else {
                                    $scope.unLinkCallback();
                                }
                            }, function(err) {
                                SpinnerFactory.unset('account-corporate');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.unLinkCatalogSwitch = function() {
                        AccountFactory.deleteCompanyPreferences();

                        if ($localStorage.catalogType === JF_CONFIG.accountTypes.company) {
                            ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);
                            if (
                                angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                                $rootScope.countObjKeys($localStorage.lastPrivateCatalogLocation) > 0 &&
                                $localStorage.lastPrivateCatalogLocation.postal_code_id !== null
                            ) {
                                ProductsFactory.setCatalogLocation($localStorage.lastPrivateCatalogLocation);
                            } else {
                                ProductsFactory.clearCatalogLocation();
                            }
                        }

                        $localStorage.order.additionalInfo.selectedPaymentMethodId = null;
                        $rootScope.order.additionalInfo.selectedPaymentMethodId = null;
                    };

                    $scope.unLinkCallback = function() {
                        SpinnerFactory.unset('account-corporate');

                        jfDialog
                            .showAlert(
                                $filter('translate')('SUCCESSFULLY_CANCELLED_CORPORATE_CODE_TITLE'),
                                $filter('translate')('SUCCESSFULLY_CANCELLED_CORPORATE_CODE_CONTENT'),
                                $filter('translate')('CANCEL_CORPORATE_CODE_OK'),
                                function() {
                                    $state.reload();
                                }
                            );

                        $scope.corporateAccount = false;
                        $scope.linkUser = {};
                    };

                    $scope.submitLink = function(form) {
                        if (form.$valid) {
                            SpinnerFactory.set('account-corporate');
                            AccountCustomerLinkOperationsFactory
                                .save(
                                    { id: jfUser.get().id, include: 'customer.company' },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.user,
                                        {
                                            corporate_code: $scope.linkUser.corporate_code,
                                            customer_id: jfUser.get().id
                                        },
                                        { id: jfUser.get().id }
                                    )
                                )
                                .$promise
                                .then(function(updatedUser) {
                                    var companyId;
                                    var corporateEnabled;

                                    angular.forEach(updatedUser.included, function(included) {
                                        if (included.type === JF_SHARED_CONFIG.modelTypes.company) {
                                            companyId = included.id;
                                        }
                                        if (included.type === JF_SHARED_CONFIG.modelTypes.customers) {
                                            corporateEnabled = included.attributes.corporate_enabled;
                                        }
                                    });
                                    jfUser.update({
                                        corporateCode: base64.encode($scope.linkUser.corporate_code),
                                        companyId: companyId,
                                        corporateEnabled: corporateEnabled
                                    });
                                    if (corporateEnabled) {
                                        ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.company);
                                    }
                                    AccountFactory
                                        .fetchUserCompanyAddresses(companyId, 'ServiceAddress')
                                        .then(function(companyAddresses) {
                                            AccountFactory.chooseAddress(companyId, companyAddresses, undefined, undefined, false, function() {
                                                $localStorage.order.additionalInfo.selectedPaymentMethodId = null;
                                                $rootScope.order.additionalInfo.selectedPaymentMethodId = null;
                                                AccountFactory
                                                    .getCompanyInformation(jfUser.get().companyId)
                                                    .then(function() {
                                                        SpinnerFactory.unset('account-corporate');
                                                        $scope.corporateAccount = jfUser.get().corporateEnabled;
                                                        $state.reload();
                                                    }, function(err) {
                                                        SpinnerFactory.unset('account-corporate');
                                                        $rootScope.$emit('app-error', {err: err});
                                                    });
                                            });
                                        }, function(err) {
                                            SpinnerFactory.unset('account-corporate');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }, function(err) {
                                    SpinnerFactory.unset('account-corporate');
                                    if (
                                        err.status === 422 && err.data.errors.length > 0
                                    ) {
                                        angular.forEach(err.data.errors, function(error) {
                                            if (error.source.pointer === '/data/attributes/corporate_code') {
                                                form.corporate_code.$setValidity('corporateCodeInvalid', false);
                                            } else {
                                                $rootScope.$emit('app-error', {err: err});
                                            }
                                        });
                                    } else if (err.status === 409) {
                                        form.corporate_code.$setValidity('corporateCodeInvalid', false);
                                    } else {
                                        $rootScope.$emit('app-error', {err: err});
                                    }
                                });
                        }
                    };

                    $scope.initCompanyAccountView = function() {
                        $scope.linkUser = {};

                        if (angular.isDefined(jfUser.get().corporateEnabled) && jfUser.get().corporateEnabled === true) {
                            SpinnerFactory.set('account-corporate');

                            AccountFactory
                                .checkCorporateEnabledFlag()
                                .then(function(flagEnabled) {
                                    SpinnerFactory.unset('account-corporate');

                                    if (!flagEnabled) {
                                        AccountFactory.corporateFlagDisabledCallback();
                                        $scope.corporateAccount = false;
                                    } else {
                                        $scope.corporateAccount = true;
                                    }
                                }, function(err) {
                                    SpinnerFactory.unset('account-corporate');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $scope.corporateAccount = false;
                        }
                    };

                    jfController.init(['initCompanyAccountView'], $scope);
                }]
            };
        }
    );
/**
 * Personal account tab directive
 */
angular.module('jfApp')
    .directive(
        'jfPersonalAccount',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/jf-personal-account.directive.html',
                controller: ['$scope', '$rootScope', '$state', '$localStorage', '$mdToast', '$filter', 'base64', 'jfJsonApi', 'jfUser', 'AccountUserProfileFactory', 'SpinnerFactory', 'LanguageFactory', 'jfController', 'JF_SHARED_CONFIG', function(
                    $scope,
                    $rootScope,
                    $state,
                    $localStorage,
                    $mdToast,
                    $filter,
                    base64,
                    jfJsonApi,
                    jfUser,
                    AccountUserProfileFactory,
                    SpinnerFactory,
                    LanguageFactory,
                    jfController,
                    JF_SHARED_CONFIG
                ) {

                    $scope.logout = function() {
                        $state.go('logout');
                    };

                    $scope.cancel = function() {
                        $state.go('home');
                    };

                    $scope.submitAccountDetails = function(form) {
                        if (form.$valid) {
                            SpinnerFactory.set('account-details-customer-data');

                            var dataToSave = {
                                salutation: $scope.user.title,
                                first_name: $scope.user.first_name,
                                last_name: $scope.user.last_name,
                                phone_no: $scope.user.phone_number,
                                preferred_locale: $localStorage.shopLocale
                            };

                            AccountUserProfileFactory
                                .update(
                                    { id: jfUser.get().profileId },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.profile,
                                        dataToSave,
                                        { id: jfUser.get().profileId }
                                    )
                                )
                                .$promise
                                .then(function() {
                                    SpinnerFactory.unset('account-details-customer-data');

                                    jfUser.update({
                                        firstName: $scope.user.first_name ? base64.encode($scope.user.first_name) : null,
                                        lastName: $scope.user.last_name ? base64.encode($scope.user.last_name) : null,
                                        phoneNo: $scope.user.phone_number ? base64.encode($scope.user.phone_number) : null,
                                        locale: $localStorage.shopLocale
                                    });
                                    LanguageFactory.use($localStorage.shopLocale);

                                    $mdToast.show($mdToast.simple().textContent($filter('translate')('PROFILE_SAVED')));
                                }, function(err) {
                                    SpinnerFactory.unset('account-details-customer-data');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    $scope.initPersonalAccountView = function() {
                        $scope.user = {};

                        if (angular.isDefined(jfUser.get().id)) {
                            SpinnerFactory.set('account-details-customer-data');

                            AccountUserProfileFactory
                                .get({
                                    'filter[user_id]': jfUser.get().id
                                })
                                .$promise
                                .then(function(result) {
                                    SpinnerFactory.unset('account-details-customer-data');

                                    $scope.user.title = result.data[0].attributes.salutation;
                                    $scope.user.first_name = result.data[0].attributes.first_name;
                                    $scope.user.last_name = result.data[0].attributes.last_name;
                                    $scope.user.phone_number = result.data[0].attributes.phone_no;
                                    $scope.user.email_address = base64.decode(jfUser.get().login);
                                    $scope.user.preferred_locale = result.data[0].attributes.preferred_locale;
                                }, function(err) {
                                    SpinnerFactory.set('account-details-customer-data');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    jfController.init(['initPersonalAccountView'], $scope);
                }]
            };
        }
    );
/**
 * My Account Details Change Password tab directive
 */
angular.module('jfApp')
    .directive(
        'jfMyAccountChangePassword',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/jf-my-account-change-password.directive.html',
                controller: ['$scope', '$rootScope', '$state', '$localStorage', 'jfJsonApi', 'jfUser', 'jfController', 'JF_SHARED_CONFIG', 'SpinnerFactory', 'OrderFactory', 'AccountCustomerFactory', function(
                    $scope,
                    $rootScope,
                    $state,
                    $localStorage,
                    jfJsonApi,
                    jfUser,
                    jfController,
                    JF_SHARED_CONFIG,
                    SpinnerFactory,
                    OrderFactory,
                    AccountCustomerFactory
                ) {
                    $scope.cancel = function() {
                        $state.go('home');
                    };

                    $scope.submitAccountPassword = function(form) {
                        form.current_password.$setValidity('wrongCurrentPassword', true);

                        if (form.$valid) {
                            SpinnerFactory.set('account-details-password-change');

                            AccountCustomerFactory
                                .update(
                                    { id: jfUser.get().id },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.customers,
                                        { password: $scope.user.new_password },
                                        { id: jfUser.get().id }
                                    )
                                )
                                .$promise
                                .then(function() {
                                    jfUser.logout();

                                    delete $localStorage.catalogLocation;
                                    delete $rootScope.jfShared.checkout;

                                    OrderFactory.createEmptyOrderObject();

                                    $state.go('login', {password_changed: true});
                                }, function(err) {
                                    SpinnerFactory.unset('account-details-password-change');

                                    if (err.status === 403) {
                                        form.current_password.$setValidity('wrongCurrentPassword', false);
                                    } else {
                                        $rootScope.$emit('app-error', { err: err });
                                    }
                                });
                        }
                    };

                    $scope.initMyAccountChangePasswordView = function() {
                        $scope.user = {};
                    };

                    jfController.init(['initMyAccountChangePasswordView'], $scope);
                }]
            };
        }
    );
/**
 * Payment methods manager directive
 */
angular
    .module('jfApp')
    .directive(
        'jfPaymentMethodsManager',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/account/directives/jf-payment-methods-manager.directive.html',
                controller: ['$scope', '$rootScope', '$window', '$filter', '$location', '$translate', '$state', '$localStorage', 'PaymentMethodsManagerFactory', 'SpinnerFactory', 'AdyenFactory', 'LanguageFactory', 'JF_CONFIG', 'jfUser', 'jfDialog', 'jfConfigUrls', 'jfHelper', 'jfController', function(
                    $scope,
                    $rootScope,
                    $window,
                    $filter,
                    $location,
                    $translate,
                    $state,
                    $localStorage,
                    PaymentMethodsManagerFactory,
                    SpinnerFactory,
                    AdyenFactory,
                    LanguageFactory,
                    JF_CONFIG,
                    jfUser,
                    jfDialog,
                    jfConfigUrls,
                    jfHelper,
                    jfController
                ) {
                    $scope.triggerPaymentMethodAdd = function(paymentMethodSection) {
                        if (paymentMethodSection.type === 'cc') {
                            PaymentMethodsManagerFactory
                                .getBillingAddress()
                                .then(function(billingAddress) {
                                    if (angular.isDefined(billingAddress)) {
                                        $state.go('account.section', {section: 'payment-methods', subnav: 'new', paymentMethod: paymentMethodSection});
                                    } else {
                                        jfDialog
                                            .showConfirm(
                                                $filter('translate')('ADD_PAYMENT_METHOD_MISSING_BILLING_ADDRESS_TITLE'),
                                                $filter('translate')('ADD_PAYMENT_METHOD_MISSING_BILLING_ADDRESS_CONTENT'),
                                                $filter('translate')('ADD_PAYMENT_METHOD_MISSING_BILLING_ADDRESS_OK'),
                                                $filter('translate')('ADD_PAYMENT_METHOD_MISSING_BILLING_ADDRESS_CANCEL'),
                                                function() {
                                                    $state.go('account.section', {section: 'my-addresses'});
                                                }
                                            );
                                    }
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $state.go('account.section', {section: 'payment-methods', subnav: 'new', paymentMethod: paymentMethodSection});
                        }
                    };

                    $scope.fetchAdyenBillingAgreements = function() {
                        PaymentMethodsManagerFactory
                            .fetchAdyenBillingAgreements()
                            .then(function(billingAgreements) {
                                $scope.paymentMethodSections.ccDE.activeBillingAgreements = billingAgreements.cc.DE;
                                $scope.paymentMethodSections.ccAT.activeBillingAgreements = billingAgreements.cc.AT;
                                $scope.paymentMethodSections.pp.activeBillingAgreements = billingAgreements.pp;
                                $scope.paymentMethodSections.sepa.activeBillingAgreements = billingAgreements.sepa;
                                $scope.paymentMethodSections.app.activeBillingAgreements = billingAgreements.app;

                                $scope.defaultPaymentMethod = jfUser.get().defaultPaymentMethod;
                                $scope.defaultBillingAgreementId = jfUser.get().preferredBillingAgreementId;
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.deleteCreditCard = function(billingAgreement, paymentSection) {
                        $scope.showAuthorizationError = false;

                        jfDialog
                            .showConfirm(
                                $filter('translate')('DELETE_CREDIT_CARD_TITLE'),
                                $filter('translate')('DELETE_CREDIT_CARD_CONTENT'),
                                $filter('translate')('DELETE_CREDIT_CARD_OK'),
                                $filter('translate')('DELETE_CREDIT_CARD_CANCEL'),
                                function() {
                                    PaymentMethodsManagerFactory
                                        .deleteBillingAgreement(billingAgreement, paymentSection)
                                        .then(function() {
                                            $scope.fetchAdyenBillingAgreements();
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            );
                    };

                    $scope.deletePayPal = function(billingAgreement, paymentSection) {
                        $scope.showAuthorizationError = false;

                        jfDialog
                            .showConfirm(
                                $filter('translate')('DELETE_PAYPAL_TITLE'),
                                $filter('translate')('DELETE_PAYPAL_CONTENT'),
                                $filter('translate')('DELETE_PAYPAL_OK'),
                                $filter('translate')('DELETE_PAYPAL_CANCEL'),
                                function() {
                                    PaymentMethodsManagerFactory
                                        .deleteBillingAgreement(billingAgreement, paymentSection)
                                        .then(function() {
                                            $scope.fetchAdyenBillingAgreements();
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            );
                    };

                    $scope.deleteSepa = function(billingAgreement, paymentSection) {
                        $scope.showAuthorizationError = false;

                        jfDialog
                            .showConfirm(
                                $filter('translate')('DELETE_SEPA_TITLE'),
                                $filter('translate')('DELETE_SEPA_CONTENT'),
                                $filter('translate')('DELETE_SEPA_OK'),
                                $filter('translate')('DELETE_SEPA_CANCEL'),
                                function() {
                                    PaymentMethodsManagerFactory
                                        .deleteBillingAgreement(billingAgreement, paymentSection)
                                        .then(function() {
                                            $scope.fetchAdyenBillingAgreements();
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            );
                    };

                    $scope.deleteApp = function(billingAgreement, paymentSection) {
                        $scope.showAuthorizationError = false;

                        jfDialog
                            .showConfirm(
                                $filter('translate')('DELETE_APPLE_PAY_TITLE'),
                                $filter('translate')('DELETE_APPLE_PAY_CONTENT'),
                                $filter('translate')('DELETE_APPLE_PAY_OK'),
                                $filter('translate')('DELETE_APPLE_PAY_CANCEL'),
                                function() {
                                    PaymentMethodsManagerFactory
                                        .deleteBillingAgreement(billingAgreement, paymentSection)
                                        .then(function() {
                                            $scope.fetchAdyenBillingAgreements();
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            );
                    };

                    $scope.triggerPayPal = function(paymentSection) {
                        $scope.showAuthorizationError = false;
                        SpinnerFactory.set('global', $translate.instant('PAY_PAL_REDIRECT_INFO'));

                        AdyenFactory
                            .sendAdyenBillingAggreement(
                                {
                                    customer_id: jfUser.get().id,
                                    country_code: paymentSection.locale.indexOf('DE') > -1 ? 'DE' : 'AT',
                                    payment_info: {
                                        paymentMethod: { type: 'paypal' },
                                        returnUrl: $window.location.href.replace(/\/+$/, ''),
                                        origin: $window.location.origin,
                                    },
                                    event: 'init'
                                },
                                paymentSection.locale.indexOf('DE') > -1 ? 'DE' : 'AT'
                            )
                            .then(function(adyenResponse) {
                                $scope.redirectHandler(adyenResponse);
                            }, function (err) {
                                SpinnerFactory.unset('global', null);

                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.redirectHandler = function(adyenResponse) {
                        if (jfHelper.mobileAppMode) {
                            $scope.redirectOnMobile(adyenResponse.data.attributes.payment_info.url);
                        } else {
                            $window.location = adyenResponse.data.attributes.payment_info.url;
                        }
                    };

                    $scope.redirectOnMobile = function(pageContentUrl) {
                        var ref = $window.window.open(pageContentUrl, '_blank', 'hidden=no,location=no,clearsessioncache=yes,clearcache=yes');

                        ref.addEventListener('exit', function() {
                            // Hack for ios - the status bar is hidden after closing inappbrowser, this is the way to fix it...
                            if (typeof StatusBar !== 'undefined') {
                                StatusBar.hide();
                                StatusBar.show();
                            }

                            SpinnerFactory.unset('global', null);
                        });

                        ref.addEventListener('loadstart', function(event) {
                            if (
                                event.url.indexOf(jfConfigUrls.get('jfShopUrl', 'customerApp')) > -1 ||
                                event.url.indexOf('ionic://cwa.jonnyfresh.com') === 0 ||
                                event.url.indexOf('https://cwa.jonnyfresh.com') === 0
                            ) {
                                ref.close();

                                var searchParams = new window.URLSearchParams(event.url.split('?')[1]);

                                if (searchParams.get('resultCode') && searchParams.get('resultCode') === 'cancelled') {
                                    $scope.showAuthorizationError = true;
                                } else {
                                    $scope.showAuthorizationError = false;
                                    $state.reload();
                                }
                            }
                        });
                    };

                    $scope.saveAsPreferredPaymentMethod = function(paymentMethodId, billingAgreementId) {
                        $scope.showAuthorizationError = false;

                        PaymentMethodsManagerFactory
                            .updateProfileWithPreferredData(paymentMethodId, billingAgreementId)
                            .then(function(result) {
                                $scope.defaultPaymentMethod = result.defaultPaymentMethod;
                                $scope.defaultBillingAgreementId = result.preferredBillingAgreementId;

                                $scope.fetchAdyenBillingAgreements();
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.isDefaultPaymentMethod = function(paymentMethodSection, activeBillingAgreement) {
                        if (paymentMethodSection.type === 'cc' && activeBillingAgreement.recurring_detail_reference === $scope.defaultBillingAgreementId) {
                            return true;
                        } else if (paymentMethodSection.type === 'cc' && activeBillingAgreement.recurring_detail_reference !== $scope.defaultBillingAgreementId) {
                            return false;
                        } else if (paymentMethodSection.paymentMethodId === $scope.defaultPaymentMethod) {
                            return true;
                        } else {
                            return false;
                        }
                    };

                    $scope.showAddNewPaymentMethodLink = function(paymentMethodSection) {
                        return (paymentMethodSection.paymentMethodId === JF_CONFIG.paymentMethods.creditCard) ||
                                (
                                    [JF_CONFIG.paymentMethods.payPalAfterPayment, JF_CONFIG.paymentMethods.sepa, JF_CONFIG.paymentMethods.app].includes(paymentMethodSection.paymentMethodId) &&
                                    paymentMethodSection.activeBillingAgreements.length === 0
                                );
                    };

                    $scope.initPaymentMethodsManagerView = function() {
                        $scope.paymentMethodSections = {
                            ccDE: {
                                type: 'cc',
                                title: $filter('translate')('CC_COUNTRY_HEAD_DE'),
                                activeBillingAgreements: [],
                                addNewTitle: $filter('translate')('CC_ADD_NEW'),
                                deleteAction: $scope.deleteCreditCard,
                                locale: 'de_DE',
                                paymentMethodId: JF_CONFIG.paymentMethods.creditCard
                            },
                            ccAT: {
                                type: 'cc',
                                title: $filter('translate')('CC_COUNTRY_HEAD_AT'),
                                activeBillingAgreements: [],
                                addNewTitle: $filter('translate')('CC_ADD_NEW'),
                                deleteAction: $scope.deleteCreditCard,
                                locale: 'de_AT',
                                paymentMethodId: JF_CONFIG.paymentMethods.creditCard
                            },
                            pp: {
                                type: 'pp',
                                title: 'PayPal',
                                activeBillingAgreements: [],
                                addNewTitle: $filter('translate')('ADD_NEW_PAYPAL_BILLING_AGREEMENT'),
                                deleteAction: $scope.deletePayPal,
                                locale: LanguageFactory.getActiveLocale(),
                                paymentMethodId: JF_CONFIG.paymentMethods.payPalAfterPayment
                            },
                            sepa: {
                                type: 'sepa',
                                title: 'SEPA Lastschrift',
                                activeBillingAgreements: [],
                                addNewTitle: $filter('translate')('ADD_NEW_SEPA_BILLING_AGREEMENT'),
                                deleteAction: $scope.deleteSepa,
                                locale: LanguageFactory.getActiveLocale(),
                                paymentMethodId: JF_CONFIG.paymentMethods.sepa
                            },
                            app: {
                                type: 'app',
                                title: 'Apple Pay',
                                activeBillingAgreements: [],
                                deleteAction: $scope.deleteApp,
                                locale: LanguageFactory.getActiveLocale(),
                                paymentMethodId: JF_CONFIG.paymentMethods.app
                            }
                        };

                        $scope.defaultPaymentMethod = jfUser.get().defaultPaymentMethod;
                        $scope.defaultBillingAgreementId = jfUser.get().preferredBillingAgreementId;

                        $scope.fetchAdyenBillingAgreements();

                        $scope.showAuthorizationError = $location.search().redirectResult && $location.search().resultCode === 'cancelled';

                        if (!AdyenFactory.isScriptLoaded() && !AdyenFactory.scriptInjected) {
                            AdyenFactory.loadScript();
                            AdyenFactory.loadCss();
                        }

                        $scope.parcelServiceEnabled = jfUser.get().parcelServiceEnabled || false;
                        $scope.allowPaymentMethodEdits = jfUser.get().allowPaymentMethodEdits || (
                            !jfUser.get().allowPaymentMethodEdits &&
                            jfUser.get().corporateEnabled &&
                            $localStorage.catalogType !== JF_CONFIG.accountTypes.company
                        );
                    };

                    jfController.init(['initPaymentMethodsManagerView'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Pickup Notes directive
 */
angular.module('jfApp')
    .directive(
        'pickupNotes',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/pickup-notes.html',
                replace: true,
                controller: ['$scope', '$rootScope', '$localStorage', function ($scope, $rootScope, $localStorage) {
                    $scope.savePickupNote = function() {
                        $localStorage.order.additionalInfo.pickupNote = $rootScope.order.additionalInfo.pickupNote;
                    };
                }]
            };
        }
    );
/**
 * Checkout - Delivery Notes directive
 */
angular.module('jfApp')
    .directive(
        'deliveryNotes',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/delivery-notes.html',
                replace: true,
                controller: ['$scope', '$rootScope', '$localStorage', function ($scope, $rootScope, $localStorage) {
                    $scope.saveDeliveryNote = function() {
                        $localStorage.order.additionalInfo.deliveryNote = $rootScope.order.additionalInfo.deliveryNote;
                    };
                }]
            };
        }
    );
/**
 * Checkout - Choose Address directive
 */
angular.module('jfApp')
    .directive(
        'chooseAddress',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/choose-address.html',
                replace: true,
                link: function($scope, element, attrs) {
                    $scope.mobileCheckoutPreview = attrs.mobileCheckoutPreview || false;
                    $scope.showAllAddresses = attrs.showAllAddresses === 'true';
                },
                controller: ['$scope', '$rootScope', '$localStorage', '$state', '$q', '$filter', 'ProductsFactory', 'AccountFactory', 'SpinnerFactory', 'OrderFactory', 'CheckoutFactory', 'JF_CONFIG', 'jfDialog', 'jfUser', 'jfController', function (
                    $scope,
                    $rootScope,
                    $localStorage,
                    $state,
                    $q,
                    $filter,
                    ProductsFactory,
                    AccountFactory,
                    SpinnerFactory,
                    OrderFactory,
                    CheckoutFactory,
                    JF_CONFIG,
                    jfDialog,
                    jfUser,
                    jfController
                ) {
                    $scope.showEditButton = function(userAddress) {
                        return angular.isDefined($rootScope.jfShared.checkout) &&
                               angular.isDefined($rootScope.jfShared.checkout.userAddresses[userAddress.id]) &&
                               $rootScope.jfShared.checkout.userAddresses[userAddress.id].attributes.addressable_type !== 'Company';
                    };

                    $scope.disablePickupAddress = function(catalogCity, userAddress) {
                        if (angular.isUndefined(userAddress) || !angular.isDefined($rootScope.jfShared.checkout.userAddresses[userAddress.id])) {
                            return false;
                        }

                        return userAddress.attributes.city.indexOf(catalogCity) === -1 ||
                                userAddress.postal_code_in_service === false ||
                                userAddress.differentPartner === true ||
                                (
                                    AccountFactory.isCompanyAccount() &&
                                    angular.isDefined($localStorage.companyDetails) &&
                                    $localStorage.companyDetails !== null &&
                                    angular.isDefined($rootScope.jfShared.checkout.userAddresses[userAddress.id]) &&
                                    $rootScope.jfShared.checkout.userAddresses[userAddress.id].attributes.addressable_type !== 'Company'
                                ) ||
                                (
                                    $rootScope.jfShared.checkout.userAddresses[userAddress.id].type === JF_CONFIG.addressTypes.invoice
                                ) ||
                                userAddress.plant_id !== $localStorage.order.details.attributes.processing_plant_id;
                    };

                    $scope.disableDeliveryAddress = function(catalogCity, userAddress) {
                        if (angular.isUndefined(userAddress) || angular.isUndefined($rootScope.jfShared.checkout.userAddresses[userAddress.id])) {
                            return false;
                        }

                        return userAddress.attributes.city.indexOf(catalogCity) === -1 ||
                            userAddress.postal_code_in_service === false ||
                            userAddress.differentPartner === true ||
                            (
                                AccountFactory.isCompanyAccount() &&
                                angular.isDefined($localStorage.companyDetails) &&
                                $localStorage.companyDetails !== null &&
                                angular.isDefined($rootScope.jfShared.checkout.userAddresses[userAddress.id]) &&
                                $rootScope.jfShared.checkout.userAddresses[userAddress.id].attributes.addressable_type !== 'Company'
                            ) ||
                            (
                                $rootScope.jfShared.checkout.userAddresses[userAddress.id].type === JF_CONFIG.addressTypes.invoice
                            ) ||
                            userAddress.plant_id !== $localStorage.order.details.attributes.processing_plant_id;
                    };

                    $scope.disableBillingAddress = function(userAddress) {
                        if (angular.isUndefined($rootScope.jfShared.checkout.userAddresses[userAddress.id])) {
                            return false;
                        }

                        return AccountFactory.isCompanyAccount() &&
                                (
                                    (
                                        angular.isDefined($localStorage.companyDetails) &&
                                        $localStorage.companyDetails !== null &&
                                        $localStorage.companyDetails.pays_for_user &&
                                        (
                                            $rootScope.jfShared.checkout.userAddresses[userAddress.id].attributes.addressable_type !== 'Company' ||
                                            (
                                                $rootScope.jfShared.checkout.userAddresses[userAddress.id].type !== JF_CONFIG.addressTypes.invoice &&
                                                $localStorage.companyDetails.billing_address_id !== userAddress.id
                                            )
                                        )
                                    ) ||
                                    (
                                        angular.isDefined($localStorage.companyDetails) &&
                                        $localStorage.companyDetails !== null &&
                                        !$localStorage.companyDetails.pays_for_user &&
                                        $rootScope.jfShared.checkout.userAddresses[userAddress.id].attributes.addressable_type === 'Company'
                                    )
                                );
                    };

                    $scope.userAddressesAsArray = function() {
                        var userAddressesArr = [];

                        angular.forEach($rootScope.jfShared.checkout.userAddresses, function(userAddress) {
                            userAddressesArr.push(userAddress);
                        });

                        var sortedArray = [];

                        angular.forEach(userAddressesArr, function(userAddress) {
                            var pushAddress = true;

                            if (
                                $localStorage.catalogType !== 'personal' &&
                                $localStorage.companyDetails.pays_for_user &&
                                userAddress.attributes.addressable_type === 'Customer'
                            ) {
                                pushAddress = false;
                            }

                            if (pushAddress) {
                                if (
                                    userAddress.id === $scope.selectedAddresses.pickupAddressId ||
                                    userAddress.id === $scope.selectedAddresses.deliveryAddressId ||
                                    userAddress.id === $scope.selectedAddresses.billingAddressId
                                ) {
                                    sortedArray.unshift(userAddress);
                                } else {
                                    sortedArray.push(userAddress);
                                }
                            }
                        });

                        return sortedArray;
                    };

                    $scope.showHiddenAddresses = function() {
                        $scope.sortedUserAddresses = $scope.userAddressesAsArray();
                        $scope.showAllAddresses = true;
                    };

                    $scope.openEditAddressForm = function(userAddress) {
                        $state.params.addressToEdit = userAddress;
                        $state.params.subnav = 'edit-address';
                        $rootScope.$emit('jfCheckout:checkoutEditAddress');
                    };

                    $scope.toggleShowAllAddresses = function() {
                        $scope.showAllAddresses = !$scope.showAllAddresses;
                    };

                    $scope.visibilityManagement = function(address) {
                        if (
                            $scope.showAllAddresses === false &&
                            (
                                address.id !== $scope.selectedAddresses.pickupAddressId &&
                                address.id !== $scope.selectedAddresses.deliveryAddressId &&
                                address.id !== $scope.selectedAddresses.billingAddressId
                            )
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    };

                    $scope.countSelectedAddresses = function() {
                        var selectedAddressIds = [];
                        angular.forEach($scope.selectedAddresses, function(selectedAddress) {
                            if (selectedAddressIds.indexOf(selectedAddress) === -1) {
                                selectedAddressIds.push(selectedAddress);
                            }
                        });

                        return selectedAddressIds.length;
                    };

                    $scope.showPartnerMissmatchPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('PARTNER_MISMATCH_POPUP_TITLE'),
                            $filter('translate')('PARTNER_MISMATCH_POPUP_CONTENT'),
                            $filter('translate')('PARTNER_MISMATCH_POPUP_OK')
                        );
                    };

                    $scope.changePickupAddressAction = function(selectedAddressId) {
                        SpinnerFactory.set('checkout-choose-address');

                        $scope
                            .changePickupAddress(selectedAddressId)
                            .then(function() {
                                $rootScope.$emit('jfCheckout:loadAddresses');

                                SpinnerFactory.unset('checkout-choose-address');
                            }, function(err) {
                                SpinnerFactory.unset('checkout-choose-address');

                                $scope.selectedAddresses.pickupAddressId = $localStorage.order.details.attributes.pickup_address.resource_id;

                                if (err.status === 422 && angular.isDefined(err.failedAddressSaveId)) {
                                    $scope.showPartnerMissmatchPopup();
                                } else {
                                    $rootScope.$emit('app-error', {err: err});
                                }
                            });
                    };

                    $scope.changePickupAddress = function(selectedAddressId) {
                        var deferred = $q.defer();

                        if (selectedAddressId === null) {
                            deferred.resolve();
                        } else {
                            var addressToSave = angular.copy($rootScope.jfShared.checkout.userAddresses[selectedAddressId].attributes);

                            addressToSave.resource_id = selectedAddressId;

                            OrderFactory
                                .savePickupAddress(addressToSave)
                                .then(function() {
                                    $scope.selectedAddresses.pickupAddressId = selectedAddressId;

                                    $scope.goBackToCheckoutView();

                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }

                        return deferred.promise;
                    };

                    $scope.changeDeliveryAddressAction = function(selectedAddressId) {
                        SpinnerFactory.set('checkout-choose-address');

                        $scope
                            .changeDeliveryAddress(selectedAddressId)
                            .then(function() {
                                $rootScope.$emit('jfCheckout:loadAddresses');

                                SpinnerFactory.unset('checkout-choose-address');
                            }, function(err) {
                                SpinnerFactory.unset('checkout-choose-address');

                                $scope.selectedAddresses.deliveryAddressId = $localStorage.order.details.attributes.delivery_address.resource_id;

                                if (err.status === 422 && angular.isDefined(err.failedAddressSaveId)) {
                                    $scope.showPartnerMissmatchPopup();
                                } else {
                                    $rootScope.$emit('app-error', {err: err});
                                }
                            });
                    };

                    $scope.changeDeliveryAddress = function(selectedAddressId) {
                        var deferred = $q.defer();

                        if (selectedAddressId === null) {
                            deferred.resolve();
                        } else {
                            var addressToSave = angular.copy($rootScope.jfShared.checkout.userAddresses[selectedAddressId].attributes);
                            addressToSave.resource_id = selectedAddressId;

                            OrderFactory
                                .saveDeliveryAddress(addressToSave)
                                .then(function() {
                                    $scope.selectedAddresses.deliveryAddressId = selectedAddressId;

                                    $scope.goBackToCheckoutView();

                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }

                        return deferred.promise;
                    };

                    $scope.changeBillingAddressAction = function(selectedAddressId) {
                        SpinnerFactory.set('checkout-choose-address');

                        $scope
                            .changeBillingAddress(selectedAddressId)
                            .then(function() {
                                SpinnerFactory.unset('checkout-choose-address');
                            }, function(err) {
                                SpinnerFactory.unset('checkout-choose-address');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.changeBillingAddress = function(selectedAddressId) {
                        var deferred = $q.defer();

                        if (selectedAddressId === null) {
                            deferred.resolve();
                        } else {
                            var addressToSave = angular.copy($rootScope.jfShared.checkout.userAddresses[selectedAddressId].attributes);
                            addressToSave.resource_id = selectedAddressId;

                            OrderFactory
                                .saveBillingAddress(addressToSave)
                                .then(function() {
                                    $scope.selectedAddresses.billingAddressId = selectedAddressId;

                                    $scope.goBackToCheckoutView();

                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }

                        return deferred.promise;
                    };

                    $scope.saveAddresses = function(dataToUpdate) {
                        var deferred = $q.defer();

                        if (angular.isDefined(dataToUpdate.pickup_address)) {
                            OrderFactory.prefillEmptyOrderAddressDetails(dataToUpdate.pickup_address);

                            if (CheckoutFactory.shouldClearPickupTimeSlot($rootScope.jfShared.checkout.userAddresses, dataToUpdate.pickup_address.resource_id)) {
                                dataToUpdate.pickup_start_ts = null;
                                dataToUpdate.pickup_end_ts = null;
                                dataToUpdate.delivery_start_ts = null;
                                dataToUpdate.delivery_end_ts = null;
                            }
                        }

                        if (angular.isDefined(dataToUpdate.delivery_address)) {
                            OrderFactory.prefillEmptyOrderAddressDetails(dataToUpdate.delivery_address);

                            if (CheckoutFactory.shouldClearDeliveryTimeSlot($rootScope.jfShared.checkout.userAddresses, dataToUpdate.delivery_address.resource_id)) {
                                dataToUpdate.delivery_start_ts = null;
                                dataToUpdate.delivery_end_ts = null;
                            }
                        }

                        if (angular.isDefined(dataToUpdate.billing_address)) {
                            OrderFactory.prefillEmptyOrderAddressDetails(dataToUpdate.billing_address);
                        }

                        OrderFactory
                            .updateOrder(
                                $localStorage.order.details.id,
                                dataToUpdate
                            )
                            .then(function() {
                                $rootScope.$emit('jfOrder:update-dates');
                                deferred.resolve();
                            }, function(err) {
                                if (err.status === 422) {
                                    var differentPartnerError = false;

                                    angular.forEach(err.data.errors, function(errorDetails) {
                                        if (
                                            differentPartnerError === false &&
                                            errorDetails.source.pointer === '/data/attributes/delivery_address'
                                        ) {
                                            differentPartnerError = true;
                                        }
                                    });
                                    if (differentPartnerError === true) {
                                        $rootScope.jfShared.checkout.userAddresses[dataToUpdate.delivery_address.resource_id].differentPartner = true;

                                        angular.extend(err, {failedAddressSaveId: dataToUpdate.delivery_address.resource_id});

                                        deferred.reject(err);
                                    } else {
                                        deferred.reject(err);
                                    }
                                } else {
                                    deferred.reject(err);
                                }
                            });

                        return deferred.promise;
                    };

                    $scope.preparePickupAddress = function() {
                        var deferred = $q.defer(),
                            dataToUpdate = {};

                        if (
                            angular.isDefined($localStorage.order.details.attributes.pickup_address) &&
                            $localStorage.order.details.attributes.pickup_address !== null &&
                            angular.isDefined($localStorage.order.details.attributes.pickup_address.resource_id) &&
                            $localStorage.order.details.attributes.pickup_address.resource_id !== null &&
                            angular.isDefined($localStorage.order.details.attributes.pickup_address.addressable_type) &&
                            $localStorage.order.details.attributes.pickup_address.addressable_type !== null
                        ) {
                            $scope.selectedAddresses.pickupAddressId = $localStorage.order.details.attributes.pickup_address.resource_id;

                            if (angular.isDefined($rootScope.jfShared.checkout.userAddresses[$scope.selectedAddresses.pickupAddressId])) {
                                deferred.resolve(dataToUpdate);
                            } else {
                                // TODO: Test this scenario by removing previously sleected address from address book. Is order commit still possible?
                                delete $scope.selectedAddresses.pickupAddressId;
                                dataToUpdate.pickup_address = $localStorage.order.details.attributes.pickup_address;
                                dataToUpdate.pickup_address.resource_id = null;
                                dataToUpdate.pickup_start_ts = null;
                                dataToUpdate.pickup_end_ts = null;
                                dataToUpdate.delivery_start_ts = null;
                                dataToUpdate.delivery_end_ts = null;

                                deferred.resolve(dataToUpdate);
                            }
                        } else {
                            var preferredAddressId = jfUser.get().ppid;

                            if (AccountFactory.isCompanyAccount()) {
                                preferredAddressId = jfUser.get().pb2bid;
                            }

                            if (
                                angular.isDefined($rootScope.jfShared.checkout.userAddresses[preferredAddressId]) &&
                                !$scope.disablePickupAddress($scope.catalogCity, $rootScope.jfShared.checkout.userAddresses[preferredAddressId])
                            ) {
                                if (
                                    angular.isUndefined($localStorage.order.details.attributes.pickup_address) ||
                                    $localStorage.order.details.attributes.pickup_address === null ||
                                    $localStorage.order.details.attributes.pickup_address.resource_id !== preferredAddressId ||
                                    angular.isUndefined($localStorage.order.details.attributes.pickup_address.addressable_type) ||
                                    $localStorage.order.details.attributes.pickup_address.addressable_type === null
                                ) {
                                    var addressToSave;

                                    addressToSave = angular.copy($rootScope.jfShared.checkout.userAddresses[preferredAddressId].attributes);
                                    addressToSave.resource_id = preferredAddressId;

                                    dataToUpdate.pickup_address = addressToSave;
                                    $scope.selectedAddresses.pickupAddressId = preferredAddressId;

                                    deferred.resolve(dataToUpdate);
                                } else {
                                    deferred.resolve(dataToUpdate);
                                }
                            } else {
                                $scope
                                    .selectFirstAvailablePickupAddress()
                                    .then(function(address) {
                                        if (address !== null) {
                                            dataToUpdate.pickup_address = address;

                                            $scope.selectedAddresses.pickupAddressId = address.resource_id;
                                        }

                                        deferred.resolve(dataToUpdate);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }
                        }

                        return deferred.promise;
                    };

                    $scope.selectFirstAvailablePickupAddress = function() {
                        var deferred = $q.defer(),
                            addressSelected = false;

                        angular.forEach($rootScope.jfShared.checkout.userAddresses, function(address) {
                            if (addressSelected === false && !$scope.disablePickupAddress($scope.catalogCity, address)) {
                                addressSelected = true;

                                if (
                                    angular.isUndefined($localStorage.order.details.attributes.pickup_address) ||
                                    $localStorage.order.details.attributes.pickup_address === null ||
                                    $localStorage.order.details.attributes.pickup_address.resource_id !== address.id ||
                                    angular.isUndefined($localStorage.order.details.attributes.pickup_address.addressable_type) ||
                                    $localStorage.order.details.attributes.pickup_address.addressable_type === null
                                ) {
                                    var addressToSave;

                                    addressToSave = angular.copy(address.attributes);
                                    addressToSave.resource_id = address.id;

                                    deferred.resolve(addressToSave);
                                }
                            }
                        });

                        if (addressSelected === false) {
                            deferred.resolve(null);
                        }

                        return deferred.promise;
                    };

                    $scope.prepareDeliveryAddress = function(dataToUpdate) {
                        var deferred = $q.defer();

                        if (
                            angular.isDefined($localStorage.order.details.attributes.delivery_address) &&
                            $localStorage.order.details.attributes.delivery_address !== null &&
                            angular.isDefined($localStorage.order.details.attributes.delivery_address.resource_id) &&
                            $localStorage.order.details.attributes.delivery_address.resource_id !== null &&
                            angular.isDefined($localStorage.order.details.attributes.delivery_address.addressable_type) &&
                            $localStorage.order.details.attributes.delivery_address.addressable_type !== null
                        ) {
                            $scope.selectedAddresses.deliveryAddressId = $localStorage.order.details.attributes.delivery_address.resource_id;

                            if (angular.isDefined($rootScope.jfShared.checkout.userAddresses[$scope.selectedAddresses.deliveryAddressId])) {
                                deferred.resolve(dataToUpdate);
                            } else {
                                delete $scope.selectedAddresses.deliveryAddressId;
                                dataToUpdate.delivery_address = $localStorage.order.details.attributes.delivery_address;
                                dataToUpdate.delivery_address.resource_id = null;
                                dataToUpdate.pickup_start_ts = null;
                                dataToUpdate.pickup_end_ts = null;
                                dataToUpdate.delivery_start_ts = null;
                                dataToUpdate.delivery_end_ts = null;

                                deferred.resolve(dataToUpdate);
                            }
                        } else {
                            var preferredAddressId = jfUser.get().pdid;

                            if (AccountFactory.isCompanyAccount()) {
                                preferredAddressId = jfUser.get().pb2bid;
                            }

                            if (
                                angular.isDefined($rootScope.jfShared.checkout.userAddresses[preferredAddressId]) &&
                                !$scope.disableDeliveryAddress($scope.catalogCity, $rootScope.jfShared.checkout.userAddresses[preferredAddressId]) &&
                                !(
                                    angular.isDefined(dataToUpdate.pickup_address) &&
                                    angular.isDefined(dataToUpdate.pickup_address.resource_id) &&
                                    $rootScope.jfShared.checkout.userAddresses[dataToUpdate.pickup_address.resource_id].plant_id !== $rootScope.jfShared.checkout.userAddresses[preferredAddressId].plant_id
                                )
                            ) {
                                if (
                                    angular.isUndefined($localStorage.order.details.attributes.delivery_address) ||
                                    $localStorage.order.details.attributes.delivery_address === null ||
                                    $localStorage.order.details.attributes.delivery_address.resource_id !== preferredAddressId ||
                                    angular.isUndefined($localStorage.order.details.attributes.delivery_address.addressable_type) ||
                                    $localStorage.order.details.attributes.delivery_address.addressable_type === null
                                ) {
                                    var addressToSave;

                                    addressToSave = angular.copy($rootScope.jfShared.checkout.userAddresses[preferredAddressId].attributes);
                                    addressToSave.resource_id = preferredAddressId;

                                    dataToUpdate.delivery_address = addressToSave;
                                    $scope.selectedAddresses.deliveryAddressId = preferredAddressId;

                                    deferred.resolve(dataToUpdate);
                                } else {
                                    deferred.resolve(dataToUpdate);
                                }
                            } else {
                                $scope
                                    .selectFirstAvailableDeliveryAddress(dataToUpdate)
                                    .then(function(address) {
                                        if (address !== null) {
                                            dataToUpdate.delivery_address = address;

                                            $scope.selectedAddresses.deliveryAddressId = address.resource_id;
                                        }

                                        deferred.resolve(dataToUpdate);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }
                        }

                        return deferred.promise;
                    };

                    $scope.selectFirstAvailableDeliveryAddress = function(dataToUpdate) {
                        var deferred = $q.defer(),
                            addressSelected = false;

                        angular.forEach($rootScope.jfShared.checkout.userAddresses, function(address) {
                            if (
                                addressSelected === false &&
                                !$scope.disableDeliveryAddress($scope.catalogCity, address) &&
                                !(
                                    angular.isDefined(dataToUpdate.pickup_address) &&
                                    angular.isDefined(dataToUpdate.pickup_address.resource_id) &&
                                    $rootScope.jfShared.checkout.userAddresses[dataToUpdate.pickup_address.resource_id].plant_id !== address.plant_id
                                )
                            ) {
                                addressSelected = true;

                                if (
                                    angular.isUndefined($localStorage.order.details.attributes.delivery_address) ||
                                    $localStorage.order.details.attributes.delivery_address === null ||
                                    $localStorage.order.details.attributes.delivery_address.resource_id !== address.id ||
                                    angular.isUndefined($localStorage.order.details.attributes.delivery_address.addressable_type) ||
                                    $localStorage.order.details.attributes.delivery_address.addressable_type === null
                                ) {
                                    var addressToSave;

                                    addressToSave = angular.copy(address.attributes);
                                    addressToSave.resource_id = address.id;

                                    deferred.resolve(addressToSave);
                                }
                            }
                        });

                        if (addressSelected === false) {
                            deferred.resolve(null);
                        }

                        return deferred.promise;
                    };

                    $scope.prepareBillingAddress = function(dataToUpdate) {
                        var deferred = $q.defer();

                        if (
                            angular.isDefined($localStorage.order.details.attributes.billing_address) &&
                            $localStorage.order.details.attributes.billing_address !== null &&
                            angular.isDefined($localStorage.order.details.attributes.billing_address.resource_id) &&
                            $localStorage.order.details.attributes.billing_address.resource_id !== null &&
                            angular.isDefined($localStorage.order.details.attributes.billing_address.addressable_type) &&
                            $localStorage.order.details.attributes.billing_address.addressable_type !== null
                        ) {
                            $scope.selectedAddresses.billingAddressId = $localStorage.order.details.attributes.billing_address.resource_id;

                            if (angular.isDefined($rootScope.jfShared.checkout.userAddresses[$scope.selectedAddresses.billingAddressId])) {
                                deferred.resolve(dataToUpdate);
                            } else {
                                delete $scope.selectedAddresses.billingAddressId;
                                dataToUpdate.billing_address = $localStorage.order.details.attributes.billing_address;
                                dataToUpdate.billing_address.resource_id = null;

                                deferred.resolve(dataToUpdate);
                            }
                        } else {
                            var preferredAddressId = jfUser.get().pbid;

                            if (
                                AccountFactory.isCompanyAccount() &&
                                angular.isDefined($rootScope.jfShared.checkout.userAddresses[jfUser.get().pb2bid]) &&
                                $scope.disableBillingAddress($rootScope.jfShared.checkout.userAddresses[jfUser.get().pb2bid]) === false
                            ) {
                                preferredAddressId = jfUser.get().pb2bid;
                            }

                            if (
                                angular.isDefined($rootScope.jfShared.checkout.userAddresses[preferredAddressId]) &&
                                $scope.disableBillingAddress($rootScope.jfShared.checkout.userAddresses[preferredAddressId]) === false
                            ) {
                                if (
                                    angular.isUndefined($localStorage.order.details.attributes.billing_address) ||
                                    $localStorage.order.details.attributes.billing_address === null ||
                                    $localStorage.order.details.attributes.billing_address.resource_id !== preferredAddressId ||
                                    angular.isUndefined($localStorage.order.details.attributes.billing_address.addressable_type) ||
                                    $localStorage.order.details.attributes.billing_address.addressable_type === null
                                ) {
                                    var addressToSave;

                                    addressToSave = angular.copy($rootScope.jfShared.checkout.userAddresses[preferredAddressId].attributes);
                                    addressToSave.resource_id = preferredAddressId;

                                    dataToUpdate.billing_address = addressToSave;
                                    $scope.selectedAddresses.billingAddressId = preferredAddressId;

                                    deferred.resolve(dataToUpdate);
                                } else {
                                    deferred.resolve(dataToUpdate);
                                }
                            } else {
                                $scope
                                    .selectFirstAvailableBillingAddress()
                                    .then(function(address) {
                                        if (address !== null) {
                                            dataToUpdate.billing_address = address;

                                            $scope.selectedAddresses.billingAddressId = address.resource_id;
                                        }

                                        deferred.resolve(dataToUpdate);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }
                        }

                        return deferred.promise;
                    };

                    $scope.selectFirstAvailableBillingAddress = function() {
                        var deferred = $q.defer(),
                            addressSelected = false;

                        angular.forEach($rootScope.jfShared.checkout.userAddresses, function(address) {
                            if (addressSelected === false && !$scope.disableBillingAddress(address)) {
                                addressSelected = true;

                                if (
                                    angular.isUndefined($localStorage.order.details.attributes.billing_address) ||
                                    $localStorage.order.details.attributes.billing_address === null ||
                                    $localStorage.order.details.attributes.billing_address.resource_id !== address.id ||
                                    angular.isUndefined($localStorage.order.details.attributes.billing_address.addressable_type) ||
                                    $localStorage.order.details.attributes.billing_address.addressable_type === null
                                ) {
                                    var addressToSave;

                                    addressToSave = angular.copy(address.attributes);
                                    addressToSave.resource_id = address.id;

                                    deferred.resolve(addressToSave);
                                }
                            }
                        });

                        if (addressSelected === false) {
                            deferred.resolve(null);
                        }

                        return deferred.promise;
                    };

                    $scope.prepareUserAddresses = function() {
                        var deferred = $q.defer();

                        $scope
                            .preparePickupAddress()
                            .then(function(dataToUpdate) {
                                $scope
                                    .prepareDeliveryAddress(dataToUpdate)
                                    .then(function(dataToUpdate) {
                                        $scope
                                            .prepareBillingAddress(dataToUpdate)
                                            .then(function(dataToUpdate) {
                                                // if (pickupResult === 'emptyPickup' && deliveryResult === 'emptyDelivery') {
                                                // if (angular.isUndefined(dataToUpdate.pickup_address) && angular.isUndefined(dataToUpdate.delivery_address)) {
                                                //     ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);
                                                // }

                                                if (
                                                    $rootScope.countObjKeys(dataToUpdate) > 0 &&
                                                    (
                                                        angular.isDefined(dataToUpdate.pickup_address) ||
                                                        angular.isDefined(dataToUpdate.delivery_address) ||
                                                        angular.isDefined(dataToUpdate.billing_address)
                                                    )
                                                ) {
                                                    $scope
                                                        .saveAddresses(dataToUpdate)
                                                        .then(function() {
                                                            deferred.resolve();
                                                        },
                                                        function(err) {
                                                            deferred.reject(err);
                                                        });
                                                } else {
                                                    deferred.resolve();
                                                }
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    }, function(err) {
                                        if (err.status === 422 && angular.isDefined(err.failedAddressSaveId)) {
                                            $scope
                                                .prepareUserAddresses()
                                                .then(function() {
                                                    deferred.resolve();
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        } else {
                                            deferred.reject(err);
                                        }
                                    });
                            }, function(err) {
                                if (err.status === 422 && angular.isDefined(err.failedAddressSaveId)) {
                                    $scope
                                        .prepareUserAddresses()
                                        .then(function() {
                                            deferred.resolve();
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    deferred.reject(err);
                                }
                            });

                        return deferred.promise;
                    };

                    $scope.catalogLocationValid = function() {
                        var deferred = $q.defer();

                        if (angular.isUndefined($localStorage.catalogLocation)) {
                            if (
                                angular.isDefined($localStorage.catalogType) &&
                                $localStorage.catalogType === JF_CONFIG.accountTypes.personal &&
                                angular.isDefined($localStorage.lastPrivateCatalogLocation)
                            ) {
                                ProductsFactory.setCatalogLocation($localStorage.lastPrivateCatalogLocation);
                            }

                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }

                        return deferred.promise;
                    };

                    $scope.isCorpCatalog = function() {
                        return angular.isDefined($localStorage.catalogType) && $localStorage.catalogType === JF_CONFIG.accountTypes.company;
                    };

                    $scope.refreshCompanyDetails = function() {
                        var deferred = $q.defer();

                        if (AccountFactory.isCompanyAccount()) {
                            AccountFactory
                                .getCompanyInformation(jfUser.get().companyId)
                                .then(function() {
                                    if (
                                        AccountFactory.isCompanyAccount() &&
                                        $localStorage.companyDetails !== null &&
                                        $localStorage.companyDetails.pays_for_user &&
                                        $localStorage.order.details.attributes.billing_address !== null &&
                                        $localStorage.order.details.attributes.billing_address.resource_id !== $localStorage.companyDetails.billing_address_id
                                    ) {
                                        OrderFactory
                                            .updateOrder(
                                                $localStorage.order.details.id,
                                                {
                                                    billing_address: { _destroy: true }
                                                }
                                            )
                                            .then(function() {
                                                delete $scope.selectedAddresses.billingAddressId;

                                                deferred.resolve();
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    } else {
                                        deferred.resolve();
                                    }
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            deferred.resolve();
                        }


                        return deferred.promise;
                    };

                    $scope.initChooseAddressDirectiveView = function() {
                        $scope.isEnglishLocale = $localStorage.shopLocale && $localStorage.shopLocale.indexOf('en') > -1;

                        $scope
                            .catalogLocationValid()
                            .then(function() {
                                // $scope.addressesSavingInProgress = false;
                                $scope.showAllAddressesListener = null;
                                $scope.selectedAddresses = {};
                                $scope.catalogCity = $localStorage.catalogLocation.city;
                                $scope.catalogPostalCode = $localStorage.catalogLocation.postal_code;
                                $scope.sortedUserAddresses = [];
                                $scope.currentState = $state.current;

                                SpinnerFactory.set('checkout-choose-address');

                                $scope
                                    .refreshCompanyDetails()
                                    .then(function() {
                                        AccountFactory
                                            .fetchUserAddresses()
                                            .then(function() {
                                                $rootScope.jfShared.checkout.addressesLoading = false;

                                                $scope
                                                    .prepareUserAddresses()
                                                    .then(function() {
                                                        $rootScope.$emit('jfCheckout:loadAddresses');
                                                        $rootScope.$emit('jfCheckout:checkoutNotesVisible');

                                                        OrderFactory
                                                            .fetchOrderItems()
                                                            .then(function() {
                                                                SpinnerFactory.unset('checkout-choose-address');

                                                                $scope.sortedUserAddresses = $scope.userAddressesAsArray();

                                                                $scope.showAllAddressesListener = $rootScope.$on('jfCheckout:showAllAddresses', function(e, data) {
                                                                    $scope.showAllAddresses = data.showAllAddresses;

                                                                    $scope.sortedUserAddresses = $scope.userAddressesAsArray();
                                                                });
                                                            }, function(err) {
                                                                SpinnerFactory.unset('checkout-choose-address');
                                                                $rootScope.$emit('app-error', {err: err});
                                                            });
                                                    }, function(err) {
                                                        SpinnerFactory.unset('checkout-choose-address');
                                                        $rootScope.$emit('app-error', {err: err});
                                                    });
                                            }, function(err) {
                                                SpinnerFactory.unset('checkout-choose-address');
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    }, function(err) {
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            }, function() {
                                $state.go('products', {'#': 'c0'});
                            });

                        $scope.$on('$destroy', function() {
                            if (
                                $scope.showAllAddressesListener !== null &&
                                angular.isFunction($scope.showAllAddressesListener)
                            ) {
                                $scope.showAllAddressesListener();
                            }
                        });
                        var savePreferredAddressesToOrderListener =
                            $rootScope.$on('jf:checkout:savePreferredAddressesToOrder', function(e, data) {
                                if (angular.isDefined(data.addresses)) {
                                    var pickupAddress = null,
                                        deliveryAddress = null,
                                        billingAddress = null;

                                    if (
                                        data.addresses.pickup_address_id &&
                                        (
                                            $localStorage.order.details.attributes.pickup_address === null ||
                                            data.addresses.pickup_address_id !== $localStorage.order.details.attributes.pickup_address.resource_id
                                        ) &&
                                        !$scope.disablePickupAddress($scope.catalogCity, $rootScope.jfShared.checkout.userAddresses[data.addresses.pickup_address_id])
                                    ) {
                                        pickupAddress = data.addresses.pickup_address_id;
                                    }

                                    if (
                                        data.addresses.delivery_address_id &&
                                        (
                                            $localStorage.order.details.attributes.delivery_address === null ||
                                            data.addresses.delivery_address_id !== $localStorage.order.details.attributes.delivery_address.resource_id
                                        ) &&
                                        !$scope.disableDeliveryAddress($scope.catalogCity, $rootScope.jfShared.checkout.userAddresses[data.addresses.delivery_address_id])
                                    ) {
                                        deliveryAddress = data.addresses.delivery_address_id;
                                    }

                                    if (
                                        data.addresses.billing_address_id &&
                                        (
                                            $localStorage.order.details.attributes.billing_address === null ||
                                            data.addresses.billing_address_id !== $localStorage.order.details.attributes.billing_address.resource_id
                                        ) &&
                                        !$scope.disableBillingAddress($rootScope.jfShared.checkout.userAddresses[data.addresses.billing_address_id])
                                    ) {
                                        billingAddress = data.addresses.billing_address_id;
                                    }

                                    SpinnerFactory.set('checkout-choose-address');

                                    $scope
                                        .changePickupAddress(pickupAddress)
                                        .then(function() {
                                            $scope
                                                .changeDeliveryAddress(deliveryAddress)
                                                .then(function() {
                                                    $scope
                                                        .changeBillingAddress(billingAddress)
                                                        .then(function() {
                                                            SpinnerFactory.unset('checkout-choose-address');

                                                            if (pickupAddress !== null || deliveryAddress !== null) {
                                                                $rootScope.$emit('jfCheckout:loadAddresses');
                                                            }

                                                            $scope.sortedUserAddresses = $scope.userAddressesAsArray();
                                                        }, function(err) {
                                                            SpinnerFactory.unset('checkout-choose-address');
                                                            $rootScope.$emit('app-error', {err: err});
                                                        });
                                                }, function(err) {
                                                    SpinnerFactory.unset('checkout-choose-address');
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        }, function(err) {
                                            SpinnerFactory.unset('checkout-choose-address');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            });

                        var userAddressesAsArrayListener = $rootScope.$on('jfCheckout:userAddressesAsArray', function() {
                            $scope.sortedUserAddresses = $scope.userAddressesAsArray();
                        });

                        $scope.$on('$destroy', function() {
                            savePreferredAddressesToOrderListener();
                            userAddressesAsArrayListener();
                        });
                    };

                    jfController.init(['initChooseAddressDirectiveView'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Pickup Timetable directive
 */
angular.module('jfApp')
    .directive(
        'pickupTimetable',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/pickup-timetable.html',
                replace: true,
                scope: {
                    order: '=',
                    origin: '@'
                },
                controller: ['$scope', '$rootScope', '$mdMedia', 'CheckoutFactory', 'OrderFactory', 'AccountFactory', 'SpinnerFactory', 'jfHelper', 'jfUser', 'jfController', function (
                    $scope,
                    $rootScope,
                    $mdMedia,
                    CheckoutFactory,
                    OrderFactory,
                    AccountFactory,
                    SpinnerFactory,
                    jfHelper,
                    jfUser,
                    jfController
                ) {
                    $scope.fetchPickupAppointments = function(address, companyId) {
                        SpinnerFactory.set('checkout-time-slots-picker');

                        CheckoutFactory
                            .fetchPickupAppointments(
                                address,
                                companyId,
                                null,
                                $scope.origin
                            )
                            .then(function(pickupAppointments) {
                                SpinnerFactory.unset('checkout-time-slots-picker');

                                $scope.preparePickupAppointments(pickupAppointments);
                            }, function(err) {
                                SpinnerFactory.set('checkout-time-slots-picker');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.preparePickupAppointments = function(pickupAppointments) {
                        $scope.pickupTimeSlots = {};
                        var tmpDaysArr = [];

                        angular.forEach(pickupAppointments, function(timeSlot) {
                            if (angular.isUndefined($scope.pickupTimeSlots[timeSlot.attributes.date])) {
                                $scope.pickupTimeSlots[timeSlot.attributes.date] = [];
                                tmpDaysArr.push(timeSlot.attributes.date);
                            }

                            if (
                                timeSlot.attributes.scheduled === true &&
                                $scope.daysWithScheduledTimeSlots.indexOf(timeSlot.attributes.date) === -1
                            ) {
                                $scope.daysWithScheduledTimeSlots.push(timeSlot.attributes.date);
                            }

                            if (
                                timeSlot.attributes.eco === true &&
                                $scope.daysWithEcoTimeSlots.indexOf(timeSlot.attributes.date) === -1
                            ) {
                                $scope.daysWithEcoTimeSlots.push(timeSlot.attributes.date);
                            }

                            $scope.pickupTimeSlots[timeSlot.attributes.date].push(timeSlot);
                        });

                        if ($scope.origin === 'checkout') {
                            if (angular.isDefined($scope.order.details.attributes.pickup_start_time) &&
                                $scope.order.details.attributes.pickup_start_time !== null
                            ) {
                                $scope.selectedPickupDay = tmpDaysArr.indexOf(
                                    $scope.order.details.attributes.pickup_date
                                );
                            }
                        } else {
                            if (angular.isDefined($scope.order.details.attributes.scheduled_pickup_start_time) &&
                                $scope.order.details.attributes.scheduled_pickup_start_time !== null
                            ) {
                                $scope.selectedPickupDay = tmpDaysArr.indexOf(
                                    $scope.order.details.attributes.scheduled_pickup_date
                                );

                                if ($scope.selectedPickupDay === -1) {
                                    $scope.selectedPickupDay = 0;
                                }
                            }
                        }
                    };

                    $scope.selectPickupTime = function(timeSlot) {
                        if ($scope.origin === 'checkout') {
                            if (angular.isDefined($scope.order.details.attributes.delivery_start_time) &&
                                $scope.order.details.attributes.delivery_start_time !== null
                            ) {
                                $scope.showDeliveryTimeClearedInfo = true;
                            }

                            SpinnerFactory.set('checkout-time-slots-picker');

                            OrderFactory
                                .updateOrder(
                                    $scope.order.details.id,
                                    {
                                        delivery_start_ts: null,
                                        delivery_end_ts: null,
                                        pickup_start_ts: timeSlot.attributes.start_ts,
                                        pickup_end_ts: timeSlot.attributes.end_ts
                                    }
                                )
                                .then(function() {
                                    SpinnerFactory.unset('checkout-time-slots-picker');

                                    if ($mdMedia('xs')) {
                                        jfHelper.goBackInHistory();
                                    } else {
                                        $scope.goBackToCheckoutView();
                                    }
                                }, function(err) {
                                    SpinnerFactory.unset('checkout-time-slots-picker');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            if (angular.isDefined($scope.order.details.attributes.scheduled_delivery_start_time) &&
                                $scope.order.details.attributes.scheduled_delivery_start_time !== null
                            ) {
                                $scope.showDeliveryTimeClearedInfo = true;
                            }

                            $scope.order.details.attributes.scheduled_pickup_start_ts = timeSlot.attributes.start_ts;
                            $scope.order.details.attributes.scheduled_pickup_end_ts = timeSlot.attributes.end_ts;

                            var timeSlotStartArr = timeSlot.attributes.start_ts.split('T');
                            var pickupDate = timeSlotStartArr[0];
                            var startTime = timeSlotStartArr[1].split(':')[0] + ':' + timeSlotStartArr[1].split(':')[1];

                            var timeSlotEndArr = timeSlot.attributes.end_ts.split('T');
                            var endTime = timeSlotEndArr[1].split(':')[0] + ':' + timeSlotEndArr[1].split(':')[1];

                            $scope.order.details.attributes.scheduled_pickup_date = pickupDate;
                            $scope.order.details.attributes.scheduled_pickup_start_time = startTime;
                            $scope.order.details.attributes.scheduled_pickup_end_time = endTime;

                            $rootScope.$emit('jfOrder:open-delivery', $scope.order);
                        }
                    };

                    $scope.selectedPickupTimeSlot = function(timeSlot) {
                        if (angular.isUndefined($scope.order.details.attributes)) {
                            return false;
                        }
                        if ($scope.origin !== 'checkout') {
                            return timeSlot.attributes.date === $scope.order.details.attributes.scheduled_pickup_date &&
                                timeSlot.attributes.start_time === $scope.order.details.attributes.scheduled_pickup_start_time;
                        }

                        return timeSlot.attributes.date === $scope.order.details.attributes.pickup_date &&
                            timeSlot.attributes.start_time === $scope.order.details.attributes.pickup_start_time;
                    };

                    $scope.getHoursDifference = function(startDate, endDate) {
                        return Math.abs(new Date(startDate) - new Date(endDate)) / 36e5;
                    };

                    $scope.initPickupTimetable = function() {
                        $scope.selectedPickupDay = 0;
                        $scope.showDeliveryTimeClearedInfo = false;
                        $scope.daysWithScheduledTimeSlots = [];
                        $scope.daysWithEcoTimeSlots = [];

                        // retrieving objects to isolated scope
                        $scope.$mdMedia = $mdMedia;
                        $scope.countObjKeys = $rootScope.countObjKeys;
                        $scope.Math = Math;
                        $scope.goBackToCheckoutView = $scope.$parent.goBackToCheckoutView;

                        if ($scope.origin === 'checkout') {
                            if ($rootScope.countObjKeys($rootScope.jfShared.checkout.userAddresses) === 0) {
                                SpinnerFactory.set('checkout-time-slots-picker');

                                AccountFactory
                                    .fetchUserAddresses()
                                    .then(function(userAddresses) {
                                        SpinnerFactory.unset('checkout-time-slots-picker');

                                        $rootScope.jfShared.checkout.userAddresses = userAddresses;

                                        $scope.fetchPickupAppointments(
                                            $rootScope.jfShared.checkout.userAddresses[
                                                $scope.order.details.attributes.pickup_address.resource_id
                                            ].attributes,
                                            jfUser.get().companyId
                                        );
                                    }, function(err) {
                                        SpinnerFactory.unset('checkout-time-slots-picker');
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                $scope.fetchPickupAppointments(
                                    $rootScope.jfShared.checkout.userAddresses[
                                        $scope.order.details.attributes.pickup_address.resource_id
                                    ].attributes,
                                    jfUser.get().companyId
                                );
                            }
                        } else {
                            $scope.fetchPickupAppointments(
                                $scope.order.details.attributes.pickup_address,
                                $scope.order.details.attributes.company_id
                            );
                        }
                    };

                    jfController.init(['initPickupTimetable'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Delivery Timetable directive
 */
angular.module('jfApp')
    .directive(
        'deliveryTimetable',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/delivery-timetable.html',
                replace: true,
                scope: {
                    order: '=',
                    origin: '@'
                },
                controller: ['$scope', '$rootScope', '$mdMedia', 'CheckoutFactory', 'OrderFactory', 'AccountFactory', 'SpinnerFactory', 'jfHelper', 'jfUser', 'jfController', function (
                    $scope,
                    $rootScope,
                    $mdMedia,
                    CheckoutFactory,
                    OrderFactory,
                    AccountFactory,
                    SpinnerFactory,
                    jfHelper,
                    jfUser,
                    jfController
                ) {
                    $scope.fetchDeliveryAppointments = function(address, companyId) {
                        var load = false;
                        if ($scope.origin === 'checkout') {
                            if (angular.isDefined($scope.order.details.attributes.pickup_start_time) &&
                                $scope.order.details.attributes.pickup_start_time !== null
                            ) {
                                load = true;
                            }
                        } else {

                            if (angular.isDefined($scope.order.details.attributes.scheduled_pickup_start_time) &&
                                $scope.order.details.attributes.scheduled_pickup_start_time !== null
                            ) {
                                load = true;
                            }
                        }

                        if (load) {
                            SpinnerFactory.set('checkout-time-slots-picker');

                            if (
                                $scope.origin !== 'checkout' &&
                                angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                                $scope.order.details.attributes.editable_content_by_customers.reset_delivery === true
                            ) {
                                CheckoutFactory
                                    .fetchPickupAppointments(
                                        address,
                                        companyId,
                                        null,
                                        $scope.origin
                                    )
                                    .then(function(deliveryAppointments) {
                                        SpinnerFactory.unset('checkout-time-slots-picker');
                                        $scope.prepareDeliveryAppointments(deliveryAppointments);
                                    }, function(err) {
                                        SpinnerFactory.unset('checkout-time-slots-picker');
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                // Check to avoid Customer selects earlier DL date when PU was already done.
                                var customNowDate = null;

                                if (
                                    angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                                    $scope.order.details.attributes.editable_content_by_customers.pickup_appointment === false &&
                                    $scope.order.details.attributes.editable_content_by_customers.delivery_appointment === true
                                ) {
                                    var deliveryStartTs = new Date($scope.order.details.attributes.delivery_start_ts),
                                        scheduledDeliveryStartTs = new Date($scope.order.details.attributes.scheduled_delivery_start_ts);

                                    customNowDate = (deliveryStartTs < scheduledDeliveryStartTs) ? deliveryStartTs : scheduledDeliveryStartTs;

                                    var originalPickupDate = new Date($scope.order.details.attributes.scheduled_pickup_start_ts);
                                    originalPickupDate.setHours(0, 0, 0, 0);
                                    originalPickupDate.setDate(originalPickupDate.getDate() + $scope.order.details.attributes.processing_time);

                                    var originalDeliveryDate = new Date(customNowDate.getTime()).setHours(0, 0, 0, 0);

                                    if (originalPickupDate < new Date(originalDeliveryDate)) {
                                        customNowDate = new Date(Date.UTC(customNowDate.getFullYear(), customNowDate.getMonth(), customNowDate.getDate(), 0, 0, 0));
                                    } else {
                                        var morningShiftTime = new Date(Date.UTC(customNowDate.getFullYear(), customNowDate.getMonth(), customNowDate.getDate()));
                                        morningShiftTime.setHours(15, 0, 0, 0);

                                        if (customNowDate < morningShiftTime) {
                                            customNowDate = new Date(Date.UTC(customNowDate.getFullYear(), customNowDate.getMonth(), customNowDate.getDate(), 0, 0, 0));
                                        } else {
                                            customNowDate = new Date(Date.UTC(customNowDate.getFullYear(), customNowDate.getMonth(), customNowDate.getDate(), 12, 0, 0));
                                        }
                                    }

                                    if (new Date() > new Date(customNowDate)) {
                                        customNowDate = null;
                                    }

                                    CheckoutFactory
                                        .fetchPickupAppointments(
                                            address,
                                            companyId,
                                            customNowDate,
                                            $scope.origin
                                        )
                                        .then(function(deliveryAppointments) {
                                            SpinnerFactory.unset('checkout-time-slots-picker');
                                            $scope.prepareDeliveryAppointments(deliveryAppointments);
                                        }, function(err) {
                                            SpinnerFactory.unset('checkout-time-slots-picker');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                } else {
                                    CheckoutFactory
                                        .fetchDeliveryAppointments(
                                            $scope.order,
                                            address,
                                            companyId,
                                            $scope.origin
                                        )
                                        .then(function(deliveryAppointments) {
                                            SpinnerFactory.unset('checkout-time-slots-picker');
                                            $scope.prepareDeliveryAppointments(deliveryAppointments);
                                        }, function(err) {
                                            SpinnerFactory.unset('checkout-time-slots-picker');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            }

                        }
                    };

                    $scope.prepareDeliveryAppointments = function(deliveryAppointments) {
                        $scope.deliveryTimeSlots = {};
                        var tmpDaysArr = [];

                        angular.forEach(deliveryAppointments, function(timeSlot) {
                            if (angular.isUndefined($scope.deliveryTimeSlots[timeSlot.attributes.date])) {
                                $scope.deliveryTimeSlots[timeSlot.attributes.date] = [];
                                tmpDaysArr.push(timeSlot.attributes.date);
                            }

                            if (
                                timeSlot.attributes.scheduled === true &&
                                $scope.daysWithScheduledTimeSlots.indexOf(timeSlot.attributes.date) === -1
                            ) {
                                $scope.daysWithScheduledTimeSlots.push(timeSlot.attributes.date);
                            }

                            if (
                                timeSlot.attributes.eco === true &&
                                $scope.daysWithEcoTimeSlots.indexOf(timeSlot.attributes.date) === -1
                            ) {
                                $scope.daysWithEcoTimeSlots.push(timeSlot.attributes.date);
                            }

                            $scope.deliveryTimeSlots[timeSlot.attributes.date].push(timeSlot);
                        });

                        if ($scope.origin === 'checkout') {
                            if (angular.isDefined($scope.order.details.attributes.delivery_start_time) &&
                                $scope.order.details.attributes.delivery_start_time !== null
                            ) {
                                $scope.selectedDeliveryDay = tmpDaysArr.indexOf(
                                    $scope.order.details.attributes.delivery_date
                                );
                            }
                        } else {
                            if (angular.isDefined($scope.order.details.attributes.scheduled_delivery_start_time) &&
                                $scope.order.details.attributes.scheduled_delivery_start_time !== null
                            ) {
                                $scope.selectedDeliveryDay = tmpDaysArr.indexOf(
                                    $scope.order.details.attributes.scheduled_delivery_date
                                );
                            }

                            if ($scope.selectedDeliveryDay === -1) {
                                $scope.order.details.attributes.scheduled_delivery_start_ts = null;
                                $scope.order.details.attributes.scheduled_delivery_end_ts = null;
                                $scope.order.details.attributes.scheduled_delivery_date = null;
                                $scope.order.details.attributes.scheduled_delivery_start_time = null;
                                $scope.order.details.attributes.scheduled_delivery_end_time = null;
                                $scope.selectedDeliveryDay = 0;
                                $rootScope.$emit('jfOrder:update-dates');
                            }
                        }
                    };

                    $scope.selectDeliveryTime = function(timeSlot) {
                        $scope.showDeliveryTimeClearedInfo = false;
                        $scope.timesError = false;

                        if ($scope.origin === 'checkout') {
                            SpinnerFactory.set('checkout-time-slots-picker');
                            OrderFactory
                                .updateOrder(
                                    $scope.order.details.id,
                                    {
                                        delivery_start_ts: timeSlot.attributes.start_ts,
                                        delivery_end_ts: timeSlot.attributes.end_ts
                                    }
                                )
                                .then(function() {
                                    SpinnerFactory.unset('checkout-time-slots-picker');
                                    if (!$mdMedia('gt-xs')) {
                                        jfHelper.goBackInHistory();
                                    } else {
                                        $scope.goBackToCheckoutView();
                                    }
                                }, function(err) {
                                    SpinnerFactory.unset('checkout-time-slots-picker');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $scope.order.details.attributes.scheduled_delivery_start_ts = timeSlot.attributes.start_ts;
                            $scope.order.details.attributes.scheduled_delivery_end_ts = timeSlot.attributes.end_ts;

                            var timeSlotStartArr = timeSlot.attributes.start_ts.split('T');
                            var deliveryDate = timeSlotStartArr[0];
                            var startTime = timeSlotStartArr[1].split(':')[0] + ':' + timeSlotStartArr[1].split(':')[1];

                            var timeSlotEndArr = timeSlot.attributes.end_ts.split('T');
                            var endTime = timeSlotEndArr[1].split(':')[0] + ':' + timeSlotEndArr[1].split(':')[1];

                            $scope.order.details.attributes.scheduled_delivery_date = deliveryDate;
                            $scope.order.details.attributes.scheduled_delivery_start_time = startTime;
                            $scope.order.details.attributes.scheduled_delivery_end_time = endTime;

                            $rootScope.$emit('jfOrder:show-confirmation', true);
                        }
                    };

                    $scope.selectedDeliveryTimeSlot = function(timeSlot) {
                        if ($scope.origin !== 'checkout') {
                            return timeSlot.attributes.date === $scope.order.details.attributes.scheduled_delivery_date &&
                                timeSlot.attributes.start_time === $scope.order.details.attributes.scheduled_delivery_start_time;
                        }
                        return timeSlot.attributes.date === $scope.order.details.attributes.delivery_date &&
                            timeSlot.attributes.start_time === $scope.order.details.attributes.delivery_start_time;
                    };

                    $scope.getHoursDifference = function(startDate, endDate) {
                        return Math.abs(new Date(startDate) - new Date(endDate)) / 36e5;
                    };

                    $scope.initDeliveryTimetable = function() {
                        $scope.selectedDeliveryDay = 0;
                        $scope.daysWithScheduledTimeSlots = [];
                        $scope.daysWithEcoTimeSlots = [];

                        // retrieving objects to isolated scope
                        $scope.$mdMedia = $mdMedia;
                        $scope.countObjKeys = $rootScope.countObjKeys;
                        $scope.Math = Math;
                        $scope.goBackToCheckoutView = $scope.$parent.goBackToCheckoutView;

                        if ($scope.origin === 'checkout') {
                            if ($rootScope.countObjKeys($rootScope.jfShared.checkout.userAddresses) === 0) {
                                SpinnerFactory.set('checkout-time-slots-picker');

                                AccountFactory
                                    .fetchUserAddresses()
                                    .then(function(userAddresses) {
                                        SpinnerFactory.unset('checkout-time-slots-picker');

                                        $rootScope.jfShared.checkout.userAddresses = userAddresses;

                                        $scope.fetchDeliveryAppointments(
                                            $rootScope.jfShared.checkout.userAddresses[
                                                $scope.order.details.attributes.delivery_address.resource_id
                                            ].attributes,
                                            jfUser.get().companyId
                                        );
                                    }, function(err) {
                                        SpinnerFactory.unset('checkout-time-slots-picker');
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                $scope.fetchDeliveryAppointments(
                                    $rootScope.jfShared.checkout.userAddresses[
                                        $scope.order.details.attributes.delivery_address.resource_id
                                    ].attributes,
                                    jfUser.get().companyId
                                );
                            }
                        } else {
                            $scope.fetchDeliveryAppointments(
                                $scope.order.details.attributes.delivery_address,
                                $scope.order.details.attributes.company_id
                            );
                        }
                    };

                    jfController.init(['initDeliveryTimetable'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Payment Methods directive
 */
angular.module('jfApp')
    .directive(
        'paymentMethods',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/payment-methods.html',
                replace: true,
                controller: ['$scope', '$rootScope', '$state', '$localStorage', '$q', '$timeout', '$filter', 'JF_CONFIG', 'BooksPaymentMethodsFactory', 'LanguageFactory', 'SpinnerFactory', 'CheckoutFactory', 'AccountFactory', 'JF_SHARED_CONFIG', 'jfDialog', 'jfController', 'jfUser', 'jfHelper', 'OrderFactory', function(
                    $scope,
                    $rootScope,
                    $state,
                    $localStorage,
                    $q,
                    $timeout,
                    $filter,
                    JF_CONFIG,
                    BooksPaymentMethodsFactory,
                    LanguageFactory,
                    SpinnerFactory,
                    CheckoutFactory,
                    AccountFactory,
                    JF_SHARED_CONFIG,
                    jfDialog,
                    jfController,
                    jfUser,
                    jfHelper,
                    OrderFactory
                ) {

                    $scope.preparePayPalBillingAgreement = function() {
                        if (
                            angular.isDefined($localStorage.order) &&
                            angular.isDefined($localStorage.order.details) &&
                            angular.isDefined($localStorage.order.details.attributes) &&
                            angular.isDefined($localStorage.order.details.attributes.delivery_address) &&
                            $localStorage.order.details.attributes.delivery_address !== null &&
                            angular.isDefined($localStorage.order.details.attributes.delivery_address.resource_id)
                        ) {
                            $scope.initPayPalAgreements();
                        }
                    };

                    $scope.initPayPalAgreements = function() {
                        // Set Credit Cards form country code
                        $scope.creditCardFormCountry = $localStorage.order.details.attributes.delivery_address.country_code;
                        $scope.sepaFormCountry = $localStorage.order.details.attributes.delivery_address.country_code;
                    };

                    $scope.savePaymentMethodToOrder = function(noRedirect) {
                        $scope
                            .savePaymentMethod()
                            .then(function() {
                                $rootScope.order.additionalInfo.checkoutGeneralErrors = [];

                                if (angular.isUndefined(noRedirect) || noRedirect === false) {
                                    $state.go('checkout', {stepBack: true});
                                }
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.changePaymentMethod = function() {
                        $rootScope.sendGAEvent('checkoutPage', 'paymentMethodSelectOption' + $scope.visiblePaymentMethods[$scope.selectedPaymentMethod].name);

                        $scope.showCreditCardsSelector = false;
                        $scope.showCreditCardsForm = false;
                        $scope.selectedCreditCard = null;
                        $localStorage.order.additionalInfo.selectedCreditCardId = null;
                        $rootScope.order.additionalInfo.selectedCreditCardId = null;
                        $localStorage.order.additionalInfo.selectedCreditCardBrand = null;
                        $rootScope.order.additionalInfo.selectedCreditCardBrand = null;

                        if (
                            $scope.visiblePaymentMethods[$scope.selectedPaymentMethod].id ===
                            JF_CONFIG.paymentMethods.creditCard
                        ) {
                            CheckoutFactory
                                .fetchUserBillingAgreements($localStorage.catalogLocation.country_code)
                                .then(function() {
                                    $scope.manageCreditCardsVisibility();

                                    // Workaround for ng-repeat re-rendering issue
                                    $timeout(function() {
                                        $scope.savePaymentMethodToOrder(true);
                                    }, 0);
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            // Workaround for ng-repeat re-rendering issue
                            $timeout(function() {
                                $scope.savePaymentMethodToOrder(true);
                            }, 0);
                        }
                    };

                    $scope.manageCreditCardsVisibility = function() {
                        if (
                            $rootScope.jfShared.checkout.userBillingAgreements.cc === null ||
                            $rootScope.jfShared.checkout.userBillingAgreements.cc.length === 0
                        ) {
                            $scope.showCreditCardsForm = true;
                            $scope.showCreditCardsSelector = false;
                        } else if ($rootScope.jfShared.checkout.userBillingAgreements.cc.length === 1) {
                            $scope.showCreditCardsForm = false;
                            $scope.showCreditCardsSelector = true;

                            $localStorage.order.additionalInfo.selectedCreditCardId = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].id;
                            $rootScope.order.additionalInfo.selectedCreditCardId = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].id;
                            $localStorage.order.additionalInfo.selectedCreditCardBrand = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].attributes.variant;
                            $rootScope.order.additionalInfo.selectedCreditCardBrand = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].attributes.variant;

                            $scope.selectedCreditCard = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].id + '|' + $rootScope.jfShared.checkout.userBillingAgreements.cc[0].attributes.variant;
                        } else {
                            $scope.showCreditCardsForm = false;
                            $scope.showCreditCardsSelector = true;

                            if ($scope.selectedCreditCard === null) {
                                if (
                                    angular.isDefined($localStorage.order.additionalInfo.selectedCreditCardId) &&
                                    $localStorage.order.additionalInfo.selectedCreditCardId !== null &&
                                    angular.isDefined($localStorage.order.additionalInfo.selectedCreditCardBrand) &&
                                    $localStorage.order.additionalInfo.selectedCreditCardBrand !== null
                                ) {
                                    $scope.selectedCreditCard = $localStorage.order.additionalInfo.selectedCreditCardId + '|' + $localStorage.order.additionalInfo.selectedCreditCardBrand;
                                } else {
                                    if (angular.isDefined(jfUser.get().preferredBillingAgreementId) && jfUser.get().preferredBillingAgreementId !== null) {
                                        angular.forEach($rootScope.jfShared.checkout.userBillingAgreements.cc, function(creditCard) {
                                            if (creditCard.id === jfUser.get().preferredBillingAgreementId) {
                                                $localStorage.order.additionalInfo.selectedCreditCardId = creditCard.id;
                                                $rootScope.order.additionalInfo.selectedCreditCardId = creditCard.id;
                                                $localStorage.order.additionalInfo.selectedCreditCardBrand = creditCard.attributes.variant;
                                                $rootScope.order.additionalInfo.selectedCreditCardBrand = creditCard.attributes.variant;

                                                $scope.selectedCreditCard = creditCard.id + '|' + creditCard.attributes.variant;
                                            }
                                        });
                                    } else {
                                        $localStorage.order.additionalInfo.selectedCreditCardId = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].id;
                                        $rootScope.order.additionalInfo.selectedCreditCardId = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].id;
                                        $localStorage.order.additionalInfo.selectedCreditCardBrand = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].attributes.variant;
                                        $rootScope.order.additionalInfo.selectedCreditCardBrand = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].attributes.variant;

                                        $scope.selectedCreditCard = $rootScope.jfShared.checkout.userBillingAgreements.cc[0].id + '|' + $rootScope.jfShared.checkout.userBillingAgreements.cc[0].attributes.variant;
                                    }
                                }
                            }
                        }
                    };

                    $scope.changeSelectedCreditCard = function() {
                        var creditCardInfo = $scope.selectedCreditCard.split('|');

                        $localStorage.order.additionalInfo.selectedCreditCardId = creditCardInfo[0];
                        $rootScope.order.additionalInfo.selectedCreditCardId = creditCardInfo[0];
                        $localStorage.order.additionalInfo.selectedCreditCardBrand = creditCardInfo[1];
                        $rootScope.order.additionalInfo.selectedCreditCardBrand = creditCardInfo[1];

                        if (
                            angular.isUndefined($localStorage.order.details.attributes.payment_method_id) ||
                            $localStorage.order.details.attributes.payment_method_id === null ||
                            (
                                angular.isDefined($scope.visiblePaymentMethods[$localStorage.order.details.attributes.payment_method_id]) &&
                                $scope.visiblePaymentMethods[$localStorage.order.details.attributes.payment_method_id].id !== JF_CONFIG.paymentMethods.creditCard
                            )
                        ) {
                            $scope.savePaymentMethodToOrder(true);
                        }
                    };

                    $scope.creditCardSaveCallback = function() {
                        var deferred = $q.defer();

                        SpinnerFactory.set('checkout-payment-methods');

                        CheckoutFactory
                            .fetchUserBillingAgreements($localStorage.catalogLocation.country_code)
                            .then(function() {
                                $scope.manageCreditCardsVisibility();

                                // Workaround for ng-repeat re-rendering issue
                                $timeout(function() {
                                    $scope.savePaymentMethodToOrder(true);
                                }, 0);

                                SpinnerFactory.unset('checkout-payment-methods');

                                deferred.resolve();
                            }, function(err) {
                                SpinnerFactory.unset('checkout-payment-methods');

                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.preparePaymentMethods = function(paymentMethods) {
                        $scope.visiblePaymentMethods = {};
                        $scope.selectedCreditCard = null;
                        $scope.showCreditCardsForm = false;
                        $scope.showCreditCardsSelector = false;

                        angular.forEach(paymentMethods, function(paymentMethod) {
                            if (['gpp', 'app'].indexOf(paymentMethod.abbreviation) === -1) {
                                $scope.visiblePaymentMethods[paymentMethod.id] = paymentMethod;

                                if (
                                    paymentMethod.id === JF_CONFIG.paymentMethods.monthlyInvoice ||
                                    paymentMethod.id === JF_CONFIG.paymentMethods.monthlyInvoiceDirectDebit
                                    ) {
                                    $scope.monthlyInvoiceName = paymentMethod.name;
                                }
                            }
                        });

                        if (
                            angular.isDefined($localStorage.order.details.attributes.payment_method_id) &&
                            $localStorage.order.details.attributes.payment_method_id !== null &&
                            $localStorage.order.details.attributes.payment_method_id &&
                            angular.isDefined($scope.visiblePaymentMethods[$localStorage.order.details.attributes.payment_method_id])
                        ) {
                            $scope.selectedPaymentMethod = $localStorage.order.details.attributes.payment_method_id;
                        } else if (AccountFactory.isCompanyAccount()) {
                            if (
                                jfUser.get().pb2bPaymentMethod &&
                                angular.isDefined($scope.visiblePaymentMethods[jfUser.get().pb2bPaymentMethod])
                            ) {
                                $scope.selectedPaymentMethod = jfUser.get().pb2bPaymentMethod;
                            } else {
                                if (
                                    jfUser.get().defaultPaymentMethod &&
                                    angular.isDefined($scope.visiblePaymentMethods[jfUser.get().defaultPaymentMethod])
                                ) {
                                    $scope.selectedPaymentMethod = jfUser.get().defaultPaymentMethod;
                                } else {
                                    $scope.selectFirstNonCashPaymentMethod(true);
                                }
                            }
                        } else if (
                            !AccountFactory.isCompanyAccount() &&
                            jfUser.get().defaultPaymentMethod &&
                            angular.isDefined($scope.visiblePaymentMethods[jfUser.get().defaultPaymentMethod])
                        ) {
                            $scope.selectedPaymentMethod = jfUser.get().defaultPaymentMethod;
                        } else {
                            if (
                                paymentMethods[0].id !== JF_CONFIG.paymentMethods.payPalAfterPayment ||
                                (
                                    paymentMethods[0].id === JF_CONFIG.paymentMethods.payPalAfterPayment &&
                                    $rootScope.jfShared.checkout.userBillingAgreements.payPal !== null &&
                                    $rootScope.jfShared.checkout.userBillingAgreements.payPal.length > 0
                                )
                            ) {
                                $scope.selectedPaymentMethod = paymentMethods[0].id;
                            }
                        }

                        if (
                            angular.isDefined($localStorage.order.details.relationships) &&
                            (
                                angular.isUndefined($localStorage.order.details.attributes.payment_method_id) ||
                                $localStorage.order.details.attributes.payment_method_id === null ||
                                (
                                    $localStorage.order.details.attributes.payment_method_id !== null &&
                                    $localStorage.order.details.attributes.payment_method_id !== $scope.selectedPaymentMethod
                                )
                            )
                        ) {
                            if (
                                angular.isDefined($scope.visiblePaymentMethods[$scope.selectedPaymentMethod]) &&
                                $scope.visiblePaymentMethods[$scope.selectedPaymentMethod].id === JF_CONFIG.paymentMethods.creditCard
                            ) {
                                if (
                                    angular.isDefined($localStorage.order.additionalInfo.selectedCreditCardId) &&
                                    $localStorage.order.additionalInfo.selectedCreditCardId !== null
                                ) {
                                    $scope.selectedCreditCard = $localStorage.order.additionalInfo.selectedCreditCardId + '|' + $localStorage.order.additionalInfo.selectedCreditCardBrand;
                                }
                                $scope.manageCreditCardsVisibility();

                                // Workaround for ng-repeat re-rendering issue
                                $timeout(function() {
                                    $scope.savePaymentMethodToOrder(true);
                                }, 0);

                            } else {
                                $scope.selectedCreditCard = null;

                                $localStorage.order.additionalInfo.selectedCreditCardId = null;
                                $rootScope.order.additionalInfo.selectedCreditCardId = null;

                                $localStorage.order.additionalInfo.selectedCreditCardBrand = null;
                                $rootScope.order.additionalInfo.selectedCreditCardBrand = null;

                                // Workaround for ng-repeat re-rendering issue
                                $timeout(function() {
                                    $scope.savePaymentMethodToOrder(true);
                                }, 0);

                            }
                        } else {
                            if (
                                angular.isDefined($scope.visiblePaymentMethods[$scope.selectedPaymentMethod]) &&
                                $scope.visiblePaymentMethods[$scope.selectedPaymentMethod].id === JF_CONFIG.paymentMethods.creditCard
                            ) {
                                $scope.manageCreditCardsVisibility();
                            }
                        }
                    };

                    $scope.fetchAvailablePaymentMethods = function() {
                        var paymentParameters = {};

                        if (
                            angular.isUndefined($localStorage.paymentMethodsCache) ||
                            angular.isUndefined($localStorage.paymentMethodsCache[$localStorage.catalogType]) ||
                            $localStorage.paymentMethodsCache[$localStorage.catalogType].expiration <= Math.floor(Date.now())
                        ) {
                            SpinnerFactory.set('checkout-payment-methods');

                            BooksPaymentMethodsFactory
                                .get(paymentParameters)
                                .$promise
                                .then(function(results) {
                                    var promises = [];
                                    var result = results.data.filter(function(paymentMethod) {
                                        return (AccountFactory.isCompanyAccount() && paymentMethod.attributes.b_levels.includes('corp')) || (!AccountFactory.isCompanyAccount() && paymentMethod.attributes.b_levels.includes('b2c'));
                                    });

                                    angular.forEach(result, function(paymentMethod) {
                                        var deferred = $q.defer();

                                            deferred.resolve({
                                                id: paymentMethod.id,
                                                name: paymentMethod.attributes.localized_name[LanguageFactory.getLocale()] || '',
                                                // description: localizedPaymentMethod.attributes.description,
                                                description: '',
                                                abbreviation: paymentMethod.attributes.abbreviation.toLowerCase()
                                            });

                                        promises.push(deferred.promise);
                                    });

                                    $q
                                        .all(promises)
                                        .then(
                                            function(result) {
                                                SpinnerFactory.unset('checkout-payment-methods');

                                                $scope.cachePaymentMethods(
                                                    result,
                                                    (AccountFactory.isCompanyAccount() ? JF_CONFIG.accountTypes.company : JF_CONFIG.accountTypes.personal)
                                                );

                                                $scope.availablePaymentMethods = result;
                                                $scope.preparePaymentMethods(result);
                                            },
                                            function(err) {
                                                SpinnerFactory.unset('checkout-payment-methods');
                                                $rootScope.$emit('app-error', {err: err});
                                            }
                                        );
                                }, function(err) {
                                    SpinnerFactory.unset('checkout-payment-methods');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            $scope.availablePaymentMethods = $localStorage.paymentMethodsCache[$localStorage.catalogType].items;
                            $scope.preparePaymentMethods($localStorage.paymentMethodsCache[$localStorage.catalogType].items);
                        }
                    };

                    $scope.getPaymentMethods = function() {
                        $scope.fetchAvailablePaymentMethods();

                        var payableAmountWatcher = $rootScope.$watch('order.details.attributes.payable_amount', function(newVal, oldVal) {
                            if (
                                angular.isDefined(newVal) &&
                                newVal !== 0 &&
                                newVal !== oldVal &&
                                angular.isDefined($localStorage.order.details.attributes)
                            ) {
                                $scope.preparePaymentMethods($scope.availablePaymentMethods);
                            }
                        });

                        $scope.$on('$destroy', function() {
                            payableAmountWatcher();
                        });
                    };

                    $scope.cachePaymentMethods = function(paymentMethods, type) {
                        $localStorage.paymentMethodsCache = $localStorage.paymentMethodsCache || {};

                        $localStorage.paymentMethodsCache[type] = {
                            expiration: Math.floor(Date.now()) + JF_CONFIG.paymentMethodsCacheTime,
                            items: paymentMethods
                        };
                    };

                    $scope.showCashInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('CASH_INFO_TITLE'),
                            $filter('translate')('CASH_INFO_MSG'),
                            $filter('translate')('CASH_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showMonthlyInvoiceInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('MONTHLY_INVOICE_INFO_TITLE'),
                            $filter('translate')('MONTHLY_INVOICE_INFO_MSG'),
                            $filter('translate')('MONTHLY_INVOICE_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showPayPalAuthorizationInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('PAY_PAL_AUTH_INFO_TITLE'),
                            $filter('translate')('PAY_PAL_AUTH_INFO_MSG'),
                            $filter('translate')('PAY_PAL_AUTH_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showPayPalAuthorizedInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('PAY_PAL_AUTHORIZED_INFO_TITLE'),
                            $filter('translate')('PAY_PAL_AUTHORIZED_INFO_MSG'),
                            $filter('translate')('PAY_PAL_AUTHORIZED_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showCCAuthorizationInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('CC_AUTH_INFO_TITLE'),
                            $filter('translate')('CC_AUTH_INFO_MSG'),
                            $filter('translate')('CC_AUTH_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showCCAuthorizedInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('CC_AUTHORIZED_INFO_TITLE'),
                            $filter('translate')('CC_AUTHORIZED_INFO_MSG'),
                            $filter('translate')('CC_AUTHORIZED_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showSepaAuthorizationInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('SEPA_AUTH_INFO_TITLE'),
                            $filter('translate')('SEPA_AUTH_INFO_MSG'),
                            $filter('translate')('SEPA_AUTH_INFO_OK_BUTTON')
                        );
                    };

                    $scope.showSepaAuthorizedInfoPopup = function() {
                        jfDialog.showAlert(
                            $filter('translate')('SEPA_AUTHORIZED_INFO_TITLE'),
                            $filter('translate')('SEPA_AUTHORIZED_INFO_MSG'),
                            $filter('translate')('SEPA_AUTHORIZED_INFO_OK_BUTTON')
                        );
                    };

                    $scope.loadPaymentMethods = function() {
                        $scope.preparePayPalBillingAgreement();

                        SpinnerFactory.set('checkout-payment-methods');

                        CheckoutFactory
                            .fetchUserBillingAgreements($localStorage.catalogLocation.country_code)
                            .then(function() {
                                SpinnerFactory.unset('checkout-payment-methods');
                                $scope.getPaymentMethods();
                            }, function(err) {
                                SpinnerFactory.unset('checkout-payment-methods');

                                if (
                                    angular.isDefined($localStorage.order.details.attributes.payment_method_id) &&
                                    $localStorage.order.details.attributes.payment_method_id !== null &&
                                    [JF_CONFIG.paymentMethods.payPalAfterPayment, JF_CONFIG.paymentMethods.creditCard].indexOf($localStorage.order.details.attributes.payment_method_id) > -1
                                ) {
                                    SpinnerFactory.set('checkout-payment-methods');

                                    $scope
                                        .removeAdyenPaymentMethodFromOrder()
                                        .then(function() {
                                            SpinnerFactory.unset('checkout-payment-methods');
                                            $scope.getPaymentMethods();
                                        }, function(err) {
                                            SpinnerFactory.unset('checkout-payment-methods');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                } else {
                                    $scope.getPaymentMethods();
                                }

                                $rootScope.$emit('app-error', {err: err, silent: true});
                            });
                    };

                    $scope.removeAdyenPaymentMethodFromOrder = function() {
                        return OrderFactory.updateOrder(
                            $localStorage.order.details.id,
                            { payment_method_id_destroy: true }
                        );
                    };

                    $scope.saveCompanyPaymentMethodId = function() {
                        if (angular.isDefined(jfUser.get().companyId)) {
                            SpinnerFactory.set('checkout-payment-methods');

                            AccountFactory
                                .fetchCompanyPaymentMethod(jfUser.get().companyId)
                                .then(function(companyPaymentMethodId) {
                                    SpinnerFactory.unset('checkout-payment-methods');

                                    $scope.selectedPaymentMethod = companyPaymentMethodId;

                                    $scope.saveSelectedPaymentMethod();
                                }, function(err) {
                                    SpinnerFactory.unset('checkout-payment-methods');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    $scope.saveSelectedPaymentMethod = function() {
                        $scope
                            .savePaymentMethod()
                            .then(function() {

                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.savePaymentMethod = function() {
                        var deferred = $q.defer();

                        SpinnerFactory.set('checkout-payment-methods');

                        OrderFactory
                            .updateOrder(
                                $localStorage.order.details.id,
                                undefined,
                                {
                                    payment_method: {
                                        data: {
                                            id: $scope.selectedPaymentMethod,
                                            type: JF_SHARED_CONFIG.modelTypes.payment_methods
                                        }
                                    }
                                }
                            )
                            .then(function() {
                                SpinnerFactory.unset('checkout-payment-methods');

                                if (
                                    $rootScope.countObjKeys($scope.visiblePaymentMethods) > 0 &&
                                    angular.isDefined($scope.visiblePaymentMethods[$scope.selectedPaymentMethod])
                                ) {
                                    $localStorage.order.additionalInfo.selectedPaymentMethodId = $scope.visiblePaymentMethods[$scope.selectedPaymentMethod].id;
                                    $rootScope.order.additionalInfo.selectedPaymentMethodId = $scope.visiblePaymentMethods[$scope.selectedPaymentMethod].id;
                                }

                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    };

                    $scope.defineCompanyInvoicingType = function(companyDetails) {
                        if (companyDetails.pays_for_user) {
                            $scope.companyPays = true;
                            $scope.companyName = companyDetails.name;

                            $scope.saveCompanyPaymentMethodId();
                        } else {
                            $scope.loadPaymentMethods();
                        }
                    };

                    $scope.displayPaymentMethods = function() {
                        return angular.isDefined($rootScope.jfShared) &&
                                angular.isDefined($rootScope.jfShared.checkout) &&
                                jfHelper.countObjKeys($rootScope.jfShared.checkout.userAddresses) > 0 &&
                                angular.isDefined($localStorage.order) &&
                                angular.isDefined($localStorage.order.details) &&
                                angular.isDefined($localStorage.order.details.attributes) &&
                                angular.isDefined($localStorage.order.details.attributes.delivery_address) &&
                                $localStorage.order.details.attributes.delivery_address !== null &&
                                angular.isDefined($localStorage.order.details.attributes.delivery_address.resource_id);
                    };

                    $scope.initPaymentMethodForAccount = function() {
                        if ($scope.displayPaymentMethods()) {
                            if (AccountFactory.isCompanyAccount() || AccountFactory.isB2BAccount()) {
                                $scope.defineCompanyInvoicingType($localStorage.companyDetails);
                            } else {
                                $scope.loadPaymentMethods();
                            }
                        }
                    };

                    $scope.displayPaymentMethod = function(paymentMethod) {
                        if (
                            (
                                $rootScope.jfShared.checkout.userBillingAgreements.payPal === null &&
                                paymentMethod.id === $scope.paymentMethods.payPalAfterPayment
                            ) ||
                            (
                                $rootScope.jfShared.checkout.userBillingAgreements.cc === null &&
                                paymentMethod.id === $scope.paymentMethods.creditCard
                            ) ||
                            (
                                $rootScope.jfShared.checkout.userBillingAgreements.sepa === null &&
                                paymentMethod.id === $scope.paymentMethods.sepa
                            )
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    };

                    $scope.selectFirstNonCashPaymentMethod = function(saveToOrder) {
                        var setNewPaymentMethod = false;

                        angular.forEach($scope.availablePaymentMethods, function(paymentMethod) {
                            if (setNewPaymentMethod === false && paymentMethod.id !== $scope.paymentMethods.cash) {
                                $scope.selectedPaymentMethod = paymentMethod.id;
                                setNewPaymentMethod = true;
                            }
                        });

                        if (saveToOrder === true) {
                            $scope.savePaymentMethodToOrder(true);
                        }
                    };

                    $scope.toggleCreditCardForm = function() {
                        $scope.showCreditCardsForm = !$scope.showCreditCardsForm;
                        $scope.showCreditCardsSelector = !$scope.showCreditCardsSelector;
                    };

                    $scope.showCouponCoversTheOrderInfo = function() {
                        return $localStorage.order.details.attributes.payable_amount === 0 &&
                               angular.isDefined($localStorage.order.details.attributes.coupon_code) &&
                               $localStorage.order.details.attributes.coupon_code !== null &&
                               $localStorage.order.details.attributes.coupon_code !== '' &&
                               !(
                                   $scope.selectedPaymentMethod === JF_CONFIG.paymentMethods.payPalAfterPayment &&
                                   $rootScope.jfShared.checkout.userBillingAgreements.payPal.length > 0
                               ) &&
                               !(
                                   $scope.selectedPaymentMethod === JF_CONFIG.paymentMethods.creditCard &&
                                   $rootScope.jfShared.checkout.userBillingAgreements.cc.length > 0
                               );
                    };

                    $scope.initPaymentMethodsView = function() {
                        $scope.availablePaymentMethods = {};
                        $scope.selectedPaymentMethod = null;
                        $scope.visiblePaymentMethods = {};
                        $scope.showApplePay = false;
                        $scope.showCreditCardsSelector = false;
                        $scope.showCreditCardsForm = false;
                        $scope.selectedCreditCard = null;
                        $scope.paymentMethods = JF_CONFIG.paymentMethods;
                        $scope.companyPays = false;
                        $scope.companyName = null;
                        $scope.creditCardsReRenderTriggered = false;
                        $scope.parcelServiceEnabled = jfUser.get().parcelServiceEnabled || false;
                        $scope.allowPaymentMethodEdits = jfUser.get().allowPaymentMethodEdits || (
                            !jfUser.get().allowPaymentMethodEdits &&
                            jfUser.get().corporateEnabled &&
                            $localStorage.catalogType !== JF_CONFIG.accountTypes.company
                        );
                        $scope.locale = LanguageFactory.getLocale();

                        $scope.loadAddressesListener = $rootScope.$on('jfCheckout:loadAddresses', $scope.initPaymentMethodForAccount);
                        $scope.reloadPaymentMethodsListener = $rootScope.$on('jfCheckout:reloadPaymentMethods', $scope.initPaymentMethodForAccount);

                        $scope.reRenderCreditCardsListener = $rootScope.$on('jfCheckout:reRenderCreditCards', function() {
                            if (
                                $scope.selectedPaymentMethod === JF_CONFIG.paymentMethods.creditCard &&
                                $localStorage.order.additionalInfo.selectedCreditCardId === null &&
                                $scope.showCreditCardsForm === false &&
                                $scope.creditCardsReRenderTriggered === false
                            ) {
                                $scope.creditCardsReRenderTriggered = true;

                                CheckoutFactory
                                    .fetchUserBillingAgreements($localStorage.catalogLocation.country_code)
                                    .then(function() {
                                        $scope.manageCreditCardsVisibility();

                                        $scope.creditCardsReRenderTriggered = false;
                                    }, function(err) {
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            }
                        });

                        $scope.applePayVisibilityListener = $rootScope.$on('jf-apple-pay-available', function() {
                            $scope.showApplePay = true;
                        });

                        $scope.$on('$destroy', function() {
                            if (angular.isDefined($scope.loadAddressesListener)) {
                                $scope.loadAddressesListener();
                            }

                            if (angular.isDefined($scope.reloadPaymentMethodsListener)) {
                                $scope.reloadPaymentMethodsListener();
                            }

                            if (angular.isDefined($scope.processOrderListener)) {
                                $scope.processOrderListener();
                            }

                            if (angular.isDefined($scope.reRenderCreditCardsListener)) {
                                $scope.reRenderCreditCardsListener();
                            }

                            if (angular.isDefined($scope.applePayVisibilityListener)) {
                                $scope.applePayVisibilityListener();
                            }
                        });
                    };

                    jfController.init(['initPaymentMethodsView'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Coupon directive
 */
angular.module('jfApp')
    .directive(
        'couponCode',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/blocks/cart/directives/coupon.html',
                replace: true,
                controller: ['$scope', '$rootScope', '$state', '$localStorage', '$translate', 'base64', 'BooksCouponValidateOperationsFactory', 'OrderFactory', 'LanguageFactory', 'SpinnerFactory', 'jfUser', 'jfController', function (
                    $scope,
                    $rootScope,
                    $state,
                    $localStorage,
                    $translate,
                    base64,
                    BooksCouponValidateOperationsFactory,
                    OrderFactory,
                    LanguageFactory,
                    SpinnerFactory,
                    jfUser,
                    jfController
                ) {
                    $scope.initCouponView = function() {
                        $scope.couponVerified = false;
                        $scope.formErrors = [];
                        $scope.couponForm = false;
                        $scope.couponBlock = {
                            couponCode: null
                        };

                        if (
                            $localStorage.order.details.attributes &&
                            angular.isDefined($localStorage.order.details.attributes.coupon_code) &&
                            $localStorage.order.details.attributes.coupon_code !== null &&
                            $localStorage.order.details.attributes.coupon_code !== ''
                        ) {
                            $scope.couponBlock.couponCode = $localStorage.order.details.attributes.coupon_code;
                        }

                        if (
                            $localStorage.order.details.attributes &&
                            angular.isDefined($localStorage.order.details.attributes.coupon_code) &&
                            $localStorage.order.details.attributes.coupon_code !== null &&
                            $localStorage.order.details.attributes.coupon_code !== ''
                        ) {
                            $scope.couponVerified = true;
                        }
                    };

                    $scope.closeCouponBlock = function () {
                        $scope.couponForm = false;
                    };

                    $scope.showCouponBlock = function() {
                        if ($state.current.name === 'products') {
                            $rootScope.sendGAEvent('catalogPage', 'showCouponSectionLink');
                        } else if ($state.current.name === 'checkout') {
                            $rootScope.sendGAEvent('checkoutPage', 'showCouponSectionLink');
                        }

                        $scope.couponForm = true;
                    };

                    $scope.submitCouponCode = function(form) {
                        $scope.clearErrors();

                        if ($state.current.name === 'checkout') {
                            $rootScope.sendGAEvent('checkoutPage', 'addCouponButton');
                        }

                        $scope.couponVerified = false;

                        form.$setSubmitted();

                        if ($scope.couponBlock.couponCode === 'APP10') {
                            $scope.formErrors.push($translate.instant('WRONG_COUPON_CODE'));
                        } else if (angular.isDefined($scope.couponBlock.couponCode) &&
                            $scope.couponBlock.couponCode !== null &&
                            $scope.couponBlock.couponCode !== ''
                        ) {
                            var userEmail = null;

                            try {
                                userEmail = base64.decode(jfUser.get().login);
                            } catch(e) {}


                            SpinnerFactory.set('cart');

                            BooksCouponValidateOperationsFactory
                                .save(
                                    {
                                        data: {
                                            attributes: {
                                                code: $scope.couponBlock.couponCode.toUpperCase(),
                                                customer_id: jfUser.get().id,
                                                order_value: parseFloat($rootScope.order.details.attributes.total_amount),
                                                email: userEmail,
                                                locale: LanguageFactory.getLocale()
                                            },
                                            type: 'coupon_validate_operations'
                                        }
                                    }
                                )
                                .$promise
                                .then(function(result) {
                                    if (result.data.attributes.result && angular.isDefined(result.data.attributes.code)) {
                                        OrderFactory
                                            .updateOrder(
                                                $localStorage.order.details.id,
                                                { coupon_code: result.data.attributes.code }
                                            )
                                            .then(function() {
                                                SpinnerFactory.unset('cart');
                                                if (form.coupon) {
                                                    form.coupon.$setValidity('wrongCode', true);
                                                }

                                                $scope.couponVerified = true;
                                            }, function(err) {
                                                $rootScope.$emit('app-error', {err: err});
                                                SpinnerFactory.unset('cart');
                                            });
                                    } else {
                                        SpinnerFactory.unset('cart');
                                        form.coupon.$setValidity('wrongCode', false);
                                    }
                                }, function(err) {
                                    if (err.status === 410) {
                                        angular.forEach(err.data, function(errObjValue) {
                                            angular.forEach(errObjValue, function(error) {
                                                $scope.formErrors.push(error);
                                            });
                                        });
                                    } else if (err.status === 422) {
                                        angular.forEach(err.data.errors, function(error) {
                                            $scope.formErrors.push(error.meta.message);
                                        });
                                    } else {
                                        $rootScope.$emit('app-error', {err: err});
                                    }
                                    SpinnerFactory.unset('cart');
                                });
                        }
                    };

                    $scope.clearErrors = function() {
                        if ($scope.formErrors.length > 0) {
                            $scope.formErrors = [];
                        }
                    };

                    $scope.removeCouponCode = function() {
                        if ($state.current.name === 'checkout') {
                            $rootScope.sendGAEvent('checkoutPage', 'removeCouponButton');
                        }

                        SpinnerFactory.set('cart');

                        OrderFactory
                            .updateOrder(
                                $localStorage.order.details.id,
                                { coupon_code: null }
                            )
                            .then(function() {
                                delete $scope.couponBlock.couponCode;

                                $scope.couponVerified = false;

                                SpinnerFactory.unset('cart');
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                                SpinnerFactory.unset('cart');
                            });
                    };

                    jfController.init(['initCouponView'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Special Instructions directive
 */
angular.module('jfApp')
    .directive(
        'specialInstructions',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/special-instructions.html',
                replace: true,
                controller: ['$scope', '$rootScope', '$localStorage', function ($scope, $rootScope, $localStorage) {
                    $scope.saveSpecialInstructionsNote = function() {
                        $localStorage.order.additionalInfo.specialInstructions = $rootScope.order.additionalInfo.specialInstructions;
                    };
                }]
            };
        }
    );
/**
 * Checkout - PayPal authorize form directive
 */
angular.module('jfApp')
    .directive(
        'jfPayPalAuthorizeForm',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/jf-pay-pal-authorize-form.html',
                scope: {
                    country: '='
                },
                controller: ['$scope', '$rootScope', '$location', '$state', '$window', '$translate', 'SpinnerFactory', 'AdyenFactory', 'jfController', 'jfHelper', 'jfUser', 'jfConfigUrls', function (
                    $scope,
                    $rootScope,
                    $location,
                    $state,
                    $window,
                    $translate,
                    SpinnerFactory,
                    AdyenFactory,
                    jfController,
                    jfHelper,
                    jfUser,
                    jfConfigUrls
                ) {
                    $scope.submitPayPalAuthorizeForm = function() {
                        $scope.showAuthorizationError = false;

                        AdyenFactory
                            .sendAdyenBillingAggreement(
                                {
                                    customer_id: jfUser.get().id,
                                    country_code: $scope.country,
                                    payment_info: {
                                        paymentMethod: { type: 'paypal' },
                                        returnUrl: $location.absUrl().split('?')[0],
                                        origin: $window.location.origin,
                                    },
                                    event: 'init'
                                },
                                $scope.country
                            )
                            .then(function(adyenResponse) {
                                $scope.redirectHandler(adyenResponse);
                            }, function (err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.redirectHandler = function(adyenResponse) {
                        SpinnerFactory.set('global', $translate.instant('PAY_PAL_REDIRECT_INFO'));

                        if (jfHelper.mobileAppMode) {
                            $scope.redirectOnMobile(adyenResponse.data.attributes.payment_info.url);
                        } else {
                            $window.location = adyenResponse.data.attributes.payment_info.url;
                        }
                    };

                    $scope.redirectOnMobile = function(pageContentUrl) {
                        var ref = $window.window.open(pageContentUrl, '_blank', 'hidden=no,location=no,clearsessioncache=yes,clearcache=yes');

                        ref.addEventListener('exit', function() {
                            // Hack for ios - the status bar is hidden after closing inappbrowser, this is the way to fix it...
                            if (typeof StatusBar !== 'undefined') {
                                StatusBar.hide();
                                StatusBar.show();
                            }

                            SpinnerFactory.unset('global', null);
                        });

                        ref.addEventListener('loadstart', function(event) {
                            if (
                                event.url.indexOf(jfConfigUrls.get('jfShopUrl', 'customerApp')) > -1 ||
                                event.url.indexOf('ionic://cwa.jonnyfresh.com') === 0 ||
                                event.url.indexOf('https://cwa.jonnyfresh.com') === 0
                            ) {
                                ref.close();

                                var searchParams = new window.URLSearchParams(event.url.split('?')[1]);

                                if (searchParams.get('resultCode') && searchParams.get('resultCode') === 'cancelled') {
                                    $scope.showAuthorizationError = true;
                                } else {
                                    $scope.showAuthorizationError = false;
                                    $state.reload();
                                }
                            }
                        });
                    };

                    $scope.initPayPalAuthorizeFormView = function() {
                        $scope.showAuthorizationError = $location.search().redirectResult && $location.search().resultCode === 'cancelled';
                    };

                    jfController.init(['initPayPalAuthorizeFormView'], $scope);
                }]
            };
        }
    );
/**
 * Instructions directive
 */
angular.module('jfApp')
    .directive(
        'jfInstructions',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/instructions/jf-instructions.html',
                replace: true,
                scope: {
                    forceDisplay: '=?'
                },
                controller: ['$scope', '$rootScope', '$state', '$localStorage', '$window', 'LanguageFactory', 'jfUser', function (
                    $scope,
                    $rootScope,
                    $state,
                    $localStorage,
                    $window,
                    LanguageFactory,
                    jfUser
                ) {
                    $scope.language = (LanguageFactory.getActiveLocale() || 'de_DE').split('_')[0].toUpperCase();

                    $scope.isRetina = function() {
                        var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
                        if ($window.devicePixelRatio > 1) {
                            return true;
                        }
                        return $window.matchMedia && $window.matchMedia(mediaQuery).matches;
                    };

                    $scope.getImgUrl = function(num) {
                        var url = 'url(' + 'assets/intro-slider/$num-$language$retina.jpg' + ') no-repeat center center / cover';
                        if ($scope.isRetina()) {
                            return url
                                .replace('$num', num)
                                .replace('$language', $scope.language)
                                .replace('$retina', '@2x');
                        }
                        return url
                            .replace('$num', num)
                            .replace('$language', $scope.language)
                            .replace('$retina', '');
                    };

                    $scope.cancelDialog = function() {
                        if (angular.isDefined($scope.forceDisplay) && $scope.forceDisplay === true) {
                            $state.go('products', {'#': 'c0'});
                        } else {
                            $localStorage.intro = 1;

                            if ($rootScope.mobileAppMode === true && !jfUser.isLoggedIn()) {
                                $state.go('location-picker');
                            } else {
                                $state.go('products', {'#': 'c0'});
                            }
                        }
                    };
                }]
            };
        });
/**
 * Products - Add Preloaded image directive
 */
angular.module('jfApp')
    .directive(
        'jfAddPreloadedImage',
        ['$rootScope', 'jfConfigUrls', function(
            $rootScope,
            jfConfigUrls
        ) {
            'use strict';

            return {
                restrict: 'A',
                link: function (
                    $scope,
                    element,
                    attr
                ) {
                    if ($rootScope.loadedProductImages.indexOf(attr.jfAddPreloadedImage) > -1) {
                        element.attr('src', jfConfigUrls.get('jfImagesCDN', 'customerApp') + '/' + attr.jfAddPreloadedImage);

                        element.css({
                            '-webkit-transition': 'opacity 0s ease',
                            '-moz-transition': 'opacity 0s ease',
                            '-o-transition': 'opacity 0s ease',
                            'transition': 'opacity 0s ease'
                        });

                        element.css('opacity', 1);
                    }
                }
            };
        }]
    );
/**
 * Catalog product price directive
 */
angular.module('jfApp')
    .directive(
        'jfCatalogProductPrice',
        function() {
            'use strict';

            return {
                restrict: 'E',
                template: '<span>{{productPrice | round: 2}}</span>',
                scope: {
                    product: '='
                },
                controller: ['$scope', 'jfController', function (
                    $scope,
                    jfController
                ) {
                    $scope.initJfCatalogProductPrice = function() {
                        $scope.productPrice = null;
                        $scope.productPrice = $scope.product.price_value;
                        $scope.productPrice = $scope.productPrice * $scope.product.price_quantity;
                    };

                    jfController.init(['initJfCatalogProductPrice'], $scope);
                }]
            };
        }
    );
/**
 * Closest Appointments directive
 */
angular.module('jfApp')
    .directive(
        'closestAppointments',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/closest-appointments.directive.html',
                replace: true,
                scope: {
                    order: '=',
                    origin: '@'
                },
                controller: ['$scope', '$rootScope', '$mdMedia', '$interval', '$localStorage', 'CheckoutFactory', 'SpinnerFactory', 'OrderFactory', 'jfController', 'jfUser', function (
                    $scope,
                    $rootScope,
                    $mdMedia,
                    $interval,
                    $localStorage,
                    CheckoutFactory,
                    SpinnerFactory,
                    OrderFactory,
                    jfController,
                    jfUser
                ) {
                    $scope.fetchClosestPickupDeliveryAppointments = function() {
                        $scope.noAppointmentsForAddress = false;

                        if (
                            angular.isDefined($scope.order.details.attributes.pickup_address) &&
                            $scope.order.details.attributes.pickup_address !== null &&
                            angular.isDefined($scope.order.details.attributes.pickup_address.resource_id) &&
                            $scope.order.details.attributes.pickup_address.resource_id !== null &&
                            angular.isDefined($scope.order.details.attributes.delivery_address) &&
                            $scope.order.details.attributes.delivery_address !== null &&
                            angular.isDefined($scope.order.details.attributes.delivery_address.resource_id) &&
                            $scope.order.details.attributes.delivery_address.resource_id !== null
                        ) {
                            if (
                                (
                                    angular.isDefined($scope.order.details.attributes.pickup_start_time) &&
                                    $scope.order.details.attributes.pickup_start_time !== null
                                ) || (
                                    angular.isDefined($scope.order.details.attributes.delivery_start_time) &&
                                    $scope.order.details.attributes.delivery_start_time !== null
                                )
                            ) {
                                $scope.checkoutAppointmentsLoaded = true;
                                $scope.initAppointmentsMonitoring();
                            } else {
                                var addressAtributes = $rootScope.jfShared.checkout.userAddresses[$scope.order.details.attributes.pickup_address.resource_id].attributes;
                                if ($scope.origin !== 'checkout') {
                                    addressAtributes = $scope.order.details.attributes;
                                }

                                SpinnerFactory.set('checkout-closest-appointments');

                                CheckoutFactory
                                    .fetchPickupAppointments(
                                        addressAtributes,
                                        jfUser.get().companyId,
                                        null,
                                        $scope.origin
                                    )
                                    .then(function(pickupAppointments) {
                                        if (pickupAppointments.length > 0) {
                                            OrderFactory
                                                .updateOrder(
                                                    $scope.order.details.id,
                                                    {
                                                        pickup_start_ts: pickupAppointments[0].attributes.start_ts,
                                                        pickup_end_ts: pickupAppointments[0].attributes.end_ts
                                                    }
                                                )
                                                .then(function(updatedOrder) {
                                                    SpinnerFactory.unset('checkout-closest-appointments');

                                                    $scope.order.details.attributes = updatedOrder.data.attributes;
                                                    $scope.setDates();
                                                    $scope.fetchClosestDeliveryAppointment();
                                                }, function(err) {
                                                    SpinnerFactory.unset('checkout-closest-appointments');
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        } else {
                                            SpinnerFactory.unset('checkout-closest-appointments');

                                            $scope.checkoutAppointmentsLoaded = false;
                                            $scope.noAppointmentsForAddress = true;
                                        }
                                    }, function(err) {
                                        SpinnerFactory.unset('checkout-closest-appointments');
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            }
                        }
                    };

                    $scope.fetchClosestDeliveryAppointment = function() {
                        var addressAtributes = $rootScope.jfShared.checkout.userAddresses[$scope.order.details.attributes.pickup_address.resource_id].attributes;
                        if ($scope.origin !== 'checkout') {
                            addressAtributes = $scope.order.details.attributes;
                        }

                        SpinnerFactory.set('checkout-closest-appointments');

                        CheckoutFactory
                            .fetchDeliveryAppointments(
                                $scope.order,
                                addressAtributes,
                                jfUser.get().companyId,
                                $scope.origin
                            )
                            .then(function(deliveryAppointments) {
                                if (deliveryAppointments.length > 0) {
                                    OrderFactory
                                        .updateOrder(
                                            $scope.order.details.id,
                                            {
                                                delivery_start_ts: deliveryAppointments[0].attributes.start_ts,
                                                delivery_end_ts: deliveryAppointments[0].attributes.end_ts
                                            }
                                        )
                                        .then(function(updatedOrder) {
                                            SpinnerFactory.unset('checkout-closest-appointments');

                                            $scope.order.details.attributes = updatedOrder.data.attributes;
                                            $scope.checkoutAppointmentsLoaded = true;
                                            $scope.showPickupNotes = OrderFactory.showPickupNotes(updatedOrder.data);
                                            $scope.showDeliveryNotes = OrderFactory.showDeliveryNotes(updatedOrder.data);
                                            $scope.setDates();
                                            $scope.initAppointmentsMonitoring();
                                        }, function(err) {
                                            SpinnerFactory.unset('checkout-closest-appointments');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                } else {
                                    SpinnerFactory.unset('checkout-closest-appointments');
                                }
                            }, function(err) {
                                SpinnerFactory.unset('checkout-closest-appointments');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.showPickupTimetable = function() {
                        $rootScope.$emit('jfCheckout:showPickupTimeTable');
                    };

                    $scope.showDeliveryTimetable = function() {
                        $rootScope.$emit('jfCheckout:showDeliveryTimeTable');
                    };

                    $scope.isTripDone = function(tripType, status) {
                        return angular.isDefined($scope.order.details) &&
                            angular.isDefined($scope.order.details.attributes) &&
                            angular.isDefined($scope.order.details.attributes.editable_content_by_customers) &&
                            !$scope.order.details.attributes.editable_content_by_customers[tripType + '_appointment'] &&
                            $scope.order.details.attributes['state_for_' + tripType] === status;
                    };

                    $scope.setDates = function() {
                        if ($scope.origin === 'checkout') {
                            $scope.pickupDate = $scope.order.details.attributes.pickup_date;
                            $scope.pickupStartTime = $scope.order.details.attributes.pickup_start_time;
                            $scope.pickupEndTime = $scope.order.details.attributes.pickup_end_time;
                            $scope.deliveryDate = $scope.order.details.attributes.delivery_date;
                            $scope.deliveryStartTime = $scope.order.details.attributes.delivery_start_time;
                            $scope.deliveryEndTime = $scope.order.details.attributes.delivery_end_time;
                        } else {
                            $scope.pickupDate = $scope.order.details.attributes.scheduled_pickup_date;
                            $scope.pickupStartTime = $scope.order.details.attributes.scheduled_pickup_start_time;
                            $scope.pickupEndTime = $scope.order.details.attributes.scheduled_pickup_end_time;
                            $scope.deliveryDate = $scope.order.details.attributes.scheduled_delivery_date;
                            $scope.deliveryStartTime = $scope.order.details.attributes.scheduled_delivery_start_time;
                            $scope.deliveryEndTime = $scope.order.details.attributes.scheduled_delivery_end_time;
                        }
                    };

                    $scope.appointmentsMonitoringInterval = null;

                    $scope.initAppointmentsMonitoring = function() {
                        if ($scope.appointmentsMonitoringInterval === null) {
                            $scope.appointmentsMonitoringInterval = $interval($scope.appointmentsMonitoringHandler, 2000);
                        }
                    };

                    $scope.appointmentsMonitoringHandler = function() {
                        var now = new Date(),
                            selectedPickupTime = $scope.order.details.attributes.pickup_start_ts,
                            selectedDeliveryTime = $scope.order.details.attributes.delivery_start_ts;

                        if (selectedPickupTime !== null && new Date(selectedPickupTime) < now) {
                            $interval.cancel($scope.appointmentsMonitoringInterval);

                            SpinnerFactory.set('checkout-closest-appointments');

                            OrderFactory
                                .updateOrder(
                                    $scope.order.details.id,
                                    {
                                        pickup_start_ts: null,
                                        pickup_end_ts: null,
                                        delivery_start_ts: null,
                                        delivery_end_ts: null
                                    }
                                )
                                .then(function(updatedOrder) {
                                    SpinnerFactory.unset('checkout-closest-appointments');

                                    $scope.order.details.attributes = updatedOrder.data.attributes;
                                    $scope.setDates();

                                    $scope.appointmentsMonitoringInterval = $interval($scope.appointmentsMonitoringHandler, 2000);
                                }, function(err) {
                                    SpinnerFactory.unset('checkout-closest-appointments');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else if (selectedDeliveryTime !== null && new Date(selectedDeliveryTime) < now) {
                            $interval.cancel($scope.appointmentsMonitoringInterval);

                            SpinnerFactory.set('checkout-closest-appointments');

                            OrderFactory
                                .updateOrder(
                                    $scope.order.details.id,
                                    {
                                        delivery_start_ts: null,
                                        delivery_end_ts: null
                                    }
                                )
                                .then(function(updatedOrder) {
                                    SpinnerFactory.unset('checkout-closest-appointments');

                                    $scope.order.details.attributes = updatedOrder.data.attributes;
                                    $scope.setDates();

                                    $scope.appointmentsMonitoringInterval = $interval($scope.appointmentsMonitoringHandler, 2000);
                                }, function(err) {
                                    SpinnerFactory.unset('checkout-closest-appointments');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    };

                    $scope.initClosestAppointmentView = function() {
                        $scope.checkoutAppointmentsLoaded = false;
                        $scope.isEnglishLocale = $localStorage.shopLocale && $localStorage.shopLocale.indexOf('en') > -1;

                        if ($scope.origin === 'checkout') {
                            $scope.order = $localStorage.order;
                            var orderWatcher = $rootScope.$watch('order', function(newVal, oldVal) {
                                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                                    $scope.order = newVal;
                                }
                            }, true);

                            $scope.showPickupNotes = OrderFactory.showPickupNotes($scope.order.details);
                            $scope.showDeliveryNotes = OrderFactory.showDeliveryNotes($scope.order.details);
                        } else {
                            $scope.showPickupNotes = OrderFactory.showPickupNotes($scope.order.details);
                            $scope.showDeliveryNotes = OrderFactory.showDeliveryNotes($scope.order.details);
                            $scope.checkoutAppointmentsLoaded = true;
                        }

                        $scope.$mdMedia = $mdMedia;
                        $scope.jfShared = $rootScope.jfShared;

                        $scope.setDates();

                        var savePickupListener = $rootScope.$on('jfCheckout:savePickup', $scope.fetchClosestPickupDeliveryAppointments),
                            saveDeliveryListener = $rootScope.$on('jfCheckout:saveDelivery', function() {
                                if (
                                    $scope.order.details.attributes.delivery_start_time === null &&
                                    $scope.order.details.attributes.pickup_start_time !== null
                                ) {
                                    $scope.fetchClosestDeliveryAppointment();
                                }
                            }),
                            userAddressesListener = $rootScope.$on('jfCheckout:loadAddresses', function() {
                                if (
                                    angular.isDefined($scope.order.details.attributes.delivery_address) &&
                                    $scope.order.details.attributes.delivery_address !== null
                                ) {
                                    $scope.fetchClosestPickupDeliveryAppointments();
                                }
                            }),
                            setPickupDateListener = $rootScope.$on('jfOrder:open-delivery', function() {
                                $scope.setDates();
                            }),
                            setDeliveryDateListener = $rootScope.$on('jfOrder:show-confirmation', function() {
                                $scope.setDates();
                            }),
                            updateDatesListener = $rootScope.$on('jfOrder:update-dates', function() {
                                $scope.setDates();
                            });

                        $scope.$on('$destroy', function() {
                            savePickupListener();
                            saveDeliveryListener();
                            userAddressesListener();
                            setPickupDateListener();
                            setDeliveryDateListener();
                            updateDatesListener();
                            if (orderWatcher) {
                                orderWatcher();
                            }
                            $interval.cancel($scope.appointmentsMonitoringInterval);
                        });
                    };

                    jfController.init(['initClosestAppointmentView'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - newsletter directive
 */
angular.module('jfApp')
    .directive(
        'jfNewsletter',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/jf-newsletter.html',
                replace: true,
                scope: {
                    formModel: '=',
                    form: '='
                },
                controller: ['$scope', '$rootScope', '$localStorage', function (
                    $scope,
                    $rootScope,
                    $localStorage
                ) {
                    $scope.saveNewsletterCheckbox = function() {
                        $rootScope.sendGAEvent('checkoutPage', 'newsletterCheckbox');

                        $localStorage.order.additionalInfo.newsletter = $scope.formModel;
                        $rootScope.order.additionalInfo.newsletter = $scope.formModel;
                    };
                }]
            };
        }
    );
/**
 * Checkout - SEPA payment method
 */
angular.module('jfApp')
    .directive(
        'jfSepaPayment',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/components/checkout/directives/jf-sepa-payment.directive.html',
                scope: {
                    country: '=',
                    showCancelButton: '=?',
                    cancelCallback: '=?',
                    saveCallback: '=?'
                },
                controller: ['$scope', '$rootScope', '$filter', '$window', '$state', 'AdyenFactory', 'SpinnerFactory', 'CheckoutFactory', 'jfUser', 'jfConfigUrls', 'jfController', function (
                    $scope,
                    $rootScope,
                    $filter,
                    $window,
                    $state,
                    AdyenFactory,
                    SpinnerFactory,
                    CheckoutFactory,
                    jfUser,
                    jfConfigUrls,
                    jfController
                ) {
                    $scope.saveSepa = function() {
                        $scope.genericErrors = [];
                        CheckoutFactory.clearValidationErrors();

                        if (
                            angular.isDefined($rootScope.jfShared.adyen) &&
                            angular.isDefined($rootScope.jfShared.adyen.sepaFormValues)
                        ) {
                            SpinnerFactory.set([
                                'account-credit-cards',
                                'checkout-payment-methods'
                            ]);

                            AdyenFactory
                                .sendAdyenBillingAggreement(
                                    {
                                        customer_id: jfUser.get().id,
                                        country_code: $scope.country,
                                        payment_info: {
                                            paymentMethod: $rootScope.jfShared.adyen.sepaFormValues.paymentMethod,
                                            returnUrl: jfConfigUrls.get('jfShopUrl', 'customerApp') + 'checkout/'
                                        },
                                        event: 'init'
                                    },
                                    $scope.country
                                )
                                .then(function(adyenResponse) {
                                    SpinnerFactory.unset([
                                        'account-credit-cards',
                                        'checkout-payment-methods'
                                    ]);

                                    if (
                                        adyenResponse.data.attributes.state === 'redirectShopper'
                                    ) {
                                        AdyenFactory
                                            .sendAdyenBillingAggreement(
                                                {
                                                    customer_id: jfUser.get().id,
                                                    country_code: $scope.country,
                                                    payment_info: adyenResponse.data.attributes.payment_info,
                                                    event: 'redirectShopper'
                                                },
                                                $scope.country
                                            )
                                            .then(function() {
                                                if (angular.isDefined($scope.saveCallback)) {
                                                    $scope.saveCallback();
                                                } else {
                                                    CheckoutFactory
                                                        .fetchUserBillingAgreements($scope.country)
                                                        .then(function() {

                                                        }, function(err) {
                                                            $rootScope.$emit('app-error', {err: err});
                                                        });
                                                }
                                            }, function(err) {
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    } else {
                                        if (angular.isDefined($scope.saveCallback)) {
                                            $scope.saveCallback();
                                        } else {
                                            CheckoutFactory
                                            .fetchUserBillingAgreements($scope.country)
                                            .then(function() {

                                            }, function(err) {
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                        }
                                    }
                                }, function(err) {
                                    SpinnerFactory.unset([
                                        'account-credit-cards',
                                        'checkout-payment-methods'
                                    ]);

                                    $scope.genericErrors.push({ detail: $filter('translate')('SEPA_ADYEN_ERROR') });

                                    $rootScope.$emit('app-error', {err: err, silent: true});
                                });
                        }
                    };

                    $scope.disableSepaSubmitButton = function() {
                        return AdyenFactory.sepaFormSubmitDisabled;
                    };

                    $scope.initSepaPaymentView = function() {
                        $scope.genericErrors = [];
                        $scope.showCancelButton = $scope.showCancelButton ? $scope.showCancelButton : false;
                        $scope.accountView = $state.current.name !== 'checkout';

                        if (!AdyenFactory.isScriptLoaded() && !AdyenFactory.scriptInjected) {
                            AdyenFactory.loadScript();
                            AdyenFactory.loadCss();
                        }

                        $scope.adyenLibWatcher = $scope.$watch(
                            function() {
                                return $window.AdyenCheckout;
                            }, function(newValue) {
                                if (angular.isDefined(newValue)) {
                                    AdyenFactory.initSepa('#jf-sepa-container');
                                }
                            }
                        );

                        $scope.$on('$destroy', function() {
                            if (angular.isDefined($scope.adyenLibWatcher)) {
                                $scope.adyenLibWatcher();
                            }
                        });
                    };

                    jfController.init(['initSepaPaymentView'], $scope);
                }]
            };
        }
    );
/**
 * Checkout - Apple pay payment method
 */
angular
  .module('jfApp')
  .directive(
    'jfApplePay',
    function() {
      'use strict';

      return {
        restrict: 'E',
        templateUrl: 'app/components/checkout/directives/jf-apple-pay.directive.html',
        scope: {},
        controller: ['$scope', '$rootScope', '$filter', '$window', '$localStorage', '$q', 'AdyenFactory', 'CheckoutFactory', 'SpinnerFactory', 'PaymentMethodsManagerFactory', 'jfUser', 'jfController', function (
          $scope,
          $rootScope,
          $filter,
          $window,
          $localStorage,
          $q,
          AdyenFactory,
          CheckoutFactory,
          SpinnerFactory,
          PaymentMethodsManagerFactory,
          jfUser,
          jfController
        ) {
          $scope.initializeAdyenPayment = function(applePayResponse) {
            var deferred = $q.defer();

            PaymentMethodsManagerFactory
                .getBillingAddress()
                .then(function(billingAddress) {
                    if (angular.isDefined(billingAddress)) {
                        if (angular.isDefined(applePayResponse)) {
                            SpinnerFactory.set(['checkout-payment-methods']);

                            AdyenFactory
                                .sendAdyenBillingAggreement(
                                    {
                                        customer_id: jfUser.get().id,
                                        country_code: $localStorage.order.details.attributes.delivery_address.country_code,
                                        payment_info: {
                                            paymentMethod: applePayResponse.paymentMethod,
                                            billingAddress: billingAddress,
                                            origin: $window.location.origin
                                        },
                                        event: 'init'
                                    },
                                    $localStorage.order.details.attributes.delivery_address.country_code
                                )
                                .then(function(result) {
                                    SpinnerFactory.unset(['checkout-payment-methods']);
                                    deferred.resolve(result.data);
                                }, function(err) {
                                    SpinnerFactory.unset(['checkout-payment-methods']);

                                    deferred.reject(err);
                                });
                        } else {
                            deferred.reject();
                        }
                    } else {
                        deferred.reject({
                            customErrorMsg: $filter('translate')('CC_ADYEN_ERROR_BILLING_ADDRESS')
                        });
                    }
                }, function(err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

          $scope.initApplePayView = function() {
            if ($rootScope.jfShared.checkout.userBillingAgreements.app === null || $rootScope.jfShared.checkout.userBillingAgreements.app.length === 0) {
              if (!AdyenFactory.isScriptLoaded() && !AdyenFactory.scriptInjected) {
                AdyenFactory.loadScript();
                AdyenFactory.loadCss();
              }

              $scope.adyenLibWatcher = $scope.$watch(
                function() {
                  return $window.AdyenCheckout;
                }, function(newValue) {
                  if (angular.isDefined(newValue)) {
                    AdyenFactory.initApplePay('#jf-apple-pay-container');
                  }
                }
              );

              $scope.applePayResponseListener = $rootScope.$on('jf-apple-pay-response', function(e, applePayResponse) {
                $scope.initializeAdyenPayment(applePayResponse).then(function() {
                  CheckoutFactory
                    .fetchUserBillingAgreements($localStorage.order.details.attributes.delivery_address.country_code)
                    .then(function() {

                    }, function(err) {
                        $rootScope.$emit('app-error', {err: err});
                    });
                }, function(err) {
                  $rootScope.$emit('app-error', {err: err});
                });
              });

              $scope.$on('$destroy', function() {
                if (angular.isDefined($scope.adyenLibWatcher)) {
                  $scope.adyenLibWatcher();
                }
                if (angular.isDefined($scope.applePayResponseListener)) {
                  $scope.applePayResponseListener();
                }
              });
            } else {
              $rootScope.$emit('jf-apple-pay-available');
            }
          };

          jfController.init(['initApplePayView'], $scope);
        }]
      };
    }
  );
/**
 * Header account switcher directive
 */
angular.module('jfApp')
    .directive(
        'headerAccountSwitcher',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/blocks/nav/header-account-switcher.directive.html',
                replace: true,
                controller: ['$state', '$scope', '$rootScope', '$location', '$timeout', 'SpinnerFactory', 'AccountFactory', 'ProductsFactory', 'jfUser', function (
                    $state,
                    $scope,
                    $rootScope,
                    $location,
                    $timeout,
                    SpinnerFactory,
                    AccountFactory,
                    ProductsFactory,
                    jfUser
                ) {
                    $scope.account = {
                        switcher: AccountFactory.isCompanyAccount()
                    };

                    $scope.corporateEnabled = jfUser.get().corporateEnabled;

                    $scope.changeAccountType = function() {
                        $timeout(function() {
                            $rootScope.$emit(
                                'jf:closeTrustBarPopup',
                                { origin: 'outside' }
                            );
                        }, 500);

                        SpinnerFactory.set('global');

                        ProductsFactory
                            .changeCatalogType()
                            .then(function() {
                                SpinnerFactory.unset('global');

                                if ($state.current.name === 'checkout') {
                                    $state.reload();
                                } else {
                                    $location.hash('');
                                }
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.closePopup = function() {
                        $rootScope.$emit(
                            'jf:closeTrustBarPopup',
                            {
                                origin: 'outside',
                                type: 'accountSwitcher'
                            }
                        );
                    };

                    $rootScope.$on('jf:accountTypeChanged', function() {
                        $scope.account.switcher = AccountFactory.isCompanyAccount();
                    });
                }],
                link: function($scope, element, attrs) {
                    $scope.trustBar = attrs.trustBar === 'true' ? true : false;
                }
            };
        }
    );
/**
 * Header catalog location selector directive
 */
angular.module('jfApp')
    .directive(
        'headerCatalogLocationSelector',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/blocks/nav/header-catalog-location-selector.directive.html',
                replace: true,
                controller: ['$state', '$scope', '$rootScope', '$localStorage', '$filter', '$window', 'ProductsFactory', 'ContextLocationsFactory', 'SpinnerFactory', 'OrderFactory', 'jfLocation', 'jfUser', 'jfDialog', 'JF_CONFIG', function (
                    $state,
                    $scope,
                    $rootScope,
                    $localStorage,
                    $filter,
                    $window,
                    ProductsFactory,
                    ContextLocationsFactory,
                    SpinnerFactory,
                    OrderFactory,
                    jfLocation,
                    jfUser,
                    jfDialog,
                    JF_CONFIG
                ) {

                    $scope.formModel = {};
                    $scope.selectedPostalCode = '';
                    $scope.currentDeliveryLocation = $localStorage.catalogLocation ? $localStorage.catalogLocation.city : '';
                    $scope.currentCatalogPostalCode = $localStorage.catalogLocation ? $localStorage.catalogLocation.postal_code : '';
                    $scope.repeaterCssClass = 'jf-header-location-switcher-content';

                    $scope.submitLocationForm = function(form) {
                        form.$submitted = true;

                        if (form.$valid && $rootScope.currentCatalogPostalCode !== $scope.formModel.postal_code) {
                            $scope.formModel.default_locale = angular.isDefined(jfUser.get().locale) ?
                                jfUser.get().locale :
                                JF_CONFIG.defaultLocale;

                            $scope.formModel.addressable_type = 'Customer';

                            $scope.proceedWithSaving();
                        }
                    };

                    $scope.proceedWithSaving = function() {
                        SpinnerFactory.set('global');

                        jfLocation
                            .postalCodeInService($scope.formModel.postal_code_id.toUpperCase(), jfUser.get().companyId)
                            .then(function(validationResult) {
                                SpinnerFactory.unset('global');

                                if (validationResult.postalCodeDetails.b_levels.includes('b2c')) {
                                    $scope.formModel.addressable_type = 'Customer';
                                    ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);
                                } else {
                                    $scope.formModel.addressable_type = 'Company';
                                    ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.company);
                                }

                                ProductsFactory.setCatalogLocation($scope.formModel);

                                if (validationResult.postalCodeDetails.plant_id !== $localStorage.order.details.attributes.processing_plant_id) {
                                    jfDialog
                                        .showConfirm(
                                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_TITLE'),
                                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_CONTENT'),
                                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_OK'),
                                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_CANCEL'),
                                            function() {
                                                SpinnerFactory.set('global');

                                                OrderFactory
                                                    .resetUserOrder()
                                                    .then(function() {
                                                        SpinnerFactory.unset('global');

                                                        if ($state.current.name === 'products') {
                                                            $window.location.reload();
                                                        } else {
                                                            $state.go('products', {'#': 'c0'});
                                                        }
                                                    }, function(err) {
                                                        SpinnerFactory.unset('global');
                                                        $rootScope.$emit('app-error', {err: err});
                                                    });
                                            }
                                        );
                                } else {
                                    if ($state.current.name === 'products') {
                                        $state.reload();
                                    } else {
                                        $state.go('products', {'#': 'c0'});
                                    }
                                }
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.closePopup = function() {
                        $rootScope.$emit(
                            'jf:closeTrustBarPopup',
                            {
                                origin: 'outside',
                                type: 'catalogSelector'
                            }
                        );
                    };
                }],
                link: function($scope, element, attrs) {
                    $scope.trustBar = attrs.trustBar === 'true' ? true : false;
                    $scope.expandedOutside = attrs.expandedOutside === 'true' ? true : false;
                }
            };
        }
    );
/**
 *  Outside click close element
 */
angular
    .module('jfApp')
    .directive(
        'trustBarClickOutside',
        ['$document', '$rootScope', function(
            $document,
            $rootScope
        ) {
            'use strict';

            return {
                restrict: 'A',
                scope: {},
                link: function($scope, element, attrs) {
                    var clickHandler = function(e) {
                        if (
                            !element[0].contains(e.target) &&
                            !(
                                angular.isDefined(document.querySelectorAll('.jf-trust-bar-switcher-button')[0]) &&
                                document.querySelectorAll('.jf-trust-bar-switcher-button')[0].contains(e.target)
                            ) &&
                            !(
                                angular.isDefined(document.querySelectorAll('.jf-trust-bar-switcher-button')[1]) &&
                                document.querySelectorAll('.jf-trust-bar-switcher-button')[1].contains(e.target)
                            ) &&
                            !(
                                angular.isDefined(document.querySelectorAll('md-virtual-repeat-container')[0]) &&
                                document.querySelectorAll('md-virtual-repeat-container')[0].contains(e.target)
                            )
                        ) {
                            $rootScope.$emit(
                                'jf:closeTrustBarPopup',
                                {
                                    origin: 'outside',
                                    type: attrs.trustBarClickOutside
                                }
                            );
                        }
                    };

                    $document.on('touchstart click', clickHandler);

                    $scope.$on('$destroy', function() {
                        $document.off('touchstart click', clickHandler);
                    });
                }
            };
        }]
    );

/**
 * Language Switcher directive
 */
angular.module('jfApp')
    .directive(
        'jfLanguageSwitcher',
        ['$mdSidenav', 'LanguageFactory', function(
            $mdSidenav,
            LanguageFactory
        ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: function(element, attrs) {
                    return 'app/shared/directives/jf-language-switcher-'+ attrs.origin +'.html';
                },
                scope: {
                    origin: '@',
                    showLanguageNav: '=',
                    mobileAppMode: '='
                },
                controller: ['$scope', function($scope) {
                    $scope.locales = LanguageFactory.getLocaleAsArray();
                    $scope.activeLocale = LanguageFactory.getActiveLocaleItem();

                    $scope.currentLanguageText = $scope.activeLocale.locale === 'de_AT' ? 'AT' : $scope.activeLocale.i18n;

                    $scope.close = function() {
                        $mdSidenav('left').close();
                    };

                    $scope.changeLocale = function(key) {
                        LanguageFactory.changeLocale(key, 'shopHeaderBar', 'languageSwitcher');
                        $scope.activeLocale = LanguageFactory.getActiveLocaleItem();
                        if ($scope.origin === 'sidenav') {
                            $scope.showLanguageNav = false;
                            $scope.close();
                        }
                    };
                }]
            };
        }]
    );
/**
 * Profile changer directive
 */
angular.module('jfApp')
    .directive(
        'jfButtonProfileChanger',
        ['AccountFactory', '$rootScope', '$timeout', '$mdMedia', '$localStorage', 'jfUser', function(
            AccountFactory,
            $rootScope,
            $timeout,
            $mdMedia,
            $localStorage,
            jfUser
        ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/shared/directives/jf-button-profile-changer.directive.html',
                scope: {
                    origin: '@',
                    color: '@',
                    showCaption: '=',
                    trustBar: '='
                },
                controller: ['$scope', function($scope) {
                    $scope.$mdMedia = $mdMedia;
                    $scope.accountSwitcher = false;
                    $scope.corporateEnabled = jfUser.get().corporateEnabled || false;
                    $scope.isCorporate = AccountFactory.isCompanyAccount();

                    $scope.showSelector = function() {
                        $scope.accountSwitcher = !$scope.accountSwitcher;

                        if ($scope.accountSwitcher) {
                            $timeout(function() {
                                $rootScope.$emit('jf:closeTrustBarPopup', { 
                                    origin: 'accountChanger', 
                                    type: 'accountSwitcher'
                                });
                            });
                        }
                    };

                    var isCorporateListener = $scope.$watch(function() { 
                        return $localStorage.catalogType; 
                    }, function(newVal, oldVal) {
                        if (oldVal !== newVal) {
                            $scope.isCorporate = AccountFactory.isCompanyAccount();
                        }
                    });

                    $rootScope.$on('jf:closeTrustBarPopup', function(e, source) {
                        if (source.origin !== 'accountChanger') {
                            $scope.accountSwitcher = false;
                        } 
                    });

                    $scope.$on('$destroy', function() {
                        isCorporateListener();
                    });
                }]
            };
        }]
    );
/**
 * Profile changer directive
 */
angular.module('jfApp')
    .directive(
        'jfButtonCatalogChanger',
        ['$rootScope', '$timeout', '$mdMedia', '$mdDialog', 'jfUser', function(
            $rootScope,
            $timeout,
            $mdMedia,
            $mdDialog,
            jfUser
        ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: 'app/shared/directives/jf-button-catalog-changer.directive.html',
                scope: {
                    origin: '@',
                    color: '@',
                    showCaption: '=',
                    trustBar: '='
                },
                controller: ['$scope', function($scope) {
                    $scope.catalogSelector = false;
                    $scope.corporateEnabled = jfUser.get().corporateEnabled || false;

                    $scope.showSelector = function() {
                        if ($mdMedia('xs')) {
                            $timeout(function() {
                                $rootScope.$emit('jf:closeTrustBarPopup', {
                                    origin: 'catalogChanger',
                                    type: 'catalogSelector'
                                });
                            });

                            $mdDialog
                                .show({
                                    template: '' +
                                    '<md-dialog class="jf-dialog jf-dialog-fullscreen">' +
                                        '<md-toolbar>' +
                                            '<div class="md-toolbar-tools">' +
                                                '<h2>{{\'CHANGE_POSTALCODE\' | translate}}</h2>' +
                                                '<a ng-click="hideDialog()"><i class="material-icons">close</i></a>' +
                                            '</div>' +
                                        '</md-toolbar>' +
                                        '<md-dialog-content>' +
                                            '<div class="md-dialog-content jf-mobile-catalog-switcher"><header-catalog-location-selector expanded-outside="true"></header-catalog-location-selector></div>' +
                                        '</md-dialog-content>' +
                                    '</md-dialog>',
                                    parent: angular.element(document.body),
                                    clickOutsideToClose: true,
                                    escapeToClose: true,
                                    controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                                        $scope.hideDialog = function() {
                                            $mdDialog.hide();
                                        };
                                    }]
                                });
                        } else {
                            $scope.catalogSelector = !$scope.catalogSelector;

                            if ($scope.catalogSelector) {
                                $timeout(function() {
                                    $rootScope.$emit('jf:closeTrustBarPopup', {
                                        origin: 'catalogChanger',
                                        type: 'catalogSelector'
                                    });
                                });
                            }
                        }
                    };

                    var closeTrustBarPopupListener = $rootScope.$on('jf:closeTrustBarPopup', function(e, source) {
                        if (source.origin !== 'catalogChanger') {
                            $scope.catalogSelector = false;
                        }
                    });

                    $scope.$on('$destroy', function () {
                        closeTrustBarPopupListener();
                    });
                }]
            };
        }]
    );
/**
 * Order items quantity changer directive
 */
angular
    .module('jfApp')
    .directive(
        'jfOrderItemQuantityChanger',
        function() {
            'use strict';

            return {
                restrict: 'E',
                template: '<div class="{{customCssClassName}}">' +
                            '<input type="number" ng-value="orderItem.attributes.quantity" name="quantity" ng-readonly="true" ng-click="inputClickHandler()" />' +
                            '<span class="material-icons" ng-if="displayEditIcon">edit</span>' +
                          '</div>',
                scope: {
                    customCssClassName: '=?',
                    displayEditIcon: '=?',
                    catalogItemPosition: '=?',
                    catalogItemCategory: '=?',
                    categoriesArr: '=?',
                    orderItem: '=',
                    mobileProductsThatAreLoading: '='
                },
                controller: ['$scope', '$filter', '$rootScope', '$mdDialog', 'SpinnerFactory', 'OrderFactory', 'jfController', function (
                    $scope,
                    $filter,
                    $rootScope,
                    $mdDialog,
                    SpinnerFactory,
                    OrderFactory,
                    jfController
                ) {
                    $scope.inputClickHandler = function() {
                        var saveQuantityChange = function(newQuantity) {
                            $scope.changeItemQuantity($scope.orderItem.id, newQuantity, $scope.orderItem.attributes.product_id);
                        };

                        $mdDialog
                            .show({
                                template: '' +
                                '<md-dialog class="jf-dialog jf-dialog-small" ng-class="{\'jf-dialog-fullscreen\': fullScreenMode}">' +
                                    '<md-toolbar>' +
                                        '<div class="md-toolbar-tools">' +
                                            '<h2>'+$filter('translate')('ORDER_ITEM_QUANTITY_CHANGE_POPUP_TITLE')+'</h2>' +
                                        '</div>' +
                                    '</md-toolbar>' +
                                    '<md-dialog-content>' +
                                        '<div class="md-dialog-content jf-text-align-center">' +
                                            '<p class="jf-quantity-change-product-name"><strong>' + $scope.orderItem.attributes.name + '</strong></p>' +
                                            '<form ng-submit="save()" class="jf-quantity-change-form">' +
                                                '<p>{{\'CHECKOUT_ITEM_QUANTITY\' | translate}}:</p>' +
                                                '<md-input-container class="jf-input-container md-block" flex>' +
                                                    '<input type="number" name="new_quantity" ng-value="currentQuantity" ng-model="popupModel.newQuantity">' +
                                                '</md-input-container>' +
                                            '</form>' +
                                        '</div>' +
                                    '</md-dialog-content>' +
                                    '<md-dialog-actions layout="column">' +
                                        '<md-button class="md-raised md-primary" ng-click="save()">'+$filter('translate')('SAVE')+'</md-button><br>' +
                                        '<md-button class="md-raised" ng-click="cancelAction()">'+$filter('translate')('CANCEL')+'</md-button>' +
                                    '</md-dialog-actions>' +
                                '</md-dialog>',
                                parent: angular.element(document.body),
                                clickOutsideToClose: true,
                                escapeToClose: true,
                                locals: {
                                    currentQuantity: $scope.orderItem.attributes.quantity
                                },
                                controller: ['$scope', '$mdDialog', 'currentQuantity', function($scope, $mdDialog, currentQuantity) {
                                    $scope.currentQuantity = currentQuantity;
                                    $scope.popupModel = {
                                        newQuantity: currentQuantity
                                    };

                                    $scope.save = function() {
                                        $mdDialog.hide();
                                        saveQuantityChange($scope.popupModel.newQuantity);
                                    };
                                    $scope.cancelAction = function() {
                                        $mdDialog.hide();
                                    };
                                }],
                                onComplete: function() {
                                    document.querySelector('.md-dialog-content .jf-quantity-change-form input[name="new_quantity"]').focus();
                                }
                            });
                    };

                    $scope.changeItemQuantity = function(orderItemId, newQuantity, productId) {
                        if (newQuantity !== null && newQuantity !== $scope.orderItem.attributes.quantity) {
                            if (newQuantity === 0) {
                                $scope.triggerOrderItemDelete(orderItemId, productId);
                            } else if (newQuantity < 1) {
                                $scope.triggerQuantityChange(orderItemId, 1, productId);
                            } else if (newQuantity > 500) {
                                $scope.triggerQuantityChange(orderItemId, 500, productId);
                            } else {
                                $scope.triggerQuantityChange(orderItemId, newQuantity, productId);
                            }
                        }
                    };

                    $scope.triggerOrderItemDelete = function(orderItemId, productId) {
                        if ($scope.catalogItemPosition) {
                            $scope.mobileProductsThatAreLoading.push(productId);
                        } else {
                            SpinnerFactory.set('cart');
                        }

                        $scope.updateInProgress = true;

                        OrderFactory
                            .deleteItemFromOrder(orderItemId, $scope.orderItem.attributes.product_id)
                            .then(function() {
                                if ($scope.catalogItemPosition) {
                                    $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);
                                } else {
                                    SpinnerFactory.unset('cart');
                                }

                                $scope.updateInProgress = false;
                            }, function(err) {
                                if ($scope.catalogItemPosition) {
                                    $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);
                                } else {
                                    SpinnerFactory.unset('cart');
                                }

                                $scope.updateInProgress = false;

                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.triggerQuantityChange = function(orderItemId, newQuantity, productId) {
                        if ($scope.catalogItemPosition) {
                            $scope.mobileProductsThatAreLoading.push(productId);
                        } else {
                            SpinnerFactory.set('cart');
                        }

                        $scope.updateInProgress = true;

                        OrderFactory
                            .changeOrderItemQuantity(orderItemId, newQuantity)
                            .then(function() {
                                if ($scope.catalogItemPosition) {
                                    $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);
                                } else {
                                    SpinnerFactory.unset('cart');
                                }

                                $scope.updateInProgress = false;
                            }, function(err) {
                                if ($scope.catalogItemPosition) {
                                    $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);
                                } else {
                                    SpinnerFactory.unset('cart');
                                }

                                $scope.updateInProgress = false;

                                $rootScope.$emit('app-error', {err: err});
                            });
                    };

                    $scope.initOrderItemQuantityChangerView = function() {
                        $scope.updateInProgress = false;
                    };

                    jfController.init(['initOrderItemQuantityChangerView'], $scope);
                }]
            };
        }
    );

/**
 * Base controller
 */
angular.module('jfApp')
    .controller(
        'BaseController',
        ['$scope', '$rootScope', '$state', '$window', '$localStorage', '$location', '$cookies', '$mdMedia', '$mdDialog', '$translate', '$transitions', 'JF_CONFIG', 'JF_GA', 'ProductsFactory', 'AccountFactory', 'AccountCustomerFactory', 'SpinnerFactory', 'OrderFactory', 'CustomerAppHelpersFactory', 'AccountUserProfileFactory', 'LanguageFactory', 'jfUser', 'jfHelper', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $window,
            $localStorage,
            $location,
            $cookies,
            $mdMedia,
            $mdDialog,
            $translate,
            $transitions,
            JF_CONFIG,
            JF_GA,
            ProductsFactory,
            AccountFactory,
            AccountCustomerFactory,
            SpinnerFactory,
            OrderFactory,
            CustomerAppHelpersFactory,
            AccountUserProfileFactory,
            LanguageFactory,
            jfUser,
            jfHelper,
            jfController
        ) {
            'use strict';

            $rootScope.androidAppUpdatePopupVisible = false;

            $rootScope.sendGAEvent = function(section, element) {
                if (angular.isDefined(JF_GA.events[section]) && angular.isDefined(JF_GA.events[section][element])) {
                    $window.dataLayer.push({
                        event: JF_GA.customEventName,
                        gaEventCategory: JF_GA.events[section][element].category,
                        gaEventAction: JF_GA.events[section][element].action,
                        gaEventLabel: JF_GA.events[section][element].label || null,
                        gaEventValue: JF_GA.events[section][element].value || null
                    });
                    $window.dataLayer.push({
                        event: JF_GA.ga4CustomEventName,
                        ga4EventCategory: JF_GA.events[section][element].category,
                        ga4EventAction: JF_GA.events[section][element].action,
                        ga4EventLabel: JF_GA.events[section][element].label || null,
                        ga4EventValue: JF_GA.events[section][element].value || null
                    });

                    if (
                        angular.isDefined($window.device) &&
                        angular.isDefined($window.cordova) &&
                        angular.isDefined($window.cordova.plugins) &&
                        angular.isDefined($window.cordova.plugins.firebase) &&
                        $rootScope.mobileTrackingPermissionGranted
                    ) {
                        $window.cordova.plugins.firebase.analytics.logEvent(JF_GA.ga4CustomEventName, {
                            ga4EventCategory: JF_GA.events[section][element].category,
                            ga4EventAction: JF_GA.events[section][element].action,
                            ga4EventLabel: JF_GA.events[section][element].label || null,
                            ga4EventValue: JF_GA.events[section][element].value || null
                        });
                    }
                }
            };

            $rootScope.sendCustomGAEvent = function(category, action, label, value) {
                $window.dataLayer.push({
                    event: JF_GA.customEventName,
                    gaEventCategory: category || null,
                    gaEventAction: action || null,
                    gaEventLabel: label || null,
                    gaEventValue: value || null
                });
                $window.dataLayer.push({
                    event: JF_GA.ga4CustomEventName,
                    ga4EventCategory: category || null,
                    ga4EventAction: action || null,
                    ga4EventLabel: label || null,
                    ga4EventValue: value || null
                });

                if (
                    angular.isDefined($window.device) &&
                    angular.isDefined($window.cordova) &&
                    angular.isDefined($window.cordova.plugins) &&
                    angular.isDefined($window.cordova.plugins.firebase) &&
                    $rootScope.mobileTrackingPermissionGranted
                ) {
                    $window.cordova.plugins.firebase.analytics.logEvent(JF_GA.ga4CustomEventName, {
                        ga4EventCategory: category || null,
                        ga4EventAction: action || null,
                        ga4EventLabel: label || null,
                        ga4EventValue: value || null
                    });
                }
            };

            $scope.checkAppMode = function(transition, notRestricted, targetStateName) {
                if ($rootScope.mobileAppMode === true) {
                    if (angular.isUndefined($localStorage.catalogLocation) && targetStateName !== 'location-picker') {
                        if (
                            (notRestricted !== true && !jfUser.isLoggedIn()) ||
                            (targetStateName === 'home' && $localStorage.intro === 1 ) ||
                            targetStateName === 'products'
                        ) {
                            transition.abort();
                            $state.go('location-picker');
                        } else {
                            if (
                                notRestricted &&
                                jfUser.isLoggedIn() &&
                                targetStateName !== 'logout' &&
                                targetStateName !== 'password_reset'
                            ) {
                                transition.abort();
                                $state.go('products', {'#': 'c0'});
                            }
                        }
                    } else if (targetStateName === 'home') {
                        transition.abort();
                        $state.go('products', {'#': 'c0'});
                    } else if (targetStateName === 'checkout' && !jfUser.isLoggedIn()) {
                        transition.abort();
                        $state.go('login', {checkoutRedirect: true});
                    } else {
                        if (
                            notRestricted &&
                            jfUser.isLoggedIn() &&
                            targetStateName !== 'logout' &&
                            targetStateName !== 'password_reset'
                        ) {
                            transition.abort();
                            $state.go('products', {'#': 'c0'});
                        }
                    }
                } else {
                    if (targetStateName === 'home') {
                        transition.abort();
                        $state.go('products', {'#': 'c0'});
                    } else if (targetStateName === 'checkout' && !jfUser.isLoggedIn()) {
                        transition.abort();

                        if (angular.isDefined($location.search().payload) && $location.search().payload !== null) {
                            var errObj = {
                                msg: 'User not logged in!',
                                currentUrl: $window.location.href
                            };

                            if (
                                angular.isDefined($localStorage.order) &&
                                $localStorage.order !== null &&
                                angular.isDefined($localStorage.order.details) &&
                                $localStorage.order.details !== null
                            ) {
                                errObj.orderId = $localStorage.order.details.id;
                            }

                            $rootScope.$emit(
                                'app-error',
                                {
                                    err: errObj,
                                    silent: true
                                }
                            );
                        }

                        $state.go('login', { redirect: '/checkout/' });
                    } else if (
                        !$rootScope.mobileAppMode &&
                        notRestricted &&
                        jfUser.isLoggedIn() &&
                        targetStateName !== 'logout' &&
                        targetStateName !== 'password_reset'
                    ) {
                        transition.abort();

                        $state.go('products', {'#': 'c0'});
                    }
                }
            };

            $scope.initBaseView = function() {
                $scope.source = $location.search().source;

                /* jshint ignore:start */
                if ($window.jfEbs.JF_ENV === 'Production' && !jfHelper.mobileAppMode) {
                    const node = document.createElement('script');
                    node.src = '/assets/js/vendor/consent-manager.js';
                    node.type = 'text/javascript';
                    node.async = true;
                    document.getElementsByTagName('head')[0].appendChild(node);
                }
                /* jshint ignore:end */

                $rootScope.$on('show-android-app-update-popup', function() {
                    $rootScope.androidAppUpdatePopupVisible = true;

                    $mdDialog
                        .show({
                            template: '' +
                                '<md-dialog class="jf-dialog">' +
                                '<md-toolbar>' +
                                    '<div class="md-toolbar-tools">' +
                                        '<h2 translate="UPDATE_POPUP_TITLE"></h2>' +
                                    '</div>' +
                                '</md-toolbar>' +
                                '<md-dialog-content>' +
                                    '<div class="md-dialog-content" translate="UPDATE_POPUP_MSG">' +
                                    '</div>' +
                                '</md-dialog-content>' +
                                '<md-dialog-actions layout="row">' +
                                    '<md-button class="md-raised" ng-click="updateApp()" translate="UPDATE_POPUP_BUTTON"></md-button>' +
                                '</md-dialog-actions>' +
                            '</md-dialog>',
                            parent: angular.element(document.body),
                            clickOutsideToClose: false,
                            escapeToClose: false,
                            controller: ['$scope', function($scope) {
                                $scope.updateApp = function() {
                                    window.cordova.plugins.InAppUpdate.updateImmediate(
                                        function () {},
                                        function () {}
                                      );
                                };
                            }]
                        });
                });

                /**
                 * Set mobile device type
                 */
                if (jfHelper.mobileAppMode && $window.device) {
                    $rootScope.mobileOsType = $window.device.platform.toLowerCase();
                }

                /**
                 * App version monitoring
                 */
                jfHelper.appVersionMonitoring();

                /**
                 * Assign Company Details if available
                 */
                $rootScope.jfShared.companyDetails = $localStorage.companyDetails || null;

                /**
                 * Assign Catalog type if available
                 */
                $rootScope.jfShared.catalogType = $localStorage.catalogType || null;

                $scope.containsTrailingSlash = function(url) {
                    return (url[url.length - 1] === '/' || url.indexOf('/?') > -1 || url.indexOf('/#') > -1);
                };

                $scope.$on('$locationChangeStart', function(event, next, current) {
                    if ($scope.containsTrailingSlash(current) && !$scope.containsTrailingSlash(next)) {
                        event.preventDefault();
                    }
                });

                $scope.continuePageLoading = function(toState, toParams) {
                    $state.go(toState, toParams);
                };

                $transitions.onStart({}, function(transition) {
                    var toState = transition.to(),
                        toParams = transition.params('to'),
                        fromState = transition.from();

                    SpinnerFactory.init();

                    if (toState.name !== 'maintenance') {
                        if (
                            (
                                angular.isDefined($localStorage.auth) &&
                                angular.isDefined($localStorage.auth.client_ref)
                            ) ||
                            (
                                angular.isDefined($localStorage.order) &&
                                angular.isDefined($localStorage.order.details) &&
                                angular.isDefined($localStorage.order.details.attributes) &&
                                angular.isDefined($localStorage.order.details.attributes.client_ref)
                            ) ||
                            (
                                angular.isDefined($localStorage.catalogLocation) &&
                                angular.isDefined($localStorage.catalogLocation.postal_code_ref)
                            ) ||
                            (
                                angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                                angular.isDefined($localStorage.lastPrivateCatalogLocation.postal_code_ref)
                            )
                        ) {
                            transition.abort();

                            CustomerAppHelpersFactory
                                .validateJsonApiVersion()
                                .then(function() {
                                    $scope.continuePageLoading(toState, toParams);
                                }, function(err) {
                                    if (err.status === 403) {
                                        $state.go('logout');
                                    } else {
                                        $scope.continuePageLoading(toState, toParams);

                                        $rootScope.$emit('app-error', {err: err, silent: true});
                                    }
                                });
                        } else if (
                            angular.isDefined($cookies.get('jf-maintenance-last-state')) &&
                            toState.name !== 'maintenance'
                        ) {
                            transition.abort();
                            $state.go('maintenance');
                        } else if (
                            toState.name === 'products' &&
                            !ProductsFactory.locationParamsAvailable() &&
                            (
                                angular.isUndefined($localStorage.catalogLocation) ||
                                $rootScope.countObjKeys($localStorage.catalogLocation) === 0
                            ) &&
                            !(
                                $localStorage.catalogType === JF_CONFIG.accountTypes.personal &&
                                angular.isDefined($localStorage.lastPrivateCatalogLocation)
                            )
                        ) {
                            transition.abort();

                            if ($rootScope.mobileAppMode) {
                                $state.go('location-picker');
                            } else {
                                SpinnerFactory.set('global');
                                $translate('PRIVATE_CUSTOMERS_URL').then(function(translation) {
                                    $window.location.href = $rootScope.blogUrl + translation;
                                }, function(translationId) {
                                    $window.location.href = $rootScope.blogUrl + translationId;
                                });
                            }
                        } else if (CustomerAppHelpersFactory.userProfileCacheIsInvalid()) {
                            transition.abort();

                            CustomerAppHelpersFactory
                                .userProfileUpdateAndReload()
                                .then(function(userRemovedFromCompany) {
                                    jfUser.update({triggerUserProfileCacheInvalidation: false});

                                    if (angular.isDefined(userRemovedFromCompany) && userRemovedFromCompany) {
                                        $rootScope.$emit('app-log', {msg: 'User Removed from the Company and redirected to catalog page.'});
                                        $state.go('products', {'#': 'c0'});
                                    } else {
                                        $scope.continuePageLoading(toState, toParams);
                                    }
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err, silent: true});

                                    $scope.continuePageLoading(toState, toParams);
                                });
                        } else if (
                            CustomerAppHelpersFactory.companyDetailsCacheIsInvalid() ||
                            CustomerAppHelpersFactory.companyDetailsAvailable()
                        ) {
                            transition.abort();

                            AccountFactory
                                .getCompanyInformation(jfUser.get().companyId)
                                .then(function() {
                                    jfUser.update({triggerCompanyDetailsCacheInvalidation: false});

                                    $scope.continuePageLoading(toState, toParams);
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err, silent: true});

                                    $scope.continuePageLoading(toState, toParams);
                                });
                        } else if (
                            jfUser.isLoggedIn() &&
                            (
                                angular.isUndefined(jfUser.get().profileId) || jfUser.get().profileId === null
                            )
                        ) {
                            transition.abort();

                            AccountCustomerFactory
                                .get({
                                    id: jfUser.get().id,
                                    include: 'profile'
                                })
                                .$promise
                                .then(function(customer) {
                                    jfUser.update({profileId: customer.included[0].id});

                                    $scope.continuePageLoading(toState, toParams);
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err, silent: true});

                                    $scope.continuePageLoading(toState, toParams);
                                });
                        } else {
                            var mainContentContainer = angular.element(document.querySelectorAll('.jf-main-content-container'));

                            if (!fromState.params.stepBack) {
                                mainContentContainer.removeClass('jf-move-backward');
                            } else {
                                mainContentContainer.addClass('jf-move-backward');

                                // clone stateParams and remove # wrong object
                                var cloneParams = {};
                                Object.keys(toParams).forEach(function(key) {
                                    if (key !== '#') {
                                        cloneParams[key] = toParams[key];
                                    }
                                });

                                cloneParams.stepBack = false;
                                fromState.params.stepBack = false;
                                toParams = cloneParams;
                            }

                            $scope.checkAppMode(transition, toState.notRestricted, toState.name);
                        }
                    }
                });

                /**
                 * State change success listener
                 */
                $transitions.onSuccess({}, function(transition) {
                    var fromState = transition.from();

                    if (fromState.views === null) {
                        if (angular.isDefined($window.cordova) && angular.isDefined($window.cordova.getAppVersion)) {
                            $window
                                .cordova
                                .getAppVersion
                                .getVersionNumber()
                                .then(function(version) {
                                    $window.dataLayer.push({
                                        event: 'app:desktop:pageview:first',
                                        gaMobileAppVersion: version,
                                        gaMobileDeviceId: $window.device.uuid,
                                        attributes: {
                                            route: $location.path()
                                        }
                                    });

                                    if (
                                        angular.isDefined($window.device) &&
                                        angular.isDefined($window.cordova) &&
                                        angular.isDefined($window.cordova.plugins) &&
                                        angular.isDefined($window.cordova.plugins.firebase) &&
                                        $rootScope.mobileTrackingPermissionGranted
                                    ) {
                                        $translate($state.current.title).then(function(translation) {
                                            $window.cordova.plugins.firebase.analytics.setCurrentScreen(translation);
                                            $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                                        }, function(translationId) {
                                            $window.cordova.plugins.firebase.analytics.setCurrentScreen(translationId);
                                            $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                                        });
                                    }
                                }, function() {
                                    $window.dataLayer.push({
                                        event: 'app:desktop:pageview:first',
                                        attributes: {
                                            route: $location.path()
                                        }
                                    });

                                    if (
                                        angular.isDefined($window.cordova) &&
                                        angular.isDefined($window.cordova.plugins) &&
                                        angular.isDefined($window.cordova.plugins.firebase) &&
                                        $rootScope.mobileTrackingPermissionGranted
                                    ) {
                                        $translate($state.current.title).then(function(translation) {
                                            $window.cordova.plugins.firebase.analytics.setCurrentScreen(translation);
                                            $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                                        }, function(translationId) {
                                            $window.cordova.plugins.firebase.analytics.setCurrentScreen(translationId);
                                            $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                                        });
                                    }
                                });
                        } else {
                            $window.dataLayer.push({
                                event: 'app:desktop:pageview:first',
                                attributes: {
                                    route: $location.path()
                                }
                            });

                            if (
                                angular.isDefined($window.cordova) &&
                                angular.isDefined($window.cordova.plugins) &&
                                angular.isDefined($window.cordova.plugins.firebase) &&
                                $rootScope.mobileTrackingPermissionGranted
                            ) {
                                $translate($state.current.title).then(function(translation) {
                                    $window.cordova.plugins.firebase.analytics.setCurrentScreen(translation);
                                    $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                                }, function(translationId) {
                                    $window.cordova.plugins.firebase.analytics.setCurrentScreen(translationId);
                                    $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                                });
                            }
                        }
                    } else {
                        $window.dataLayer.push({
                            event: 'app:desktop:pageview',
                            attributes: {
                                route: $location.path()
                            }
                        });

                        if (
                            angular.isDefined($window.cordova) &&
                            angular.isDefined($window.cordova.plugins) &&
                            angular.isDefined($window.cordova.plugins.firebase) &&
                            $rootScope.mobileTrackingPermissionGranted
                        ) {
                            $translate($state.current.title).then(function(translation) {
                                $window.cordova.plugins.firebase.analytics.setCurrentScreen(translation);
                                $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                            }, function(translationId) {
                                $window.cordova.plugins.firebase.analytics.setCurrentScreen(translationId);
                                $window.cordova.plugins.firebase.analytics.logEvent('screen_view');
                            });
                        }
                    }

                    /**
                     * Check accepted AGB version
                     */
                    if (jfUser.isLoggedIn() && angular.isUndefined(jfUser.get().agb_version)) {
                        SpinnerFactory.set('global');

                        AccountUserProfileFactory
                            .get({
                                'filter[user_id]': jfUser.get().id
                            })
                            .$promise
                            .then(function(userProfile) {
                                SpinnerFactory.unset('global');
                                jfUser.update({ agb_version: userProfile.data[0].attributes.agb_version });
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    }

                    /**
                     * Check order age - potential fix for issue when user opens the app with very old order,
                     * which is already in different (maybe wrong) state
                     */
                    if (
                        transition.to().name &&
                        transition.to().name !== 'maintenance' &&
                        angular.isDefined($localStorage.order) &&
                        angular.isDefined($localStorage.order.details) &&
                        angular.isDefined($localStorage.order.details.id) &&
                        angular.isDefined($localStorage.order.details.attributes) &&
                        angular.isDefined($localStorage.order.details.attributes.updated_at)
                    ) {
                        var limitDate = new Date(),
                            orderLastModification = new Date($localStorage.order.details.attributes.updated_at);

                        limitDate.setDate(limitDate.getDate() - 14);

                        if (orderLastModification < limitDate) {
                            SpinnerFactory.set('global');
                            OrderFactory
                                .getOrderDetails()
                                .then(function() {
                                    SpinnerFactory.unset('global');
                                    $rootScope.$emit('app-log', {msg: 'Order refreshed because last update was more than 14 days ago. Order ID: ' + $localStorage.order.details.id});
                                }, function(err) {
                                    SpinnerFactory.unset('global');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    }
                });

                /**
                 * Token refreshed listener
                 */
                $rootScope.$on('jf:jsonApi:refresh', function() {
                    CustomerAppHelpersFactory
                        .refreshJsonApiObjects()
                        .then(function() {

                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err, silent: true});
                        });
                });

                /**
                 * Prepare locale
                 */
                var activeLocale = LanguageFactory.getActiveLocale();

                var getParams = angular.copy($location.search());
                if (angular.isDefined(getParams.locale)) {
                    $location.search('locale', null);
                    activeLocale = getParams.locale;
                }

                var userLocale = jfUser.get().id && jfUser.get().locale ? jfUser.get().locale : $localStorage.shopLocale;

                if (userLocale !== activeLocale) {
                    LanguageFactory.changeLocale(activeLocale, 'shopHeaderBar', 'languageSwitcher', true, false);
                } else {
                    LanguageFactory.use(activeLocale);

                    if (angular.isUndefined($localStorage.shopLocale)) {
                        LanguageFactory.saveLocale(activeLocale, 'shopHeaderBar', 'languageSwitcher', true, false);
                    }
                }

                // create cookie for AGB version in development mode
                if (angular.isDefined(window.jfEbs) && window.jfEbs.JF_ENV === 'Development') {
                    var agbVersion = $cookies.get('jf_agb_version_dev');
                    if (!agbVersion) {
                        $cookies.put(
                            'jf_agb_version_dev',
                            1,
                            {
                                path: '/',
                                domain: JF_CONFIG.cookies_domain,
                                samesite: 'lax',
                                secure: true
                            }
                        );
                    }
                }

                $rootScope.cwaBottomAlertEnabled = JF_CONFIG.globalBottomAlertEnabled;

                if (jfHelper.mobileAppMode) {
                    $rootScope.$on('postalCodeInputFocused', function() {
                        $rootScope.cwaBottomAlertEnabled = false;
                    });
                    $rootScope.$on('postalCodeInputBlur', function() {
                        $rootScope.cwaBottomAlertEnabled = true;
                    });
                }

                $rootScope.showGlobalBottomAlert = function() {
                    return JF_CONFIG.globalBottomAlertEnabled &&
                            !(
                                (jfHelper.mobileAppMode || $mdMedia('xs')) &&
                                ['login', 'register', 'forgot_password', 'password_reset'].indexOf($state.current.name) > -1
                            ) &&
                            ['location-picker', 'login', 'register', 'forgot_password', 'password_reset'].indexOf($state.current.name) > -1;
                };
            };

            jfController.init(['initBaseView'], $scope);
        }]
    );
/**
 * Nav controller
 */
angular
    .module('jfApp')
    .controller(
        'NavController',
        ['$rootScope', '$state', '$scope', '$mdMedia', '$mdComponentRegistry', '$translate', 'base64', 'jfHelper', 'jfUser', 'jfController', function(
            $rootScope,
            $state,
            $scope,
            $mdMedia,
            $mdComponentRegistry,
            $translate,
            base64,
            jfHelper,
            jfUser,
            jfController
        ) {
            'use strict';

            $scope.isOpen = function() {
                return false;
            };

            $scope.activateMenu = function() {
                $scope.toggle();
            };

            $scope.isStaging = function() {
                return angular.isDefined(window.jfEbs) && window.jfEbs.JF_ENV === 'Staging';

            };

            $scope.goBackActionFromNav = function() {
                if (
                    angular.isDefined($state.params.subnav) &&
                    angular.isDefined($state.params.section) &&
                    $state.params.subnav !== null
                ) {
                    $state.go($state.current.name, {section: $state.params.section, subnav: null});
                } else {
                    if ($state.current.name === 'checkout.success') {
                        $state.go('products', {'#': 'c0'});
                    } else {
                        jfHelper.goBackInHistory();
                    }
                }
            };

            $scope.redirectToCheckout = function() {
                if ($state.current.name === 'checkout.success') {
                    $state.go('products', {'#': 'c0'});
                } else {
                    $state.go('checkout');
                }
            };

            $scope.redirectToCheckoutDesktop = function() {
                $rootScope.sendGAEvent('shopHeaderBar', 'cartButton');
                $rootScope.sendGAEvent('catalogPage', 'goToCheckoutButton');

                $scope.redirectToCheckout();
            };

            $scope.redirectToCheckoutMobile = function() {
                $rootScope.$emit('jfMobileHeader:clickOnBasketIcon');
                $rootScope.sendGAEvent('shopHeaderBar', 'cartButton');
                $rootScope.sendGAEvent('catalogPage', 'goToCheckoutButton');

                $scope.redirectToCheckout();
            };

            $scope.redirectToAccount = function() {
                if ($mdMedia('gt-sm')) {
                    $state.go('account.section', {section: 'my-orders', subnav: null});
                }
                $rootScope.sendGAEvent('shopHeaderBar', 'accountButton');
            };

            $scope.initNavView = function() {
                $scope.state = $state;
                $scope.goBackInHistory = jfHelper.goBackInHistory;

                if (jfUser.isLoggedIn()) {
                    var firstName = '';

                    try {
                        firstName = base64.decode(jfUser.get().login).split('@')[0];
                    } catch(e) {
                        $rootScope.$emit('app-error', {err: {msg: e.toString()}, silent: true});
                    }

                    if (jfUser.get().firstName) {
                        try {
                            firstName = base64.decode(jfUser.get().firstName);
                        } catch(e) {
                            $rootScope.$emit('app-error', {err: {msg: e.toString()}, silent: true});
                        }
                    }

                    $scope.name = firstName;
                } else {
                    $translate('SIGN_IN')
                        .then(function (translation) {
                            $scope.name = translation + '!';
                        }, function (translationId) {
                            $scope.name = translationId;
                        });
                }

                $mdComponentRegistry
                    .when('left')
                    .then(function(sideNav) {
                        $scope.isOpen = angular.bind( sideNav, sideNav.isOpen );
                        $scope.toggle = angular.bind( sideNav, sideNav.toggle );
                    });
            };

            jfController.init(['initNavView'], $scope);
        }]
    );
/**
 * Trust bar controller
 */
angular.module('jfApp')
    .controller(
        'TrustBarController',
        ['$scope', '$rootScope', 'jfUser', 'jfController', function(
            $scope,
            $rootScope,
            jfUser,
            jfController
        ) {
            'use strict';

            $scope.initTrustBarView = function() {
                $scope.corporateEnabled = jfUser.get().corporateEnabled || false;

                var loginListener = $rootScope.$on('event:user-logged-id', function() {
                    $scope.corporateEnabled = jfUser.get().corporateEnabled || false;
                });

                $scope.$on('$destroy', function() {
                    loginListener();
                });
            };

            jfController.init(['initTrustBarView'], $scope);
        }]
    );
angular
    .module('jfApp')
    .controller(
        'SidenavController',
        ['$rootScope', '$scope', '$mdSidenav', 'jfHelper', 'ExternalRedirectsFactory', function(
            $rootScope,
            $scope,
            $mdSidenav,
            jfHelper,
            ExternalRedirectsFactory
        ) {
            'use strict';

            $scope.showLegals = false;
            $scope.showAboutUs = false;
            $scope.showLanguageNav = false;

            $scope.close = function() {
                $mdSidenav('left').close();
            };

            $scope.openExternalUrl = function(url, pageTitle) {
                if (jfHelper.mobileAppMode) {
                    url = url + '?remoteAccess=remote-access-content-only';
                }
                ExternalRedirectsFactory.openUrl(url, pageTitle);
            };

            var clickOnBasketIconListener = $rootScope.$on('jfMobileHeader:clickOnBasketIcon', function() {
                $scope.close();
            });

            $scope.$on('$destroy', function() {
                clickOnBasketIconListener();
            });
        }]
    );
/**
 * Cart controller
 */
angular
    .module('jfApp')
    .controller(
        'LaundryBasketController',
        ['$scope', '$state', '$rootScope', 'CheckoutFactory', 'jfController', function (
            $scope,
            $state,
            $rootScope,
            CheckoutFactory,
            jfController
        ) {
            'use strict';

            $scope.proceedToCheckoutMobile = function() {
                $rootScope.sendGAEvent('catalogPage', 'goToCheckoutButton');
                $rootScope.sendGAEvent('shopHeaderBar', 'cartButton');

                if ($scope.order.details.attributes.items_number === 0) {
                    $rootScope.sendGAEvent('catalogPage', 'goToCheckoutButtonNoItems');
                }

                if (CheckoutFactory.orderPassedMinOrderValue()) {
                    $state.go('checkout');
                }
            };

            $scope.initLaundryBasketView = function() {
                $scope.minOrderValue = CheckoutFactory.getMinimumOrderValue();

                /* istanbul ignore else */
                if (angular.isDefined($state.params) && $state.params.orderError) {
                    CheckoutFactory.showDialogMinOrderValue();
                }
            };

            jfController.init(['initLaundryBasketView'], $scope);
        }]
    );

/**
 * Help controller
 */
angular.module('jfApp')
    .controller(
        'HelpController',
        ['$scope', '$mdBottomSheet', '$filter', 'JF_CONFIG', 'jfUser', function(
            $scope,
            $mdBottomSheet,
            $filter,
            JF_CONFIG,
            jfUser
        ) {
            'use strict';

            $scope.callSupport = function() {
                $mdBottomSheet
                    .show(
                        {
                        template: '<md-bottom-sheet class="md-list md-has-header">' +
                            '  <md-list ng-cloak>' +
                            '    <md-list-item ng-repeat="phone in phoneNumbers">' +
                            '      <md-button\n' +
                            '          ng-click="triggerCall($index)"\n' +
                            '          class="md-list-item-content">' +
                            '        <span class="md-inline-list-icon-label">{{ phone }}</span>' +
                            '      </md-button>' +
                            '    </md-list-item>' +
                            '    <md-list-item>' +
                            '      <md-button\n' +
                            '          md-autofocus="true"' +
                            '          ng-click="closeSheet()"\n' +
                            '          class="md-list-item-content">' +
                            '        <span class="md-inline-list-icon-label" translate>CANCEL</span>' +
                            '      </md-button>' +
                            '    </md-list-item>' +
                            '  </md-list>' +
                            '</md-bottom-sheet>',
                        controller: ['$scope', function($scope) {
                            $scope.phoneNumbers = [
                                JF_CONFIG.supportPhoneNumbers.DE + ' (DE)',
                                JF_CONFIG.supportPhoneNumbers.AT + ' (AT)'
                            ];

                            $scope.triggerCall = function(index) {
                                if (index === 0) {
                                    window.open('tel:' + encodeURI(JF_CONFIG.supportPhoneNumbers.DE_dial), '_system', 'location=yes');
                                } else if (index === 1) {
                                    window.open('tel:' + encodeURI(JF_CONFIG.supportPhoneNumbers.AT_dial), '_system', 'location=yes');
                                }
                            };

                            $scope.closeSheet = function() {
                                $mdBottomSheet.hide();
                            };
                        }]
                    })
                    .then(function() {})
                    .catch(function() {});
            };

            $scope.mailSupport = function() {
                window.open('mailto:' + JF_CONFIG.supportEmail + '?subject=' +
                    $filter('translate')('EMAIL_SUPPORT_SUBJECT', {userId: jfUser.get().customerNo}), '_system');
            };
        }]
    );

/**
 * Account controller
 */
angular.module('jfApp')
    .controller(
        'AccountController',
        ['$rootScope', '$scope', '$state', '$timeout', '$localStorage', '$mdMedia', 'jfController', 'jfUser', function(
            $rootScope,
            $scope,
            $state,
            $timeout,
            $localStorage,
            $mdMedia,
            jfController,
            jfUser
        ) {
            'use strict';

            $rootScope.accountSections = {};

            $rootScope.accountSections['my-orders'] = {
                title: 'MY_ORDERS',
                summary: 'MY_ORDERS_SUMMARY',
                template: 'app/components/account/account.my-orders.html'
            };

            $rootScope.accountSections.details = {
                title: 'ACCOUNT_DETAILS',
                summary: 'ACCOUNT_DETAILS_SUMMARY',
                template: 'app/components/account/account.details.html',
                subnav: {
                    'delete-account': 'app/components/account/account.details-delete-account.html'
                }
            };

            $rootScope.accountSections['my-addresses'] = {
                title: 'MY_ADDRESSES',
                summary: 'MY_ADDRESSES_SUMMARY',
                template: 'app/components/account/account.my-addresses.html',
                subnav: {
                    'new-address' : 'app/components/account/account.my-addresses-new-address.html',
                    'edit-address' : 'app/components/account/account.my-addresses-edit-address.html'
                }
            };

            $rootScope.accountSections['payment-methods'] = {
                title: 'PAYMENT_METHODS',
                summary: 'PAYMENT_METHODS_SUMMARY',
                template: 'app/components/account/account.payment-methods.html',
                subnav: {
                    'manage-credit-cards' : 'app/components/account/account.payment-methods-manage-credit-cards.html',
                    'new': 'app/components/account/account.payment-methods-new.html'
                }
            };

            // Workaround - for some reasons on iOS, my account page, after tap on my password link it's focusing
            // on input on the next state and keyboard is open. I think it's somehow triggering a second click event
            // after some ms.
            $scope.navigateToAccountSection = function(sectionName) {
                $timeout(function() {
                    $state.transitionTo('account.section', {section: sectionName});
                }, 150);
            };

            $scope.initAccountView = function() {
                if (!jfUser.isLoggedIn()) {
                    if ($rootScope.mobileAppMode || $mdMedia('xs')) {
                        $state.go('login', { redirect: '/account/' });
                    } else {
                        $state.go('login', { redirect: '/account/my-orders/' });
                    }
                } else {
                    if (angular.isDefined($localStorage.companyDetails) && $localStorage.companyDetails !== null) {
                        $scope.companyName = $localStorage.companyDetails.name;
                    }
                }
            };

            jfController.init(['initAccountView'], $scope);
        }]
    );

/**
 * Login Form Controller
 */
angular
    .module('jfApp')
    .controller(
        'LoginFormCtrl',
        ['$scope', '$rootScope', '$state', '$filter', 'jfLogin', 'jfDialog', 'AccountFactory', 'SpinnerFactory', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $filter,
            jfLogin,
            jfDialog,
            AccountFactory,
            SpinnerFactory,
            jfController
        ) {
            'use strict';

            $scope.submitLogin = function(form) {
                $rootScope.sendGAEvent('loginPage', 'loginButton');

                if (form.$valid) {
                    SpinnerFactory.set('login-page');

                    jfLogin
                        .login($scope.user.email_address, $scope.user.password, {}, true)
                        .then(function() {
                            AccountFactory.submitLoginSuccessCallback();
                        }, function(err) {
                            SpinnerFactory.unset('login-page');

                            if (err.status === 404) {
                                if (
                                    angular.isDefined(form) &&
                                    angular.isDefined(form.email_address) &&
                                    form.email_address !== null
                                ) {
                                    form.email_address.$setValidity('notExists', false);
                                }
                            } else if (err.status === 403) {
                                if (
                                    angular.isDefined(form) &&
                                    angular.isDefined(form.password) &&
                                    form.password !== null
                                ) {
                                    form.password.$setValidity('badPassword', false);
                                }
                            } else if (err.status === 423) {
                                jfDialog
                                    .showAlert(
                                        $filter('translate')('WRONG_ACCOUNT_TYPE_TITLE'),
                                        $filter('translate')('WRONG_ACCOUNT_TYPE_CONTENT'),
                                        $filter('translate')('WRONG_ACCOUNT_TYPE_BUTTON')
                                    );
                            } else {
                                $rootScope.$emit('app-error', {err: err});
                            }
                        });
                }
            };

            $scope.navigateToRegistrationPage = function() {
                $state.go('register', { redirect: $state.params.redirect });
            };

            $scope.initLoginView = function() {
                $scope.user = {};
                $scope.blogUrl = $rootScope.blogUrl;

                if (angular.isDefined($state.params) && $state.params.password_changed) {
                    $scope.password_changed = $state.params.password_changed;
                } else {
                    $scope.password_changed = null;
                }

                $scope.account_deleted = $state.params.account_deleted;
            };

            jfController.init(['initLoginView'], $scope);
        }]
    );
/**
 * Forgotten Password Form Controller
 */
angular.module('jfApp')
    .controller(
        'ForgottenPasswordFormCtrl',
        ['$scope', '$rootScope', '$filter', 'jfJsonApi', 'jfDialog', 'LanguageFactory', 'SpinnerFactory', 'AccountCustomerPasswordForgottenOperation', 'JF_SHARED_CONFIG', function(
            $scope,
            $rootScope,
            $filter,
            jfJsonApi,
            jfDialog,
            LanguageFactory,
            SpinnerFactory,
            AccountCustomerPasswordForgottenOperation,
            JF_SHARED_CONFIG
        ) {
            'use strict';

            $scope.user = {};
            $scope.emailSent = false;

            $scope.submitForgottenPassword = function(form) {
                $rootScope.sendGAEvent('forgotPasswordPage', 'sendButton');

                if (form.$valid) {
                    SpinnerFactory.set('forgot-password-page');

                    AccountCustomerPasswordForgottenOperation
                        .save(
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.user,
                                {
                                    email: $scope.user.email_address,
                                    // locale: LanguageFactory.getActiveLocale()
                                }
                            )
                        )
                        .$promise
                        .then(function() {
                            SpinnerFactory.unset('forgot-password-page');
                            $scope.emailSent = true;
                        }, function(err) {
                            SpinnerFactory.unset('forgot-password-page');

                            if (err.status === 404 || (err.data && err.data.errors && err.data.errors.find(function(error) { return error.source.pointer === '/data/attributes/customer'; }))) {
                                $scope.emailSent = true;
                            } else if (err.status === 423) {
                                jfDialog
                                    .showAlert(
                                        $filter('translate')('WRONG_ACCOUNT_TYPE_TITLE'),
                                        $filter('translate')('WRONG_ACCOUNT_TYPE_CONTENT'),
                                        $filter('translate')('WRONG_ACCOUNT_TYPE_BUTTON')
                                    );
                            } else {
                                $rootScope.$emit('app-error', {err: err});
                            }
                        });
                }
            };
        }]);
/**
 * Password Reset Form Controller
 */
angular.module('jfApp')
    .controller(
        'PasswordResetFormCtrl',
        ['$scope', '$rootScope', '$state', '$localStorage', 'jfUser', 'jfJsonApi', 'OrderFactory', 'SpinnerFactory', 'AccountCustomerPasswordResetOperation', 'jfController', 'JF_SHARED_CONFIG', function(
            $scope,
            $rootScope,
            $state,
            $localStorage,
            jfUser,
            jfJsonApi,
            OrderFactory,
            SpinnerFactory,
            AccountCustomerPasswordResetOperation,
            jfController,
            JF_SHARED_CONFIG
        ) {
            'use strict';

            $scope.submitPasswordReset = function(form) {
                if (form.$valid) {
                    SpinnerFactory.set('password-reset-page');

                    AccountCustomerPasswordResetOperation
                        .save(
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.customers,
                                $scope.user
                            )
                        )
                        .$promise
                        .then(function(response) {
                            if (angular.isDefined(response.data.id)) {
                                $state.go('login', { password_changed: true });
                            } else {
                                SpinnerFactory.unset('password-reset-page');

                                $rootScope.$emit('app-error', {
                                    err: {
                                        status: 500,
                                        error: 'Error while resetting password.'
                                    }
                                });
                            }
                        }, function(err) {
                            SpinnerFactory.unset('password-reset-page');

                            $rootScope.$emit('app-error', {err: err});
                        });
                }
            };

            $scope.initAccountPasswordResetView = function() {
                if (!$state.params.t) {
                    $state.go('forgot_password');
                } else {
                    if (jfUser.isLoggedIn()) {
                        jfUser.logout();

                        delete $localStorage.catalogLocation;
                        delete $rootScope.jfShared.checkout;

                        OrderFactory.createEmptyOrderObject();

                        $scope.user = {};
                        $scope.user.password_reset_token = $state.params.t;
                    } else {
                        $scope.user = {};
                        $scope.user.password_reset_token = $state.params.t;
                    }
                }
            };

            jfController.init(['initAccountPasswordResetView'], $scope);
        }]);
/**
 * Account details Controller
 */
angular.module('jfApp')
    .controller(
        'AccountDetailsCtrl',
        ['$scope', '$state', 'jfUser', 'jfController', function(
            $scope,
            $state,
            jfUser,
            jfController
        ) {
            'use strict';

            $scope.initAccountDetailsView = function() {
                $scope.activeTab = $state.params.activeTab || 0;
                $scope.customerNumber = angular.isDefined(jfUser.get().customerNo) ? jfUser.get().customerNo : null;
            };

            jfController.init(['initAccountDetailsView'], $scope);
        }]
    );
/**
 * Account my addresses Controller
 */
angular.module('jfApp')
    .controller(
        'AccountMyAddressesCtrl',
        ['$scope', '$rootScope', '$state', '$q', '$localStorage', '$mdToast', 'jfJsonApi', 'AccountAddressesFactory', 'AccountUserProfileFactory', '$filter', 'OrderFactory', 'SpinnerFactory', 'jfDialog', 'CheckoutFactory', 'jfController', 'jfUser', 'JF_CONFIG', 'JF_SHARED_CONFIG', function(
            $scope,
            $rootScope,
            $state,
            $q,
            $localStorage,
            $mdToast,
            jfJsonApi,
            AccountAddressesFactory,
            AccountUserProfileFactory,
            $filter,
            OrderFactory,
            SpinnerFactory,
            jfDialog,
            CheckoutFactory,
            jfController,
            jfUser,
            JF_CONFIG,
            JF_SHARED_CONFIG
        ) {
            'use strict';

            $scope.addresses = {};

            $scope.delete = function(addressId) {
                jfDialog
                    .showConfirm(
                        $filter('translate')('DELETE_ADDRESS_TITLE'),
                        $filter('translate')('DELETE_ADDRESS_CONTENT'),
                        $filter('translate')('DELETE_ADDRESS_OK'),
                        $filter('translate')('DELETE_ADDRESS_CANCEL'),
                        function() {
                            SpinnerFactory.set('account-my-addresses');

                            AccountAddressesFactory
                                .remove({
                                    id: jfUser.get().id,
                                    addressId: addressId
                                })
                                .$promise
                                .then(function() {
                                    $scope
                                        .getAddresses()
                                        .then(function(addresses) {
                                            $scope.addresses = {};

                                            angular.forEach(addresses, function(address) {
                                                $scope.addresses[address.id] = address;
                                            });

                                            $scope
                                                .deletePreferredAddress(addressId, addresses)
                                                .then(function() {
                                                    $scope.deletePreferredAddressCallback($scope.addresses, addressId);
                                                }, function(err) {
                                                    SpinnerFactory.unset('account-my-addresses');
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        }, function(err) {
                                            SpinnerFactory.unset('account-my-addresses');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }, function(err) {
                                    SpinnerFactory.unset('account-my-addresses');

                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }
                    );
            };

            $scope.deletePreferredAddressCallback = function(userAddresses, addressId) {
                var dataToUpdate = {},
                    addressToSave;

                if (
                    angular.isDefined($localStorage.order.details.id) &&
                    $localStorage.order.details.attributes.pickup_address !== null &&
                    CheckoutFactory.shouldClearPickupTimeSlot(userAddresses, $localStorage.order.details.attributes.pickup_address.resource_id)
                ) {
                    dataToUpdate.pickup_start_ts = null;
                    dataToUpdate.pickup_end_ts = null;
                    dataToUpdate.delivery_start_ts = null;
                    dataToUpdate.delivery_end_ts = null;
                } else if (
                    angular.isDefined($localStorage.order.details.id) &&
                    $localStorage.order.details.attributes.delivery_address !== null &&
                    CheckoutFactory.shouldClearDeliveryTimeSlot(userAddresses, $localStorage.order.details.attributes.delivery_address.resource_id)
                ) {
                    dataToUpdate.delivery_start_ts = null;
                    dataToUpdate.delivery_end_ts = null;
                }

                if (
                    angular.isDefined($localStorage.order.details.id) &&
                    $localStorage.order.details.attributes.pickup_address !== null &&
                    $localStorage.order.details.attributes.pickup_address.resource_id === addressId
                ) {
                    if (angular.isDefined($localStorage.catalogLocation)) {
                        addressToSave = angular.copy($localStorage.catalogLocation);
                        addressToSave.addressable_type = $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company';

                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                        dataToUpdate.pickup_address = addressToSave;
                    }

                    dataToUpdate.payment_method_id_destroy = true;
                }

                if (
                    angular.isDefined($localStorage.order.details.id) &&
                    $localStorage.order.details.attributes.delivery_address !== null &&
                    $localStorage.order.details.attributes.delivery_address.resource_id === addressId
                ) {
                    if (angular.isDefined($localStorage.catalogLocation)) {
                        addressToSave = angular.copy($localStorage.catalogLocation);
                        addressToSave.addressable_type = $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company';

                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                        dataToUpdate.delivery_address = addressToSave;
                    }

                    dataToUpdate.payment_method_id_destroy = true;
                }

                if (
                    angular.isDefined($localStorage.order.details.id) &&
                    $localStorage.order.details.attributes.billing_address !== null &&
                    $localStorage.order.details.attributes.billing_address.resource_id === addressId
                ) {
                    dataToUpdate.billing_address = { _destroy: true };
                }

                if ($rootScope.countObjKeys(dataToUpdate) > 0 && angular.isDefined($localStorage.order.details.id)) {
                    OrderFactory
                        .updateOrder(
                            $localStorage.order.details.id,
                            dataToUpdate
                        )
                        .then(function() {
                            SpinnerFactory.unset('account-my-addresses');
                            $mdToast.show($mdToast.simple().textContent($filter('translate')('ADDRESS_DELETED')));
                        }, function(err) {
                            SpinnerFactory.unset('account-my-addresses');
                            $rootScope.$emit('app-error', {err: err});
                        });
                } else {
                    SpinnerFactory.unset('account-my-addresses');
                    $mdToast.show($mdToast.simple().textContent($filter('translate')('ADDRESS_DELETED')));
                }
            };

            $scope.getAddresses = function() {
                var deferred = $q.defer();

                AccountAddressesFactory
                    .get({
                        'filter[addressable_id]': jfUser.get().id,
                        'filter[addressable_type]': 'Customer'
                    })
                    .$promise
                    .then(function(result) {
                        deferred.resolve(result.data);
                    }, function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            };

            $scope.deletePreferredAddress = function(addressId, availableAddresses) {
                var deferred = $q.defer(),
                    preferredAddressesToUpdate = {},
                    userUpdate = {};

                $scope.prepareUserPreferredAddressesToDelete(addressId, userUpdate, preferredAddressesToUpdate, availableAddresses);

                if ($rootScope.countObjKeys(preferredAddressesToUpdate) > 0) {
                    AccountUserProfileFactory
                        .update(
                            { id: jfUser.get().profileId },
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.profile,
                                preferredAddressesToUpdate,
                                { id: jfUser.get().profileId }
                            )
                        )
                        .$promise
                        .then(function() {
                            jfUser.update(userUpdate);

                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            };

            $scope.prepareUserPreferredAddressesToDelete = function(addressId, userUpdate, preferredAddressesToUpdate, availableAddresses) {
                var serviceAddresses = [],
                    invoiceAddresses = [];

                angular.forEach(availableAddresses, function(address) {
                    if (address.type === JF_CONFIG.addressTypes.service) {
                        serviceAddresses.push(address);
                    } else {
                        invoiceAddresses.push(address);
                    }
                });

                if (addressId === jfUser.get().ppid) {
                    if (serviceAddresses.length > 0) {
                        preferredAddressesToUpdate.pickup_address_id = serviceAddresses[0].id;
                        userUpdate.ppid = serviceAddresses[0].id;
                    } else {
                        preferredAddressesToUpdate.pickup_address_id = null;
                        userUpdate.ppid = null;
                    }
                }
                if (addressId === jfUser.get().pdid) {
                    if (serviceAddresses.length > 0) {
                        preferredAddressesToUpdate.delivery_address_id = serviceAddresses[0].id;
                        userUpdate.pdid = serviceAddresses[0].id;
                    } else {
                        preferredAddressesToUpdate.delivery_address_id = null;
                        userUpdate.pdid = null;
                    }
                }
                if (addressId === jfUser.get().pbid) {
                    if (invoiceAddresses.length > 0) {
                        preferredAddressesToUpdate.billing_address_id = invoiceAddresses[0].id;
                        userUpdate.pbid = invoiceAddresses[0].id;
                    } else if (serviceAddresses.length > 0) {
                        preferredAddressesToUpdate.billing_address_id = serviceAddresses[0].id;
                        userUpdate.pbid = serviceAddresses[0].id;
                    } else {
                        preferredAddressesToUpdate.billing_address_id = null;
                        userUpdate.pbid = null;
                    }
                }
            };

            $scope.addressAdded = function() {
                $state.go('account.section', {section: 'my-addresses', subnav: null}, {reload: true});
            };

            $scope.submitAddressPreferences = function(form) {
                if (form.$valid) {
                    SpinnerFactory.set('account-my-addresses');

                    AccountUserProfileFactory
                        .update(
                            { id: jfUser.get().profileId },
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.profile,
                                {
                                    pickup_note: $scope.addressPreferences.pickup_notes ? $scope.addressPreferences.pickup_notes : null,
                                    delivery_note: $scope.addressPreferences.delivery_notes ? $scope.addressPreferences.delivery_notes : null,
                                    special_instructions: $scope.addressPreferences.special_instructions ? $scope.addressPreferences.special_instructions : null,
                                    newsletter: $scope.addressPreferences.newsletter ? $scope.addressPreferences.newsletter : false,
                                    trip_notification_email: $scope.addressPreferences.trip_notification ? $scope.addressPreferences.trip_notification : false
                                },
                                { id: jfUser.get().profileId }
                            )
                        )
                        .$promise
                        .then(function() {
                            SpinnerFactory.unset('account-my-addresses');

                            jfUser.update({
                                newsletter: $scope.addressPreferences.newsletter,
                                trip_notification: $scope.addressPreferences.trip_notification
                            });

                            $localStorage.order.additionalInfo.newsletter = $scope.addressPreferences.newsletter;
                            $rootScope.order.additionalInfo.newsletter = $scope.addressPreferences.newsletter;

                            $mdToast.show($mdToast.simple().textContent($filter('translate')('PREFERENCES_SAVED')));
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });
                }
            };

            $scope.initAccountMyAddressesView = function() {
                $scope.addressPreferences = {};

                SpinnerFactory.set('account-my-addresses');

                AccountUserProfileFactory
                    .get({
                        'filter[user_id]': jfUser.get().id
                    })
                    .$promise
                    .then(function(userProfile) {
                        $scope.addressPreferences.pickup_notes = userProfile.data[0].attributes.pickup_note;
                        $scope.addressPreferences.delivery_notes = userProfile.data[0].attributes.delivery_note;
                        $scope.addressPreferences.special_instructions = userProfile.data[0].attributes.special_instructions;
                        $scope.addressPreferences.newsletter = userProfile.data[0].attributes.newsletter;
                        $scope.addressPreferences.trip_notification = userProfile.data[0].attributes.trip_notification_email;

                        if (angular.isDefined(jfUser.get().id)) {
                            $scope
                                .getAddresses()
                                .then(function(addresses) {
                                    SpinnerFactory.unset('account-my-addresses');

                                    $scope.addresses = addresses;
                                }, function(err) {
                                    SpinnerFactory.unset('account-my-addresses');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            SpinnerFactory.unset('account-my-addresses');
                        }
                    }, function(err) {
                        SpinnerFactory.unset('account-my-addresses');
                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            jfController.init(['initAccountMyAddressesView'], $scope);
        }]
    );

/**
 * Account my orders Controller
 */
angular.module('jfApp')
    .controller(
        'AccountMyOrdersCtrl',
        ['$scope', '$state', 'jfController', function(
            $scope,
            $state,
            jfController
        ) {
            'use strict';

            $scope.initAccountMyOrdersView = function() {
                $scope.activeTab = $state.params.activeTab || 0;
            };

            jfController.init(['initAccountMyOrdersView'], $scope);
        }]
    );
/**
 * Account logout Controller
 */
angular.module('jfApp')
    .controller(
        'LogoutController',
        ['$scope', '$rootScope', '$state', '$window', 'jfController', '$localStorage', '$timeout', 'jfUser', 'jfToken', 'JF_CONFIG', 'ProductsFactory', 'OrderFactory', function(
            $scope,
            $rootScope,
            $state,
            $window,
            jfController,
            $localStorage,
            $timeout,
            jfUser,
            jfToken,
            JF_CONFIG,
            ProductsFactory,
            OrderFactory
        ) {
            'use strict';

            $scope.gotoLogin = function() {
                $state.go('login');
            };

            $scope.initLogoutView = function() {
                jfUser.logout();

                if (angular.isDefined($window.Sentry)) {
                    $window.Sentry.configureScope(function(scope) {
                        scope.clear();
                    });
                }

                delete $localStorage.catalogLocation;
                delete $localStorage.lastPrivateCatalogLocation;
                delete $localStorage.companyDetails;
                ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);
                delete $rootScope.jfShared.checkout;
                delete $rootScope.jfShared.companyDetails;

                OrderFactory.createEmptyOrderObject();
                OrderFactory.setCookieWithCartItems(0);

                $scope.showLoginButton = false;

                $timeout(function() {
                    $scope.showLoginButton = true;
                }, 5000);

                delete $localStorage.auth;

                if (angular.isUndefined($localStorage.auth)) {
                    jfToken
                        .getToken()
                        .then(function() {
                            $state.go('login', $state.params);
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });
                } else {
                    $state.go('login', $state.params);
                }
            };

            jfController.init(['initLogoutView'], $scope);
        }]
    );
/**
 * Account Register Controller
 */
angular.module('jfApp')
    .controller(
        'AccountRegisterCtrl',
        ['$scope', '$rootScope', '$state', '$window', '$location', 'JF_CONFIG', 'jfUser', 'base64', 'ProductsFactory', 'AccountRegisterFormFactory', 'AccountFactory', 'OrderFactory', 'SpinnerFactory', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $window,
            $location,
            JF_CONFIG,
            jfUser,
            base64,
            ProductsFactory,
            AccountRegisterFormFactory,
            AccountFactory,
            OrderFactory,
            SpinnerFactory,
            jfController
        ) {
            'use strict';

            $scope.submitRegistration = function(form) {
                $rootScope.sendGAEvent('registerPage', 'registerButton');

                form.$setSubmitted();

                if (form.$valid) {
                    SpinnerFactory.set('register-page');

                    AccountRegisterFormFactory
                        .registerUser($scope.registerFormData)
                        .then(function(registeredUserData) {
                            $scope.registerSuccessCallback(registeredUserData);
                        }, function(err) {
                            SpinnerFactory.unset('register-page');
                            $scope.registerErrorCallback(err, form);
                        });
                }
            };

            $scope.registerSuccessCallback = function(registeredUserData) {
                if ($rootScope.mobileAppMode && $state.params.checkoutRedirect) {
                    ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);

                    if (angular.isDefined($state.params.redirect) && $state.params.redirect !== null) {
                        if ($state.params.redirect.indexOf('https') > -1) {
                            $window.location = $state.params.redirect;
                        } else {
                            $location.path($state.params.redirect);
                        }
                    } else {
                        $state.go('checkout');
                    }
                } else {
                    if ($scope.registerFormData.corporate_code && $scope.registerFormData.corporate_code !== null) {
                        jfUser.update({
                            corporateCode: base64.encode($scope.registerFormData.corporate_code),
                            companyId: registeredUserData.newUserDetails.data.relationships.company.data.id
                        });

                        ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.company);

                        AccountFactory
                            .fetchUserCompanyAddresses(registeredUserData.newUserDetails.data.relationships.company.data.id, 'ServiceAddress')
                            .then(function(companyAddresses) {
                                if ($rootScope.countObjKeys(companyAddresses) > 1) {
                                    $state.go('on-boarding');
                                } else {
                                    var location = companyAddresses[Object.keys(companyAddresses)[0]];
                                    AccountFactory
                                        .submitCompanyAccountPreferences(companyAddresses, location, null)
                                        .then(function() {
                                            var addressToSave = {};
                                            addressToSave = location.attributes;
                                            addressToSave.id = location.id;
                                            addressToSave.type = JF_CONFIG.addressTypes.service;
                                            OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                            OrderFactory
                                                .createNewOrder({
                                                    company_id: registeredUserData.newUserDetails.data.relationships.company.data.id,
                                                    pickup_address: addressToSave,
                                                    delivery_address: addressToSave
                                                })
                                                .then(function() {
                                                    $state.go('products', {'#': 'c0'});
                                                }, function(err) {
                                                    SpinnerFactory.unset('register-page');
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        }, function(err) {
                                            SpinnerFactory.unset('register-page');
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            }, function(err) {
                                SpinnerFactory.unset('register-page');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    } else {
                        ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);

                        if (angular.isDefined($state.params.redirect) && $state.params.redirect !== null) {
                            if ($state.params.redirect.indexOf('https') > -1) {
                                $window.location = $state.params.redirect;
                            } else {
                                $location.path($state.params.redirect);
                            }
                        } else {
                            $state.go('products', {'#': 'c0'});
                        }
                    }
                }
            };

            $scope.registerErrorCallback = function(err, form) {
                if (err.status === 422 && err.data.errors.length > 0) {
                    angular.forEach(err.data.errors, function(error) {
                        if (error.source.pointer === '/data/attributes/email') {
                            form.email_address.$setValidity('loginAlreadyTaken', false);
                        } else if (error.source.pointer === '/data/attributes/corporate_code') {
                            form.corporate_code.$setValidity('corporateCodeInvalid', false);
                        } else {
                            $scope.registerFormErrors.push(error);
                        }
                    });
                } else {
                    $rootScope.$emit('app-error', {err: err});
                }
            };

            $scope.navigateToLoginPage = function() {
                $state.go('login', { stepBack: true });
            };

            $scope.initRegisterView = function() {
                $scope.registerFormData = {
                    corporate_code: null
                };
                var urlGetParams = angular.copy($location.search());
                if (angular.isDefined(urlGetParams.corporateCode)) {
                    $scope.registerFormData = {
                        corporate_code: urlGetParams.corporateCode
                    };
                }

                $scope.registerFormErrors = [];
                // Temporary set to true, should be set to false when FB logging will be introduced
                $scope.showRegisterForm = true;
            };

            jfController.init(['initRegisterView'], $scope);
        }]
    );
angular
  .module('jfApp')
  .controller(
      'PaymentMethodsManagerNewController',
      ['$scope', '$state', '$q', '$rootScope', 'jfController', function(
          $scope,
          $state,
          $q,
          $rootScope,
          jfController
      ) {
          'use strict';

          $scope.creditCardCancelCallback = function() {
            var deferred = $q.defer();

            $state.go('account.section', {section: 'payment-methods', subnav: null });

            deferred.resolve();

            return deferred.promise;
          };

          $scope.creditCardSaveCallback = function() {
            var deferred = $q.defer();

            $state.go('account.section', {section: 'payment-methods', subnav: null });

            deferred.resolve();

            return deferred.promise;
          };

          $scope.sepaCancelCallback = function() {
            var deferred = $q.defer();

            $state.go('account.section', {section: 'payment-methods', subnav: null });

            deferred.resolve();

            return deferred.promise;
          };

          $scope.sepaSaveCallback = function() {
            var deferred = $q.defer();

            $state.go('account.section', {section: 'payment-methods', subnav: null });

            deferred.resolve();

            return deferred.promise;
          };

          $scope.initPaymentMethodsManagerNewView = function() {
            $scope.showAdyenFrame = false;
            $scope.paymentMethod = $state.params.paymentMethod;
            $scope.locale = $state.params.paymentMethod.locale.indexOf('DE') > -1 ? 'DE' : 'AT';

            $scope.showMainCheckoutListener = $rootScope.$on(
                'jfCheckout:checkoutshowMainCheckout', function(e, data) {
                    $scope.showAdyenFrame = !data;
                }
            );
          };

          jfController.init(['initPaymentMethodsManagerNewView'], $scope);
      }]);
/**
 * Account delete account Controller
 */
 angular
    .module('jfApp')
    .controller(
        'AccountDetailsDeleteAccountCtrl',
        ['$scope', '$state', '$filter', '$q', '$rootScope', 'jfJsonApi', 'jfUser', 'jfDialog', 'SpinnerFactory', 'AccountCustomerFactory', 'JF_SHARED_CONFIG', 'AccountCustomerAnonymizeOperationsFactory', function(
            $scope,
            $state,
            $filter,
            $q,
            $rootScope,
            jfJsonApi,
            jfUser,
            jfDialog,
            SpinnerFactory,
            AccountCustomerFactory,
            JF_SHARED_CONFIG,
            AccountCustomerAnonymizeOperationsFactory
    ) {
        'use strict';

        $scope.isDeletionPossible = function() {
            var deferred = $q.defer();

            SpinnerFactory.set('delete-account');

            AccountCustomerFactory
                .get({
                    id: jfUser.get().id,
                    'fields[customers]': 'anonymize_info',
                    'extra_fields[customers]': 'anonymize_info'
                })
                .$promise
                .then(function(customer) {
                    SpinnerFactory.unset('delete-account');

                    if (
                        angular.isDefined(customer.data) &&
                        angular.isDefined(customer.data.attributes) &&
                        angular.isDefined(customer.data.attributes.anonymize_info) &&
                        customer.data.attributes.anonymize_info.anonymizable === true
                    ) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                }, function(err) {
                    SpinnerFactory.unset('delete-account');
                    $rootScope.$emit('app-error', {err: err});
                });

            return deferred.promise;
        };

        $scope.deleteAccount = function() {
            $scope
                .isDeletionPossible()
                .then(function() {
                    SpinnerFactory.set('delete-account');

                    AccountCustomerAnonymizeOperationsFactory
                        .save(
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.customer_anonymize_operations,
                                {
                                    customer_no: jfUser.get().customerNo,
                                    customer_id: jfUser.get().id
                                }
                            )
                        )
                        .$promise
                        .then(function() {
                            $state.go('logout', { account_deleted: true });
                        }, function(err) {
                            SpinnerFactory.unset('delete-account');

                            $rootScope.$emit('app-error', {err: err});
                        });
                }, function() {
                    jfDialog
                        .showAlert(
                            $filter('translate')('ACCOUNT_DELETION_NOT_POSSIBLE_HEADER'),
                            $filter('translate')('ACCOUNT_DELETION_NOT_POSSIBLE_CONTENT'),
                            $filter('translate')('ACCOUNT_DELETION_NOT_POSSIBLE_OK')
                        );
                });
        };

        $scope.cancel = function() {
            $state.go('account.section', { section: 'details', subnav: null, stepBack: true });
        };
    }]
);
/**
 * Products controller
 */
angular.module('jfApp')
    .controller(
        'ProductsController',
        ['$scope', '$rootScope', '$localStorage', '$location', '$filter', '$translate', 'JF_CONFIG', 'OrderFactory', 'ProductsFactory', 'AccountFactory', 'LanguageFactory', 'SpinnerFactory', 'jfController', 'jfDialog', 'jfConfigUrls', 'jfUser', function(
            $scope,
            $rootScope,
            $localStorage,
            $location,
            $filter,
            $translate,
            JF_CONFIG,
            OrderFactory,
            ProductsFactory,
            AccountFactory,
            LanguageFactory,
            SpinnerFactory,
            jfController,
            jfDialog,
            jfConfigUrls,
            jfUser
        ) {
            'use strict';

            $rootScope.currentDeliveryLocation = null;

            $scope.isSelected = function(tab, $first) {
                if ($location.hash() === '') {
                    $location.hash('c0');
                    $rootScope.selectedProductsTab = tab;

                    return $first;
                }

                return tab === $rootScope.selectedProductsTab;
            };

            $scope.addToOrderOnMobile = function(productId, quantity, categoryId, categoryName) {
                $rootScope.sendGAEvent('catalogPage', 'addToCartFromCatalog');

                $scope.mobileProductsThatAreLoading.push(productId);

                OrderFactory
                    .addToOrder(productId, quantity, categoryId, categoryName)
                    .then(function() {
                        $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);
                    }, function(err) {
                        $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);

                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.addToOrder = function(productId, quantity, categoryId, categoryName) {
                $rootScope.sendGAEvent('catalogPage', 'addToCartFromCatalog');

                SpinnerFactory.set('cart');

                OrderFactory
                    .addToOrder(productId, quantity, categoryId, categoryName)
                    .then(function() {
                        SpinnerFactory.unset('cart');
                    }, function(err) {
                        SpinnerFactory.unset('cart');

                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.removeFromOrder = function(productId, quantity) {
                $rootScope.sendGAEvent('catalogPage', 'removeFromCartFromCatalog');

                SpinnerFactory.set('cart');

                OrderFactory
                    .removeFromOrder(productId, quantity)
                    .then(function() {
                        SpinnerFactory.unset('cart');
                    }, function(err) {
                        SpinnerFactory.unset('cart');

                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.removeFromOrderOnMobile = function(productId, quantity) {
                $rootScope.sendGAEvent('catalogPage', 'removeFromCartFromCatalog');

                $scope.mobileProductsThatAreLoading.push(productId);

                OrderFactory
                    .removeFromOrder(productId, quantity)
                    .then(function() {
                        $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);
                    }, function(err) {
                        $scope.mobileProductsThatAreLoading.splice($scope.mobileProductsThatAreLoading.indexOf(productId), 1);

                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.loggedUser = function() {
                return jfUser.isLoggedIn();
            };

            $scope.initCatalog = function() {
                if ($rootScope.countObjKeys($localStorage.catalogLocation) > 0) {
                    $localStorage.catalogLocation.locale = LanguageFactory.getActiveLocale();
                }

                // FIX for orders wth object list items
                if (!angular.isArray($localStorage.order.items)) {
                    var items = [];
                    angular.forEach(Object.keys($localStorage.order.items), function(key) {
                        items.push($localStorage.order.items[key]);
                    });
                    items.sort(function(a, b) {
                        return a.created_at > b.created_at;
                    });
                    $localStorage.order.items = angular.copy(items);
                    $rootScope.order.items = angular.copy(items);
                    OrderFactory.updateOrderItemPositionAtProducts();
                }

                if (
                    angular.isDefined($localStorage.catalogLocation) &&
                    (
                        angular.isUndefined($localStorage.catalogLocation.postal_code_id) ||
                        $localStorage.catalogLocation.postal_code_id === null
                    )
                ) {
                    delete $localStorage.catalogLocation;
                }

                SpinnerFactory.set(['catalog', 'cart']);

                ProductsFactory
                    .initCatalog()
                    .then(function(city) {
                        $rootScope.currentDeliveryLocation = city;
                        $localStorage.currentDeliveryLocation = city;

                        SpinnerFactory.unset(['catalog', 'cart']);
                    }, function (err) {
                        SpinnerFactory.unset(['catalog', 'cart']);
                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            /**
             * Products lazy loading on mobile view
             */
            if (angular.isUndefined($rootScope.loadedProductImages)) {
                $rootScope.loadedProductImages = [];
                $rootScope.minProductImgHeight = 0;
            }

            $scope.lazyLoadImage = function(imgName, inviewInfo) {
                if ($rootScope.loadedProductImages.indexOf(imgName) === -1) {
                    $rootScope.loadedProductImages.push(imgName);

                    inviewInfo.element.bind('load', function() {
                        if ($rootScope.minProductImgHeight !== this.clientHeight) {
                            $rootScope.minProductImgHeight = this.clientHeight;
                        }
                        inviewInfo.element.css('opacity', 1);
                    });

                    inviewInfo.element.attr('src', jfConfigUrls.get('jfImagesCDN', 'customerApp') + '/' + imgName);
                } else {
                    inviewInfo.element.css('opacity', 1);
                    inviewInfo.element.attr('src', jfConfigUrls.get('jfImagesCDN', 'customerApp') + '/' + imgName);
                }
            };

            $scope.displayQuantityLabel = function(product) {
                return $filter('findInObject')($localStorage.order.items, 'price_list_entry_id', product.price_id) !== null;
            };

            $scope.hasAdditionalInfo = function(id) {
                var showInfo = false;
                angular.forEach($scope.productsWithAdditionalInfo, function(product) {
                    if (product.id === id) {
                        showInfo = true;
                    }
                });
                return showInfo;
            };

            $scope.showAdditionalInfo = function(id) {
                angular.forEach($scope.productsWithAdditionalInfo, function(product) {
                    if (product.id === id) {
                        jfDialog
                            .showAlert(
                                $translate.instant(product.title),
                                $translate.instant(product.content),
                                $translate.instant(product.button)
                            );
                    }
                });
            };

            $scope.initProductsView = function() {
                $scope.corporateEnabled = jfUser.get().corporateEnabled || false;
                $scope.isCompanyAccount = AccountFactory.isCompanyAccount();

                $scope.mobileProductsThatAreLoading = [];

                $scope.productsWithAdditionalInfo = [
                    {
                        id: '03e86c0b-966e-4684-96c9-7fdcbcb3309b',
                        title: 'WASH_AND_FOLD_STANDARD_INFO_TITLE',
                        content: 'WASH_AND_FOLD_STANDARD_INFO_TITLE_MSG',
                        button: 'WASH_AND_FOLD_STANDARD_INFO_TITLE_OK_BUTTON'
                    },
                    {
                        id: '9893e6f1-a802-4d6f-a4c3-c7f5b8f23efd',
                        title: 'WASH_AND_FOLD_SEPARATED_TITLE',
                        content: 'WASH_AND_FOLD_SEPARATED_MSG',
                        button: 'WASH_AND_FOLD_SEPARATED_OK_BUTTON'
                    }
                ];

                ProductsFactory.setCatalogType($localStorage.catalogType || JF_CONFIG.accountTypes.personal);

                if (angular.isDefined($localStorage.catalogContent) && angular.isDefined($localStorage.catalogContent.catalog)) {
                    ProductsFactory.loadSavedCatalog();
                }

                if (
                    angular.isUndefined($localStorage.catalogLocation) &&
                    angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                    $localStorage.lastPrivateCatalogLocation &&
                    angular.isDefined($localStorage.lastPrivateCatalogLocation.postal_code_id) &&
                    $localStorage.lastPrivateCatalogLocation.postal_code_id !== null
                ) {
                    ProductsFactory.setCatalogLocation($localStorage.lastPrivateCatalogLocation);
                }

                $scope.initCatalog();

                if (
                    angular.isDefined($localStorage.order.details.attributes.destroyable_order_items) &&
                    $localStorage.order.details.attributes.destroyable_order_items.length > 0 &&
                    $localStorage.order.details.attributes.delivery_address !== null &&
                    (
                        $localStorage.catalogType === JF_CONFIG.accountTypes.company && $localStorage.order.details.attributes.delivery_address.addressable_type === 'Company' ||
                        $localStorage.catalogType === JF_CONFIG.accountTypes.personal && $localStorage.order.details.attributes.delivery_address.addressable_type === 'Customer'
                    )
                ) {
                    OrderFactory.handleDestroyableOrderItems(
                        $localStorage.order.details.attributes.destroyable_order_items,
                        $localStorage.order.items
                    );
                }

                $scope.orderDestroyableItemsWatcher = $rootScope.$watch('order.details.attributes.destroyable_order_items', function(newVal, oldVal) {
                    if (angular.isDefined(oldVal) && angular.isDefined(newVal) && oldVal.length !== newVal.length && newVal.length > 0) {
                        OrderFactory.handleDestroyableOrderItems(newVal, $localStorage.order.items);
                    }
                }, true);

                $scope.$on('$destroy', function() {
                    $scope.orderDestroyableItemsWatcher();
                });
            };

            jfController.init(['initProductsView'], $scope);
        }]
    );
angular
    .module('jfApp')
    .controller(
        'LocationPickerLanguageMenuController',
        ['$scope', '$mdBottomSheet', 'LanguageFactory', function(
            $scope,
            $mdBottomSheet,
            LanguageFactory
        ) {
            'use strict';

            $scope.locales = LanguageFactory.getLocaleAsArray();
            $scope.activeLocale = LanguageFactory.getActiveLocaleItem();

            $scope.changeLocale = function(key) {
                LanguageFactory.changeLocale(key, 'shopHeaderBar', 'languageSwitcher', false);
                $scope.activeLocale = LanguageFactory.getActiveLocaleItem();
                $mdBottomSheet.hide();
            };
        }]
    );

/**
 * Location Picker controller
 */
angular.module('jfApp')
    .controller(
        'LocationPickerFormController',
        ['$scope', '$rootScope', '$localStorage', '$state', '$window', '$filter', 'JF_CONFIG', 'ProductsFactory', 'SpinnerFactory', 'OrderFactory', 'jfLocation', 'jfUser', 'jfDialog', 'jfController', function(
            $scope,
            $rootScope,
            $localStorage,
            $state,
            $window,
            $filter,
            JF_CONFIG,
            ProductsFactory,
            SpinnerFactory,
            OrderFactory,
            jfLocation,
            jfUser,
            jfDialog,
            jfController
        ) {
            'use strict';

            $scope.submitLocationPickerForm = function(form) {
                form.$submitted = true;

                if (form.$valid) {
                    if (!$scope.formModel.default_locale) {
                        $scope.formModel.default_locale = angular.isDefined(jfUser.get().locale) ?
                            jfUser.get().locale :
                            JF_CONFIG.defaultLocale;
                    }

                    $window.dataLayer.push({
                        event: 'app:mobile:zipcode:submit'
                    });

                    jfLocation
                        .postalCodeInService($scope.formModel.postal_code_id.toUpperCase(), jfUser.get().companyId)
                        .then(function(validationResult) {
                            if (validationResult.postalCodeDetails.b_levels.includes('b2c')) {
                                $scope.formModel.addressable_type = 'Customer';
                                ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.user);

                                $scope.proceedWithSaving(false);
                            } else {
                                $scope.formModel.addressable_type = 'Company';
                                ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.company);

                                $scope.proceedWithSaving(true);
                            }
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });
                }
            };

            $scope.proceedWithSaving = function(isCompany) {
                if (angular.isDefined($localStorage.catalogLocation) &&
                    Object.keys($localStorage.catalogLocation).length > 0 &&
                    $localStorage.catalogLocation.postal_code !== $scope.formModel.postal_code
                ) {
                    jfDialog
                        .showConfirm(
                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_TITLE'),
                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_CONTENT'),
                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_OK'),
                            $filter('translate')('CHECKOUT_ADDRESS_CHANGE_WARN_CANCEL'),
                            function() {
                                $scope.processUserSelection(isCompany, true);
                            }
                        );
                } else {
                    $scope.processUserSelection(isCompany, !!$localStorage.order.details.id === false);
                }
            };

            $scope.processUserSelection = function(isCompany, resetOrder) {
                SpinnerFactory.set('location-picker-page');

                if (isCompany) {
                    ProductsFactory.setCatalogLocation($scope.formModel);

                    OrderFactory
                        .resetUserOrder()
                        .then(function() {
                            SpinnerFactory.unset('location-picker-page');
                            $state.go('products', {'#': 'c0'});
                        }, function(err) {
                            SpinnerFactory.unset('location-picker-page');
                            $rootScope.$emit('app-error', {err: err});
                        });
                } else {
                    ProductsFactory.setCatalogLocation($scope.formModel);

                    if (resetOrder) {
                        OrderFactory
                            .resetUserOrder()
                            .then(function() {
                                $state.go('products', {'#': 'c0'});
                            }, function(err) {
                                SpinnerFactory.unset('location-picker-page');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    } else {
                        $state.go('products', {'#': 'c0'});
                    }
                }
            };

            $scope.initLocationPickerFormView = function() {
                $scope.formModel = {};
                $scope.selectedPostalCode = '';
                $scope.emptyCatalog = false;

                if ($rootScope.mobileAppMode === false) {
                    $state.go('products', {'#': 'c0'});
                    return;
                } else {
                    if ($state.params.emptyCatalog === true && $state.params.postalCode !== null) {
                        $scope.emptyCatalog = true;
                        $scope.selectedPostalCode = $state.params.postalCode;

                        var postalCodeWatcher = $scope.$watch('selectedPostalCode', function(newVal) {
                            if (newVal === null) {
                                postalCodeWatcher();
                                $scope.emptyCatalog = false;
                            }
                        });
                    }
                }
            };

            jfController.init(['initLocationPickerFormView'], $scope);
        }]
    );
/**
 * Location Picker controller
 */
angular.module('jfApp')
    .controller(
        'LocationPickerFooterController',
        ['$scope', '$rootScope', '$mdBottomSheet', 'LanguageFactory', function(
            $scope,
            $rootScope,
            $mdBottomSheet,
            LanguageFactory
        ) {
            'use strict';

            $scope.activeLocale = LanguageFactory.getActiveLocaleItem();
            $scope.showSwitcher = true;

            $rootScope.$on('languageSwitcherHide', function () {
                if ($rootScope.mobileAppMode) {
                    $scope.showSwitcher = false;
                }
            });

            $rootScope.$on('languageSwitcherShow', function () {
                if ($rootScope.mobileAppMode) {
                    $scope.showSwitcher = true;
                }
            });

            $scope.openLanguageSwitcher = function() {
                $mdBottomSheet.show({
                    templateUrl: 'app/components/location-picker/menu/location-picker-language-menu.html',
                    controller: 'LocationPickerLanguageMenuController'
                }).then(function() {
                    $scope.activeLocale = LanguageFactory.getActiveLocaleItem();
                }, function() {
                    return;
                });
            };
        }]
    );

/**
 * Products Toolbar controller
 */
angular.module('jfApp')
    .controller(
        'ProductsToolbarController',
        ['$scope', '$location', '$rootScope', 'jfController', function(
            $scope,
            $location,
            $rootScope,
            jfController
        ) {
            'use strict';

            $scope.setSelectedTabIndex = function() {
                $scope.selectedTabIndex = $location.hash() !== '' ? $location.hash().replace('c', '') : 0;
            };

            $scope.selectTab = function(tab, index) {
                if ($rootScope.selectedProductsTab !== tab) {
                    if (angular.isDefined($rootScope.selectedProductsTab)) {
                        $rootScope.sendGAEvent('catalogCategoriesBar', 'category' + index);
                    }

                    $location.hash('c' + index);

                    $rootScope.selectedProductsTab = tab;
                }
            };

            $scope.initProductsToolbarView = function() {
                $scope.setSelectedTabIndex();

                window.addEventListener('hashchange', function() {
                    $scope.setSelectedTabIndex();
                });
            };

            jfController.init(['initProductsToolbarView'], $scope);
        }]
    );
/**
 * Products - Tabs scroll handler directive
 */
angular.module('jfApp')
    .directive(
        'jfProductTabsScroll',
        ['$timeout', '$window', '$mdMedia', function(
            $timeout,
            $window,
            $mdMedia
        ) {
            'use strict';

            return {
                restrict: 'A',
                link: function (
                    $scope,
                    element
                ) {
                    var tabsPaginationWrapper = angular.element(element).find('md-pagination-wrapper'),
                        leftArrow = angular.element(document.querySelectorAll('.jf-tabs-hint-left')),
                        rightArrow = angular.element(document.querySelectorAll('.jf-tabs-hint-right')),
                        scrollTreshold = 50;

                    if ($mdMedia('xs')) {
                        scrollTreshold = 20;
                    }

                    if ($mdMedia('sm')) {
                        scrollTreshold = 30;
                    }

                    $scope.scrollToLeft = function() {
                        tabsPaginationWrapper.scrollLeft(tabsPaginationWrapper.scrollLeft() - 100, 500)
                            .then(
                                function() {},
                                function() {}
                            );
                    };

                    $scope.scrollToRight = function() {
                        tabsPaginationWrapper.scrollLeft(tabsPaginationWrapper.scrollLeft() + 100, 500)
                            .then(
                                function() {},
                                function() {}
                            );
                    };

                    $scope.tabsScrollHandler = function() {
                        var hideRightArrowPoint = this.scrollWidth - this.clientWidth - scrollTreshold;

                        if (this.scrollLeft >= hideRightArrowPoint) {
                            rightArrow.addClass('jf-tabs-hint-hidden');
                        } else {
                            rightArrow.removeClass('jf-tabs-hint-hidden');
                        }

                        if (this.scrollLeft < scrollTreshold) {
                            leftArrow.addClass('jf-tabs-hint-hidden');
                        } else {
                            leftArrow.removeClass('jf-tabs-hint-hidden');
                        }
                    };

                    $scope.windowResizeHandler = function() {
                        $scope.initTabsScroll();
                    };

                    $scope.initTabsScroll = function() {
                        if (
                            rightArrow.hasClass('jf-tabs-hint-hidden') &&
                            tabsPaginationWrapper[0].scrollWidth > tabsPaginationWrapper[0].clientWidth
                        ) {
                            rightArrow.removeClass('jf-tabs-hint-hidden');
                        }
                    };

                    tabsPaginationWrapper.on('scroll', $scope.tabsScrollHandler);

                    angular.element($window).on('resize', $scope.windowResizeHandler);

                    $timeout(function() {
                        $scope.initTabsScroll();
                    }, 1);

                    $scope.$on('$destroy', function() {
                        tabsPaginationWrapper.off('scroll', $scope.tabsScrollHandler);
                        angular.element($window).off('resize', $scope.windowResizeHandler);
                    });
                }
            };
        }]
    );
/**
 * Checkout step - address controller
 */
angular.module('jfApp')
    .controller(
        'CheckoutAddressController',
        ['$scope', '$rootScope', '$state', '$mdMedia', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $mdMedia,
            jfController
        ) {
            'use strict';

            $scope.addNewAddressCancelCallback = function() {
                $state.go('checkout.addresses');
            };

            $scope.addNewAddressSubmitCallback = function() {
                $state.go('checkout.addresses', {}, {reload: true});
            };

            $scope.initCheckoutAddressesStepView = function() {
                if (!$scope.editAddressForm && !$scope.newAddressForm) {
                    $state.go('checkout');
                }
            };

            jfController.init(['initCheckoutAddressesStepView'], $scope);
        }]
    );
/**
 * Checkout step - pickup/delivery controller
 */
angular.module('jfApp')
    .controller(
        'CheckoutPickupDeliveryController',
        ['$scope', '$state', '$window', '$localStorage', '$mdMedia', 'jfController', function(
            $scope,
            $state,
            $window,
            $localStorage,
            $mdMedia,
            jfController
        ) {
            'use strict';

            $scope.timesError = false;

            $scope.backToAddressStep = function() {
                $state.go('checkout.addresses');
            };

            $scope.initCheckoutPickupDeliveryView = function() {
                $scope.order = $localStorage.order;
                if (
                    $mdMedia('xs') &&
                    angular.isDefined($state.params) &&
                    !$state.params.showPickup &&
                    !$state.params.showDelivery
                ) {
                    $state.go('checkout');
                } else {
                    if (angular.isDefined($window.dataLayer)) {
                        $window.dataLayer.push({
                            event: 'app:desktop:checkout:timeSlotsStep'
                        });
                    }
                }
            };

            jfController.init(['initCheckoutPickupDeliveryView'], $scope);
        }]
    );
/**
 * Checkout step - success controller
 */
angular.module('jfApp')
    .controller(
        'CheckoutSuccessController',
        ['$scope', '$rootScope', '$state', '$filter', '$localStorage', '$window', '$q', 'base64', 'JF_CONFIG', 'jfHelper', 'jfUser', 'CheckoutFactory', 'SpinnerFactory', 'AccountFactory', 'OrderFactory', 'AccountCustomerFactory', 'LanguageFactory', 'CustomerAppHelpersFactory', 'BooksOrdersFactory', 'BooksOrdersOrderItemsFactory', 'BooksPaymentMethodsFactory', 'SurveyFactory', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $filter,
            $localStorage,
            $window,
            $q,
            base64,
            JF_CONFIG,
            jfHelper,
            jfUser,
            CheckoutFactory,
            SpinnerFactory,
            AccountFactory,
            OrderFactory,
            AccountCustomerFactory,
            LanguageFactory,
            CustomerAppHelpersFactory,
            BooksOrdersFactory,
            BooksOrdersOrderItemsFactory,
            BooksPaymentMethodsFactory,
            SurveyFactory,
            jfController
        ) {
            'use strict';

            $scope.addCalendarEvent = function(tripType) {
                SpinnerFactory.set('global');

                CheckoutFactory
                    .fetchOrderTrip($scope.commitedOrderSummary.data.attributes.logistic_order_id, tripType, true)
                    .then(function(trip) {
                        SpinnerFactory.unset('global');

                        if ($scope.mobileAppMode) {
                            var eventTitle = '',
                                eventLocation = '',
                                eventNote = '',
                                eventStart = '',
                                eventEnd = '';


                            var jcalData = $window.ICAL.parse(trip.attributes.ical_content);
                            var vcalendar = new $window.ICAL.Component(jcalData);
                            var vevent = vcalendar.getFirstSubcomponent('vevent');

                            eventTitle = vevent.getFirstPropertyValue('summary');
                            eventLocation = vevent.getFirstPropertyValue('location');
                            eventNote = vevent.getFirstPropertyValue('description');

                            var startDate = vevent.getFirstPropertyValue('dtstart');
                            var endDate = vevent.getFirstPropertyValue('dtend');

                            // Creating new date from date properties than toString because in IOS had an issue:
                            // it was adding timezone in time
                            eventStart = new Date(startDate.year, startDate.month-1, startDate.day, startDate.hour, startDate.minute, startDate.second);
                            eventEnd = new Date(endDate.year, endDate.month-1, endDate.day, endDate.hour, endDate.minute, endDate.second);

                            if (angular.isDefined($window.plugins) && angular.isDefined($window.plugins.calendar)) {
                                $window.plugins.calendar.createEventInteractively(eventTitle, eventLocation, eventNote, eventStart, eventEnd);
                            }

                        } else {
                            jfHelper.createAndDownloadFile('calendar_event.ics', 'text/calendar', trip.attributes.ical_content);
                        }
                    }, function(err) {
                        SpinnerFactory.unset('global');
                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.fetchPaymentMethod = function() {
                if (
                    $scope.commitedOrderSummary.data.payment_method_id === JF_CONFIG.paymentMethods.creditCard ||
                    $scope.commitedOrderSummary.data.payment_method_id === JF_CONFIG.paymentMethods.app
                ) {
                    var paymentDetails = CustomerAppHelpersFactory.findIncludedByType($scope.commitedOrderSummary.included, 'payments');

                    if (angular.isUndefined($rootScope.jfShared.checkout)) {
                        CheckoutFactory.setDefaultCheckoutModel();
                    }

                    if (
                        $rootScope.jfShared.checkout.userBillingAgreements.cc === null ||
                        $rootScope.jfShared.checkout.userBillingAgreements.app === null
                    ) {
                        SpinnerFactory.set('global');

                        CheckoutFactory
                            .fetchUserBillingAgreements(
                                angular.isDefined($localStorage.catalogLocation) ? $localStorage.catalogLocation.country_code : $scope.commitedOrderSummary.data.attributes.delivery_address.country_code,
                                $scope.commitedOrderSummary.data.attributes.customer_id
                            )
                            .then(function() {
                                SpinnerFactory.unset('global');

                                if ($scope.commitedOrderSummary.data.attributes.payment_method_id === JF_CONFIG.paymentMethods.app) {
                                    $scope.creditCardDetails = $filter('findInObject')($rootScope.jfShared.checkout.userBillingAgreements.app, 'id', paymentDetails.attributes.billing_agreement);
                                } else {
                                    $scope.creditCardDetails = $filter('findInObject')($rootScope.jfShared.checkout.userBillingAgreements.cc, 'id', paymentDetails.attributes.billing_agreement);
                                }

                                $scope.fetchPaymentMethod();
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err});
                            });
                    } else {
                        if ($scope.commitedOrderSummary.data.attributes.payment_method_id === JF_CONFIG.paymentMethods.app) {
                            $scope.creditCardDetails = $filter('findInObject')($rootScope.jfShared.checkout.userBillingAgreements.app, 'id', paymentDetails.attributes.billing_agreement);
                        } else {
                            $scope.creditCardDetails = $filter('findInObject')($rootScope.jfShared.checkout.userBillingAgreements.cc, 'id', paymentDetails.attributes.billing_agreement);
                        }
                    }
                } else {
                    $scope.fetchPaymentMethod();
                }
            };

            $scope.fetchPaymentMethod = function() {
                SpinnerFactory.set('global');

                BooksPaymentMethodsFactory
                    .get({
                        id: $scope.commitedOrderSummary.data.attributes.payment_method_id,
                    })
                    .$promise
                    .then(function(paymentMethod) {
                        $scope.paymentMethodName = paymentMethod.data.attributes.localized_name[LanguageFactory.getLocale()];

                        SpinnerFactory.unset('global');
                    }, function(err) {
                        SpinnerFactory.unset('global');
                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.prepareCompanyInformation = function() {
                if (
                    angular.isDefined($localStorage.companyDetails) &&
                    $localStorage.companyDetails !== null &&
                    $localStorage.companyDetails.pays_for_user === true &&
                    (AccountFactory.isCompanyAccount() || AccountFactory.isB2BAccount())
                ) {
                    $scope.companyInformation = $localStorage.companyDetails;
                }
            };

            $scope.prepareCurrentUser = function() {
                $scope.currentUser = {};

                if (angular.isDefined($rootScope.jfShared.jfUser.firstName) && $rootScope.jfShared.jfUser.firstName !== null) {
                    try {
                        $scope.currentUser.firstName = base64.decode($rootScope.jfShared.jfUser.firstName);
                    } catch(err) {
                        $scope.currentUser.firstName = $rootScope.jfShared.jfUser.firstName;
                    }

                }

                if (angular.isDefined($rootScope.jfShared.jfUser.lastName) && $rootScope.jfShared.jfUser.lastName !== null) {
                    try {
                        $scope.currentUser.lastName = base64.decode($rootScope.jfShared.jfUser.lastName);
                    } catch(err) {
                        $scope.currentUser.lastName = $rootScope.jfShared.jfUser.lastName;
                    }
                }

                if (angular.isDefined($rootScope.jfShared.jfUser.phoneNo) && $rootScope.jfShared.jfUser.phoneNo !== null) {
                    try {
                        $scope.currentUser.phoneNo = base64.decode($rootScope.jfShared.jfUser.phoneNo);
                    } catch(err) {
                        $scope.currentUser.phoneNo = $rootScope.jfShared.jfUser.phoneNo;
                    }
                }
            };

            $scope.showPickupAndDeliveryNotes = function() {
                if ($scope.commitedOrderSummary &&
                    $scope.orderCorp &&
                    angular.isDefined($scope.commitedOrderSummary.data.attributes.pickup_address) &&
                    $scope.commitedOrderSummary.data.attributes.pickup_address !== null &&
                    angular.isDefined($scope.commitedOrderSummary.data.attributes.pickup_address.customer_interaction) &&
                    !$scope.commitedOrderSummary.data.attributes.pickup_address.customer_interaction) {
                    return true;
                }
                return false;
            };

            $scope.setSurvey = function() {
                SurveyFactory.setSurvey(
                    $filter('lowercase')(base64.decode(jfUser.get().login)),
                    $scope.commitedOrderSummary.data.attributes.delivery_address.first_name,
                    $scope.commitedOrderSummary.data.attributes.delivery_address.last_name,
                    CheckoutFactory.isNewCustomer ? 'New' : 'Existing',
                    $scope.commitedOrderSummary.data.attributes.b_level,
                    $scope.commitedOrderSummary.data.attributes.pickup_address.city,
                    $scope.commitedOrderSummary.data.attributes.pickup_address.postal_code
                );
                $rootScope.$emit('jfCheckout:surveyShowModal');
            };

            $scope.initCheckoutSuccessView = function() {
                $scope.paymentMethods = JF_CONFIG.paymentMethods;
                $scope.currencySymbols = $rootScope.currencySymbols;
                $scope.orderItems = $rootScope.order.items;
                $scope.blogUrl = $rootScope.blogUrl;
                $scope.Math = $window.Math;
                $scope.mobileAppMode = $rootScope.mobileAppMode;
                $scope.deliveryType = JF_CONFIG.tripTypes.delivery;
                $scope.pickupType = JF_CONFIG.tripTypes.pickup;
                $scope.footerLoadListener = null;
                $scope.shopLocale = LanguageFactory.getLocale();

                if (angular.isDefined($localStorage.companyDetails) && $localStorage.companyDetails !== null && $localStorage.companyDetails.invoicing_fee) {
                    $scope.invoicingFee = $filter('round')($localStorage.companyDetails.invoicing_fee, 2);
                }

                if (angular.isDefined($state.params.orderId) && $state.params.orderId !== '' && $state.params.orderId !== null) {
                    try {
                        var successPageOrderId = base64.decode($state.params.orderId);
                        var regexp = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gm;

                        if (regexp.test(successPageOrderId)) {
                            SpinnerFactory.set('global');

                            BooksOrdersFactory
                            .get(
                                {
                                    id: successPageOrderId,
                                    include: 'payment'
                                }
                            )
                            .$promise
                            .then(function(order) {
                                $scope.commitedOrderSummary = order;
                                $scope.orderCorp = $scope.commitedOrderSummary.data.attributes.b_level === JF_CONFIG.orderKinds.corporate;
                                $scope.showNotes = $scope.showPickupAndDeliveryNotes();

                                if (jfUser.isLoggedIn() && jfUser.get().id === $scope.commitedOrderSummary.data.attributes.customer_id) {
                                    $scope.orderCustomerEmail = base64.decode(jfUser.get().login);
                                } else {
                                    AccountCustomerFactory
                                        .get({id: $scope.commitedOrderSummary.data.attributes.customer_id})
                                        .$promise
                                        .then(function(orderCustomer) {
                                            $scope.orderCustomerEmail = orderCustomer.data.attributes.login;
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err, silent: true});
                                        });
                                }

                                var promises = [];
                                if ($scope.orderItems.length === 0) {
                                    promises.push(
                                        BooksOrdersOrderItemsFactory
                                            .get({
                                                'filter[order_id]': successPageOrderId,
                                                'page[number]': 1,
                                                'page[size]': 999
                                            })
                                            .$promise
                                    );
                                }

                                $q.all(promises).then(function(orderItems) {
                                    if ($scope.orderItems.length === 0) {
                                        $scope.orderItems = OrderFactory.prepareOrderItems(orderItems[0].data);
                                    }

                                    SpinnerFactory.unset('global');

                                    $scope.prepareCurrentUser();
                                    $scope.fetchPaymentMethod();
                                    $scope.prepareCompanyInformation();

                                    var orderNumber = $scope.commitedOrderSummary.data.attributes.order_no;
                                    $scope.orderNumberFormatted = orderNumber.substring(0, orderNumber.length -5) + ' - ' + orderNumber.substring(orderNumber.length-5, orderNumber.length);

                                    $scope.orderSummaryModel = {
                                        details: $scope.commitedOrderSummary.data
                                    };

                                }, function(err) {
                                    if (err.status === 404){
                                        $state.go('products', {'#': 'c0'});
                                    } else {
                                        $rootScope.$emit('app-error', {err: err});
                                    }
                                });
                            }, function(err) {
                                if (err.status === 404){
                                    $state.go('products', {'#': 'c0'});
                                } else {
                                    $rootScope.$emit('app-error', {err: err});
                                }
                            });
                        } else {
                            $rootScope.$emit('app-log', {msg: 'Error trying to get the success page with invalid order ID: '+ successPageOrderId});

                            $state.go('products', {'#': 'c0'});
                        }
                    } catch (e) {
                        $state.go('products', {'#': 'c0'});
                    }

                } else {
                    $state.go('products', {'#': 'c0'});
                }

                $scope.surveyScriptLoaded = $rootScope.$on('jfCheckout:surveyScriptLoaded', $scope.setSurvey);

                $scope.$on('$destroy', function() {
                    $scope.surveyScriptLoaded();
                    if ($scope.footerLoadListener !== null) {
                        $scope.footerLoadListener();
                    }
                });
            };

            jfController.init(['initCheckoutSuccessView'], $scope);
        }]
    );
/**
 * Checkout controller
 */
angular.module('jfApp')
    .controller(
        'CheckoutController',
        ['$scope', '$rootScope', '$state', '$localStorage', '$filter', '$q', '$mdMedia', '$window', 'base64', 'CheckoutFactory', 'OrderFactory', 'ProductsFactory', 'AccountFactory', 'CustomerAppHelpersFactory', 'PaymentMethodsManagerFactory', 'SpinnerFactory', 'JF_CONFIG', 'AdyenFactory', 'jfUser', 'jfDialog', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $localStorage,
            $filter,
            $q,
            $mdMedia,
            $window,
            base64,
            CheckoutFactory,
            OrderFactory,
            ProductsFactory,
            AccountFactory,
            CustomerAppHelpersFactory,
            PaymentMethodsManagerFactory,
            SpinnerFactory,
            JF_CONFIG,
            AdyenFactory,
            jfUser,
            jfDialog,
            jfController
        ) {
            'use strict';

            $scope.isCompanyAccount = AccountFactory.isCompanyAccount;
            $scope.isCorporate = $scope.isCompanyAccount();
            $scope.landingPageUrl = $localStorage.companyDetails ? $localStorage.companyDetails.landing_page_url : undefined;
            $scope.userAcceptedCurrentAgb = CheckoutFactory.userAcceptedCurrentAgb;

            $scope.corporateEnabled = false;

            $scope.downloadAgb = function(e) {
                e.stopPropagation();

                if ($rootScope.mobileAppMode) {
                    e.preventDefault();
                    CustomerAppHelpersFactory.downloadFile($scope.legalDocuments.gtc.document_file.url, 'agb');
                }
            };

            $scope.downloadPrivacyPolicy = function(e) {
                e.stopPropagation();

                if ($rootScope.mobileAppMode) {
                    e.preventDefault();
                    CustomerAppHelpersFactory.downloadFile($scope.legalDocuments.pp.document_file.url, 'datenschutz');
                }
            };

            $scope.openNewAddressForm = function() {
                $rootScope.$emit('jfCheckout:checkoutNewAddress');
            };

            $scope.mobileOrderCommit = function() {
                $rootScope.sendGAEvent('checkoutPage', 'confirmOrderButton');

                $rootScope.$emit('jfCheckout:orderCommit');
            };

            $scope.triggerCheckoutValidation = function() {
                var deferred = $q.defer(),
                    validationResult = CheckoutFactory.validateOrder();

                $rootScope.order.additionalInfo.checkoutGeneralErrors = [];

                if (validationResult.errorsCount > 0) {
                    $rootScope.order.additionalInfo.errors = validationResult.errors;
                    $rootScope.order.additionalInfo.errorMessages = validationResult.errorMessages;
                    $rootScope.order.additionalInfo.errorsCount = validationResult.errorsCount;

                    deferred.reject();
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            };

            $scope.triggerOrderCommit = function () {
                $rootScope.order.additionalInfo.checkoutGeneralErrors = [];

                $scope
                    .triggerCheckoutValidation()
                    .then(function() {
                        CheckoutFactory.userProfileDataCheck($scope.processOrderCommit);
                    }, function() {});
            };

            $scope.processOrderCommit = function() {
                SpinnerFactory.set('global');

                CheckoutFactory
                    .commitOrder()
                    .then(function(commitedData) {
                        CheckoutFactory.finishOrderProcessing();

                        var placedOrder = angular.copy($localStorage.order.details),
                            placedOrderAdditionalInfo = angular.copy($localStorage.order.additionalInfo),
                            placedOrderItems = angular.copy($localStorage.order.items);

                        $scope.isCorporate = $scope.isCompanyAccount();
                        $state.go('checkout.success', { orderId: base64.encode(placedOrder.id) });

                        SpinnerFactory.set('global');

                        OrderFactory
                            .resetUserOrder({
                                company_id: CustomerAppHelpersFactory.getCompanyId()
                            })
                            .then(function() {
                                CheckoutFactory
                                    .saveAgbVersion(placedOrderAdditionalInfo)
                                    .then(function() {
                                        CheckoutFactory
                                            .saveUserNewsletterFlag(placedOrderAdditionalInfo)
                                            .then(function() {
                                                if (commitedData.payment) {
                                                    PaymentMethodsManagerFactory
                                                        .updateProfileWithPreferredData(placedOrder.attributes.payment_method_id, commitedData.payment.billing_agreement)
                                                        .then(function() {
                                                            SpinnerFactory.unset('global');
                                                        }, function(err) {
                                                            SpinnerFactory.unset('global');
                                                            $rootScope.$emit('app-error', {err: err});
                                                        });
                                                }
                                            }, function(err) {
                                                SpinnerFactory.unset('global');
                                                $rootScope.$emit('app-error', {err: err, silent: true});
                                            });
                                    }, function(err) {
                                        SpinnerFactory.unset('global');
                                        $rootScope.$emit('app-error', {err: err, silent: true});
                                    });
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err});
                            });

                        CheckoutFactory.trackOrder(placedOrder, placedOrderItems);
                    }, function(err) {
                        SpinnerFactory.unset('global');
                        CheckoutFactory.finishOrderProcessing();

                        // 1 - corporate flag was disabled
                        // 2 - invalid time slots
                        if (err.commitError === 1) {
                            $rootScope.$emit(
                                'app-error',
                                {
                                    err: {
                                        status: 400,
                                        error: 'Corporate flag was disabled for this user.'
                                    },
                                    silent: true
                                }
                            );

                            $scope.corporateErrorHandler();
                        } else if (err.commitError === 2) {
                            $rootScope.$emit('app-log', { msg: 'Invalid time slots error' });

                            jfDialog
                                .showAlert(
                                    $filter('translate')('INVALID_TIME_SLOTS_ERROR_TITLE'),
                                    $filter('translate')('INVALID_TIME_SLOTS_ERROR_CONTENT'),
                                    $filter('translate')('INVALID_TIME_SLOTS_ERROR_OK'),
                                    function() {
                                        SpinnerFactory.set('global');
                                        OrderFactory
                                            .updateOrder(
                                                $localStorage.order.details.id,
                                                {
                                                    pickup_start_ts: null,
                                                    pickup_end_ts: null,
                                                    delivery_start_ts: null,
                                                    delivery_end_ts: null
                                                }
                                            )
                                            .then(function() {
                                                SpinnerFactory.unset('global');
                                                $state.reload();
                                            }, function(err) {
                                                SpinnerFactory.unset('global');
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    },
                                    false
                                );
                        } else {
                            if (err.status === 422) {
                                if (
                                    angular.isDefined($localStorage.order.additionalInfo.unprocessableErrorReloadPopupShown) &&
                                    $localStorage.order.additionalInfo.unprocessableErrorReloadPopupShown === true
                                ) {
                                    $rootScope.$emit('app-error', {err: err});
                                } else {
                                    CheckoutFactory
                                        .handleUnprocessableOrderCommitErrors(err.data.errors)
                                        .then(function(handlerResult) {
                                            if (handlerResult.reportToSentry) {
                                                $rootScope.$emit('app-error', {err: err, silent: true});
                                            }

                                            if (
                                                handlerResult.retryOrderCommit === true &&
                                                angular.isUndefined($localStorage.order.additionalInfo.retryOrderCommit) ||
                                                $localStorage.order.additionalInfo.retryOrderCommit === null
                                            ) {
                                                CheckoutFactory.startOrderProcessing();

                                                OrderFactory.updateOrderAdditionalInfo({ retryOrderCommit: true });

                                                $scope.processOrderCommit();
                                            } else {
                                                if (
                                                    angular.isDefined($localStorage.order.additionalInfo.retryOrderCommit) &&
                                                    $localStorage.order.additionalInfo.retryOrderCommit !== null
                                                ) {
                                                    OrderFactory.updateOrderAdditionalInfo({ retryOrderCommit: null });
                                                }

                                                if (
                                                    angular.isDefined(handlerResult.errorsToDisplay) &&
                                                    handlerResult.errorsToDisplay.length > 0
                                                ) {
                                                    angular.forEach(handlerResult.errorsToDisplay, function(errorToDisplay) {
                                                        $rootScope.order.additionalInfo.checkoutGeneralErrors.push({ message: errorToDisplay });
                                                    });
                                                } else if (
                                                    angular.isUndefined($localStorage.order.additionalInfo.unprocessableErrorReloadPopupShown) ||
                                                    $localStorage.order.additionalInfo.unprocessableErrorReloadPopupShown === false
                                                ) {
                                                    OrderFactory.updateOrderAdditionalInfo({ unprocessableErrorReloadPopupShown: true });

                                                    jfDialog
                                                        .showAlert(
                                                            handlerResult.errorPopupContent.title,
                                                            handlerResult.errorPopupContent.message,
                                                            $filter('translate')('CHECKOUT_422_ERROR_POPUP_RELOAD_BUTTON'),
                                                            function() {
                                                                $window.location.reload();
                                                            },
                                                            false,
                                                            true,
                                                            10
                                                        );
                                                } else {
                                                    $rootScope.$emit('app-error', {err: err});
                                                }
                                            }
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            } else if (err.status === 406) {
                                SpinnerFactory.set('global');
                                OrderFactory
                                    .resetUserOrder()
                                    .then(function() {
                                        $state.go('products', {'#': 'c0'});
                                    }, function(err) {
                                        SpinnerFactory.unset('global');
                                        $rootScope.$emit('app-error', {err: err});
                                    });

                                $rootScope.$emit('app-log', {msg: err});
                            } else if (err.status === 404 || err.status === 409) {
                                OrderFactory.recreateOrder();
                                $rootScope.$emit('app-log', {msg: err});
                            } else {
                                SpinnerFactory.unset('global');
                                $rootScope.$emit('app-error', {err: err});
                            }
                        }
                    });
            };

            $scope.corporateErrorHandler = function() {
                jfDialog
                    .showAlert(
                        $filter('translate')('UNLINK_CORPORATE_USER_TITLE'),
                        $filter('translate')('UNLINK_CORPORATE_USER_CONTENT'),
                        $filter('translate')('UNLINK_CORPORATE_USER_OK'),
                        function() {
                            SpinnerFactory.set('global');
                            ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);

                            AccountFactory.deleteCompanyPreferences();

                            AccountFactory
                                .updateOrderCompanyId(null)
                                .then(function() {
                                    SpinnerFactory.unset('global');
                                    delete $localStorage.catalogLocation;

                                    ProductsFactory.redirectToProducts();
                                }, function(err) {
                                    SpinnerFactory.unset('global');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        },
                        false,
                        true
                    );
            };

            $scope.goBackToCheckoutView = function() {
                $scope.showPickup = false;
                $scope.showDelivery = false;

                $rootScope.$emit('jfOrder:update-dates');
            };

            $scope.showPickupTimetable = function() {
                $rootScope.sendGAEvent('checkoutPage', 'editPickupTimeIcon');

                if (angular.isDefined($rootScope.jfShared.checkout.userAddresses)) {
                    $scope.showPickup = true;
                }
            };

            $scope.showDeliveryTimetable = function() {
                $rootScope.sendGAEvent('checkoutPage', 'editDeliveryTimeIcon');

                if (
                    angular.isDefined($localStorage.order.details.attributes.pickup_start_time) &&
                    $localStorage.order.details.attributes.pickup_start_time !== null
                ) {
                    $scope.showDelivery = true;
                }
            };

            $scope.showPickupAndDeliveryNotes = function() {
                if ($scope.corporateEnabled &&
                    angular.isDefined($localStorage.order.details.attributes.pickup_address) &&
                    $localStorage.order.details.attributes.pickup_address !== null &&
                    angular.isDefined($localStorage.order.details.attributes.pickup_address.customer_interaction) &&
                    !$localStorage.order.details.attributes.pickup_address.customer_interaction) {
                    return false;
                }
                return true;
            };

            $scope.closePickupTimeSlotSelector = function() {
                $scope.showPickup = false;
            };

            $scope.closeDeliveryTimeSlotSelector = function() {
                $scope.showDelivery = false;
            };

            $scope.saveAgbSelection = function() {
                CheckoutFactory.saveAgbSelection();
            };

            $scope.saveInvoicingFeeSelection = CheckoutFactory.saveInvoicingFeeSelection;

            $scope.newAddressSubmitOnePageCheckoutCallback = function(savedAddress, savedPreferredAddresses) {
                if (angular.isDefined(savedAddress)) {
                    $rootScope.jfShared.checkout.userAddresses[savedAddress.id] = savedAddress;
                    $rootScope.$emit('jfCheckout:userAddressesAsArray');
                }

                $rootScope.$emit(
                    'jfCheckout:checkoutNewAddressClose',
                    {
                        newAddressSaved: angular.isDefined(savedAddress),
                        savedPreferredAddresses: angular.isDefined(savedPreferredAddresses)
                    }
                );
                $rootScope.$emit('jf:checkout:savePreferredAddressesToOrder', { addresses: savedPreferredAddresses });
            };

            $scope.editAddressSubmitOnePageCheckoutCallback = function(savedAddress) {
                if (angular.isDefined(savedAddress)) {
                    $rootScope.jfShared.checkout.userAddresses[savedAddress.id].attributes = savedAddress.attributes;
                }

                $rootScope.$emit('jfCheckout:checkoutEditAddressClose');
            };

            $scope.refreshValidationErrors = function(newVal, oldVal) {
                if (
                    JSON.stringify(newVal) !== JSON.stringify(oldVal) &&
                    angular.isDefined($rootScope.order.additionalInfo.errorsCount) &&
                    $rootScope.order.additionalInfo.errorsCount > 0
                ) {
                    var validationResult = CheckoutFactory.validateOrder();

                    if (JSON.stringify(validationResult.errors) !== JSON.stringify($rootScope.order.additionalInfo.errors)) {
                        $rootScope.order.additionalInfo.errors = validationResult.errors;
                        $rootScope.order.additionalInfo.errorMessages = validationResult.errorMessages;
                    }

                    if (JSON.stringify(validationResult.errorsCount) !== JSON.stringify($rootScope.order.additionalInfo.errorsCount)) {
                        $rootScope.order.additionalInfo.errorsCount = validationResult.errorsCount;
                    }
                }
            };

            $scope.destroyableOrderItemsHandler = function() {
                if (
                    angular.isDefined($localStorage.order.details.attributes.destroyable_order_items) &&
                    $localStorage.order.details.attributes.destroyable_order_items.length > 0 &&
                    $localStorage.order.details.attributes.delivery_address !== null &&
                    (
                        $localStorage.catalogType === JF_CONFIG.accountTypes.company && $localStorage.order.details.attributes.delivery_address.addressable_type === 'Company' ||
                        $localStorage.catalogType === JF_CONFIG.accountTypes.personal && $localStorage.order.details.attributes.delivery_address.addressable_type === 'Customer'
                    )
                ) {
                    OrderFactory.handleDestroyableOrderItems(
                        $localStorage.order.details.attributes.destroyable_order_items,
                        $localStorage.order.items
                    );
                }

                $scope.orderDestroyableItemsWatcher = $rootScope.$watch('order.details.attributes.destroyable_order_items', function(newVal, oldVal) {
                    if (angular.isDefined(oldVal) && angular.isDefined(newVal) && oldVal.length !== newVal.length && newVal.length > 0) {
                        OrderFactory.handleDestroyableOrderItems(newVal, $localStorage.order.items);
                    }
                }, true);
            };

            $scope.isLoadingCompleted = function() {
                return SpinnerFactory.isLoadingCompleted();
            };

            $scope.allAddressesSpecified = function() {
                return angular.isDefined($localStorage.order) &&
                    angular.isDefined($localStorage.order.details) &&
                    angular.isDefined($localStorage.order.details.attributes) &&
                    angular.isDefined($localStorage.order.details.attributes.pickup_address) &&
                    $localStorage.order.details.attributes.pickup_address !== null &&
                    angular.isDefined($localStorage.order.details.attributes.pickup_address.resource_id) &&
                    angular.isDefined($localStorage.order.details.attributes.delivery_address) &&
                    $localStorage.order.details.attributes.delivery_address !== null &&
                    angular.isDefined($localStorage.order.details.attributes.delivery_address.resource_id) &&
                    angular.isDefined($localStorage.order.details.attributes.billing_address) &&
                    $localStorage.order.details.attributes.billing_address !== null &&
                    angular.isDefined($localStorage.order.details.attributes.billing_address.resource_id);
            };

            $scope.isBillingAddressMissing = function() {
                return angular.isDefined($localStorage.order) &&
                    angular.isDefined($localStorage.order.details) &&
                    angular.isDefined($localStorage.order.details.attributes) &&
                    angular.isDefined($localStorage.order.details.attributes.pickup_address) &&
                    $localStorage.order.details.attributes.pickup_address !== null &&
                    angular.isDefined($localStorage.order.details.attributes.pickup_address.resource_id) &&
                    angular.isDefined($localStorage.order.details.attributes.delivery_address) &&
                    $localStorage.order.details.attributes.delivery_address !== null &&
                    angular.isDefined($localStorage.order.details.attributes.delivery_address.resource_id) &&
                    (
                        angular.isUndefined($localStorage.order.details.attributes.billing_address) ||
                        $localStorage.order.details.attributes.billing_address === null ||
                        angular.isUndefined($localStorage.order.details.attributes.billing_address.resource_id)
                    );
            };

            $scope.toggleMobilePaymentMethods = function() {
                $scope.showPaymentMethodsOnMobile = !$scope.showPaymentMethodsOnMobile;
            };

            $scope.showPaymentMethodsMobileBox = function(selectedPaymentMethodId) {
                return $scope.selectedPaymentMethodWithoutBillingAgreement(selectedPaymentMethodId) ||
                       !selectedPaymentMethodId ||
                       $scope.showPaymentMethodsOnMobile ||
                       (
                           angular.isDefined($localStorage.order.additionalInfo.errors) &&
                           $localStorage.order.additionalInfo.errors.payment.length > 0
                       );
            };

            $scope.selectedPaymentMethodWithoutBillingAgreement = function(selectedPaymentMethodId) {
                var billingAgreementKeyMap = {};

                billingAgreementKeyMap[JF_CONFIG.paymentMethods.payPalAfterPayment] = 'payPal';
                billingAgreementKeyMap[JF_CONFIG.paymentMethods.creditCard] = 'cc';
                billingAgreementKeyMap[JF_CONFIG.paymentMethods.sepa] = 'sepa';
                billingAgreementKeyMap[JF_CONFIG.paymentMethods.app] = 'app';

                return angular.isDefined(billingAgreementKeyMap[selectedPaymentMethodId]) &&
                       (
                           $rootScope.jfShared.checkout.userBillingAgreements[billingAgreementKeyMap[selectedPaymentMethodId]] === null ||
                           (
                               $rootScope.jfShared.checkout.userBillingAgreements[billingAgreementKeyMap[selectedPaymentMethodId]] !== null &&
                               $rootScope.jfShared.checkout.userBillingAgreements[billingAgreementKeyMap[selectedPaymentMethodId]].length === 0
                           )
                       );
            };

            $scope.initMainCheckoutView = function() {
                if (!AdyenFactory.isScriptLoaded() && !AdyenFactory.scriptInjected) {
                    AdyenFactory.loadScript();
                    AdyenFactory.loadCss();
                }

                CustomerAppHelpersFactory.fetchLegalDocuments().then(function(legalDocuments) {
                    $scope.legalDocuments = legalDocuments;
                }, function(err) {
                    $rootScope.$emit('app-error', {err: err});
                });

                $scope.orderCopy = angular.copy($localStorage.order);
                $scope.Math = Math;
                $scope.showPickup = false;
                $scope.showDelivery = false;
                $scope.newAddressForm = false;
                $scope.editAddressForm = false;
                $scope.showPaymentMethodsOnMobile = false;
                $scope.orderCommitListener = null;
                $scope.desktopShowAllAddresses = false;
                $scope.minOrderValue = CheckoutFactory.getMinimumOrderValue();
                $scope.blogUrl = $rootScope.blogUrl;
                $scope.newsletterFlagSet = jfUser.get().newsletter;
                $scope.mobileAppMode = $rootScope.mobileAppMode;
                $scope.showMainCheckout = true;
                $scope.isEnglishLocale = $localStorage.shopLocale && $localStorage.shopLocale.indexOf('en') > -1;

                if (angular.isDefined($localStorage.companyDetails) && $localStorage.companyDetails !== null && $localStorage.companyDetails.invoicing_fee) {
                    $scope.invoicingFee = $filter('round')($localStorage.companyDetails.invoicing_fee, 2);
                }

                $scope.visiblePaymentMethods = {};
                if (angular.isDefined($localStorage.paymentMethods)) {
                    angular.forEach($localStorage.paymentMethods.items, function(paymentMethod) {
                        $scope.visiblePaymentMethods[paymentMethod.id] = paymentMethod;

                        if (
                            angular.isDefined($localStorage.order) &&
                            angular.isDefined($localStorage.order.additionalInfo) &&
                            paymentMethod.name === $localStorage.order.additionalInfo.selectedPaymentMethodName) {
                            $localStorage.order.additionalInfo.selectedPaymentMethodId = paymentMethod.id;
                            $rootScope.order.additionalInfo.selectedPaymentMethodId = paymentMethod.id;

                            $localStorage.order.additionalInfo.selectedPaymentMethodName = undefined;
                            $rootScope.order.additionalInfo.selectedPaymentMethodName = undefined;
                        }
                    });
                }

                if ($state.current.name !== 'checkout.success') {
                    if (
                        angular.isUndefined($localStorage.order) ||
                        angular.isUndefined($localStorage.order.details) ||
                        angular.isUndefined($localStorage.order.details.attributes) ||
                        $localStorage.order.details.attributes.total_amount < $scope.minOrderValue
                    ) {
                        $state.go('products', { '#': 'c0', cartError: true });
                    } else {
                        $window.dataLayer.push({
                            event: 'app:desktop:checkout:init',
                            attributes: {
                                order_num_items: $localStorage.order.additionalInfo.totalItems,
                                order_payable_amount: $filter('round')($localStorage.order.details.attributes.payable_amount, 2, true),
                                order_currency: $localStorage.order.details.attributes.currency
                            }
                        });

                        if (angular.isDefined($localStorage.order.additionalInfo.unprocessableErrorReloadPopupShown)) {
                            delete $localStorage.order.additionalInfo.unprocessableErrorReloadPopupShown;
                        }

                        if (angular.isDefined($localStorage.order.additionalInfo.retryOrderCommit)) {
                            delete $localStorage.order.additionalInfo.retryOrderCommit;
                        }

                        $scope.corporateEnabled = jfUser.get().corporateEnabled;
                        $scope.showNotes = $scope.showPickupAndDeliveryNotes();

                        CheckoutFactory.initCheckoutModel();

                        SpinnerFactory.set('cart');

                        CheckoutFactory
                            .fetchCurrentAgbVersion()
                            .then(function(currentAgbVersion) {
                                SpinnerFactory.unset('cart');
                                $localStorage.order.additionalInfo.remoteAgbVersion = currentAgbVersion;
                            }, function(err) {
                                SpinnerFactory.unset('cart');
                                $rootScope.$emit('app-error', {err: err});
                            });

                        $scope.checkoutEditAddressesListener = $rootScope.$on(
                            'jfCheckout:checkoutNewAddress',
                            function() {
                                if ($mdMedia('xs') && $state.current.name === 'checkout') {
                                    $state.go('checkout.addresses');
                                }

                                $scope.editAddressForm = false;
                                $scope.newAddressForm = true;
                            }
                        );

                        $scope.checkoutEditAddressesListener = $rootScope.$on(
                            'jfCheckout:checkoutEditAddress',
                            function() {
                                if ($mdMedia('xs') && $state.current.name === 'checkout') {
                                    $state.go('checkout.addresses', {
                                        addressToEdit: $state.params.addressToEdit,
                                        subnav: $state.params.subnav
                                    });
                                }

                                $scope.editAddressForm = true;
                                $scope.newAddressForm = false;
                            }
                        );

                        $scope.checkoutEditAddressesListener = $rootScope.$on(
                            'jfCheckout:checkoutEditAddressClose',
                            function() {
                                delete $state.params.addressToEdit;

                                if ($mdMedia('xs')) {
                                    $state.go('checkout');
                                } else {
                                    $scope.editAddressForm = false;
                                    $scope.newAddressForm = false;
                                    $state.reload();
                                }
                            }
                        );

                        $scope.checkoutNewAddressesListener = $rootScope.$on(
                            'jfCheckout:checkoutNewAddressClose',
                            function(e, data) {
                                if ($mdMedia('xs')) {
                                    $state.go('checkout');
                                } else {
                                    if (angular.isDefined(data) && data.newAddressSaved === true) {
                                        $scope.showPickupAndDeliveryNotes();
                                    }

                                    $scope.newAddressForm = false;
                                    $scope.editAddressForm = false;
                                }
                            }
                        );

                        $scope.orderCommitListener = $rootScope.$on(
                            'jfCheckout:orderCommit',
                            $scope.triggerOrderCommit
                        );

                        $scope.checkoutShowPickupTimetable = $rootScope.$on(
                            'jfCheckout:showPickupTimeTable',
                            $scope.showPickupTimetable
                        );

                        $scope.checkoutShowDeliveryTimetable = $rootScope.$on(
                            'jfCheckout:showDeliveryTimeTable',
                            $scope.showDeliveryTimetable
                        );

                        $scope.checkoutNotesVisibleListener = $rootScope.$on(
                            'jfCheckout:checkoutNotesVisible', function() {
                                $scope.showNotes = $scope.showPickupAndDeliveryNotes();
                            }
                        );

                        $scope.showMainCheckoutListener = $rootScope.$on(
                            'jfCheckout:checkoutshowMainCheckout', function(e, data) {
                                $scope.showMainCheckout = data;
                            }
                        );

                        CheckoutFactory.clearValidationErrors();

                        $scope.orderErrorsWatcher = $rootScope.$watch('order', $scope.refreshValidationErrors, true);

                        $scope.destroyableOrderItemsHandler();

                        $scope.$on('$destroy', function() {
                            $scope.orderDestroyableItemsWatcher();
                            $scope.checkoutEditAddressesListener();
                            $scope.orderCommitListener();
                            $scope.orderErrorsWatcher();
                            $scope.checkoutShowPickupTimetable();
                            $scope.checkoutShowDeliveryTimetable();
                            $scope.checkoutNotesVisibleListener();
                            $scope.showMainCheckoutListener();
                        });
                    }
                }
            };

            jfController.init(['initMainCheckoutView'], $scope);
        }]
    );

/**
 * WP content controller
 */
angular.module('jfApp')
    .controller(
        'WpContentController',
        ['$scope', '$rootScope', '$state', '$window', '$translate', '$mdSidenav', 'JF_CONFIG', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $window,
            $translate,
            $mdSidenav,
            JF_CONFIG,
            jfController
        ) {
            'use strict';

            $scope.initWpContentView = function() {
                $translate($state.params.title)
                    .then(function(headPageTitleTranslation) {
                        $window.document.title = headPageTitleTranslation + JF_CONFIG.pageHeadTitleSuffix;
                        $rootScope.jfShared.pageTitle = headPageTitleTranslation;
                    }, function() {});

                $scope.url = $state.params.url;

                $mdSidenav('left').close();
            };

            jfController.init(['initWpContentView'], $scope);
        }]
    );

/**
 * Model compare values directive
 */
angular.module('jfApp')
    .directive(
        'wpIframeOnload',
        ['$window', 'SpinnerFactory', function(
            $window,
            SpinnerFactory
        ) {
            'use strict';

            return {
                restrict: 'A',
                link: function($scope, element) {
                    SpinnerFactory.set('global');

                    $scope.handleMessage = function(event) {
                        if (event.origin.indexOf('jonnyfresh.com') !== -1 || event.origin.indexOf('jf.devel') !== -1) {
                            $window.open(event.data, '_system');
                        }
                    };

                    element.on('load', function() {
                        SpinnerFactory.unset('global');

                        $window.addEventListener('message', $scope.handleMessage);
                    });

                    $scope.$on('$destroy', function() {
                        $window.removeEventListener('message', $scope.handleMessage);
                    });
                }
            };
        }]
    );
/**
 * Invoices controller
 */
angular.module('jfApp')
    .controller(
        'InvoicesController',
        ['$scope', '$rootScope', '$state', '$location', 'ActionCableConfig', 'ActionCableChannel', 'ActionCableSocketWrangler', 'BooksInvoicesFactory', 'NotificationInvoiceDocumentsFactory', 'NotificationInvoiceDetailsDocumentsFactory', 'JF_CONFIG', 'JF_SHARED_CONFIG', 'jfJsonApi', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $location,
            ActionCableConfig,
            ActionCableChannel,
            ActionCableSocketWrangler,
            BooksInvoicesFactory,
            NotificationInvoiceDocumentsFactory,
            NotificationInvoiceDetailsDocumentsFactory,
            JF_CONFIG,
            JF_SHARED_CONFIG,
            jfJsonApi,
            jfController
        ) {
            'use strict';

            $scope.$on('$destroy', function() {
                if (ActionCableSocketWrangler.connected && $scope.consumerHandler !== null) {
                    $scope.consumerHandler.unsubscribe();
                    ActionCableSocketWrangler.stop();
                } else if (ActionCableSocketWrangler.connecting) {
                    ActionCableSocketWrangler.stop();
                }
            });

            $scope.getDocument = function(invoice) {
                NotificationInvoiceDocumentsFactory
                    .save(
                        jfJsonApi.prepare(
                            JF_SHARED_CONFIG.modelTypes.invoices,
                            {
                                invoice_id: invoice.data.id,
                                invoice_date: invoice.data.attributes.invoice_date,
                                invoice_no: invoice.data.attributes.invoice_no,
                                websocket_params: {
                                    identifier: invoice.data.attributes.customer_id || invoice.data.attributes.company_id
                                }
                            }
                        )
                    )
                    .$promise
                    .then(function(documentResponse) {
                        if (documentResponse.data.attributes.url !== null) {
                            window.location = documentResponse.data.attributes.url;
                        }
                    }, function(err) {
                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.triggerActionCable = function (invoice) {
                var identifier = null;

                if (angular.isDefined(invoice.data.attributes.customer_id) && invoice.data.attributes.customer_id !== null) {
                    identifier = invoice.data.attributes.customer_id;
                    ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_user_id=' + invoice.data.attributes.customer_id;
                } else if (angular.isDefined(invoice.data.attributes.company_id) && invoice.data.attributes.company_id !== null) {
                    identifier = invoice.data.attributes.company_id;
                    ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_company_id=' + invoice.data.attributes.company_id;
                } else {
                    ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_user_id=null';
                }

                $scope.consumerHandler = new ActionCableChannel(JF_CONFIG.actionCable.channels.jobs);

                $scope.consumerHandler.onConfirmSubscription(function() {
                    $scope.getDocument(invoice);
                });

                var inboundCallback = function (incomingMessage) {
                    if (
                        angular.isDefined(incomingMessage.message.args) &&
                        angular.isDefined(incomingMessage.message.args.invoice_id) &&
                        incomingMessage.message.args.invoice_id === invoice.data.id &&
                        angular.isDefined(incomingMessage.message.websocket) &&
                        angular.isDefined(incomingMessage.message.websocket.identifier) &&
                        incomingMessage.message.websocket.identifier === identifier
                    ) {
                        window.location = incomingMessage.message.websocket.redirect_url;
                    }
                };

                $scope.consumerHandler.subscribe(inboundCallback);

                ActionCableSocketWrangler.start();
            };

            $scope.consumerHandler = null;

            $scope.initInvoicesView = function() {
                $scope.source = $location.search().source;

                if (angular.isUndefined($state.params.id) || $state.params.id === '') {
                    $state.go('products', {'#': 'c0'});
                } else {
                    BooksInvoicesFactory
                        .get({ id: $state.params.id })
                        .$promise
                        .then(function(invoice) {
                            if (
                                angular.isDefined(invoice.data.attributes.company_invoicing_breakdown) &&
                                invoice.data.attributes.company_invoicing_breakdown === true
                            ) {
                                NotificationInvoiceDetailsDocumentsFactory
                                    .save(
                                        jfJsonApi.prepare(
                                            JF_SHARED_CONFIG.modelTypes.invoiceDetails,
                                            {
                                                invoice_id: invoice.data.id,
                                                invoice_date: invoice.data.attributes.invoice_date,
                                                invoice_no: invoice.data.attributes.invoice_no,
                                                websocket_params: {
                                                    identifier: invoice.data.attributes.customer_id || invoice.data.attributes.company_id
                                                }
                                            }
                                        )
                                    )
                                    .$promise
                                    .then(function(documentResponse) {
                                        if (documentResponse.data.attributes.url !== null) {
                                            window.location = documentResponse.data.attributes.url;
                                        }

                                        $scope.triggerActionCable(invoice);
                                    }, function(err) {
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                $scope.triggerActionCable(invoice);
                            }

                        }, function(err) {
                            if (err.status === 404) {
                                $state.go('products', {'#': 'c0'});
                            } else {
                                $rootScope.$emit('app-error', {err: err});
                            }
                        });
                }
            };

            jfController.init(['initInvoicesView'], $scope);
        }]
    );

/**
 * Reminders controller
 */
angular.module('jfApp')
    .controller(
        'RemindersController',
        ['$scope', '$rootScope', '$state', 'ActionCableConfig', 'ActionCableChannel', 'ActionCableSocketWrangler', 'BooksRemindersFactory', 'NotificationInvoiceReminderDocumentsFactory', 'JF_CONFIG', 'JF_SHARED_CONFIG', 'jfJsonApi', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            ActionCableConfig,
            ActionCableChannel,
            ActionCableSocketWrangler,
            BooksRemindersFactory,
            NotificationInvoiceReminderDocumentsFactory,
            JF_CONFIG,
            JF_SHARED_CONFIG,
            jfJsonApi,
            jfController
        ) {
            'use strict';

            $scope.$on('$destroy', function() {
                if (ActionCableSocketWrangler.connected && $scope.consumerHandler !== null) {
                    $scope.consumerHandler.unsubscribe();
                    ActionCableSocketWrangler.stop();
                } else if (ActionCableSocketWrangler.connecting) {
                    ActionCableSocketWrangler.stop();
                }
            });

            $scope.consumerHandler = null;

            $scope.getDocument = function(reminder) {
                NotificationInvoiceReminderDocumentsFactory
                    .save(
                        jfJsonApi.prepare(
                            JF_SHARED_CONFIG.modelTypes.reminders,
                            {
                            invoice_reminder_id: reminder.data.id,
                            invoice_no: reminder.data.attributes.invoice_no,
                            reminder_date: reminder.data.attributes.reminder_date,
                            running_no: reminder.data.attributes.running_no,
                            websocket_params: {
                                identifier: reminder.data.attributes.customer_id
                            }
                            }
                        )
                    )
                    .$promise
                    .then(function(documentResponse) {
                        if (documentResponse.data.attributes.url !== null) {
                            window.location = documentResponse.data.attributes.url;
                        }
                    }, function(err) {
                        $rootScope.$emit('app-error', {err: err});
                    });
            };

            $scope.initRemindersView = function() {
                if (angular.isUndefined($state.params.id) || $state.params.id === '') {
                    $state.go('products', {'#': 'c0'});
                } else {
                    BooksRemindersFactory
                        .get({ id: $state.params.id })
                        .$promise
                        .then(function(reminder) {
                            var identifier = null;

                            if (angular.isDefined(reminder.data.attributes.customer_id) && reminder.data.attributes.customer_id !== null) {
                                identifier = reminder.data.attributes.customer_id;
                                ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_user_id=' + reminder.data.attributes.customer_id;
                            } else if (angular.isDefined(reminder.data.attributes.company_id) && reminder.data.attributes.company_id !== null) {
                                identifier = reminder.data.attributes.company_id;
                                ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_company_id=' + reminder.data.attributes.company_id;
                            } else {
                                ActionCableConfig.wsUri = ActionCableConfig.wsUri + '?current_user_id=null';
                            }

                            $scope.consumerHandler = new ActionCableChannel(JF_CONFIG.actionCable.channels.jobs);

                            $scope.consumerHandler.onConfirmSubscription(function() {
                                $scope.getDocument(reminder);
                            });

                            var inboundCallback = function (incomingMessage) {
                                if (
                                    angular.isDefined(incomingMessage.message.args) &&
                                    angular.isDefined(incomingMessage.message.args.invoice_reminder_id) &&
                                    incomingMessage.message.args.invoice_reminder_id === reminder.data.id &&
                                    angular.isDefined(incomingMessage.message.websocket) &&
                                    angular.isDefined(incomingMessage.message.websocket.identifier) &&
                                    incomingMessage.message.websocket.identifier === reminder.data.attributes.customer_id
                                ) {
                                    window.location = incomingMessage.message.websocket.redirect_url;
                                }
                            };

                            $scope.consumerHandler.subscribe(inboundCallback);

                            ActionCableSocketWrangler.start();
                        }, function(err) {
                            if (err.status === 404) {
                                $state.go('products', {'#': 'c0'});
                            } else {
                                $rootScope.$emit('app-error', {err: err});
                            }
                        });
                }
            };

            jfController.init(['initRemindersView'], $scope);
        }]
    );

/**
 * Invoices controller
 */
angular.module('jfApp')
    .controller(
        'MaintenanceController',
        ['$scope', '$rootScope', '$state', '$timeout', 'jfToken', 'jfHelper', 'authService', 'jfController', function(
            $scope,
            $rootScope,
            $state,
            $timeout,
            jfToken,
            jfHelper,
            authService,
            jfController
        ) {
            'use strict';

            $scope.tokenPing = function () {
                jfToken
                    .getToken()
                    .then(function() {
                        authService.loginConfirmed();
                        jfHelper.goBackInHistory();
                    }, function(err) {
                        if (err.status === 403) {
                            $state.go('logout');
                        } else if (err.status !== 345) {
                            $rootScope.$emit('app-error', {err: err});
                        }

                        $timeout($scope.tokenPing, 10000);
                    });
            };

            $scope.initMaintenanceView = function() {
                $scope.tokenPing();
            };

            jfController.init(['initMaintenanceView'], $scope);
        }]
    );

/**
 * Order factory
 */
angular.module('jfApp')
    .factory(
        'OrderFactory',
        ['$localStorage', '$rootScope', '$q', '$window', '$cookies', '$state', '$filter', '$injector', 'JF_SHARED_CONFIG', 'JF_CONFIG', 'jfJsonApi', 'jfDialog', 'jfLocation', 'SpinnerFactory', 'BooksOrdersFactory', 'BooksOrderRemoveDestroyableOrderItemsFactory', 'BooksOrdersOrderItemsFactory', 'jfConfigUrls', 'jfUser', function(
            $localStorage,
            $rootScope,
            $q,
            $window,
            $cookies,
            $state,
            $filter,
            $injector,
            JF_SHARED_CONFIG,
            JF_CONFIG,
            jfJsonApi,
            jfDialog,
            jfLocation,
            SpinnerFactory,
            BooksOrdersFactory,
            BooksOrderRemoveDestroyableOrderItemsFactory,
            BooksOrdersOrderItemsFactory,
            jfConfigUrls,
            jfUser
        ) {
            'use strict';

            return {
                createEmptyOrderObject: function() {
                    var emptyOrder = {
                        details: { attributes: {} },
                        additionalInfo: {
                            totalItems: 0,
                            pickupNote: null,
                            deliveryNote: null,
                            specialInstructions: null,
                            newsletter: jfUser.get().newsletter
                        },
                        items: []
                    };

                    $localStorage.order = angular.copy(emptyOrder);
                    $rootScope.order = angular.copy(emptyOrder);
                    this.updateOrderItemPositionAtProducts();
                },
                updateOrder: function(id, dataToUpdate, relationships) {
                    var deferred = $q.defer(),
                        factory = this;

                    // passing user ID
                    if (dataToUpdate) {
                        dataToUpdate.user_id = jfUser.get().id || null;
                        dataToUpdate.customer_id = jfUser.get().id || null;

                        if (angular.isUndefined(dataToUpdate.company_id)) {
                            var CustomerAppHelpersFactory =  $injector.get('CustomerAppHelpersFactory');
                            var companyId = CustomerAppHelpersFactory.getCompanyId();

                            if (companyId !== null) {
                                dataToUpdate.company_id = companyId;
                            }
                        }
                    }

                    if (
                        angular.isUndefined($rootScope.jfShared.newOrderCreationInProgress) ||
                        $rootScope.jfShared.newOrderCreationInProgress === false
                    ) {
                        factory
                            .performOrderUpdate(id, dataToUpdate, relationships)
                            .then(function(updatedOrder) {
                                deferred.resolve(updatedOrder);
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        var newOrderCreationInProgressWatcher =
                                $rootScope.$watch('jfShared.newOrderCreationInProgress', function(newVal) {
                                    if (newVal === false) {
                                        newOrderCreationInProgressWatcher();

                                        factory
                                            .performOrderUpdate(id, dataToUpdate, relationships)
                                            .then(function(updatedOrder) {
                                                deferred.resolve(updatedOrder);
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    }
                                });
                    }

                    return deferred.promise;
                },
                performOrderUpdate: function(id, dataToUpdate, relationships) {
                    var deferred = $q.defer(),
                        factory = this;

                    relationships = relationships || {};

                    BooksOrdersFactory
                        .update(
                            {
                                id: id
                            },
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.orders,
                                dataToUpdate,
                                {},
                                {},
                                relationships
                            )
                        )
                        .$promise
                        .then(function(updatedOrder) {
                            if ($localStorage.order.details.id === id) {
                                factory.refreshOrderDetails(updatedOrder.data);
                            }

                            deferred.resolve(updatedOrder);
                        }, function(err) {
                            if (err.status === 404 || err.status === 409) {
                                factory.recreateOrder();
                                $rootScope.$emit('app-log', {msg: err});
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                updateOrderAdditionalInfo: function(additionalInfo) {
                    angular.merge($localStorage.order.additionalInfo, additionalInfo);
                    angular.merge($rootScope.order.additionalInfo, additionalInfo);
                },
                createNewOrder: function(additionalParams, relationships) {
                    var deferred = $q.defer(),
                        factory = this,
                        dataToSave = {
                            user_id: jfUser.get().id || null,
                            customer_id: jfUser.get().id || null,
                            locale: $localStorage.shopLocale
                        };

                    relationships = relationships || {};

                    var CustomerAppHelpersFactory =  $injector.get('CustomerAppHelpersFactory');
                    dataToSave.company_id = CustomerAppHelpersFactory.getCompanyId();

                    if (angular.isDefined(additionalParams) && angular.isObject(additionalParams)) {
                        angular.extend(dataToSave, additionalParams);
                    }

                    if (
                        (
                            (
                                angular.isUndefined(dataToSave.pickup_address) ||
                                dataToSave.pickup_address === null
                            ) && angular.isDefined($localStorage.catalogLocation)
                        ) ||
                        (
                            (
                                angular.isDefined(dataToSave.pickup_address) &&
                                dataToSave.pickup_address !== null
                            ) &&
                            angular.isDefined($localStorage.catalogLocation) &&
                            dataToSave.pickup_address.postal_code_id !== $localStorage.catalogLocation.postal_code_id
                        )
                    ) {
                        var addressToSave = angular.copy($localStorage.catalogLocation);
                        factory.prefillEmptyOrderAddressDetails(addressToSave);
                        addressToSave.type = JF_CONFIG.addressTypes.service;

                        dataToSave.delivery_address = addressToSave;
                        dataToSave.pickup_address = addressToSave;
                    }

                    if (angular.isUndefined(dataToSave.delivery_address) || dataToSave.delivery_address === null) {
                        this.createEmptyOrderObject();

                        if ($rootScope.mobileAppMode) {
                            $state.go('location-picker');
                        } else {
                            $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                        }
                    } else {
                        if (
                            dataToSave.company_id !== null &&
                            angular.isDefined(dataToSave.pickup_address) &&
                            dataToSave.pickup_address.addressable_type === 'Customer' &&
                            jfUser.get().corporateEnabled === true
                        ) {
                            dataToSave.company_id = null;
                        }

                        if (
                            angular.isUndefined($rootScope.jfShared.newOrderCreationInProgress) ||
                            $rootScope.jfShared.newOrderCreationInProgress === false
                        ) {
                            $rootScope.jfShared.newOrderCreationInProgress = true;

                            this.createEmptyOrderObject();

                            BooksOrdersFactory
                                .save(
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.regular_orders,
                                        dataToSave,
                                        {},
                                        {},
                                        relationships
                                    )
                                )
                                .$promise
                                .then(function(newOrder) {
                                    factory.refreshOrderDetails(newOrder.data);

                                    $rootScope.jfShared.newOrderCreationInProgress = false;

                                    if (angular.isDefined($window.Sentry)) {
                                        $window.Sentry.setExtra({ order_id: $localStorage.order.details.id });
                                    }

                                    deferred.resolve();
                                }, function(err) {
                                    if (err.status === 422) {
                                        var retryOrderCreation = false;

                                        angular.forEach(err.data.errors, function(error) {
                                            if (error.source.pointer === '/data/attributes/order_no') {
                                                retryOrderCreation = true;
                                            }
                                        });

                                        if (retryOrderCreation === true) {
                                            factory
                                                .createNewOrder({
                                                    pickup_address: addressToSave,
                                                    delivery_address: addressToSave
                                                })
                                                .then(
                                                    function() {
                                                        if (angular.isDefined($window.Sentry)) {
                                                            $window.Sentry.setExtra({ order_id: $localStorage.order.details.id });
                                                        }
                                                    },
                                                    function(err) {
                                                        deferred.reject(err);
                                                    }
                                                );
                                        }
                                    } else {
                                        deferred.reject(err);
                                    }
                                    deferred.reject(err);
                                });
                        } else {
                            var newOrderCreationInProgressWatcher =
                                $rootScope.$watch('jfShared.newOrderCreationInProgress', function(newVal) {
                                    if (newVal === false) {
                                        newOrderCreationInProgressWatcher();

                                        deferred.resolve();
                                    }
                                });
                        }
                    }

                    return deferred.promise;
                },
                getOrderDetails: function(isValidatingJson) {
                    var deferred = $q.defer(),
                        factory = this;

                    BooksOrdersFactory
                        .get({
                            id: $localStorage.order.details.id,
                            include: 'order_items',
                            'page[order_items][size]': 999
                        })
                        .$promise
                        .then(function(orderDetails) {
                            factory
                                .orderDetailsValidation(orderDetails.data, true)
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    $rootScope.$emit('app-log', { msg: err });
                                });
                        }, function(err) {
                            if (err.status === 404) {
                                if (angular.isUndefined(isValidatingJson)) {
                                    factory.recreateOrder();
                                } else {
                                    factory.createNewOrder();
                                    deferred.resolve();
                                }
                                $rootScope.$emit('app-log', { msg: err });
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                orderDetailsValidation: function(orderDetails, validateOrderItems) {
                    var deferred = $q.defer(),
                        factory = this;

                    if (orderDetails.attributes.state !== JF_CONFIG.orderStates.commenced) {
                        // Wrong order state
                        $rootScope.$emit('app-log', {msg: 'Wrong order state: ' + orderDetails.attributes.state + '. Order ID: ' + orderDetails.id});

                        factory
                            .createNewOrder()
                            .then(
                                function() {
                                    deferred.resolve();

                                    $state.go('products', {'#': 'c0'});
                                },
                                function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                }
                            );
                    } else {
                        factory.refreshOrderDetails(orderDetails);

                        if (validateOrderItems === true) {
                            var orderItemsCount = 0;

                            angular.forEach(orderDetails.included, function(includeItem) {
                                if (includeItem.type === 'order_items') {
                                    orderItemsCount++;
                                }
                            });

                            if (
                                angular.isUndefined(orderDetails.included) ||
                                orderItemsCount !== $localStorage.order.items.length
                            ) {
                                factory
                                    .fetchOrderItems()
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }
                        } else {
                            deferred.resolve();
                        }
                    }

                    return deferred.promise;
                },
                refreshOrderDetails: function(orderDetails) {
                    $localStorage.order.details = angular.copy(orderDetails);
                    $rootScope.order.details = angular.copy(orderDetails);

                    this.setCookieWithCartItems($localStorage.order.additionalInfo.totalItems);
                },
                setCookieWithCartItems: function(cartItems) {
                    $cookies.put(
                        'jf-order-total-items',
                        String(cartItems),
                        {
                            domain: JF_CONFIG.cookies_domain,
                            samesite: 'lax',
                            secure: true
                        }
                    );
                },
                cancelOrder: function(orderId) {
                    return BooksOrdersFactory
                               .delete(
                                   { id: orderId }
                               )
                               .$promise;
                },
                fetchOrderItems: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    if (
                        angular.isDefined($localStorage.order) &&
                        angular.isDefined($localStorage.order.details) &&
                        angular.isDefined($localStorage.order.details.id)
                    ) {
                        BooksOrdersOrderItemsFactory
                            .get({
                                'filter[order_id]': $localStorage.order.details.id,
                                'page[size]': 999,
                                'page[number]': 1
                            })
                            .$promise
                            .then(function(orderItems) {
                                $rootScope.order.additionalInfo.totalItems = 0;
                                $localStorage.order.additionalInfo.totalItems = 0;

                                if (orderItems.data.length !== $localStorage.order.items.length) {
                                    $localStorage.order.items = [];
                                    $rootScope.order.items = [];
                                }

                                angular.forEach(orderItems.data, function(orderItem) {
                                    if (
                                        angular.isDefined($localStorage.catalogContent) &&
                                        angular.isDefined($localStorage.catalogContent.catalog)
                                    ) {
                                        angular.forEach($localStorage.catalogContent.catalog, function(category) {
                                            var catalogProduct = $filter('findInObject')(category.products, 'product_id', orderItem.attributes.product_id);

                                            if (catalogProduct !== null) {
                                                orderItem.attributes.processing_time = catalogProduct.processing_time;
                                                orderItem.attributes.product_image = jfConfigUrls.get('jfImagesCDN', 'customerApp') + '/' + catalogProduct.product_image_name + '.png';
                                            }
                                        });
                                    } else {
                                        $state.go('products', {'#': 'c0'});
                                    }

                                    factory.setItemToOrder(orderItem);

                                    $rootScope.order.additionalInfo.totalItems = $rootScope.order.additionalInfo.totalItems + parseInt(orderItem.attributes.quantity);
                                    $localStorage.order.additionalInfo.totalItems = $localStorage.order.additionalInfo.totalItems + parseInt(orderItem.attributes.quantity);

                                    factory.setCookieWithCartItems($localStorage.order.additionalInfo.totalItems);
                                });

                                deferred.resolve();
                            }, function(err) {
                                if (err.status === 404) {
                                    factory.recreateOrder();
                                    $rootScope.$emit('app-log', {msg: err});
                                } else {
                                    deferred.reject(err);
                                }
                            });
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                },
                prepareOrderItems: function(orderItems) {
                    var orderItemsArr = [];

                    angular.forEach(orderItems, function(orderItem) {
                        orderItemsArr.push(orderItem);
                    });

                    return orderItemsArr;
                },
                prefillEmptyOrderAddressDetails: function(address) {
                    if (
                        angular.isUndefined(address.phone_no) ||
                        address.phone_no === null ||
                        address.phone_no === ''
                    ) {
                        address.phone_no = '-';
                    }

                    if (
                        angular.isUndefined(address.first_name) ||
                        address.first_name === null ||
                        address.first_name === ''
                    ) {
                        address.first_name = '-';
                    }

                    if (
                        angular.isUndefined(address.last_name) ||
                        address.last_name === null ||
                        address.last_name === ''
                    ) {
                        address.last_name = '-';
                    }

                    if (
                        angular.isUndefined(address.street) ||
                        address.street === null ||
                        address.street === ''
                    ) {
                        address.street = '-';
                    }

                    if (
                        angular.isUndefined(address.house_no_main) ||
                        address.house_no_main === null ||
                        address.house_no_main === ''
                    ) {
                        address.house_no_main = '-';
                    }
                },
                getItemfromOrderItems: function(productId) {
                    var item;
                    angular.forEach($localStorage.order.items, function(orderItem) {
                        if (orderItem.attributes.product_id === productId) {
                            item = orderItem;
                        }
                    });
                    return item;
                },
                setItemToOrder: function(item) {
                    if (angular.isUndefined($rootScope.order.items)) {
                        $rootScope.order.items = [];
                    }
                    if (angular.isUndefined($localStorage.order.items)) {
                        $localStorage.order.items = [];
                    }

                    var orderIndex;

                    angular.forEach($localStorage.order.items, function(orderItem, index) {
                        if (angular.isDefined(orderItem.attributes.bundled)) {
                            $rootScope.order.items.splice(index, 1);
                            $localStorage.order.items.splice(index, 1);
                        } else if (orderItem && orderItem.attributes.product_id === item.attributes.product_id) {
                            orderIndex = index;
                        }
                    });

                    if (angular.isDefined(orderIndex)) {
                        $rootScope.order.items[orderIndex] = angular.copy(item);
                        $localStorage.order.items[orderIndex] = angular.copy(item);
                    } else {
                        $rootScope.order.items.push(angular.copy(item));
                        $localStorage.order.items.push(angular.copy(item));
                    }

                    this.updateOrderItemPositionAtProducts();
                },
                updateOrderItemPositionAtProducts: function() {
                    if (angular.isDefined($localStorage.catalogContent)) {
                        // inserting order item reference position to product
                        angular.forEach($localStorage.catalogContent.catalog, function(category) {
                            angular.forEach(category.products, function(product) {
                                product.item_order_position = undefined;
                                angular.forEach($localStorage.order.items, function(item, index) {
                                    if (product.product_id === item.attributes.product_id) {
                                        product.item_order_position = index;
                                    }
                                });
                            });
                        });
                        if (angular.isDefined($rootScope.categoriesArr)) {
                            $rootScope.categoriesArr = $localStorage.catalogContent.catalog;
                        }
                    }
                },
                changeOrderItemQuantity: function(orderItemId, quantity) {
                    var deferred = $q.defer(),
                        model = this;

                    BooksOrdersOrderItemsFactory
                            .update(
                                {
                                    itemId: orderItemId,
                                    include: 'order'
                                },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.order_items,
                                    {
                                        quantity: quantity
                                    },
                                    {
                                        id: orderItemId,
                                        relationships: {
                                            order: {
                                                data: {
                                                    id: $localStorage.order.details.id,
                                                    type: JF_SHARED_CONFIG.modelTypes.orders
                                                }
                                            }
                                        }
                                    }
                                )
                            )
                            .$promise
                            .then(function(updatedItem) {
                                model.addToOrderSuccessCallback(updatedItem);

                                deferred.resolve();
                            }, function(err) {
                                if (
                                    err.status === 404 ||
                                    err.status === 409 ||
                                    err.status === 422
                                ) {
                                    $rootScope.$emit('app-log', {msg: err});

                                    model.recreateOrder();

                                    deferred.resolve();
                                } else {
                                    deferred.reject(err);
                                }
                            });

                    return deferred.promise;
                },
                addToOrder: function(productId, quantity, categoryId, categoryName) {
                    var model = this,
                        addNew = true,
                        orderItemId = null,
                        factory = this,
                        item = this.getItemfromOrderItems(productId),
                        deferred = $q.defer();

                    if (addNew && angular.isDefined(item)) {
                        addNew = false;
                        quantity = parseInt(quantity) + parseInt(item.attributes.quantity);
                        orderItemId = item.id;
                    }

                    if (addNew) {
                        BooksOrdersOrderItemsFactory
                            .save(
                                { include: 'order' },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.order_items,
                                    {
                                        product_id: productId,
                                        quantity: quantity,
                                        category_id: categoryId,
                                        category_name: categoryName
                                    },
                                    {
                                        relationships: {
                                            order: {
                                                data: {
                                                    id: $localStorage.order.details.id,
                                                        type: JF_SHARED_CONFIG.modelTypes.orders
                                                }
                                            }
                                        }
                                    }
                                )
                            )
                            .$promise
                            .then(function(updatedItem) {
                                model.addToOrderSuccessCallback(updatedItem);

                                deferred.resolve();
                            }, function(err) {
                                if (err.status === 404 || err.status === 409) {
                                    $rootScope.$emit('app-log', {msg: err});

                                    factory.recreateOrder();

                                    deferred.resolve();
                                } else if (err.status === 422) {
                                    delete $localStorage.catalogContent;

                                    $injector
                                        .get('ProductsFactory')
                                        .initCatalog()
                                        .then(function() {
                                            deferred.reject(err);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    deferred.reject(err);
                                }
                            });
                    } else {
                        BooksOrdersOrderItemsFactory
                            .update(
                                {
                                    itemId: orderItemId,
                                    include: 'order'
                                },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.order_items,
                                    {
                                        quantity: quantity
                                    },
                                    {
                                        id: orderItemId,
                                        relationships: {
                                            order: {
                                                data: {
                                                    id: $localStorage.order.details.id,
                                                    type: JF_SHARED_CONFIG.modelTypes.orders
                                                }
                                            }
                                        }
                                    }
                                )
                            )
                            .$promise
                            .then(function(updatedItem) {
                                model.addToOrderSuccessCallback(updatedItem);

                                deferred.resolve();
                            }, function(err) {
                                if (
                                    err.status === 404 ||
                                    err.status === 409 ||
                                    err.status === 422
                                ) {
                                    $rootScope.$emit('app-log', {msg: err});

                                    factory.recreateOrder();

                                    deferred.resolve();
                                } else {
                                    deferred.reject(err);
                                }
                            });
                    }

                    return deferred.promise;
                },
                addToOrderSuccessCallback: function(updatedItem) {
                    var factory = this;

                    if (updatedItem.$status !== 404) {
                        updatedItem = this.getOrderItemImage(updatedItem.data.attributes.product_id, updatedItem);

                        factory.setItemToOrder(updatedItem.data);
                        factory.updateOrderItemPositionAtProducts();

                        factory
                            .orderDetailsValidation(updatedItem.included[0], false)
                            .then(function() {
                                $rootScope.order.additionalInfo.totalItems = factory.getOrderItemsQuantity();
                                $localStorage.order.additionalInfo.totalItems = factory.getOrderItemsQuantity();

                                factory.setCookieWithCartItems($localStorage.order.additionalInfo.totalItems);
                            }, function(err) {
                                $rootScope.$emit('app-log', { msg: err });
                            });
                    }
                },
                addManyToOrder: function(products) {
                    var deferred = $q.defer(),
                        promises = [],
                        factory = this;

                    angular.forEach(products, function(product) {
                        var categoryId;
                        angular.forEach($rootScope.categoriesArr, function(category) {
                            if (category.name === product.attributes.category_name) {
                                categoryId = category.id;
                            }
                        });

                        promises.push(
                            factory.addToOrder(
                                product.attributes.product_id,
                                product.attributes.quantity,
                                categoryId,
                                product.attributes.category_name
                            )
                        );
                    });

                    $q
                        .all(promises)
                        .then(function() {
                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                removeFromOrder: function(productId, quantity) {
                    var factory = this,
                        item = this.getItemfromOrderItems(productId),
                        deferred = $q.defer();

                    if (angular.isDefined(item)) {
                        var model = this,
                            orderItemId = item.id;

                        quantity = item.attributes.quantity - quantity;

                        if (quantity > 0) {
                            BooksOrdersOrderItemsFactory
                                .update(
                                    { itemId: orderItemId },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.order_items,
                                        { quantity: quantity }, {
                                            id: orderItemId,
                                            relationships: {
                                                order: {
                                                    data: {
                                                        id: $localStorage.order.details.id,
                                                        type: JF_SHARED_CONFIG.modelTypes.orders
                                                    }
                                                }
                                            }
                                        }
                                    )
                                )
                                .$promise
                                .then(function(updatedItem) {
                                    var orderIndex = null;
                                    angular.forEach($localStorage.order.items, function(orderItem, index) {
                                        if (orderItem.attributes.product_id === updatedItem.data.attributes.product_id) {
                                            orderIndex = index;
                                        }
                                    });
                                    updatedItem = factory.getOrderItemImage(updatedItem.data.attributes.product_id, updatedItem);
                                    $rootScope.order.items[orderIndex] = angular.copy(updatedItem.data);
                                    $localStorage.order.items[orderIndex] = angular.copy(updatedItem.data);

                                    factory.updateOrderItemPositionAtProducts();

                                    model
                                        .removeFromOrderSuccessCallback(updatedItem)
                                        .then(function() {
                                            deferred.resolve();
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    if (err.status === 404 || err.status === 409) {
                                        factory.recreateOrder();
                                        $rootScope.$emit('app-log', {msg: err});
                                        deferred.reject(err);
                                    } else {
                                        $rootScope.$emit('app-error', {err: err});
                                        deferred.reject(err);
                                    }
                                });
                        } else {
                            model
                                .deleteItemFromOrder(orderItemId, productId)
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                },
                removeFromOrderSuccessCallback: function(updatedItem) {
                    var factory = this,
                        deferred = $q.defer();

                    if (angular.isUndefined(updatedItem.included)) {
                        factory
                            .getOrderDetails()
                            .then(function() {
                                $rootScope.order.additionalInfo.totalItems = factory.getOrderItemsQuantity();
                                $localStorage.order.additionalInfo.totalItems = factory.getOrderItemsQuantity();

                                factory.setCookieWithCartItems($localStorage.order.additionalInfo.totalItems);

                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        factory
                            .orderDetailsValidation(updatedItem.included[0], false)
                            .then(function() {
                                $rootScope.order.additionalInfo.totalItems = factory.getOrderItemsQuantity();
                                $localStorage.order.additionalInfo.totalItems = factory.getOrderItemsQuantity();

                                factory.setCookieWithCartItems($localStorage.order.additionalInfo.totalItems);

                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                },
                deleteItemFromOrder: function(orderItemId, productId) {
                    var factory = this,
                        deferred = $q.defer();

                    BooksOrdersOrderItemsFactory
                        .delete(
                            {
                                itemId: orderItemId
                            }
                        )
                        .$promise
                        .then(function(updatedItem) {
                            angular.forEach($localStorage.order.items, function(orderItem, index) {
                                if (orderItem.attributes.product_id === productId) {
                                    $rootScope.order.items.splice(index, 1);
                                    $localStorage.order.items.splice(index, 1);
                                }
                            });

                            factory.updateOrderItemPositionAtProducts();

                            factory
                                .removeFromOrderSuccessCallback(updatedItem)
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            if (err.status === 404 || err.status === 409) {
                                factory.recreateOrder();
                                $rootScope.$emit('app-log', {msg: err});
                                deferred.reject(err);
                            } else {
                                $rootScope.$emit('app-error', {err: err});
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                getOrderItemsQuantity: function() {
                    var quantity = 0;

                    angular.forEach($localStorage.order.items, function(item) {
                        quantity = parseInt(quantity) + parseInt(item.attributes.quantity);
                    });

                    return quantity;
                },
                isUserFirstOrder: function() {
                    var deferred = $q.defer();

                    BooksOrdersFactory
                        .get({
                            'filter[customer_id]' : jfUser.get().id,
                            order: '-created_at',
                            'page[size]': [2],
                            'page[number]': [1]
                        })
                        .$promise
                        .then(function(orders) {
                            if (orders.data.length > 1) {
                                deferred.reject();
                            } else {
                                deferred.resolve();
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                resetUserOrder: function(additionalParams, relationships) {
                    var deferred = $q.defer();

                    additionalParams = additionalParams || {};

                    this.createEmptyOrderObject();

                    this
                        .createNewOrder(additionalParams, relationships)
                        .then(function() {
                            $injector
                                .get('CheckoutFactory')
                                .setDefaultCheckoutModel();

                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                getOrderItemImage: function(productId, orderItem) {
                    if (
                        angular.isDefined($localStorage.catalogContent) &&
                        angular.isDefined($localStorage.catalogContent.catalog)
                    ) {
                        angular.forEach($localStorage.catalogContent.catalog, function(category) {
                            var catalogProduct = $filter('findInObject')(category.products, 'product_id', productId);

                            if (catalogProduct !== null) {
                                orderItem.data.attributes.processing_time = catalogProduct.processing_time;
                                orderItem.data.attributes.product_image = jfConfigUrls.get('jfImagesCDN', 'customerApp') + '/' + catalogProduct.product_image_name + '.png';
                            }
                        });
                    }

                    return orderItem;
                },
                savePickupAddress: function(addressToSave) {
                    var deferred = $q.defer(),
                        dataToUpdate = {
                            pickup_address: addressToSave
                        };

                    this.prefillEmptyOrderAddressDetails(addressToSave);

                    if ($injector.get('CheckoutFactory').shouldClearPickupTimeSlot($rootScope.jfShared.checkout.userAddresses, addressToSave.resource_id)) {
                        dataToUpdate.pickup_start_ts = null;
                        dataToUpdate.pickup_end_ts = null;
                        dataToUpdate.delivery_start_ts = null;
                        dataToUpdate.delivery_end_ts = null;
                    }

                    this
                        .updateOrder(
                            $localStorage.order.details.id,
                            dataToUpdate
                        )
                        .then(function() {
                            $rootScope.$emit('jfCheckout:savePickup');

                            deferred.resolve();
                        }, function(err) {
                            if (err.status === 422) {
                                var differentPartnerError = false;

                                angular.forEach(err.data.errors, function(errorDetails) {
                                    if (
                                        differentPartnerError === false &&
                                        errorDetails.source.pointer === '/data/attributes/delivery_address'
                                    ) {
                                        differentPartnerError = true;
                                    }
                                });
                                if (differentPartnerError === true) {
                                    $rootScope.jfShared.checkout.userAddresses[addressToSave.resource_id].differentPartner = true;

                                    angular.extend(err, {failedAddressSaveId: addressToSave.resource_id});

                                    deferred.reject(err);
                                } else {
                                    deferred.reject(err);
                                }
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                saveDeliveryAddress: function(addressToSave) {
                    var deferred = $q.defer(),
                        dataToUpdate = {
                            delivery_address: addressToSave
                        };

                    this.prefillEmptyOrderAddressDetails(addressToSave);

                    if ($injector.get('CheckoutFactory').shouldClearDeliveryTimeSlot($rootScope.jfShared.checkout.userAddresses, addressToSave.resource_id)) {
                        dataToUpdate.delivery_start_ts = null;
                        dataToUpdate.delivery_end_ts = null;
                    }

                    this
                        .updateOrder(
                            $localStorage.order.details.id,
                            dataToUpdate
                        )
                        .then(function() {
                            $rootScope.$emit('jfCheckout:saveDelivery');

                            deferred.resolve();
                        }, function(err) {
                            if (err.status === 422) {
                                var differentPartnerError = false;

                                angular.forEach(err.data.errors, function(errorDetails) {
                                    if (
                                        differentPartnerError === false &&
                                        errorDetails.source.pointer === '/data/attributes/delivery_address'
                                    ) {
                                        differentPartnerError = true;
                                    }
                                });
                                if (differentPartnerError === true) {
                                    $rootScope.jfShared.checkout.userAddresses[addressToSave.resource_id].differentPartner = true;

                                    angular.extend(err, {failedAddressSaveId: addressToSave.resource_id});

                                    deferred.reject(err);
                                } else {
                                    deferred.reject(err);
                                }
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                saveBillingAddress: function(addressToSave) {
                    var deferred = $q.defer();

                    this.prefillEmptyOrderAddressDetails(addressToSave);

                    this
                        .updateOrder(
                            $localStorage.order.details.id,
                            { billing_address: addressToSave }
                        )
                        .then(function() {
                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                handleDestroyableOrderItems: function(destroyableOrderItems, itemsToSearchIn, continueCallback, switchBackCallback) {
                    var factory = this,
                        orderItemsToDestroy = [],
                        popupContent = $filter('translate')('DESTROYABLE_ORDER_ITEMS_POPUP_CONTENT'),
                        itemsToDestroyList = '<ul>',
                        ProductsFactory = $injector.get('ProductsFactory');

                    angular.forEach(destroyableOrderItems, function(itemToDestroy) {
                        var catalogProduct = $filter('findInObject')(itemsToSearchIn, 'id', itemToDestroy);
                        if (catalogProduct !== null) {
                            orderItemsToDestroy.push(catalogProduct.attributes.name);
                        }
                    });

                    angular.forEach(orderItemsToDestroy, function(itemToDestroy) {
                        itemsToDestroyList = itemsToDestroyList + '<li>' + itemToDestroy + '</li>';
                    });

                    itemsToDestroyList = itemsToDestroyList + '</ul>';

                    jfDialog
                        .showConfirm(
                            $filter('translate')('DESTROYABLE_ORDER_ITEMS_POPUP_TITLE'),
                            popupContent + itemsToDestroyList,
                            $filter('translate')('DESTROYABLE_ORDER_ITEMS_POPUP_CONTINUE'),
                            $filter('translate')('DESTROYABLE_ORDER_ITEMS_POPUP_SWITCH_BACK_PROFILE'),
                            function() {
                                if (angular.isDefined(continueCallback)) {
                                    continueCallback();
                                } else {
                                    SpinnerFactory.set(['catalog', 'cart']);

                                    BooksOrderRemoveDestroyableOrderItemsFactory
                                        .update({ orderId: $localStorage.order.details.id })
                                        .$promise
                                        .then(function() {
                                            factory
                                                .getOrderDetails()
                                                .then(function() {
                                                    SpinnerFactory.unset(['catalog', 'cart']);
                                                }, function(err) {
                                                    SpinnerFactory.set(['catalog', 'cart']);
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        }, function(err) {
                                            SpinnerFactory.set(['catalog', 'cart']);
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            }, function() {
                                if (angular.isDefined(switchBackCallback)) {
                                    switchBackCallback();
                                } else {
                                    SpinnerFactory.set(['catalog', 'cart']);

                                    ProductsFactory
                                        .changeCatalogType()
                                        .then(function() {
                                            SpinnerFactory.unset(['catalog', 'cart']);

                                            if ($localStorage.catalogType === JF_CONFIG.accountTypes.company) {
                                                $state.reload();
                                            } else {
                                                ProductsFactory.redirectToProducts();
                                            }
                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            },
                            null,
                            false
                        );
                },
                refreshAddressBeforeRecreate: function(addressType, cachedAddresses) {
                    var deferred = $q.defer(),
                        AccountFactory = $injector.get('AccountFactory');

                    if (
                        $localStorage.order.details.attributes[addressType] === null ||
                        angular.isUndefined($localStorage.order.details.attributes[addressType]) ||
                        angular.isUndefined($localStorage.order.details.attributes[addressType].resource_id) ||
                        $localStorage.order.details.attributes[addressType].resource_id === null
                    ) {
                        if (
                            addressType !== 'billing_address' &&
                            angular.isDefined($localStorage.order.details.attributes[addressType]) &&
                            $localStorage.order.details.attributes[addressType] !== null
                        ) {
                            jfLocation
                                .postalCodeInService($localStorage.order.details.attributes[addressType].postal_code_id, $localStorage.order.details.attributes.company_id)
                                .then(function(validationResult) {
                                    if (validationResult.valid === true) {
                                        deferred.resolve($localStorage.order.details.attributes[addressType]);
                                    } else {
                                        deferred.resolve(null);
                                    }
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            deferred.resolve($localStorage.order.details.attributes[addressType]);
                        }
                    } else {
                        if (
                            angular.isDefined(cachedAddresses) &&
                            angular.isDefined(cachedAddresses[$localStorage.order.details.attributes[addressType].resource_id])
                        ) {
                            deferred.resolve(cachedAddresses[$localStorage.order.details.attributes[addressType].resource_id]);
                        } else {
                            if (jfUser.isLoggedIn() && jfUser.get().id) {
                                AccountFactory
                                    .fetchUserAddress($localStorage.order.details.attributes[addressType].resource_id)
                                    .then(function(userAddress) {

                                        if (addressType !== 'billing_address') {
                                            var companyId = jfUser.get().companyId || null;

                                            jfLocation
                                                .postalCodeInService(userAddress.data.attributes.postal_code_id, companyId)
                                                .then(function(validationResult) {
                                                    if (validationResult.valid === true) {
                                                        userAddress.data.attributes.resource_id = userAddress.data.id;

                                                        deferred.resolve(userAddress.data.attributes);
                                                    } else {
                                                        deferred.resolve(null);
                                                    }
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        } else {
                                            userAddress.data.attributes.resource_id = userAddress.data.id;

                                            deferred.resolve(userAddress.data.attributes);
                                        }
                                    }, function(err) {
                                        if (err.status === 404) {
                                            deferred.resolve(null);
                                        } else {
                                            deferred.reject(err);
                                        }
                                    });
                            } else {
                                deferred.resolve(null);
                            }
                        }
                    }

                    return deferred.promise;
                },
                refreshAllAddressesBeforeRecreate: function() {
                    var deferred = $q.defer(),
                        addressesCache = {},
                        factory = this,
                        dataToCopy = {};

                    factory
                        .refreshAddressBeforeRecreate('pickup_address')
                        .then(function(refreshedPickupAddress) {
                            if (angular.isDefined(refreshedPickupAddress) && refreshedPickupAddress !== null) {
                                dataToCopy.pickup_address = refreshedPickupAddress;

                                if (angular.isDefined(refreshedPickupAddress.resource_id)) {
                                    addressesCache[refreshedPickupAddress.resource_id] = refreshedPickupAddress;
                                }
                            }

                            factory
                                .refreshAddressBeforeRecreate('delivery_address', addressesCache)
                                .then(function(refreshedDeliveryAddress) {
                                    if (angular.isDefined(refreshedDeliveryAddress) && refreshedDeliveryAddress !== null) {
                                        dataToCopy.delivery_address = refreshedDeliveryAddress;

                                        if (angular.isDefined(refreshedDeliveryAddress.resource_id)) {
                                            addressesCache[refreshedDeliveryAddress.resource_id] = refreshedDeliveryAddress;
                                        }
                                    }

                                    factory
                                        .refreshAddressBeforeRecreate('billing_address', addressesCache)
                                        .then(function(refreshedBillingAddress) {
                                            if (angular.isDefined(refreshedBillingAddress) && refreshedBillingAddress !== null) {
                                                dataToCopy.billing_address = refreshedBillingAddress;
                                            }

                                            deferred.resolve(dataToCopy);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                recreateOrder: function() {
                    var relationships = {},
                        items = [],
                        additionalDataPromises = [],
                        factory = this;

                    SpinnerFactory.set('global');

                    if (angular.isDefined($localStorage.order)) {
                        items = angular.copy($localStorage.order.items);

                        if (
                            angular.isDefined($localStorage.order.details) &&
                            angular.isDefined($localStorage.order.details.attributes)
                        ) {
                            additionalDataPromises.push(factory.refreshAllAddressesBeforeRecreate());
                        }
                    }

                    $q
                        .all(additionalDataPromises)
                        .then(function(dataToCopy) {
                            factory
                                .resetUserOrder(dataToCopy[0], relationships)
                                .then(function() {
                                    var promises = [];

                                    // delete items from local storage
                                    $localStorage.order.items = [];

                                    angular.forEach(items, function(item) {
                                        var categoryId;
                                        angular.forEach($rootScope.categoriesArr, function(category) {
                                            if (category.name === item.attributes.category_name) {
                                                categoryId = category.id;
                                            }
                                        });
                                        promises.push(
                                            factory.addToOrder(
                                                item.attributes.product_id,
                                                item.attributes.quantity,
                                                categoryId,
                                                item.attributes.category_name
                                            )
                                        );
                                    });

                                    $q.all(promises).then(function() {
                                        SpinnerFactory.unset('global');
                                        $state.reload();
                                    }, function(err) {
                                        SpinnerFactory.unset('global');
                                        $rootScope.$emit('app-log', {msg: err});

                                        $state.reload();
                                    });
                                }, function (err) {
                                    SpinnerFactory.unset('global');
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        }, function(err) {
                            SpinnerFactory.unset('global');
                            $rootScope.$emit('app-error', {err: err});
                        });
                },
                showPickupNotes: function(order) {
                    if (angular.isDefined(order) &&
                        angular.isDefined(order.attributes)) {

                        if (order.attributes.b_level === JF_CONFIG.orderKinds.corporate &&
                            ['completing', 'completed', 'concluded', 'canceled'].indexOf(order.attributes.state) === -1 &&
                            order.attributes.state_for_pickup !== 'concluded' &&
                            angular.isDefined(order.attributes.pickup_address) &&
                            order.attributes.pickup_address !== null &&
                            angular.isDefined(order.attributes.pickup_address.customer_interaction) &&
                            !order.attributes.pickup_address.customer_interaction) {
                            return true;
                        }
                    }
                    return false;
                },
                showDeliveryNotes: function(order) {
                    if (angular.isDefined(order) &&
                        angular.isDefined(order.attributes)) {

                        if (order.attributes.b_level === JF_CONFIG.orderKinds.corporate &&
                            ['completing', 'completed', 'concluded', 'canceled'].indexOf(order.attributes.state) === -1 &&
                            order.attributes.state_for_delivery !== 'concluded' &&
                            angular.isDefined(order.attributes.delivery_address) &&
                            order.attributes.delivery_address !== null &&
                            angular.isDefined(order.attributes.delivery_address.customer_interaction) &&
                            !order.attributes.delivery_address.customer_interaction) {
                            return true;
                        }
                    }
                    return false;
                }
            };
        }]
    );
/**
 * Customer app helpers factory
 */
angular.module('jfApp')
    .factory(
        'CustomerAppHelpersFactory',
        ['$localStorage', '$rootScope', '$injector', '$q', '$window', '$http', 'JF_CONFIG', 'OrderFactory', 'LegalDocumentsFactory', 'LanguageFactory', 'jfConfigUrls', 'jfToken', 'jfUser', function(
            $localStorage,
            $rootScope,
            $injector,
            $q,
            $window,
            $http,
            JF_CONFIG,
            OrderFactory,
            LegalDocumentsFactory,
            LanguageFactory,
            jfConfigUrls,
            jfToken,
            jfUser
        ) {
            'use strict';
            return {
                prepareOrderInitValue: function() {
                    var OrderFactory = $injector.get('OrderFactory');

                    if (angular.isUndefined($localStorage.order) || $localStorage.order.details.id === null) {
                        OrderFactory.createEmptyOrderObject();
                    } else {
                        $rootScope.order = angular.copy($localStorage.order);

                        if (angular.isDefined($window.Sentry)) {
                            $window.Sentry.setExtra({ order_id: $localStorage.order.details.id });
                        }
                    }

                    if (
                        angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                        angular.isUndefined($localStorage.lastPrivateCatalogLocation.postal_code_id)
                    ) {
                        delete $localStorage.lastPrivateCatalogLocation;
                    }

                    if (angular.isDefined($localStorage.cart)) {
                        delete $localStorage.cart;
                    }
                },
                handleCacheInvalidation: function(
                    footerCacheTimestamp,
                    userProfileCacheTimestamp,
                    companyDetailsCacheTimestamp,
                    paymentMethodsCacheTimestamp
                ) {
                    var invalidateFooterCacheCurrent = angular.copy($localStorage.invalidateFooterCache),
                        invalidateUserProfileCacheCurrent = angular.copy($localStorage.invalidateUserProfileCache),
                        invalidateCompanyDetailsCacheCurrent = angular.copy($localStorage.invalidateCompanyDetailsCache),
                        invalidatePaymentMethodsCacheCurrent = angular.copy($localStorage.invalidatePaymentMethodsCache);

                    $localStorage.invalidateFooterCache = footerCacheTimestamp;
                    $localStorage.invalidateUserProfileCache = userProfileCacheTimestamp;
                    $localStorage.invalidateCompanyDetailsCache = companyDetailsCacheTimestamp;
                    $localStorage.invalidatePaymentMethodsCache = paymentMethodsCacheTimestamp;

                    if (invalidateFooterCacheCurrent !== $localStorage.invalidateFooterCache) {
                        delete $localStorage.footerCache;
                    }
                    if (invalidatePaymentMethodsCacheCurrent !== $localStorage.invalidatePaymentMethodsCache) {
                        delete $localStorage.paymentMethodsCache;
                    }
                    if (
                        jfUser.isLoggedIn() &&
                        angular.isDefined(invalidateUserProfileCacheCurrent) &&
                        invalidateUserProfileCacheCurrent !== $localStorage.invalidateUserProfileCache
                    ) {
                        jfUser.update({triggerUserProfileCacheInvalidation: true});
                    }
                    if (
                        jfUser.isLoggedIn() &&
                        invalidateCompanyDetailsCacheCurrent !== $localStorage.invalidateCompanyDetailsCache
                    ) {
                        jfUser.update({triggerCompanyDetailsCacheInvalidation: true});
                    }
                },
                userProfileCacheIsInvalid: function() {
                    return jfUser.isLoggedIn() &&
                        (
                            angular.isUndefined(jfUser.get().updatedAt) ||
                            (
                                ((Math.floor(Date.now()) - jfUser.get().updatedAt) >= JF_CONFIG.userProfileCacheTime) ||
                                (angular.isDefined(jfUser.get().triggerUserProfileCacheInvalidation) && jfUser.get().triggerUserProfileCacheInvalidation === true)
                            )
                        );
                },
                companyDetailsCacheIsInvalid: function() {
                    return jfUser.isLoggedIn() &&
                        jfUser.get().companyId &&
                        jfUser.get().companyId !== null &&
                        (
                            (
                                angular.isDefined($localStorage.companyDetails) &&
                                $localStorage.companyDetails !== null &&
                                angular.isDefined($localStorage.companyDetails.updatedAt) &&
                                (
                                    (Math.floor(Date.now()) - $localStorage.companyDetails.updatedAt) >= JF_CONFIG.companyDetailsCacheTime
                                )
                            ) ||
                            (
                                angular.isDefined(jfUser.get().triggerCompanyDetailsCacheInvalidation) &&
                                jfUser.get().triggerCompanyDetailsCacheInvalidation === true
                            )
                        );


                },
                getCompanyId: function() {
                    var companyId = null;
                    if ((jfUser.get().corporateEnabled && $localStorage.catalogType === JF_CONFIG.accountTypes.company) ||
                        (!jfUser.get().corporateEnabled && jfUser.get().companyId)) {
                        companyId = jfUser.get().companyId;
                    }
                    return companyId;
                },
                companyDetailsAvailable: function() {
                    return jfUser.isLoggedIn() &&
                        jfUser.get().companyId &&
                        jfUser.get().companyId !== null &&
                        (angular.isUndefined($localStorage.companyDetails) || $localStorage.companyDetails === null);
                },
                userProfileUpdateAndReload: function() {
                    var currentUserProfile = angular.copy(jfUser.get()),
                        deferred = $q.defer(),
                        ProductsFactory = $injector.get('ProductsFactory');

                    delete currentUserProfile.updatedAt;

                    jfUser
                        .updateUserData()
                        .then(function() {
                            var newUserProfile = angular.copy(jfUser.get());
                            delete newUserProfile.updatedAt;

                            if (angular.isUndefined($localStorage.catalogType) || $localStorage.catalogType === null) {
                                ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);
                            }

                            if (JSON.stringify(currentUserProfile) !== JSON.stringify(newUserProfile)) {
                                if (currentUserProfile.corporateEnabled !== newUserProfile.corporateEnabled) {
                                    if (newUserProfile.corporateEnabled === false) {
                                        if (angular.isDefined($localStorage.lastPrivateCatalogLocation)) {
                                            ProductsFactory.setCatalogType(JF_CONFIG.accountTypes.personal);

                                            var addressToSave = angular.copy($localStorage.lastPrivateCatalogLocation);
                                            addressToSave.addressable_type = 'Customer';

                                            OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                            OrderFactory
                                                .updateOrder(
                                                    $localStorage.order.details.id,
                                                    {
                                                        company_id: null,
                                                        pickup_address: addressToSave,
                                                        delivery_address: addressToSave
                                                    }
                                                )
                                                .then(function() {
                                                    deferred.resolve(true);
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }
                                    } else {
                                        deferred.resolve();
                                    }
                                } else {
                                    deferred.resolve();
                                }
                            } else {
                                deferred.resolve();
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                downloadFile: function(filePath, filename) {
                    $http
                        .get(
                            decodeURIComponent(jfConfigUrls.get('jfBlogUrl', 'customerApp') + filePath),
                            {
                                S3Request: true,
                                responseType: 'arraybuffer',
                                headers: {
                                    accept: 'application/pdf'
                                }
                            }
                        )
                        .then(
                            function(pdfContent) {
                                var pdfOutput = new Blob([pdfContent.data], { type: 'application/pdf' }),
                                    pdfFileName = 'jonnyfresh-' + filename + '.pdf';

                                var writeDirectory = $window.cordova.file.externalDataDirectory;

                                if ($window.device.platform.toLowerCase() === 'ios') {
                                    writeDirectory = $window.cordova.file.dataDirectory;
                                }

                                $window.resolveLocalFileSystemURL(
                                    writeDirectory,
                                    function(entry) {
                                        entry.getFile(
                                            pdfFileName,
                                            { create: true, exclusive: false },
                                            function (entry) {
                                                var myFileUrl = entry.toURL();

                                                entry.createWriter(
                                                    function (writer) {
                                                        writer.onwriteend = function () {
                                                            $window.cordova.plugins.fileOpener2.open(
                                                                myFileUrl,
                                                                'application/pdf',
                                                                {
                                                                    error: function(e) {
                                                                        $rootScope.$emit(
                                                                            'app-error',
                                                                            {
                                                                                err: {
                                                                                    status: 500,
                                                                                    error: 'Error status: ' + e.status + ' - Error message: ' + e.message
                                                                                }
                                                                            }
                                                                        );
                                                                    }
                                                                }
                                                            );

                                                        };
                                                        writer.write(pdfOutput);
                                                    },
                                                    function (error) {
                                                        $rootScope.$emit(
                                                            'app-error',
                                                            {
                                                                err: {
                                                                    status: 500,
                                                                    error: 'Error: Could not create file writer, ' + error.code
                                                                }
                                                            }
                                                        );
                                                    }
                                                );
                                            }, function (error) {
                                                $rootScope.$emit(
                                                    'app-error',
                                                    {
                                                        err: {
                                                            status: 500,
                                                            error: 'Error: Could not create file, ' + error.code
                                                        }
                                                    }
                                                );
                                            });
                                    }, function(evt) {
                                        $rootScope.$emit(
                                            'app-error',
                                            {
                                                err: {
                                                    status: 500,
                                                    error: 'Error: Could not access file system, ' + evt.target.error.code
                                                }
                                            }
                                        );
                                    }
                                );
                            },
                            function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            }
                        );
                },
                findIncludedById: function(includedResources, idToFind) {
                    var result = null;

                    angular.forEach(includedResources, function(includedResource) {
                        if (result === null && includedResource.id === idToFind) {
                            result = includedResource;
                        }
                    });

                    return result;
                },
                findIncludedByType: function(includedResources, typeToFind) {
                    var result = null;

                    angular.forEach(includedResources, function(includedResource) {
                        if (result === null && includedResource.type === typeToFind) {
                            result = includedResource;
                        }
                    });

                    return result;
                },
                validateJsonApiVersion: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    jfToken
                        .getToken()
                        .then(function() {
                            factory
                                .refreshJsonApiObjects()
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                refreshJsonApiObjects: function() {
                    var deferred = $q.defer();

                    OrderFactory
                        .getOrderDetails(true)
                        .then(function() {
                            if (
                                angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                                angular.isDefined($localStorage.lastPrivateCatalogLocation.postal_code_ref)
                            ) {

                                $localStorage.lastPrivateCatalogLocation.postal_code_id = $localStorage.lastPrivateCatalogLocation.postal_code_ref;
                                delete $localStorage.lastPrivateCatalogLocation.postal_code_ref;
                            }

                            if (
                                angular.isDefined($localStorage.catalogLocation) &&
                                angular.isDefined($localStorage.catalogLocation.postal_code_ref)
                            ) {

                                $localStorage.catalogLocation.postal_code_id = $localStorage.catalogLocation.postal_code_ref;
                                delete $localStorage.catalogLocation.postal_code_ref;
                            }

                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchLegalDocuments: function() {
                    var deferred = $q.defer();

                    LegalDocumentsFactory
                        .get()
                        .$promise
                        .then(function(result) {
                            var legalDocuments = {};
                            var language = LanguageFactory.getActiveLocale().substring(0, 2);

                            result.data.forEach(function(legalDocument) {
                                if (legalDocument.attributes.locale === language) {
                                    legalDocuments[legalDocument.attributes.label] = legalDocument.attributes;
                                }
                            });
    
                            deferred.resolve(legalDocuments);
                        }, function (err) {
                            deferred.reject(err);
                        });

                        return deferred.promise;
                }
            };

        }]

    );
/**
 * Survey Factory
 */
angular.module('jfApp')
    .factory(
        'SurveyFactory',
        ['$rootScope', '$sce', '$window', 'AccountUserProfileFactory', 'LanguageFactory', 'jfUser', 'jfJsonApi', 'JF_CONFIG', 'JF_SHARED_CONFIG', function(
            $rootScope,
            $sce,
            $window,
            AccountUserProfileFactory,
            LanguageFactory,
            jfUser,
            jfJsonApi,
            JF_CONFIG,
            JF_SHARED_CONFIG
        ) {
            'use strict';

            return {
                provider: JF_CONFIG.surveyProvider,
                identity: undefined,
                firstName: undefined,
                lastName: undefined,
                properties: undefined,
                getParams: function(environment) {
                    return JF_CONFIG.zenloop[environment];
                },
                getHashId: function() {
                    var params = this.getParams(this.getEnvironment());
                    var locale = LanguageFactory.getActiveLocale().replace(/_[A-Z]{2}/, '').toUpperCase();

                    var hashIdName = 'hashId<locale>';
                    hashIdName = hashIdName.replace('<locale>', locale);

                    return params[hashIdName];
                },
                getUrl: function() {
                    var environment = this.getEnvironment();
                    var params = this.getParams(environment);
                    var hashId = this.getHashId();
                    var url = params.url.replace('<survey_hash_id>', hashId);
                    if (angular.isDefined(window.jfEbs) && window.jfEbs.JF_ENV !== 'Production') {
                        if (environment === 'desktop') {
                            url = url + '&isTest=true';
                        } else {
                            url = url + '?is_a_test=true';
                        }
                    }
                    return $sce.trustAsResourceUrl(url);
                },
                getImageUrl: function() {
                    var hashId = this.getHashId();
                    var url = this.getParams('mobile').imageUrl.replace('<survey_hash_id>', hashId);
                    return $sce.trustAsResourceUrl(url);
                },
                showSurvey: function(frontendData) {
                    if (angular.isDefined(frontendData) && frontendData !== null) {
                        if (angular.isDefined(frontendData.order_survey_showed_at)) {
                            var surveyShowedAt = new Date(frontendData.order_survey_showed_at);
                            var surveyshowAgainAt = surveyShowedAt.setMonth(surveyShowedAt.getMonth() + 3);
                            var today = new Date().getTime();
                            if (surveyshowAgainAt > today) {
                                return false;
                            }
                        }
                    }
                    return true;
                },
                setSurvey: function(email, firstName, lastName, customerType, orderType, city, postalCode) {
                    var properties = this.setProperties(customerType, orderType, city, postalCode);
                    var survey = window.Zenloop || {};

                    this.identity = email;
                    this.firstName = firstName;
                    this.lastName = lastName;
                    this.properties = properties;

                    survey.recipient = {
                        identity: this.identity,
                        identity_type: 'email',
                        first_name: this.firstName,
                        last_name: this.lastName,
                        properties: this.properties
                    };

                    // now the survey is ready to be shown, now we save data from survey
                    this.saveData();
                },
                isMobile: {
                    Android: function() {
                        return $window.navigator.userAgent.match(/Android/i) ? 'Android' : undefined;
                    },
                    BlackBerry: function() {
                        return $window.navigator.userAgent.match(/BlackBerry/i) ? 'BlackBerry' : undefined;
                    },
                    IOS: function() {
                        return $window.navigator.userAgent.match(/iPhone|iPad|iPod/i) ? 'IOS' : undefined;
                    },
                    Opera: function() {
                        return $window.navigator.userAgent.match(/Opera Mini/i) ? 'Opera' : undefined;
                    },
                    Windows: function() {
                        return $window.navigator.userAgent.match(/IEMobile/i) ? 'Windows' : undefined;
                    },
                    any: function() {
                        return (this.Android() || this.BlackBerry() || this.IOS() || this.Opera() || this.Windows());
                    }
                },
                isDesktop: {
                    Windows: function() {
                        return $window.navigator.userAgent.match(/Win/i) ? 'Windows' : undefined;
                    },
                    Mac: function() {
                        return $window.navigator.userAgent.match(/Mac/i) ? 'MacOS' : undefined;
                    },
                    Unix: function() {
                        return $window.navigator.userAgent.match(/X11/i) ? 'Unix' : undefined;
                    },
                    Linux: function() {
                        return $window.navigator.userAgent.match(/Linux/i) ? 'Linux' : undefined;
                    },
                    any: function() {
                        return (this.Windows() || this.Mac() || this.Unix() || this.Linux()) ?
                            (this.Windows() || this.Mac() || this.Unix() || this.Linux()) :
                            'Unknown';
                    }
                },
                getDeviceType: function() {
                    var deviceType = 'Computer';
                    // breakpoints based in https://material.io/design/layout/responsive-layout-grid.html#breakpoints
                    if ($rootScope.$mdMedia('xs')) {
                        deviceType = 'Phone';
                    } else if ($rootScope.$mdMedia('sm')) {
                        if ($rootScope.$mdMedia('landscape') && $rootScope.$mdMedia('max-width: 959px')) {
                            deviceType = 'Phone';
                        } else {
                            deviceType = 'Tablet';
                        }
                    } else if ($rootScope.$mdMedia('md')) {
                        deviceType = 'Tablet';
                    }
                    return deviceType;
                },
                getEnvironment: function() {
                    return this.getDeviceType() === 'Computer' ? 'desktop' : 'mobile';
                },
                setProperties: function(customerType, orderType, city, postalCode) {
                    var deviceType = this.getDeviceType();

                    return {
                        customerType: customerType,
                        userType: orderType === 'corp' ? 'Corporate' : orderType.toUpperCase(),
                        city: city,
                        postalCode: postalCode,
                        deviceType: deviceType,
                        technology: $rootScope.mobileAppMode ? 'App' : 'Website',
                        appVersion: angular.isDefined($window.jfAppVersion) ? $window.jfAppVersion : 'unknown',
                        deviceModel: (angular.isDefined($window.device) && angular.isDefined($window.device.model)) ? $window.device.model : 'unknown',
                        os: this.isMobile.any() ? this.isMobile.any() : this.isDesktop.any(),
                        osVersion: (angular.isDefined($window.device) && angular.isDefined($window.device.version)) ? $window.device.version : 'unknown',
                        userAgent: (angular.isDefined($window.navigator) && angular.isDefined($window.navigator.userAgent)) ? $window.navigator.userAgent : 'unknown'
                    };
                },
                saveData: function() {
                    var factory = this;
                    AccountUserProfileFactory
                        .update(
                            { id: jfUser.get().profileId },
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.profile,
                                {
                                    frontend_data: {
                                        order_survey_provider: factory.provider,
                                        order_survey_showed_at: new Date()
                                    }
                                },
                                { id: jfUser.get().profileId }
                            )
                        )
                        .$promise
                        .then(function() {

                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });
                }
            };
        }]
    );
/**
 * Language factory
 */
angular.module('jfApp')
    .factory(
        'LanguageFactory',
        ['$rootScope', '$q', '$translate', '$localStorage', '$cookies', '$state', '$injector', 'jfUser', 'jfJsonApi', 'jfConfigUrls', 'SpinnerFactory', 'AccountUserProfileFactory', 'OrderFactory', 'JF_SHARED_CONFIG', 'JF_CONFIG', function(
            $rootScope,
            $q,
            $translate,
            $localStorage,
            $cookies,
            $state,
            $injector,
            jfUser,
            jfJsonApi,
            jfConfigUrls,
            SpinnerFactory,
            AccountUserProfileFactory,
            OrderFactory,
            JF_SHARED_CONFIG,
            JF_CONFIG
        ) {
            'use strict';

            return {
                /**
                 * update blog URL
                 */
                updateBlogUrl: function(key) {
                    $rootScope.blogUrl = jfConfigUrls.get('jfBlogUrl', 'customerApp');
                    if (key !== JF_CONFIG.defaultLocale) {
                        $rootScope.blogUrl += '/' + JF_CONFIG.locales[key].shortName;
                    }
                },
                getLocale: function() {
                    return $localStorage.shopLocale ? $localStorage.shopLocale : JF_CONFIG.defaultLocale;
                },
                getLocaleFromDevice: function() {
                    if (angular.isUndefined(navigator.language) || navigator.language === null) {
                        return null;
                    } else {
                        return navigator.language.replace('-', '_');
                    }
                },
                /**
                 * change the locale but don't save it in user preferences
                 */
                use: function(key) {
                    this.updateBlogUrl(key);
                    return $translate.use(key);
                },
                /**
                 * translate the app based in i18n keys
                 */
                changeLocale: function(key, page, event, reload, sendEvent) {
                    reload = reload ? reload : true;
                    sendEvent = sendEvent ? sendEvent : true;

                    var locale = key ? key : JF_CONFIG.defaultLocale,
                        LanguageFactory = this;

                    SpinnerFactory.set('global');

                    LanguageFactory
                        .use(locale)
                        .then(function() {
                            SpinnerFactory.unset('global');
                            LanguageFactory.saveLocale(locale, page, event, reload, sendEvent);
                        }, function(err) {
                            SpinnerFactory.unset('global');
                            $rootScope.$emit('app-log', {msg: 'Wrong locale code: ' + err});

                            LanguageFactory.saveLocale(JF_CONFIG.defaultLocale, page, event, reload, sendEvent);
                        });
                },
                /**
                 * Save new locale wherever it's needed
                 */
                saveLocale: function(locale, page, event, reload, sendEvent) {
                    var ProductsFactory = $injector.get('ProductsFactory');

                    if (
                        locale === 'en_DE' &&
                        $localStorage.catalogLocation &&
                        $localStorage.catalogLocation.country_code === 'AT'
                    ) {
                        locale = 'en_AT';
                    }

                    SpinnerFactory.set('global');

                    $localStorage.shopLocale = locale;

                    $cookies.put(
                        JF_CONFIG.localeCookieName,
                        locale,
                        {
                            domain: JF_CONFIG.cookies_domain,
                            samesite: 'lax',
                            secure: true
                        }
                    );

                    if (sendEvent) {
                        $rootScope.sendGAEvent(page, event + locale.toUpperCase());
                    }

                    var promises = [];
                    if (angular.isDefined(jfUser.get().id) && jfUser.get().locale !== locale) {
                        promises.push(
                            AccountUserProfileFactory
                                .update(
                                    { id: jfUser.get().profileId },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.profile,
                                        { preferred_locale: locale },
                                        { id: jfUser.get().profileId }
                                    )
                                )
                                .$promise
                        );
                    }

                    if (angular.isDefined($localStorage.order) &&
                        angular.isDefined($localStorage.order.details) &&
                        angular.isDefined($localStorage.order.details.id) &&
                        $localStorage.order.details.attributes.locale !== locale
                    ) {
                        promises.push(
                            OrderFactory
                                .updateOrder(
                                    $localStorage.order.details.id,
                                    {
                                        locale: locale
                                    }
                                )
                        );
                    }

                    $q.all(promises)
                        .then(function() {
                            SpinnerFactory.unset('global');

                            if (angular.isDefined(jfUser.get().id) && jfUser.get().locale !== locale) {
                                jfUser.update({
                                    locale: locale
                                });
                            }
                            if (!$state.current.abstract && reload && !ProductsFactory.locationParamsAvailable()) {
                                $state.reload();
                            }
                        }, function(err) {
                            SpinnerFactory.unset('global');
                            $rootScope.$emit('app-error', {err: err});
                        });
                },
                getActiveLocale: function() {
                    var activeLocale,
                        factory = this;

                    // is user coming from device?
                    if ($rootScope.mobileAppMode) {
                        if (angular.isUndefined(jfUser.get().id)) {
                            var deviceLocale = factory.getLocaleFromDevice();

                            // get locale from device, if it is a valid locale to us
                            if (angular.isUndefined($localStorage.shopLocale)) {
                                angular.forEach(factory.getLocaleAsArray(), function(locale) {
                                    if (locale.locale === deviceLocale) {
                                        activeLocale = deviceLocale;
                                    }
                                });
                            }
                            // if the user already clicked in language switcher, don't change it
                            activeLocale = $localStorage.shopLocale || activeLocale;
                        } else {
                            // if user is logged in, get locale from the profile
                            if (angular.isDefined(jfUser.get().locale)) {
                                activeLocale = jfUser.get().locale;
                            }
                        }
                    // or desktop?
                    } else {
                        activeLocale = factory.getLocaleFromCookie();
                    }

                    return JF_CONFIG.locales[activeLocale] ? activeLocale : JF_CONFIG.defaultLocale;
                },
                /**
                * returns the i18n item from constants of current language
                */
                getActiveLocaleItem: function() {
                    return JF_CONFIG.locales[this.getLocale()] || JF_CONFIG.locales[JF_CONFIG.defaultLocale];
                },
                /**
                 * return locale from cookie
                 */
                getLocaleFromCookie: function() {
                    return $cookies.get(JF_CONFIG.localeCookieName);
                },
                /**
                 * return all languages as array
                 */
                getLocaleAsArray: function() {
                    var items = [];
                    Object.keys(JF_CONFIG.locales).forEach(function(key) {
                        var item = {};
                        item.id = key;

                        Object.keys(JF_CONFIG.locales[key]).forEach(function (itemKey) {
                            item[itemKey] = JF_CONFIG.locales[key][itemKey];
                        });

                        items.push(item);
                    });
                    return items;
                }
            };
        }]
    );
/**
 * Adyen Signature factory
 */
angular.module('jfApp')
    .factory(
        'AdyenSignature',
        ['JF_CONFIG', function(
            JF_CONFIG
        ) {
            'use strict';

            return {
                hmacKey: JF_CONFIG.adyenHmacKey,
                generateSignature: function(requestData) {
                    var signature = this.sortObj(requestData),
                        hexadecimalKey = CryptoJS.enc.Hex.parse(this.hmacKey);

                    signature = this.escapeValues(signature);
                    signature = this.concatenateObj(signature);

                    return CryptoJS.HmacSHA256(signature, hexadecimalKey).toString(CryptoJS.enc.Base64);
                },
                sortObj: function(objToSort) {
                    var result = [],
                        keys = Object.keys(objToSort);

                    keys.sort();

                    angular.forEach(keys, function(key) {
                        var objToAdd = {};
                        objToAdd[key] = objToSort[key];

                        result.push(objToAdd);
                    });

                    return result;
                },
                escapeValues: function(arrOfObjectsToEscape) {
                    angular.forEach(arrOfObjectsToEscape, function(objToEscape, index) {
                        var objectKey = Object.keys(objToEscape)[0];

                        objToEscape[objectKey] = objToEscape[objectKey] === null ? '' : objToEscape[objectKey];
                        objToEscape[objectKey] = objToEscape[objectKey].replace(/\\/g, '\\\\').replace(/:/g, '\\:');

                        arrOfObjectsToEscape[index] = objToEscape;
                    });

                    return arrOfObjectsToEscape;
                },
                concatenateObj: function(requestDataArr) {
                    var objKeys = [],
                        objValues = [];

                    angular.forEach(requestDataArr, function(arrObj) {
                        objKeys.push(Object.keys(arrObj)[0]);
                        objValues.push(arrObj[Object.keys(arrObj)[0]]);
                    });

                    return objKeys.join(':') + ':' + objValues.join(':');
                }
            };
        }]
    );
/**
 * Adyen factory
 */
angular
    .module('jfApp')
    .factory(
        'AdyenFactory',
        ['$window', '$q', '$localStorage', '$rootScope', 'AccountUsersBillingAgreements', 'LanguageFactory', 'AccountAdyenPaymentMethods', 'JF_CONFIG', 'JF_SHARED_CONFIG', 'jfJsonApi', 'jfConfigUrls', function(
            $window,
            $q,
            $localStorage,
            $rootScope,
            AccountUsersBillingAgreements,
            LanguageFactory,
            AccountAdyenPaymentMethods,
            JF_CONFIG,
            JF_SHARED_CONFIG,
            jfJsonApi,
            jfConfigUrls
        ) {
            'use strict';

            return {
                scriptInjected: false,
                ccFormSubmitDisabled: true,
                sepaFormSubmitDisabled: true,
                adyenOriginKey: angular.isDefined($window.device) ? JF_CONFIG.adyenOriginKey[$window.device.platform.toLowerCase()] : JF_CONFIG.adyenOriginKey.desktop,
                loadScript: function() {
                    var factory = this;

                    factory.scriptInjected = true;

                    var s = document.createElement('script');
                    s.src = jfConfigUrls.get('adyenCheckoutWidgetJsUrl', 'customerApp');
                    s.setAttribute('crossorigin', 'anonymous');
                    s.async = true;
                    s.addEventListener('load', function() {
                        factory.scriptInjected = true;
                    });
                    document.body.appendChild(s);
                },
                loadCss: function() {
                    var adyenCss = document.createElement('link');
                    adyenCss.rel = 'stylesheet';
                    adyenCss.setAttribute('crossorigin', 'anonymous');
                    adyenCss.href = jfConfigUrls.get('adyenCheckoutWidgetCssUrl', 'customerApp');

                    document.head.insertBefore(adyenCss, document.head.childNodes[ document.head.childNodes.length - 1 ].nextSibling);
                },
                isScriptLoaded: function() {
                    return angular.isDefined($window.AdyenCheckout);
                },
                initCCForm: function(elementToMount) {
                    $rootScope.jfShared.adyen = {};

                    var factory = this;

                    $window.AdyenCheckout({
                        locale: LanguageFactory.getActiveLocale(),
                        environment: JF_CONFIG.environment === 'Production' ? 'live' : 'test',
                        clientKey: factory.adyenOriginKey,
                        onChange: function(state) {
                            factory.ccFormSubmitDisabled = !state.isValid;

                            if (state.isValid) {
                                $rootScope.jfShared.adyen.ccFormValues = state.data;
                            }
                        }
                    }).then(function(checkoutHandler) {
                        checkoutHandler.create('card', {
                            hasHolderName: true,
                            holderNameRequired: true,
                            brands: ['amex', 'diners', 'discover', 'maestro', 'mc', 'visa'],
                            styles: {
                                base: {
                                    color: '#394c57',
                                    fontSize: '14px',
                                    fontFamily: 'Quicksand,Helvetica,sans-serif'
                                },
                                error: {
                                    color: '#e16749'
                                },
                                validated: {
                                    color: '#339966'
                                },
                                placeholder: {
                                    color: '#b7c1c6',
                                    fontWeight: 300
                                }
                            },
                            onFieldValid: function(fieldDetails) {
                                if (angular.isDefined(fieldDetails.endDigits)) {
                                    $rootScope.jfShared.adyen.ccEndDigits = fieldDetails.endDigits;
                                }
                            }
                        }).mount(elementToMount);
                    }, function(err) {
                        $rootScope.$emit('app-error', {err: err, silent: true});
                    });
                },
                sendAdyenBillingAggreement: function(data) {
                    var defer = $q.defer();

                    data.locale = LanguageFactory.getActiveLocale();

                    AccountUsersBillingAgreements
                        .save(
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.adyen_billing_aggreements,
                                data,
                                {}
                            )
                        )
                        .$promise
                        .then(function(result) {
                            defer.resolve(result);
                        }, function(err) {
                            defer.reject(err);
                        });

                    return defer.promise;
                },
                initSepa: function(elementToMount) {
                    $rootScope.jfShared.adyen = {};

                    var factory = this;

                    $window.AdyenCheckout({
                        locale: LanguageFactory.getActiveLocale(),
                        environment: JF_CONFIG.environment === 'Production' ? 'live' : 'test',
                        clientKey: factory.adyenOriginKey,
                        onChange: function(state) {
                            factory.sepaFormSubmitDisabled = !state.isValid;

                            if (state.isValid) {
                                $rootScope.jfShared.adyen.sepaFormValues = state.data;
                            }
                        }
                    }).then(function(checkoutHandler) {
                        checkoutHandler.create('sepadirectdebit').mount(elementToMount);
                    }, function(err) {
                        $rootScope.$emit('app-error', {err: err, silent: true});
                    });
                },
                initApplePay: function(elementToMount) {
                    var factory = this;

                    if (!$localStorage.order.details.attributes.delivery_address) {
                        return;
                    }

                    $window.AdyenCheckout({
                        locale: LanguageFactory.getActiveLocale(),
                        environment: JF_CONFIG.environment === 'Production' ? 'live' : 'test',
                        clientKey: factory.adyenOriginKey,
                        onChange: function(state) {
                            $rootScope.$emit('jf-apple-pay-response', state.data);
                        }
                    }).then(function(checkoutHandler) {
                        AccountAdyenPaymentMethods
                            .get({
                                'filter[country_code]': $localStorage.order.details.attributes.delivery_address.country_code
                            })
                            .$promise
                            .then(function(adyenPaymentMethods) {
                                angular.forEach(adyenPaymentMethods.data, function(paymentMethod) {
                                    if (paymentMethod.attributes.type === 'applepay') {
                                        var applePayComponent = checkoutHandler.create('applepay', {
                                            amount: {
                                                value: 0,
                                                currency: 'EUR'
                                            },
                                            configuration: paymentMethod.attributes.configuration,
                                            countryCode: paymentMethod.attributes.country_code
                                        });

                                        applePayComponent
                                            .isAvailable()
                                            .then(function() {
                                                $rootScope.$emit('jf-apple-pay-available');
                                                applePayComponent.mount(elementToMount);
                                            })
                                            .catch(function(err) {
                                                console.log(err);
                                                // $rootScope.$emit('app-error', {err: err, silent: true});
                                            });
                                    }
                                });
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    }, function(err) {
                        $rootScope.$emit('app-error', {err: err, silent: true});
                    });
                }
            };
        }]
    );
/**
 * Corporate factory
 */
angular
    .module('jfApp')
    .factory(
        'CorporateFactory',
        ['$q', '$rootScope', 'AccountCompanyAddresses', 'jfUser', function(
            $q,
            $rootScope,
            AccountCompanyAddresses,
            jfUser
        ) {
            'use strict';

            return {
                validateCorpMembership: function(selectedPostalCodeId) {
                    var deferred = $q.defer(),
                        postalCodeValid = false;

                    AccountCompanyAddresses
                        .get({
                            'filter[addressable_id]': jfUser.get().companyId,
                            'filter[addressable_type]': 'Company'
                        })
                        .$promise
                        .then(function(companyAddresses) {
                            angular.forEach(companyAddresses.data, function(companyAddress) {
                                if (
                                    postalCodeValid === false &&
                                    companyAddress.attributes.postal_code_id === selectedPostalCodeId
                                ) {
                                    postalCodeValid = true;
                                }
                            });

                            deferred.resolve(postalCodeValid);
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err, silent: true});

                            deferred.resolve(postalCodeValid);
                        });

                    return deferred.promise;
                }
            };
        }]
    );
angular
  .module('jfApp')
  .factory(
    'ExternalRedirectsFactory',
    ['$window', '$state', '$timeout', 'jfHelper', function(
      $window,
      $state,
      $timeout,
      jfHelper
    ) {
      'use strict';
      return {
        openUrl: function(url, pageTitle) {
          if (angular.isDefined($window.SafariViewController)) {
            var isAvailableCheckDone = false;

            $timeout(function() {
              if (!isAvailableCheckDone) {
                isAvailableCheckDone = true;
                $state.go('wp-content', { title: pageTitle || '', url: url });
              }
            }, 1000);

            $window.SafariViewController.isAvailable(function (available) {
              if (!isAvailableCheckDone) {
                isAvailableCheckDone = true;

                if (available) {
                  $window.SafariViewController.show(
                    {
                      url: url,
                      hidden: false,
                      animated: true,
                      enterReaderModeIfAvailable: false,
                      transition: 'slide',
                      tintColor: '#0080c8',
                      barColor: '#0080c8',
                      controlTintColor: '#ffffff',
                      showDefaultShareMenuItem: false
                    }
                  );
                } else {
                  $state.go('wp-content', { title: pageTitle || '', url: url });
                }
              }
            });
          } else {
            if (jfHelper.mobileAppMode) {
              $state.go('wp-content', { title: pageTitle || '', url: url });
            } else {
              $window.location.href = url;
            }
          }
        }
      };
    }]
 );
/**
 * Checkout factory
 */
angular.module('jfApp')
    .factory(
        'CheckoutFactory',
        ['$rootScope', '$q', '$localStorage', '$filter', '$mdDialog', '$injector', '$window', 'base64', 'jfJsonApi', 'OrderFactory', 'SpinnerFactory', 'AccountUserProfileFactory', 'CustomerAppHelpersFactory', 'LogisticAppointmentsPickupFactory', 'LogisticAppointmentsDeliveryFactory', 'BooksOrdersServiceableFactory', 'LogisticTripsFactory', 'AccountUsersBillingAgreements', 'BooksPaymentsFactory', 'BooksPaymentMethodsFactory', 'BooksPaymentMethodsLocalizedFactory', 'BooksOrdersCommitFactory', 'BooksOrderRemoveDestroyableOrderItemsFactory', 'jfDialog', 'jfUser', 'jfHelper', 'JF_CONFIG', 'JF_SHARED_CONFIG', function(
            $rootScope,
            $q,
            $localStorage,
            $filter,
            $mdDialog,
            $injector,
            $window,
            base64,
            jfJsonApi,
            OrderFactory,
            SpinnerFactory,
            AccountUserProfileFactory,
            CustomerAppHelpersFactory,
            LogisticAppointmentsPickupFactory,
            LogisticAppointmentsDeliveryFactory,
            BooksOrdersServiceableFactory,
            LogisticTripsFactory,
            AccountUsersBillingAgreements,
            BooksPaymentsFactory,
            BooksPaymentMethodsFactory,
            BooksPaymentMethodsLocalizedFactory,
            BooksOrdersCommitFactory,
            BooksOrderRemoveDestroyableOrderItemsFactory,
            jfDialog,
            jfUser,
            jfHelper,
            JF_CONFIG,
            JF_SHARED_CONFIG
        ) {
            'use strict';

            return {
                isNewCustomer: false,
                initCheckoutModel: function() {
                    if (angular.isUndefined($rootScope.jfShared.checkout)) {
                        this.setDefaultCheckoutModel();
                    }
                },
                setDefaultCheckoutModel: function() {
                    $rootScope.jfShared.checkout = {
                        userBillingAgreements: {
                            cc: null,
                            payPal: null,
                            sepa: null,
                            app: null
                        },
                        companyAddresses: {},
                        userAddresses: {},
                        addressesLoading: true
                    };
                },
                assignCheckoutDefaultValues: function() {
                    if (angular.isDefined(jfUser.get().id)) {
                        this.assignCheckoutPickupDeliveryNote();
                    }
                },
                assignCheckoutPickupDeliveryNote: function() {
                    if (
                        angular.isUndefined($localStorage.order.details.attributes.pickup_note) ||
                        angular.isUndefined($localStorage.order.details.attributes.delivery_note) ||
                        $localStorage.order.details.attributes.pickup_note === null ||
                        $localStorage.order.details.attributes.delivery_note === null
                    ) {
                        this.getDefaultNotes();
                    }
                },
                getDefaultNotes: function() {
                    SpinnerFactory.set('checkout-notes');
                    AccountUserProfileFactory
                        .get({
                            'filter[user_id]': jfUser.get().id
                        })
                        .$promise
                        .then(function(userProfile) {
                            SpinnerFactory.unset('checkout-notes');
                            if (
                                angular.isUndefined($localStorage.order.details.attributes.pickup_note) ||
                                $localStorage.order.details.attributes.pickup_note === null &&
                                $localStorage.order.additionalInfo.pickupNote === null &&
                                $rootScope.order.additionalInfo.pickupNote === null &&
                                userProfile.data[0].attributes.pickup_note !== ''
                            ) {
                                $rootScope.order.additionalInfo.pickupNote = userProfile.data[0].attributes.pickup_note;
                                $localStorage.order.additionalInfo.pickupNote = userProfile.data[0].attributes.pickup_note;
                            }
                            if (
                                angular.isUndefined($localStorage.order.details.attributes.delivery_note) ||
                                $localStorage.order.details.attributes.delivery_note === null &&
                                $rootScope.order.additionalInfo.deliveryNote === null &&
                                $localStorage.order.additionalInfo.deliveryNote === null &&
                                userProfile.data[0].attributes.delivery_note !== ''
                            ) {
                                $rootScope.order.additionalInfo.deliveryNote = userProfile.data[0].attributes.delivery_note;
                                $localStorage.order.additionalInfo.deliveryNote = userProfile.data[0].attributes.delivery_note;
                            }
                            if (
                                angular.isUndefined($localStorage.order.details.attributes.special_instructions) ||
                                $localStorage.order.details.attributes.special_instructions === null &&
                                $rootScope.order.additionalInfo.specialInstructions === null &&
                                $localStorage.order.additionalInfo.specialInstructions === null &&
                                userProfile.data[0].attributes.special_instructions !== ''
                            ) {
                                $rootScope.order.additionalInfo.specialInstructions = userProfile.data[0].attributes.special_instructions;
                                $localStorage.order.additionalInfo.specialInstructions = userProfile.data[0].attributes.special_instructions;
                            }
                        }, function(err) {
                            SpinnerFactory.unset('checkout-notes');
                            $rootScope.$emit('app-error', {err: err});
                        });
                },
                fetchPickupAppointments: function(address, companyId, customNowDate, origin) {
                    SpinnerFactory.set([
                        'account-my-orders-active',
                        'account-my-orders-completed',
                        'account-my-orders-canceled'
                    ]);

                    var deferred = $q.defer(),
                        nowDate = jfHelper.getCurrentIsoTime(),
                        company = origin === 'checkout' ? ($localStorage.catalogType === JF_CONFIG.accountTypes.personal ? null : companyId) : companyId;

                    if (angular.isDefined(customNowDate) && customNowDate !== null) {
                        nowDate = new Date(customNowDate).toISOString();
                    }

                    var appointmentsFetchQuery = {
                            'filter[by_location][country_code]': address.country_code,
                            'filter[by_location][city]': address.city,
                            'filter[by_location][postal_code]': address.postal_code,
                            'filter[by_location][postal_code_id]': address.postal_code_id,
                            'filter[postal_address_id]': address.postal_address_id,
                            'filter[now]': nowDate,
                            'filter[days]': 12,
                            'filter[company_id]': company
                        };

                    this
                        .fetchPickupAppointmentQuery(appointmentsFetchQuery)
                        .then(function(results) {
                            SpinnerFactory.unset([
                                'account-my-orders-active',
                                'account-my-orders-completed',
                                'account-my-orders-canceled'
                            ]);
                            deferred.resolve(results);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchDeliveryAppointments: function(order, address, companyId, origin) {
                    SpinnerFactory.set([
                        'account-my-orders-active',
                        'account-my-orders-completed',
                        'account-my-orders-canceled'
                    ]);

                    var deferred = $q.defer(),
                        pickupTime = order.details.attributes.state === JF_CONFIG.orderStates.commenced ? order.details.attributes.pickup_start_ts : order.details.attributes.scheduled_pickup_start_ts,
                        company = origin === 'checkout' ? ($localStorage.catalogType === JF_CONFIG.accountTypes.personal ? null : companyId) : companyId;

                    var appointmentsFetchQuery = {
                            'filter[by_location][country_code]': address.country_code,
                            'filter[by_location][city]': address.city,
                            'filter[by_location][postal_code]': address.postal_code,
                            'filter[by_location][postal_code_id]': address.postal_code_id,
                            'filter[postal_address_id]': address.postal_address_id,
                            'filter[pickup_time]': pickupTime,
                            'filter[days]': 12,
                            'filter[company_id]': company,
                            'filter[processing_time]': order.details.attributes.processing_time
                        };

                    this
                        .fetchDeliveryAppointmentQuery(appointmentsFetchQuery)
                        .then(function(results) {
                            SpinnerFactory.unset([
                                'account-my-orders-active',
                                'account-my-orders-completed',
                                'account-my-orders-canceled'
                            ]);
                            deferred.resolve(results);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchPickupAppointmentQuery: function(appointmentsFetchQuery) {
                    var deferred = $q.defer();
                    LogisticAppointmentsPickupFactory
                        .get(appointmentsFetchQuery)
                        .$promise
                        .then(function(results) {
                            deferred.resolve(results.data);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchDeliveryAppointmentQuery: function(appointmentsFetchQuery) {
                    var deferred = $q.defer();
                    LogisticAppointmentsDeliveryFactory
                        .get(appointmentsFetchQuery)
                        .$promise
                        .then(function(results) {
                            deferred.resolve(results.data);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                validateTimeSlots: function() {
                    var deferred = $q.defer();

                    BooksOrdersServiceableFactory
                        .get({id: $localStorage.order.details.id})
                        .$promise
                        .then(function(validationResult) {
                            deferred.resolve(validationResult);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                shouldClearPickupTimeSlot: function(userAddresses, selectedPickupAddressId) {
                    // Check if pickup time is already selected, if yes, continue
                    if (
                        (angular.isDefined($localStorage.order.details.attributes.pickup_start_time) && $localStorage.order.details.attributes.pickup_start_time !== null)
                    ) {
                        // Check if user addresses list is empty, if yes, clear time slots
                        if (angular.isUndefined(userAddresses)) {
                            return true;
                        } else {
                            // Check if cart address is still on the user addresses list, if not, clear time slots
                            if (angular.isUndefined(userAddresses[selectedPickupAddressId])) {
                                return true;
                            } else {
                                return $localStorage.order.details.attributes.pickup_address === null || $localStorage.order.details.attributes.pickup_address.postal_code !== userAddresses[selectedPickupAddressId].attributes.postal_code;
                            }
                        }
                    }

                    return false;
                },
                shouldClearDeliveryTimeSlot: function(userAddresses, selectedDeliveryAddressId) {
                    // Check if delivery time is already selected, if yes, continue
                    if (
                        (angular.isDefined($localStorage.order.details.attributes.delivery_start_time) && $localStorage.order.details.attributes.delivery_start_time !== null)
                    ) {
                        // Check if user addresses list is empty, if yes, clear time slots
                        if (angular.isUndefined(userAddresses)) {
                            return true;
                        } else {
                            // Check if cart address is still on the user addresses list, if not, clear time slots
                            if (angular.isUndefined(userAddresses[selectedDeliveryAddressId])) {
                                return true;
                            } else {
                                return $localStorage.order.details.attributes.delivery_address === null || $localStorage.order.details.attributes.delivery_address.postal_code !== userAddresses[selectedDeliveryAddressId].attributes.postal_code;
                            }
                        }
                    }

                    return false;
                },
                fetchOrderTrip: function(orderId, tripType, ical) {
                    var deferred = $q.defer();

                    var options = {
                        'filter[order_id]' : orderId,
                        'filter[type]': tripType,
                        'ical': ical
                    };

                    LogisticTripsFactory
                        .get(options)
                        .$promise
                        .then(function(trips) {
                            deferred.resolve(trips.data[0]);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                saveUserNotes: function() {
                    var deferred = $q.defer(),
                        notesToUpdate = {};

                    if (
                        $localStorage.order.additionalInfo.pickupNote !== $localStorage.order.details.attributes.pickup_note ||
                        $rootScope.order.additionalInfo.pickupNote !== $localStorage.order.details.attributes.pickup_note
                    ) {
                        notesToUpdate.pickup_note = $rootScope.order.additionalInfo.pickupNote;
                    }

                    if (
                        $localStorage.order.additionalInfo.deliveryNote !== $localStorage.order.details.attributes.delivery_note ||
                        $rootScope.order.additionalInfo.deliveryNote !== $localStorage.order.details.attributes.delivery_note
                    ) {
                        notesToUpdate.delivery_note = $rootScope.order.additionalInfo.deliveryNote;
                    }

                    if (
                        $localStorage.order.additionalInfo.specialInstructions !== $localStorage.order.details.attributes.special_instructions ||
                        $rootScope.order.additionalInfo.specialInstructions !== $localStorage.order.details.attributes.special_instructions
                    ) {
                        notesToUpdate.special_instructions = $rootScope.order.additionalInfo.specialInstructions;
                    }

                    if ($rootScope.countObjKeys(notesToUpdate) > 0) {
                        OrderFactory
                            .updateOrder(
                                $localStorage.order.details.id,
                                notesToUpdate
                            )
                            .then(function() {
                                if (angular.isDefined(notesToUpdate.pickup_note)) {
                                    $localStorage.order.additionalInfo.pickupNote = $localStorage.order.details.attributes.pickup_note;
                                    $rootScope.order.additionalInfo.pickupNote = $localStorage.order.details.attributes.pickup_note;
                                }
                                if (angular.isDefined(notesToUpdate.delivery_note)) {
                                    $localStorage.order.additionalInfo.deliveryNote = $localStorage.order.details.attributes.delivery_note;
                                    $rootScope.order.additionalInfo.deliveryNote = $localStorage.order.details.attributes.delivery_note;
                                }
                                if (angular.isDefined(notesToUpdate.special_instructions)) {
                                    $localStorage.order.additionalInfo.specialInstructions = $localStorage.order.details.attributes.special_instructions;
                                    $rootScope.order.additionalInfo.specialInstructions = $localStorage.order.details.attributes.special_instructions;
                                }

                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });

                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                },
                fetchUserBillingAgreements: function(countryCode, customerId) {
                    var deferred = $q.defer();

                    SpinnerFactory.set('checkout-payment-methods');

                    AccountUsersBillingAgreements
                        .get({
                            'filter[user_id]': customerId || jfUser.get().id,
                            'filter[country_code]': countryCode
                        })
                        .$promise
                        .then(function(result) {
                            SpinnerFactory.unset('checkout-payment-methods');

                            $rootScope.jfShared.checkout.userBillingAgreements = {
                                cc: [],
                                payPal: [],
                                sepa: [],
                                app: []
                            };

                            angular.forEach(result.data, function(billingAgreement) {
                                if (billingAgreement.attributes.variant.indexOf('_applepay') > -1) {
                                    $rootScope.jfShared.checkout.userBillingAgreements.app.push(billingAgreement);
                                } else if (billingAgreement.attributes.variant === 'paypal') {
                                    $rootScope.jfShared.checkout.userBillingAgreements.payPal.push(billingAgreement);
                                } else if (billingAgreement.attributes.variant === 'sepadirectdebit' && billingAgreement.attributes.recurring_detail_reference !== null) {
                                    $rootScope.jfShared.checkout.userBillingAgreements.sepa.push(billingAgreement);
                                } else {
                                    $rootScope.jfShared.checkout.userBillingAgreements.cc.push(billingAgreement);
                                }
                            });

                            deferred.resolve();
                        }, function(err) {
                            SpinnerFactory.unset('checkout-payment-methods');
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchAvailablePaymentMethods: function(corporatePayments) {
                    var deferred = $q.defer(),
                        paymentParameters = {};

                    // paymentParameters.sort = 'created_at';

                    BooksPaymentMethodsFactory
                        .get(paymentParameters)
                        .$promise
                        .then(function(visiblePaymentMethods) {
                            var result = visiblePaymentMethods.data.filter(function(paymentMethod) {
                                return ($localStorage.catalogType === JF_CONFIG.accountTypes.company || angular.isDefined(corporatePayments) && paymentMethod.attributes.b_levels.includes('corp')) || (!($localStorage.catalogType === JF_CONFIG.accountTypes.company || angular.isDefined(corporatePayments)) && paymentMethod.attributes.b_levels.includes('b2c'));
                            });

                            deferred.resolve(result);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                // fetchLocalizedPaymentMethod: function(paymentMethodId) {
                //     var deferred = $q.defer();

                //     BooksPaymentMethodsLocalizedFactory
                //         .get({
                //             'filter[payment_method_id]': paymentMethodId,
                //             'filter[by_locale]': jfUser.get().locale,
                //             include: 'payment_method'
                //         })
                //         .$promise
                //         .then(function(localizedPaymentMethod) {
                //             deferred.resolve({
                //                 id: localizedPaymentMethod.data[0].relationships.payment_method.data.id,
                //                 name: localizedPaymentMethod.data[0].attributes.name
                //             });
                //         }, function(err) {
                //             deferred.reject(err);
                //         });

                //     return deferred.promise;
                // },
                fetchPayment: function(paymentId) {
                    var deferred = $q.defer();

                    BooksPaymentsFactory
                        .get({ id: paymentId })
                        .$promise
                        .then(function(payment) {
                            deferred.resolve(payment);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                getMinimumOrderValue: function() {
                    if (
                        angular.isDefined($localStorage.order) &&
                        angular.isDefined($localStorage.order.details) &&
                        angular.isDefined($localStorage.order.details.attributes) &&
                        angular.isDefined($localStorage.order.details.attributes.min_order_value)
                    ) {
                        return  parseFloat($localStorage.order.details.attributes.min_order_value);
                    }

                    return JF_CONFIG.minOrderValue;
                },
                userProfileDataCheck: function(callback) {
                    if (
                        $localStorage.order.details.attributes.corporate &&
                        (
                            !(
                                typeof jfUser.get().firstName === 'string' &&
                                jfUser.get().firstName !== ''
                            ) ||
                            !(
                                typeof jfUser.get().lastName === 'string' &&
                                jfUser.get().lastName !== ''
                            ) ||
                            !(
                                typeof jfUser.get().phoneNo === 'string' &&
                                jfUser.get().phoneNo !== ''
                            ) ||
                            !(
                                typeof jfUser.get().salutation === 'string' &&
                                jfUser.get().salutation !== ''
                            )
                        )
                    ) {
                        this.showMissingFieldsPrompt(callback);
                    } else {
                        this.startOrderProcessing();

                        callback();
                    }
                },
                showMissingFieldsPrompt: function(callback) {
                    var factory = this;

                    $mdDialog
                        .show({
                            templateUrl: 'app/components/checkout/checkout-profile.dialog.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: false,
                            controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                                factory.missingFieldsPromptControllerInit($scope);

                                /* istanbul ignore next */
                                $scope.saveAction = function() {
                                    if (!factory.isOrderProcessing() && $scope.missingProfileDataForm.$valid) {
                                        factory.startOrderProcessing();
                                        factory.missingFieldsPromptSaveAction($scope, callback);
                                    }
                                };

                                /* istanbul ignore next */
                                $scope.cancelAction = function() {
                                    factory.finishOrderProcessing();

                                    factory.missingFieldsPromptCancelAction($mdDialog);
                                };
                            }]
                        });
                },
                missingFieldsPromptControllerInit: function($scope) {
                    $scope.currentUser = jfUser.get();
                    $scope.userProfileData = {
                        profile_attributes: {}
                    };

                    if (
                        angular.isDefined($localStorage.order.details.attributes.billing_address.resource_id) &&
                        angular.isDefined($localStorage.order.details.attributes.billing_address.addressable_type) &&
                        $localStorage.order.details.attributes.billing_address.addressable_type !== 'Company' &&
                        angular.isDefined($rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.billing_address.resource_id])
                    ) {
                        $scope.userProfileData.profile_attributes.first_name = $rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.billing_address.resource_id].attributes.first_name;
                        $scope.userProfileData.profile_attributes.last_name = $rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.billing_address.resource_id].attributes.last_name;
                        $scope.userProfileData.profile_attributes.phone_no = $rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.billing_address.resource_id].attributes.phone_no;
                        $scope.userProfileData.profile_attributes.salutation = $rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.billing_address.resource_id].attributes.salutation;
                    }
                },
                missingFieldsPromptSaveAction: function($scope, callback) {
                    if ($scope.missingProfileDataForm.$valid) {
                        $mdDialog.hide();

                        var currentUser = jfUser.get();

                        AccountUserProfileFactory
                            .update(
                                { id: jfUser.get().profileId },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.profile,
                                    $scope.userProfileData.profile_attributes,
                                    { id: jfUser.get().profileId }
                                )
                            )
                            .$promise
                            .then(function() {
                                jfUser.update({
                                    firstName: $scope.userProfileData.profile_attributes.first_name ? base64.encode($scope.userProfileData.profile_attributes.first_name) : currentUser.firstName,
                                    lastName: $scope.userProfileData.profile_attributes.last_name ? base64.encode($scope.userProfileData.profile_attributes.last_name) : currentUser.lastName,
                                    phoneNo: $scope.userProfileData.profile_attributes.phone_no ? base64.encode($scope.userProfileData.profile_attributes.phone_no) : currentUser.phoneNo,
                                    salutation: $scope.userProfileData.profile_attributes.salutation ? $scope.userProfileData.profile_attributes.salutation : currentUser.salutation
                                });

                                if (angular.isDefined(callback)) {
                                    callback();
                                }
                            }, function(err) {
                                $rootScope.$emit('app-error', {err: err});
                            });
                    }
                },
                missingFieldsPromptCancelAction: function($mdDialog) {
                    $mdDialog.hide();
                },
                saveAgbVersion: function(placedOrderAdditionalInfo) {
                    var deferred = $q.defer();

                    if (
                        angular.isDefined(placedOrderAdditionalInfo.agb) &&
                        placedOrderAdditionalInfo.agb === true &&
                        angular.isDefined(placedOrderAdditionalInfo.remoteAgbVersion) &&
                        placedOrderAdditionalInfo.remoteAgbVersion !== null
                    ) {
                        AccountUserProfileFactory
                            .update(
                                { id: jfUser.get().profileId },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.profile,
                                    { agb_version: placedOrderAdditionalInfo.remoteAgbVersion },
                                    { id: jfUser.get().profileId }
                                )
                            )
                            .$promise
                            .then(function() {
                                jfUser.update({ agb_version: placedOrderAdditionalInfo.remoteAgbVersion });

                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                },
                commitOrder: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    if ($localStorage.catalogType === JF_CONFIG.accountTypes.personal) {
                        factory
                            .proceedWithCommit()
                            .then(function(commitedData) {
                                deferred.resolve(commitedData);
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        var AccountFactory = $injector.get('AccountFactory');

                        AccountFactory
                            .checkCorporateEnabledFlag()
                            .then(function(flagEnabled) {
                                if (flagEnabled) {
                                    factory
                                        .proceedWithCommit()
                                        .then(function(commitedData) {
                                            deferred.resolve(commitedData);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    deferred.reject({commitError: 1});
                                }
                            }, function(err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                },
                proceedWithCommit: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    factory
                        .validateTimeSlots()
                        .then(function(validationResult) {
                            if (validationResult.$status === 205) {
                                var itemsToDestroyList = '<ul>',
                                    orderItemsToDestroy = [],
                                    popupContent = $filter('translate')('CHECKOUT_COMMIT_NOT_POSSIBLE_INVALID_ITEMS_POPUP_CONTENT');

                                angular.forEach($localStorage.order.details.attributes.destroyable_order_items, function(itemToDestroy) {
                                    var catalogProduct = $filter('findInObject')($localStorage.order.items, 'id', itemToDestroy);
                                    if (catalogProduct !== null) {
                                        orderItemsToDestroy.push(catalogProduct.attributes.name);
                                    }
                                });

                                angular.forEach(orderItemsToDestroy, function(itemToDestroy) {
                                    itemsToDestroyList = itemsToDestroyList + '<li>' + itemToDestroy + '</li>';
                                });

                                itemsToDestroyList = itemsToDestroyList + '</ul>';

                                jfDialog
                                    .showConfirm(
                                        $filter('translate')('CHECKOUT_COMMIT_NOT_POSSIBLE_INVALID_ITEMS_POPUP_TITLE'),
                                        popupContent + itemsToDestroyList,
                                        $filter('translate')('CHECKOUT_COMMIT_NOT_POSSIBLE_INVALID_ITEMS_POPUP_CONTINUE'),
                                        $filter('translate')('CHECKOUT_COMMIT_NOT_POSSIBLE_INVALID_ITEMS_POPUP_CANCEL'),
                                        function() {
                                            BooksOrderRemoveDestroyableOrderItemsFactory
                                                .update({ orderId: $localStorage.order.details.id })
                                                .$promise
                                                .then(function() {
                                                    OrderFactory
                                                        .getOrderDetails()
                                                        .then(function() {
                                                            factory
                                                                .sendOrderCommitAction()
                                                                .then(function(commitedData) {
                                                                    deferred.resolve(commitedData);
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }, function(err) {
                                                            $rootScope.$emit('app-error', {err: err});
                                                        });
                                                }, function(err) {
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        }, function() {
                                            jfDialog.hideDialogs();
                                        },
                                        null,
                                        false
                                    );
                            } else {
                                factory
                                    .sendOrderCommitAction()
                                    .then(function(commitedData) {
                                        deferred.resolve(commitedData);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }
                        }, function(err) {
                            if (err.status === 406) {
                                deferred.reject({ commitError : 2 });
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                sendOrderCommitAction: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    factory
                        .saveUserNotes()
                        .then(function() {
                            var commitData = {
                                strategy: 'at_shop',
                                locale: $localStorage.shopLocale
                            };

                            if ($localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.creditCard) {
                                commitData.payment = {
                                    country_code: $localStorage.order.details.attributes.delivery_address.country_code,
                                    billing_agreement: $localStorage.order.additionalInfo.selectedCreditCardId,
                                    variant: $localStorage.order.additionalInfo.selectedCreditCardBrand
                                };
                            } else if ($localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.payPalAfterPayment) {
                                commitData.payment = {
                                    country_code: $localStorage.order.details.attributes.delivery_address.country_code,
                                    billing_agreement: $rootScope.jfShared.checkout.userBillingAgreements.payPal[0].id,
                                    variant: $rootScope.jfShared.checkout.userBillingAgreements.payPal[0].attributes.variant
                                };
                            } else if ($localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.sepa) {
                                commitData.payment = {
                                    country_code: $localStorage.order.details.attributes.delivery_address.country_code,
                                    billing_agreement: $rootScope.jfShared.checkout.userBillingAgreements.sepa[0].id,
                                    variant: $rootScope.jfShared.checkout.userBillingAgreements.sepa[0].attributes.variant
                                };
                            } else if ($localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.app) {
                                commitData.payment = {
                                    country_code: $localStorage.order.details.attributes.delivery_address.country_code,
                                    billing_agreement: $rootScope.jfShared.checkout.userBillingAgreements.app[0].id,
                                    variant: $rootScope.jfShared.checkout.userBillingAgreements.app[0].attributes.variant
                                };
                            }

                            BooksOrdersCommitFactory
                                .save(
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.regular_orders,
                                        commitData,
                                        { id: $localStorage.order.details.id }
                                    )
                                )
                                .$promise
                                .then(function() {
                                    deferred.resolve(commitData);
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                handleUnprocessableOrderCommitErrors: function(errors) {
                    var deferred = $q.defer(),
                        dataToUpdate = {},
                        errorsToDisplay = [],
                        reportToSentry = true,
                        errorPopupContent = {
                            title: $filter('translate')('CHECKOUT_422_ERROR_POPUP_TITLE'),
                            message: $filter('translate')('CHECKOUT_422_ERROR_POPUP_MESSAGE')
                        };

                    angular.forEach(errors, function(orderError) {
                        if (orderError.source.pointer === '/data/attributes/customer' && angular.isDefined(jfUser.get().id)) {
                            dataToUpdate.customer_id = jfUser.get().id;
                        }

                        if (orderError.source.pointer === '/data/attributes/customer_account') {
                            errorsToDisplay.push($filter('translate')('CUSTOMER_BLOCKED'));
                            reportToSentry = false;
                        }

                        if (orderError.source.pointer === '/data/attributes/price_list_id') {
                            dataToUpdate.price_list = true;
                            errorPopupContent.title = $filter('translate')('PRICES_CHANGED_POPUP_TITLE');
                            errorPopupContent.message = orderError.meta.message;

                            if (angular.isDefined($localStorage.catalogContent)) {
                                delete $localStorage.catalogContent;
                            }
                        }

                        if (orderError.source.pointer === '/data/attributes/delivery_fee_list_id') {
                            dataToUpdate.delivery_fee_list = true;
                            errorPopupContent.title = $filter('translate')('DELIVERY_FEE_LIST_CHANGED_POPUP_TITLE');
                            errorPopupContent.message = orderError.meta.message;
                        }

                        if (orderError.source.pointer === '/data/attributes/payment_method') {
                            $localStorage.order.details.attributes.payment_method_id = null;
                            $rootScope.order.details.attributes.payment_method_id = null;
                            reportToSentry = false;
                        }

                        if (orderError.source.pointer === '/data/attributes/payment') {
                            errorsToDisplay.push($filter('translate')('MISSING_BILLING_AGREEMENT_ERROR'));
                            reportToSentry = false;

                            $rootScope.$emit('jfCheckout:reloadPaymentMethods');
                        }

                        if (orderError.source.pointer === '/data/attributes/coupons') {
                            errorsToDisplay.push(orderError.meta.message);
                            reportToSentry = false;
                        }
                    });

                    if (jfHelper.countObjKeys(dataToUpdate) > 0) {
                        SpinnerFactory.set('global');


                        OrderFactory
                            .updateOrder(
                                $localStorage.order.details.id,
                                dataToUpdate
                            )
                            .then(function() {
                                SpinnerFactory.unset('global');

                                if (
                                    (
                                        angular.isDefined(dataToUpdate.price_list) &&
                                        dataToUpdate.price_list === true
                                    ) ||
                                    (
                                        angular.isDefined(dataToUpdate.delivery_fee_list) &&
                                        dataToUpdate.delivery_fee_list === true
                                    )
                                ) {
                                    deferred.resolve({
                                        retryOrderCommit: false,
                                        errorPopupContent: errorPopupContent,
                                        reportToSentry: reportToSentry
                                    });
                                } else {
                                    deferred.resolve({
                                        retryOrderCommit: true,
                                        errorPopupContent: errorPopupContent,
                                        reportToSentry: reportToSentry
                                    });
                                }
                            }, function(err) {
                                SpinnerFactory.unset('global');
                                deferred.reject(err);
                            });
                    } else if (errorsToDisplay.length > 0) {
                        deferred.resolve({
                            retryOrderCommit: false,
                            errorPopupContent: errorPopupContent,
                            errorsToDisplay: errorsToDisplay,
                            reportToSentry: reportToSentry
                        });
                    } else {
                        deferred.resolve({
                            retryOrderCommit: false,
                            errorPopupContent: errorPopupContent,
                            reportToSentry: reportToSentry
                        });
                    }

                    return deferred.promise;
                },
                saveUserNewsletterFlag: function(placedOrderAdditionalInfo) {
                    var deferred = $q.defer();

                    if (!jfUser.get().newsletter && placedOrderAdditionalInfo.newsletter) {
                        jfUser.update({ newsletter: placedOrderAdditionalInfo.newsletter });
                        $rootScope.jfShared.jfUser.newsletter = placedOrderAdditionalInfo.newsletter;

                        AccountUserProfileFactory
                            .update(
                                { id: jfUser.get().profileId },
                                jfJsonApi.prepare(
                                    JF_SHARED_CONFIG.modelTypes.profile,
                                    { newsletter: placedOrderAdditionalInfo.newsletter },
                                    { id: jfUser.get().profileId }
                                )
                            )
                            .$promise
                            .then(function() {
                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                },
                trackOrder: function(orderSummary, orderItems) {
                    var factory = this;

                    $window.dataLayer.push({
                        event: 'app:desktop:checkout:orderConfirmationStep',
                        attributes: {
                            order_payable_amount: $filter('round')(orderSummary.attributes.payable_amount, 2, true),
                            order_currency: orderSummary.attributes.currency
                        }
                    });

                    var transactionDetails = {
                        attributes: {
                            order_payable_amount: $filter('round')(orderSummary.attributes.payable_amount, 2, true),
                            order_currency: orderSummary.attributes.currency,
                            order_delivery_postal_code: orderSummary.attributes.delivery_address.postal_code,
                            order_delivery_city: orderSummary.attributes.delivery_address.city,
                            order_customer_type: ''
                        },
                        transactionId: orderSummary.attributes.order_no,
                        transactionAffiliation: 'Jonny Fresh Online-Shop',
                        transactionTotal: $filter('round')(orderSummary.attributes.payable_amount, 2, true),
                        transactionTax: orderSummary.attributes.vat_amount,
                        transactionShipping: orderSummary.attributes.delivery_fee_amount,
                        transactionProducts: []
                    };

                    var ga4TransactionDetails = {
                        event: 'jf:ga4:purchaseEvent',
                        ecommerce: {
                            transaction_id: orderSummary.attributes.order_no,
                            currency: orderSummary.attributes.currency,
                            items: [],
                            shipping: orderSummary.attributes.delivery_fee_amount,
                            tax: orderSummary.attributes.vat_amount,
                            value: parseFloat($filter('round')(orderSummary.attributes.payable_amount, 2, true))
                        }
                    };

                    angular.forEach(orderItems, function(orderItem) {
                        transactionDetails.transactionProducts.push({
                            'sku': orderItem.id,
                            'name': orderItem.attributes.product_name || orderItem.attributes.name,
                            'category': '',
                            'price': parseFloat($filter('round')(orderItem.attributes.discounted_price_value, 2, true)),
                            'quantity': orderItem.attributes.quantity
                        });
                        ga4TransactionDetails.ecommerce.items.push({
                            item_id: orderItem.id,
                            item_name: orderItem.attributes.product_name || orderItem.attributes.name,
                            currency: orderSummary.attributes.currency,
                            price: parseFloat($filter('round')(orderItem.attributes.discounted_price_value, 2, true)),
                            quantity: orderItem.attributes.quantity
                        });
                    });

                    if (orderSummary.attributes.coupon_discount_amount > 0) {
                        transactionDetails.transactionProducts.push({
                            'sku': orderSummary.attributes.coupon_code,
                            'name': 'Discount coupon (' + orderSummary.attributes.coupon_code + ')',
                            'category': 'Discount',
                            'price': '-' + orderSummary.attributes.coupon_discount_amount,
                            'quantity': 1
                        });
                        ga4TransactionDetails.ecommerce.coupon = 'Discount coupon (' + orderSummary.attributes.coupon_code + ')';
                    }

                    OrderFactory
                        .isUserFirstOrder()
                        .then(
                            function() {
                                factory.isNewCustomer = true;
                                transactionDetails.attributes.order_customer_type = 1;
                                ga4TransactionDetails.ecommerce.order_customer_type = 1;

                                $window.dataLayer.push(
                                    angular.merge(
                                        {},
                                        transactionDetails,
                                        { event: 'app:desktop:checkout:orderConfirmationStep:newCustomerOrder' }
                                    )
                                );
                                $window.dataLayer.push({ ecommerce: null });
                                $window.dataLayer.push(ga4TransactionDetails);

                                if (
                                    angular.isDefined($window.cordova) &&
                                    angular.isDefined($window.cordova.plugins) &&
                                    angular.isDefined($window.cordova.plugins.firebase) &&
                                    $rootScope.mobileTrackingPermissionGranted
                                ) {
                                    $window.cordova.plugins.firebase.analytics.logEvent('purchase', ga4TransactionDetails.ecommerce);
                                }
                            },
                            function(err) {
                                if (angular.isDefined(err)) {
                                    $rootScope.$emit('app-error', {err: err});
                                } else {
                                    factory.isNewCustomer = false;
                                    transactionDetails.attributes.order_customer_type = 0;
                                    ga4TransactionDetails.ecommerce.order_customer_type = 0;

                                    $window.dataLayer.push(
                                        angular.merge(
                                            {},
                                            transactionDetails,
                                            { event: 'app:desktop:checkout:orderConfirmationStep:returningCustomerOrder' }
                                        )
                                    );
                                    $window.dataLayer.push({ ecommerce: null });
                                    $window.dataLayer.push(ga4TransactionDetails);

                                    if (
                                        angular.isDefined($window.cordova) &&
                                        angular.isDefined($window.cordova.plugins) &&
                                        angular.isDefined($window.cordova.plugins.firebase) &&
                                        $rootScope.mobileTrackingPermissionGranted
                                    ) {
                                        $window.cordova.plugins.firebase.analytics.logEvent('purchase', ga4TransactionDetails.ecommerce);
                                    }
                                }
                            }
                        );
                },
                hasPrivateAddress: function(userAddresses) {
                    var hasPrivateAddress = false;

                    angular.forEach(userAddresses, function(userAddress) {
                        if (!hasPrivateAddress && userAddress.attributes.addressable_type !== 'Company') {
                            hasPrivateAddress = true;
                        }
                    });

                    return hasPrivateAddress;
                },
                validateOrder: function() {
                    var validationResult = {
                        errorsCount: 0,
                        errors: {
                            addresses: [],
                            timeSlots: {
                                pickup: [],
                                delivery: []
                            },
                            payment: [],
                            termsAndConditions: [],
                            invoicingFee: [],
                            general: []
                        },
                        errorMessages: []
                    };

                    var isAddressUndefined = function(addressType) {
                        return angular.isUndefined($localStorage.order.details.attributes[addressType]) ||
                            $localStorage.order.details.attributes[addressType] === null ||
                            angular.isUndefined($localStorage.order.details.attributes[addressType].resource_id) ||
                            $localStorage.order.details.attributes[addressType].resource_id === null;
                    };

                    if (isAddressUndefined('pickup_address') && isAddressUndefined('delivery_address') && isAddressUndefined('billing_address')) {
                        validationResult.errors.addresses.push($filter('translate')('NO_ADDRESSES_ERROR'));
                        validationResult.errorMessages.push($filter('translate')('NO_ADDRESSES_ERROR'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    } else {
                        if (isAddressUndefined('pickup_address')) {
                            validationResult.errors.addresses.push($filter('translate')('SPECIFY_YOUR_PICKUP_ADDRESS'));
                            validationResult.errorMessages.push($filter('translate')('SPECIFY_YOUR_PICKUP_ADDRESS'));
                            validationResult.errorsCount = validationResult.errorsCount + 1;
                        }
                        if (isAddressUndefined('delivery_address')) {
                            validationResult.errors.addresses.push($filter('translate')('SPECIFY_YOUR_DELIVERY_ADDRESS'));
                            validationResult.errorMessages.push($filter('translate')('SPECIFY_YOUR_DELIVERY_ADDRESS'));
                            validationResult.errorsCount = validationResult.errorsCount + 1;
                        }
                        if (isAddressUndefined('billing_address')) {
                            if (
                                angular.isDefined($localStorage.companyDetails) &&
                                $localStorage.companyDetails !== null &&
                                !$localStorage.companyDetails.pays_for_user &&
                                !this.hasPrivateAddress($rootScope.jfShared.checkout.userAddresses) &&
                                $localStorage.catalogType === JF_CONFIG.accountTypes.company
                            ) {
                                validationResult.errors.addresses.push($filter('translate')('SPECIFY_YOUR_BILLING_ADDRESS_AND_ADD_ADDRESS'));
                                validationResult.errorMessages.push($filter('translate')('SPECIFY_YOUR_BILLING_ADDRESS_AND_ADD_ADDRESS'));
                            } else {
                                validationResult.errors.addresses.push($filter('translate')('SPECIFY_YOUR_BILLING_ADDRESS'));
                                validationResult.errorMessages.push($filter('translate')('SPECIFY_YOUR_BILLING_ADDRESS'));
                            }

                            validationResult.errorsCount = validationResult.errorsCount + 1;
                        }
                    }

                    if (
                        $localStorage.order.details.attributes.pickup_start_ts === null ||
                        $localStorage.order.details.attributes.pickup_end_ts === null
                    ) {
                        validationResult.errors.timeSlots.pickup.push($filter('translate')('PICKUP_TIME_MISSING'));
                        validationResult.errorMessages.push($filter('translate')('PICKUP_TIME_MISSING'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (
                        $localStorage.order.details.attributes.delivery_start_ts === null ||
                        $localStorage.order.details.attributes.delivery_end_ts === null
                    ) {
                        validationResult.errors.timeSlots.delivery.push($filter('translate')('DELIVERY_TIME_MISSING'));
                        validationResult.errorMessages.push($filter('translate')('DELIVERY_TIME_MISSING'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }

                    if (
                        angular.isUndefined($localStorage.order.details.attributes.payment_method_id) ||
                        $localStorage.order.details.attributes.payment_method_id === null
                    ) {
                        validationResult.errors.payment.push($filter('translate')('SELECT_PAYMENT_METHOD'));
                        validationResult.errorMessages.push($filter('translate')('SELECT_PAYMENT_METHOD'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (parseFloat($localStorage.order.details.attributes.total_amount) < parseFloat(this.getMinimumOrderValue())) {
                        validationResult.errors.general.push($filter('translate')('MIN_ORDER_VALUE_ERROR'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (
                        angular.isDefined($localStorage.order.details.attributes.payment_method_id) &&
                        $localStorage.order.details.attributes.payment_method_id !== null &&
                        $localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.payPalAfterPayment &&
                        $rootScope.jfShared.checkout.userBillingAgreements.payPal !== null &&
                        $rootScope.jfShared.checkout.userBillingAgreements.payPal.length === 0
                    ) {
                        validationResult.errors.payment.push($filter('translate')('PAY_PAL_AUTH_ERROR'));
                        validationResult.errorMessages.push($filter('translate')('PAY_PAL_AUTH_ERROR'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (
                        angular.isDefined($localStorage.order.details.attributes.payment_method_id) &&
                        $localStorage.order.details.attributes.payment_method_id !== null &&
                        $localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.sepa &&
                        $rootScope.jfShared.checkout.userBillingAgreements.sepa !== null &&
                        $rootScope.jfShared.checkout.userBillingAgreements.sepa.length === 0
                    ) {
                        validationResult.errors.payment.push($filter('translate')('SEPA_DATA_MISSING_ERROR'));
                        validationResult.errorMessages.push($filter('translate')('SEPA_DATA_MISSING_ERROR'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (
                        angular.isDefined($localStorage.order.details.attributes.payment_method_id) &&
                        $localStorage.order.details.attributes.payment_method_id !== null &&
                        $localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.app &&
                        $rootScope.jfShared.checkout.userBillingAgreements.app !== null &&
                        $rootScope.jfShared.checkout.userBillingAgreements.app.length === 0
                    ) {
                        validationResult.errors.payment.push($filter('translate')('APPLE_PAY_DATA_MISSING_ERROR'));
                        validationResult.errorMessages.push($filter('translate')('APPLE_PAY_DATA_MISSING_ERROR'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (
                        angular.isDefined($localStorage.order.details.attributes.payment_method_id) &&
                        $localStorage.order.details.attributes.payment_method_id !== null &&
                        $localStorage.order.details.attributes.payment_method_id === JF_CONFIG.paymentMethods.creditCard &&
                        (
                            angular.isUndefined($localStorage.order.additionalInfo.selectedCreditCardId) ||
                            $localStorage.order.additionalInfo.selectedCreditCardId === null
                        )
                    ) {
                        validationResult.errors.payment.push($filter('translate')('MISSING_CREDIT_CARD_ERROR'));
                        validationResult.errorMessages.push($filter('translate')('MISSING_CREDIT_CARD_ERROR'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;

                        $rootScope.$emit('jfCheckout:reRenderCreditCards');
                    }
                    if (
                        (
                            $localStorage.order.details.attributes.delivery_address !== null &&
                            $localStorage.order.details.attributes.delivery_address.resource_id !== null &&
                            angular.isDefined($rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.delivery_address.resource_id]) &&
                            $rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.delivery_address.resource_id].postal_code_in_service === false
                        ) ||
                        (
                            $localStorage.order.details.attributes.pickup_address !== null &&
                            $localStorage.order.details.attributes.pickup_address.resource_id !== null &&
                            angular.isDefined($rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.pickup_address.resource_id]) &&
                            $rootScope.jfShared.checkout.userAddresses[$localStorage.order.details.attributes.pickup_address.resource_id].postal_code_in_service === false
                        )
                    ) {
                        validationResult.errors.addresses.push($filter('translate')('SERVICE_UNAVAILABLE_IN_THIS_AREA'));
                        validationResult.errorMessages.push($filter('translate')('SERVICE_UNAVAILABLE_IN_THIS_AREA'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }
                    if (
                        angular.isDefined($localStorage.companyDetails) &&
                        $localStorage.companyDetails !== null && 
                        $localStorage.companyDetails.invoicing_fee > 0 &&
                        $localStorage.order.additionalInfo.invoicingFee !== true
                    ) {
                        validationResult.errors.invoicingFee.push($filter('translate')('INVOICING_FEE_ACCEPT_REQUIRED'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }

                    if (!this.userAcceptedCurrentAgb() && $localStorage.order.additionalInfo.agb !== true) {
                        validationResult.errors.termsAndConditions.push($filter('translate')('TERMS_AND_CONDITIONS_ACCEPT_REQUIRED'));
                        validationResult.errorsCount = validationResult.errorsCount + 1;
                    }

                    return validationResult;
                },
                clearValidationErrors: function() {
                    delete $rootScope.order.additionalInfo.errors;
                    delete $rootScope.order.additionalInfo.errorsCount;
                },
                fetchCurrentAgbVersion: function() {
                    var deferred = $q.defer();

                    CustomerAppHelpersFactory.fetchLegalDocuments().then(function(legalDocuments) {
                        deferred.resolve(legalDocuments.gtc ? legalDocuments.gtc.version : 'GfgfsE6Iaqe8Rmqs1ZNlrgkFd1o8VHKO'); // defaults to AGB version from 27.09.2022
                    }, function(err) {
                        deferred.reject(err);
                    });

                    return deferred.promise;
                },
                userAcceptedCurrentAgb: function() {
                    return jfUser.get().agb_version === $localStorage.order.additionalInfo.remoteAgbVersion;
                },
                saveAgbSelection: function() {
                    $localStorage.order.additionalInfo.agb = $rootScope.order.additionalInfo.agb;
                },
                saveInvoicingFeeSelection: function() {
                    $localStorage.order.additionalInfo.invoicingFee = $rootScope.order.additionalInfo.invoicingFee;
                },
                showDialogMinOrderValue: function(minOrderValue) {
                    jfDialog
                        .showAlert(
                            $filter('translate')('MIN_ORDER_VALUE_MOBILE_ERROR_LABEL'),
                            $filter('translate')('MIN_ORDER_VALUE_MOBILE_ERROR_CONTENT', {min_order_value: minOrderValue}),
                            $filter('translate')('MIN_ORDER_VALUE_MOBILE_ERROR_BUTTON')
                        );
                },
                orderPassedMinOrderValue: function() {
                    var minOrderValue = this.getMinimumOrderValue();
                    if (parseFloat($localStorage.order.details.attributes.total_amount) < parseFloat(minOrderValue)) {
                        this.showDialogMinOrderValue(minOrderValue);
                        return false;
                    }
                    return true;
                },
                startOrderProcessing: function () {
                    $rootScope.jfShared.checkout.orderProcessing = true;
                },
                finishOrderProcessing: function() {
                    $rootScope.jfShared.checkout.orderProcessing = false;
                },
                isOrderProcessing: function() {
                    return angular.isDefined($rootScope.jfShared) &&
                           angular.isDefined($rootScope.jfShared.checkout) &&
                           angular.isDefined($rootScope.jfShared.checkout.orderProcessing) &&
                           $rootScope.jfShared.checkout.orderProcessing === true;
                }
            };
        }]
    );
/**
 * Account Register Form Factory
 */
angular.module('jfApp')
    .factory(
        'AccountRegisterFormFactory',
        ['$localStorage', '$q', '$window', '$rootScope', 'JF_SHARED_CONFIG', 'JF_CONFIG', 'jfJsonApi', 'AccountCustomerFactory', 'CheckoutFactory', 'jfLogin', 'jfUser', function(
            $localStorage,
            $q,
            $window,
            $rootScope,
            JF_SHARED_CONFIG,
            JF_CONFIG,
            jfJsonApi,
            AccountCustomerFactory,
            CheckoutFactory,
            jfLogin,
            jfUser
        ) {
            'use strict';

            return {
                saveUserRegistrationData: function(userData, agbVersion) {
                    var deferred = $q.defer();

                    AccountCustomerFactory
                        .save(
                            { include: 'company' },
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.customers,
                                {
                                    email: userData.email_address,
                                    password: userData.new_password,
                                    corporate_code: userData.corporate_code || null,
                                    profile_attributes: {
                                        preferred_locale: $localStorage.shopLocale || JF_CONFIG.defaultLocale,
                                        agb_version: agbVersion || null
                                    }
                                }
                            )
                        )
                        .$promise
                        .then(function(response) {
                            deferred.resolve(response);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                registerUser: function(userData) {
                    var deferred = $q.defer(),
                        model = this;


                    CheckoutFactory
                        .fetchCurrentAgbVersion()
                        .then(function(currentAgbVersion) {
                            model
                                .saveUserRegistrationData(userData, currentAgbVersion)
                                .then(function(newUserDetails) {
                                    model
                                        .saveUserRegistrationDataCallback(newUserDetails, userData)
                                        .then(function(newUserDetails) {
                                            deferred.resolve(newUserDetails);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err, silent: true});

                            model
                                .saveUserRegistrationData(userData)
                                .then(function(newUserDetails) {
                                    model
                                        .saveUserRegistrationDataCallback(newUserDetails, userData)
                                        .then(function(newUserDetails) {
                                            deferred.resolve(newUserDetails);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        });

                    return deferred.promise;
                },
                saveUserRegistrationDataCallback: function(newUserDetails, userData) {
                    var deferred = $q.defer();

                    if (angular.isDefined(newUserDetails.data.id) && newUserDetails.data.id !== '') {
                        $window.dataLayer.push({
                            event: 'app:desktop:account:registration'
                        });

                        jfLogin
                            .login(userData.email_address, userData.new_password, {}, true)
                            .then(function(loginResponse) {
                                if (angular.isDefined($window.Sentry)) {
                                    $window.Sentry.setUser({ id: jfUser.get().id });
                                }

                                deferred.resolve({newUserDetails: newUserDetails, loginResponse: loginResponse});
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        deferred.reject({err: 'Error while user registration.'});
                    }

                    return deferred.promise;
                }
            };
        }]
    );
angular
    .module('jfApp')
    .factory(
        'PaymentMethodsManagerFactory',
        ['$q', '$filter', '$localStorage', '$rootScope', 'jfUser', 'jfDialog', 'jfJsonApi', 'JF_CONFIG', 'JF_SHARED_CONFIG', 'SpinnerFactory', 'AccountAddressesFactory', 'AccountUserProfileFactory', 'AccountUsersBillingAgreements', 'AccountUsersBillingAgreementsDisableOperation', function(
            $q,
            $filter,
            $localStorage,
            $rootScope,
            jfUser,
            jfDialog,
            jfJsonApi,
            JF_CONFIG,
            JF_SHARED_CONFIG,
            SpinnerFactory,
            AccountAddressesFactory,
            AccountUserProfileFactory,
            AccountUsersBillingAgreements,
            AccountUsersBillingAgreementsDisableOperation
        ) {
            'use strict';

            return {
                fetchAdyenBillingAgreements: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    SpinnerFactory.set('jf-payment-methods-manager');

                    AccountUsersBillingAgreements
                        .get({
                            'filter[customer_id]': jfUser.get().id,
                            'filter[country_code]': 'DE'
                        })
                        .$promise
                        .then(function(result) {
                            SpinnerFactory.unset('jf-payment-methods-manager');

                            factory
                                .saveDefaultPreferredPaymentMethod(result)
                                .then(function() {
                                    var billingAgreements = {
                                        cc: { DE: [], AT: [] },
                                        pp: [],
                                        sepa: [],
                                        app: []
                                    };

                                    factory.assignPaymentMethodType(result, billingAgreements);

                                    factory
                                        .fetchATCreditCards(billingAgreements)
                                        .then(function() {
                                            deferred.resolve(billingAgreements);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            SpinnerFactory.unset('jf-payment-methods-manager');

                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchATCreditCards: function(billingAgreements) {
                    var deferred = $q.defer(),
                        factory = this;

                    SpinnerFactory.set('jf-payment-methods-manager');

                    AccountUsersBillingAgreements
                        .get({
                            'filter[customer_id]': jfUser.get().id,
                            'filter[country_code]': 'AT'
                        })
                        .$promise
                        .then(function(result) {
                            SpinnerFactory.unset('jf-payment-methods-manager');

                            if (result.data.length > 0) {
                                factory
                                    .saveDefaultPreferredPaymentMethod(result)
                                    .then(function() {
                                        angular.forEach(result.data, function(billingAgreement) {
                                            if (billingAgreement.attributes.payment_info.card !== null) {
                                                billingAgreements.cc.AT.push(billingAgreement.attributes);
                                            }
                                        });

                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.resolve();
                            }
                        }, function(err) {
                            SpinnerFactory.unset('jf-payment-methods-manager');

                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                saveDefaultPreferredPaymentMethod: function(billingAgreements) {
                    var deferred = $q.defer();

                    if (billingAgreements.data.length === 1) {
                        if (angular.isUndefined(jfUser.get().defaultPaymentMethod) || jfUser.get().defaultPaymentMethod === null) {
                            this
                                .updateProfileWithPreferredData(this.getPaymentMethodIdFromVariant(billingAgreements.data[0].attributes.variant), billingAgreements.data[0].id)
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            deferred.resolve();
                        }
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                },
                getPaymentMethodIdFromVariant: function(variant) {
                    if (variant === 'sepadirectdebit') {
                        return JF_CONFIG.paymentMethods.sepa;
                    } else if (variant === 'paypal') {
                        return JF_CONFIG.paymentMethods.payPalAfterPayment;
                    } else if (variant.indexOf('_applepay') > -1) {
                        return JF_CONFIG.paymentMethods.app;
                    } else {
                        return JF_CONFIG.paymentMethods.creditCard;
                    }
                },
                assignPaymentMethodType: function(result, billingAgreements) {
                    angular.forEach(result.data, function(billingAgreement) {
                        if (billingAgreement.attributes.variant.indexOf('_applepay') > -1) {
                            billingAgreements.app.push(billingAgreement.attributes);
                        } else if (angular.isDefined(billingAgreement.attributes.payment_info.card) && billingAgreement.attributes.payment_info.card !== null) {
                           billingAgreements.cc[billingAgreement.attributes.country_code].push(billingAgreement.attributes);
                        } else if (billingAgreement.attributes.variant === 'paypal') {
                            billingAgreements.pp.push(billingAgreement.attributes);
                        } else if (billingAgreement.attributes.variant === 'sepadirectdebit') {
                            billingAgreements.sepa.push(billingAgreement.attributes);
                        }
                    });
                },
                removePreferredSettings: function(billingAgreementId, paymentSection) {
                    var deferred = $q.defer(),
                        factory = this,
                        updatePreferredPaymentMethod,
                        updatePreferredBillingAgreement;
                    if (
                        angular.isDefined(jfUser.get().preferredBillingAgreementId) &&
                        jfUser.get().preferredBillingAgreementId === billingAgreementId
                    ) {
                        updatePreferredBillingAgreement = null;
                    }

                    if (paymentSection.activeBillingAgreements.length < 2) {
                        updatePreferredPaymentMethod = null;
                    }

                    if (angular.isUndefined(updatePreferredPaymentMethod) && angular.isUndefined(updatePreferredBillingAgreement)) {
                        deferred.resolve();
                    } else {
                        factory
                            .updateProfileWithPreferredData(updatePreferredPaymentMethod, updatePreferredBillingAgreement)
                            .then(function() {
                                deferred.resolve();
                            }, function(err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                },
                deleteBillingAgreement: function(billingAgreement, paymentSection) {
                    var deferred = $q.defer(),
                        factory = this;

                    if (billingAgreement.deletable === true) {
                        SpinnerFactory.set('jf-payment-methods-manager');

                        AccountUsersBillingAgreementsDisableOperation
                            .save(
                                {
                                    data: {
                                        attributes: {
                                            id: billingAgreement.recurring_detail_reference,
                                            user_id: jfUser.get().id,
                                            country_code: billingAgreement.country_code
                                        },
                                        type: 'billing_agreement_disable_operations'
                                    }
                                })
                            .$promise
                            .then(function() {
                                if ($localStorage.order.additionalInfo.selectedCreditCardId !== null &&
                                    $localStorage.order.additionalInfo.selectedCreditCardId === billingAgreement.recurring_detail_reference
                                ) {
                                    $localStorage.order.additionalInfo.selectedCreditCardId = null;
                                    $rootScope.order.additionalInfo.selectedCreditCardId = null;
                                }

                                factory
                                    .removePreferredSettings(billingAgreement.recurring_detail_reference, paymentSection)
                                    .then(function() {
                                        SpinnerFactory.unset('jf-payment-methods-manager');

                                        deferred.resolve();
                                    }, function(err) {
                                        SpinnerFactory.unset('jf-payment-methods-manager');

                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                SpinnerFactory.unset('jf-payment-methods-manager');

                                deferred.reject(err);
                            });
                    } else {
                        jfDialog
                          .showAlert(
                              $filter('translate')('PREVENT_PAYMENT_METHOD_DELETION_TITLE'),
                              $filter('translate')('PREVENT_PAYMENT_METHOD_DELETION_CONTENT'),
                              $filter('translate')('PREVENT_PAYMENT_METHOD_DELETION_OK')
                          );
                    }

                    return deferred.promise;
                },
                updateProfileWithPreferredData: function(paymentMethodId, preferredBillingAgreementId) {
                    var deferred = $q.defer();

                    var profileUpdate = {
                        id: jfUser.get().profileId,
                        invoice_delivery: 'by_email'
                    };

                    if (angular.isDefined(paymentMethodId)) {
                        if (paymentMethodId === null) {
                            profileUpdate.payment_method_id = null;
                        } else {
                            profileUpdate.payment_method_id = paymentMethodId;
                        }
                    }

                    SpinnerFactory.set('jf-payment-methods-manager');

                    AccountUserProfileFactory
                        .get({
                            'filter[user_id]': jfUser.get().id
                        })
                        .$promise
                        .then(function(userProfile) {
                            profileUpdate.frontend_data = userProfile.data[0].attributes.frontend_data;

                            if (angular.isDefined(preferredBillingAgreementId)) {
                                if (profileUpdate.frontend_data === null) {
                                    profileUpdate.frontend_data = {};
                                }

                                if (preferredBillingAgreementId === null) {
                                    profileUpdate.frontend_data.preferred_billing_agreement_id = null;
                                } else {
                                    profileUpdate.frontend_data.preferred_billing_agreement_id = preferredBillingAgreementId;
                                }
                            }

                            AccountUserProfileFactory
                                .update(
                                    { id: jfUser.get().profileId },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.profile,
                                        profileUpdate,
                                        { id: jfUser.get().profileId }
                                    )
                                )
                                .$promise
                                .then(function() {
                                    SpinnerFactory.unset('jf-payment-methods-manager');

                                    var localProfileToUpdate = {};

                                    if (angular.isDefined(paymentMethodId)) {
                                        if (paymentMethodId === null) {
                                            localProfileToUpdate.defaultPaymentMethod = null;
                                        } else {
                                            localProfileToUpdate.defaultPaymentMethod = paymentMethodId;
                                        }
                                    }

                                    if (angular.isDefined(preferredBillingAgreementId)) {
                                        if (preferredBillingAgreementId === null) {
                                            localProfileToUpdate.preferredBillingAgreementId = null;
                                        } else {
                                            localProfileToUpdate.preferredBillingAgreementId = preferredBillingAgreementId;
                                        }
                                    }


                                    jfUser.update(localProfileToUpdate);

                                    deferred.resolve(localProfileToUpdate);
                                }, function(err) {
                                    SpinnerFactory.unset('jf-payment-methods-manager');

                                    deferred.reject(err);
                                });
                            }, function(err) {
                                deferred.reject(err);
                            });

                    return deferred.promise;
                },
                getBillingAddress: function() {
                    var deferred = $q.defer();

                    if (
                        angular.isDefined($localStorage.order.details.attributes.billing_address) &&
                        $localStorage.order.details.attributes.billing_address !== null
                    ) {
                        deferred.resolve({
                            street: $localStorage.order.details.attributes.billing_address.street,
                            houseNumberOrName: $localStorage.order.details.attributes.billing_address.house_no_main,
                            city: $localStorage.order.details.attributes.billing_address.city,
                            country: $localStorage.order.details.attributes.billing_address.country_code,
                            postalCode: $localStorage.order.details.attributes.billing_address.postal_code
                        });
                    } else if (
                        angular.isDefined(jfUser.get().pbid) &&
                        jfUser.get().pbid !== null
                    ) {
                        SpinnerFactory.set([
                            'account-credit-cards',
                            'checkout-payment-methods',
                            'jf-payment-methods-manager'
                        ]);

                        AccountAddressesFactory
                            .get({
                                addressId: jfUser.get().pbid,
                                'filter[addressable_id]': jfUser.get().id,
                                'filter[addressable_type]': 'Customer'
                            })
                            .$promise
                            .then(function(userPreferredBillingAddress) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods',
                                    'jf-payment-methods-manager'
                                ]);

                                if (
                                    angular.isDefined(userPreferredBillingAddress.data) &&
                                    angular.isDefined(userPreferredBillingAddress.data.attributes)
                                ) {
                                    deferred.resolve({
                                        street: userPreferredBillingAddress.data.attributes.street,
                                        houseNumberOrName: userPreferredBillingAddress.data.attributes.house_no_main,
                                        city: userPreferredBillingAddress.data.attributes.city,
                                        country: userPreferredBillingAddress.data.attributes.country_code,
                                        postalCode: userPreferredBillingAddress.data.attributes.postal_code
                                    });
                                } else {
                                    deferred.resolve();
                                }
                            }, function(err) {
                                SpinnerFactory.unset([
                                    'account-credit-cards',
                                    'checkout-payment-methods',
                                    'jf-payment-methods-manager'
                                ]);

                                $rootScope.$emit('app-error', {err: err, silent: true});

                                deferred.resolve();
                            });
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                }
            };
        }]
  );
/**
 * Account factory
 */
angular.module('jfApp')
    .factory(
        'AccountFactory',
        ['$q', '$localStorage', '$filter', '$state', '$location', '$rootScope', '$window', '$injector', '$mdDialog', 'AccountCustomerFactory', 'AccountUserProfileFactory', 'AccountCompanies', 'AccountCompanyAddresses', 'AccountAddressesFactory', 'OrderFactory', 'CheckoutFactory', 'LanguageFactory', 'SpinnerFactory', 'ProductsFactory', 'JF_CONFIG', 'JF_SHARED_CONFIG', 'jfJsonApi', 'jfUser', 'jfLocation', 'jfDialog', function(
            $q,
            $localStorage,
            $filter,
            $state,
            $location,
            $rootScope,
            $window,
            $injector,
            $mdDialog,
            AccountCustomerFactory,
            AccountUserProfileFactory,
            AccountCompanies,
            AccountCompanyAddresses,
            AccountAddressesFactory,
            OrderFactory,
            CheckoutFactory,
            LanguageFactory,
            SpinnerFactory,
            ProductsFactory,
            JF_CONFIG,
            JF_SHARED_CONFIG,
            jfJsonApi,
            jfUser,
            jfLocation,
            jfDialog
        ) {
            'use strict';

            return {
                fetchCompanyId: function() {
                    var deferred = $q.defer();

                    AccountCustomerFactory
                        .get({
                            id: jfUser.get().id,
                            include: 'company'
                        })
                        .$promise
                        .then(function(customer) {
                            if (angular.isDefined(customer.data) &&
                                angular.isDefined(customer.data.attributes)) {
                                deferred.resolve(customer.included[0].id);
                            } else {
                                deferred.reject(null);
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                deleteCompanyPreferences: function() {
                    var currentUser = jfUser.get();

                    delete currentUser.corporateCode;
                    delete currentUser.defaultPaymentMethod;
                    delete currentUser.service_location;
                    delete currentUser.pb2bid;
                    delete currentUser.companyId;
                    delete currentUser.companyPostalCode;
                    delete currentUser.corporateEnabled;
                    delete $localStorage.companyDetails;
                    delete $rootScope.jfShared.companyDetails;

                    jfUser.update(currentUser);
                },
                checkCorporateEnabledFlag: function() {
                    var deferred = $q.defer();

                    AccountCustomerFactory
                        .get({
                            id: jfUser.get().id
                        })
                        .$promise
                        .then(function(customer) {
                            deferred.resolve(customer.data.attributes.corporate_enabled);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                corporateFlagDisabledCallback: function() {
                    $injector
                        .get('ProductsFactory')
                        .setCatalogType(JF_CONFIG.accountTypes.personal);

                    this.deleteCompanyPreferences();

                    jfDialog
                        .showAlert(
                            $filter('translate')('UNLINK_CORPORATE_USER_TITLE'),
                            $filter('translate')('UNLINK_CORPORATE_USER_CONTENT'),
                            $filter('translate')('UNLINK_CORPORATE_USER_OK'),
                            function() {
                                SpinnerFactory.set('account-corporate');
                                OrderFactory
                                    .resetUserOrder()
                                    .then(function() {
                                        SpinnerFactory.unset('account-corporate');
                                        $state.reload();
                                    }, function(err) {
                                        SpinnerFactory.unset('account-corporate');
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            }
                        );
                },
                fetchUserTypeAccount: function() {
                    var deferred = $q.defer();

                    AccountCustomerFactory
                        .get({
                            id: jfUser.get().id,
                            include: 'company'
                        })
                        .$promise
                        .then(function(customer) {
                            deferred.resolve(customer.data);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                getCompanyInformation: function(companyId) {
                    var deferred = $q.defer();

                    AccountCompanies
                        .get({
                            id: companyId
                        })
                        .$promise
                        .then(function(companyDetails) {
                            $localStorage.companyDetails = companyDetails.data.attributes;
                            $localStorage.companyDetails.updatedAt = new Date().getTime();

                            $rootScope.jfShared.companyDetails = companyDetails.data.attributes;
                            $rootScope.jfShared.companyDetails.updatedAt = new Date().getTime();

                            deferred.resolve(companyDetails.data.attributes);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchCompanyPaymentMethod: function(companyId) {
                    var deferred = $q.defer();

                    AccountCompanies
                        .get({
                            id: companyId
                        })
                        .$promise
                        .then(function(response) {
                            deferred.resolve(response.data.attributes.payment_method_id);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                updateOrderCompanyId: function(companyId) {
                    var deferred = $q.defer();

                    if (companyId === null) {
                        if (angular.isDefined($localStorage.lastPrivateCatalogLocation)) {
                            var addressToSave = angular.copy($localStorage.lastPrivateCatalogLocation);
                            addressToSave.addressable_type = 'Customer';

                            OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                            OrderFactory
                                .updateOrder(
                                    $localStorage.order.details.id,
                                    {
                                        payment_method_id_destroy: true,
                                        pickup_start_ts: null,
                                        pickup_end_ts: null,
                                        delivery_start_ts: null,
                                        delivery_end_ts: null,
                                        company_id: companyId,
                                        pickup_address: addressToSave,
                                        delivery_address: addressToSave,
                                        billing_address: { _destroy: true }
                                    }
                                )
                                .then(function(updatedOrder) {
                                    $localStorage.order.additionalInfo.selectedPaymentMethodId = null;
                                    $rootScope.order.additionalInfo.selectedPaymentMethodId = null;

                                    deferred.resolve(updatedOrder);
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            OrderFactory
                                .updateOrder(
                                    $localStorage.order.details.id,
                                    {
                                        payment_method_id_destroy: true,
                                        pickup_start_ts: null,
                                        pickup_end_ts: null,
                                        delivery_start_ts: null,
                                        delivery_end_ts: null,
                                        company_id: companyId,
                                        billing_address: { _destroy: true }
                                    }
                                )
                                .then(function(updatedOrder) {
                                    $localStorage.order.additionalInfo.selectedPaymentMethodId = null;
                                    $rootScope.order.additionalInfo.selectedPaymentMethodId = null;

                                    deferred.resolve(updatedOrder);
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }
                    } else {
                        OrderFactory
                            .updateOrder(
                                $localStorage.order.details.id,
                                {
                                    payment_method_id_destroy: true,
                                    pickup_start_ts: null,
                                    pickup_end_ts: null,
                                    delivery_start_ts: null,
                                    delivery_end_ts: null,
                                    company_id: companyId,
                                    billing_address: { _destroy: true }
                                }
                            )
                            .then(function(updatedOrder) {
                                $localStorage.order.additionalInfo.selectedPaymentMethodId = null;
                                $rootScope.order.additionalInfo.selectedPaymentMethodId = null;

                                deferred.resolve(updatedOrder);
                            }, function(err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                },
                fetchUserAddresses: function() {
                    var deferred = $q.defer(),
                        model = this;

                    $rootScope.jfShared.checkout.userAddresses = {};

                    if (angular.isDefined(jfUser.get().id)) {
                        model
                            .fetchUserPrivateAddresses()
                            .then(function(userAddresses) {
                                $rootScope.jfShared.checkout.userAddresses = userAddresses;

                                if (model.isCompanyAccount()) {
                                    model
                                        .fetchUserCompanyAddresses(jfUser.get().companyId)
                                        .then(function(companyAddresses) {
                                            angular.extend($rootScope.jfShared.checkout.userAddresses, companyAddresses);

                                            CheckoutFactory.assignCheckoutDefaultValues();

                                            deferred.resolve($rootScope.jfShared.checkout.userAddresses);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    CheckoutFactory.assignCheckoutDefaultValues();

                                    deferred.resolve($rootScope.jfShared.checkout.userAddresses);
                                }
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        deferred.reject({err: 'User not logged in.'});
                    }

                    return deferred.promise;
                },
                fetchUserPrivateAddresses: function() {
                    var deferred = $q.defer(),
                        userAddresses = {},
                        currentUserCompanyId = null;

                    if (
                        jfUser.isLoggedIn() &&
                        angular.isDefined(jfUser.get().companyId) &&
                        jfUser.get().companyId !== null
                    ) {
                        currentUserCompanyId = jfUser.get().companyId;
                    }

                    AccountAddressesFactory
                        .get({
                            'filter[addressable_id]': jfUser.get().id,
                            'filter[addressable_type]': 'Customer'
                        })
                        .$promise
                        .then(function(addresses) {
                            if (addresses.data.length > 0) {
                                var promises = [];

                                angular.forEach(addresses.data, function(address) {
                                    var deferred = $q.defer();

                                    userAddresses[address.id] = address;

                                    if (address.type === JF_SHARED_CONFIG.modelTypes.service_address) {
                                        jfLocation
                                            .postalCodeInService(address.attributes.postal_code_id, currentUserCompanyId)
                                            .then(function(validationResult) {
                                                userAddresses[address.id].postal_code_in_service = validationResult.valid;
                                                if (
                                                    angular.isDefined(validationResult.postalCodeDetails) &&
                                                    angular.isDefined(validationResult.postalCodeDetails.plant_id) &&
                                                    validationResult.postalCodeDetails.plant_id !== null
                                                ) {
                                                    userAddresses[address.id].plant_id = validationResult.postalCodeDetails.plant_id;
                                                }

                                                deferred.resolve(userAddresses);
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    } else {
                                        deferred.resolve(userAddresses);
                                    }
                                    promises.push(deferred.promise);
                                });

                                $q.all(promises)
                                    .then(function(results) {
                                        var returnValue = {};

                                        angular.forEach(results, function(result) {
                                            angular.extend(returnValue, result);
                                        });

                                        deferred.resolve(returnValue);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.resolve({});
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchUserCompanyAddresses: function(companyId, addressType) {
                    var deferred = $q.defer(),
                        params = {
                            'filter[addressable_id]': companyId,
                            'filter[addressable_type]': 'Company'
                        };

                    if (angular.isDefined(addressType)) {
                        params['filter[type]'] = addressType;
                    }

                    AccountCompanyAddresses
                        .get(params)
                        .$promise
                        .then(function(companyAddresses) {
                            if (companyAddresses.data.length > 0) {
                                var promises = [],
                                    addresses = [];

                                angular.forEach(companyAddresses.data, function(companyAddress) {
                                    var deferred = $q.defer();

                                    addresses[companyAddress.id] = companyAddress;

                                    if (companyAddress.type === JF_SHARED_CONFIG.modelTypes.service_address) {
                                        jfLocation
                                            .postalCodeInService(companyAddress.attributes.postal_code_id, companyId)
                                            .then(function(validationResult) {
                                                addresses[companyAddress.id].postal_code_in_service = validationResult.valid;

                                                if (
                                                    angular.isDefined(validationResult.postalCodeDetails) &&
                                                    angular.isDefined(validationResult.postalCodeDetails.plant_id) &&
                                                    validationResult.postalCodeDetails.plant_id !== null
                                                ) {
                                                    addresses[companyAddress.id].plant_id = validationResult.postalCodeDetails.plant_id;
                                                }

                                                deferred.resolve(addresses);
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    } else {
                                        deferred.resolve(addresses);
                                    }
                                    promises.push(deferred.promise);
                                });

                                $q.all(promises)
                                    .then(function(results) {
                                        var returnValue = {};

                                        angular.forEach(results, function(result) {
                                            angular.extend(returnValue, result);
                                        });

                                        deferred.resolve(returnValue);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.resolve({});
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                fetchUserAddress: function(userAddressId) {
                    var deferred = $q.defer();

                    AccountAddressesFactory
                        .get(
                            {
                                'filter[addressable_id]': jfUser.get().corporateEnabled ? jfUser.get().companyId : jfUser.get().id,
                                'filter[addressable_type]': jfUser.get().corporateEnabled ? 'Company' : 'Customer',
                                addressId: userAddressId
                            }
                        )
                        .$promise
                        .then(function(address) {
                            deferred.resolve(address);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                isCompanyAccount: function() {
                    return $localStorage.catalogType === JF_CONFIG.accountTypes.company;
                },
                isB2BAccount: function() {
                    return jfUser.get().companyId && !jfUser.get().corporateEnabled;
                },
                setCatalogLocationForCompany: function() {
                    var deferred = $q.defer(),
                        factory = this;

                    this
                        .fetchUserCompanyAddresses(jfUser.get().companyId)
                        .then(function(companyAddresses) {
                            if ($rootScope.countObjKeys(companyAddresses) > 0) {
                                var catalogLocation;

                                if (
                                    angular.isDefined(jfUser.get().pb2bid) &&
                                    jfUser.get().pb2bid !== null &&
                                    companyAddresses[jfUser.get().pb2bid].type === JF_CONFIG.addressTypes.service
                                ) {
                                    catalogLocation = companyAddresses[jfUser.get().pb2bid].attributes;
                                } else {
                                    catalogLocation = factory.getServiceableCompanyAddress(companyAddresses);
                                }

                                if (catalogLocation !== null) {
                                    catalogLocation.default_locale = LanguageFactory.getActiveLocale();

                                    $injector
                                        .get('ProductsFactory')
                                        .setCatalogLocation({
                                            postal_code_id: catalogLocation.postal_code_id,
                                            postal_code: catalogLocation.postal_code,
                                            city: catalogLocation.city,
                                            province: catalogLocation.province,
                                            country: catalogLocation.country,
                                            country_code: catalogLocation.country_code,
                                            default_locale: catalogLocation.default_locale,
                                            addressable_type: 'Company',
                                            company: catalogLocation.addressable_id
                                        });
                                }

                                deferred.resolve();
                            } else {
                                deferred.resolve();
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });


                    return deferred.promise;
                },
                getServiceableCompanyAddress: function(companyAddresses) {
                    var addressToSave = null;

                    angular.forEach(companyAddresses, function(companyAddress) {
                        if (
                            addressToSave === null &&
                            companyAddress.type === JF_SHARED_CONFIG.modelTypes.service_address
                        ) {
                            addressToSave = companyAddress.attributes;
                            addressToSave.id = companyAddress.id;
                        }
                    });

                    if (addressToSave !== null) {
                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                        addressToSave.type = JF_CONFIG.addressTypes.service;
                    }

                    return addressToSave;
                },
                submitLoginSuccessCallback: function() {
                    var factory = this;

                    if (angular.isDefined($window.Sentry)) {
                        $window.Sentry.setUser({ id: jfUser.get().id });
                    }

                    factory
                        .fetchUserTypeAccount()
                        .then(function (userDetails) {
                            jfUser.update({
                                corporateEnabled: userDetails.attributes.corporate_enabled
                            });

                            if (userDetails.attributes.corporate_enabled) {
                                jfUser.update({
                                    companyId: userDetails.relationships.company.data.id
                                });

                                factory
                                    .fetchCompanyPostalCode(userDetails.relationships.company.data.id)
                                    .then(function () {
                                        if (
                                            angular.isDefined($localStorage.order) &&
                                            angular.isDefined($localStorage.order.details) &&
                                            angular.isDefined($localStorage.order.details.id)
                                        ) {
                                            SpinnerFactory.unset(['login-page']);
                                            SpinnerFactory.set('global');

                                            ProductsFactory
                                                .changeCatalogType()
                                                .then(function() {
                                                    SpinnerFactory.unset('global');
                                                    factory.setCatalogAndRedirect(userDetails.relationships.company.data.id);
                                                }, function(err) {
                                                    SpinnerFactory.unset('global');
                                                    $rootScope.$emit('app-error', {err: err});
                                                });
                                        } else {
                                            $injector.get('ProductsFactory').setCatalogType(JF_CONFIG.accountTypes.company);
                                            factory.setCatalogAndRedirect(userDetails.relationships.company.data.id);
                                        }
                                    }, function (err) {
                                        SpinnerFactory.unset(['login-page']);
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                factory.setCatalogAndRedirect(
                                    userDetails.relationships.company.data !== null ?
                                        userDetails.relationships.company.data.id :
                                        null
                                );

                                $injector.get('ProductsFactory').setCatalogType(JF_CONFIG.accountTypes.personal);
                            }
                        }, function(err) {
                            $rootScope.$emit('app-error', {err: err});
                        });
                },
                fetchCompanyPostalCode: function(companyId) {
                    var deferred = $q.defer(),
                        factory = this;

                    factory
                        .fetchUserCompanyAddresses(companyId)
                        .then(function(companyAddresses) {
                            if ($rootScope.countObjKeys(companyAddresses) >= 1) {
                                if (
                                    angular.isDefined(jfUser.get().pb2bid) &&
                                    jfUser.get().pb2bid !== null &&
                                    companyAddresses[jfUser.get().pb2bid].attributes.postal_code_id !== null
                                ) {
                                    jfUser.update({companyPostalCode: companyAddresses[jfUser.get().pb2bid].attributes.postal_code});

                                    $injector.get('ProductsFactory').setCatalogLocation({
                                        postal_code_id: companyAddresses[jfUser.get().pb2bid].attributes.postal_code_id,
                                        postal_code: companyAddresses[jfUser.get().pb2bid].attributes.postal_code,
                                        city: companyAddresses[jfUser.get().pb2bid].attributes.city,
                                        province: companyAddresses[jfUser.get().pb2bid].attributes.province,
                                        country: companyAddresses[jfUser.get().pb2bid].attributes.country,
                                        country_code: companyAddresses[jfUser.get().pb2bid].attributes.country_code,
                                        default_locale: companyAddresses[jfUser.get().pb2bid].attributes.default_locale,
                                        addressable_type: 'Company',
                                        company: companyAddresses[jfUser.get().pb2bid].attributes.addressable_id
                                    });
                                } else {
                                    var addressToSave = factory.getServiceableCompanyAddress(companyAddresses);

                                    if (addressToSave !== null) {
                                        jfUser.update({
                                            companyPostalCode: addressToSave.postal_code
                                        });

                                        $injector.get('ProductsFactory').setCatalogLocation({
                                            postal_code_id: addressToSave.postal_code_id,
                                            postal_code: addressToSave.postal_code,
                                            city: addressToSave.city,
                                            province: addressToSave.province,
                                            country: addressToSave.country,
                                            country_code: addressToSave.country_code,
                                            default_locale: addressToSave.default_locale,
                                            addressable_type: 'Company',
                                            company: addressToSave.addressable_id
                                        });
                                    } else {
                                        $injector.get('ProductsFactory').setCatalogType(JF_CONFIG.accountTypes.personal);
                                    }
                                }
                            } else {
                                $rootScope.$emit('app-error', {
                                    err: {
                                        status: 404,
                                        error: 'Company does not have address.'
                                    }
                                });
                            }
                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                setCatalogAndRedirect: function (companyId) {
                    var factory = this;

                    if (angular.isDefined($state.params.redirect) && $state.params.redirect !== null) {
                        if ($state.params.redirect.indexOf('https') > -1) {
                            $window.location = $state.params.redirect;
                        } else {
                            $location.path($state.params.redirect);
                        }
                    } else {
                        if (
                            $localStorage.catalogType === JF_CONFIG.accountTypes.personal &&
                            angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                            angular.isDefined($localStorage.lastPrivateCatalogLocation.postal_code_id) &&
                            jfUser.get().pdid === null
                        ) {
                            factory.setUserLocale($localStorage.lastPrivateCatalogLocation);
                            factory.redirectTo($state.params.checkoutRedirect);
                        } else if (
                            (
                                jfUser.get().pdid !== null && $localStorage.catalogType === JF_CONFIG.accountTypes.personal
                            ) ||
                            (
                                jfUser.get().pb2bid !== null && $localStorage.catalogType === JF_CONFIG.accountTypes.company
                            )
                        ) {
                            var addressId = $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? jfUser.get().pdid : jfUser.get().pb2bid;

                            factory
                                .fetchUserAddress(addressId)
                                .then(function(userAddress) {
                                    if ($localStorage.catalogType === JF_CONFIG.accountTypes.personal) {
                                        jfLocation
                                            .postalCodeInService(userAddress.data.attributes.postal_code_id, companyId)
                                            .then(function(validationResult) {
                                                if (validationResult.valid === true) {
                                                    factory.setUserLocale(userAddress.data.attributes);

                                                    factory.redirectTo($state.params.checkoutRedirect);
                                                } else {
                                                    if ($rootScope.mobileAppMode) {
                                                        $state.go('location-picker');
                                                    } else {
                                                        $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                                                    }
                                                }
                                            }, function(err) {
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    } else {
                                        factory.setUserLocale(userAddress.data.attributes);

                                        factory.redirectTo($state.params.checkoutRedirect);
                                    }
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            if ($localStorage.catalogType === JF_CONFIG.accountTypes.personal) {
                                AccountAddressesFactory
                                    .get({
                                        'filter[addressable_id]': jfUser.get().id,
                                        'filter[addressable_type]': 'Customer'
                                    })
                                    .$promise
                                    .then(function(addresses) {
                                        if (addresses.data.length >= 1) {
                                            factory.setUserLocale(addresses.data[0].attributes);

                                            factory.redirectTo($state.params.checkoutRedirect);
                                        } else {
                                            if (
                                                angular.isDefined($localStorage.catalogLocation) &&
                                                angular.isDefined($localStorage.catalogLocation.postal_code) &&
                                                angular.isDefined($localStorage.catalogLocation.postal_code_id)
                                            ) {
                                                factory.redirectTo($state.params.checkoutRedirect);
                                            } else {
                                                if ($rootScope.mobileAppMode) {
                                                    $state.go('location-picker');
                                                } else {
                                                    $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                                                }
                                            }
                                        }
                                    }, function(err) {
                                        $rootScope.$emit('app-error', {err: err});
                                    });
                            } else {
                                factory.redirectTo($state.params.checkoutRedirect);
                            }
                        }
                    }
                },
                setUserLocale: function(address) {
                    var catalogAddress = angular.copy(address);

                    catalogAddress.default_locale = jfUser.get().locale || ($localStorage.shopLocale || JF_CONFIG.defaultLocale);

                    $injector.get('ProductsFactory').setCatalogLocation({
                        postal_code_id: catalogAddress.postal_code_id,
                        postal_code: catalogAddress.postal_code,
                        city: catalogAddress.city,
                        province: catalogAddress.province,
                        country: catalogAddress.country,
                        country_code: catalogAddress.country_code,
                        default_locale: catalogAddress.default_locale,
                        addressable_type: catalogAddress.addressable_type === 'Company' ? 'Company' : 'Customer',
                        company: catalogAddress.addressable_id
                    });
                },
                redirectTo: function(checkoutRedirect) {
                    if (checkoutRedirect) {
                        $state.go('checkout');
                    } else {
                        $state.go('products', {'#': 'c0'});
                    }
                },
                submitCompanyAccountPreferences: function(companyAddresses, companyAddress, gaEventSection) {
                    var deferred = $q.defer();
                    var companyAddressId = companyAddress.id;

                    if (angular.isDefined(gaEventSection) && gaEventSection !== null) {
                        $rootScope.sendGAEvent(gaEventSection, 'saveButton');
                    }

                    this
                        .saveUserPreferences(companyAddresses, companyAddressId)
                        .then(function() {
                            deferred.resolve(companyAddress);
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                saveUserPreferences: function(companyAddresses, companyAddressId, silent) {
                    var deferred = $q.defer();
                    AccountUserProfileFactory
                        .update(
                            { id: jfUser.get().profileId },
                            jfJsonApi.prepare(
                                JF_SHARED_CONFIG.modelTypes.profile,
                                {
                                    preferred_b2b_address_id: companyAddressId
                                },
                                { id: jfUser.get().profileId }
                            )
                        )
                        .$promise
                        .then(function() {
                            jfUser.update({
                                pb2bid: companyAddressId,
                                companyPostalCode: companyAddresses[companyAddressId].attributes.postal_code
                            });

                            if (angular.isDefined($localStorage.catalogType) && $localStorage.catalogType === JF_CONFIG.accountTypes.company) {
                                var catalogLocation = angular.copy(companyAddresses[companyAddressId].attributes);

                                catalogLocation.default_locale = LanguageFactory.getActiveLocale();

                                if (catalogLocation.postal_code_id !== null) {
                                    ProductsFactory.setCatalogLocation(catalogLocation);
                                }
                                if (!silent) {
                                    $mdDialog.hide();
                                }
                            }

                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                updateOrderWithNewAddress: function(companyId, addressToSave) {
                    var deferred = $q.defer();

                    jfLocation
                        .postalCodeInService(addressToSave.postal_code_id, companyId)
                        .then(function(validationResult) {
                            if (validationResult.valid === true) {
                                OrderFactory
                                    .updateOrder(
                                        $localStorage.order.details.id,
                                        {
                                            payment_method_id_destroy: true,
                                            pickup_start_ts: null,
                                            pickup_end_ts: null,
                                            delivery_start_ts: null,
                                            delivery_end_ts: null,
                                            company_id: companyId,
                                            pickup_address: addressToSave,
                                            delivery_address: addressToSave,
                                            billing_address: { _destroy: true }
                                        }
                                    )
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.resolve();
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                chooseAddress: function(companyId, companyAddresses, companyAddress, gaEventSection, showCancelButton, callback) {
                    var factory = this;

                    if ($rootScope.countObjKeys(companyAddresses) === 1) {
                        var addressToSave = this.getServiceableCompanyAddress(companyAddresses);

                        if (addressToSave === null) {
                            addressToSave = { _destroy: true };
                            ProductsFactory.clearCatalogLocation();
                        } else {
                            addressToSave.resource_id = addressToSave.id;
                        }

                        if (
                            angular.isDefined($localStorage.order) &&
                            angular.isDefined($localStorage.order.details) &&
                            angular.isDefined($localStorage.order.details.id)
                        ) {
                            this.updateOrderWithNewAddress(companyId, addressToSave)
                                .then(function() {
                                    if (callback) {
                                        callback(addressToSave);
                                    }
                                }, function(err) {
                                    $rootScope.$emit('app-error', {err: err});
                                });
                        } else {
                            if (callback) {
                                callback(addressToSave);
                            }
                        }
                    } else {
                        $mdDialog
                            .show({
                                templateUrl: 'app/components/account/directives/jf-company-preferences-addresses.dialog.html',
                                parent: angular.element(document.body),
                                clickOutsideToClose: false,
                                escapeToClose: false,
                                controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                                    factory.chooseAddressInit(companyAddresses, companyAddress, showCancelButton, $scope);

                                    $scope.chooseLocation = function(location, key) {
                                        $scope.buttonSaveDisabled = false;
                                        $scope.companyAddress = location;
                                        $scope.selectedIndex = key;
                                    };

                                    /* istanbul ignore next */
                                    $scope.cancelAction = function() {
                                        $mdDialog.hide();
                                    };

                                    $scope.saveAction = function() {
                                        SpinnerFactory.set('account-corporate');

                                        factory
                                            .submitCompanyAccountPreferences(companyAddresses, $scope.companyAddress, gaEventSection)
                                            .then(function() {
                                                var addressToSave = {};
                                                addressToSave = $scope.companyAddress.attributes;
                                                addressToSave.id = $scope.companyAddress.id;
                                                addressToSave.type = JF_CONFIG.addressTypes.service;

                                                factory
                                                    .updateOrderWithNewAddress(companyId, addressToSave)
                                                    .then(function() {
                                                        SpinnerFactory.unset('account-corporate');
                                                        if (callback) {
                                                            callback(addressToSave);
                                                        }
                                                    }, function(err) {
                                                        SpinnerFactory.unset('account-corporate');
                                                        $rootScope.$emit('app-error', {err: err});
                                                    });
                                            }, function(err) {
                                                SpinnerFactory.unset('account-corporate');
                                                $rootScope.$emit('app-error', {err: err});
                                            });
                                    };
                                }]
                            });
                    }
                },
                chooseAddressInit: function(companyAddresses, companyAddress, showCancelButton, dialogScope) {
                    dialogScope.locations = companyAddresses;
                    dialogScope.buttonSaveDisabled = true;
                    dialogScope.companyAddress = companyAddress;
                    dialogScope.selectedIndex = -1;
                    dialogScope.showCancelButton = showCancelButton;

                    angular.forEach(Object.keys(companyAddresses), function(location, key) {
                        if (location === companyAddress) {
                            dialogScope.selectedIndex = key;
                        }
                    });
                }
            };
        }]);
/**
 * Products factory
 */
angular.module('jfApp')
    .factory(
        'ProductsFactory',
        ['$rootScope', '$q', '$localStorage', '$location', '$window', '$state', '$filter', '$cookies', '$injector', 'JF_CONFIG', 'JF_SHARED_CONFIG', 'base64', 'jfUser', 'SpinnerFactory', 'ShopLocalizedCatalogFactory', 'ContextPostalCodesFactory', 'CustomerAppHelpersFactory', 'OrderFactory', 'jfLocation', function(
            $rootScope,
            $q,
            $localStorage,
            $location,
            $window,
            $state,
            $filter,
            $cookies,
            $injector,
            JF_CONFIG,
            JF_SHARED_CONFIG,
            base64,
            jfUser,
            SpinnerFactory,
            ShopLocalizedCatalogFactory,
            ContextPostalCodesFactory,
            CustomerAppHelpersFactory,
            OrderFactory,
            jfLocation
        ) {
            'use strict';

            return {
                initCatalog: function() {
                    var deferred = $q.defer(),
                        model = this;

                    if ($rootScope.mobileAppMode) {
                        model
                            .initMobileCatalog()
                            .then(function(city) {
                                deferred.resolve(city);
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else {
                        model
                            .initDesktopCatalog()
                            .then(function(city) {
                                deferred.resolve(city);
                            }, function(err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                },
                initDesktopCatalog: function() {
                    var deferred = $q.defer(),
                        model = this,
                        locationParams = model.getLocationParams(),
                        addressToSave,
                        CustomerAppHelpersFactory = $injector.get('CustomerAppHelpersFactory');

                    if (locationParams !== null && angular.isDefined(locationParams.postalCodeId)) {
                        ContextPostalCodesFactory
                            .get({
                                id: locationParams.postalCodeId,
                                sort: 'city_name',
                            })
                            .$promise
                            .then(function(results) {
                                if (angular.isDefined(results.data) && results.data !== null) {
                                    var companyId = jfUser.isLoggedIn() ? jfUser.get().companyId : null;
                                    var country = JF_SHARED_CONFIG.countries.find(function(country) { return country.code === results.data.attributes.country_code; });

                                    jfLocation
                                        .postalCodeInService(results.data.id, companyId)
                                        .then(function(validationResult) {
                                            if (validationResult.valid === true) {
                                                model.clearLocationParams();

                                                if (
                                                    angular.isUndefined($localStorage.catalogLocation) ||
                                                    results.data.attributes.code !== $localStorage.catalogLocation.postal_code
                                                ) {
                                                    if (locationParams.corporate === '1') {
                                                        model.setCatalogType(JF_CONFIG.accountTypes.company);
                                                    } else if ($localStorage.catalogType === JF_CONFIG.accountTypes.company) {
                                                        model.setCatalogType(JF_CONFIG.accountTypes.personal);
                                                    }

                                                    model.setCatalogLocation({
                                                        postal_code_id: results.data.id,
                                                        postal_code: results.data.attributes.code,
                                                        city: results.data.attributes.city_name,
                                                        province: null,
                                                        country: country.name,
                                                        country_code: results.data.attributes.country_code,
                                                        default_locale: country.default_locale,
                                                        addressable_type: $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company',
                                                        company: companyId
                                                    });

                                                    addressToSave = angular.copy($localStorage.catalogLocation);

                                                    OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                                    var additionalParams = {
                                                        pickup_address: addressToSave,
                                                        delivery_address: addressToSave
                                                    };

                                                    OrderFactory
                                                        .createNewOrder(additionalParams)
                                                        .then(function() {
                                                            model
                                                                .getCatalog(
                                                                    $localStorage.catalogLocation.country_code,
                                                                    $localStorage.catalogLocation.city,
                                                                    $localStorage.catalogLocation.postal_code,
                                                                    $localStorage.catalogLocation.postal_code_id,
                                                                    $localStorage.catalogLocation.locale,
                                                                    CustomerAppHelpersFactory.getCompanyId()
                                                                )
                                                                .then(function() {
                                                                    OrderFactory
                                                                        .fetchOrderItems()
                                                                        .then(function() {
                                                                            deferred.resolve($localStorage.catalogLocation.city);
                                                                        }, function(err) {
                                                                            deferred.reject(err);
                                                                        });
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                } else {
                                                    if (locationParams.corporate === '1') {
                                                        model.setCatalogType(JF_CONFIG.accountTypes.company);
                                                    } else {
                                                        model.setCatalogType(JF_CONFIG.accountTypes.personal);
                                                    }

                                                    if (
                                                        (
                                                            angular.isUndefined($localStorage.order.details.attributes.delivery_address) ||
                                                            $localStorage.order.details.attributes.delivery_address === null
                                                        ) ||
                                                        angular.isUndefined($localStorage.catalogLocation) ||
                                                        results.data.attributes.code !== $localStorage.catalogLocation.postal_code
                                                    ) {
                                                        model.setCatalogLocation({
                                                            postal_code_id: results.data.id,
                                                            postal_code: results.data.attributes.code,
                                                            city: results.data.attributes.city_name,
                                                            province: null,
                                                            country: country.name,
                                                            country_code: results.data.attributes.country_code,
                                                            default_locale: country.default_locale,
                                                            addressable_type: $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company',
                                                            company: companyId
                                                        });

                                                        addressToSave = angular.copy($localStorage.catalogLocation);

                                                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                                        if (angular.isUndefined($localStorage.order.details.id) || $localStorage.order.details.id === null) {
                                                            OrderFactory
                                                                .createNewOrder(
                                                                    {
                                                                        pickup_address: addressToSave,
                                                                        delivery_address: addressToSave
                                                                    }
                                                                )
                                                                .then(function() {
                                                                    model
                                                                        .getCatalog(
                                                                            $localStorage.catalogLocation.country_code,
                                                                            $localStorage.catalogLocation.city,
                                                                            $localStorage.catalogLocation.postal_code,
                                                                            $localStorage.catalogLocation.postal_code_id,
                                                                            $localStorage.catalogLocation.locale,
                                                                            CustomerAppHelpersFactory.getCompanyId()
                                                                        )
                                                                        .then(function() {
                                                                            OrderFactory
                                                                                .fetchOrderItems()
                                                                                .then(function() {
                                                                                    deferred.resolve($localStorage.catalogLocation.city);
                                                                                }, function(err) {
                                                                                    deferred.reject(err);
                                                                                });
                                                                        }, function(err) {
                                                                            deferred.reject(err);
                                                                        });
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        } else {
                                                            OrderFactory
                                                                .updateOrder(
                                                                    $localStorage.order.details.id,
                                                                    {
                                                                        pickup_address: addressToSave,
                                                                        delivery_address: addressToSave,
                                                                        company_id: CustomerAppHelpersFactory.getCompanyId()
                                                                    }
                                                                )
                                                                .then(function() {
                                                                    model
                                                                        .getCatalog(
                                                                            $localStorage.catalogLocation.country_code,
                                                                            $localStorage.catalogLocation.city,
                                                                            $localStorage.catalogLocation.postal_code,
                                                                            $localStorage.catalogLocation.postal_code_id,
                                                                            $localStorage.catalogLocation.locale,
                                                                            CustomerAppHelpersFactory.getCompanyId()
                                                                        )
                                                                        .then(function() {
                                                                            OrderFactory
                                                                                .fetchOrderItems()
                                                                                .then(function() {
                                                                                    deferred.resolve($localStorage.catalogLocation.city);
                                                                                }, function(err) {
                                                                                    deferred.reject(err);
                                                                                });
                                                                        }, function(err) {
                                                                            deferred.reject(err);
                                                                        });
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }
                                                    } else {
                                                        model.setCatalogLocation({
                                                            postal_code_id: results.data.id,
                                                            postal_code: results.data.attributes.code,
                                                            city: results.data.attributes.city_name,
                                                            province: null,
                                                            country: country.name,
                                                            country_code: results.data.attributes.country_code,
                                                            default_locale: country.default_locale,
                                                            addressable_type: $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company',
                                                            company: companyId
                                                        });

                                                        model
                                                            .getCatalog(
                                                                $localStorage.catalogLocation.country_code,
                                                                $localStorage.catalogLocation.city,
                                                                $localStorage.catalogLocation.postal_code,
                                                                $localStorage.catalogLocation.postal_code_id,
                                                                $localStorage.catalogLocation.locale,
                                                                CustomerAppHelpersFactory.getCompanyId()
                                                            )
                                                            .then(function() {
                                                                OrderFactory
                                                                    .fetchOrderItems()
                                                                    .then(function() {
                                                                        deferred.resolve($localStorage.catalogLocation.city);
                                                                    }, function(err) {
                                                                        deferred.reject(err);
                                                                    });
                                                            }, function(err) {
                                                                deferred.reject(err);
                                                            });
                                                    }
                                                }
                                            } else {
                                                SpinnerFactory.set('global');

                                                $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                                            }
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    SpinnerFactory.set('global');

                                    $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                                }
                            }, function(err) {
                                deferred.reject(err);
                            });
                    } else if (
                        angular.isDefined($localStorage.catalogLocation) &&
                        $rootScope.countObjKeys($localStorage.catalogLocation) > 0 &&
                        $localStorage.catalogLocation.postal_code_id !== null
                    ) {
                        model.clearLocationParams();

                        var currentUserCompanyId = (jfUser.isLoggedIn() && $localStorage.catalogType === JF_CONFIG.accountTypes.company) ? jfUser.get().companyId : null;

                        if (
                            angular.isUndefined($localStorage.order.details.attributes.delivery_address) ||
                            $localStorage.order.details.attributes.delivery_address === null ||
                            $localStorage.order.details.attributes.pickup_address === null ||
                            $localStorage.order.details.attributes.delivery_address.postal_code !== $localStorage.catalogLocation.postal_code ||
                            $localStorage.order.details.attributes.pickup_address.postal_code !== $localStorage.catalogLocation.postal_code
                        ) {
                            jfLocation
                                .postalCodeInService($localStorage.catalogLocation.postal_code_id, currentUserCompanyId)
                                .then(function(validationResult) {
                                    if (validationResult.valid === true) {
                                        addressToSave = angular.copy($localStorage.catalogLocation);
                                        addressToSave.addressable_type = $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company';

                                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                        if (angular.isUndefined($localStorage.order.details.id) || $localStorage.order.details.id === null) {
                                            OrderFactory
                                                .createNewOrder(
                                                    {
                                                        pickup_address: addressToSave,
                                                        delivery_address: addressToSave
                                                    }
                                                )
                                                .then(function() {
                                                    model
                                                        .getCatalog(
                                                            $localStorage.catalogLocation.country_code,
                                                            $localStorage.catalogLocation.city,
                                                            $localStorage.catalogLocation.postal_code,
                                                            $localStorage.catalogLocation.postal_code_id,
                                                            $localStorage.catalogLocation.locale,
                                                            CustomerAppHelpersFactory.getCompanyId()
                                                        )
                                                        .then(function() {
                                                            OrderFactory
                                                                .fetchOrderItems()
                                                                .then(function() {
                                                                    deferred.resolve($localStorage.catalogLocation.city);
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        } else {

                                            OrderFactory
                                                .updateOrder(
                                                    $localStorage.order.details.id,
                                                    {
                                                        pickup_address: addressToSave,
                                                        delivery_address: addressToSave,
                                                        company_id: CustomerAppHelpersFactory.getCompanyId()
                                                    }
                                                )
                                                .then(function() {
                                                    model
                                                        .getCatalog(
                                                            $localStorage.catalogLocation.country_code,
                                                            $localStorage.catalogLocation.city,
                                                            $localStorage.catalogLocation.postal_code,
                                                            $localStorage.catalogLocation.postal_code_id,
                                                            $localStorage.catalogLocation.locale,
                                                            CustomerAppHelpersFactory.getCompanyId()
                                                        )
                                                        .then(function() {
                                                            OrderFactory
                                                                .fetchOrderItems()
                                                                .then(function() {
                                                                    deferred.resolve($localStorage.catalogLocation.city);
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }
                                    } else {
                                        SpinnerFactory.set('global');

                                        $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                                    }
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            jfLocation
                                .postalCodeInService($localStorage.catalogLocation.postal_code_id, currentUserCompanyId)
                                .then(function(validationResult) {
                                    if (validationResult.valid === true) {
                                        model
                                            .getCatalog(
                                                $localStorage.catalogLocation.country_code,
                                                $localStorage.catalogLocation.city,
                                                $localStorage.catalogLocation.postal_code,
                                                $localStorage.catalogLocation.postal_code_id,
                                                $localStorage.catalogLocation.locale,
                                                CustomerAppHelpersFactory.getCompanyId()
                                            )
                                            .then(function() {
                                                OrderFactory
                                                    .fetchOrderItems()
                                                    .then(function() {
                                                        deferred.resolve($localStorage.catalogLocation.city);
                                                    }, function(err) {
                                                        deferred.reject(err);
                                                    });
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    } else {
                                        SpinnerFactory.set('global');

                                        $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                                    }
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }
                    } else {
                        $rootScope.$emit('app-log', { msg: 'Empty catalog location!' });

                        if (angular.isDefined($localStorage.catalogLocation)) {
                            delete $localStorage.catalogLocation;
                        }

                        if (angular.isDefined($localStorage.lastPrivateCatalogLocation)) {
                            delete $localStorage.lastPrivateCatalogLocation;
                        }

                        SpinnerFactory.set('global');

                        $state.reload();
                    }

                    return deferred.promise;
                },
                initMobileCatalog: function() {
                    var deferred = $q.defer(),
                        model = this,
                        addressToSave,
                        currentUserCompanyId = (jfUser.isLoggedIn() && $localStorage.catalogType === JF_CONFIG.accountTypes.company) ? jfUser.get().companyId : null,
                        CustomerAppHelpersFactory = $injector.get('CustomerAppHelpersFactory');

                    if (
                        angular.isDefined($localStorage.catalogLocation) &&
                        $rootScope.countObjKeys($localStorage.catalogLocation) > 0 &&
                        $localStorage.catalogLocation.postal_code_id !== null
                    ) {
                        if (
                            angular.isUndefined($localStorage.order.details.attributes.delivery_address) ||
                            $localStorage.order.details.attributes.delivery_address === null ||
                            $localStorage.order.details.attributes.pickup_address === null ||
                            $localStorage.order.details.attributes.delivery_address.postal_code !== $localStorage.catalogLocation.postal_code ||
                            $localStorage.order.details.attributes.pickup_address.postal_code !== $localStorage.catalogLocation.postal_code
                        ) {
                            jfLocation
                                .postalCodeInService($localStorage.catalogLocation.postal_code_id, currentUserCompanyId)
                                .then(function(validationResult) {
                                    if (validationResult.valid === true) {
                                        addressToSave = angular.copy($localStorage.catalogLocation);
                                        addressToSave.addressable_type = $localStorage.catalogType === JF_CONFIG.accountTypes.personal ? 'Customer' : 'Company';

                                        OrderFactory.prefillEmptyOrderAddressDetails(addressToSave);

                                        if (angular.isUndefined($localStorage.order.details.id) || $localStorage.order.details.id === null) {
                                            OrderFactory
                                                .createNewOrder(
                                                    {
                                                        pickup_address: addressToSave,
                                                        delivery_address: addressToSave
                                                    }
                                                )
                                                .then(function() {
                                                    model
                                                        .getCatalog(
                                                            $localStorage.catalogLocation.country_code,
                                                            $localStorage.catalogLocation.city,
                                                            $localStorage.catalogLocation.postal_code,
                                                            $localStorage.catalogLocation.postal_code_id,
                                                            $localStorage.catalogLocation.locale,
                                                            CustomerAppHelpersFactory.getCompanyId()
                                                        )
                                                        .then(function() {
                                                            OrderFactory
                                                                .fetchOrderItems()
                                                                .then(function() {
                                                                    deferred.resolve($localStorage.catalogLocation.city);
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        } else {
                                            OrderFactory
                                                .updateOrder(
                                                    $localStorage.order.details.id,
                                                    {
                                                        pickup_address: addressToSave,
                                                        delivery_address: addressToSave,
                                                        company_id: CustomerAppHelpersFactory.getCompanyId()
                                                    }
                                                )
                                                .then(function() {
                                                    model
                                                        .getCatalog(
                                                            $localStorage.catalogLocation.country_code,
                                                            $localStorage.catalogLocation.city,
                                                            $localStorage.catalogLocation.postal_code,
                                                            $localStorage.catalogLocation.postal_code_id,
                                                            $localStorage.catalogLocation.locale,
                                                            CustomerAppHelpersFactory.getCompanyId()
                                                        )
                                                        .then(function() {
                                                            OrderFactory
                                                                .fetchOrderItems()
                                                                .then(function() {
                                                                    deferred.resolve($localStorage.catalogLocation.city);
                                                                }, function(err) {
                                                                    deferred.reject(err);
                                                                });
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }
                                    } else {
                                        $state.go('location-picker');
                                    }
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        } else {
                            model
                                .getCatalog(
                                    $localStorage.catalogLocation.country_code,
                                    $localStorage.catalogLocation.city,
                                    $localStorage.catalogLocation.postal_code,
                                    $localStorage.catalogLocation.postal_code_id,
                                    $localStorage.catalogLocation.locale,
                                    CustomerAppHelpersFactory.getCompanyId()
                                )
                                .then(function() {
                                    OrderFactory
                                        .fetchOrderItems()
                                        .then(function() {
                                            deferred.resolve($localStorage.catalogLocation.city);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }
                    } else {
                        SpinnerFactory.unset('global');
                        $state.go('location-picker');
                    }

                    return deferred.promise;
                },
                locationParamsAvailable: function() {
                    var urlGetParams = angular.copy($location.search()),
                        cookieParams = $cookies.get('jf-wp-plz');

                    return (
                               angular.isDefined(urlGetParams.plz) &&
                               urlGetParams.plz !== ''
                           ) ||
                           angular.isDefined(cookieParams);
                },
                getLocationParams: function() {
                    var urlGetParams = angular.copy($location.search()),
                        cookieParams = $cookies.get('jf-wp-plz');

                    if (angular.isDefined(urlGetParams.postalCodeId) && urlGetParams.postalCodeId !== '') {
                        return {
                            postalCodeId: urlGetParams.postalCodeId,
                            locale: urlGetParams.locale || $localStorage.shopLocale || JF_CONFIG.defaultLocale,
                            corporate: urlGetParams.corporate || null
                        };
                    } else if (angular.isDefined(cookieParams)) {
                        cookieParams = cookieParams.split('|');

                        if (cookieParams[0].length > 8) {
                            return {
                                postalCodeId: cookieParams[0],
                                locale: cookieParams[1],
                                corporate: cookieParams[2] || null,
                            };
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
                clearLocationParams: function() {
                    var urlGetParams = angular.copy($location.search());

                    if (angular.isDefined(urlGetParams.postalCodeId) || angular.isDefined(urlGetParams.plz)) {
                        $location.search('plz', null);
                        $location.search('postalCodeId', null);
                        $location.search('corporate', null);
                    } else if (angular.isDefined($cookies.get('jf-wp-plz'))) {
                        $cookies.remove('jf-wp-plz', {
                            path: '/',
                            domain: JF_CONFIG.cookies_domain
                        });
                    }
                },
                saveCatalog: function (catalogData, city, locale, locationHash, companyId, priceListId) {
                    $localStorage.catalogContent = {
                        city: city,
                        location: locationHash,
                        locale: locale || JF_CONFIG.defaultLocale,
                        catalog: catalogData,
                        companyId: companyId,
                        priceListId: priceListId
                    };
                },
                loadSavedCatalog: function() {
                    if (JSON.stringify($rootScope.categoriesArr) !== JSON.stringify($localStorage.catalogContent.catalog)) {
                        $rootScope.categoriesArr = $localStorage.catalogContent.catalog;
                    }
                },
                fetchCatalogFromBackend: function(countryCode, city, postalCode, postalCodeId, locale, locationHash, companyId) {
                    var deferred = $q.defer(),
                        model = this;

                    SpinnerFactory.set('global');

                    ShopLocalizedCatalogFactory
                        .get({
                            'filter[by_location][country_code]': countryCode,
                            'filter[by_location][city]': city,
                            'filter[by_location][postal_code]': postalCode,
                            'filter[by_location][postal_code_id]': postalCodeId,
                            'filter[locale]': locale || JF_CONFIG.defaultLocale,
                            'filter[company_id]': companyId,
                            't': new Date().getTime(),
                            include: 'items'
                        })
                        .$promise
                        .then(function(results) {
                            SpinnerFactory.unset('global');

                            var categories = {};

                            if (angular.isUndefined(results.included) || results.included.length === 0) {
                                model.handleEmptyCatalogResponse(countryCode, city, postalCode, postalCodeId, locale, companyId);

                                deferred.resolve();
                            } else {
                                angular.forEach(results.included, function(catalogItem) {
                                    if (catalogItem.type === 'localized_catalog_items') {
                                        if (!angular.isDefined(categories[catalogItem.attributes.category_id])) {
                                            categories[catalogItem.attributes.category_id] = {
                                                position: catalogItem.attributes.category_position,
                                                id: catalogItem.attributes.category_id,
                                                name: catalogItem.attributes.category_name,
                                                image: catalogItem.attributes.category_image_name,
                                                products: []
                                            };
                                        }

                                        if (angular.isUndefined(catalogItem.attributes.product_image_name) ||
                                            catalogItem.attributes.product_image_name === null
                                        ) {
                                            catalogItem.attributes.product_image_name = JF_CONFIG.productImgPlaceholder;
                                        }

                                        categories[catalogItem.attributes.category_id].products.push(catalogItem.attributes);
                                    }
                                });

                                var newCategoriesArr = [];

                                angular.forEach(categories, function(category) {
                                    newCategoriesArr.push(category);
                                });

                                $rootScope.categoriesArr = newCategoriesArr;

                                model.saveCatalog(
                                    $rootScope.categoriesArr,
                                    city,
                                    locale,
                                    locationHash,
                                    companyId,
                                    results.data.relationships.price_list.data.id
                                );

                                if (
                                    angular.isDefined($localStorage.catalogContent) &&
                                    $localStorage.order.details.attributes.price_list_id !== null &&
                                    $localStorage.order.details.attributes.price_list_id !== results.data.relationships.price_list.data.id
                                ) {
                                    SpinnerFactory.set(['catalog', 'cart']);

                                    OrderFactory
                                        .updateOrder(
                                            $localStorage.order.details.id,
                                            { price_list: true }
                                        )
                                        .then(function() {
                                            SpinnerFactory.unset(['catalog', 'cart']);

                                            deferred.resolve();
                                        }, function(err) {
                                            SpinnerFactory.unset(['catalog', 'cart']);

                                            deferred.reject(err);
                                        });

                                } else {
                                    deferred.resolve();
                                }
                            }
                        }, function(err) {
                            SpinnerFactory.unset('global');

                            if (err.status === 404) {
                                model.handleEmptyCatalogResponse(countryCode, city, postalCode, postalCodeId, locale, companyId);

                                deferred.resolve();
                            } else if (err.status === 406) {
                                if ($localStorage.order.details.attributes.company_id !== jfUser.get().companyId) {
                                    $rootScope.$emit('app-error', {err: {
                                        msg: 'Company ID missmatch.'
                                    }, silent: true});

                                    SpinnerFactory.set('global');

                                    model
                                        .changeCatalogType()
                                        .then(function() {
                                            SpinnerFactory.unset('global');

                                            $location.hash('');

                                            deferred.resolve();
                                        }, function(err) {
                                            SpinnerFactory.unset('global');

                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                } else {
                                    deferred.reject(err);
                                }
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                handleEmptyCatalogResponse: function(countryCode, city, postalCode, postalCodeId, locale, companyId) {
                    $rootScope.$emit(
                        'app-log',
                        {
                            msg: 'Empty Catalog Response',
                            details: {
                                country_code: countryCode,
                                city: city,
                                postal_code: postalCode,
                                postal_code_id: postalCodeId,
                                locale: locale || JF_CONFIG.defaultLocale,
                                company_id: companyId
                            }
                        }
                    );

                    if ($rootScope.mobileAppMode) {
                        $state.go('location-picker', { emptyCatalog: true, postalCode: postalCode });
                    } else {
                        SpinnerFactory.set('global');

                        $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                    }
                },
                getCatalog: function(countryCode, city, postalCode, postalCodeId, locale, companyId) {
                    var model = this,
                        deferred = $q.defer(),
                        locationHash = base64.encode(countryCode + city + postalCode + postalCodeId);

                    model
                        .fetchCatalogFromBackend(countryCode, city, postalCode, postalCodeId, locale, locationHash, companyId)
                        .then(function() {
                            deferred.resolve();
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                setCatalogLocation: function(address) {
                    if (angular.isUndefined($localStorage.catalogLocation)) {
                        $localStorage.catalogLocation = {};
                    }

                    $localStorage.catalogLocation.postal_code_id = address.postal_code_id;
                    $localStorage.catalogLocation.postal_code = address.postal_code;
                    $localStorage.catalogLocation.city = address.city;
                    $localStorage.catalogLocation.province = address.province;
                    $localStorage.catalogLocation.country_code = address.country_code;
                    $localStorage.catalogLocation.country = address.country;
                    $localStorage.catalogLocation.locale = $localStorage.catalogLocation.locale || $localStorage.shopLocale || address.default_locale;
                    $localStorage.catalogLocation.addressable_type = address.addressable_type;
                    $localStorage.catalogLocation.company = address.company;

                    if (
                        $localStorage.catalogType === JF_CONFIG.accountTypes.personal &&
                        $localStorage.catalogLocation.addressable_type !== 'Company'
                    ) {
                        $localStorage.lastPrivateCatalogLocation = angular.copy($localStorage.catalogLocation);
                    }

                    if (
                        angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                        $localStorage.lastPrivateCatalogLocation.addressable_type === 'Company'
                    ) {
                        delete $localStorage.lastPrivateCatalogLocation;
                    }
                },
                clearCatalogLocation: function() {
                    $localStorage.catalogLocation = {};
                    $rootScope.currentDeliveryLocation = null;
                },
                setCatalogType: function(newCatalogType) {
                    $rootScope.jfShared.catalogType = newCatalogType;
                    $localStorage.catalogType = newCatalogType;

                    $rootScope.$emit('jf:accountTypeChanged');
                },
                changeCatalogType: function() {
                    var deferred = $q.defer(),
                        currentOrderId = $localStorage.order.details.id,
                        factory = this;

                    if ($localStorage.catalogType === JF_CONFIG.accountTypes.personal) {
                        factory.setCatalogType(JF_CONFIG.accountTypes.company);
                    } else {
                        factory.setCatalogType(JF_CONFIG.accountTypes.personal);
                    }

                    OrderFactory
                        .cancelOrder(currentOrderId)
                        .then(function() {
                            factory.processCatalogTypeChange()
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });
                        }, function(err) {
                            if (err.status === 404) {
                                factory.processCatalogTypeChange()
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.reject(err);
                            }
                        });

                    return deferred.promise;
                },
                processCatalogTypeChange: function() {
                    var deferred = $q.defer(),
                    AccountFactory = $injector.get('AccountFactory'),
                    currentOrderItems = angular.copy($localStorage.order.items),
                    factory = this,
                    handlePreviousCartItems = function() {
                        var deferred = $q.defer();

                        factory
                            .initCatalog()
                            .then(function(city) {
                                $rootScope.currentDeliveryLocation = city;
                                $localStorage.currentDeliveryLocation = city;

                                var itemsToRemove = prepareItemsToRemove(currentOrderItems);

                                if (itemsToRemove.length > 0) {
                                    OrderFactory.handleDestroyableOrderItems(
                                        itemsToRemove,
                                        currentOrderItems,
                                        function() {
                                            var itemsToRestore = [];

                                            angular.forEach(currentOrderItems, function(currentOrderItem) {
                                                if (itemsToRemove.indexOf(currentOrderItem.id) === -1) {
                                                    itemsToRestore.push(currentOrderItem);
                                                }
                                            });

                                            OrderFactory
                                                .addManyToOrder(itemsToRestore)
                                                .then(function() {
                                                    deferred.resolve();
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }, function() {
                                            factory
                                                .changeCatalogType()
                                                .then(function() {
                                                    $location.hash('');
                                                    $rootScope.$emit('jf:accountTypeChanged');

                                                    OrderFactory
                                                        .addManyToOrder(currentOrderItems)
                                                        .then(function() {
                                                            deferred.resolve();
                                                        }, function(err) {
                                                            deferred.reject(err);
                                                        });
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }
                                    );
                                } else {
                                    OrderFactory
                                        .addManyToOrder(currentOrderItems)
                                        .then(function() {
                                            deferred.resolve();
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }

                            }, function(err) {
                                deferred.reject(err);
                            });

                        return deferred.promise;
                    },
                    prepareItemsToRemove = function(currentOrderItems) {
                        var itemsToRemove = [];

                        angular.forEach(currentOrderItems, function(currentOrderItem) {
                            var productToRemove = $filter('findInObject')($localStorage.catalogContent.catalog, 'product_id', currentOrderItem.attributes.product_id);

                            if (productToRemove === null) {
                                itemsToRemove.push(currentOrderItem.id);
                            }
                        });

                        return itemsToRemove;
                    };

                    if (angular.isDefined($window.Sentry)) {
                        $window.Sentry.setExtra({ order_id: $localStorage.order.details.id });
                    }
                    $injector
                        .get('CheckoutFactory')
                        .setDefaultCheckoutModel();

                    if ($localStorage.catalogType === JF_CONFIG.accountTypes.personal) {
                        if (
                            angular.isDefined($localStorage.lastPrivateCatalogLocation) &&
                            $rootScope.countObjKeys($localStorage.lastPrivateCatalogLocation) > 0 &&
                            $localStorage.lastPrivateCatalogLocation.postal_code_id !== null
                        ) {
                            factory.setCatalogLocation($localStorage.lastPrivateCatalogLocation);

                                    OrderFactory
                                        .createNewOrder()
                                        .then(function() {
                                            handlePreviousCartItems()
                                                .then(function() {
                                                    deferred.resolve();
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    OrderFactory.createEmptyOrderObject();
                                    OrderFactory.setCookieWithCartItems(0);
                                    factory.clearCatalogLocation();

                            if ($rootScope.mobileAppMode) {
                                $state.go('location-picker');
                            } else {
                                $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                            }
                        }
                    } else {
                        AccountFactory
                            .setCatalogLocationForCompany()
                            .then(function() {
                                OrderFactory
                                .createNewOrder()
                                    .then(function() {
                                        handlePreviousCartItems()
                                            .then(function() {
                                                deferred.resolve();
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }, function(err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                },
                redirectToProducts: function() {
                    if (angular.isDefined($localStorage.lastPrivateCatalogLocation)) {
                        this.setCatalogLocation($localStorage.lastPrivateCatalogLocation);

                        $state.reload();
                    } else {
                        if ($rootScope.mobileAppMode) {
                            $state.go('location-picker');
                        } else {
                            SpinnerFactory.set('global');

                            $window.location.href = $rootScope.blogUrl + $filter('translate')('PRIVATE_CUSTOMERS_URL');
                        }
                    }
                }
            };
        }]
    );
/**
 * Rounding filter
 */
angular.module('jfApp')
    .filter(
        'round',
        function() {
            'use strict';

            return function(number, decimalPlaces, returnAsNumber) {
                var finalNumber = Number(
                    Math.round(number + 'e' + decimalPlaces) + 'e-'+ decimalPlaces
                ).toFixed(decimalPlaces);

                if (angular.isDefined(returnAsNumber) && returnAsNumber === true) {
                    return finalNumber;
                } else {
                    return finalNumber.replace('.', ',');
                }
            };
        }
    );
/**
 * Trust As Resource Url filter
 */
angular.module('jfApp')
    .filter(
        'trustAsResourceUrl',
        ['$sce', function($sce) {
            'use strict';

            return function(val) {
                return $sce.trustAsResourceUrl(val);
            };
        }]
    );
/**
 * Find in Object filter
 */
angular.module('jfApp')
    .filter(
        'findInObject',
        ['$rootScope', function($rootScope) {
            'use strict';

            return function(inputObj, keyToSearch, valueToSearch, recursive) {
                if (angular.isUndefined(recursive)) {
                    recursive = true;
                }

                if (angular.isUndefined(inputObj) || !angular.isObject(inputObj)) {
                    return inputObj;
                }

                var foundObject = null,
                    keepSearching = true,
                    search = function(obj) {
                        angular.forEach(obj, function(objItemValue, objItemKey) {
                            if (objItemValue instanceof Array) {
                                search(objItemValue);
                            } else {
                                if (keepSearching &&
                                    objItemKey === keyToSearch &&
                                    objItemValue === valueToSearch
                                ) {
                                    foundObject = obj;
                                    keepSearching = false;
                                } else if (recursive && keepSearching && angular.isObject(objItemValue) && $rootScope.countObjKeys(objItemValue) > 0) {
                                    search(objItemValue);
                                }
                            }
                        });
                    };

                search(inputObj);

                return foundObject;
            };
        }]
    );
angular
  .module('jf.urls.config', [])
  .constant('JF_URLS_CONFIG', {
    shared: {
      development: {
        apiEndpoint: 'https://jfapi.devel',
        actionCableHost: 'wss://jfapi.devel/cable',
      },
      staging: {
        apiEndpoint: 'https://staging-api.jonnyfresh.com',
        actionCableHost: 'wss://staging-api.jonnyfresh.com/cable',
      },
      production: {
        apiEndpoint: 'https://api.jonnyfresh.com',
        actionCableHost: 'wss://api.jonnyfresh.com/cable',
      },
      'jonnyfresh.dev': {
        apiEndpoint: 'https://api.jonnyfresh.dev',
        actionCableHost: 'wss://api.jonnyfresh.dev/cable',
      },
    },
    customerApp: {
      development: {
        adyenEndpoint: 'https://test.adyen.com/hpp/skipDetails.shtml',
        adyenDomainUrl: 'https://app.jf.devel',
        adyenCheckoutReturnUrl:
          'https://jfapi.devel/accounts/threeds/redirect_shoppers',
        adyenCheckoutWidgetJsUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.js',
        adyenCheckoutWidgetCssUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.css',
        amazonCheckoutReturnUrl: 'https://app.jf.devel/checkout/',
        amazonRegisterPageReturnUrl: 'https://app.jf.devel/register/',
        amazonPayScriptUrl:
          'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/sandbox/lpa/js/Widgets.js',
        amazonProfileUrl: 'https://api.sandbox.amazon.co.uk/user/profile',
        amazonTokenInfoUrl:
          'https://api.sandbox.amazon.co.uk/auth/o2/tokeninfo',
        jfImagesCDN:
          'https://s3.eu-central-1.amazonaws.com/img.staging-customerwebapp.jonnyfresh.com',
        jfBlogUrl: 'https://wpcms.jf.devel',
        jfShopUrl: 'https://app.jf.devel/',
        weDeliverAppUrl: 'https://trunkd-sandbox.apps.emea.vwapps.io/',
      },
      staging: {
        adyenEndpoint: 'https://test.adyen.com/hpp/skipDetails.shtml',
        adyenDomainUrl: 'https://staging-customerwebapp.jonnyfresh.com',
        adyenCheckoutReturnUrl:
          'https://staging-api.jonnyfresh.com/accounts/threeds/redirect_shoppers',
        adyenCheckoutWidgetJsUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.js',
        adyenCheckoutWidgetCssUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.css',
        amazonCheckoutReturnUrl:
          'https://staging-customerwebapp.jonnyfresh.com/checkout/',
        amazonRegisterPageReturnUrl:
          'https://staging-customerwebapp.jonnyfresh.com/register/',
        amazonPayScriptUrl:
          'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/sandbox/lpa/js/Widgets.js',
        amazonProfileUrl: 'https://api.sandbox.amazon.co.uk/user/profile',
        amazonTokenInfoUrl:
          'https://api.sandbox.amazon.co.uk/auth/o2/tokeninfo',
        jfImagesCDN:
          'https://s3.eu-central-1.amazonaws.com/img.staging-customerwebapp.jonnyfresh.com',
        jfBlogUrl: 'https://staging-www.jonnyfresh.com',
        jfShopUrl: 'https://staging-customerwebapp.jonnyfresh.com/',
        weDeliverAppUrl: 'https://trunkd-sandbox.apps.emea.vwapps.io/',
      },
      production: {
        adyenEndpoint: 'https://live.adyen.com/hpp/skipDetails.shtml',
        adyenDomainUrl: 'https://shop.jonnyfresh.com',
        adyenCheckoutReturnUrl:
          'https://api.jonnyfresh.com/accounts/threeds/redirect_shoppers',
        adyenCheckoutWidgetJsUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.js',
        adyenCheckoutWidgetCssUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.css',
        amazonCheckoutReturnUrl: 'https://shop.jonnyfresh.com/checkout/',
        amazonRegisterPageReturnUrl: 'https://shop.jonnyfresh.com/register/',
        amazonPayScriptUrl:
          'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/lpa/js/Widgets.js',
        amazonProfileUrl: 'https://api.amazon.de/user/profile',
        amazonTokenInfoUrl: 'https://api.amazon.de/auth/o2/tokeninfo',
        jfImagesCDN:
          'https://s3.eu-central-1.amazonaws.com/img.customerwebapp.jonnyfresh.com',
        jfBlogUrl: 'https://www.jonnyfresh.com',
        jfShopUrl: 'https://shop.jonnyfresh.com/',
        weDeliverAppUrl: 'https://deliver.volkswagen-we.com/app',
      },
      'jonnyfresh.dev': {
        adyenEndpoint: 'https://test.adyen.com/hpp/skipDetails.shtml',
        adyenDomainUrl: 'https://customer-webapp.jonnyfresh.dev',
        adyenCheckoutReturnUrl:
          'https://api.jonnyfresh.dev/accounts/threeds/redirect_shoppers',
        adyenCheckoutWidgetJsUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.js',
        adyenCheckoutWidgetCssUrl:
          'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.19.0/adyen.css',
        amazonCheckoutReturnUrl:
          'https://customer-webapp.jonnyfresh.dev/checkout/',
        amazonRegisterPageReturnUrl:
          'https://customer-webapp.jonnyfresh.dev/register/',
        amazonPayScriptUrl:
          'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/sandbox/lpa/js/Widgets.js',
        amazonProfileUrl: 'https://api.sandbox.amazon.co.uk/user/profile',
        amazonTokenInfoUrl:
          'https://api.sandbox.amazon.co.uk/auth/o2/tokeninfo',
        jfImagesCDN:
          'https://s3.eu-central-1.amazonaws.com/img.staging-customerwebapp.jonnyfresh.com',
        jfBlogUrl: 'https://www.jonnyfresh.dev',
        jfShopUrl: 'https://customer-webapp.jonnyfresh.dev/',
        weDeliverAppUrl: 'https://trunkd-sandbox.apps.emea.vwapps.io/',
      },
    },
    driverApp: {
      development: {},
      staging: {},
      production: {},
    },
    dryCleanerApp: {
      development: {},
      staging: {},
      production: {},
    },
  })
  .factory('jfConfigUrls', ['$window', 'JF_URLS_CONFIG', function ($window, JF_URLS_CONFIG) {
    'use strict';

    return {
      get: function (urlName, app) {
        app = app || 'shared';

        var env = $window.jfEbs.JF_ENV
          ? $window.jfEbs.JF_ENV.toLowerCase()
          : 'development';

        return JF_URLS_CONFIG[app][env][urlName] || '';
      },
    };
  }]);

angular.module('jf.shared.config', []).constant('JF_SHARED_CONFIG', {
  debug: window.jfEbs ? window.jfEbs.JF_APP_DEBUG_MODE : false,
  logEntriesToken: window.jfEbs ? window.jfEbs.JF_LOG_ENTRIES_TOKEN : '',
  modelTypes: {
    profile: 'profiles',
    user: 'users',
    customers: 'customers',
    company: 'companies',
    pickup_address: 'pickup_addresses',
    delivery_address: 'delivery_addresses',
    billing_address: 'billing_addresses',
    cart_item: 'cart_items',
    address: 'addresses',
    payment: 'payments',
    payment_methods: 'payment_methods',
    token: 'contexts',
    orders: 'orders',
    regular_orders: 'regular_orders',
    order_items: 'order_items',
    adyen_billing_aggreements: 'adyen_billing_aggreements',
    amazon_billing_agreements: 'amazon_billing_agreements',
    billing_aggreements: 'billing_aggreements',
    postal_address: 'postal_addresses',
    service_address: 'service_addresses',
    invoice_address: 'invoice_addresses',
    pickup_trip: 'pickup_trips',
    delivery_trip: 'delivery_trips',
    commit_orders: 'commit_orders',
    trip_slips: 'trip_slips',
    invoices: 'invoice_documents',
    invoiceDetails: 'invoice_details_documents',
    reminders: 'invoice_reminder_documents',
    service_postal_codes: 'service_postal_codes',
    cabs_access_tokens: 'cabs_access_tokens',
    cabs_bookings: 'cabs_bookings',
    customer_anonymize_operations: 'customer_anonymize_operations',
    create_order_operations: 'create_order_operations',
    credentials: 'credentials',
  },
  countries: [
    {
      id: '6be3f66b-35c6-4a3d-b73e-51dba18fe59c',
      name: 'Deutschland',
      code: 'DE',
      alpha2: 'DE',
      alpha3: 'DEU',
      vat: 0.19,
      default_currency: 'EUR',
      default_locale: 'de_DE'
    },
    {
      id: '7a4befe8-ae7a-41f1-a8eb-a3fed385ccde',
      name: 'Österreich',
      code: 'AT',
      alpha2: 'AT',
      alpha3: 'AUT',
      vat: 0.2,
      default_currency: 'EUR',
      default_locale: 'de_AT'
    }
  ]
});

/**
 *  JF Spinner
 */
angular
    .module('jf.directives-jf-spinner', [])
    .directive(
        'jfSpinner',
        ['$rootScope', function(
            $rootScope
        ) {
            'use strict';

            return {
                restrict: 'E',
                template: '<div class="jf-spinner-overlay">' +
                    '                <div class="jf-spinner-content" ng-style="{\'top\': spinnerPosition + \'%\'}">' +
                    '                    <div class="jf-spinner-element">' +
                    '                        <span us-spinner="{radius:7, width:2, length: 7, color: \'#0184C5\'}"></span>' +
                    '                    </div>\n' +
                    '                    <div class="message" ng-if="jfShared.spinner.text">{{jfShared.spinner.text}}</div>' +
                    '                </div>' +
                    '            </div>',
                replace: true,
                scope: {
                    spinnerPosition: '=?'
                },
                controller: ['$scope', function($scope) {
                    if (angular.isUndefined($scope.spinnerPosition)) {
                        $scope.spinnerPosition = 40;
                    }
                    $scope.jfShared = $rootScope.jfShared;
                }]
            };
        }]
    );

/**
 * Spinner factory
 */
angular
    .module('jf.directives-jf-spinner-factory', [])
    .factory(
        'SpinnerFactory',
        ['$rootScope', '$injector', function(
            $rootScope,
            $injector
        ) {
            'use strict';

            return {
                init: function() {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                    $rootScope.jfShared.spinner = {
                        components: {},
                        isLoading: this.isLoading,
                        text: null
                    };
                },
                set: function(componentName, spinnerText) {
                    if (angular.isDefined(spinnerText)) {
                        if (spinnerText !== null) {
                            $rootScope.jfShared.spinner.text = spinnerText;
                        } else {
                            $rootScope.jfShared.spinner.text = null;
                        }
                    }

                    if (angular.isArray(componentName)) {
                        angular.forEach(componentName, function(component) {
                            if (angular.isDefined($rootScope.jfShared.spinner.components[component])) {
                                $rootScope.jfShared.spinner.components[component]++;
                            } else {
                                $rootScope.jfShared.spinner.components[component] = 1;
                            }
                        });
                    } else {
                        if (angular.isDefined($rootScope.jfShared.spinner.components[componentName])) {
                            $rootScope.jfShared.spinner.components[componentName]++;
                        } else {
                            $rootScope.jfShared.spinner.components[componentName] = 1;
                        }
                    }
                },
                unset: function(componentName, spinnerText) {
                    if (angular.isDefined(spinnerText) && spinnerText === null) {
                        $rootScope.jfShared.spinner.text = null;
                    }

                    if (angular.isArray(componentName)) {
                        angular.forEach(componentName, function(component) {
                            if (angular.isDefined($rootScope.jfShared.spinner.components[component])) {
                                if ($rootScope.jfShared.spinner.components[component] > 1) {
                                    $rootScope.jfShared.spinner.components[component]--;
                                } else {
                                    delete $rootScope.jfShared.spinner.components[component];
                                }
                            }
                        });
                    } else {
                        if (angular.isDefined($rootScope.jfShared.spinner.components[componentName])) {
                            if ($rootScope.jfShared.spinner.components[componentName] > 1) {
                                $rootScope.jfShared.spinner.components[componentName]--;
                            } else {
                                delete $rootScope.jfShared.spinner.components[componentName];
                            }
                        }
                    }
                },
                setText: function(text) {
                    $rootScope.jfShared.spinner.text = text;
                },
                isLoading: function(componentName) {
                    // console.log($rootScope.jfShared.spinner.components);
                    if (angular.isArray(componentName)) {
                        var result = false;
                        angular.forEach(componentName, function(component) {
                            if (result === false) {
                                result = angular.isDefined($rootScope.jfShared.spinner.components[component]) && $rootScope.jfShared.spinner.components[component] > 0;
                            }
                        });
                        return result;
                    } else {
                        return angular.isDefined($rootScope.jfShared.spinner.components[componentName]) && $rootScope.jfShared.spinner.components[componentName] > 0;
                    }
                },
                isLoadingCompleted: function() {
                    return angular.isUndefined($rootScope.jfShared.spinner) ||
                        angular.isUndefined($rootScope.jfShared.spinner.components) ||
                        $injector.get('jfHelper').countObjKeys($rootScope.jfShared.spinner.components) === 0;
                },
                isTextSet: function() {
                    return $rootScope.jfShared.spinner.text !== null;
                }
            };
        }]
    );
angular.module('jf.dialog', [])
    .provider(
        'jfDialog',
        function() {
            'use strict';

            return {
                $get: ['$mdDialog', function(
                    $mdDialog
                ) {
                    return {
                        showAlert: function(title, content, okText, callback, clickOutsideToClose, preventPopupClose, closeCountdown) {
                            var okButton = '';

                            if (okText !== null && angular.isDefined(okText)) {
                                okButton = '<md-dialog-actions layout="row">' +
                                                '<md-button class="md-raised" ng-click="hideDialog()">'+okText+ '{{(countdown >=0 ? \' (\' + countdown + \')\' : \'\')}}</md-button>' +
                                            '</md-dialog-actions>';
                            }

                            $mdDialog
                                .show({
                                    template: '' +
                                        '<md-dialog class="jf-dialog">' +
                                        '<md-toolbar>' +
                                            '<div class="md-toolbar-tools">' +
                                                '<h2>'+title+'</h2>' +
                                            '</div>' +
                                        '</md-toolbar>' +
                                        '<md-dialog-content>' +
                                            '<div class="md-dialog-content">' +
                                                content +
                                            '</div>' +
                                        '</md-dialog-content>' +
                                        okButton +
                                    '</md-dialog>',
                                    parent: angular.element(document.body),
                                    clickOutsideToClose: angular.isDefined(clickOutsideToClose) ? clickOutsideToClose : true,
                                    escapeToClose: angular.isDefined(clickOutsideToClose) ? clickOutsideToClose : true,
                                    controller: ['$scope', '$mdDialog', '$interval', function($scope, $mdDialog, $interval) {
                                        $scope.hideDialog = function() {
                                            if (angular.isUndefined(preventPopupClose) || preventPopupClose === false) {
                                                $mdDialog.hide();
                                            }

                                            if (angular.isFunction(callback)) {
                                                callback();
                                            }
                                        };

                                        if (angular.isDefined(closeCountdown) && closeCountdown > 0) {
                                            $scope.countdown = closeCountdown;

                                            var countdownHandler = $interval(function() {
                                                if ($scope.countdown > 0) {
                                                    $scope.countdown--;
                                                } else {
                                                    $interval.cancel(countdownHandler);

                                                    $scope.hideDialog();
                                                }
                                            }, 1000);

                                            $scope.$on('$destroy', function() {
                                                $interval.cancel(countdownHandler);
                                            });
                                        }
                                    }]
                                });
                        },
                        showConfirm: function(title, content, okText, cancelText, okCallback, cancelCallback, openCallback, manualClose, fullScreenMode, thirdMiddleButtonText, thirdMiddleButtonCallback) {
                            return $mdDialog
                                .show({
                                    template: '' +
                                    '<md-dialog class="jf-dialog" ng-class="{\'jf-dialog-fullscreen\': fullScreenMode}">' +
                                        '<md-toolbar>' +
                                            '<div class="md-toolbar-tools">' +
                                                '<h2>'+title+'</h2>' +
                                            '</div>' +
                                        '</md-toolbar>' +
                                        '<md-dialog-content>' +
                                            '<div class="md-dialog-content">' +
                                                content +
                                            '</div>' +
                                        '</md-dialog-content>' +
                                        (
                                            fullScreenMode
                                            ?
                                                '<md-dialog-actions layout="row" layout-align="space-around center">' +
                                                    '<md-button flex="45" class="md-raised md-primary" ng-click="okAction()">'+okText+'</md-button>' +
                                                    (thirdMiddleButtonText ? '<md-button flex="45" class="md-raised jf-dialog-confirm-third-button" ng-click="thirdMiddleButtonAction()">'+thirdMiddleButtonText+'</md-button>' : '') +
                                                    '<md-button flex="45" class="md-raised" ng-click="cancelAction()">'+cancelText+'</md-button>'
                                            :
                                                '<md-dialog-actions layout="row" layout-xs="column">' +
                                                    '<md-button class="md-raised md-primary" ng-click="okAction()">'+okText+'</md-button>' +
                                                    (thirdMiddleButtonText ? '<md-button flex="45" class="md-raised jf-dialog-confirm-third-button" ng-click="thirdMiddleButtonAction()">'+thirdMiddleButtonText+'</md-button>' : '') +
                                                    '<md-button class="md-raised" ng-click="cancelAction()">'+cancelText+'</md-button>'
                                        ) +
                                        '</md-dialog-actions>' +
                                    '</md-dialog>',
                                    parent: angular.element(document.body),
                                    clickOutsideToClose: false,
                                    escapeToClose: false,
                                    controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                                        $scope.fullScreenMode = fullScreenMode || false;

                                        $scope.okAction = function() {
                                            if (angular.isUndefined(manualClose) || manualClose === null || manualClose === false) {
                                                $mdDialog.hide();
                                            }

                                            if (angular.isDefined(okCallback) && okCallback !== null) {
                                                okCallback();
                                            }
                                        };
                                        $scope.cancelAction = function() {
                                            if (angular.isUndefined(manualClose) || manualClose === null || manualClose === false) {
                                                $mdDialog.hide();
                                            }

                                            if (angular.isDefined(cancelCallback) && cancelCallback !== null) {
                                                cancelCallback();
                                            }
                                        };

                                        $scope.thirdMiddleButtonAction = function() {
                                            if (angular.isDefined(thirdMiddleButtonCallback) && thirdMiddleButtonCallback !== null) {
                                                thirdMiddleButtonCallback();
                                            }
                                        };
                                    }],
                                    onComplete: function() {
                                        if (angular.isDefined(openCallback) && openCallback !== null) {
                                            openCallback();
                                        }
                                    }
                                });
                        },
                        showPrompt: function(title, content, saveText, cancelText, defaultValue, saveCallback, cancelCallback, required) {
                            defaultValue = (angular.isDefined(defaultValue) && defaultValue !== null) ? defaultValue : null;
                            saveCallback = (angular.isDefined(saveCallback) && saveCallback !== null) ? saveCallback : null;
                            cancelCallback = (angular.isDefined(cancelCallback) && cancelCallback !== null) ? cancelCallback : null;
                            required = (angular.isDefined(required) && required !== null) ? required : true;

                            $mdDialog
                                .show({
                                    template: '' +
                                    '<md-dialog class="jf-dialog">' +
                                        '<md-toolbar>' +
                                            '<div class="md-toolbar-tools">' +
                                                '<h2>'+title+'</h2>' +
                                            '</div>' +
                                        '</md-toolbar>' +
                                        '<form name="promptForm" novalidate>' +
                                            '<md-dialog-content>' +
                                                '<div class="md-dialog-content" style="padding-bottom: 10px;">' +
                                                    content +
                                                    '<md-input-container class="jf-input-container" style="width: 100%;margin-top: 15px;">' +
                                                        '<textarea name="promptValue" ng-model="promptValue" ng-required="required" rows="3" style="line-height: 18px;" aria-label="Prompt value"></textarea>' +
                                                        '<div ng-messages="promptForm.promptValue.$error">' +
                                                            '<div ng-message="required" translate>REQUIRED</div>' +
                                                        '</div>' +
                                                    '</md-input-container>' +
                                                '</div>' +
                                            '</md-dialog-content>' +
                                            '<md-dialog-actions layout="row" layout-xs="column">' +
                                                '<md-button type="submit" class="md-raised md-primary" ng-click="saveAction()">'+saveText+'</md-button>' +
                                                '<md-button class="md-raised" ng-click="cancelAction()">'+cancelText+'</md-button>' +
                                            '</md-dialog-actions>' +
                                        '</form>' +
                                    '</md-dialog>',
                                    parent: angular.element(document.body),
                                    clickOutsideToClose: false,
                                    controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                                        $scope.promptValue = defaultValue;
                                        $scope.required = required;

                                        $scope.saveAction = function() {
                                            if ($scope.promptForm.$valid) {
                                                $mdDialog.hide();

                                                if (saveCallback !== null) {
                                                    saveCallback($scope.promptValue);
                                                }
                                            }
                                        };
                                        $scope.cancelAction = function() {
                                            $mdDialog.hide();

                                            if (cancelCallback !== null) {
                                                cancelCallback();
                                            }
                                        };
                                    }]
                                });
                        },
                        hideDialogs: function() {
                            $mdDialog.hide();
                        }
                    };
                }]
            };
        }
    );
angular.module('jf.controller', [])
    .provider(
        'jfController',
        function() {
            'use strict';

            return {
                $get: function() {
                    return {
                        init: function (methods, controller) {
                            if (methods.length > 0) {
                                angular.forEach(methods, function(method) {
                                    if (angular.isDefined(controller[method])) {
                                        controller[method]();
                                    }
                                });
                            }
                        }
                    };
                }
            };
        }
    );
angular.module('jf.json-api', [])
    .provider(
        'jfJsonApi',
        function() {
            'use strict';

            return {
                $get: function() {
                    return {
                        prepare: function(type, attributes, additionalData, filters, relationships) {
                            var jsonResource = {
                                data: {
                                    type: type,
                                    attributes: attributes || {}
                                }
                            };
                            angular.merge(jsonResource.data, additionalData);

                            if (angular.isDefined(filters)) {
                                jsonResource.filter = {};
                                angular.merge(jsonResource.filter, filters);
                            }

                            if (angular.isDefined(relationships)) {
                                jsonResource.data.relationships = {};
                                angular.merge(jsonResource.data.relationships, relationships);
                            }

                            return jsonResource;
                        }
                    };
                }
            };
        }
    );
angular.module('jf.internet-connection', [])
    .provider(
        'jfInternetConnection',
        function() {
            'use strict';

            return {
                translations: {
                    offlinePopupTitle: '',
                    offlinePopupMsg: '',
                    offlinePopupButton: ''
                },
                reloadAfterReconnect: true,
                initSharedObject: function($rootScope) {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                    $rootScope.jfShared.jfInternetConnection = $rootScope.jfShared.jfInternetConnection || {};
                },
                initModule: function($rootScope) {
                    $rootScope.jfShared.jfInternetConnection.networkConnected = true;
                    $rootScope.jfShared.jfInternetConnection.noInternetConnectionPopup = null;
                },
                setTranslations: function(translationKeys) {
                    this.translations.offlinePopupTitle = translationKeys.offlinePopupTitle;
                    this.translations.offlinePopupMsg = translationKeys.offlinePopupMsg;
                    this.translations.offlinePopupButton = translationKeys.offlinePopupButton;
                },
                setReloadAfterReconnect: function(reloadAfterReconnect) {
                    this.reloadAfterReconnect = reloadAfterReconnect;
                },
                $get: ['$rootScope', '$timeout', '$state', '$filter', '$window', 'jfDialog', function(
                    $rootScope,
                    $timeout,
                    $state,
                    $filter,
                    $window,
                    jfDialog
                ) {
                    var jfInternetConnection = this;

                    jfInternetConnection.initSharedObject($rootScope);
                    jfInternetConnection.initModule($rootScope);

                    return {
                        init: function() {
                            var jfInternetConnectionApi = this;

                            $rootScope.jfShared.jfInternetConnection.networkConnected = true;
                            $rootScope.jfShared.jfInternetConnection.noInternetConnectionPopup = null;

                            if (angular.isDefined($window.cordova)) {
                                $rootScope.$on('$cordovaNetwork:offline', function() {
                                    if ($rootScope.jfShared.jfInternetConnection.networkConnected === true) {
                                        $rootScope.jfShared.jfInternetConnection.networkConnected = false;

                                        jfInternetConnectionApi.showNoInternetPopup();
                                    }
                                });
                                $rootScope.$on('$cordovaNetwork:online', function() {
                                    $rootScope.jfShared.jfInternetConnection.networkConnected = true;

                                    jfInternetConnectionApi.showNoInternetPopupCallback(jfInternetConnectionApi);
                                });
                            } else {
                                $window.addEventListener('offline', function() {
                                    if ($rootScope.jfShared.jfInternetConnection.networkConnected === true) {
                                        $rootScope.jfShared.jfInternetConnection.networkConnected = false;

                                        jfInternetConnectionApi.showNoInternetPopup();
                                    }
                                });
                                $window.addEventListener('online', function() {
                                    $rootScope.jfShared.jfInternetConnection.networkConnected = true;

                                    jfInternetConnectionApi.showNoInternetPopupCallback(jfInternetConnectionApi);
                                });
                            }
                        },
                        showNoInternetPopup: function() {
                            var jfInternetConnectionApi = this;

                            if ($rootScope.jfShared.jfInternetConnection.networkConnected === false) {
                                $rootScope.jfShared.jfInternetConnection.noInternetConnectionPopup = true;

                                jfDialog
                                    .showAlert(
                                        $filter('translate')(jfInternetConnection.translations.offlinePopupTitle),
                                        $filter('translate')(jfInternetConnection.translations.offlinePopupMsg),
                                        $filter('translate')(jfInternetConnection.translations.offlinePopupButton),
                                        function() {
                                            jfInternetConnectionApi.showNoInternetPopupCallback(jfInternetConnectionApi);
                                        },
                                        false,
                                        true
                                    );
                            }
                        },
                        showNoInternetPopupCallback: function(jfInternetConnectionApi) {
                            if ($rootScope.jfShared.jfInternetConnection.networkConnected === true) {
                                $rootScope.jfShared.jfInternetConnection.noInternetConnectionPopup = null;

                                jfInternetConnectionApi.reconnectedCallback();
                            }
                        },
                        reconnectedCallback: function() {
                            if (jfInternetConnection.reloadAfterReconnect) {
                                if (angular.isDefined($window.jfEbs)) {
                                    if (angular.isDefined($state.current.abstract) && $state.current.abstract === true) {
                                        $window.location.reload();
                                    } else {
                                        $state.reload();
                                    }

                                } else {
                                    $window.location.reload();
                                }
                            } else {
                                jfDialog.hideDialogs();
                            }
                        }
                    };
                }]
            };
        }
    );
angular.module('jf.user', [])
    .provider(
        'jfUser',
        function() {
            'use strict';

            return {
                userObjName: 'user',
                userCookieName: 'uuid',
                userCookieOptions: {
                    domain: '',
                    expires: null,
                    samesite: 'lax',
                    secure: true
                },
                userDetailsToUpdate: {},
                initSharedObject: function($rootScope) {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                    $rootScope.jfShared.jfUser = $rootScope.jfShared.jfUser || {};
                },
                initModule: function(JF_CONFIG) {
                    var cookieExpirationTime = new Date();
                    cookieExpirationTime.setYear(cookieExpirationTime.getFullYear() + 1);

                    if (angular.isDefined(window.jfEbs) && window.jfEbs.JF_ENV !== 'Production') {
                        this.userCookieName = this.userCookieName + '-' + window.jfEbs.JF_ENV.toLowerCase();
                    }

                    this.userCookieOptions.domain = JF_CONFIG.cookies_domain;
                    this.userCookieOptions.expires = cookieExpirationTime;

                },
                setUserObjName: function(userObjName) {
                    this.userObjName = userObjName;
                },
                setUserDetailsToUpdate: function(userDetailsToUpdate) {
                    this.userDetailsToUpdate = userDetailsToUpdate;
                },
                $get: ['$q', '$localStorage', '$rootScope', '$cookies', '$injector', 'base64', 'JF_CONFIG', 'AccountCustomerFactory', function(
                    $q,
                    $localStorage,
                    $rootScope,
                    $cookies,
                    $injector,
                    base64,
                    JF_CONFIG,
                    AccountCustomerFactory
                ) {
                    var jfUser = this;

                    jfUser.initSharedObject($rootScope);
                    jfUser.initModule(JF_CONFIG);

                    return {
                        init: function() {
                            if (angular.isDefined($localStorage[jfUser.userObjName])) {
                                $rootScope.jfShared.jfUser = $localStorage[jfUser.userObjName];
                            }
                        },
                        get: function() {
                            if (angular.isDefined($localStorage[jfUser.userObjName])) {
                                return $localStorage[jfUser.userObjName];
                            }

                            return {};
                        },
                        getUserObjName: function() {
                            return jfUser.userObjName;
                        },
                        update: function(user, options) {
                            var jfUserApi = this,
                                opts = {
                                    remove: false,
                                    set: false
                                },
                                currentUser = jfUserApi.get();

                            angular.merge(opts, options);
                            angular.merge(currentUser, user);

                            if (opts.remove === true) {
                                jfUserApi.removeUserSession();
                            } else {
                                if (opts.set === true) {
                                    jfUserApi.createUserSession(currentUser);
                                }

                                currentUser.updatedAt = Math.floor(Date.now());

                                $localStorage[jfUser.userObjName] = currentUser;
                                $rootScope.jfShared.jfUser = currentUser;
                            }

                            $rootScope.$broadcast('event:user-updated');
                        },
                        createUserSession: function(currentUser) {
                            $cookies.put(
                                jfUser.userCookieName,
                                currentUser.id,
                                jfUser.userCookieOptions
                            );
                        },
                        removeUserSession: function() {
                            delete $localStorage[jfUser.userObjName];
                            $rootScope.jfShared.jfUser = {};

                            $cookies.remove(jfUser.userCookieName, jfUser.userCookieOptions);
                        },
                        isLoggedIn: function() {
                            return angular.isDefined($localStorage[jfUser.userObjName]) &&
                                $localStorage[jfUser.userObjName] !== '';
                        },
                        login: function(userData) {
                            var deferred = $q.defer(),
                                jfUserApi = this;

                            jfUserApi.update(userData, { set: true });

                            $rootScope.$broadcast('event:user-logged-id');

                            deferred.resolve();

                            return deferred.promise;
                        },
                        logout: function() {
                            var jfUserApi = this;

                            jfUserApi.update(
                                {},
                                { remove: true }
                            );
                        },
                        updateUserData: function() {
                            var jfUserApi = this,
                                deferred = $q.defer();

                            if ($injector.get('jfHelper').countObjKeys(jfUser.userDetailsToUpdate) > 0) {
                                var params = { id: $localStorage[jfUser.userObjName].id };

                                if (angular.isDefined(jfUser.userDetailsToUpdate.relationships)) {
                                    params.include = jfUser.userDetailsToUpdate.relationships.join(',');
                                }

                                AccountCustomerFactory
                                    .get(params)
                                    .$promise
                                    .then(function(userDetails) {
                                        var userData = {
                                            locale: userDetails.included ? userDetails.included[0].attributes.preferred_locale : 'de_DE',
                                            country: userDetails.included ? userDetails.included[0].attributes.country_of_residence : 'DE'
                                        };

                                        angular.forEach(jfUser.userDetailsToUpdate, function (listOfAttributes, nameOfParameter) {
                                            /* istanbul ignore else */
                                            if (nameOfParameter === 'data') {
                                                angular.forEach(listOfAttributes, function(backendResponseName, localStorageName) {
                                                    var fieldValue = userDetails.data.attributes[backendResponseName];

                                                    if (
                                                        angular.isDefined(jfUser.userDetailsToUpdate.encode) &&
                                                        jfUser.userDetailsToUpdate.encode.indexOf(localStorageName) > -1 &&
                                                        fieldValue !== null
                                                    ) {
                                                        fieldValue = base64.encode(fieldValue);
                                                    }

                                                    userData[localStorageName] = fieldValue;
                                                });
                                            } else if (nameOfParameter === 'included') {
                                                angular.forEach(listOfAttributes, function(backendResponseName, localStorageName) {
                                                    angular.forEach(userDetails.included, function(includedContent) {
                                                        if (includedContent.type === 'profiles') {
                                                            var fieldValue = includedContent.attributes;

                                                            if (backendResponseName.indexOf('.') > -1) {
                                                                var fieldNameArr = backendResponseName.split('.');

                                                                angular.forEach(fieldNameArr, function(fieldName) {
                                                                    if (
                                                                        fieldValue !== null &&
                                                                        angular.isDefined(fieldValue[fieldName]) &&
                                                                        fieldValue[fieldName] !== null
                                                                    ) {
                                                                        fieldValue = fieldValue[fieldName];
                                                                    } else {
                                                                        fieldValue = null;
                                                                    }
                                                                });
                                                            } else {
                                                                fieldValue = fieldValue[backendResponseName];
                                                            }

                                                            if (
                                                                angular.isDefined(jfUser.userDetailsToUpdate.encode) &&
                                                                jfUser.userDetailsToUpdate.encode.indexOf(localStorageName) > -1 &&
                                                                fieldValue !== null
                                                            ) {
                                                                fieldValue = base64.encode(fieldValue);
                                                            }

                                                            userData[localStorageName] = fieldValue;
                                                        }
                                                    });
                                                });
                                            } else if (nameOfParameter === 'relationships') {
                                                angular.forEach(userDetails.data.relationships, function(relationshipObj, relationshipName) {
                                                    if (
                                                        angular.isDefined(relationshipObj.data) &&
                                                        relationshipObj.data !== null &&
                                                        listOfAttributes.indexOf(relationshipName) > -1
                                                    ) {
                                                        userData[relationshipName + 'Id'] = relationshipObj.data.id;
                                                    }
                                                });
                                            }
                                        });

                                        // Customer WebApp related logic - maybe we could move it somehow to the config phase
                                        // Check if user doesn't have preferred delivery address - he's a V1 user
                                        // If yes and there is already saved preferred delivery address in the localStorage, then use it
                                        /* istanbul ignore else */
                                        if (userData.pdid === null && $localStorage[jfUser.userObjName].pdid !== null) {
                                            userData.pdid = $localStorage[jfUser.userObjName].pdid;
                                        }

                                        jfUserApi.update(userData, { set: true });

                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.resolve();
                            }

                            return deferred.promise;
                        }
                    };
                }]
            };
        }
    );
angular.module('jf.helpers', [])
    .provider(
        'jfHelper',
        function() {
            'use strict';

            return {
                pageHeadTitleSuffix: '',
                translations: {
                    fatalErrorPopupTitle: '',
                    fatalErrorPopupMsg: '',
                    fatalErrorPopupButton: ''
                },
                initSharedObject: function($rootScope) {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                },
                initModule: function() {

                },
                setPageHeadTitleSuffix: function(suffix) {
                    this.pageHeadTitleSuffix = suffix;
                },
                setTranslations: function(translationKeys) {
                    this.translations.fatalErrorPopupTitle = translationKeys.fatalErrorPopupTitle;
                    this.translations.fatalErrorPopupMsg = translationKeys.fatalErrorPopupMsg;
                    this.translations.fatalErrorPopupButton = translationKeys.fatalErrorPopupButton;
                },
                $get: ['$rootScope', '$translate', '$window', '$state', '$filter', '$interval', '$mdToast', '$http', '$timeout', '$q', 'jfDialog', 'jfHistory', 'jfConfigUrls', 'jfAppUpdate', 'JF_CONFIG', 'JF_SHARED_CONFIG', function(
                    $rootScope,
                    $translate,
                    $window,
                    $state,
                    $filter,
                    $interval,
                    $mdToast,
                    $http,
                    $timeout,
                    $q,
                    jfDialog,
                    jfHistory,
                    jfConfigUrls,
                    jfAppUpdate,
                    JF_CONFIG,
                    JF_SHARED_CONFIG
                ) {
                    var jfHelper = this,
                        jfHelperApi;

                    jfHelper.initSharedObject($rootScope);
                    jfHelper.initModule($rootScope);

                    jfHelperApi = {
                        mobileAppMode : /* istanbul ignore next */ (document.URL.indexOf( 'http://' ) === -1 && document.URL.indexOf( 'https://' ) === -1) || document.URL.indexOf( 'https://cwa.' ) > -1 || document.URL.indexOf( 'https://dra.' ) > -1 || document.URL.indexOf( 'https://dca.' ) > -1,
                        countObjKeys: function (obj) {
                            if (angular.isDefined(obj) && obj !== null) {
                                return Object.keys(obj).length;
                            }

                            return 0;
                        },
                        stateChangeSuccessHandler: function(transition) {
                            $rootScope.jfShared.pageTitle = transition.to().title;

                            $translate(transition.to().title)
                                .then(function(headPageTitleTranslation) {
                                    $window.document.title = headPageTitleTranslation + jfHelper.pageHeadTitleSuffix;
                                }, function() {});
                        },
                        stateChangeStartHandler: function(transition) {
                            if (angular.isDefined(transition)) {
                                jfHistory.addState(transition.to().name, {
                                    fromState: {
                                        name: transition.from().name,
                                        params: transition.params('from')
                                    },
                                    currentState: {
                                        name: transition.to().name,
                                        params: transition.to('from')
                                    }
                                });
                            }
                        },
                        appErrorHandler: function(e, args) {
                            // Print errors to the console in Debug Mode
                            if (JF_SHARED_CONFIG.debug) {
                                console.error(JSON.stringify(args.err));
                            }

                            // Show fatal error popup
                            if (
                                !args.silent &&
                                !(
                                    angular.isDefined(args.err.status) &&
                                    (
                                        args.err.status === -1 ||
                                        args.err.status === 345
                                    )
                                )
                            ) {
                                jfDialog
                                    .showAlert(
                                        $filter('translate')(jfHelper.translations.fatalErrorPopupTitle),
                                        $filter('translate')(jfHelper.translations.fatalErrorPopupMsg),
                                        $filter('translate')(jfHelper.translations.fatalErrorPopupButton)
                                    );
                            }

                            // Log errors to LogEntries external service
                            if (
                                args.err.status !== -1 &&
                                args.err.status !== 345 &&
                                angular.isDefined($window.Sentry)
                            ) {
                                var additionalData = {};

                                if (angular.isDefined(args.err) && angular.isDefined(args.err.data) && angular.isDefined(args.err.data.exception)) {
                                    additionalData.exception = args.err.data.exception;
                                }

                                if (
                                    angular.isDefined(args) &&
                                    angular.isDefined(args.err) &&
                                    angular.isDefined(args.err.data)
                                ) {
                                    if (
                                        angular.isDefined(args.err.data.traces) &&
                                        angular.isDefined(args.err.data.traces['Application Trace'])
                                    ) {
                                        additionalData.applicationTrace = JSON.stringify(args.err.data.traces['Application Trace']);
                                    }

                                    if (
                                        angular.isDefined(args.err.data.errors) &&
                                        args.err.data.errors.length > 0
                                    ) {
                                        additionalData.errors = {};
                                        var sentryAdditionalTitle = [];

                                        angular.forEach(args.err.data.errors, function(errorDetails) {
                                            if (angular.isDefined(errorDetails.source) && angular.isDefined(errorDetails.source.pointer)) {
                                                additionalData.errors[errorDetails.source.pointer] = errorDetails.detail;
                                                sentryAdditionalTitle.push(errorDetails.detail);
                                            } else {
                                                additionalData.errors[errorDetails.status + ' ' + errorDetails.code] = errorDetails.detail;
                                                sentryAdditionalTitle.push(errorDetails.status + ' ' + errorDetails.code);
                                            }
                                        });

                                        sentryAdditionalTitle = sentryAdditionalTitle.join(' | ');
                                    }
                                }

                                var sentryErrorObj = jfHelperApi.prepareSentryError(args.err, additionalData.exception, sentryAdditionalTitle);

                                jfHelperApi
                                    .getAppVersion()
                                    .then(function(appVersion) {
                                        jfHelperApi
                                            .getCodePushUpdateVersion()
                                            .then(function(codePushUpdateVersion) {
                                                if (angular.isDefined(appVersion)) {
                                                    additionalData.appVersion = appVersion;
                                                }

                                                if (angular.isDefined(codePushUpdateVersion)) {
                                                    additionalData.currentCodePush = codePushUpdateVersion;
                                                }

                                                jfHelperApi.sendSentryError(sentryErrorObj, additionalData, e, args);
                                            }, function() {
                                                jfHelperApi.sendSentryError(sentryErrorObj, additionalData, e, args);
                                            });
                                    }, function() {
                                        jfHelperApi.sendSentryError(sentryErrorObj, additionalData, e, args);
                                    });
                            }
                        },
                        getAppVersion: function() {
                            var deferred = $q.defer();

                            if (angular.isDefined($window.cordova) && angular.isDefined($window.cordova.getAppVersion)) {
                                $window
                                    .cordova
                                    .getAppVersion
                                    .getVersionNumber()
                                    .then(function (appVersion) {
                                        deferred.resolve(appVersion);
                                    }, function() {
                                        deferred.reject();
                                    });
                            } else {
                                deferred.resolve();
                            }

                            return deferred.promise;
                        },
                        getCodePushUpdateVersion: function() {
                            var deferred = $q.defer();

                            if (angular.isDefined($window.codePush)) {
                                $window
                                    .codePush
                                    .getCurrentPackage(
                                        function(currentAppUpdate) {
                                            deferred.resolve(currentAppUpdate);
                                        },
                                        function() {
                                            deferred.reject();
                                        }
                                    );
                            } else {
                                deferred.resolve();
                            }

                            return deferred.promise;
                        },
                        prepareSentryError: function(error, exception, sentryAdditionalTitle) {
                            if (
                                angular.isUndefined(error.status) &&
                                angular.isUndefined(error.error) &&
                                angular.isUndefined(error.statusText) &&
                                angular.isUndefined(exception) &&
                                angular.isUndefined(sentryAdditionalTitle)
                            ) {
                                return new Error('Undefined error: ' + JSON.stringify(error));
                            } else {
                                var errorName = '';

                                if (angular.isDefined(error.error)) {
                                    errorName = error.error;
                                } else if (angular.isDefined(error.statusText)) {
                                    errorName = error.statusText;
                                }

                                if (angular.isDefined(exception)) {
                                    exception = ' - ' + exception.substring(0, 60);
                                } else {
                                    exception = '';
                                }

                                if (angular.isDefined(sentryAdditionalTitle)) {
                                    sentryAdditionalTitle = ' - ' + sentryAdditionalTitle;
                                } else {
                                    sentryAdditionalTitle = '';
                                }

                                return new Error(error.status + ' ' + errorName + exception + sentryAdditionalTitle);
                            }
                        },
                        sendSentryError: function(sentryErrorObj, additionalData, e, args) {
                            if (angular.isDefined(args.err.status) && args.err.status === 404) {
                                jfHelperApi.appLogHandler(e, args);
                            } else {
                                $window.Sentry.captureException(
                                    sentryErrorObj,
                                    {
                                        extra: additionalData
                                    }
                                );
                            }
                        },
                        appLogHandler: function(e, args) {
                            // Print errors to the console in Debug Mode
                            if (JF_SHARED_CONFIG.debug) {
                                console.log(JSON.stringify(args));
                            }

                            // Log errors to LogEntries external service
                            if (angular.isDefined(JF_SHARED_CONFIG.logEntriesToken) &&
                                JF_SHARED_CONFIG.logEntriesToken !== '' &&
                                !(angular.isDefined(args.disableLogEntries) && args.disableLogEntries === true)
                            ) {
                                LE.log({
                                    log: JSON.stringify(args),
                                    currentState: ($state && $state.current) ? $state.current : ''
                                });
                            }
                        },
                        getCurrentIsoTime: function(date) {
                            var now = date ? date : new Date(),
                                // tzo = -now.getTimezoneOffset(),
                                // dif = tzo >= 0 ? '+' : '-',
                                pad = function(num) {
                                    var norm = Math.abs(Math.floor(num));
                                    return (norm < 10 ? '0' : '') + norm;
                                };
                            return now.getFullYear() +
                                '-' + pad(now.getMonth()+1) +
                                '-' + pad(now.getDate()) +
                                'T' + pad(now.getHours()) +
                                ':' + pad(now.getMinutes()) +
                                ':' + pad(now.getSeconds());
                            // + dif + pad(tzo / 60)
                            // + ':' + pad(tzo % 60);
                        },
                        getCurrentDate: function(date) {
                            var dateObj = date ? date : new Date(),
                                month = dateObj.getMonth() + 1,
                                day = dateObj.getDate(),
                                year = dateObj.getFullYear();

                            return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
                        },
                        getCurrentTime: function(excludeSeconds, date) {
                            var dateObj = date ? date : new Date(),
                                hours = dateObj.getHours(),
                                minutes = dateObj.getMinutes(),
                                seconds = dateObj.getSeconds();

                            return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + (excludeSeconds === true ? '' : ':' + ('0' + seconds).slice(-2));
                        },
                        transformDateToGerman: function(date) {
                            var newDate = date.split('-');
                            return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
                        },
                        moveDateByDays: function(date, daysSwitch) {
                            var dateObj = new Date(date);

                            if (angular.isDefined(daysSwitch)) {
                                dateObj.setDate(dateObj.getDate() + daysSwitch);
                            }

                            var month = dateObj.getMonth() + 1,
                                day = dateObj.getDate(),
                                year = dateObj.getFullYear();

                            return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
                        },
                        goBackInHistory: function() {
                            if (angular.isUndefined($state.current.params)) {
                                $state.current.params = {};
                            }
                            $state.current.params.stepBack = true;

                            $window.history.back();
                        },
                        appVersionMonitoring: function() {
                            if (
                                (
                                    angular.isDefined($window.jfEbs) &&
                                    (
                                        $window.jfEbs.JF_ENV === 'Production' ||
                                        $window.jfEbs.JF_ENV === 'Staging'
                                    )
                                ) &&
                                angular.isDefined($window.jfAppVersion) &&
                                $window.jfAppVersion !== ''
                            ) {
                                var fetchInProgress = false,
                                    intervalHandler = $interval(function() {
                                        if (fetchInProgress === false) {
                                            fetchInProgress = true;

                                            jfHelperApi
                                                .fetchCurrentAppVersion()
                                                .then(function(currentAppVersion) {
                                                    fetchInProgress = false;

                                                    if (currentAppVersion.data !== '') {
                                                        var fetchedAppVersion = currentAppVersion.data.split('|');

                                                        if (jfHelperApi.mobileAppMode) {
                                                            if (jfAppUpdate.isForceAppUpdatePopupAvailable()) {
                                                                jfAppUpdate
                                                                    .isAppUpdateRequired(fetchedAppVersion[2])
                                                                    .then(function(isUpdateRequired) {
                                                                        if (isUpdateRequired) {
                                                                            jfAppUpdate.showMandatoryVersionMissingError(2000);

                                                                            $interval.cancel(intervalHandler);
                                                                        } else if (fetchedAppVersion[0] !== $window.jfAppVersion) {
                                                                            if (angular.isDefined($window.codePush)) {
                                                                                jfHelperApi.triggerMobileWaitForUpdate();
                                                                            }

                                                                            $interval.cancel(intervalHandler);
                                                                        }
                                                                    }, function() {});
                                                            }
                                                        } else {
                                                            if (fetchedAppVersion[0] !== $window.jfAppVersion) {
                                                                jfHelperApi.showAppReloadPopup(fetchedAppVersion[1]);

                                                                $interval.cancel(intervalHandler);
                                                            }
                                                        }
                                                    }
                                                }, function(err) {
                                                    $rootScope.$emit('app-error', {err: err, silent: true});
                                                });
                                        }
                                    }, JF_CONFIG.appVersionCheckInterval || 2000);
                            }
                        },
                        fetchCurrentAppVersion: function() {
                            return $http.get(jfConfigUrls.get('jfShopUrl', 'customerApp') + 'monitoring/jf-app-current-version.txt');
                        },
                        triggerMobileWaitForUpdate: function() {
                            $interval(function() {
                                jfAppUpdate.checkForUpdate();
                            }, JF_CONFIG.mobileAppUpdateCheckInterval || 10000);
                        },
                        showAppReloadPopup: function(forceUpdate) {
                            if (forceUpdate === '0') {
                                $timeout(function() {
                                    $mdToast
                                        .show({
                                            position: 'bottom right',
                                            hideDelay: 0,
                                            controller: 'appVersionMonitoringCtrl',
                                            template: '<md-toast>' +
                                                    '<span class="md-toast-text" flex>{{\'APP_VERSION_MONITORING_TOAST_INFO\' | translate}}</span>' +
                                                    '<md-button class="md-highlight md-primary" flex ng-click="appReload()">' +
                                                        '{{\'APP_VERSION_MONITORING_TOAST_BUTTON\' | translate}} ({{countdown}})' +
                                                    '</md-button>' +
                                                  '</md-toast>'
                                        });
                                }, 1000);
                            } else {
                                $timeout(function() {
                                    jfDialog.showAlert(
                                        $filter('translate')('APP_VERSION_MONITORING_POPUP_TITLE'),
                                        $filter('translate')('APP_VERSION_MONITORING_POPUP_MSG'),
                                        $filter('translate')('APP_VERSION_MONITORING_POPUP_BUTTON'),
                                        function() {
                                            window.location.reload();
                                        },
                                        false,
                                        true,
                                        20
                                    );
                                }, 1000);
                            }
                        },
                        createAndDownloadFile: function(fileName, fileType, fileContent) {
                            var newBlob = new Blob([fileContent], { type: fileType });
                            // IE download
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(newBlob);
                                return;
                            }
                            // For other browsers:
                            // Create a link pointing to the ObjectURL containing the blob.
                            var data = window.URL.createObjectURL(newBlob);
                            var link = document.createElement('a');
                            link.href = data;
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        },
                        isMobileBrowser: function() {
                            return (function(a){ return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)));})(navigator.userAgent||navigator.vendor||window.opera);
                        }
                    };

                    return jfHelperApi;
                }]
            };
        }
    )
    .controller(
        'appVersionMonitoringCtrl',
        ['$scope', '$interval', function($scope, $interval) {
            'use strict';

            $scope.countdown = 20;
            $scope.appReload = function() {
                window.location.reload();
            };

            var countdownHandler = $interval(function() {
                if ($scope.countdown > 0) {
                    $scope.countdown--;
                } else {
                    $interval.cancel(countdownHandler);
                    window.location.reload();
                }
            }, 1000);

            $scope.$on('$destroy', function() {
                $interval.cancel(countdownHandler);
            });
        }]
    )
    .filter(
        'jfFindInObject',
        ['$rootScope', 'jfHelper', function(
            $rootScope,
            jfHelper
        ) {
            'use strict';

            return function(inputObj, keyToSearch, valueToSearch, recursive, returnParentObj) {
                if (angular.isUndefined(recursive)) {
                    recursive = true;
                }

                if (angular.isUndefined(returnParentObj)) {
                    returnParentObj = false;
                }

                if (angular.isUndefined(inputObj) || !angular.isObject(inputObj)) {
                    return inputObj;
                }

                var foundObject = null,
                    keepSearching = true,
                    parentObj = null,

                    search = function(obj, firstLevel) {
                        firstLevel = firstLevel || false;

                        angular.forEach(obj, function(objItemValue, objItemKey) {
                            if (firstLevel && parentObj === null) {
                                parentObj = objItemValue;
                            }

                            if (objItemValue instanceof Array) {
                                parentObj = null;

                                search(objItemValue);
                            } else {
                                /* istanbul ignore else */
                                if (keepSearching &&
                                    objItemKey === keyToSearch &&
                                    objItemValue === valueToSearch
                                ) {
                                    foundObject = obj;
                                    keepSearching = false;
                                } else if (recursive && keepSearching && angular.isObject(objItemValue) && jfHelper.countObjKeys(objItemValue) > 0) {
                                    search(objItemValue);
                                }
                            }

                            if (firstLevel && foundObject === null) {
                                parentObj = null;
                            }
                        });
                    };

                search(inputObj, true);

                if (foundObject !== null) {
                    return returnParentObj ? parentObj : foundObject;
                }

                return foundObject;
            };
        }]
    )
    .filter(
        'jfRound',
        function() {
            'use strict';

            return function(number, decimalPlaces, returnAsNumber) {
                var finalNumber = Number(
                    Math.round(number + 'e' + decimalPlaces) + 'e-'+ decimalPlaces
                ).toFixed(decimalPlaces);

                if (angular.isDefined(returnAsNumber) && returnAsNumber === true) {
                    return finalNumber;
                } else {
                    return finalNumber.replace('.', ',');
                }
            };
        }
    )
    .filter(
        'jfTrustAsResourceUrl',
        ['$sce', function($sce) {
            'use strict';

            return function(val) {
                return $sce.trustAsResourceUrl(val);
            };
        }]
    );
angular.module('jf.token', [])
    .provider(
        'jfToken',
        function() {
            'use strict';

            return {
                tokenIntervalTime: 1000,
                translations: {
                    fatalErrorPopupTitle: '',
                    fatalErrorPopupMsg: '',
                    fatalErrorPopupButton: ''
                },
                tokenObjName: 'auth',
                initSharedObject: function($rootScope) {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                    $rootScope.jfShared.jfToken = $rootScope.jfShared.jfToken || {};
                },
                initModule: function($rootScope) {
                    $rootScope.jfShared.jfToken.intervalPromise = null;
                },
                setTranslations: function(translationKeys) {
                    this.translations.fatalErrorPopupTitle = translationKeys.fatalErrorPopupTitle;
                    this.translations.fatalErrorPopupMsg = translationKeys.fatalErrorPopupMsg;
                    this.translations.fatalErrorPopupButton = translationKeys.fatalErrorPopupButton;
                },
                setTokenObjName: function(tokenObjName) {
                    this.tokenObjName = tokenObjName;
                },
                $get: ['$rootScope', '$q', '$interval', '$localStorage', '$filter', '$state', '$window', 'jfJsonApi', 'ContextContextsFactory', 'authService', 'jfUser', 'jfDialog', 'JF_SHARED_CONFIG', function(
                    $rootScope,
                    $q,
                    $interval,
                    $localStorage,
                    $filter,
                    $state,
                    $window,
                    jfJsonApi,
                    ContextContextsFactory,
                    authService,
                    jfUser,
                    jfDialog,
                    JF_SHARED_CONFIG
                ) {
                    var jfToken = this;

                    jfToken.initSharedObject($rootScope);
                    jfToken.initModule($rootScope);

                    return {
                        getTokenObjName: function() {
                            return jfToken.tokenObjName;
                        },
                        init: function() {
                            var jfTokenApi = this,
                                deferred = $q.defer();

                            $rootScope.jfShared.jfToken.intervalPromise = null;

                            $rootScope.$on('event:auth-loginRequired', function() {
                                jfTokenApi.loginRequiredEventCallback(jfTokenApi);
                            });

                            if (angular.isUndefined($localStorage[jfToken.tokenObjName]) ||
                                !angular.isString($localStorage[jfToken.tokenObjName].token) ||
                                $localStorage[jfToken.tokenObjName].token === '' ||
                                jfTokenApi.isTokenExpired($localStorage[jfToken.tokenObjName].expire_time)
                            ) {
                                jfTokenApi
                                    .getToken()
                                    .then(function() {
                                        deferred.resolve();
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                jfTokenApi.startInterval();
                                deferred.resolve();
                            }

                            return deferred.promise;
                        },
                        loginRequiredEventCallback: function(jfTokenApi) {
                            if ($rootScope.jfShared.jfNetwork.unauthorizedResponses < 10) {
                                jfTokenApi
                                    .getToken()
                                    .then(function() {
                                        authService.loginConfirmed();
                                    }, function(err) {
                                        if (err.status === 403) {
                                            $state.go('logout');
                                        } else {
                                            $rootScope.$emit('app-error', { err: err });
                                        }
                                    });
                            } else {
                                jfDialog
                                    .showAlert(
                                        $filter('translate')(jfToken.translations.fatalErrorPopupTitle),
                                        $filter('translate')(jfToken.translations.fatalErrorPopupMsg),
                                        $filter('translate')(jfToken.translations.fatalErrorPopupButton),
                                        function() {
                                            $window.location.reload();
                                        }
                                    );

                                $rootScope.$emit('app-error', {err: {msg: '401 Infinite loop error - displayed error popup with page reload button. Affected urls: ' + $rootScope.jfShared.jfNetwork.unauthorizedResponsesArray.join('|')}, silent: true});
                            }
                        },
                        getToken: function() {
                            var deferred = $q.defer(),
                                jfAppUpdateApi = this;

                            jfAppUpdateApi
                                .createNewToken()
                                .then(function(token) {
                                    $localStorage[jfToken.tokenObjName] = token;

                                    jfAppUpdateApi.cancelInterval();
                                    jfAppUpdateApi.startInterval();

                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });

                            return deferred.promise;
                        },
                        createNewToken: function() {
                            var deferred = $q.defer();

                            ContextContextsFactory
                                .save(
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.token,
                                        {
                                            payload: {
                                                user_id: jfUser.get().id
                                            }
                                        }
                                    )
                                )
                                .$promise
                                .then(function(token) {
                                    deferred.resolve(token.data.attributes);
                                }, function(err) {
                                    deferred.reject(err);
                                });

                            return deferred.promise;
                        },
                        updateToken: function() {
                            var deferred = $q.defer(),
                                jfAppUpdateApi = this;

                            ContextContextsFactory
                                .update(
                                    { id: $localStorage[jfToken.tokenObjName].token },
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.token,
                                        {
                                            payload: {
                                                refreshed_at: new Date().getTime(),
                                                user_id: jfUser.get().id
                                            }
                                        },
                                        { id: $localStorage[jfToken.tokenObjName].token }
                                    )
                                )
                                .$promise
                                .then(function(result) {
                                    if (angular.isDefined(result.data.attributes.token)) {
                                        deferred.resolve(result.data.attributes);
                                    } else {
                                        deferred.reject('Token not refreshed! Result from API: ' + JSON.stringify(result));
                                    }
                                }, function() {
                                    jfAppUpdateApi
                                        .createNewToken()
                                        .then(function(token) {
                                            deferred.resolve(token);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                });

                            return deferred.promise;
                        },
                        startInterval: function() {
                            var jfAppUpdateApi = this;

                            $rootScope.jfShared.jfToken.intervalPromise = $interval(function() {
                                jfAppUpdateApi.intervalLogic();
                            }, jfToken.tokenIntervalTime);
                        },
                        intervalLogic: function() {
                            var jfAppUpdateApi = this,
                                refreshJsonApiVersion = false;

                            if (
                                angular.isDefined($localStorage[jfToken.tokenObjName]) &&
                                jfAppUpdateApi.isTokenExpired($localStorage[jfToken.tokenObjName].expire_time)
                            ) {
                                jfAppUpdateApi.cancelInterval();

                                if (
                                    angular.isDefined($localStorage[jfToken.tokenObjName].client_ref) ||
                                    (
                                        angular.isDefined($localStorage.order) &&
                                        angular.isDefined($localStorage.order.details) &&
                                        angular.isDefined($localStorage.order.details.attributes) &&
                                        angular.isDefined($localStorage.order.details.attributes.client_ref)
                                    )
                                ) {
                                    refreshJsonApiVersion = true;
                                }

                                jfAppUpdateApi
                                    // .updateToken()
                                    .createNewToken()
                                    .then(function(result) {
                                        $localStorage[jfToken.tokenObjName] = result;

                                        if (refreshJsonApiVersion) {
                                            $rootScope.$emit('jf:jsonApi:refresh');
                                        }

                                        jfAppUpdateApi.startInterval();
                                    }, function(err) {
                                        jfAppUpdateApi.startInterval();

                                        $rootScope.$emit(
                                            'app-log',
                                            {
                                                msg: 'Error: Token not refreshed!',
                                                response: JSON.stringify(err)
                                            }
                                        );
                                    });
                            } else {
                                if (
                                    angular.isDefined($localStorage.order) &&
                                    angular.isDefined($localStorage.order.details) &&
                                    angular.isDefined($localStorage.order.details.attributes) &&
                                    angular.isDefined($localStorage.order.details.attributes.client_ref)
                                ) {
                                    $rootScope.$emit('jf:jsonApi:refresh');
                                }
                            }
                        },
                        cancelInterval: function() {
                            if (
                                $rootScope.jfShared.jfToken.intervalPromise !== null &&
                                $rootScope.jfShared.jfToken.intervalPromise.$$state.status !== 2
                            ) {
                                $interval.cancel($rootScope.jfShared.jfToken.intervalPromise);
                            }
                        },
                        isTokenExpired: function(expirationTime) {
                            var exp = new Date(expirationTime);

                            return exp.getTime() <= new Date().getTime();
                        }
                    };
                }]
            };
        }
    );
angular.module('jf.network', [])
    .provider(
        'jfNetwork',
        function() {
            'use strict';

            return {
                translations: {
                    timeout1PopupTitle: '',
                    timeout1PopupMsg: '',
                    timeout1PopupButton: '',
                    timeout2PopupTitle: '',
                    timeout2PopupMsg: '',
                    timeout2PopupButton: ''
                },
                isBackgroundRequest: function() {
                    return false;
                },
                secondTimeoutRedirectPage: 'products',
                initSharedObject: function($rootScope) {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                    $rootScope.jfShared.jfNetwork = $rootScope.jfShared.jfNetwork || {};
                },
                initModule: function($rootScope) {
                    $rootScope.jfShared.jfNetwork.unauthorizedResponses = 0;
                    $rootScope.jfShared.jfNetwork.unauthorizedResponsesArray = [];
                    $rootScope.jfShared.jfNetwork.xhrPending = 0;
                    $rootScope.jfShared.jfNetwork.xhrCompleted = 0;
                    $rootScope.jfShared.jfNetwork.fatalErrorAlertPopup = null;
                    $rootScope.jfShared.jfNetwork.loading = false;
                    $rootScope.jfShared.jfNetwork.loadingText = null;
                    $rootScope.jfShared.jfNetwork.loadingIndicatorEnabled = true;
                },
                isLoading: function($rootScope) {
                    return $rootScope.jfShared.jfNetwork.xhrPending !== $rootScope.jfShared.jfNetwork.xhrCompleted;
                },
                setTranslations: function(translationKeys) {
                    this.translations.timeout1PopupTitle = translationKeys.timeout1PopupTitle;
                    this.translations.timeout1PopupMsg = translationKeys.timeout1PopupMsg;
                    this.translations.timeout1PopupButton = translationKeys.timeout1PopupButton;

                    this.translations.timeout2PopupTitle = translationKeys.timeout2PopupTitle;
                    this.translations.timeout2PopupMsg = translationKeys.timeout2PopupMsg;
                    this.translations.timeout2PopupButton = translationKeys.timeout2PopupButton;
                },
                setBackgroundRequestChecker: function(backgroundRequestChecker) {
                    if (typeof backgroundRequestChecker === 'function') {
                        this.isBackgroundRequest = backgroundRequestChecker;
                    }
                },
                setSecondTimeoutRedirectPage: function(redirectPage) {
                    this.secondTimeoutRedirectPage = redirectPage;
                },
                $get: ['$rootScope', '$q', '$injector', '$localStorage', 'jfHistory', 'jfConfigUrls', 'JF_CONFIG', function(
                    $rootScope,
                    $q,
                    $injector,
                    $localStorage,
                    jfHistory,
                    jfConfigUrls,
                    JF_CONFIG
                ) {
                    var jfNetwork = this,
                        jfNetworkApi;

                    jfNetwork.initSharedObject($rootScope);
                    jfNetwork.initModule($rootScope);


                    jfNetworkApi = {
                        loadingIndicatorEnabled: function(isEnabled) {
                            $rootScope.jfShared.jfNetwork.loadingIndicatorEnabled = isEnabled;
                        },
                        setLoading: function(isLoading) {
                            $rootScope.jfShared.jfNetwork.loading = isLoading;
                        },
                        setLoadingText: function(loadingText) {
                            $rootScope.jfShared.jfNetwork.loadingText = loadingText;
                        },
                        getLoadingText: function() {
                            return $rootScope.jfShared.jfNetwork.loadingText;
                        },
                        canToggleLoader: function(config) {
                            return !jfNetwork.isBackgroundRequest(config) &&
                                $rootScope.jfShared.jfNetwork.loadingIndicatorEnabled &&
                                config.url.indexOf('jf-app-current-version.txt') === -1 &&
                                config.url.indexOf('.svg') === -1;
                        },
                        handleTimeoutError: function(rejection, deferred) {
                            rejection.requestTimeout = true;

                            if (rejection.config.requestCounter !== 2) {
                                if ($rootScope.jfShared.jfNetwork.fatalErrorAlertPopup === null) {
                                    $rootScope.jfShared.jfNetwork.fatalErrorAlertPopup = true;

                                    jfNetworkApi.showFirstTimeoutDialog(rejection, deferred);
                                } else {
                                    deferred.reject(rejection);
                                }
                            } else {
                                if ($rootScope.jfShared.jfNetwork.fatalErrorAlertPopup === null) {
                                    $rootScope.jfShared.jfNetwork.fatalErrorAlertPopup = true;

                                    jfNetworkApi.showSecondTimeoutDialog();

                                    deferred.reject(rejection);
                                } else {
                                    deferred.reject(rejection);
                                }
                            }
                        },
                        getApiKey: function() {
                            if ($injector.get('jfHelper').mobileAppMode && angular.isDefined(window.device)) {
                                return JF_CONFIG.api_keys[window.device.platform.toLowerCase()];
                            } else {
                                return JF_CONFIG.api_keys.web;
                            }
                        },
                        isAmazonPayRequest: function(url) {
                            return url.indexOf(jfConfigUrls.get('amazonProfileUrl', 'customerApp')) > -1 ||
                                url.indexOf(jfConfigUrls.get('amazonTokenInfoUrl', 'customerApp')) > -1;
                        },
                        showFirstTimeoutDialog: function(rejection, deferred) {
                            var $filter = $injector.get('$filter');

                            $injector.get('jfDialog').showAlert(
                                $filter('translate')(jfNetwork.translations.timeout1PopupTitle),
                                $filter('translate')(jfNetwork.translations.timeout1PopupMsg),
                                $filter('translate')(jfNetwork.translations.timeout1PopupButton),
                                function() {
                                    jfNetworkApi.showFirstTimeoutDialogCallback(rejection, deferred);
                                },
                                false
                            );
                        },
                        showFirstTimeoutDialogCallback: function(rejection, deferred) {
                            $injector.get('jfDialog').hideDialogs();

                            $rootScope.jfShared.jfNetwork.fatalErrorAlertPopup = null;

                            var $http = $injector.get('$http');

                            rejection.config.requestCounter = 2;

                            $http(rejection.config).then(function(result) {
                                deferred.resolve(result);
                            }, function() {
                                deferred.reject(rejection);
                            });
                        },
                        showSecondTimeoutDialog: function() {
                            var $filter = $injector.get('$filter');

                            $injector.get('jfDialog').showAlert(
                                $filter('translate')(jfNetwork.translations.timeout2PopupTitle),
                                $filter('translate')(jfNetwork.translations.timeout2PopupMsg),
                                $filter('translate')(jfNetwork.translations.timeout2PopupButton),
                                jfNetworkApi.showSecondTimeoutDialogCallback,
                                false
                            );
                        },
                        showSecondTimeoutDialogCallback: function() {
                            $injector.get('jfDialog').hideDialogs();

                            $rootScope.jfShared.jfNetwork.fatalErrorAlertPopup = null;

                            $injector.get('$state').go(jfNetwork.secondTimeoutRedirectPage);
                        },
                        request: function(config) {
                            if (
                                config.url.indexOf('app/') === -1 &&
                                config.url.indexOf('./assets/') === -1 &&
                                config.url.indexOf('jf-app-current-version.txt') === -1
                            ) {
                                jfHistory.addRequest({
                                    method: config.method,
                                    url: config.url,
                                    params: config.params,
                                    data: config.data,
                                    headers: config.headers
                                });
                            }

                            config.headers = config.headers || {};

                            var tokenObjName = $injector.get('jfToken').getTokenObjName();

                            if (angular.isUndefined(config.S3Request)) {
                                if (
                                    (config.method === 'PUT' || config.method === 'POST') &&
                                    config.url.indexOf(jfConfigUrls.get('contextService') + '/contexts') > -1
                                ) {
                                    config.headers.Authorization = 'Basic ' + jfNetworkApi.getApiKey();
                                } else {
                                    if (
                                        angular.isDefined($localStorage[tokenObjName]) &&
                                        angular.isString($localStorage[tokenObjName].token) &&
                                        $localStorage[tokenObjName].token !== '' &&
                                        !jfNetworkApi.isAmazonPayRequest(config.url)
                                    ) {
                                        config.headers.Authorization = 'Bearer ' + $localStorage[tokenObjName].token;
                                    } else {
                                        config.headers.Authorization = undefined;
                                    }
                                }

                                if (!jfNetworkApi.isAmazonPayRequest(config.url)) {
                                    config.headers['Content-Type'] = 'application/vnd.api+json';
                                    config.headers.Accept = 'application/vnd.api+json';
                                } else {
                                    config.headers['Content-Type'] = undefined;
                                    config.headers.Accept = undefined;
                                }
                            }

                            if (config.url.indexOf('/we_deliver/cabs/bookings') > -1) {
                                config.headers['CABS-Access-Token'] = $localStorage.CABSAccessToken;
                            }

                            if (
                                jfNetworkApi.canToggleLoader(config) &&
                                config.url.indexOf('.html') === -1
                            ) {
                                $rootScope.jfShared.jfNetwork.xhrPending++;

                                jfNetworkApi.setLoading(jfNetwork.isLoading($rootScope));
                            }

                            config.requestStartTime = (new Date()).getTime();

                            return config;
                        },
                        requestError: function (rejection) {
                            if (
                                jfNetworkApi.canToggleLoader(rejection.config) &&
                                rejection.config.url.indexOf('.html') === -1
                            ) {
                                $rootScope.jfShared.jfNetwork.xhrCompleted++;

                                jfNetworkApi.setLoading(jfNetwork.isLoading($rootScope));
                            }

                            return $q.reject(rejection);
                        },
                        response: function (response) {
                            if (
                                jfNetworkApi.canToggleLoader(response.config) &&
                                response.config.url.indexOf('.html') === -1
                            ) {
                                $rootScope.jfShared.jfNetwork.xhrCompleted++;

                                jfNetworkApi.setLoading(jfNetwork.isLoading($rootScope));
                            }

                            // Reset unauthorized requests counter on all success responses excepts token creation
                            if (!(
                                response.config.method === 'POST' &&
                                response.config.url.indexOf(jfConfigUrls.get('contextService') + '/contexts') > -1
                            )
                            ) {
                                $rootScope.jfShared.jfNetwork.unauthorizedResponses = 0;
                                $rootScope.jfShared.jfNetwork.unauthorizedResponsesArray = [];
                            }

                            return response;
                        },
                        responseError: function (rejection) {
                            var deferred = $q.defer();

                            if (
                                jfNetworkApi.canToggleLoader(rejection.config) &&
                                rejection.config.url.indexOf('.html') === -1
                            ) {
                                $rootScope.jfShared.jfNetwork.xhrCompleted++;

                                jfNetworkApi.setLoading(jfNetwork.isLoading($rootScope));
                            }

                            if (rejection.status === -1 &&
                                ((new Date()).getTime() - rejection.config.requestStartTime) >= JF_CONFIG.requestTimeout &&
                                rejection.config.url.indexOf(jfConfigUrls.get('contextService') + '/contexts') === -1 &&
                                rejection.config.url.indexOf(jfConfigUrls.get('booksService') + '/books/orders/commit') === -1 &&
                                rejection.config.url.indexOf(jfConfigUrls.get('jfShopUrl') + 'monitoring/jf-app-current-version.txt') === -1
                            ) {
                                jfNetworkApi.handleTimeoutError(rejection, deferred);
                            } else if (rejection.status === 401) {
                                $rootScope.jfShared.jfNetwork.unauthorizedResponses++;
                                if ($rootScope.jfShared.jfNetwork.unauthorizedResponsesArray.indexOf(rejection.config.url) === -1) {
                                    $rootScope.jfShared.jfNetwork.unauthorizedResponsesArray.push(rejection.config.url);
                                }

                                deferred.reject(rejection);
                            } else if (rejection.status === 345) {
                                var $state = $injector.get('$state');

                                if ($state.current.name !== 'maintenance') {
                                    $state.go('maintenance');
                                } else {
                                    deferred.reject(rejection);
                                }
                            } else {
                                deferred.reject(rejection);
                            }

                            return deferred.promise;
                        }
                    };

                    return jfNetworkApi;
                }]
            };
        }
    );
angular.module('jf.login', [])
    .provider(
        'jfLogin',
        function() {
            'use strict';

            return {
                allowedRole: null,
                userDetails: {},
                setAllowedUserRole: function(userRole) {
                    this.allowedRole = userRole;
                },
                setUserDetails: function(userDetails) {
                    this.userDetails = userDetails;
                },
                $get: ['$q', 'base64', 'jfUser', 'AccountCredentialsFactory', 'AccountAddressesFactory', 'jfJsonApi', 'JF_CONFIG', 'JF_SHARED_CONFIG', function(
                    $q,
                    base64,
                    jfUser,
                    AccountCredentialsFactory,
                    AccountAddressesFactory,
                    jfJsonApi,
                    JF_CONFIG,
                    JF_SHARED_CONFIG
                ) {
                    var jfLogin = this;

                    return {
                        preparePreferredUserAddresses:  function(userData) {
                            // Check if user doesn't have preferred delivery address - he's a V1 user
                            // If yes, then grab his first address and set it temporary as a preferred delivery address
                            // If not, then do nothing
                            var deferred = $q.defer();

                            if (userData.pdid === null || userData.ppid === null || userData.pbid === null) {
                                AccountAddressesFactory
                                    .get({
                                        'filter[addressable_id]': userData.id,
                                        'filter[addressable_type]': 'User',
                                        'filter[type]': 'ServiceAddress'
                                    })
                                    .$promise
                                    .then(function(userAddresses) {
                                        if (userAddresses.data.length > 0) {
                                            if (userData.pdid === null) {
                                                userData.pdid = userAddresses.data[0].id;
                                            }
                                            if (userData.ppid === null) {
                                                userData.ppid = userAddresses.data[0].id;
                                            }
                                        }
                                        deferred.resolve();
                                    }, function (err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                deferred.resolve();
                            }

                            return deferred.promise;
                        },
                        login: function(email, password, additionalParams) {
                            var deferred = $q.defer(),
                                model = this;

                            additionalParams = additionalParams || {};

                            var loginParams = additionalParams;

                            loginParams.login = email;
                            loginParams.password = password;

                            AccountCredentialsFactory
                                .save(
                                    jfJsonApi.prepare(
                                        JF_SHARED_CONFIG.modelTypes.credentials,
                                        loginParams
                                    )
                                )
                                .$promise
                                .then(function(response) {
                                    model.
                                        loginProcessCredentials(response)
                                        .then(function(response) {
                                            deferred.resolve(response);
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                }, function(err) {
                                    deferred.reject(err);
                                });

                            return deferred.promise;
                        },
                        loginSuccessProceed: function(response) {
                            var deferred = $q.defer(),
                                model = this,
                                userData = {
                                    id: response.data.id,
                                    login: base64.encode(response.data.attributes.login),
                                    locale: response.included[0].attributes.preferred_locale,
                                    country: response.included[0].attributes.country_of_residence
                                };

                            angular.forEach(jfLogin.userDetails, function (listOfAttributes, nameOfParameter) {
                                if (nameOfParameter === 'data') {
                                    angular.forEach(listOfAttributes, function(backendResponseName, localStorageName) {
                                        var fieldValue = response.data.attributes[backendResponseName];

                                        if (
                                            angular.isDefined(jfLogin.userDetails.encode) &&
                                            jfLogin.userDetails.encode.indexOf(localStorageName) > -1 &&
                                            fieldValue !== null
                                        ) {
                                            fieldValue = base64.encode(fieldValue);
                                        }

                                        userData[localStorageName] = fieldValue;
                                    });
                                } else if (nameOfParameter === 'included') {
                                    angular.forEach(response.included, function(includedData) {
                                        if (includedData.type === 'profiles') {
                                            angular.forEach(listOfAttributes, function(backendResponseName, localStorageName) {
                                                var fieldValue = includedData.attributes;

                                                if (backendResponseName.indexOf('.') > -1) {
                                                    var fieldNameArr = backendResponseName.split('.');

                                                    angular.forEach(fieldNameArr, function(fieldName) {
                                                        if (
                                                            fieldValue !== null &&
                                                            angular.isDefined(fieldValue[fieldName]) &&
                                                            fieldValue[fieldName] !== null
                                                        ) {
                                                            fieldValue = fieldValue[fieldName];
                                                        } else {
                                                            fieldValue = null;
                                                        }
                                                    });
                                                } else {
                                                    fieldValue = fieldValue[backendResponseName];
                                                }

                                                if (
                                                    angular.isDefined(jfLogin.userDetails.encode) &&
                                                    jfLogin.userDetails.encode.indexOf(localStorageName) > -1 &&
                                                    fieldValue !== null
                                                ) {
                                                    fieldValue = base64.encode(fieldValue);
                                                }

                                                userData[localStorageName] = fieldValue;
                                            });
                                            userData.profileId = includedData.id;
                                        }
                                    });
                                } else if (nameOfParameter === 'relationships') {
                                    angular.forEach(response.data.relationships, function(relationshipObj, relationshipName) {
                                        if (
                                            angular.isDefined(relationshipObj.data) &&
                                            relationshipObj.data !== null &&
                                            listOfAttributes.indexOf(relationshipName) > -1
                                        ) {
                                            userData[relationshipName + 'Id'] = relationshipObj.data.id;
                                        }
                                    });
                                }
                            });

                            model
                                .loginAdditionalActions(
                                    response.data.relationships.role.data.id,
                                    userData,
                                    response
                                )
                                .then(function(response) {
                                    deferred.resolve(response);
                                }, function(err) {
                                    deferred.reject(err);
                                });

                            return deferred.promise;
                        },
                        loginProcessCredentials: function(response) {
                            var deferred = $q.defer(),
                                model = this,
                                userData = {
                                    login: base64.encode(response.data.attributes.login)
                                };

                            var listOfAttributes = Object.assign({}, jfLogin.userDetails.data, jfLogin.userDetails.included);

                            angular.forEach(response.included, function(includedData) {
                                angular.forEach(listOfAttributes, function(backendResponseName, localStorageName) {
                                    var fieldValue = includedData.attributes;

                                    if (backendResponseName.indexOf('.') > -1) {
                                        var fieldNameArr = backendResponseName.split('.');

                                        angular.forEach(fieldNameArr, function(fieldName) {
                                            if (
                                                fieldValue !== null &&
                                                angular.isDefined(fieldValue[fieldName]) &&
                                                fieldValue[fieldName] !== null
                                            ) {
                                                fieldValue = fieldValue[fieldName];
                                            } else {
                                                fieldValue = null;
                                            }
                                        });
                                    } else {
                                        fieldValue = fieldValue[backendResponseName];
                                    }

                                    if (
                                        angular.isDefined(jfLogin.userDetails.encode) &&
                                        jfLogin.userDetails.encode.indexOf(localStorageName) > -1 &&
                                        angular.isDefined(fieldValue) &&
                                        fieldValue !== null
                                    ) {
                                        fieldValue = base64.encode(fieldValue);
                                    }

                                    if (angular.isUndefined(userData[localStorageName])) {
                                        userData[localStorageName] = fieldValue;
                                    }

                                });

                                if (includedData.type === 'profiles') {
                                    userData.profileId = includedData.id;
                                    userData.locale = includedData.attributes.preferred_local;
                                    userData.country = includedData.attributes.country_of_residence;
                                }

                                if (includedData.type === 'customers') {
                                    userData.id = includedData.id;
                                }

                                if (includedData.type === 'companies') {
                                    userData.companyId = includedData.id;
                                }
                            });

                            angular.forEach(response.data.relationships, function(relationshipObj, relationshipName) {
                                if (
                                    angular.isDefined(relationshipObj.data) &&
                                    relationshipObj.data !== null &&
                                    jfLogin.userDetails.relationships.indexOf(relationshipName) > -1
                                ) {
                                    userData[relationshipName + 'Id'] = relationshipObj.data.id;
                                }
                            });

                            model
                                .loginAdditionalActions(
                                    null,
                                    userData,
                                    response
                                )
                                .then(function(response) {
                                    deferred.resolve(response);
                                }, function(err) {
                                    deferred.reject(err);
                                });

                            return deferred.promise;
                        },
                        loginAdditionalActions: function(responseUserRoleId, userData, response) {
                            var deferred = $q.defer(),
                                model = this;

                            if (jfLogin.allowedRole !== null) {
                                if (jfLogin.allowedRole === 'driver') {
                                    if (responseUserRoleId === JF_CONFIG.userRoleIds.driver) {
                                        model
                                            .performLogin(userData)
                                            .then(function() {
                                                deferred.resolve(response);
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    } else {
                                        deferred.reject({
                                            status: 401
                                        });
                                    }
                                } else if (jfLogin.allowedRole === 'dryCleaner') {
                                    if (responseUserRoleId === JF_CONFIG.userRoleIds.dryCleaner) {
                                        model
                                            .performLogin(userData)
                                            .then(function() {
                                                deferred.resolve(response);
                                            }, function(err) {
                                                deferred.reject(err);
                                            });
                                    } else {
                                        deferred.reject({
                                            status: 401
                                        });
                                    }
                                } else if (jfLogin.allowedRole === 'customer') {
                                    this
                                        .preparePreferredUserAddresses(userData)
                                        .then(function() {
                                            model
                                                .performLogin(userData)
                                                .then(function() {
                                                    deferred.resolve(response);
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }, function(err) {
                                            deferred.reject(err);
                                        });
                                } else {
                                    deferred.reject({
                                        status: 401
                                    });
                                }
                            } else {
                                deferred.reject({
                                    status: 401
                                });
                            }

                            return deferred.promise;
                        },
                        performLogin: function(userData) {
                            var deferred = $q.defer();
                            jfUser
                                .login(userData)
                                .then(function() {
                                    deferred.resolve();
                                }, function(err) {
                                    deferred.reject(err);
                                });

                            return deferred.promise;
                        }
                    };
                }]
            };
        }
    );
angular
    .module('jf.location', [])
    .factory(
        'jfLocation',
        ['$q', 'jfUser', 'LogisticValidatePostalCodeOperationFactory', 'LogisticInfoPostalCodeOperationFactory', function(
            $q,
            jfUser,
            LogisticValidatePostalCodeOperationFactory,
            LogisticInfoPostalCodeOperationFactory
        ) {
            'use strict';

            return {
                postalCodeInService: function(postalCodeId, companyId) {
                    var deferred = $q.defer(),
                        params = { postal_code_id: postalCodeId },
                        companyId = companyId || null,
                        customerKind = 'b2c',
                        factory = this;

                    if (angular.isDefined(companyId) && companyId !== null) {
                        params.company_id = companyId;

                        if (jfUser.get().corporateEnabled === true) {
                            customerKind = 'corp';
                        } else {
                            customerKind = 'b2b';
                        }
                    }


                    LogisticValidatePostalCodeOperationFactory
                        .save({
                            data: {
                                attributes: params,
                                type: 'validate_postal_code_operations'
                            }
                        })
                        .$promise
                        .then(function(postalCodeDetails) {
                            if (!postalCodeDetails || !postalCodeDetails.data || postalCodeDetails.data.attributes.b_levels.length === 0) {
                                LogisticInfoPostalCodeOperationFactory
                                    .save({
                                        data: {
                                            attributes: params,
                                            type: 'info_postal_code_operations'
                                        }
                                    })
                                    .$promise
                                    .then(function(postalCodeInfo) {
                                        if (angular.isUndefined(postalCodeInfo.data) || postalCodeInfo.data === null) {
                                            deferred.resolve({ valid: false, reason: 1 });
                                        } else {
                                            factory
                                                .postalCodeValidationLogic(postalCodeInfo.data.attributes, customerKind, companyId)
                                                .then(function(validationResult) {
                                                    deferred.resolve(validationResult);
                                                }, function(err) {
                                                    deferred.reject(err);
                                                });
                                        }
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            } else {
                                factory
                                    .postalCodeValidationLogic(postalCodeDetails.data.attributes, customerKind, companyId)
                                    .then(function(validationResult) {
                                        deferred.resolve(validationResult);
                                    }, function(err) {
                                        deferred.reject(err);
                                    });
                            }
                        }, function(err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                },
                postalCodeValidationLogic: function(postalCodeDetails, customerKind, companyId) {
                    var deferred = $q.defer();

                    /**
                     Failed validation reasons:
                     1 - Not serviceable
                     2 - B2B only
                     3 - Corp only
                     **/
                    var postalCodeKinds = postalCodeDetails.b_levels,
                        postalCodeCompany_ids = postalCodeDetails.company_ids;

                    switch (customerKind) {
                        case 'b2b':
                            if (postalCodeKinds.indexOf('b2b') > -1) {
                                if (postalCodeDetails.serviceable === true) {
                                    deferred.resolve({valid: true, postalCodeDetails: postalCodeDetails});
                                } else {
                                    deferred.resolve({valid: false, reason: 2, postalCodeDetails: postalCodeDetails});
                                }
                            } else {
                                if (postalCodeKinds.indexOf('corp') > -1) {
                                    deferred.resolve({valid: false, reason: 3, postalCodeDetails: postalCodeDetails});
                                } else {
                                    deferred.resolve({valid: false, reason: 1, postalCodeDetails: postalCodeDetails});
                                }
                            }
                            break;
                        case 'corp':
                            if (postalCodeKinds.indexOf('corp') > -1) {
                                if (postalCodeCompany_ids.indexOf(companyId) > -1) {
                                    if (postalCodeDetails.serviceable === true) {
                                        deferred.resolve({valid: true, setCorpFlag: true, postalCodeDetails: postalCodeDetails});
                                    } else {
                                        deferred.resolve({valid: false, reason: 3, postalCodeDetails: postalCodeDetails});
                                    }
                                } else {
                                    if (postalCodeKinds.indexOf('b2c') > -1) {
                                        if (postalCodeDetails.serviceable === true) {
                                            deferred.resolve({valid: true, postalCodeDetails: postalCodeDetails});
                                        } else {
                                            deferred.resolve({valid: false, reason: 2, postalCodeDetails: postalCodeDetails});
                                        }
                                    } else {
                                        deferred.resolve({valid: false, reason: 3, postalCodeDetails: postalCodeDetails});
                                    }
                                }
                            } else {
                                if (postalCodeKinds.indexOf('b2c') > -1 && postalCodeDetails.serviceable === true) {
                                    deferred.resolve({valid: true, postalCodeDetails: postalCodeDetails});
                                } else {
                                    deferred.resolve({valid: false, reason: 2, postalCodeDetails: postalCodeDetails});
                                }
                            }
                            break;
                        default: //b2c
                            if (postalCodeKinds.indexOf('b2c') > -1) {
                                if (postalCodeDetails.serviceable === true) {
                                    deferred.resolve({valid: true, postalCodeDetails: postalCodeDetails});
                                } else {
                                    deferred.resolve({valid: false, reason: 2, postalCodeDetails: postalCodeDetails});
                                }
                            } else {
                                if (
                                    postalCodeKinds.indexOf('b2b') > -1 &&
                                    postalCodeKinds.indexOf('corp') === -1
                                ) {
                                    deferred.resolve({valid: false, reason: 2, postalCodeDetails: postalCodeDetails});
                                } else {
                                    deferred.resolve({valid: false, reason: 3, postalCodeDetails: postalCodeDetails});
                                }
                            }
                    }

                    return deferred.promise;
                }
            };
        }]
    );
angular.module('jf.mobile-events', [])
    .provider(
        'jfMobileEvents',
        function() {
            'use strict';

            return {
                appDefaultScreens: ['login'],
                exitAppMessageVisible: false,
                translations: {
                    appExitDialogTitle: '',
                    appExitDialogContent: '',
                    appExitDialogOk: '',
                    appExitDialogCancel: ''
                },
                setAppDefaultScreens: function(defaultScreens) {
                    this.appDefaultScreens = this.appDefaultScreens.concat(defaultScreens);
                },
                setTranslations: function(translationKeys) {
                    this.translations.appExitDialogTitle = translationKeys.appExitDialogTitle;
                    this.translations.appExitDialogContent = translationKeys.appExitDialogContent;
                    this.translations.appExitDialogOk = translationKeys.appExitDialogOk;
                    this.translations.appExitDialogCancel = translationKeys.appExitDialogCancel;
                },
                $get: ['$state', '$rootScope', '$filter', '$timeout', '$window', 'JF_CONFIG', 'jfAppUpdate', 'jfUser', 'jfDialog', 'jfHelper', function(
                    $state,
                    $rootScope,
                    $filter,
                    $timeout,
                    $window,
                    JF_CONFIG,
                    jfAppUpdate,
                    jfUser,
                    jfDialog,
                    jfHelper
                ) {
                    var jfMobileEvents = this;

                    return {
                        deviceready: function () {
                            if (jfHelper.mobileAppMode && angular.isDefined(cordova)) {
                                /**
                                 * Fix for iOS input focus issue
                                 */
                                if (angular.isDefined($window.device) && $window.device.platform.toLowerCase() === 'ios') {
                                    $window.addEventListener('keyboardDidShow', function () {
                                        var viewportHeight = (window.innerHeight || document.documentElement.clientHeight),
                                            inputBottomPosition = document.activeElement.getBoundingClientRect().bottom;

                                        if (inputBottomPosition > viewportHeight) {
                                            document.activeElement.scrollIntoView(false);
                                        }
                                    });
                                }

                                /**
                                 * Assign inAppBrowser
                                 */
                                /* istanbul ignore else */
                                if (angular.isDefined(cordova.InAppBrowser) && angular.isDefined(cordova.InAppBrowser.open)) {
                                    window.open = cordova.InAppBrowser.open;
                                }

                                /**
                                 * Check for app updates
                                 */
                                if (
                                    angular.isUndefined(JF_CONFIG.codePushEnabled) ||
                                    JF_CONFIG.codePushEnabled === true ||
                                    JF_CONFIG.codePushEnabled === 'true'
                                ) {
                                    jfAppUpdate.checkForUpdate();
                                }

                                /**
                                 * Update user data if logged in
                                 */
                                /* istanbul ignore else */
                                if (jfUser.isLoggedIn()) {
                                    jfUser
                                        .updateUserData()
                                        .then(function() {

                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }

                                /**
                                 * Splash screen hide for iOS
                                 */
                                /* istanbul ignore else */
                                if (window.navigator && window.navigator.splashscreen) {
                                    $timeout(function() {
                                        window.navigator.splashscreen.hide();
                                    }, 2000);
                                }
                            }
                        },
                        resume: function() {
                            if (jfHelper.mobileAppMode && angular.isDefined(cordova)) {
                                /**
                                 * Check for app updates
                                 */
                                if (
                                    angular.isUndefined(JF_CONFIG.codePushEnabled) ||
                                    JF_CONFIG.codePushEnabled === true ||
                                    JF_CONFIG.codePushEnabled === 'true'
                                ) {
                                    jfAppUpdate.checkForUpdate();
                                }

                                /**
                                 * Update user data if logged in
                                 */
                                /* istanbul ignore else */
                                if (jfUser.isLoggedIn()) {
                                    jfUser
                                        .updateUserData()
                                        .then(function() {

                                        }, function(err) {
                                            $rootScope.$emit('app-error', {err: err});
                                        });
                                }
                            }
                        },
                        backbutton: function(customBackFunction) {
                            if (jfHelper.mobileAppMode && angular.isDefined(cordova)) {
                                if (jfHelper.mobileAppMode && jfMobileEvents.appDefaultScreens.indexOf($state.current.name) > -1) {
                                    /* istanbul ignore else */
                                    if (
                                        jfMobileEvents.exitAppMessageVisible === false &&
                                        jfAppUpdate.isForceAppUpdateMessageVisible() === false
                                    ) {
                                        jfMobileEvents.exitAppMessageVisible = true;

                                        jfDialog
                                            .showConfirm(
                                                $filter('translate')(jfMobileEvents.translations.appExitDialogTitle),
                                                $filter('translate')(jfMobileEvents.translations.appExitDialogContent),
                                                $filter('translate')(jfMobileEvents.translations.appExitDialogOk),
                                                $filter('translate')(jfMobileEvents.translations.appExitDialogCancel),
                                                function() {
                                                    jfMobileEvents.exitAppMessageVisible = false;

                                                    window.navigator.app.exitApp();
                                                },
                                                function() {
                                                    jfMobileEvents.exitAppMessageVisible = false;
                                                }
                                            );
                                    }
                                } else {
                                    if (angular.isDefined(customBackFunction) && angular.isFunction(customBackFunction)) {
                                        customBackFunction();
                                    } else {
                                        jfHelper.goBackInHistory();
                                    }
                                }
                            }
                        }
                    };
                }]
            };
        }
    );
angular.module('jf.app-update', [])
    .provider(
        'jfAppUpdate',
        function() {
            'use strict';

            return {
                googlePlayLink: null,
                appleStoreLink: null,
                translations: {
                    installingUpdate: '',
                    downloadingUpdate: '',
                    forceUpdatePopupTitle: '',
                    forceUpdatePopupMsg: '',
                    forceUpdatePopupButton: ''
                },
                initSharedObject: function($rootScope) {
                    $rootScope.jfShared = $rootScope.jfShared || {};
                    $rootScope.jfShared.jfAppUpdate = $rootScope.jfShared.jfAppUpdate || {};
                },
                initModule: function($rootScope) {
                    $rootScope.jfShared.jfAppUpdate.forceAppUpdateMessageVisible = false;
                },
                setGooglePlayLink: function(googlePlayLink) {
                    this.googlePlayLink = googlePlayLink;
                },
                setAppleStoreLink: function(appleStoreLink) {
                    this.appleStoreLink = appleStoreLink;
                },
                setTranslations: function(translationKeys) {
                    this.translations.installingUpdate = translationKeys.installingUpdate;
                    this.translations.downloadingUpdate = translationKeys.downloadingUpdate;
                    this.translations.forceUpdatePopupTitle = translationKeys.forceUpdatePopupTitle;
                    this.translations.forceUpdatePopupMsg = translationKeys.forceUpdatePopupMsg;
                    this.translations.forceUpdatePopupButton = translationKeys.forceUpdatePopupButton;
                },
                $get: ['$rootScope', '$filter', '$window', '$injector', '$q', '$timeout', 'SpinnerFactory', 'jfDialog', 'jfNetwork', function(
                    $rootScope,
                    $filter,
                    $window,
                    $injector,
                    $q,
                    $timeout,
                    SpinnerFactory,
                    jfDialog,
                    jfNetwork
                ) {
                    var internal = this;

                    internal.initSharedObject($rootScope);
                    internal.initModule($rootScope);

                    return {
                        googlePlayLink: internal.googlePlayLink,
                        appleStoreLink: internal.appleStoreLink,
                        isForceAppUpdatePopupAvailable: function() {
                            return internal.translations.forceUpdatePopupTitle !== '';
                        },
                        isForceAppUpdateMessageVisible: function() {
                            return $rootScope.jfShared.jfAppUpdate.forceAppUpdateMessageVisible === true;
                        },
                        checkForUpdate: function() {
                            var jfAppUpdateApi = this;

                            jfNetwork.setLoadingText(null);

                            $window
                                .codePush
                                .sync(
                                    function(SyncStatus) {
                                        jfAppUpdateApi.updateLoaderState(SyncStatus);
                                    },
                                    {},
                                    function(downloadProgress) {
                                        jfAppUpdateApi.handleDownloadProgress(downloadProgress);
                                    },
                                    function(err) {
                                        jfNetwork.setLoadingText(null);

                                        $rootScope.$emit('app-error', {err: err, silent: true});
                                    }
                                );
                        },
                        updateLoaderState: function(SyncStatus) {
                            switch (SyncStatus) {
                                case 2:
                                    jfNetwork.setLoading(false);
                                    jfNetwork.setLoadingText(null);

                                    SpinnerFactory.unset('global', null);

                                    $rootScope.$emit(
                                        'app-log',
                                        {
                                            status: SyncStatus,
                                            msg: 'Code-Push app update IGNORED.'
                                        }
                                    );
                                    break;
                                case 3:
                                    jfNetwork.setLoading(false);
                                    jfNetwork.setLoadingText(null);

                                    SpinnerFactory.unset('global', null);

                                    $rootScope.$emit(
                                        'app-log',
                                        {
                                            status: SyncStatus,
                                            msg: 'Code-Push app update ERROR.'
                                        }
                                    );
                                    break;
                                case 7:
                                    jfNetwork.setLoading(true);

                                    if (!SpinnerFactory.isLoading('global')) {
                                        SpinnerFactory.set('global');
                                    }
                                    break;
                                case 8:
                                    jfNetwork.setLoading(true);
                                    jfNetwork.setLoadingText($filter('translate')(internal.translations.installingUpdate));

                                    if (!SpinnerFactory.isLoading('global')) {
                                        SpinnerFactory.set('global', $injector.get('$translate').instant(internal.translations.installingUpdate));
                                    } else {
                                        SpinnerFactory.setText($injector.get('$translate').instant(internal.translations.installingUpdate));
                                    }

                                    break;
                                default:
                                    jfNetwork.setLoading(false);
                                    jfNetwork.setLoadingText(null);

                                    SpinnerFactory.unset('global', null);
                                    break;
                            }
                        },
                        handleDownloadProgress: function(downloadProgress) {
                            jfNetwork.setLoading(true);

                            if (jfNetwork.getLoadingText() === null) {
                                jfNetwork.setLoadingText(
                                    $filter('translate')(
                                        internal.translations.downloadingUpdate,
                                        {
                                            progress: parseInt(
                                                (downloadProgress.receivedBytes * 100) / downloadProgress.totalBytes
                                            )
                                        }
                                    )
                                );
                            }

                            if (!SpinnerFactory.isLoading('global')) {
                                SpinnerFactory.set(
                                    'global',
                                    $injector
                                        .get('$translate')
                                        .instant(internal.translations.downloadingUpdate,
                                        {
                                            progress: parseInt(
                                                (downloadProgress.receivedBytes * 100) / downloadProgress.totalBytes
                                            )
                                        })
                                );
                            } else {
                                SpinnerFactory.setText($injector
                                    .get('$translate')
                                    .instant(internal.translations.downloadingUpdate,
                                        {
                                            progress: parseInt(
                                                (downloadProgress.receivedBytes * 100) / downloadProgress.totalBytes
                                            )
                                        }));
                            }
                        },
                        showMandatoryVersionMissingError: function(timeout) {
                            $timeout(function() {
                                $rootScope.jfShared.jfAppUpdate.forceAppUpdateMessageVisible = true;

                                jfDialog
                                    .showAlert(
                                        $filter('translate')(internal.translations.forceUpdatePopupTitle),
                                        $filter('translate')(internal.translations.forceUpdatePopupMsg),
                                        $filter('translate')(internal.translations.forceUpdatePopupButton),
                                        function() {
                                            if ($window.device.platform.toLowerCase() === 'ios') {
                                                // $window.location = internal.appleStoreLink;
                                                $window.open(internal.appleStoreLink, '_system');
                                            } else {
                                                $window.location = internal.googlePlayLink;
                                            }
                                        },
                                        false,
                                        true
                                    );
                            }, timeout);
                        },
                        isAppUpdateRequired: function(mandatoryVersion) {
                            var deferred = $q.defer();

                            if (angular.isDefined($window.cordova) && angular.isDefined($window.cordova.getAppVersion)) {
                                $window
                                    .cordova
                                    .getAppVersion
                                    .getVersionNumber()
                                    .then(function (version) {
                                        deferred.resolve((parseFloat(version) < parseFloat(mandatoryVersion)));
                                    }, function() {
                                        deferred.resolve(true);
                                    });
                            } else {
                                deferred.resolve(true);
                            }

                            return deferred.promise;
                        }
                    };
                }]
            };
        }
    );
angular
  .module('jf.api-application', [])
  .factory('LegalDocumentsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/legal_documents');
  }]);

angular
  .module('jf.api-account', [])
  .factory('AccountCustomerFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/customers/:id', {
      id: '@id',
    });
  }])
  .factory('AccountUserProfileFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/profiles/:id', {
      id: '@id',
    });
  }])
  .factory('AccountAddressesFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/addresses/:addressId',
      { addressId: '@addressId' }
    );
  }])
  .factory(
    'AccountPasswordForgottenFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/customers/password_forgotten'
      );
    }]
  )
  .factory(
    'AccountCustomerPasswordForgottenOperation',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') +
          '/myo/customer_password_forgotten_operations'
      );
    }]
  )
  .factory(
    'AccountCustomerPasswordResetOperation',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') +
          '/myo/customer_password_reset_operations'
      );
    }]
  )
  .factory('AccountPasswordResetFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/customers/password_reset'
    );
  }])
  .factory('AccountUsersBillingAgreements', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/adyen_billing_agreements/:id',
      {
        id: '@id',
      }
    );
  }])
  .factory('AccountAdyenPaymentMethods', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/adyen_payment_methods'
    );
  }])
  .factory(
    'AccountUsersBillingAgreementsDisable',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') +
          '/myo/adyen_billing_agreements/:id/disable',
        {
          id: '@id',
        },
        {
          save: {
            method: 'PATCH',
          },
        }
      );
    }]
  )
  .factory(
    'AccountUsersBillingAgreementsDisableOperation',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') +
          '/myo/adyen_billing_agreement_disable_operations'
      );
    }]
  )
  .factory(
    'AccountUsersBillingAgreementsThreeDs',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/threeds/redirect_shoppers/:md',
        {
          md: '@md',
        }
      );
    }]
  )
  .factory('AccountCompanies', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/companies/:id', {
      id: '@id',
    });
  }])
  .factory('AccountCompanyAddresses', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/addresses');
  }])
  .factory(
    'AccountCustomerAnonymizeOperationsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/customer_anonymize_operations'
      );
    }]
  )
  .factory(
    'AccountCustomerUnlinkOperationsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/customer_unlink_operations'
      );
    }]
  )
  .factory(
    'AccountCustomerLinkOperationsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/customer_link_operations'
      );
    }]
  )
  .factory('AccountCredentialsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/credentials');
  }]);

angular
  .module('jf.api-books', [])
  .factory('BooksOrdersFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/orders/:id', {
      id: '@id',
    });
  }])
  .factory('BooksOrdersOrderItemsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/order_items/:itemId',
      { itemId: '@itemId' }
    );
  }])
  .factory('BooksOrdersServiceableFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/orders/:id/serviceable',
      { id: '@id' }
    );
  }])
  .factory('BooksOrdersCommitFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/commit_orders');
  }])
  .factory('BooksPaymentMethodsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/payment_methods/:id',
      { id: '@id' }
    );
  }])
  .factory(
    'BooksPaymentMethodsLocalizedFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/localized_payment_methods/:id',
        { id: '@id' }
      );
    }]
  )
  .factory(
    'BooksCouponValidateOperationsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/coupon_validate_operations'
      );
    }]
  )
  .factory('BooksPaymentsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/payments/:id', {
      id: '@id',
    });
  }])
  .factory('BooksInvoicesFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/invoices/:id', {
      id: '@id',
    });
  }])
  .factory('BooksRemindersFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/invoice_reminders/:id',
      {
        id: '@id',
      }
    );
  }])
  .factory('BooksOrderSlipsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/orders/:orderId/documents',
      {
        orderId: '@orderId',
      }
    );
  }])
  .factory(
    'BooksOrderRemoveDestroyableOrderItemsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') +
          '/myo/orders/:orderId/remove_destroyable_order_items',
        { orderId: '@orderId' },
        {
          update: {
            method: 'PATCH',
          },
        }
      );
    }]
  );

angular
  .module('jf.api-context', [])
  .factory(
    'ContextContextsFactory',
    ['$resource', 'JF_CONFIG', 'jfConfigUrls', function ($resource, JF_CONFIG, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/contexts/:id',
        { id: '@id' },
        {
          save: {
            timeout: JF_CONFIG.requestTimeout,
            method: 'POST',
          },
          update: {
            timeout: JF_CONFIG.requestTimeout,
            method: 'PUT',
          },
        }
      );
    }]
  )
  .factory('ContextLocationsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/postal_codes');
  }])
  .factory('ContextPostalAddressesFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/postal_addresses/:id',
      { id: '@id' }
    );
  }])
  .factory(
    'ContextGeocodingLocationsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/geocoding_locations'
      );
    }]
  )
  .factory('ContextPostalCodesFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/postal_codes/:id',
      { id: '@id' }
    );
  }]);

angular
  .module('jf.api-shop', [])
  .factory('ShopLocalizedCatalogFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(
      jfConfigUrls.get('apiEndpoint') + '/myo/localized_catalogs'
    );
  }]);

angular
  .module('jf.api-logistic', [])
  .factory(
    'LogisticAppointmentsPickupFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/appointment/pickups'
      );
    }]
  )
  .factory(
    'LogisticAppointmentsDeliveryFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/appointment/deliveries'
      );
    }]
  )
  .factory(
    'LogisticValidatePostalCodeOperationFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/validate_postal_code_operations'
      );
    }]
  )
  .factory(
    'LogisticInfoPostalCodeOperationFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/info_postal_code_operations'
      );
    }]
  )
  .factory('LogisticTripsFactory', ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
    'use strict';

    return $resource(jfConfigUrls.get('apiEndpoint') + '/myo/trips/:id', {
      id: '@id',
    });
  }]);

angular
  .module('jf.api-notification', [])
  .factory(
    'NotificationInvoiceDocumentsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/invoice_documents',
        {}
      );
    }]
  )
  .factory(
    'NotificationInvoiceDetailsDocumentsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/invoice_details_documents',
        {}
      );
    }]
  )
  .factory(
    'NotificationInvoiceReminderDocumentsFactory',
    ['$resource', 'jfConfigUrls', function ($resource, jfConfigUrls) {
      'use strict';

      return $resource(
        jfConfigUrls.get('apiEndpoint') + '/myo/invoice_reminder_documents',
        {}
      );
    }]
  );

angular.module('jf.history', [])
    .provider(
        'jfHistory',
        function() {
            'use strict';

            return {
                historyObjName: 'history',
                maxHistoryLevel: 10,
                maxHistoryRequests: 10,
                setHistoryObjName: function(historyObjName) {
                    this.historyObjName = historyObjName;
                },
                $get: ['$localStorage', function(
                    $localStorage
                ) {
                    var jfHistory = this;

                    return {
                        init: function() {
                            $localStorage[jfHistory.historyObjName] = [];
                        },
                        get: function(asJsonString) {
                            if (angular.isUndefined($localStorage[jfHistory.historyObjName])) {
                                return {};
                            }

                            if (angular.isDefined(asJsonString) && asJsonString === true) {
                                return JSON.stringify($localStorage[jfHistory.historyObjName]);
                            }

                            return $localStorage[jfHistory.historyObjName];
                        },
                        addState: function(stateName, data) {
                            if (angular.isDefined($localStorage[jfHistory.historyObjName])) {
                                if ($localStorage[jfHistory.historyObjName].length === jfHistory.maxHistoryLevel) {
                                    $localStorage[jfHistory.historyObjName].shift();
                                }

                                $localStorage[jfHistory.historyObjName].push({
                                    stateName: stateName,
                                    stateInfo: data,
                                    requests: []
                                });
                            }
                        },
                        addRequest: function(data) {
                            if (angular.isDefined($localStorage[jfHistory.historyObjName])) {
                                var lastHistoryElement = this.getLastHistoryElement();

                                if (angular.isUndefined(lastHistoryElement)) {
                                    this.addState(
                                        'Empty state (requests before $stateChangeStart)',
                                        {}
                                    );

                                    lastHistoryElement = this.getLastHistoryElement();
                                }

                                if (lastHistoryElement.requests.length === jfHistory.maxHistoryRequests) {
                                    lastHistoryElement.requests.shift();
                                }

                                lastHistoryElement.requests.push(data);
                            }
                        },
                        getLastHistoryElement: function() {
                            return $localStorage[jfHistory.historyObjName][$localStorage[jfHistory.historyObjName].length - 1];
                        }
                    };
                }]
            };
        }
    );